/* eslint-disable import/no-anonymous-default-export */
// this is the selection.json file from IcoMoon, with "export default" added at the start and renamed from '.json' to '.js';

export default {
  IcoMoonType: 'selection',
  icons: [
    {
      icon: {
        paths: [
          'M304 608c0 114.876 93.124 208 208 208s208-93.124 208-208-93.124-208-208-208-208 93.124-208 208zM960 256h-224c-16-64-32-128-96-128h-256c-64 0-80 64-96 128h-224c-35.2 0-64 28.8-64 64v576c0 35.2 28.8 64 64 64h896c35.2 0 64-28.8 64-64v-576c0-35.2-28.8-64-64-64zM512 892c-156.85 0-284-127.148-284-284 0-156.85 127.15-284 284-284 156.852 0 284 127.15 284 284 0 156.852-127.146 284-284 284zM960 448h-128v-64h128v64z',
        ],
        tags: ['camera', 'photo', 'picture', 'image'],
        defaultCode: 59663,
        grid: 16,
        attrs: [],
      },
      attrs: [],
      properties: {
        ligatures: 'camera, photo',
        name: 'camera',
        order: 3,
        id: 16,
        prevSize: 32,
      },
      setIdx: 0,
      setId: 1,
      iconIdx: 15,
    },
    {
      icon: {
        paths: ['M0 64v640h1024v-640h-1024zM960 640h-896v-512h896v512zM672 768h-320l-32 128-64 64h512l-64-64z'],
        tags: ['display', 'screen', 'monitor', 'computer', 'desktop', 'pc'],
        defaultCode: 59734,
        grid: 16,
        attrs: [],
      },
      attrs: [],
      properties: {
        ligatures: 'display, screen',
        name: 'display',
        order: 2,
        id: 87,
        prevSize: 32,
        code: 59734,
      },
      setIdx: 0,
      setId: 1,
      iconIdx: 86,
    },
    {
      icon: {
        paths: ['M1024 0v416l-160-160-192 192-96-96 192-192-160-160zM448 672l-192 192 160 160h-416v-416l160 160 192-192z'],
        tags: ['enlarge', 'expand', 'maximize', 'fullscreen'],
        defaultCode: 59787,
        grid: 16,
        attrs: [],
      },
      attrs: [],
      properties: {
        ligatures: 'enlarge2, expand2',
        name: 'enlarge',
        order: 61,
        id: 140,
        prevSize: 32,
      },
      setIdx: 16,
      setId: 1,
      iconIdx: 139,
    },
    {
      icon: {
        paths: ['M448 576v416l-160-160-192 192-96-96 192-192-160-160zM1024 96l-192 192 160 160h-416v-416l160 160 192-192z'],
        tags: ['shrink', 'collapse', 'minimize', 'contract'],
        defaultCode: 59788,
        grid: 16,
        attrs: [],
      },
      attrs: [],
      properties: {
        ligatures: 'shrink2, collapse2',
        name: 'shrink',
        order: 62,
        id: 141,
        prevSize: 32,
      },
      setIdx: 16,
      setId: 1,
      iconIdx: 140,
    },
    {
      icon: {
        paths: [
          'M0 511.723c0-282.684 229.366-511.723 512.040-511.723 282.799 0 511.96 229.049 511.92 511.723 0 282.951-229.121 512.277-511.96 512.277-282.674 0-512-229.314-512-512.277z',
          'M768.687 257.574l-511.115 511.115',
          'M240.941 257.575l511.114 511.114',
        ],
        attrs: [
          {
            fill: 'rgb(49, 153, 152)',
          },
          {
            fill: 'none',
            stroke: 'rgb(255, 255, 255)',
            strokeLinejoin: 'miter',
            strokeLinecap: 'round',
            strokeMiterlimit: '4',
            strokeWidth: 80.31372549019608,
          },
          {
            fill: 'none',
            stroke: 'rgb(255, 255, 255)',
            strokeLinejoin: 'miter',
            strokeLinecap: 'round',
            strokeMiterlimit: '4',
            strokeWidth: 80.31372549019608,
          },
        ],
        isMulticolor: false,
        isMulticolor2: true,
        grid: 0,
        tags: ['icon-close'],
        colorPermutations: {
          '2552552551491531521': [
            {
              f: 0,
            },
            {
              s: 1,
            },
            {
              s: 1,
            },
          ],
        },
      },
      attrs: [
        {
          fill: 'rgb(49, 153, 152)',
        },
        {
          fill: 'none',
          stroke: 'rgb(255, 255, 255)',
          strokeLinejoin: 'miter',
          strokeLinecap: 'round',
          strokeMiterlimit: '4',
          strokeWidth: 80.31372549019608,
        },
        {
          fill: 'none',
          stroke: 'rgb(255, 255, 255)',
          strokeLinejoin: 'miter',
          strokeLinecap: 'round',
          strokeMiterlimit: '4',
          strokeWidth: 80.31372549019608,
        },
      ],
      properties: {
        order: 57,
        id: 1,
        name: 'icon-close',
        prevSize: 32,
      },
      setIdx: 0,
      setId: 16,
      iconIdx: 0,
    },
    {
      icon: {
        paths: [
          'M512.040 0c-282.674 0-512.040 229.039-512.040 511.723 0 282.963 229.324 512.277 512 512.277 282.839 0 511.96-229.326 511.96-512.277 0.040-282.674-229.121-511.723-511.92-511.723zM548.521 796.642c-11.88 10.599-25.68 15.92-41.279 15.92-16.159 0-30.24-5.24-42.279-15.679-12.041-10.441-18.081-25.080-18.081-43.881 0-16.679 5.841-30.72 17.48-42.080s25.919-17.041 42.879-17.041c16.679 0 30.72 5.68 42.080 17.041s17.081 25.401 17.081 42.080c-0.040 18.48-6.001 33.041-17.88 43.64h-0.002zM696.796 429.046c-9.12 16.96-20 31.559-32.559 43.879-12.561 12.32-35.121 33.001-67.68 62.121-9.001 8.2-16.199 15.4-21.641 21.641-5.401 6.24-9.481 11.921-12.119 17.081-2.68 5.16-4.72 10.318-6.16 15.478-1.442 5.16-3.64 14.24-6.562 27.2-5 27.519-20.759 41.279-47.239 41.279-13.762 0-25.321-4.479-34.76-13.481-9.401-8.999-14.081-22.359-14.081-40.079 0-22.241 3.439-41.482 10.32-57.762 6.841-16.278 16.001-30.559 27.361-42.879 11.399-12.32 26.72-26.919 46.080-43.879 16.958-14.84 29.2-26.002 36.719-33.521 7.56-7.56 13.88-15.958 19.040-25.198 5.198-9.28 7.72-19.319 7.72-30.16 0-21.201-7.841-39.041-23.6-53.601-15.762-14.559-36.081-21.839-60.96-21.839-29.122 0-50.559 7.361-64.319 22.040-13.762 14.679-25.401 36.32-34.92 64.879-9.001 29.921-26.082 44.879-51.2 44.879-14.84 0-27.321-5.24-37.521-15.679-10.16-10.439-15.28-21.759-15.28-33.961 0-25.118 8.080-50.6 24.199-76.439 16.161-25.801 39.721-47.2 70.68-64.12 30.959-16.958 67.080-25.439 108.359-25.439 38.36 0 72.24 7.080 101.601 21.239s52.079 33.4 68.080 57.76c16.001 24.361 24 50.8 24 79.4 0.12 22.48-4.439 42.201-13.559 59.159v0.002z',
        ],
        attrs: [
          {
            fill: 'rgb(49, 153, 152)',
          },
        ],
        isMulticolor: false,
        isMulticolor2: false,
        grid: 0,
        tags: ['question'],
        colorPermutations: {
          '2552552551491531521': [
            {
              f: 0,
            },
          ],
        },
      },
      attrs: [
        {
          fill: 'rgb(49, 153, 152)',
        },
      ],
      properties: {
        order: 56,
        id: 0,
        name: 'question',
        prevSize: 32,
      },
      setIdx: 0,
      setId: 16,
      iconIdx: 1,
    },
    {
      icon: {
        paths: ['M992 512l-480-480v288h-512v384h512v288z'],
        tags: ['arrow-right', 'right', 'next'],
        defaultCode: 59956,
        grid: 16,
        attrs: [],
      },
      attrs: [],
      properties: {
        ligatures: 'arrow-right, right3',
        name: 'arrow-right',
        order: 44,
        id: 309,
        prevSize: 32,
      },
      setIdx: 9,
      setId: 1,
      iconIdx: 308,
    },
    {
      icon: {
        paths: [
          'M621.254 877.254l320-320c24.994-24.992 24.994-65.516 0-90.51l-320-320c-24.994-24.992-65.516-24.992-90.51 0-24.994 24.994-24.994 65.516 0 90.51l210.746 210.746h-613.49c-35.346 0-64 28.654-64 64s28.654 64 64 64h613.49l-210.746 210.746c-12.496 12.496-18.744 28.876-18.744 45.254s6.248 32.758 18.744 45.254c24.994 24.994 65.516 24.994 90.51 0z',
        ],
        tags: ['arrow-right', 'right', 'next'],
        defaultCode: 59964,
        grid: 16,
        attrs: [],
      },
      attrs: [],
      properties: {
        ligatures: 'arrow-right2, right4',
        name: 'arrow-right2',
        order: 43,
        id: 317,
        prevSize: 32,
      },
      setIdx: 9,
      setId: 1,
      iconIdx: 316,
    },
    {
      icon: {
        paths: [
          'M512 938.667c235.639 0 426.667-191.027 426.667-426.667 0-235.642-191.027-426.667-426.667-426.667-235.642 0-426.667 191.025-426.667 426.667 0 235.639 191.025 426.667 426.667 426.667z',
          'M512 341.333v341.333',
          'M341.333 512h341.333',
        ],
        attrs: [
          {
            fill: 'none',
            stroke: 'rgb(49, 153, 152)',
            strokeLinejoin: 'round',
            strokeLinecap: 'round',
            strokeMiterlimit: '4',
            strokeWidth: 85.33333333333333,
          },
          {
            fill: 'none',
            stroke: 'rgb(49, 153, 152)',
            strokeLinejoin: 'round',
            strokeLinecap: 'round',
            strokeMiterlimit: '4',
            strokeWidth: 85.33333333333333,
          },
          {
            fill: 'none',
            stroke: 'rgb(49, 153, 152)',
            strokeLinejoin: 'round',
            strokeLinecap: 'round',
            strokeMiterlimit: '4',
            strokeWidth: 85.33333333333333,
          },
        ],
        isMulticolor: false,
        isMulticolor2: false,
        grid: 0,
        tags: ['plus'],
      },
      attrs: [
        {
          fill: 'none',
          stroke: 'rgb(49, 153, 152)',
          strokeLinejoin: 'round',
          strokeLinecap: 'round',
          strokeMiterlimit: '4',
          strokeWidth: 85.33333333333333,
        },
        {
          fill: 'none',
          stroke: 'rgb(49, 153, 152)',
          strokeLinejoin: 'round',
          strokeLinecap: 'round',
          strokeMiterlimit: '4',
          strokeWidth: 85.33333333333333,
        },
        {
          fill: 'none',
          stroke: 'rgb(49, 153, 152)',
          strokeLinejoin: 'round',
          strokeLinecap: 'round',
          strokeMiterlimit: '4',
          strokeWidth: 85.33333333333333,
        },
      ],
      properties: {
        order: 18,
        id: 3,
        name: 'plus',
        prevSize: 32,
      },
      setIdx: 1,
      setId: 4,
      iconIdx: 0,
    },
    {
      icon: {
        paths: [
          'M512 938.667c235.639 0 426.667-191.027 426.667-426.667 0-235.642-191.027-426.667-426.667-426.667-235.642 0-426.667 191.025-426.667 426.667 0 235.639 191.025 426.667 426.667 426.667z',
          'M341.333 512h341.333',
        ],
        attrs: [
          {
            fill: 'none',
            stroke: 'rgb(49, 153, 152)',
            strokeLinejoin: 'round',
            strokeLinecap: 'round',
            strokeMiterlimit: '4',
            strokeWidth: 85.33333333333333,
          },
          {
            fill: 'none',
            stroke: 'rgb(49, 153, 152)',
            strokeLinejoin: 'round',
            strokeLinecap: 'round',
            strokeMiterlimit: '4',
            strokeWidth: 85.33333333333333,
          },
        ],
        isMulticolor: false,
        isMulticolor2: false,
        grid: 0,
        tags: ['minus'],
      },
      attrs: [
        {
          fill: 'none',
          stroke: 'rgb(49, 153, 152)',
          strokeLinejoin: 'round',
          strokeLinecap: 'round',
          strokeMiterlimit: '4',
          strokeWidth: 85.33333333333333,
        },
        {
          fill: 'none',
          stroke: 'rgb(49, 153, 152)',
          strokeLinejoin: 'round',
          strokeLinecap: 'round',
          strokeMiterlimit: '4',
          strokeWidth: 85.33333333333333,
        },
      ],
      properties: {
        order: 17,
        id: 2,
        name: 'minus',
        prevSize: 32,
      },
      setIdx: 1,
      setId: 4,
      iconIdx: 1,
    },
    {
      icon: {
        paths: [
          'M512 938.667c235.639 0 426.667-191.027 426.667-426.667 0-235.642-191.027-426.667-426.667-426.667-235.642 0-426.667 191.025-426.667 426.667 0 235.639 191.025 426.667 426.667 426.667z',
          'M512 682.667l170.667-170.667-170.667-170.667',
          'M341.333 512h341.333',
        ],
        attrs: [
          {
            fill: 'none',
            stroke: 'rgb(49, 153, 152)',
            strokeLinejoin: 'round',
            strokeLinecap: 'round',
            strokeMiterlimit: '4',
            strokeWidth: 85.33333333333333,
          },
          {
            fill: 'none',
            stroke: 'rgb(49, 153, 152)',
            strokeLinejoin: 'round',
            strokeLinecap: 'round',
            strokeMiterlimit: '4',
            strokeWidth: 85.33333333333333,
          },
          {
            fill: 'none',
            stroke: 'rgb(49, 153, 152)',
            strokeLinejoin: 'round',
            strokeLinecap: 'round',
            strokeMiterlimit: '4',
            strokeWidth: 85.33333333333333,
          },
        ],
        isMulticolor: false,
        isMulticolor2: false,
        grid: 0,
        tags: ['arrow-right'],
      },
      attrs: [
        {
          fill: 'none',
          stroke: 'rgb(49, 153, 152)',
          strokeLinejoin: 'round',
          strokeLinecap: 'round',
          strokeMiterlimit: '4',
          strokeWidth: 85.33333333333333,
        },
        {
          fill: 'none',
          stroke: 'rgb(49, 153, 152)',
          strokeLinejoin: 'round',
          strokeLinecap: 'round',
          strokeMiterlimit: '4',
          strokeWidth: 85.33333333333333,
        },
        {
          fill: 'none',
          stroke: 'rgb(49, 153, 152)',
          strokeLinejoin: 'round',
          strokeLinecap: 'round',
          strokeMiterlimit: '4',
          strokeWidth: 85.33333333333333,
        },
      ],
      properties: {
        order: 13,
        id: 0,
        name: 'arrow-right',
        prevSize: 32,
      },
      setIdx: 0,
      setId: 4,
      iconIdx: 0,
    },
    {
      icon: {
        paths: [
          'M708.847 389.325h-37.615v-105.745c0-156.331-127.044-283.58-283.375-283.58s-283.375 127.283-283.375 283.375v105.745h-37.41c-37.019 0.058-67.014 30.053-67.072 67.067l-0 0.005v500.736c0 36.966 30.106 67.072 67.072 67.072h641.98c37.034-0.039 67.048-30.041 67.106-67.066l0-0.006v-500.736c-0.328-36.953-30.322-66.791-67.304-66.867l-0.007-0zM189.781 283.375c0.097-109.374 88.736-198.013 198.101-198.11l0.009-0c109.382 0.078 198.032 88.728 198.11 198.102l0 0.008v105.54h-396.22v-105.54zM85.299 938.735v-464.145h605.423v464.145h-605.457zM387.891 875.008c23.62 0 42.667-19.012 42.667-42.667v-70.11c12.337-11.277 20.046-27.44 20.046-45.403 0-33.932-27.508-61.44-61.44-61.44s-61.44 27.508-61.44 61.44c0 16.753 6.705 31.94 17.578 43.023l-0.010-0.010v72.533c0.019 23.526 19.076 42.594 42.595 42.633l0.004 0z',
        ],
        attrs: [
          {
            fill: 'rgb(170, 178, 178)',
          },
        ],
        width: 785,
        isMulticolor: false,
        isMulticolor2: false,
        grid: 16,
        tags: ['lock'],
        colorPermutations: {
          '17017817811900113120991281': [
            {
              f: 2,
            },
          ],
        },
      },
      attrs: [
        {
          fill: 'rgb(170, 178, 178)',
        },
      ],
      properties: {
        order: 16,
        id: 495,
        name: 'lock',
        prevSize: 32,
      },
      setIdx: 0,
      setId: 1,
      iconIdx: 0,
    },
    {
      icon: {
        paths: [
          'M149.948 661.948c53.291-53.487 118.36-95.201 190.992-120.925l3.568-1.102c-78.019-54.043-128.481-143.084-128.512-243.912l-0-0.005c0-163.226 132.779-296.004 296.004-296.004s296.004 132.779 296.004 296.004c-0.031 100.833-50.493 189.874-127.532 243.274l-0.98 0.643c76.199 26.826 141.268 68.539 194.544 122.011l0.016 0.016c92.626 92.144 149.95 219.697 149.95 360.639 0 0.497-0.001 0.994-0.002 1.49l0-0.077h-80.009c0-238.217-193.775-431.991-431.991-431.991s-431.991 193.741-431.991 431.991h-80.009c0-136.772 53.248-265.318 149.948-362.052zM512 512c119.236-0.136 215.86-96.759 215.996-215.983l0-0.013c-0.136-119.236-96.759-215.86-215.983-215.996l-0.013-0c-119.236 0.136-215.86 96.759-215.996 215.983l-0 0.013c0.136 119.236 96.759 215.86 215.983 215.996l0.013 0z',
        ],
        attrs: [
          {
            fill: 'rgb(170, 178, 178)',
          },
        ],
        isMulticolor: false,
        isMulticolor2: false,
        grid: 16,
        tags: ['user-icon'],
        colorPermutations: {
          '17017817811900113120991281': [
            {
              f: 2,
            },
          ],
        },
      },
      attrs: [
        {
          fill: 'rgb(170, 178, 178)',
        },
      ],
      properties: {
        order: 15,
        id: 494,
        name: 'user-icon',
        prevSize: 32,
      },
      setIdx: 0,
      setId: 1,
      iconIdx: 1,
    },
    {
      icon: {
        paths: ['M768 640v-128h-320v-128h320v-128l192 192zM704 576v256h-320v192l-384-192v-832h704v320h-64v-256h-512l256 128v576h256v-192z'],
        tags: ['exit', 'signout', 'logout', 'quit', 'close'],
        defaultCode: 59924,
        grid: 16,
        attrs: [],
      },
      attrs: [],
      properties: {
        ligatures: 'exit, signout',
        name: 'exit',
        order: 9,
        id: 277,
        prevSize: 32,
      },
      setIdx: 0,
      setId: 1,
      iconIdx: 277,
    },
    {
      icon: {
        paths: [
          'M512 92.774l429.102 855.226h-858.206l429.104-855.226zM512 0c-22.070 0-44.14 14.882-60.884 44.648l-437.074 871.112c-33.486 59.532-5 108.24 63.304 108.24h869.308c68.3 0 96.792-48.708 63.3-108.24h0.002l-437.074-871.112c-16.742-29.766-38.812-44.648-60.882-44.648v0z',
          'M576 832c0 35.346-28.654 64-64 64s-64-28.654-64-64c0-35.346 28.654-64 64-64s64 28.654 64 64z',
          'M512 704c-35.346 0-64-28.654-64-64v-192c0-35.346 28.654-64 64-64s64 28.654 64 64v192c0 35.346-28.654 64-64 64z',
        ],
        tags: ['warning', 'sign'],
        defaultCode: 59911,
        grid: 16,
        attrs: [],
      },
      attrs: [],
      properties: {
        ligatures: 'warning, sign',
        name: 'warning',
        order: 8,
        id: 264,
        prevSize: 32,
      },
      setIdx: 0,
      setId: 1,
      iconIdx: 264,
    },
    {
      icon: {
        paths: ['M864 128l-480 480-224-224-160 160 384 384 640-640z'],
        tags: ['checkmark', 'tick', 'correct', 'accept', 'ok'],
        defaultCode: 59920,
        grid: 16,
        attrs: [],
      },
      attrs: [],
      properties: {
        ligatures: 'checkmark, tick',
        name: 'checkmark',
        order: 7,
        id: 273,
        prevSize: 32,
      },
      setIdx: 0,
      setId: 1,
      iconIdx: 273,
    },
    {
      icon: {
        paths: [
          'M546.832 815.875c-7.308 9.017-16.589 16.292-27.149 21.294-10.56 5.007-22.13 7.605-33.85 7.605s-23.29-2.598-33.85-7.605c-10.56-5.001-19.84-12.277-27.149-21.294l-286.137-353.251c-11.881-14.205-18.376-32.031-18.376-50.428s6.496-36.223 18.376-50.428c7.474-8.573 16.779-15.418 27.25-20.047s21.851-6.927 33.328-6.731c11.477 0.196 22.769 2.88 33.071 7.863s19.36 12.14 26.529 20.963l149.051 185.329v-468.441c-0.428-18.421 5.671-36.415 17.252-50.894s27.922-24.541 46.218-28.459c11.287-2.11 22.907-1.742 34.032 1.078s21.481 8.022 30.327 15.236c8.845 7.213 15.965 16.26 20.848 26.493s7.411 21.402 7.4 32.707v472.281l150.609-185.073c7.448-9.178 16.939-16.552 27.74-21.555 10.795-5.003 22.62-7.502 34.552-7.304s23.665 3.087 34.288 8.445c10.617 5.358 19.849 13.043 26.98 22.462 9.599 14.485 14.401 31.54 13.749 48.821s-6.726 33.938-17.386 47.683l-287.701 353.251z',
          'M66.024 895.995h835.974c14.88-0.323 29.443 4.231 41.402 12.946 11.959 8.709 20.636 21.084 24.673 35.177 2.441 9.388 2.684 19.192 0.717 28.683-1.973 9.491-6.106 18.421-12.089 26.112-5.988 7.691-13.673 13.943-22.469 18.286-8.801 4.344-18.486 6.661-28.332 6.785h-837.795c-14.876 0.323-29.439-4.231-41.399-12.94-11.96-8.715-20.639-21.089-24.673-35.182-2.481-9.534-2.695-19.499-0.626-29.125s6.366-18.653 12.556-26.376c6.19-7.729 14.108-13.943 23.137-18.168s18.926-6.349 28.923-6.198z',
        ],
        attrs: [{ fill: 'rgb(55, 52, 99)' }, { fill: 'rgb(55, 52, 99)' }],
        width: 970,
        isMulticolor: false,
        isMulticolor2: false,
        grid: 0,
        tags: ['Download'],
      },
      attrs: [{ fill: 'rgb(55, 52, 99)' }, { fill: 'rgb(55, 52, 99)' }],
      properties: {
        order: 5,
        id: 0,
        name: 'Download',
        prevSize: 32,
        code: 59648,
      },
      setIdx: 0,
      setId: 3,
      iconIdx: 0,
    },
    {
      icon: {
        paths: ['M864 128l-480 480-224-224-160 160 384 384 640-640z'],
        tags: ['checkmark', 'tick', 'correct', 'accept', 'ok'],
        defaultCode: 59920,
        grid: 16,
        attrs: [],
      },
      attrs: [],
      properties: {
        ligatures: 'checkmark, tick',
        name: 'checkmark',
        order: 4,
        id: 273,
        prevSize: 32,
        code: 59920,
      },
      setIdx: 0,
      setId: 1,
      iconIdx: 272,
    },
    {
      icon: {
        paths: [
          'M1719.027 0c-124.055 0-221.27 52.364-277.946 149.558-56.816-97.194-153.956-149.224-277.957-149.224-192.868 0-340.863 116.671-340.863 367.972v216.236c-24.468 184.352-157.545 263.308-301.951 263.308-194.366 0-325.955-140.665-325.955-332.358 0-191.682 131.589-330.73 325.955-330.73 0.34-0.001 0.742-0.002 1.145-0.002 32.255 0 63.539 4.157 93.346 11.964l-2.557-0.569c7.454 2.234 16.018 3.52 24.884 3.52 40.216 0 74.251-26.462 85.645-62.923l0.171-0.636c2.483-7.847 3.913-16.871 3.913-26.229 0-39.72-25.772-73.42-61.507-85.291l-0.634-0.183-2.048-0.474c-2.702-0.877-6.056-1.7-9.486-2.302l-0.474-0.069c-39.037-9.395-83.856-14.783-129.933-14.783-0.866 0-1.732 0.002-2.598 0.006l0.133-0c-305.001 0-520.311 215.417-520.311 508.702 0 293.295 215.309 508.723 520.311 508.723 251.85 0 478.424-151.261 491.908-413.75 0.41-4.161 0.614-8.095 0.614-11.803l0.539-230.616c0-134.64 71.723-189.925 165.953-189.925 94.24 0 165.963 56.848 165.963 189.925v534.075c1.419 51.769 43.709 93.198 95.682 93.227l0.003 0c25.991-0.001 49.561-10.364 66.806-27.182l-0.020 0.019c17.266-16.84 28.194-40.11 28.906-65.932l0.003-0.132v-534.151c0-133.152 71.723-189.925 165.953-189.925 94.24 0 165.963 55.35 165.963 189.925v534.14c1.419 51.769 43.709 93.198 95.682 93.227l0.003 0c25.991-0.001 49.561-10.364 66.806-27.182l-0.020 0.019c17.266-16.84 28.194-40.11 28.906-65.932l0.003-0.132v-534.14c0-251.311-148.2-367.972-340.938-367.972z',
          'M2387.742 0h263.847c3.714-0.070 8.094-0.11 12.483-0.11 58.231 0 114.824 7.011 168.982 20.235l-4.862-1.003c51.892 13.819 96.816 38.624 134.001 71.899l-0.31-0.273c103.952 89.131 155.928 224.655 155.928 406.56 0.019 2.040 0.030 4.452 0.030 6.866 0 55.761-5.713 110.188-16.586 162.727l0.895-5.172c-10.439 50.544-27.2 95.397-49.747 136.635l1.274-2.545c-22.868 41.225-50.792 76.451-83.552 106.487l-0.308 0.278c-25.294 22.896-54.346 42.305-85.991 57.093l-2.138 0.897c-29.566 13.771-63.901 24.453-99.849 30.342l-2.314 0.313c-40.96 6.273-82.362 9.248-123.796 8.893h-263.923c-36.832 0-64.555-5.562-83.181-16.686-17.723-10.238-30.827-26.797-36.335-46.526l-0.13-0.546c-5.49-21.429-8.64-46.030-8.64-71.367 0-2.619 0.034-5.23 0.101-7.833l-0.008 0.385v-733.356c0-43.687 9.787-75.345 29.351-94.963 19.575-19.618 51.168-29.373 94.779-29.233zM2466.115 160.348v678.815h153.417c33.706 0 60.082-0.927 79.107-2.781 21.943-2.292 42.037-7.075 61.035-14.118l-1.718 0.558c20.52-7.192 38.215-17.615 53.426-30.825l-0.199 0.169c67.789-57.344 101.689-156.058 101.689-296.141 0-98.714-14.875-172.625-44.614-221.723-29.739-49.109-66.506-80.411-110.301-93.885-43.655-13.56-96.375-20.34-158.159-20.34l-133.681 0.269zM3753.499 912.158c-37.733 30.433-80.715 56.799-126.886 77.283l-3.679 1.457c-40.443 16.795-87.416 26.548-136.667 26.548-1.694 0-3.385-0.012-5.073-0.035l0.256 0.003c-1.54 0.032-3.356 0.050-5.175 0.050-43.946 0-85.424-10.566-122.033-29.297l1.515 0.704c-34.828-17.735-63.153-43.878-83.006-75.834l-0.509-0.88c-18.475-29.679-29.428-65.705-29.428-104.289 0-0.253 0-0.506 0.001-0.759l-0 0.039c-0.031-1.27-0.048-2.765-0.048-4.265 0-48.557 18.397-92.818 48.6-126.192l-0.144 0.161c32.272-35.948 76.584-60.039 132.937-72.305 11.803-2.803 41.176-8.947 88.139-18.443 46.953-9.496 87.062-18.249 120.325-26.247 52.622-12.47 88.942-22.456 124.894-33.291l-16.425 4.253c-2.253-49.109-12.137-85.154-29.621-108.113-17.494-22.97-53.647-34.46-108.469-34.46-47.276 0-82.847 6.607-106.712 19.812-25.303 14.634-45.972 34.661-60.93 58.621l-0.424 0.728c-17.085 26.408-29.125 43.795-36.131 52.159s-22.118 12.568-45.358 12.611c-0.306 0.004-0.668 0.007-1.030 0.007-20.48 0-39.155-7.726-53.271-20.422l0.073 0.064c-14.041-12.134-22.873-29.966-22.873-49.862 0-0.592 0.008-1.182 0.023-1.77l-0.002 0.087c0-32.736 11.598-64.566 34.784-95.501s59.338-56.385 108.469-76.38c49.077-19.984 110.204-29.998 183.382-30.041 81.801 0 146.141 9.669 193.008 29.028s79.926 49.917 99.177 91.707c19.348 41.865 29.017 97.377 29.017 166.513 0 43.633-0.108 80.691-0.334 111.174-0.226 30.472-0.571 64.393-1.024 101.742 0.263 39.244 6.515 76.933 17.886 112.329l-0.736-2.653c11.62 37.985 17.408 62.421 17.365 73.318 0 19.133-8.957 36.498-27.12 52.235-15.991 14.593-37.36 23.531-60.817 23.531-0.071 0-0.142-0-0.213-0l0.011 0c-19.111 0-37.985-9.044-56.6-27.131-22.222-22.818-41.794-48.399-58.107-76.129l-1.016-1.867zM3741.233 642.673c-32.164 11.426-72.075 22.37-112.95 30.659l-6.028 1.021c-52.062 11.167-88.086 19.37-108.059 24.619-22.159 6.227-41.352 16.795-57.47 30.808l0.18-0.153c-18.076 15.285-27.12 36.562-27.12 63.822-0.002 0.219-0.003 0.478-0.003 0.738 0 28.303 12.358 53.72 31.973 71.149l0.097 0.085c21.245 19.941 49.152 29.912 83.731 29.912 35.355 0.291 70.257-8.020 101.689-24.21 28.756-14.054 52.080-35.412 68.128-61.698l0.404-0.712c16.815-28.219 25.223-74.612 25.223-139.178l0.205-26.861zM4519.839 879.724c-10.148-11.015-24.589-17.941-40.649-18.108l-0.030-0c-14.702 0.55-29.319 2.511-43.655 5.831-14.562 3.352-29.405 5.282-44.345 5.767-20.017 0-34.439-4.883-43.245-14.649-8.752-10.248-14.542-23.263-15.91-37.57l-0.021-0.275c-1.982-17.654-3.113-38.119-3.113-58.848 0-2.943 0.023-5.88 0.068-8.812l-0.005 0.443v-313.84h89.013c44.97-0.196 81.349-36.696 81.349-81.693 0-0.042-0-0.084-0-0.126l0 0.007c0-0.032 0-0.070 0-0.109 0-44.997-36.379-81.497-81.33-81.693l-0.019-0h-89.357v-126.814c0.064-2.651 0.1-5.774 0.1-8.904 0-22.511-1.883-44.583-5.5-66.065l0.323 2.32c-3.418-17.287-12.072-32.156-24.215-43.278l-0.059-0.054c-16.456-16.284-39.071-26.372-64.042-26.462l-0.017-0c-0.302-0.004-0.66-0.006-1.017-0.006-16.411 0-31.779 4.462-44.958 12.239l0.413-0.225c-13.121 7.494-23.747 17.996-31.174 30.607l-0.214 0.393c-7.369 12.671-12.237 27.654-13.535 43.646l-0.024 0.375c-1.671 17.042-2.501 40.583-2.501 70.602v111.648h-25.287c-45.154-0-81.758 36.604-81.758 81.758 0 0.015 0 0.030 0 0.045l-0-0.002c0.004 22.584 9.151 43.031 23.941 57.841l-0.001-0.001c14.795 14.802 35.237 23.959 57.818 23.962l25.288 0v328.488c0 57.786 4.646 103.963 13.959 138.509 8.969 34.395 30.111 62.829 58.442 81.056l0.54 0.325c30.052 19.542 74.17 29.33 132.333 29.383 61.332 0 108.372-7.966 141.14-23.886 32.768-15.91 49.13-38.88 49.087-68.91 0.019-0.573 0.030-1.247 0.030-1.923 0-16.796-6.827-31.997-17.857-42.98l-0.002-0.002z',
        ],
        attrs: [
          {
            fill: '#3DDEED',
          },
          {
            fill: 'rgb(255, 255, 255)',
          },
        ],
        width: 4538,
        isMulticolor: true,
        isMulticolor2: false,
        grid: 0,
        tags: ['cmdat'],
      },
      attrs: [
        {
          fill: '#3DDEED',
        },
        {
          fill: 'rgb(255, 255, 255)',
        },
      ],
      properties: {
        order: 31,
        id: 22,
        name: 'cmdat',
        prevSize: 32,
      },
      setIdx: 0,
      setId: 2,
      iconIdx: 0,
    },
    {
      icon: {
        paths: [
          'M47.923 573.781l462.643 383.932c40.619 33.792 107.588 33.792 148.207 0 40.687-33.724 40.687-89.293 0-123.017l-387.345-322.423 388.574-322.492c40.619-33.724 40.619-89.293 0-123.017-20.004-16.078-45.709-25.806-73.685-25.806-0.159 0-0.318 0-0.477 0.001l0.025-0c-27.511 0-53.794 8.875-74.138 25.805l-462.575 384c-41.916 33.724-41.916 89.225-1.229 123.017z',
        ],
        attrs: [
          {
            fill: 'rgb(190, 0, 113)',
          },
        ],
        width: 751,
        isMulticolor: false,
        isMulticolor2: false,
        grid: 0,
        tags: ['Chevron-left'],
      },
      attrs: [
        {
          fill: 'rgb(190, 0, 113)',
        },
      ],
      properties: {
        order: 28,
        id: 20,
        name: 'Chevron-left',
        prevSize: 32,
      },
      setIdx: 0,
      setId: 2,
      iconIdx: 0,
    },
    {
      icon: {
        paths: [
          'M256 64h512v128h-512v-128z',
          'M960 256h-896c-35.2 0-64 28.8-64 64v320c0 35.2 28.794 64 64 64h192v256h512v-256h192c35.2 0 64-28.8 64-64v-320c0-35.2-28.8-64-64-64zM128 448c-35.346 0-64-28.654-64-64s28.654-64 64-64 64 28.654 64 64-28.652 64-64 64zM704 896h-384v-320h384v320z',
        ],
        tags: ['printer', 'print'],
        defaultCode: 59732,
        grid: 16,
        attrs: [],
      },
      attrs: [],
      properties: {
        ligatures: 'printer, print',
        name: 'printer',
        order: 2,
        id: 85,
        prevSize: 32,
        code: 59732,
      },
      setIdx: 0,
      setId: 1,
      iconIdx: 84,
    },
    {
      icon: {
        paths: ['M896 0h-896v1024h1024v-896l-128-128zM512 128h128v256h-128v-256zM896 896h-768v-768h64v320h576v-320h74.978l53.022 53.018v714.982z'],
        tags: ['floppy-disk', 'save'],
        defaultCode: 59746,
        grid: 16,
        attrs: [],
      },
      attrs: [],
      properties: {
        ligatures: 'floppy-disk, save2',
        name: 'floppy-disk',
        order: 3,
        id: 99,
        prevSize: 32,
        code: 59746,
      },
      setIdx: 0,
      setId: 1,
      iconIdx: 98,
    },
    {
      icon: {
        paths: [
          'M709.905 446.464l-466.261-379.563c-41.028-33.314-107.998-32.7-148.275 1.434-40.346 34.133-39.799 89.702 1.161 123.017l390.417 318.805-385.434 326.11c-40.277 34.133-39.799 89.702 1.161 123.017 20.48 16.657 48.060 25.327 74.411 25.122 0.018 0 0.040 0 0.062 0 28.111 0 53.88-10.030 73.922-26.708l-0.188 0.152 459.093-388.369c41.506-34.133 40.96-89.702 0-123.017z',
        ],
        attrs: [
          {
            fill: 'rgb(190, 0, 113)',
          },
        ],
        width: 751,
        isMulticolor: false,
        isMulticolor2: false,
        grid: 0,
        tags: ['Chevron-right'],
      },
      attrs: [
        {
          fill: 'rgb(190, 0, 113)',
        },
      ],
      properties: {
        order: 27,
        id: 19,
        name: 'Chevron-right',
        prevSize: 32,
      },
      setIdx: 0,
      setId: 2,
      iconIdx: 1,
    },
    {
      icon: {
        paths: [
          'M3179.669 164.94c-80.179 0-143.177 34.362-179.83 97.36-36.653-62.998-99.651-96.215-179.83-96.215-124.85 0-221.065 75.597-221.065 238.246v139.74c-16.036 119.123-101.942 170.667-195.866 170.667-125.996 0-210.756-90.488-210.756-215.338s84.761-214.192 210.756-214.192c20.617 0 40.089 2.291 59.562 6.872 30.926 9.163 62.998-9.163 72.161-40.089 9.163-29.781-8.018-61.852-37.799-71.016h-1.145c-2.291-1.145-4.582-1.145-6.872-1.145-28.635-6.872-57.271-9.163-85.906-9.163-197.011 0-336.752 139.74-336.752 328.734s139.74 328.734 336.752 328.734c162.649 0 309.262-97.36 318.425-268.027v-156.922c0-87.051 46.962-122.559 107.669-122.559s107.669 36.653 107.669 122.559v345.915c1.145 34.362 29.781 60.707 64.143 60.707 33.217-1.145 59.562-27.49 60.707-60.707v-345.915c0-85.906 46.962-122.559 107.669-122.559s107.669 35.508 107.669 122.559v345.915c1.145 34.362 29.781 60.707 64.143 60.707 33.217-1.145 59.562-27.49 60.707-60.707v-345.915c-1.145-162.649-97.36-238.246-222.21-238.246zM3612.635 164.94h170.667c38.944-1.145 76.743 3.436 114.541 12.6 32.072 8.018 61.852 24.054 87.051 45.817 67.579 57.271 100.796 145.468 100.796 263.445 0 35.508-3.436 71.016-10.309 106.523-5.727 29.781-17.181 59.562-30.926 87.051-13.745 26.345-32.072 49.253-53.834 68.725-17.181 14.89-36.653 27.49-57.271 37.799-20.617 9.163-43.526 16.036-66.434 19.472-26.345 4.582-53.834 5.727-80.179 5.727h-170.667c-24.054 0-41.235-3.436-53.834-10.309-11.454-6.872-20.617-17.181-24.054-30.926-4.582-17.181-5.727-34.362-5.727-51.544v-474.201c0-28.635 6.872-49.253 19.472-61.852 11.454-12.6 32.072-18.327 60.707-18.327zM3663.034 268.027v439.839h99.651c21.763 0 38.944-1.145 51.544-2.291s26.345-4.582 38.944-9.163 24.054-11.454 34.362-19.472c43.526-36.653 65.289-100.796 65.289-191.284 0-64.143-9.163-112.251-28.635-143.177-19.472-32.072-43.526-51.544-71.016-60.707-28.635-9.163-61.852-12.6-101.942-12.6l-88.197-1.145zM4496.895 754.828c-26.345 20.617-53.834 37.799-84.761 50.398-28.635 11.454-60.707 17.181-91.633 17.181-28.635 0-56.125-5.727-81.324-18.327-21.763-11.454-41.235-28.635-53.834-49.253s-19.472-43.526-19.472-67.579c-1.145-30.926 10.309-60.707 30.926-84.761 20.617-22.908 49.253-38.944 85.906-46.962 8.018-2.291 26.345-5.727 57.271-11.454s56.125-11.454 77.888-17.181c21.763-5.727 44.671-11.454 69.87-18.327-1.145-32.072-8.018-54.98-19.472-69.87s-34.362-21.763-69.87-21.763c-30.926 0-53.834 4.582-68.725 12.6-16.036 9.163-29.781 22.908-40.089 38.944-11.454 17.181-18.327 28.635-22.908 33.217-4.582 5.727-14.89 8.018-29.781 8.018-12.6 0-25.199-4.582-35.508-12.6-9.163-8.018-14.89-20.617-14.89-33.217 0-20.617 8.018-41.235 22.908-61.852 14.89-19.472 38.944-36.653 69.87-49.253 32.072-12.6 71.016-19.472 119.123-19.472 52.689 0 95.069 5.727 124.85 18.327s51.544 32.072 64.143 59.562c12.6 27.49 18.327 62.998 18.327 107.669v72.161c0 19.472 0 41.235-1.145 65.289 0 24.054 3.436 48.107 11.454 71.016 8.018 24.054 11.454 40.089 11.454 46.962 0 12.6-5.727 24.054-17.181 34.362-10.309 10.309-25.199 14.89-38.944 14.89-12.6 0-24.054-5.727-36.653-17.181-13.745-16.036-27.49-33.217-37.799-51.544zM4488.877 580.725c-25.199 8.018-50.398 14.89-76.743 20.617-33.217 6.872-57.271 12.6-69.87 16.036-13.745 3.436-26.345 10.309-36.653 19.472-11.454 10.309-17.181 24.054-17.181 41.235 0 18.327 6.872 34.362 20.617 46.962s32.072 19.472 53.834 19.472c22.908 0 45.817-5.727 65.289-16.036 18.327-9.163 34.362-22.908 44.671-40.089 11.454-18.327 16.036-48.107 16.036-90.488v-17.181zM4992.859 734.21c-6.872-6.872-16.036-11.454-26.345-11.454-9.163 0-19.472 1.145-28.635 3.436s-19.472 3.436-28.635 3.436c-12.6 0-21.763-3.436-27.49-9.163-5.727-6.872-9.163-16.036-10.309-24.054-1.145-14.89-2.291-28.635-2.291-43.526v-203.884h57.271c28.635 0 52.689-24.054 52.689-52.689s-24.054-52.689-52.689-52.689h-58.416v-82.47c0-16.036-1.145-30.926-3.436-46.962-2.291-10.309-8.018-20.617-16.036-27.49-11.454-11.454-26.345-17.181-41.235-17.181-10.309 0-20.617 2.291-29.781 8.018-8.018 4.582-14.89 11.454-20.617 20.617-4.582 9.163-8.018 18.327-9.163 28.635-1.145 11.454-1.145 26.345-1.145 45.817v71.016h-16.036c-29.781 0-52.689 24.054-52.689 52.689 0 29.781 24.054 52.689 52.689 52.689h16.036v213.047c0 37.799 3.436 67.579 9.163 89.342s19.472 40.089 37.799 52.689c19.472 12.6 48.107 19.472 85.906 19.472 40.089 0 69.87-4.582 91.633-14.89s32.072-25.199 32.072-44.671c2.291-11.454-2.291-21.763-10.309-29.781z',
          'M418.076 587.597c12.6-2.291 29.781-3.436 51.544-3.436 26.345 0 45.817 5.727 58.416 17.181 11.454 10.309 18.327 25.199 18.327 43.526s-5.727 33.217-16.036 44.671c-13.745 14.89-36.653 22.908-62.998 22.908-8.018 0-14.89 0-21.763-2.291v82.47h-26.345v-205.029zM444.421 687.248c5.727 1.145 13.745 2.291 21.763 2.291 32.072 0 51.544-16.036 51.544-44.671 0-27.49-19.472-40.089-49.253-40.089-11.454 0-20.617 1.145-25.199 2.291v80.179zM706.72 715.884c0 54.98-37.799 79.034-74.452 79.034-40.089 0-71.016-29.781-71.016-76.743 0-49.253 32.072-79.034 73.306-79.034 43.526 1.145 72.161 32.072 72.161 76.743zM589.888 718.174c0 32.072 18.327 57.271 44.671 57.271s44.671-24.054 44.671-57.271c0-25.199-12.6-57.271-44.671-57.271-30.926-1.145-44.671 28.635-44.671 57.271zM750.246 643.723l19.472 75.597c4.582 16.036 8.018 32.072 11.454 46.962h1.145c3.436-14.89 8.018-30.926 13.745-46.962l24.054-75.597h22.908l22.908 74.452c5.727 18.327 10.309 33.217 13.745 48.107h1.145c2.291-14.89 6.872-30.926 11.454-48.107l20.617-74.452h26.345l-48.107 148.904h-24.054l-22.908-71.016c-5.727-16.036-9.163-30.926-13.745-49.253h-1.145c-3.436 18.327-8.018 33.217-13.745 49.253l-24.054 71.016h-24.054l-44.671-148.904h27.49zM977.038 722.756c1.145 36.653 24.054 51.544 50.398 51.544 19.472 0 30.926-3.436 41.235-8.018l4.582 19.472c-9.163 4.582-26.345 9.163-49.253 9.163-45.817 0-73.306-29.781-73.306-74.452s26.345-80.179 69.87-80.179c48.107 0 61.852 42.38 61.852 69.87 0 5.727-1.145 10.309-1.145 12.6h-104.233zM1056.072 703.284c0-17.181-6.872-43.526-37.799-43.526-27.49 0-38.944 25.199-41.235 43.526h79.034zM1115.633 689.539c0-17.181 0-32.072-1.145-45.817h24.054l1.145 28.635h1.145c6.872-19.472 22.908-32.072 41.235-32.072 3.436 0 5.727 0 8.018 1.145v25.199c-2.291-1.145-5.727-1.145-9.163-1.145-19.472 0-32.072 14.89-36.653 34.362-1.145 3.436-1.145 8.018-1.145 12.6v79.034h-26.345v-101.942zM1227.884 722.756c1.145 36.653 24.054 51.544 50.398 51.544 19.472 0 30.926-3.436 41.235-8.018l4.582 19.472c-9.163 4.582-26.345 9.163-49.253 9.163-45.817 0-73.306-29.781-73.306-74.452s26.345-80.179 69.87-80.179c48.107 0 61.852 42.38 61.852 69.87 0 5.727-1.145 10.309-1.145 12.6h-104.233zM1306.917 703.284c0-17.181-6.872-43.526-37.799-43.526-27.49 0-38.944 25.199-41.235 43.526h79.034zM1494.765 573.852v179.83c0 13.745 0 28.635 1.145 37.799h-24.054l-1.145-26.345h-1.145c-8.018 16.036-26.345 28.635-50.398 28.635-35.508 0-62.998-30.926-62.998-75.597 0-49.253 30.926-80.179 66.434-80.179 22.908 0 37.799 10.309 44.671 22.908h1.145v-88.197h26.345zM1468.421 703.284c0-3.436 0-8.018-1.145-11.454-3.436-17.181-18.327-30.926-38.944-30.926-27.49 0-44.671 24.054-44.671 57.271 0 29.781 14.89 54.98 43.526 54.98 18.327 0 34.362-11.454 40.089-32.072 1.145-3.436 1.145-6.872 1.145-11.454v-26.345zM1603.579 791.481c1.145-10.309 1.145-25.199 1.145-37.799v-179.83h26.345v92.779h1.145c9.163-16.036 26.345-27.49 50.398-27.49 36.653 0 62.998 30.926 62.998 75.597 0 52.689-33.217 79.034-66.434 79.034-21.763 0-38.944-8.018-49.253-27.49h-1.145l-1.145 24.054h-24.054zM1631.069 731.919c0 3.436 1.145 6.872 1.145 10.309 5.727 18.327 20.617 32.072 40.089 32.072 28.635 0 44.671-22.908 44.671-57.271 0-29.781-14.89-54.98-44.671-54.98-18.327 0-35.508 12.6-41.235 33.217-1.145 3.436-1.145 6.872-1.145 11.454v25.199zM1786.846 643.723l32.072 88.197c3.436 10.309 6.872 21.763 9.163 30.926h1.145c2.291-9.163 5.727-20.617 9.163-30.926l29.781-87.051h28.635l-40.089 105.378c-19.472 50.398-32.072 76.743-50.398 92.779-13.745 11.454-26.345 16.036-33.217 17.181l-6.872-22.908c6.872-2.291 16.036-6.872 24.054-13.745 6.872-5.727 16.036-16.036 22.908-29.781 1.145-2.291 2.291-4.582 2.291-6.872s-1.145-3.436-2.291-6.872l-54.98-136.304h28.635z',
        ],
        attrs: [
          {
            fill: 'rgb(255, 255, 255)',
          },
          {
            fill: 'rgb(255, 255, 255)',
          },
        ],
        width: 5422,
        isMulticolor: false,
        isMulticolor2: false,
        grid: 0,
        tags: ['powered-by-cmdat'],
      },
      attrs: [
        {
          fill: 'rgb(255, 255, 255)',
        },
        {
          fill: 'rgb(255, 255, 255)',
        },
      ],
      properties: {
        order: 25,
        id: 18,
        name: 'powered-by-cmdat',
        prevSize: 32,
      },
      setIdx: 0,
      setId: 2,
      iconIdx: 0,
    },
    {
      icon: {
        paths: [
          'M761.245 449.858h-42.554v101.319c-10.132-10.807-27.694-19.588-51.335-19.588-21.615 0-42.554 8.781-57.414 24.317-18.913 18.913-29.045 46.607-29.045 78.354 0 56.739 35.124 97.266 83.082 97.266 24.317 0 45.256-10.807 58.765-28.369 0.675 9.456 1.351 23.641 1.351 23.641h38.501l-1.351-52.011v-224.929zM719.367 645.741l-1.351 13.509c-5.404 21.615-22.966 36.475-44.58 36.475-36.475 0-49.309-34.449-49.309-63.493 0-39.177 20.264-65.52 49.984-65.52 24.317 0 39.852 17.562 43.905 34.449l1.351 13.509v31.071zM482.955 530.237c-53.361 0-90.512 42.554-90.512 103.346 0 58.765 37.15 96.591 94.565 96.591 29.72 0 50.66-6.755 62.818-12.158l3.377-1.351-8.106-32.422-4.728 2.026c-10.807 4.053-24.992 8.781-48.633 8.781-16.211 0-54.037-6.079-57.414-54.712 8.781 0.675 126.311 1.351 126.311 1.351v-3.377l1.351-16.887c0.675-41.879-20.264-91.187-79.029-91.187zM434.322 608.591c4.053-21.615 17.562-45.256 45.256-45.256 11.483 0 20.939 3.377 27.694 10.807 10.807 10.807 12.834 26.343 12.834 34.449h-85.784zM357.319 651.145c-6.079-25.668-17.562-42.554-33.098-50.66 27.018-12.158 43.905-36.475 43.905-65.52 0-20.939-8.106-39.852-21.615-52.011-16.887-15.536-41.203-22.29-77.003-22.29-22.29 0-46.607 2.026-64.169 6.079l-3.377 0.675v259.377h41.879v-110.1h26.343c27.694 1.351 39.852 12.834 47.282 45.931 7.43 35.124 12.834 54.712 16.887 62.142l1.351 2.026h43.905l-3.377-6.755c-4.728-9.456-11.483-36.475-18.913-68.897zM272.887 582.923h-29.045v-84.433c4.053-0.675 12.158-2.026 27.694-2.026 24.992 0 54.037 7.43 54.037 42.554 0 26.343-20.264 43.905-52.686 43.905zM1168.549 458.639c-14.86 0-26.343 10.807-26.343 25.668s10.807 26.343 24.992 26.343h0.675c14.86 0 26.343-11.483 26.343-26.343s-10.807-25.668-25.668-25.668zM1577.879 534.966s-0.675 11.483-0.675 18.913c-9.456-11.483-25.668-22.966-54.037-22.966-43.23 0-87.135 34.449-87.135 101.319 0 54.712 34.449 93.889 82.406 93.889 22.29 0 41.203-8.781 54.712-22.966v8.106c0 39.852-18.237 59.441-54.712 59.441-27.018 0-44.58-10.132-51.335-14.185l-4.728-3.377-11.483 34.449 2.702 2.026c14.86 9.456 39.177 16.211 63.493 16.211 16.211 0 47.282-2.702 69.573-22.966 18.913-17.562 27.694-44.58 27.694-87.135v-106.047l1.351-54.037h-37.826zM1572.475 644.391l-2.026 16.211c-6.079 18.913-22.29 31.747-41.879 31.747-36.475 0-49.309-33.098-49.309-61.467 0-39.177 20.264-64.844 49.984-64.844 20.264 0 35.799 12.158 41.879 32.422l1.351 13.509v32.422zM1402.934 449.858h-42.554v101.319c-10.132-10.807-27.694-19.588-51.335-19.588-21.615 0-42.554 8.781-58.090 24.317-18.913 18.913-29.045 46.607-29.045 78.354 0 56.739 35.124 97.266 83.082 97.266 24.317 0 45.256-10.807 58.765-28.369 0.675 9.456 1.351 23.641 1.351 23.641h38.501l-2.026-52.011v-224.929zM1361.055 645.741l-1.351 13.509c-5.404 21.615-22.966 36.475-44.58 36.475-36.475 0-49.309-34.449-49.309-63.493 0-39.177 20.264-65.52 49.984-65.52 24.317 0 39.177 17.562 43.905 34.449l1.351 13.509v31.071zM1737.963 530.237c-53.361 0-90.512 42.554-90.512 103.346 0 58.765 37.15 96.591 94.565 96.591 29.72 0 50.66-6.755 62.818-12.158l3.377-1.351-8.106-32.422-4.728 2.026c-10.807 4.053-24.992 8.781-48.633 8.781-16.211 0-54.037-6.079-57.414-54.712 9.456 0 126.987 0.675 126.987 0.675v-3.377l1.351-16.887c0-41.203-20.939-90.512-79.704-90.512zM1690.005 608.591c4.053-21.615 17.562-45.256 45.256-45.256 11.483 0 20.939 3.377 27.694 10.807 10.807 10.807 12.834 26.343 12.834 34.449h-85.784zM1060.475 559.958c-0.675-10.132-1.351-24.992-1.351-24.992h-37.826l1.351 61.467-0.675 130.364h42.554v-101.995l1.351-15.536c4.053-23.641 20.264-38.501 39.852-38.501l14.86 0.675 1.351-4.728v-35.124l-13.509-1.351c-19.588 0.675-37.15 12.158-47.958 29.72zM1147.609 726.797h42.554v-191.831h-42.554v191.831zM908.496 530.913c-24.992 0-44.58 9.456-58.765 25.668v-106.723h-42.554v225.604l-1.351 51.335h37.826s0.675-14.185 1.351-22.966c14.185 18.237 33.098 27.018 58.090 27.018 41.879 0 87.135-32.422 87.135-102.67 0-57.414-33.773-97.266-81.731-97.266zM896.338 695.726c-21.615 0-39.852-14.185-45.256-35.799 0-0.675-0.675-10.807-0.675-10.807v-33.098l2.026-12.834c5.404-22.29 24.317-37.15 45.931-37.15 34.449 0 49.984 31.747 49.984 64.169-0.675 39.852-20.264 65.52-52.011 65.52zM2507.314 490.385c-0.675 0-1.351 0.675-2.026 1.351-1.351 0.675-3.377 2.026-4.728 2.702l0.675-0.675 2.702-1.351 2.026-1.351c-0.675 0.675-1.351 0.675-2.026 1.351s-1.351 0.675-2.026 1.351c0.675-0.675 0.675-1.351 1.351-1.351l1.351-0.675 2.026-1.351c-0.675 0-1.351 0.675-2.026 1.351 0 0-0.675 0.675-1.351 0.675 8.106-12.834-6.079-6.079-6.079-6.079l-22.29 14.185c-11.483 3.377-20.264-3.377-20.264-3.377-72.95-25.668-108.074 3.377-108.074 3.377-60.116 34.449-133.066 128.338-133.066 128.338l-11.483 11.483c-6.755 3.377-14.185 6.755-14.185 6.755l-4.053-0.675v-8.781c24.317-35.124 45.256-70.248 62.818-100.644h0.675s12.834-16.211 5.404-9.456c0.675-0.675 0.675-1.351 0.675-1.351 3.377-6.755 7.43-12.834 10.132-18.913 1.351-0.675 3.377-2.026 4.728-2.702 2.702-4.728 4.728-8.781 6.755-13.509-0.675 0.675-1.351 0.675-2.026 1.351 0 0 0.675-0.675 0.675-1.351l-0.675 0.675c0-0.675 0.675-1.351 0.675-1.351l-0.675 0.675c9.456-18.237 16.887-33.098 20.939-42.554 2.026-1.351 3.377-2.702 3.377-2.702l2.026-3.377 2.026-4.053c1.351-4.053 2.702-8.106 3.377-11.483l-0.675 0.675c-0.675 0.675-1.351 1.351-2.026 2.702 0-0.675 0.675-2.026 0.675-2.702h-0.675c0-0.675 0-0.675 0.675-1.351h-0.675c3.377-11.483 4.728-22.29 5.404-33.098 0.675-0.675 1.351-1.351 2.026-1.351v-5.404c-0.675 0.675-1.351 0.675-1.351 1.351v-2.026c0-7.43-1.351-14.86-2.702-22.29 0.675 0 0.675-0.675 1.351-1.351-0.675-2.026-0.675-3.377-1.351-5.404l-1.351 1.351c0-0.675 0-0.675-0.675-1.351v-0.675c-2.026-8.106-4.728-15.536-7.43-22.29l0.675-0.675-4.053-8.106-0.675 0.675c-10.807-22.29-22.966-37.15-26.343-41.203l-0.675-0.675c-0.675-0.675-1.351-0.675-1.351-1.351-6.079-4.728-8.781-18.237-10.132-29.72 0.675-2.702 0.675-5.404 1.351-8.106 1.351-9.456 2.026-16.211 2.702-18.913 0 0-0.675 4.728-2.702 12.158-0.675 1.351-0.675 3.377-1.351 5.404 1.351-8.106 2.026-14.86 2.026-17.562v-1.351s-0.675 4.728-2.702 12.158v-8.106c-1.351-4.728-3.377 0-3.377 0-8.106 37.826-20.939 43.905-20.939 43.905-39.177 18.913-54.037 37.826-54.037 37.826-75.652 58.765-12.834 250.596-12.834 250.596l16.211 75.652-2.026 6.079s-4.053 2.026-8.106 0.675v-2.026s-20.939-25.668-29.72-66.871c0 0-3.377-32.422-21.615-70.923v-2.702c-2.026-4.053-4.053-8.106-6.755-12.834 0 0.675 0.675 2.026 0.675 2.702-6.079-11.483-14.185-22.966-23.641-34.449v-0.675c-3.377-4.053-7.43-8.781-11.483-12.834-8.781-8.781-18.913-17.562-31.071-24.992 0 0-16.211-18.913-84.433 3.377 0 0-20.264-2.026-43.23-29.72 0 0-9.456-2.026-6.079 4.728 0 0 20.939 16.887 22.29 43.23-0.675 0-0.675 0.675 0 1.351v1.351s-7.43 37.826 1.351 70.248c0.675 2.026 1.351 4.728 2.026 6.755h0.675c4.728 12.834 12.158 24.317 23.641 31.747 0 0 11.483 13.509 52.686 35.124l2.026 2.702h4.728c31.071 15.536 76.327 34.449 142.522 54.712 2.026 4.728 4.053 10.132 4.053 10.132l-2.026 4.053-29.72 4.728s-107.398 14.185-103.346 97.942c0 0 4.728 16.211-20.264 33.098 0 0-3.377 8.106 3.377 6.755 0 0 2.702-2.702 7.43-6.079-2.702 2.702-5.404 4.728-7.43 6.755 0 0 2.702-2.702 7.43-5.404-2.702 2.702-5.404 4.728-8.106 6.755 0 0 2.702-2.702 8.106-5.404-2.026 2.026-4.053 4.053-6.079 5.404 0 0 4.728-4.728 12.834-8.781l6.079-4.053c6.079-1.351 13.509-1.351 22.29 0.675 0 0 0.675 0 2.702 0.675 0 0 0 0.675-0.675 0.675h0.675v0.675s0 0.675-0.675 0.675c1.351 0 3.377 0.675 6.755 0.675l0.675-0.675h1.351l1.351-1.351c4.728 0 10.132 0.675 16.887-0.675l-0.675 0.675h0.675c0 0.675-0.675 0.675-0.675 1.351h2.026c3.377-0.675 6.755-0.675 10.132-2.026l0.675-2.026c11.483-3.377 23.641-9.456 34.449-21.615v2.026c0.675-0.675 1.351-1.351 1.351-2.026v1.351c3.377-4.053 6.755-8.781 10.132-14.185v-4.728c2.702-5.404 5.404-11.483 8.106-18.913l1.351 2.702v-5.404l1.351 4.053 0.675 1.351v-9.456c1.351-3.377 2.026-7.43 2.702-11.483 0 0 12.834-36.475 10.807-49.309h0.675c2.702-2.026 7.43-1.351 7.43-1.351l3.377 3.377s1.351 3.377 2.702 5.404c0.675 2.702 2.702 5.404 3.377 8.781s1.351 4.728 2.702 9.456c0.675 4.728 1.351 10.807 2.702 13.509 0.675 3.377 4.053 12.158 4.053 12.158l55.388 177.646 7.43 4.053 5.404-2.702v-11.483c0-6.755-8.781-26.343-8.781-26.343l-58.090-157.383 1.351-10.132c-5.404-20.939-4.728-16.211-4.053-19.588s2.702-2.702 2.702-2.702h3.377l0.675 0.675s0.675 0 0.675 0.675c15.536 39.177 66.871 62.142 85.108 69.573l2.702 2.702c2.702 0.675 4.053 1.351 4.053 1.351 0.675 0 0.675 0 1.351 0.675 0-0.675-0.675-0.675-0.675-1.351 0.675 0 1.351 0.675 1.351 0.675s0.675 0 1.351 0.675c0 0-0.675-0.675-0.675-1.351 7.43 2.702 14.185 2.702 20.264 1.351l1.351 1.351c0.675 0 0.675-0.675 1.351-0.675l6.079-2.026c-0.675-0.675-1.351-1.351-2.026-1.351 4.728-2.026 8.106-4.728 10.807-6.755 0.675 0.675 0.675 0.675 0.675 1.351l1.351-1.351s0 0.675 0.675 0.675l3.377-3.377c0.675-0.675 1.351-0.675 2.026-1.351l-1.351-2.026c8.106-4.053 20.939-2.702 20.939-2.702h17.562c0.675-0.675 0.675-1.351 0-2.702h2.026s-0.675 0-2.026-0.675l-0.675-0.675c-4.053-4.728-17.562-9.456-17.562-9.456-4.053-1.351-7.43-3.377-10.132-6.079-2.026-2.026-3.377-4.053-4.728-6.079h-0.675c-2.702-4.053-4.728-7.43-4.728-7.43-1.351-2.026-2.026-3.377-3.377-4.728h0.675c-1.351-2.026-3.377-3.377-4.728-4.728-27.694-28.369-83.082-19.588-83.082-19.588l-35.124 0.675c-5.404-1.351-11.483-2.026-14.86-3.377-8.781-2.702-5.404-0.675-8.106-4.053s0 0 0.675-2.702 1.351-3.377 5.404-7.43c45.256 1.351 82.406-0.675 111.451-3.377h6.079v-0.675h2.026v-0.675c24.317-2.702 43.23-6.755 56.063-10.132 4.053 0 7.43-0.675 10.807-0.675h1.351c1.351 0 2.702-0.675 4.053-0.675h-3.377c1.351 0 2.702-0.675 4.053-0.675h-4.728c8.781-2.702 12.834-4.728 12.834-4.728 6.079-2.026 11.483-4.728 16.887-7.43 0.675 0 2.026 0.675 2.702 0.675 0 0 0.675 0 0.675-0.675h0.675c2.702-1.351 4.728-2.702 7.43-4.053h-2.702s0.675 0 0.675-0.675h-1.351c14.185-8.106 24.992-16.887 33.098-25.668h3.377c1.351-1.351 2.026-2.702 3.377-4.053h-2.702c0-0.675 0.675-0.675 0.675-1.351h-0.675c5.404-6.755 9.456-14.185 12.158-20.939h2.026c0.675-1.351 1.351-2.702 1.351-4.053h-2.026v-0.675h-0.675c2.702-7.43 3.377-14.185 3.377-20.264v-0.675h1.351v-1.351c-0.675 0-1.351 0-2.026-0.675v-0.675c0-8.106-1.351-13.509-1.351-13.509 1.351-11.483 24.992-24.992 24.992-24.992l4.728-2.702 2.026 2.026zM199.261 283.694h14.86v101.319h48.633v12.158h-63.493v-113.478zM309.361 399.198c-21.615 0-39.177-16.211-39.177-41.879 0-27.018 18.237-43.23 40.528-43.23 23.641 0 39.177 16.887 39.177 41.879 0 30.396-20.939 43.23-40.528 43.23zM309.361 388.391c14.185 0 24.992-13.509 24.992-31.747 0-13.509-6.755-31.071-24.317-31.071s-24.992 16.211-24.992 31.747c0 17.562 10.132 31.071 24.317 31.071zM368.127 337.731c0-8.781 0-15.536-0.675-22.29h12.834l0.675 13.509h0.675c4.053-7.43 13.509-14.86 27.018-14.86 11.483 0 29.045 6.755 29.045 34.449v48.633h-14.86v-47.282c0-12.834-4.728-24.317-18.913-24.317-9.456 0-16.887 6.755-19.588 14.86-0.675 2.026-0.675 4.728-0.675 6.755v49.309h-14.86v-58.765zM532.264 277.615v98.617c0 7.43 0 15.536 0.675 20.939h-13.509l-0.675-14.185c-4.728 8.781-14.185 16.211-27.694 16.211-19.588 0-35.124-16.887-35.124-41.203 0-27.018 16.887-43.905 36.475-43.905 12.834 0 20.939 6.079 24.317 12.158v-48.633h15.536zM517.404 349.214c0-2.026 0-4.053-0.675-6.079-2.026-9.456-10.132-16.887-21.615-16.887-15.536 0-24.317 13.509-24.317 31.071 0 16.887 8.106 30.396 24.317 30.396 10.132 0 18.913-6.755 21.615-17.562 0.675-2.026 0.675-4.053 0.675-6.079v-14.86zM589.678 399.198c-21.615 0-39.177-16.211-39.177-41.879 0-27.018 18.237-43.23 40.528-43.23 23.641 0 39.177 16.887 39.177 41.879 0 30.396-20.939 43.23-40.528 43.23zM590.354 388.391c14.185 0 24.992-13.509 24.992-31.747 0-13.509-6.755-31.071-24.317-31.071s-24.992 16.211-24.992 31.747c0 17.562 10.132 31.071 24.317 31.071zM649.119 337.731c0-8.781 0-15.536-0.675-22.29h13.509l0.675 13.509c4.053-7.43 13.509-14.86 27.018-14.86 11.483 0 29.045 6.755 29.045 34.449v48.633h-14.86v-47.282c0-12.834-4.728-24.317-18.913-24.317-9.456 0-16.887 6.755-19.588 14.86-0.675 2.026-0.675 4.728-0.675 6.755v49.309h-14.86v-58.765zM778.807 285.72c6.079-1.351 16.887-2.702 27.018-2.702 14.86 0 24.317 2.702 31.071 8.106 6.079 4.053 9.456 10.807 9.456 20.264 0 10.807-7.43 20.939-18.913 24.992v0.675c10.807 2.702 23.641 11.483 23.641 28.369 0 9.456-4.053 16.887-9.456 22.966-7.43 7.43-20.264 10.807-39.177 10.807-10.132 0-17.562-0.675-22.966-1.351v-112.127zM793.668 332.327h13.509c15.536 0 24.317-8.106 24.317-18.913 0-12.834-10.132-18.237-24.992-18.237-6.755 0-10.807 0.675-12.834 1.351v35.799zM793.668 386.364c2.702 0.675 6.755 0.675 12.158 0.675 14.86 0 29.045-5.404 29.045-22.29 0-15.536-13.509-21.615-29.045-21.615h-12.158v43.23zM903.768 399.198c-21.615 0-39.177-16.211-39.177-41.879 0-27.018 18.237-43.23 40.528-43.23 23.641 0 39.177 16.887 39.177 41.879 0 30.396-20.939 43.23-40.528 43.23zM903.768 388.391c14.185 0 24.992-13.509 24.992-31.747 0-13.509-6.755-31.071-24.317-31.071s-24.992 16.211-24.992 31.747c0 17.562 10.132 31.071 24.317 31.071zM963.208 341.108c0-9.456 0-17.562-0.675-25.668h12.834l0.675 16.211h0.675c3.377-10.807 12.834-17.562 22.966-17.562 1.351 0 2.702 0 4.053 0.675v13.509c-1.351 0-3.377-0.675-5.404-0.675-10.132 0-17.562 8.106-19.588 18.913 0 2.026-0.675 4.728-0.675 6.755v43.23h-14.86v-55.388zM1050.343 399.198c-21.615 0-39.177-16.211-39.177-41.879 0-27.018 18.237-43.23 40.528-43.23 23.641 0 39.177 16.887 39.177 41.879 0 30.396-20.939 43.23-40.528 43.23zM1050.343 388.391c14.185 0 24.992-13.509 24.992-31.747 0-13.509-6.755-31.071-24.317-31.071s-24.992 16.211-24.992 31.747c0 17.562 10.132 31.071 24.317 31.071zM1177.33 375.557c0 8.106 0 15.536 0.675 22.29h-12.834l-0.675-13.509c-3.377 6.755-12.158 14.86-27.018 14.86-12.834 0-28.369-7.43-28.369-35.799v-47.958h14.86v45.256c0 15.536 4.728 26.343 18.237 26.343 10.132 0 16.887-6.755 19.588-13.509 0.675-2.026 1.351-4.728 1.351-7.43v-49.984h14.86v59.441zM1271.894 385.689c0 18.913-4.053 30.396-11.483 37.15-8.106 7.43-19.588 9.456-29.72 9.456-9.456 0-20.264-2.026-27.018-6.755l3.377-11.483c5.404 3.377 13.509 6.755 23.641 6.755 14.86 0 26.343-8.106 26.343-28.369v-8.781c-4.053 7.43-13.509 13.509-25.668 13.509-20.264 0-34.449-16.887-34.449-39.852 0-27.694 18.237-43.23 37.15-43.23 14.185 0 21.615 7.43 25.668 14.185l0.675-12.158h12.834c-0.675 6.079-0.675 12.158-0.675 22.29v47.282zM1257.034 347.863c0-2.702 0-4.728-0.675-6.755-2.702-8.781-9.456-15.536-20.939-15.536-14.185 0-24.317 12.158-24.317 31.071 0 15.536 8.106 29.045 24.317 29.045 9.456 0 17.562-5.404 20.264-15.536 0.675-2.026 1.351-5.404 1.351-8.106v-14.185zM1296.211 277.615h14.86v50.66c2.702-4.053 6.079-8.106 10.807-10.132 4.053-2.702 9.456-4.053 14.86-4.053 10.807 0 28.369 6.755 28.369 35.124v48.633h-14.185v-46.607c0-13.509-4.728-24.317-18.913-24.317-9.456 0-16.887 6.755-19.588 14.86-0.675 2.026-1.351 4.053-1.351 6.755v49.309h-14.86v-120.232zM1458.322 399.198c-21.615 0-39.177-16.211-39.177-41.879 0-27.018 18.237-43.23 40.528-43.23 23.641 0 39.177 16.887 39.177 41.879 0 30.396-20.939 43.23-40.528 43.23zM1458.997 388.391c14.185 0 24.992-13.509 24.992-31.747 0-13.509-6.755-31.071-24.317-31.071s-24.992 16.211-24.992 31.747c0 17.562 10.132 31.071 24.317 31.071zM1519.113 397.172v-69.573h-11.483v-11.483h11.483v-4.053c0-11.483 2.702-21.615 9.456-28.369 5.404-5.404 12.834-7.43 19.588-7.43 5.404 0 9.456 1.351 12.834 2.026l-2.026 11.483c-2.702-1.351-5.404-2.026-9.456-2.026-12.158 0-15.536 10.807-15.536 23.641v4.053h19.588v11.483h-19.588v70.248h-14.86z',
        ],
        attrs: [
          {
            fill: 'rgb(255, 255, 255)',
          },
        ],
        width: 2707,
        isMulticolor: false,
        isMulticolor2: false,
        grid: 0,
        tags: ['Redbridge Council Logo-Full White'],
      },
      attrs: [
        {
          fill: 'rgb(255, 255, 255)',
        },
      ],
      properties: {
        order: 24,
        id: 17,
        name: 'Redbridge-Council-Logo-Full-White',
        prevSize: 32,
      },
      setIdx: 0,
      setId: 2,
      iconIdx: 1,
    },
    {
      icon: {
        paths: [
          'M778.442 406.143h-45.367v108.017c-10.802-11.522-29.525-20.883-54.729-20.883-23.044 0-45.367 9.361-61.21 25.924-20.163 20.163-30.965 49.688-30.965 83.533 0 60.489 37.446 103.696 88.574 103.696 25.924 0 48.248-11.522 62.65-30.245 0.72 10.082 1.44 25.204 1.44 25.204h41.046l-1.44-55.449v-239.797zM733.795 615.696l-1.44 14.402c-5.761 23.044-24.484 38.886-47.527 38.886-38.886 0-52.568-36.726-52.568-67.691 0-41.767 21.603-69.851 53.288-69.851 25.924 0 42.487 18.723 46.807 36.726l1.44 14.402v33.125zM481.035 492.557c-56.889 0-96.495 45.367-96.495 110.177 0 62.65 39.606 102.976 100.816 102.976 31.685 0 54.008-7.201 66.97-12.962l3.601-1.44-8.641-33.845-5.041 2.16c-11.522 4.321-26.644 9.361-51.848 9.361-17.283 0-57.609-6.481-61.21-58.329 10.082 0 135.381 0.72 135.381 0.72v-3.601l1.44-18.003c0-45.367-22.323-97.215-84.973-97.215zM429.907 575.37c4.321-23.044 18.723-48.248 48.248-48.248 12.242 0 22.323 3.601 29.525 11.522 11.522 11.522 13.682 28.084 13.682 36.726h-91.454zM347.814 621.457c-6.481-27.364-18.723-45.367-35.286-54.008 28.805-12.962 46.807-38.886 46.807-69.851 0-22.323-8.641-42.487-23.044-55.449-18.003-16.563-43.927-23.764-82.093-23.764-23.764 0-49.688 2.16-68.411 6.481l-3.601 0.72v276.523h44.647v-117.378h28.084c29.525 1.44 42.487 13.682 50.408 48.968 7.921 37.446 13.682 58.329 18.003 66.25l1.44 2.16h46.807l-3.601-7.201c-5.041-10.082-12.242-39.606-20.163-73.451zM257.8 548.006h-30.965v-90.014c4.321-0.72 12.962-2.16 29.525-2.16 26.644 0 57.609 7.921 57.609 45.367 0 28.805-22.323 46.807-56.169 46.807zM1212.669 416.225c-15.842 0-28.084 11.522-28.084 27.364s11.522 28.084 26.644 28.084h0.72c15.842 0 28.084-12.242 28.084-28.084s-11.522-27.364-27.364-27.364zM1649.058 497.598s-0.72 12.242-0.72 20.163c-10.082-12.242-27.364-24.484-57.609-24.484-46.087 0-92.895 36.726-92.895 108.017 0 58.329 36.726 100.096 87.854 100.096 23.764 0 43.927-9.361 58.329-24.484v8.641c0 42.487-19.443 63.37-58.329 63.37-28.805 0-47.527-10.802-54.729-15.122l-5.041-3.601-12.242 36.726 2.88 2.16c15.842 10.082 41.767 17.283 67.691 17.283 17.283 0 50.408-2.88 74.172-24.484 20.163-18.723 29.525-47.527 29.525-92.895v-113.778l1.44-57.609h-40.326zM1643.297 613.536l-2.16 17.283c-6.481 20.163-23.764 33.845-44.647 33.845-38.886 0-52.568-35.286-52.568-65.53 0-41.767 21.603-69.131 53.288-69.131 21.603 0 38.166 12.962 44.647 34.565l1.44 14.402v34.565zM1462.549 406.143h-45.367v108.017c-10.802-11.522-29.525-20.883-54.729-20.883-23.044 0-45.367 9.361-61.93 25.924-20.163 20.163-30.965 49.688-30.965 83.533 0 60.489 37.446 103.696 88.574 103.696 25.924 0 48.248-11.522 62.65-30.245 0.72 10.082 1.44 25.204 1.44 25.204h41.046l-2.16-55.449v-239.797zM1417.181 615.696l-1.44 14.402c-5.761 23.044-24.484 38.886-47.527 38.886-38.886 0-52.568-36.726-52.568-67.691 0-41.767 21.603-69.851 53.288-69.851 25.924 0 41.767 18.723 46.807 36.726l1.44 14.402v33.125zM1819.724 492.557c-56.889 0-96.495 45.367-96.495 110.177 0 62.65 39.606 102.976 100.816 102.976 31.685 0 54.008-7.201 66.97-12.962l3.601-1.44-8.641-34.565-5.041 2.16c-11.522 4.321-26.644 9.361-51.848 9.361-17.283 0-57.609-6.481-61.21-58.329 10.082 0 135.381 0.72 135.381 0.72v-3.601l1.44-18.003c0-44.647-22.323-96.495-84.973-96.495zM1768.596 575.37c4.321-23.044 18.723-48.248 48.248-48.248 12.242 0 22.323 3.601 29.525 11.522 11.522 11.522 13.682 28.084 13.682 36.726h-91.454zM1097.451 524.242c-0.72-10.802-1.44-26.644-1.44-26.644h-40.326l1.44 65.53-0.72 138.982h45.367v-108.737l1.44-16.563c4.321-25.204 21.603-41.046 42.487-41.046l15.842 0.72 1.44-5.041v-37.446l-14.402-1.44c-20.883 0-39.606 12.242-51.128 31.685zM1190.346 702.11h45.367v-204.512h-45.367v204.512zM935.426 492.557c-26.644 0-47.527 10.082-62.65 27.364v-113.778h-45.367v240.518l-1.44 54.729h40.326s0.72-15.122 1.44-24.484c15.122 19.443 35.286 28.805 61.93 28.805 44.647 0 92.895-34.565 92.895-109.457 0-60.489-36.006-103.696-87.134-103.696zM922.464 668.264c-23.044 0-42.487-15.122-48.248-38.166 0-0.72-0.72-11.522-0.72-11.522v-35.286l2.16-13.682c5.761-23.764 25.924-39.606 48.968-39.606 36.726 0 53.288 33.845 53.288 68.411-1.44 43.207-22.323 69.851-55.449 69.851z',
          'M2285.637 632.979s-5.041-0.72-7.921 1.44c-0.72 0.72-7.201-0.72-7.201-0.72l4.321-7.921s-4.321-13.682-8.641-17.283 3.601-1.44 3.601-1.44 2.88 4.321 7.201 5.761c4.321 1.44 9.361-0.72 9.361-0.72l9.361-26.644-0.72 29.525 4.321 0.72s9.361-4.321 16.563-8.641c3.601-2.16 7.201-4.321 7.921-5.761 3.601-4.321 12.962-10.802 12.962-10.802l-14.402 15.122s-9.361 5.761-13.682 10.082c-4.321 4.321-5.041 5.041-5.761 7.921s-3.601-0.72-0.72 2.88-0.72 1.44 8.641 4.321c9.361 2.88 30.245 5.761 32.405 7.201 2.88 0.72 3.601 5.041 0.72 5.761s0.72 5.041-13.682 0-18.003-5.761-18.003-5.761h-5.041s-1.44-0.72-2.88 2.88c-0.72 3.601-1.44-1.44 4.321 20.883l-1.44 10.802 61.93 167.786s9.361 21.603 9.361 28.084v12.242l-5.761 2.88-7.921-4.321-59.049-189.39s-3.601-9.361-4.321-12.962c-0.72-3.601-1.44-9.361-2.88-14.402-0.72-5.041-1.44-7.201-2.88-10.082-0.72-3.601-2.88-7.201-3.601-9.361-0.72-2.88-2.88-5.761-2.88-5.761z',
          'M2273.395 632.979l1.44-1.44c2.16-2.88 7.201-10.802 0-15.842 0 0 5.761 12.242 13.682-5.041l3.601-4.321v6.481s0 5.041 8.641 4.321c0.72 0 1.44 0 2.88-0.72 11.522-2.16-10.082 9.361-3.601 12.242 7.201 2.88 13.682 4.321 13.682 4.321l-7.921 0.72-4.321 2.88v5.761l-6.481-9.361-5.041-5.041c-1.44 0-4.321-2.16-16.563 5.041z',
          'M2050.16 395.342s-11.522 2.88-21.603 1.44c-10.082-0.72 5.041 10.082 21.603-1.44z',
          'M2289.958 612.096l-18.723-87.854s-66.25-204.512 11.522-270.042c0 0 16.563-20.163 57.609-40.326 0 0 13.682-6.481 22.323-46.807 0 0 2.16-5.041 3.601 0 0 0-1.44 51.128 13.682 59.049 0 0 70.571 75.612 36.726 163.466 0 0.72-48.968 112.338-126.74 222.515z',
          'M2305.8 615.696l20.163-20.163s77.772-100.096 141.862-136.821c0 0 37.446-31.685 115.218-3.601 0 0 8.641 7.201 21.603 3.601l23.764-15.122s17.283-8.641 3.601 10.082c0 0-25.204 13.682-26.644 26.644 0 0 20.163 71.291-84.253 111.617 0.72 0-64.090 28.805-215.314 23.764z',
          'M2276.996 610.655s-22.323-27.364-31.685-71.291c0 0-11.522-108.017-100.096-165.626 0 0-17.283-20.163-90.014 3.601 0 0-21.603-2.16-46.087-31.685 0 0-10.082-2.16-6.481 5.041 0 0 23.764 18.723 23.764 48.968 0 0-17.283 87.854 28.805 115.218 0 0 37.446 45.367 218.194 100.096 0 0.72 5.041 2.16 3.601-4.321z',
          'M2274.835 630.098l-33.845 5.041s-114.498 15.122-110.177 104.416c0 0 5.041 17.283-21.603 35.286 0 0-3.601 8.641 3.601 7.201 0 0 17.283-18.723 46.087-11.522 0 0 84.253 22.323 106.577-82.813 0.72 0 19.443-54.008 9.361-57.609z',
          'M2310.121 635.139l54.008-1.44s71.291-11.522 96.495 31.685c0 0 7.201 16.563 21.603 20.163 0 0 23.764 8.641 18.723 13.682h-18.723s-17.283-1.44-25.204 5.041c0 0-22.323 23.764-47.527 11.522-0.72-0.72-82.093-27.364-99.376-80.653z',
          'M2356.208 497.598l-2.16 2.16c3.601-1.44 5.761-2.16 5.761-2.16s20.883-25.924-3.601 0zM2266.194 603.454s-18.003-18.723-34.565-35.286l-19.443-19.443v-1.44c23.044-6.481 12.962-4.321 0.72-2.88 9.361-31.685 8.641-64.81 7.201-82.813-2.16-4.321-4.321-8.641-7.201-12.962 11.522 41.767-5.041 94.335-5.041 95.775l-3.601-3.601c-2.16-2.16-10.082-10.802-20.883-23.044 2.16-5.041 16.563-51.848 5.041-103.696-3.601-4.321-7.921-9.361-12.242-13.682v0.72s25.924 20.883 1.44 109.457c-8.641-10.082-18.723-21.603-28.805-33.125l2.88 0.72c9.361-66.97-12.242-100.096-18.723-108.737-3.601-0.72-7.201-1.44-12.242-1.44 38.886 41.046 28.084 95.055 25.204 106.577-9.361-10.802-19.443-21.603-28.805-31.685 0-39.606-7.921-65.53-11.522-74.172-1.44 0-2.88 0-4.321 0.72 10.082 30.965 10.802 56.889 10.802 68.411-10.802-11.522-20.883-21.603-29.525-29.525 0-19.443-9.361-33.125-9.361-33.125h-2.88c4.321 5.041 5.041 18.723 5.761 27.364-3.601-3.601-7.201-5.761-10.802-7.921-31.685-18.003-46.087-30.965-60.489-43.927l15.122 20.163 42.487 30.965 39.606 39.606 5.041 5.761c-0.72 0.72-35.286 14.402-80.653-0.72 0 0 11.522 16.563 87.854 9.361v-0.72l20.883 21.603c-8.641 2.16-59.049 13.682-108.017-0.72 0.72 2.16 1.44 5.041 2.16 7.201 13.682 3.601 50.408 9.361 110.897 0.72 0 0 0.72 0 1.44-0.72l30.245 31.685c-7.201 1.44-67.691 12.242-113.058-2.88l-4.321 3.601s31.685 18.003 123.139 5.761l24.484 25.204c-2.16 0.72-39.606 16.563-92.174 4.321l4.321 6.481h0.72c3.601 0 51.848 3.601 90.734-7.201l14.402 15.122c-4.321 2.88-23.044 14.402-48.968 12.242 0 0 0 4.321 5.761 5.761 5.041 0.72 34.565-5.041 46.807-14.402l1.44 1.44s38.166 41.046 47.527 43.927c7.201 1.44-6.481-10.802-6.481-10.802zM2026.397 407.584l-0.72 5.041s40.326 26.644 54.729 7.201c0 0-14.402 10.802-54.008-12.242zM2379.252 228.276l-2.88-2.88c-5.041 3.601-11.522 7.921-17.283 11.522 0 0 5.761 6.481 20.163-8.641zM2234.509 659.623c-25.204-20.163-60.489 4.321-37.446-1.44 18.003-4.321 31.685 0 37.446 1.44-5.041 4.321-8.641 7.921-10.802 12.242 0 0-1.44 1.44-2.88 3.601-8.641-4.321-30.245-12.962-49.688-5.761 0 0 34.565 6.481 44.647 10.082-3.601 3.601-7.201 7.921-12.242 13.682-11.522-19.443-45.367-9.361-57.609-5.761l-2.16 4.321c18.003-8.641 50.408 0 59.049 2.88-4.321 5.041-9.361 10.082-14.402 15.842-10.082-16.563-43.207-5.041-46.087-3.601-1.44 0.72-5.041 3.601-7.921 5.761 0 0.72 0 1.44-0.72 2.16 18.723-13.682 43.927-6.481 52.568-3.601-7.201 7.921-15.842 16.563-23.764 24.484-15.122-5.761-25.924-2.88-31.685 1.44v5.761c9.361-8.641 24.484-7.921 30.965-7.201-18.003 18.003-36.006 36.006-48.968 46.807 0 0 5.041-5.041 13.682-9.361 8.641-5.761 16.563-11.522 18.003-12.962 2.16-2.16 30.965-32.405 41.767-41.767v0.72c0 31.685-23.764 48.968-24.484 51.848 0 0 0 0.72-0.72 0.72 1.44 0 3.601 0.72 7.201 0.72 24.484-30.245 20.883-52.568 18.723-54.729 1.44-1.44 2.16-2.16 2.88-2.16 2.16-1.44 7.201-6.481 12.242-12.242 0.72 0.72 0.72 1.44 0.72 1.44s17.283 25.204-14.402 67.691c3.601-0.72 7.201-0.72 10.802-2.16l7.921-20.883s3.601-22.323 5.041-27.364c0.72-4.321-2.88-20.163-7.201-22.323 4.321-5.041 8.641-9.361 11.522-12.242 0 0.72 0.72 0.72 0.72 0.72s33.125-0.72 21.603 53.288v5.041c3.601-4.321 7.201-9.361 10.802-15.122v-8.641s-18.723-40.326-27.364-41.046c4.321-5.041 12.962-13.682 21.603-22.323l16.563 48.248 0.72 1.44v-2.16c0-29.525-7.921-46.807-10.082-51.848 0 0 0-0.72-0.72-1.44 9.361-8.641 18.003-16.563 22.323-17.283 0 1.44-22.323 10.082-38.166 23.044zM2262.594 481.035s2.16 1.44 5.041 4.321c-0.72-0.72-0.72-1.44-1.44-2.88-12.242-32.405-3.601-1.44-3.601-1.44zM2585.924 458.712c-3.601 6.481-6.481 13.682-8.641 21.603l7.201-2.16s0.72-9.361 5.041-18.003c-1.44 0-2.88-0.72-3.601-1.44zM2638.492 450.070c-0.72 0.72-1.44 0.72-2.16 1.44-12.242 7.201-30.245 16.563-51.848 27.364-11.522 5.761-23.764 12.242-36.006 18.723 3.601-8.641 10.082-25.204 25.924-43.207l-6.481-2.16c-8.641 10.802-20.163 29.525-23.764 46.807-9.361 5.041-18.723 9.361-28.805 14.402 1.44-9.361 7.201-42.487 36.006-65.53-2.16-0.72-4.321-0.72-5.761-1.44-9.361 10.802-29.525 35.286-36.726 69.851l-25.924 12.962c-4.321-2.16-6.481-3.601-1.44 0.72l-12.962 6.481c3.601-12.962 22.323-72.011 56.889-89.294v-2.16h-9.361c-12.962 15.122-46.087 57.609-53.288 94.335-11.522 5.761-23.044 11.522-33.845 16.563 9.361-36.726 50.408-90.734 63.37-107.297-1.44 0.72-2.88 0.72-4.321 1.44-43.927 42.487-63.37 99.376-66.97 110.177l-24.484 12.242c2.88-10.802 13.682-50.408 39.606-74.172l-3.601-3.601s-34.565 39.606-41.046 80.653c-20.883 10.802-34.565 17.283-34.565 17.283l-5.041 2.16c7.921-10.802 22.323-37.446 35.286-51.128l-11.522 0.72s-25.204 28.805-28.084 52.568l-25.204 11.522c9.361 0.72 20.883-2.88 33.125-7.921 10.802 7.201 78.492 10.082 78.492 10.082l-1.44-4.321c-53.288-2.88-65.53-7.201-68.411-9.361 18.723-8.641 34.565-18.723 37.446-19.443 2.16-0.72 3.601-1.44 5.041-2.16l1.44 5.041s56.169 23.764 100.096 17.283c2.16-0.72 4.321-0.72 6.481-1.44h-2.16c-11.522 0-61.21-2.16-98.655-24.484 5.041-1.44 12.962-6.481 12.962-6.481l13.682-6.481c14.402 7.201 77.052 19.443 103.696 23.764 2.88-1.44 5.041-2.88 7.921-4.321-36.726-3.601-92.895-20.163-102.976-23.764l23.044-10.802 15.842-9.361c15.842 12.242 71.291 15.122 99.376 15.122 1.44-1.44 2.16-2.88 3.601-4.321-38.886 5.041-68.411-3.601-84.253-9.361 1.44-0.72 5.761-11.522 7.921-17.283l2.16-1.44 14.402-6.481 12.242-7.201c-2.16 12.962 0.72 4.321 2.88-1.44l2.16-1.44c5.761 17.283 38.166 21.603 54.729 22.323 0.72-1.44 0.72-2.88 1.44-4.321-33.125-1.44-48.968-13.682-54.729-18.723l34.565-20.163c0 11.522 12.962 15.122 23.764 16.563v-1.44c-15.842-3.601-15.842-10.082-15.842-10.082l-5.761-5.761 49.688-29.525 2.16 0.72zM2505.271 538.644c-7.201-2.88-11.522-5.041-11.522-5.041h-1.44l14.402-8.641c-1.44 9.361-2.16 12.962-1.44 13.682zM2457.024 682.667l5.041-1.44 7.201-2.16c-2.16-2.16-3.601-4.321-5.041-6.481-5.761 1.44-10.802 2.88-14.402 4.321-9.361-2.88-18.723-5.041-18.723-5.041s-6.481-2.16-15.842-5.041c16.563-5.761 30.245-6.481 40.326-6.481-1.44-2.16-3.601-3.601-5.041-5.041-17.283 0.72-30.245 6.481-38.886 10.802-7.921-2.16-16.563-5.041-26.644-8.641 10.082-6.481 30.965-12.242 44.647-15.122-2.16-0.72-5.041-2.16-7.201-2.88-22.323 2.16-33.845 11.522-38.886 17.283-7.921-2.88-15.842-5.041-23.764-7.201 3.601-4.321 13.682-11.522 41.767-10.802 0 0-7.921-3.601-16.563-3.601h-2.16c-8.641 0-18.723 2.88-23.764 15.122-9.361-2.88-18.003-5.761-25.924-7.921 0 0 2.88-2.16 9.361-5.041h-5.761c-1.44 1.44-2.16 2.88-3.601 5.041-5.761-1.44-10.802-2.88-15.122-4.321-6.481-2.16-10.082-2.88-10.802-2.88-2.16 0.72 0.72 2.88 3.601 4.321 2.16 1.44 4.321 2.16 4.321 2.16s7.201 2.88 15.122 6.481c-2.88 23.044 18.003 33.125 18.003 33.125-12.242-17.283-15.842-28.805-17.283-33.125 5.761 2.16 11.522 4.321 16.563 5.041 2.88 0.72 5.761 1.44 9.361 2.16-10.082 33.125 26.644 43.207 26.644 43.207-26.644-23.764-26.644-39.606-26.644-43.207 7.921 2.16 17.283 4.321 23.764 6.481 0 0.72-3.601 28.084 25.204 55.449 2.88 0.72 4.321 1.44 4.321 1.44 0.72 0 0.72 0 1.44 0.72-10.802-13.682-31.685-43.927-30.965-56.889 0.72 0 0.72 0 1.44 0.72 2.16 0.72 4.321 1.44 5.761 2.16 2.16 0.72 8.641 2.88 16.563 5.041 0 0.72 0.72 1.44 0.72 2.16l-1.44 1.44c0.72 0 1.44-0.72 1.44-0.72 2.88 9.361 10.082 30.245 30.245 48.248l6.481-2.16c-9.361-7.921-23.044-22.323-35.286-46.087 0.72-0.72 2.16-0.72 2.88-1.44 10.802 2.88 22.323 5.761 29.525 7.921 0 0 0 2.16 0.72 5.041-2.16 1.44-2.88 2.88-2.88 2.88l4.321 1.44c2.16 5.761 5.761 13.682 12.962 23.044l3.601-3.601c0.72-0.72 1.44-0.72 2.16-1.44l-12.962-19.443 5.761-1.44c9.361 5.041 18.723 10.082 20.883 10.802 2.16 1.44 18.723 1.44 20.163 1.44h7.921s-18.723-4.321-20.883-5.041c-1.44-2.88-13.682-7.201-23.764-10.802zM2338.205 532.883c-8.641 9.361-25.924 11.522-34.565 12.242 1.44-8.641 2.88-17.283 5.041-27.364 7.921 0.72 27.364 0 45.367-18.003-11.522 3.601-35.286 10.802-43.927 10.802 0.72-5.041 2.16-10.802 2.88-15.842 11.522-3.601 47.527-16.563 69.131-32.405 2.88-5.041 5.041-9.361 7.201-14.402-14.402 8.641-62.65 36.726-74.892 38.886 1.44-7.921 2.88-15.842 4.321-24.484 5.761 2.88 3.601 0 0.72-2.88v-0.72c23.044-4.321 92.895-59.049 92.895-59.049l2.16-3.601 2.16-4.321c1.44-4.321 2.88-7.921 3.601-12.242l-0.72 0.72c-23.044 34.565-92.895 70.571-100.096 74.172 2.16-11.522 4.321-23.764 6.481-35.286 0.72 0 0.72-0.72 0-2.16 0-1.44 0.72-2.16 0.72-3.601 12.962-4.321 73.451-51.848 97.935-71.291v-5.761c-28.805 25.924-96.495 69.851-97.215 70.571 2.16-10.802 3.601-21.603 5.761-32.405 2.88 0.72 2.16-0.72 0.72-2.16 0-0.72 0-2.16 0.72-2.88 12.242-1.44 63.37-39.606 87.134-58.329-0.72-2.16-0.72-3.601-1.44-5.761-19.443 20.163-74.172 52.568-84.973 58.329 2.88-15.122 5.041-29.525 7.921-43.927 18.003 2.16 50.408-23.764 68.411-40.326l-4.321-8.641c-28.084 28.805-56.889 45.367-64.090 48.248 2.88-15.122 5.041-29.525 7.921-43.207 0-2.16 0.72-3.601 0.72-5.761 6.481-35.286 11.522-65.53 13.682-84.973 1.44-10.082 2.16-17.283 2.88-20.163 0 0-0.72 5.041-2.88 12.962-2.88 13.682-7.921 36.006-13.682 64.81-7.201-8.641-14.402-19.443-17.283-24.484 0 0-0.72 0-0.72 0.72 7.201 23.764 14.402 25.924 17.283 25.204-2.16 9.361-4.321 19.443-6.481 30.245-2.16-2.16-23.764-23.764-28.805-46.087l-6.481 4.321c5.041 12.242 25.204 44.647 33.845 48.968-2.88 12.962-5.041 26.644-7.921 40.326-7.921-9.361-30.245-36.726-43.927-75.612-3.601 2.88-5.761 5.041-7.201 7.201 6.481 14.402 30.965 62.65 51.128 71.291-2.88 12.962-5.041 26.644-7.921 40.326-12.962-15.842-57.609-73.451-57.609-90.014l-5.761 1.44c-0.72 0.72-0.72 1.44-1.44 2.16 6.481 10.802 48.248 79.932 63.37 92.174-2.16 11.522-4.321 23.764-6.481 35.286-10.082-14.402-56.889-79.932-66.25-105.136-0.72 2.16-1.44 5.041-2.16 7.201 8.641 14.402 53.288 89.294 67.691 104.416-2.16 13.682-5.041 26.644-7.201 39.606-10.802-11.522-55.449-63.37-63.37-99.376l-3.601-4.321v5.761l4.321 19.443s41.046 68.411 61.93 84.253c-2.16 1.44-2.88 2.16 0 2.16l-4.321 25.924c-14.402-10.802-56.169-64.090-56.169-64.090l-1.44 2.88c0 2.16 0.72 4.321 0.72 7.201 10.082 23.044 43.927 51.848 56.169 61.21-0.72 5.761-1.44 10.802-2.88 16.563-8.641-3.601-26.644-18.003-35.286-25.204 9.361 21.603 25.924 29.525 34.565 31.685-1.44 9.361-2.88 18.003-3.601 26.644-7.921-3.601-22.323-11.522-27.364-23.044 0 0 7.201 17.283 20.163 25.204-2.88 0.72-4.321 1.44 6.481 4.321-2.88 23.044-5.041 42.487-5.041 56.889 0 0 4.321-22.323 10.082-56.169h3.601c3.601 0 5.041 0 4.321-0.72 15.122-3.601 27.364-16.563 27.364-16.563z',
          'M2358.368 497.598l-2.16 2.16c3.601-1.44 6.481-2.16 6.481-2.16s19.443-26.644-4.321 0zM2268.354 603.454s-18.003-18.723-34.565-35.286c-1.44-1.44-2.88-2.88-3.601-4.321l-15.842-15.842v-1.44c23.044-6.481 12.962-4.321 0.72-2.88 9.361-31.685 8.641-64.81 7.201-82.813-2.16-4.321-4.321-8.641-7.201-13.682 11.522 41.767-5.041 94.335-5.041 95.775l-3.601-3.601c-2.16-2.16-10.082-10.802-20.883-23.044 1.44-5.041 16.563-51.848 5.041-103.696-3.601-4.321-7.921-9.361-12.242-13.682v0.72s25.924 20.883 1.44 109.457c-8.641-10.082-18.723-21.603-28.805-33.125l2.88 0.72c9.361-66.97-12.242-100.096-18.723-108.737-3.601-0.72-7.201-1.44-12.242-1.44 38.886 41.046 28.084 95.055 25.204 106.577-9.361-10.802-19.443-21.603-28.805-31.685 0-39.606-7.921-65.53-11.522-74.172-1.44 0-2.88 0-4.321 0.72 10.082 30.965 10.802 56.889 10.802 68.411-10.802-11.522-20.883-21.603-29.525-29.525 0-19.443-9.361-33.125-9.361-33.125h-2.88c3.601 5.041 5.041 18.723 5.761 27.364-3.601-3.601-7.201-5.761-10.802-7.921-31.685-18.003-46.087-30.965-60.489-43.927l15.122 20.163 42.487 30.965 39.606 39.606 5.041 5.761c-0.72 0.72-35.286 14.402-80.653-0.72 0 0 11.522 16.563 87.854 9.361v-0.72l20.883 21.603c-8.641 2.16-59.049 13.682-108.017-1.44 0.72 2.16 1.44 4.321 2.16 7.201 13.682 3.601 50.408 9.361 110.897 0.72 0 0 0.72 0 1.44-0.72l30.245 31.685c-7.201 1.44-67.691 12.242-113.058-2.88l-4.321 3.601s31.685 18.003 123.139 5.761l24.484 25.204c-2.16 0.72-39.606 16.563-92.174 4.321l4.321 6.481h0.72c3.601 0 51.848 3.601 90.734-7.201l14.402 15.122c-4.321 2.88-23.044 14.402-48.968 12.242 0 0 0 4.321 5.761 5.761 5.041 0.72 34.565-5.041 46.807-14.402l1.44 1.44s38.166 41.046 47.527 43.927c7.201 2.88-6.481-8.641-6.481-8.641zM2027.837 406.864l-0.72 5.041s40.326 26.644 54.729 7.201c0 0.72-13.682 11.522-54.008-12.242zM2381.412 227.556c-0.72-0.72-2.16-1.44-2.88-2.88-5.041 3.601-11.522 7.921-17.283 11.522 0 0 5.761 6.481 20.163-8.641zM2236.669 659.623c-25.204-20.163-60.489 4.321-37.446-1.44 18.003-4.321 31.685 0 37.446 1.44-5.041 4.321-8.641 7.921-10.802 12.242l-3.601 3.601c-8.641-4.321-30.245-12.962-49.688-5.761 0 0 34.565 5.761 44.647 10.082-3.601 3.601-7.201 7.921-12.242 13.682-11.522-19.443-45.367-9.361-57.609-5.761l-2.16 4.321c18.003-8.641 50.408 0 59.049 2.88-4.321 5.041-9.361 10.082-14.402 15.842-10.082-16.563-43.207-5.041-46.087-3.601-1.44 0.72-5.041 3.601-7.921 5.761 0 0.72 0 1.44-0.72 2.16 18.723-13.682 43.927-6.481 52.568-3.601-7.201 7.921-15.842 16.563-23.764 24.484-15.122-5.761-25.924-2.88-31.685 1.44v6.481c9.361-8.641 24.484-7.921 30.965-7.201-18.003 18.003-36.006 36.006-48.968 46.807 0 0 5.041-5.041 13.682-9.361 8.641-5.761 16.563-11.522 18.003-12.962 2.16-2.16 30.965-31.685 41.767-41.767v0.72c0 31.685-23.764 48.968-24.484 51.848 0 0 0 0.72-0.72 0.72 1.44 0 3.601 0.72 7.201 1.44 24.484-30.245 20.883-52.568 18.723-54.729 1.44-1.44 2.16-2.16 2.88-2.16 2.16-1.44 7.201-6.481 12.242-12.242 0.72 0.72 0.72 1.44 0.72 1.44s17.283 25.204-14.402 67.691c3.601-0.72 7.201-0.72 10.802-2.16l7.921-20.883s3.601-22.323 4.321-27.364c0.72-4.321-2.88-20.163-7.201-22.323 4.321-5.041 8.641-9.361 11.522-12.242 0 0.72 0.72 0.72 0.72 0.72s33.125-0.72 21.603 53.288v5.041c3.601-4.321 7.201-9.361 10.802-15.122v-8.641s-18.723-40.326-27.364-41.046c5.041-5.041 12.962-13.682 21.603-22.323l16.563 48.248 0.72 1.44v-2.16c0.72-29.525-7.921-46.807-10.082-51.848 0 0 0-0.72-0.72-0.72 9.361-8.641 18.003-16.563 22.323-17.283 0.72-1.44-21.603 7.921-36.726 20.883zM2264.754 481.035s2.16 1.44 5.041 3.601c-0.72-0.72-0.72-1.44-1.44-2.88-12.962-31.685-3.601-0.72-3.601-0.72zM2587.364 458.712c-3.601 6.481-6.481 13.682-8.641 21.603l7.201-2.16s0.72-9.361 5.041-18.003c-1.44-0.72-2.16-1.44-3.601-1.44zM2639.932 449.35c-0.72 0-1.44 0.72-2.16 1.44-12.242 7.201-30.245 16.563-51.848 27.364-11.522 5.761-23.764 12.242-36.006 18.723 3.601-8.641 10.082-25.204 25.924-43.207l-6.481-2.16c-8.641 10.802-20.163 29.525-23.764 46.807-9.361 5.041-18.723 9.361-28.805 14.402 1.44-9.361 7.201-42.487 36.006-65.53-2.16 0-4.321-0.72-5.761-1.44-9.361 10.802-29.525 35.286-36.726 69.851l-25.924 12.962c-4.321-2.16-6.481-3.601-1.44 0.72-4.321 2.16-8.641 4.321-12.242 6.481 3.601-12.962 22.323-72.011 56.889-89.294v-2.16h-9.361c-12.962 15.122-46.087 57.609-53.288 94.335l-33.125 16.563c9.361-36.726 50.408-90.734 63.37-107.297-1.44 0.72-2.88 0.72-4.321 1.44-43.927 42.487-63.37 99.376-66.97 110.177l-24.484 12.242c2.88-10.802 13.682-50.408 38.886-74.172l-3.601-3.601s-34.565 39.606-41.046 80.653c-20.883 10.082-34.565 17.283-34.565 17.283l-5.041 2.16c7.921-10.802 22.323-37.446 35.286-51.128l-11.522 0.72s-25.204 28.805-28.084 52.568l-25.204 11.522c9.361 0.72 20.883-2.88 32.405-7.921 10.802 7.201 79.212 10.082 79.212 10.082l-1.44-4.321c-53.288-2.88-65.53-7.201-68.411-9.361 18.003-8.641 34.565-18.723 37.446-19.443 2.16-0.72 3.601-1.44 5.041-2.16l1.44 5.041s56.169 23.764 100.096 17.283c2.16 0 4.321-0.72 6.481-1.44h-2.16c-11.522 0-61.21-2.16-98.655-23.764 5.041-1.44 12.962-6.481 12.962-6.481l13.682-6.481c14.402 7.201 77.052 19.443 103.696 23.764 2.88-1.44 5.041-2.88 7.921-4.321-36.726-3.601-92.895-20.163-102.976-23.764l23.764-10.802 15.842-9.361c15.842 12.242 71.291 15.122 99.376 15.122 1.44-1.44 2.16-2.88 3.601-4.321-38.886 5.041-68.411-3.601-83.533-9.361 1.44 0 5.761-10.802 7.921-17.283l2.16-1.44 14.402-6.481 12.242-7.201c-2.16 13.682 0.72 4.321 2.88-1.44l2.16-1.44c5.761 17.283 38.166 21.603 54.729 22.323 0.72-1.44 1.44-2.88 1.44-4.321-33.125-1.44-49.688-13.682-54.729-18.723l34.565-20.883c0 12.242 12.962 15.842 23.764 16.563v-1.44c-15.842-3.601-15.842-10.082-15.842-10.082l-5.761-5.761 49.688-29.525v0.72zM2507.432 538.644c-7.201-2.88-11.522-5.041-11.522-5.041h-1.44l14.402-8.641c-2.16 8.641-2.16 12.962-1.44 13.682zM2458.464 681.947l5.041-1.44 7.201-2.16c-2.16-2.16-3.601-4.321-5.041-6.481-5.761 1.44-10.802 2.16-14.402 4.321-9.361-2.88-18.723-5.041-18.723-5.041s-6.481-2.16-15.842-5.041c16.563-5.761 30.245-6.481 40.326-6.481-1.44-2.16-3.601-3.601-5.041-5.041-17.283 0.72-30.245 6.481-38.886 10.802-7.201-2.16-16.563-5.041-26.644-8.641 10.082-6.481 30.965-12.242 44.647-15.122-2.16-0.72-5.041-1.44-7.201-2.88-21.603 2.16-33.845 11.522-38.886 17.283-7.921-2.16-15.842-5.041-23.764-7.201 3.601-4.321 13.682-11.522 41.767-11.522 0 0-7.921-3.601-16.563-3.601h-2.16c-8.641 0-18.723 2.88-23.764 14.402-9.361-2.88-18.003-5.761-25.924-7.921 0 0 2.88-2.16 9.361-5.041h-5.761c-1.44 1.44-2.16 2.88-3.601 5.041-5.761-2.16-10.802-3.601-15.122-4.321-5.761-1.44-10.082-2.88-10.802-2.88-2.16 0.72 0.72 2.88 3.601 4.321 2.16 1.44 4.321 2.16 4.321 2.16s7.201 2.88 15.122 6.481c-2.16 23.044 18.003 33.125 18.003 33.125-11.522-17.283-15.842-28.805-17.283-33.125 5.761 2.16 11.522 4.321 16.563 5.041 2.88 0.72 5.761 1.44 9.361 2.16-10.082 33.125 26.644 43.207 26.644 43.207-26.644-23.764-26.644-39.606-26.644-43.207 7.921 2.16 17.283 4.321 23.764 6.481 0 0.72-3.601 28.084 25.204 55.449 2.88 0.72 4.321 1.44 4.321 1.44s0.72 0 1.44 0.72c-10.802-13.682-31.685-43.927-30.965-56.889 0.72 0 0.72 0 1.44 0.72 2.16 0.72 4.321 1.44 5.761 2.16 2.16 0.72 8.641 2.88 16.563 5.041 0 0.72 0.72 1.44 0.72 2.16l-1.44 1.44c0.72 0 1.44-0.72 2.16-0.72 2.88 9.361 10.082 30.245 30.245 48.248l6.481-2.16c-9.361-7.921-23.044-22.323-35.286-46.087 0.72-0.72 2.16-0.72 2.88-1.44 10.802 2.88 23.044 5.761 29.525 7.921 0 0 0 2.16 0.72 5.041-2.16 1.44-2.88 2.16-2.88 2.16l4.321 1.44c2.16 5.761 5.761 13.682 12.962 23.044l3.601-3.601c0.72-0.72 1.44-0.72 2.16-1.44l-12.962-19.443 5.761-1.44c9.361 5.761 18.723 10.082 20.883 10.802 2.16 1.44 18.723 1.44 20.163 1.44 0.72 0 7.921 0.72 7.921 0.72s-18.723-4.321-20.883-5.041c-2.16-0.72-13.682-5.041-24.484-9.361zM2340.366 532.163c-8.641 9.361-25.204 11.522-34.565 12.242 1.44-8.641 2.88-17.283 5.041-26.644 7.921 0.72 27.364 0 45.367-18.003-11.522 3.601-35.286 10.802-43.927 10.802 0.72-5.041 2.16-10.802 2.88-15.842 11.522-3.601 47.527-16.563 69.131-31.685 2.88-5.041 5.041-9.361 7.201-14.402-14.402 8.641-62.65 36.726-74.892 38.886 1.44-7.921 2.88-15.842 4.321-24.484 5.761 2.88 3.601 0 0.72-2.88v-0.72c23.044-4.321 92.895-59.049 92.895-59.049l2.16-3.601 2.16-4.321c1.44-4.321 2.88-8.641 3.601-12.242l-0.72 0.72c-23.044 34.565-92.895 70.571-100.096 74.172 2.16-11.522 4.321-23.764 6.481-35.286 0.72 0 0.72-0.72 0-2.16 0-1.44 0.72-2.16 0.72-3.601 12.962-4.321 73.451-51.848 97.935-71.291v-5.761c-29.525 25.924-96.495 69.851-97.215 70.571 2.16-10.802 3.601-21.603 5.761-32.405 2.88 0.72 2.16-0.72 0.72-2.16 0-0.72 0.72-2.16 0.72-2.88 12.242-1.44 63.37-39.606 87.134-58.329-0.72-2.16-0.72-3.601-1.44-5.761-19.443 20.163-74.172 52.568-84.253 58.329 2.88-15.122 5.041-29.525 7.921-43.927 18.003 2.16 50.408-24.484 68.411-40.326l-4.321-8.641c-28.084 28.805-56.889 45.367-64.090 48.248 2.88-15.122 5.041-29.525 7.201-43.207 0-2.16 0.72-3.601 0.72-5.761 5.761-35.286 10.802-65.53 13.682-84.973 1.44-10.082 2.16-17.283 2.88-20.163 0 0-0.72 5.041-2.88 12.962-2.88 13.682-7.921 36.006-13.682 64.81-7.201-8.641-14.402-19.443-17.283-24.484h-0.72c7.201 24.484 14.402 25.924 17.283 25.204-2.16 9.361-4.321 19.443-6.481 30.245-2.16-2.16-23.764-23.764-28.805-46.087l-6.481 4.321c5.041 12.242 25.204 43.927 33.845 48.968-2.88 12.962-5.041 26.644-7.921 41.046-7.921-9.361-30.245-36.726-43.927-75.612-3.601 2.88-5.761 5.041-7.201 7.201 6.481 14.402 30.965 62.65 51.128 71.291-2.88 12.962-5.041 26.644-7.921 40.326-12.962-15.842-57.609-73.451-57.609-90.014l-5.761 1.44c-0.72 0.72-0.72 1.44-1.44 2.16 6.481 10.802 48.248 79.932 63.37 92.174-2.16 11.522-4.321 23.764-6.481 35.286-10.082-14.402-56.889-79.932-66.97-105.136-0.72 2.16-1.44 5.041-2.16 7.201 8.641 14.402 53.288 88.574 67.691 104.416-2.16 13.682-5.041 26.644-7.201 39.606-10.802-11.522-55.449-63.37-63.37-100.096l-3.601-4.321v5.761l4.321 19.443s41.046 68.411 61.93 84.253c-2.16 1.44-2.88 2.16 0 2.16l-4.321 25.924c-14.402-10.802-56.169-64.090-56.169-64.090l-1.44 2.88c0 2.16 0.72 4.321 0.72 7.201 10.082 23.044 43.927 51.848 55.449 61.93-0.72 5.761-1.44 10.802-2.88 16.563-8.641-3.601-26.644-18.003-35.286-25.204 9.361 21.603 25.924 29.525 34.565 31.685-1.44 9.361-2.88 18.003-3.601 26.644-7.921-3.601-22.323-11.522-27.364-23.044 0 0 7.201 17.283 20.163 25.204-2.88 0.72-4.321 1.44 6.481 4.321-2.88 23.044-4.321 42.487-5.041 56.889 0 0 4.321-22.323 10.082-56.169h3.601c3.601 0 5.041 0 4.321-0.72 15.842-5.041 28.805-18.003 28.805-18.003z',
          'M2356.208 496.878l-2.16 2.16c3.601-1.44 5.761-2.16 5.761-2.16s20.883-26.644-3.601 0zM2266.194 602.734s-18.003-18.723-34.565-36.006l-19.443-19.443v-0.72c23.044-6.481 12.962-5.041 0.72-2.88 9.361-31.685 8.641-64.81 7.201-82.813-2.16-4.321-4.321-8.641-7.201-12.962 11.522 41.767-5.041 94.335-5.041 95.775l-3.601-3.601c-2.16-2.16-10.082-10.802-20.883-23.044 2.16-5.041 16.563-51.848 5.041-103.696-3.601-4.321-7.921-9.361-12.242-13.682v0.72s25.924 20.883 1.44 109.457c-8.641-10.082-18.723-21.603-29.525-33.125l2.88 0.72c9.361-66.97-12.242-100.096-18.723-108.737-3.601-0.72-7.201-1.44-12.242-1.44 38.886 41.046 28.084 95.055 25.204 106.577-9.361-10.802-19.443-21.603-28.805-31.685 0-39.606-7.921-65.53-11.522-74.172-1.44 0-2.88 0-4.321 0.72 10.082 30.965 10.802 56.889 10.802 68.411-10.802-11.522-20.883-21.603-29.525-29.525 0-19.443-9.361-33.125-9.361-33.125h-2.88c4.321 5.041 5.041 18.723 5.761 27.364-3.601-3.601-7.201-5.761-10.802-7.921-31.685-18.003-46.087-30.965-60.489-43.207l15.122 20.163 42.487 30.965 39.606 39.606 5.041 5.761c-0.72 0.72-35.286 14.402-80.653-0.72 0 0 11.522 16.563 87.854 9.361v-0.72l20.883 21.603c-8.641 2.16-59.049 13.682-108.017-1.44 0.72 2.16 1.44 4.321 2.16 7.201 13.682 2.88 50.408 9.361 110.897 0.72 0 0 0.72 0 1.44-0.72l30.245 31.685c-7.201 1.44-67.691 12.242-113.058-2.88l-4.321 3.601s31.685 18.003 123.139 5.761l24.484 25.204c-2.16 0.72-39.606 16.563-92.174 4.321l4.321 5.761h0.72c3.601 0 51.848 3.601 90.734-7.201l14.402 15.122c-4.321 2.88-23.044 14.402-48.968 12.242 0 0 0 4.321 5.761 5.041 5.041 0.72 34.565-5.041 46.807-14.402l1.44 1.44s38.166 41.046 47.527 43.927c7.921 2.16-5.761-9.361-5.761-9.361zM2026.397 406.143l-0.72 5.041s40.326 26.644 54.729 7.201c0 0.72-14.402 10.802-54.008-12.242zM2379.252 226.835c-0.72-0.72-1.44-1.44-2.88-2.16-5.041 3.601-11.522 7.921-17.283 11.522 0-0.72 5.761 5.761 20.163-9.361zM2234.509 658.183c-25.204-20.163-60.489 4.321-37.446-1.44 18.003-3.601 31.685 0 37.446 1.44-5.041 4.321-8.641 7.921-10.802 12.242 0 0-1.44 1.44-2.88 3.601-8.641-4.321-30.245-12.962-49.688-5.041 0 0 34.565 5.761 44.647 10.082-2.88 3.601-7.201 7.921-12.242 13.682-11.522-19.443-45.367-9.361-57.609-5.761l-2.16 4.321c18.003-8.641 50.408 0 59.049 2.88-4.321 5.041-9.361 10.082-14.402 15.842-10.082-16.563-43.207-5.041-46.087-3.601-1.44 0.72-5.041 3.601-7.921 5.761 0 0.72 0 1.44-0.72 2.16 18.723-13.682 43.927-6.481 52.568-2.88-7.201 7.921-15.842 16.563-23.764 24.484-15.122-5.761-25.924-2.88-31.685 1.44v5.761c10.082-8.641 24.484-7.921 30.965-7.201-18.003 18.003-36.006 36.006-48.968 46.807 0 0 5.041-5.041 13.682-9.361 8.641-5.761 16.563-11.522 18.003-12.962 2.16-2.16 30.965-32.405 41.767-41.767v0.72c0 31.685-23.764 48.968-24.484 51.848 0 0 0 0.72-0.72 0.72 1.44 0 3.601 0.72 7.201 1.44 24.484-30.245 20.883-52.568 18.723-54.729 1.44-1.44 2.16-2.16 2.88-2.16 2.16-1.44 7.201-6.481 12.242-12.242 0.72 0.72 0.72 1.44 0.72 1.44s17.283 25.204-14.402 67.691l10.802-2.16 7.921-20.883s3.601-22.323 5.041-27.364c0.72-4.321-2.88-20.163-7.201-22.323 4.321-5.041 8.641-9.361 11.522-12.242 0 0.72 0.72 0.72 0.72 0.72s33.125-0.72 21.603 53.288v5.041c3.601-4.321 7.201-9.361 10.802-15.122v-8.641s-18.723-41.046-27.364-41.046c4.321-5.041 12.962-13.682 21.603-22.323l16.563 48.248 0.72 1.44v-2.16c0-29.525-7.921-46.807-10.082-51.848 0 0 0-0.72-0.72-0.72 9.361-8.641 18.003-16.563 22.323-17.283 0-1.44-22.323 7.921-38.166 20.163zM2262.594 479.595s2.16 1.44 5.041 3.601c-0.72-0.72-0.72-2.16-1.44-2.88-12.242-31.685-3.601-0.72-3.601-0.72zM2585.924 457.271c-2.88 6.481-6.481 13.682-8.641 21.603l7.201-1.44s0.72-9.361 5.041-18.003c-1.44-0.72-2.88-1.44-3.601-2.16zM2638.492 448.63c-0.72 0-1.44 0.72-2.16 1.44-12.242 7.201-30.245 16.563-51.848 27.364-11.522 5.761-23.764 12.242-36.006 18.723 3.601-8.641 10.082-25.204 25.924-43.207l-6.481-2.16c-8.641 10.802-20.163 29.525-23.764 46.807-9.361 5.041-18.723 9.361-28.805 14.402 1.44-9.361 7.201-42.487 36.006-65.53-2.16 0-4.321-0.72-5.761-1.44-9.361 10.802-29.525 35.286-36.726 69.851l-25.924 12.962c-4.321-2.16-7.201-3.601-1.44 0.72l-12.962 6.481c3.601-12.962 22.323-72.011 56.889-89.294v-2.16h-9.361c-12.962 15.122-46.087 57.609-53.288 94.335l-33.125 16.563c9.361-36.726 50.408-90.734 63.37-107.297-1.44 0.72-2.88 0.72-4.321 1.44-43.927 41.767-63.37 99.376-66.97 110.177-9.361 4.321-17.283 8.641-24.484 12.242 2.88-10.802 13.682-50.408 39.606-74.172l-3.601-3.601s-34.565 39.606-41.046 80.653c-20.883 10.082-34.565 17.283-34.565 17.283l-5.041 2.16c7.921-10.802 22.323-37.446 35.286-51.128l-11.522 0.72s-25.204 28.805-28.084 52.568l-25.204 11.522c9.361 0.72 20.883-2.88 32.405-7.921 10.802 7.201 79.212 10.082 79.212 10.082l-1.44-4.321c-53.288-2.88-65.53-7.201-68.411-9.361 18.003-8.641 34.565-18.723 37.446-19.443 2.16-0.72 3.601-1.44 5.041-2.16l1.44 5.041s56.169 23.764 100.096 17.283c2.16-0.72 4.321-0.72 6.481-1.44h-2.16c-11.522 0-61.21-2.16-98.655-23.764 5.041-1.44 12.962-6.481 12.962-6.481l13.682-6.481c14.402 7.201 77.052 19.443 103.696 23.764 2.88-1.44 5.041-2.88 7.921-4.321-36.726-3.601-92.174-20.163-102.976-23.764l23.044-10.802 15.842-9.361c15.842 12.242 71.291 15.122 99.376 15.122 1.44-1.44 2.16-2.88 3.601-4.321-38.886 5.041-68.411-3.601-83.533-9.361 1.44 0 5.761-11.522 7.921-17.283l2.16-1.44 15.122-6.481 12.242-7.201c-2.16 12.962 0.72 4.321 2.88-1.44l2.16-1.44c5.761 18.003 38.166 21.603 54.729 22.323 0.72-1.44 0.72-2.88 1.44-4.321-33.125-1.44-49.688-13.682-54.729-18.723l34.565-20.163c0 11.522 12.242 15.122 23.764 16.563v-2.16c-15.842-2.88-15.842-10.082-15.842-10.082l-5.761-5.761 49.688-29.525v0.72zM2505.271 537.204c-7.201-2.88-11.522-5.041-11.522-5.041h-1.44l14.402-8.641c-1.44 9.361-2.16 12.962-1.44 13.682zM2457.024 681.226l5.041-1.44 7.201-2.16c-2.16-2.16-3.601-4.321-5.041-6.481-5.761 1.44-10.802 2.16-14.402 4.321-9.361-2.88-18.723-5.041-18.723-5.041s-6.481-2.16-15.842-5.041c16.563-5.761 30.245-6.481 40.326-6.481-1.44-2.16-3.601-3.601-5.041-5.041-17.283 0.72-30.245 6.481-38.886 10.802-7.201-2.16-16.563-5.041-26.644-8.641 10.082-6.481 30.965-12.242 44.647-15.122-2.16-0.72-5.041-2.16-7.201-2.88-21.603 2.16-33.845 11.522-38.886 17.283-7.921-2.16-15.842-5.041-23.764-7.201 3.601-4.321 13.682-11.522 41.767-11.522 0 0-7.921-3.601-16.563-3.601h-2.16c-8.641 0-18.723 2.88-23.764 15.122-9.361-2.88-18.003-5.761-25.924-7.921 0 0 2.88-2.16 9.361-5.041h-5.761c-1.44 1.44-2.16 2.88-3.601 5.041-5.761-1.44-10.802-2.88-15.122-4.321-6.481-1.44-10.082-2.88-10.802-2.88-2.16 0.72 0.72 2.88 3.601 4.321 2.16 1.44 4.321 2.16 4.321 2.16s7.201 3.601 15.122 6.481c-2.88 23.044 18.003 33.125 18.003 33.125-12.242-17.283-15.842-28.805-17.283-33.125 5.761 2.16 11.522 4.321 16.563 5.041 2.88 0.72 5.761 0.72 9.361 2.16-10.082 33.125 26.644 43.207 26.644 43.207-26.644-23.764-26.644-39.606-26.644-43.207 7.921 2.16 17.283 4.321 23.764 6.481 0 0.72-3.601 28.084 25.204 55.449 2.88 0.72 4.321 1.44 4.321 1.44h1.44c-10.802-13.682-31.685-43.927-30.965-56.889 0.72 0 0.72 0 1.44 0.72 2.16 0.72 4.321 1.44 5.761 2.16 2.16 0.72 8.641 2.88 16.563 5.041 0 0.72 0.72 1.44 0.72 2.16l-1.44 1.44c0.72 0 1.44-0.72 2.16-0.72 2.88 9.361 10.082 30.245 30.245 48.248l6.481-2.16c-9.361-7.921-23.044-22.323-35.286-46.087 1.44-0.72 2.16-0.72 2.88-1.44 10.802 2.88 22.323 5.761 29.525 7.921 0 0 0 2.16 0.72 5.041-2.16 1.44-2.88 2.88-2.88 2.88l4.321 1.44c2.16 5.761 5.761 13.682 12.962 23.044l3.601-3.601c0.72-0.72 1.44-0.72 2.16-1.44l-12.962-19.443 5.761-1.44c9.361 5.761 18.723 10.082 20.883 10.802 2.16 1.44 19.443 1.44 20.163 1.44s7.921 0.72 7.921 0.72-18.723-4.321-20.883-5.041c-2.16-1.44-14.402-6.481-24.484-10.082zM2338.205 531.443c-8.641 9.361-25.924 11.522-34.565 12.242 1.44-8.641 2.88-17.283 5.041-26.644 7.921 0.72 27.364 0 45.367-18.003-11.522 3.601-35.286 10.802-43.927 11.522 0.72-5.041 2.16-10.802 2.88-15.842 11.522-3.601 47.527-16.563 69.131-31.685 2.88-5.041 5.041-9.361 7.201-14.402-14.402 8.641-62.65 36.726-74.892 38.886 1.44-7.921 2.88-15.842 4.321-24.484 5.761 2.88 3.601 0 0.72-2.88v-0.72c23.044-4.321 92.895-59.769 92.895-59.769l2.16-3.601 2.16-4.321c1.44-4.321 2.88-8.641 3.601-12.242h-0.72c-23.044 34.565-92.895 70.571-100.096 74.172 2.16-11.522 4.321-23.764 6.481-35.286 0.72 0 0.72-0.72 0-2.16 0-1.44 0.72-2.16 0.72-3.601 12.962-4.321 73.451-51.848 97.935-71.291v-5.761c-29.525 25.924-96.495 69.851-97.215 70.571 2.16-10.802 3.601-21.603 5.761-32.405 2.88 0.72 2.16-0.72 0.72-2.16 0-0.72 0-2.16 0.72-2.88 12.242-1.44 63.37-39.606 87.134-58.329-0.72-2.16-0.72-3.601-1.44-5.761-19.443 20.163-74.172 52.568-84.973 58.329 2.88-14.402 5.041-29.525 7.921-43.927 17.283 2.16 50.408-23.764 68.411-40.326l-4.321-8.641c-28.084 28.805-56.889 44.647-64.090 48.248 2.88-15.122 5.041-29.525 7.921-43.207 0.72-2.16 0.72-3.601 0.72-5.761 6.481-35.286 10.802-65.53 13.682-84.973 1.44-10.082 2.16-17.283 2.88-20.163 0 0-0.72 5.041-2.88 12.962-2.88 13.682-7.921 36.006-13.682 64.81-7.201-8.641-14.402-19.443-17.283-24.484h-0.72c7.201 23.764 14.402 25.924 17.283 25.204-2.16 9.361-4.321 19.443-6.481 30.245-2.16-2.16-23.764-24.484-28.805-46.087l-6.481 4.321c5.041 12.242 25.204 43.927 33.845 48.968-2.88 12.962-5.041 26.644-7.921 41.046-7.921-9.361-30.245-36.726-43.927-75.612-3.601 2.88-5.761 5.041-7.201 7.201 6.481 14.402 30.965 62.65 51.128 71.291-2.88 12.962-5.041 26.644-7.921 40.326-12.962-15.842-57.609-73.451-57.609-90.014l-5.761 1.44c-0.72 0.72-0.72 1.44-1.44 2.16 6.481 10.802 48.248 79.932 63.37 92.174-2.16 11.522-4.321 23.764-6.481 35.286-10.082-14.402-56.889-79.932-66.25-105.136-0.72 2.16-1.44 5.041-2.16 7.201 8.641 14.402 53.288 88.574 67.691 104.416-2.16 13.682-5.041 26.644-7.201 39.606-10.802-11.522-55.449-63.37-63.37-100.096l-3.601-4.321v5.761l4.321 19.443s41.046 68.411 61.93 84.253c-2.16 1.44-2.88 2.16 0 2.16l-4.321 25.924c-14.402-10.802-56.889-64.090-56.889-64.090l-1.44 2.88c0 2.16 0.72 4.321 0.72 7.201 10.082 23.044 43.927 51.848 56.169 61.21-0.72 5.761-1.44 10.802-2.88 16.563-8.641-3.601-26.644-18.003-35.286-25.204 10.082 21.603 26.644 29.525 34.565 31.685-1.44 9.361-2.88 18.003-3.601 26.644-7.921-3.601-22.323-11.522-27.364-23.044 0 0 7.201 17.283 20.163 25.204-2.88 0.72-4.321 1.44 6.481 4.321-2.88 23.044-4.321 42.487-5.041 56.889 0 0 4.321-22.323 10.082-56.169h3.601c3.601 0 5.041 0 4.321-0.72 15.842-3.601 28.084-16.563 28.084-16.563z',
          'M179.308 229.716h15.122v108.017h51.848v12.962h-67.691v-120.979zM295.966 352.855c-23.044 0-41.767-17.283-41.767-44.647 0-28.805 19.443-46.087 43.207-46.087 25.204 0 41.767 18.003 41.767 44.647 0 31.685-22.323 46.087-43.207 46.087zM296.686 340.613c15.122 0 26.644-14.402 26.644-33.845 0-14.402-7.201-33.125-25.924-33.125s-26.644 17.283-26.644 33.845c0 18.723 10.802 33.125 25.924 33.125zM359.336 287.325c0-9.361 0-16.563-0.72-23.764h13.682l0.72 14.402h0.72c4.321-7.921 14.402-15.842 28.805-15.842 12.242 0 30.965 7.201 30.965 36.726v51.848h-15.842v-50.408c0-13.682-5.041-25.924-20.163-25.924-10.082 0-18.003 7.201-20.883 15.842-0.72 2.16-0.72 5.041-0.72 7.201v52.568h-15.842v-62.65zM534.323 223.235v105.136c0 7.921 0 16.563 0.72 22.323h-14.402l-0.72-15.122c-5.041 10.082-15.842 17.283-29.525 17.283-20.883 0-37.446-18.003-37.446-43.927 0-28.805 18.003-46.807 38.886-46.807 13.682 0 22.323 6.481 25.924 12.962v-51.848h16.563zM518.481 299.567c0-2.16 0-4.321-0.72-6.481-2.16-10.082-10.802-18.003-23.044-18.003-16.563 0-25.924 14.402-25.924 33.125 0 18.003 8.641 32.405 25.924 32.405 10.802 0 20.163-7.201 23.044-18.723 0.72-2.16 0.72-4.321 0.72-6.481v-15.842zM595.533 352.855c-23.044 0-41.767-17.283-41.767-44.647 0-28.805 19.443-46.087 43.207-46.087 25.204 0 41.767 18.003 41.767 44.647 0 31.685-22.323 46.087-43.207 46.087zM596.253 340.613c15.122 0 26.644-14.402 26.644-33.845 0-14.402-7.201-33.125-25.924-33.125s-26.644 17.283-26.644 33.845c-0.72 18.723 10.082 33.125 25.924 33.125zM658.903 287.325c0-9.361 0-16.563-0.72-23.764h13.682l0.72 14.402c4.321-7.921 14.402-15.842 28.805-15.842 12.242 0 30.965 7.201 30.965 36.726v51.848h-15.842v-50.408c0-13.682-5.041-25.924-20.163-25.924-10.082 0-18.003 7.201-20.883 15.842-0.72 2.16-0.72 5.041-0.72 7.201v52.568h-15.842v-62.65zM797.165 231.876c6.481-1.44 18.003-2.88 28.805-2.88 15.842 0 25.924 2.88 33.125 8.641 6.481 4.321 10.082 11.522 10.082 21.603 0 11.522-7.921 22.323-20.163 26.644v0.72c11.522 2.88 25.204 12.242 25.204 30.245 0 10.082-4.321 18.003-10.082 24.484-7.921 7.921-21.603 11.522-41.767 11.522-10.802 0-18.723-0.72-24.484-1.44v-119.539zM812.287 280.844h14.402c16.563 0 25.924-8.641 25.924-20.163 0-13.682-10.802-19.443-26.644-19.443-7.201 0-11.522 0.72-13.682 1.44v38.166zM812.287 339.173c2.88 0.72 7.201 0.72 12.962 0.72 15.842 0 30.965-5.761 30.965-23.764 0-16.563-14.402-23.044-30.965-23.044h-12.962v46.087zM929.665 352.855c-23.044 0-41.767-17.283-41.767-44.647 0-28.805 19.443-46.087 43.207-46.087 25.204 0 41.767 18.003 41.767 44.647 0.72 31.685-22.323 46.087-43.207 46.087zM930.385 340.613c15.122 0 26.644-14.402 26.644-33.845 0-14.402-7.201-33.125-25.924-33.125s-26.644 17.283-26.644 33.845c0 18.723 10.802 33.125 25.924 33.125zM993.035 290.925c0-10.082 0-18.723-0.72-27.364h13.682l0.72 17.283h0.72c3.601-11.522 13.682-18.723 24.484-18.723 1.44 0 2.88 0 4.321 0.72v14.402c-1.44 0-3.601-0.72-5.761-0.72-10.802 0-18.723 8.641-20.883 20.163 0 2.16-0.72 5.041-0.72 7.201v46.087h-15.842v-59.049zM1085.93 352.855c-23.044 0-41.767-17.283-41.767-44.647 0-28.805 19.443-46.087 43.207-46.087 25.204 0 41.767 18.003 41.767 44.647 0 31.685-22.323 46.087-43.207 46.087zM1086.65 340.613c15.122 0 26.644-14.402 26.644-33.845 0-14.402-7.201-33.125-25.924-33.125s-26.644 17.283-26.644 33.845c0 18.723 10.802 33.125 25.924 33.125zM1222.031 326.931c0 8.641 0 16.563 0.72 23.764h-13.682l-0.72-14.402c-3.601 7.201-12.962 15.842-28.805 15.842-13.682 0-30.245-7.921-30.245-38.166v-51.128h15.842v48.248c0 16.563 5.041 28.084 19.443 28.084 10.802 0 18.003-7.201 20.883-14.402 0.72-2.16 1.44-5.041 1.44-7.921v-53.288h15.842v63.37zM1322.847 337.733c0 20.163-4.321 32.405-12.242 39.606-8.641 7.921-20.883 10.082-31.685 10.082-10.082 0-21.603-2.16-28.805-7.201l3.601-12.242c5.761 3.601 14.402 7.201 25.204 7.201 15.842 0 28.084-8.641 28.084-30.245v-9.361c-4.321 7.921-14.402 14.402-27.364 14.402-21.603 0-36.726-18.003-36.726-42.487 0-29.525 19.443-46.087 39.606-46.087 15.122 0 23.044 7.921 27.364 15.122l0.72-12.962h13.682c-0.72 6.481-0.72 12.962-0.72 23.764v50.408zM1307.004 298.127c0-2.88 0-5.041-0.72-7.201-2.88-9.361-10.082-16.563-22.323-16.563-15.122 0-25.924 12.962-25.924 33.125 0 16.563 8.641 30.965 25.924 30.965 10.082 0 18.723-5.761 21.603-16.563 0.72-2.16 1.44-5.761 1.44-8.641v-15.122zM1348.771 223.235h15.842v54.008c2.88-4.321 6.481-8.641 11.522-10.802 4.321-2.88 10.082-4.321 15.842-4.321 11.522 0 30.245 7.201 30.245 37.446v51.848h-15.842v-49.688c0-14.402-5.041-25.924-20.163-25.924-10.082 0-18.003 7.201-20.883 15.842-0.72 2.16-1.44 4.321-1.44 7.201v52.568h-15.842v-128.18zM1521.598 352.855c-23.044 0-41.767-17.283-41.767-44.647 0-28.805 19.443-46.087 43.207-46.087 25.204 0 41.767 18.003 41.767 44.647 0 31.685-22.323 46.087-43.207 46.087zM1522.318 340.613c15.122 0 26.644-14.402 26.644-33.845 0-14.402-7.201-33.125-25.924-33.125s-26.644 17.283-26.644 33.845c-0.72 18.723 10.082 33.125 25.924 33.125zM1586.408 350.695v-74.892h-12.242v-12.242h12.242v-4.321c0-12.242 2.88-23.044 10.082-30.245 5.761-5.761 13.682-7.921 20.883-7.921 5.761 0 10.082 1.44 13.682 2.16l-2.16 12.242c-2.88-1.44-5.761-2.16-10.082-2.16-12.962 0-16.563 11.522-16.563 25.204v4.321h20.883v12.242h-20.883v74.892h-15.842z',
        ],
        attrs: [
          {
            fill: 'rgb(184, 12, 116)',
          },
          {
            fill: 'rgb(155, 165, 31)',
          },
          {
            fill: 'rgb(106, 137, 38)',
          },
          {
            fill: 'rgb(133, 149, 33)',
          },
          {
            fill: 'rgb(0, 0, 0)',
          },
          {
            fill: 'rgb(0, 0, 0)',
          },
          {
            fill: 'rgb(0, 0, 0)',
          },
          {
            fill: 'rgb(0, 0, 0)',
          },
          {
            fill: 'rgb(0, 0, 0)',
          },
          {
            fill: 'rgb(117, 131, 29)',
          },
          {
            fill: 'rgb(218, 207, 75)',
          },
          {
            fill: 'rgb(106, 137, 38)',
          },
          {
            fill: 'rgb(114, 119, 122)',
          },
        ],
        width: 2885,
        isMulticolor: true,
        isMulticolor2: false,
        grid: 0,
        tags: ['Redbridge Council Logo-Main'],
      },
      attrs: [
        {
          fill: 'rgb(184, 12, 116)',
        },
        {
          fill: 'rgb(155, 165, 31)',
        },
        {
          fill: 'rgb(106, 137, 38)',
        },
        {
          fill: 'rgb(133, 149, 33)',
        },
        {
          fill: 'rgb(0, 0, 0)',
        },
        {
          fill: 'rgb(0, 0, 0)',
        },
        {
          fill: 'rgb(0, 0, 0)',
        },
        {
          fill: 'rgb(0, 0, 0)',
        },
        {
          fill: 'rgb(0, 0, 0)',
        },
        {
          fill: 'rgb(117, 131, 29)',
        },
        {
          fill: 'rgb(218, 207, 75)',
        },
        {
          fill: 'rgb(106, 137, 38)',
        },
        {
          fill: 'rgb(114, 119, 122)',
        },
      ],
      properties: {
        order: 23,
        id: 16,
        name: 'Redbridge-Council-Logo-Main',
        prevSize: 32,
      },
      setIdx: 0,
      setId: 2,
      iconIdx: 2,
    },
    {
      icon: {
        paths: [
          'M650.175 57.449l-559.646 120.245 165.913 774.264 559.646-120.24-165.913-774.264z',
          'M643.534 72.594l-540.737 116.154 160.336 748.087 540.732-116.154-160.331-748.087z',
          'M637.816 79.561l-526.963 113.212 156.762 731.568 526.963-113.217-156.762-731.563z',
          'M498.939 76.223l-261.421 56.164 13.588 63.408 261.421-56.164-13.588-63.408z',
          'M354.952 42.371c-20.179 4.342-32.949 24.631-28.511 45.312 4.442 20.681 24.385 33.958 44.529 29.616 20.149-4.342 32.954-24.631 28.511-45.312-4.437-20.681-24.345-33.953-44.524-29.616zM367.621 101.522c-1.54 0.384-3.308 0.604-5.128 0.604-7.368 0-13.892-3.613-17.897-9.163l-0.045-0.065c-2.585-3.575-4.135-8.048-4.135-12.882 0-8.954 5.318-16.666 12.967-20.151l0.139-0.057c2.639-1.206 5.725-1.909 8.975-1.909 5.935 0 11.322 2.344 15.287 6.157l-0.007-0.007c3.080 2.959 5.301 6.79 6.267 11.096l0.028 0.148c0.354 1.474 0.557 3.167 0.557 4.907 0 7.333-3.608 13.823-9.145 17.792l-0.066 0.045c-2.216 1.59-4.827 2.796-7.648 3.455l-0.147 0.029z',
          'M495.606 74.089l-255.92 54.99 12.991 60.617 255.91-54.985-12.986-60.612z',
          'M354.952 42.376c-16.641 3.69-28.901 18.321-28.901 35.816 0 5.249 1.104 10.241 3.092 14.756l-0.092-0.235c5.766 13.114 18.642 22.105 33.619 22.105 0.179 0 0.358-0.001 0.536-0.004l-0.027 0c15.137-0.228 28.023-9.626 33.368-22.875l0.087-0.245c1.628-3.997 2.572-8.635 2.572-13.493 0-12.833-6.591-24.126-16.574-30.68l-0.139-0.086c-5.609-3.68-12.482-5.87-19.866-5.87-2.719 0-5.369 0.297-7.919 0.86l0.243-0.045zM367.054 98.896c-1.332 0.299-2.861 0.47-4.43 0.47-7.179 0-13.52-3.586-17.33-9.065l-0.046-0.069c-2.335-3.354-3.73-7.513-3.73-11.998 0-8.642 5.18-16.074 12.605-19.361l0.135-0.053c2.467-1.096 5.346-1.734 8.373-1.734 5.72 0 10.908 2.277 14.707 5.975l-0.005-0.005c3.956 3.847 6.411 9.221 6.411 15.167 0 10.101-7.081 18.548-16.55 20.647l-0.141 0.026z',
          'M910.15 153.324h-572.381v791.883h572.381v-791.883z',
          'M900.483 166.711h-553.035v765.119h553.035v-765.119z',
          'M893.44 172.353h-538.955v748.213h538.955v-748.213z',
          'M758.352 139.907h-267.374v64.853h267.374v-64.853z',
          'M624.67 76.599c-20.641 0-37.381 17.157-37.381 38.325s16.74 38.32 37.381 38.32 37.381-17.152 37.381-38.32c0-21.168-16.74-38.32-37.381-38.32zM624.67 137.035c-0.157 0.004-0.341 0.006-0.526 0.006-9.013 0-16.763-5.403-20.189-13.147l-0.056-0.141c-1.157-2.596-1.83-5.626-1.83-8.812 0-10.608 7.463-19.473 17.426-21.63l0.146-0.026c1.355-0.296 2.911-0.465 4.506-0.465 7.599 0 14.3 3.842 18.268 9.689l0.049 0.077c2.356 3.463 3.762 7.736 3.765 12.338l0 0.001c0 0.047 0.001 0.102 0.001 0.158 0 5.959-2.383 11.361-6.249 15.306l0.004-0.004c-3.902 3.98-9.31 6.47-15.301 6.545l-0.014 0v0.1z',
          'M755.536 137.126h-261.737v61.992h261.737v-61.992z',
          'M624.67 76.599c-7.578 0-14.617 2.307-20.453 6.256l0.129-0.082c-9.865 6.669-16.265 17.814-16.265 30.454 0 17.692 12.539 32.456 29.214 35.89l0.237 0.041c2.147 0.448 4.614 0.705 7.141 0.705 12.631 0 23.764-6.408 30.328-16.15l0.083-0.13c3.865-5.718 6.169-12.765 6.169-20.351 0-10.112-4.095-19.268-10.717-25.9l0 0c-6.617-6.626-15.763-10.726-25.866-10.727l-0-0zM624.67 134.375c-8.744-0.007-16.242-5.336-19.429-12.922l-0.052-0.139c-1.011-2.385-1.599-5.159-1.599-8.071 0-10.202 7.219-18.718 16.827-20.718l0.137-0.024c1.246-0.262 2.678-0.411 4.146-0.411 7.275 0 13.69 3.683 17.482 9.287l0.047 0.074c2.324 3.464 3.569 7.549 3.579 11.726 0 0.003 0 0.007 0 0.010 0 11.666-9.457 21.123-21.123 21.123-0.005 0-0.011-0-0.016-0l0.001 0v0.060z',
          'M24.927 966.611h-4.929v27.974h4.929v-27.974z',
          'M36.437 983.065v-4.929h-27.939v4.929h27.944z',
          'M596.259 0h-4.924v27.974h4.924v-27.974z',
          'M607.769 16.444v-4.929h-27.934v4.929h27.934z',
          'M1009.91 1013.183c-2.151-0.965-3.622-3.087-3.622-5.554 0-0.626 0.095-1.23 0.271-1.798l-0.011 0.043c0.081-0.26 0.128-0.559 0.128-0.869 0-1.289-0.81-2.39-1.949-2.819l-0.021-0.007c-0.309-0.116-0.666-0.183-1.039-0.183-0.986 0-1.862 0.468-2.419 1.194l-0.005 0.007c-0.128 0.171-0.242 0.366-0.334 0.573l-0.008 0.019c-0.958 2.153-3.078 3.627-5.543 3.627-0.624 0-1.227-0.095-1.794-0.27l0.043 0.011c-0.258-0.080-0.555-0.126-0.862-0.126-1.291 0-2.392 0.812-2.82 1.953l-0.007 0.021c-0.116 0.31-0.184 0.667-0.184 1.041 0 0.985 0.469 1.862 1.195 2.417l0.007 0.005c0.181 0.141 0.376 0.251 0.587 0.341 2.155 0.957 3.631 3.078 3.631 5.545 0 0.629-0.096 1.236-0.274 1.807l0.012-0.043c-0.080 0.259-0.127 0.556-0.127 0.864 0 1.289 0.81 2.389 1.948 2.819l0.021 0.007c0.313 0.121 0.675 0.191 1.054 0.191 1.221 0 2.272-0.731 2.739-1.779l0.008-0.019c0.958-2.154 3.078-3.628 5.543-3.628 0.626 0 1.23 0.095 1.798 0.272l-0.043-0.011c0.195 0.065 0.422 0.111 0.657 0.13l0.011 0.001c0.056 0.004 0.121 0.006 0.186 0.006 1.294 0 2.398-0.817 2.824-1.963l0.007-0.021c0.12-0.312 0.189-0.673 0.189-1.050 0-1.223-0.729-2.276-1.776-2.747l-0.019-0.008z',
          'M178.999 744.252c-2.153-0.953-3.629-3.071-3.629-5.534 0-0.632 0.097-1.241 0.277-1.813l-0.012 0.043c0.089-0.266 0.141-0.572 0.141-0.89 0-0.605-0.186-1.166-0.504-1.629l0.006 0.010c-0.553-0.83-1.485-1.369-2.543-1.369-0.301 0-0.592 0.044-0.866 0.125l0.022-0.005c-0.857 0.261-1.539 0.867-1.895 1.653l-0.008 0.019c-0.948 2.158-3.067 3.637-5.531 3.637-0.629 0-1.236-0.096-1.806-0.275l0.043 0.012c-0.259-0.080-0.556-0.127-0.864-0.127-1.289 0-2.389 0.81-2.819 1.948l-0.007 0.021c-0.116 0.31-0.184 0.667-0.184 1.041 0 1.226 0.726 2.282 1.771 2.761l0.019 0.008c2.153 0.953 3.629 3.071 3.629 5.534 0 0.632-0.097 1.241-0.277 1.813l0.012-0.043c-0.088 0.265-0.138 0.57-0.138 0.886 0 0.605 0.185 1.168 0.501 1.634l-0.007-0.010c0.552 0.83 1.484 1.37 2.541 1.37 0.302 0 0.593-0.044 0.868-0.126l-0.022 0.005c0.856-0.261 1.538-0.867 1.895-1.653l0.008-0.019c0.957-2.155 3.078-3.632 5.545-3.632 0.624 0 1.226 0.094 1.792 0.27l-0.043-0.011c0.259 0.080 0.556 0.127 0.864 0.127 1.289 0 2.389-0.81 2.819-1.948l0.007-0.021c0.116-0.31 0.184-0.667 0.184-1.041 0-1.226-0.726-2.282-1.771-2.761l-0.019-0.008zM871.083 89.414c-2.151-0.962-3.623-3.083-3.623-5.548 0-0.626 0.095-1.231 0.272-1.799l-0.011 0.043c0.061-0.194 0.107-0.42 0.129-0.654l0.001-0.013c0.003-0.049 0.004-0.106 0.004-0.163 0-1.68-1.362-3.042-3.042-3.042-0.298 0-0.587 0.043-0.859 0.123l0.022-0.005c-0.857 0.261-1.539 0.867-1.895 1.653l-0.008 0.019c-0.956 2.153-3.076 3.628-5.54 3.628-0.626 0-1.229-0.095-1.796-0.271l0.043 0.011c-0.195-0.065-0.422-0.111-0.657-0.13l-0.011-0.001c-0.057-0.004-0.124-0.006-0.191-0.006-1.295 0-2.398 0.817-2.824 1.963l-0.007 0.021c-0.117 0.31-0.185 0.669-0.185 1.044 0 0.984 0.467 1.858 1.191 2.414l0.007 0.005c0.186 0.136 0.381 0.251 0.592 0.341 2.151 0.962 3.623 3.083 3.623 5.548 0 0.626-0.095 1.231-0.272 1.799l0.011-0.043c-0.062 0.195-0.108 0.424-0.13 0.659l-0.001 0.013c-0.003 0.049-0.004 0.106-0.004 0.163 0 1.68 1.362 3.042 3.042 3.042 0.298 0 0.587-0.043 0.859-0.123l-0.022 0.005c0.857-0.261 1.539-0.867 1.895-1.653l0.008-0.019c0.955-2.156 3.076-3.633 5.542-3.633 0.625 0 1.228 0.095 1.794 0.271l-0.043-0.011c0.265 0.088 0.571 0.139 0.888 0.139 0.603 0 1.163-0.183 1.627-0.497l-0.010 0.007c0.833-0.547 1.375-1.477 1.375-2.533 0-0.307-0.046-0.602-0.13-0.881l0.006 0.021c-0.262-0.857-0.868-1.54-1.653-1.9l-0.019-0.008z',
          'M1064.348 422.29c5.454 0 9.876-4.422 9.876-9.876s-4.422-9.876-9.876-9.876v0c-5.446 0-9.864 4.422-9.864 9.879 0 5.451 4.417 9.874 9.864 9.874zM302.195 989.079c5.448-0.003 9.864-4.42 9.864-9.869 0-0.004-0-0.007-0-0.011l0 0.001c0.003-0.094 0.005-0.204 0.005-0.315 0-5.45-4.418-9.869-9.869-9.869s-9.869 4.418-9.869 9.869c0 0.111 0.002 0.221 0.005 0.331l-0-0.016c0 5.456 4.417 9.879 9.864 9.879zM963.062 635.743c5.454 0 9.876-4.422 9.876-9.876s-4.422-9.876-9.876-9.876h0c-5.446 0.006-9.859 4.422-9.859 9.869 0 0.002 0 0.004 0 0.005l-0-0c0 5.456 4.412 9.879 9.859 9.879z',
          'M114.131 136.232c5.446 0 9.864-4.417 9.864-9.874 0.003-0.094 0.005-0.204 0.005-0.315 0-5.45-4.418-9.869-9.869-9.869s-9.869 4.418-9.869 9.869c0 0.111 0.002 0.221 0.005 0.331l-0-0.016c0 5.456 4.417 9.879 9.864 9.879z',
          'M9.864 405.619c5.446 0 9.864-4.417 9.864-9.874 0.003-0.094 0.005-0.204 0.005-0.315 0-5.45-4.418-9.869-9.869-9.869s-9.869 4.418-9.869 9.869c0 0.111 0.002 0.221 0.005 0.331l-0-0.016c0 5.451 4.417 9.874 9.864 9.874z',
        ],
        attrs: [
          {
            fill: 'rgb(224, 224, 224)',
          },
          {
            fill: 'rgb(0, 0, 0)',
            opacity: 0.5,
          },
          {
            fill: 'rgb(250, 250, 250)',
          },
          {
            fill: 'rgb(0, 0, 0)',
          },
          {
            fill: 'rgb(0, 0, 0)',
          },
          {
            fill: 'rgb(108, 99, 255)',
          },
          {
            fill: 'rgb(108, 99, 255)',
          },
          {
            fill: 'rgb(224, 224, 224)',
          },
          {
            fill: 'rgb(0, 0, 0)',
            opacity: 0.5,
          },
          {
            fill: 'rgb(255, 255, 255)',
          },
          {
            fill: 'rgb(0, 0, 0)',
          },
          {
            fill: 'rgb(0, 0, 0)',
          },
          {
            fill: 'rgb(108, 99, 255)',
          },
          {
            fill: 'rgb(108, 99, 255)',
          },
          {
            fill: 'rgb(71, 230, 177)',
            opacity: 0.25,
          },
          {
            fill: 'rgb(71, 230, 177)',
            opacity: 0.25,
          },
          {
            fill: 'rgb(71, 230, 177)',
            opacity: 0.25,
          },
          {
            fill: 'rgb(71, 230, 177)',
            opacity: 0.25,
          },
          {
            fill: 'rgb(77, 138, 240)',
            opacity: 0.5,
          },
          {
            fill: 'rgb(253, 216, 53)',
            opacity: 0.5,
          },
          {
            fill: 'rgb(245, 95, 68)',
            opacity: 0.5,
          },
          {
            fill: 'rgb(77, 138, 240)',
            opacity: 0.5,
          },
          {
            fill: 'rgb(71, 230, 177)',
            opacity: 0.5,
          },
        ],
        width: 1074,
        isMulticolor: true,
        isMulticolor2: true,
        grid: 0,
        tags: ['no-data'],
      },
      attrs: [
        {
          fill: 'rgb(224, 224, 224)',
        },
        {
          fill: 'rgb(0, 0, 0)',
          opacity: 0.5,
        },
        {
          fill: 'rgb(250, 250, 250)',
        },
        {
          fill: 'rgb(0, 0, 0)',
        },
        {
          fill: 'rgb(0, 0, 0)',
        },
        {
          fill: 'rgb(108, 99, 255)',
        },
        {
          fill: 'rgb(108, 99, 255)',
        },
        {
          fill: 'rgb(224, 224, 224)',
        },
        {
          fill: 'rgb(0, 0, 0)',
          opacity: 0.5,
        },
        {
          fill: 'rgb(255, 255, 255)',
        },
        {
          fill: 'rgb(0, 0, 0)',
        },
        {
          fill: 'rgb(0, 0, 0)',
        },
        {
          fill: 'rgb(108, 99, 255)',
        },
        {
          fill: 'rgb(108, 99, 255)',
        },
        {
          fill: 'rgb(71, 230, 177)',
          opacity: 0.25,
        },
        {
          fill: 'rgb(71, 230, 177)',
          opacity: 0.25,
        },
        {
          fill: 'rgb(71, 230, 177)',
          opacity: 0.25,
        },
        {
          fill: 'rgb(71, 230, 177)',
          opacity: 0.25,
        },
        {
          fill: 'rgb(77, 138, 240)',
          opacity: 0.5,
        },
        {
          fill: 'rgb(253, 216, 53)',
          opacity: 0.5,
        },
        {
          fill: 'rgb(245, 95, 68)',
          opacity: 0.5,
        },
        {
          fill: 'rgb(77, 138, 240)',
          opacity: 0.5,
        },
        {
          fill: 'rgb(71, 230, 177)',
          opacity: 0.5,
        },
      ],
      properties: {
        order: 22,
        id: 15,
        name: 'no-data',
        prevSize: 32,
      },
      setIdx: 0,
      setId: 2,
      iconIdx: 0,
    },
    {
      icon: {
        paths: [
          'M1183.706 457.485h-560.985v566.515h560.985v-566.515z',
          'M1176.083 547.131h-545.724v461.6h545.724v-461.6z',
          'M1176.083 463.212h-545.724v83.93h545.724v-83.93z',
          'M672.336 526.146c11.591 0 20.988-9.397 20.988-20.988s-9.397-20.988-20.988-20.988c-11.591 0-20.988 9.397-20.988 20.988 0 0.003 0 0.005 0 0.008l-0-0c0.002 11.588 9.396 20.981 20.984 20.981 0.001 0 0.003-0 0.004-0l-0 0z',
          'M725.766 526.146c0.084 0.001 0.183 0.002 0.282 0.002 11.589 0 20.984-9.395 20.984-20.984s-9.395-20.984-20.984-20.984c-0.099 0-0.198 0.001-0.297 0.002l0.015-0c-0.145-0.004-0.317-0.006-0.489-0.006-11.591 0-20.988 9.397-20.988 20.988s9.397 20.988 20.988 20.988c0.172 0 0.343-0.002 0.514-0.006l-0.025 0z',
          'M779.192 526.146c11.591 0 20.988-9.397 20.988-20.988s-9.397-20.988-20.988-20.988c-11.591 0-20.988 9.397-20.988 20.988 0 0.003 0 0.005 0 0.008l-0-0c0.002 11.588 9.396 20.981 20.984 20.981 0.001 0 0.003-0 0.004-0l-0 0z',
          'M1128.012 655.182h-449.597v28.171h449.597v-28.171zM1128.012 727.628h-449.597v28.175h449.597v-28.175zM1128.012 800.074h-449.597v28.175h449.597v-28.175zM1128.012 872.52h-449.597v28.175h449.597v-28.175z',
          'M858.924 721.215c28.907 0 52.342-23.427 52.342-52.323s-23.434-52.323-52.342-52.323-52.338 23.427-52.338 52.323 23.431 52.323 52.338 52.323z',
          'M987.766 793.661c28.907 0 52.338-23.423 52.338-52.323 0-28.896-23.431-52.323-52.338-52.323s-52.342 23.427-52.342 52.323c0 28.9 23.434 52.323 52.342 52.323z',
          'M923.345 866.107c28.907 0 52.342-23.423 52.342-52.323 0-28.896-23.434-52.323-52.342-52.323s-52.342 23.427-52.342 52.323c0 28.9 23.434 52.323 52.342 52.323z',
          'M1103.182 938.553c28.907 0 52.342-23.423 52.342-52.323 0-28.896-23.434-52.323-52.342-52.323s-52.342 23.427-52.342 52.323c0 28.9 23.434 52.323 52.342 52.323z',
          'M858.924 713.167c24.462 0 44.29-19.824 44.29-44.275s-19.828-44.271-44.29-44.271c-24.458 0-44.286 19.82-44.286 44.271s19.828 44.275 44.286 44.275zM987.766 785.613c24.458 0 44.286-19.824 44.286-44.275s-19.828-44.271-44.286-44.271c-24.462 0-44.29 19.82-44.29 44.271s19.828 44.275 44.29 44.275zM923.345 858.059c24.458 0 44.29-19.824 44.29-44.275s-19.831-44.271-44.29-44.271c-24.458 0-44.29 19.82-44.29 44.271s19.831 44.275 44.29 44.275z',
          'M1103.182 930.505c24.458 0 44.29-19.82 44.29-44.275 0-24.451-19.831-44.271-44.29-44.271s-44.29 19.82-44.29 44.271c0 24.455 19.831 44.275 44.29 44.275z',
          'M560.985 0h-560.985v566.515h560.985v-566.515z',
          'M553.362 89.646h-545.724v461.604h545.724v-461.604z',
          'M553.362 5.727h-545.724v83.93h545.724v-83.93z',
          'M49.615 68.665c0.145 0.004 0.317 0.006 0.489 0.006 11.591 0 20.988-9.397 20.988-20.988s-9.397-20.988-20.988-20.988c-0.172 0-0.343 0.002-0.514 0.006l0.025-0c-0.084-0.001-0.183-0.002-0.282-0.002-11.589 0-20.984 9.395-20.984 20.984s9.395 20.984 20.984 20.984c0.099 0 0.198-0.001 0.297-0.002l-0.015 0z',
          'M103.045 68.665c0.145 0.004 0.317 0.006 0.489 0.006 11.591 0 20.988-9.397 20.988-20.988s-9.397-20.988-20.988-20.988c-0.172 0-0.343 0.002-0.514 0.006l0.025-0c-0.084-0.001-0.183-0.002-0.282-0.002-11.589 0-20.984 9.395-20.984 20.984s9.395 20.984 20.984 20.984c0.099 0 0.198-0.001 0.297-0.002l-0.015 0z',
          'M156.471 68.665c0.084 0.001 0.183 0.002 0.282 0.002 11.589 0 20.984-9.395 20.984-20.984s-9.395-20.984-20.984-20.984c-0.099 0-0.198 0.001-0.297 0.002l0.015-0c-0.084-0.001-0.183-0.002-0.282-0.002-11.589 0-20.984 9.395-20.984 20.984s9.395 20.984 20.984 20.984c0.099 0 0.198-0.001 0.297-0.002l-0.015 0z',
          'M178.347 200.287h-51.348v240.333h51.352v-240.333zM263.555 200.287h-51.348v240.333h51.352v-240.333zM348.752 200.287h-51.352v240.333h51.352v-240.333zM433.945 200.287h-51.348v240.333h51.348v-240.333z',
          'M178.347 320.455h-51.348v120.165h51.352v-120.165z',
          'M178.347 270.279h-51.348v52.493h51.352v-52.489z',
          'M264.025 295.151h-51.348v52.497h51.352v-52.497z',
          'M433.971 297.901h-51.348v52.497h51.348v-52.497z',
          'M263.555 346.533h-51.348v94.075h51.352v-94.075z',
          'M348.752 302.945h-51.352v137.675h51.352v-137.671z',
          'M348.752 255.116h-51.352v47.828h51.352v-47.825z',
          'M433.945 350.788h-51.348v89.831h51.348v-89.831z',
          'M824.032 215.26h-560.985v566.515h560.985v-566.515z',
          'M816.409 304.905h-545.728v461.6h545.728v-461.6z',
          'M816.409 220.975h-545.728v83.93h545.728v-83.93z',
          'M312.661 283.921c0.145 0.004 0.317 0.006 0.489 0.006 11.591 0 20.988-9.397 20.988-20.988s-9.397-20.988-20.988-20.988c-0.172 0-0.343 0.002-0.514 0.006l0.025-0c-0.084-0.001-0.183-0.002-0.282-0.002-11.589 0-20.984 9.395-20.984 20.984s9.395 20.984 20.984 20.984c0.099 0 0.198-0.001 0.297-0.002l-0.015 0z',
          'M366.091 283.921c0.084 0.001 0.183 0.002 0.282 0.002 11.589 0 20.984-9.395 20.984-20.984s-9.395-20.984-20.984-20.984c-0.099 0-0.198 0.001-0.297 0.002l0.015-0c-0.084-0.001-0.183-0.002-0.282-0.002-11.589 0-20.984 9.395-20.984 20.984s9.395 20.984 20.984 20.984c0.099 0 0.198-0.001 0.297-0.002l-0.015 0z',
          'M419.518 283.921c11.591 0 20.988-9.397 20.988-20.988s-9.397-20.988-20.988-20.988c-11.591 0-20.988 9.397-20.988 20.988 0 0.003 0 0.005 0 0.008l-0-0c0.002 11.588 9.396 20.981 20.984 20.981 0.001 0 0.003-0 0.004-0l-0 0z',
          'M543.539 377.378h-0.952v316.617h0.952c0 0 0.001 0 0.001 0 43.728 0 83.317-17.719 111.979-46.369l-0.001 0.001c28.656-28.645 46.38-68.223 46.38-111.94s-17.725-83.296-46.38-111.94l-0-0c-28.662-28.649-68.251-46.368-111.979-46.368-0 0-0.001 0-0.001 0l0-0z',
          'M542.587 377.405c-43.39 0.267-82.602 17.939-111.047 46.38l0-0c-28.439 28.433-46.108 67.637-46.364 110.968l-0 0.049h157.412v-157.396z',
          'M376.597 536.436v0.994c0.006 45.444 18.361 86.6 48.060 116.463l-0.008-0.008c29.715 29.874 70.764 48.45 116.151 48.735l0.054 0v-166.184h-164.257z',
          'M381.376 538.556v0.956c0.001 43.554 17.594 82.998 46.060 111.615l-0.007-0.007c28.478 28.633 67.821 46.434 111.323 46.698l0.050 0v-159.262h-157.427z',
        ],
        attrs: [
          {
            fill: 'rgb(0, 0, 0)',
          },
          {
            fill: 'rgb(255, 255, 255)',
          },
          {
            fill: 'rgb(189, 189, 189)',
          },
          {
            fill: 'rgb(255, 82, 82)',
          },
          {
            fill: 'rgb(255, 255, 0)',
          },
          {
            fill: 'rgb(105, 240, 174)',
          },
          {
            fill: 'rgb(224, 224, 224)',
          },
          {
            fill: 'rgb(0, 0, 0)',
          },
          {
            fill: 'rgb(0, 0, 0)',
          },
          {
            fill: 'rgb(0, 0, 0)',
          },
          {
            fill: 'rgb(0, 0, 0)',
          },
          {
            fill: 'rgb(108, 99, 255)',
          },
          {
            fill: 'rgb(105, 240, 174)',
          },
          {
            fill: 'rgb(0, 0, 0)',
          },
          {
            fill: 'rgb(255, 255, 255)',
          },
          {
            fill: 'rgb(189, 189, 189)',
          },
          {
            fill: 'rgb(255, 82, 82)',
          },
          {
            fill: 'rgb(255, 255, 0)',
          },
          {
            fill: 'rgb(105, 240, 174)',
          },
          {
            fill: 'rgb(224, 224, 224)',
          },
          {
            fill: 'rgb(33, 150, 243)',
          },
          {
            fill: 'rgb(33, 150, 243)',
            opacity: 0.4,
          },
          {
            fill: 'rgb(105, 240, 174)',
            opacity: 0.4,
          },
          {
            fill: 'rgb(255, 255, 0)',
            opacity: 0.4,
          },
          {
            fill: 'rgb(105, 240, 174)',
          },
          {
            fill: 'rgb(108, 99, 255)',
          },
          {
            fill: 'rgb(108, 99, 255)',
            opacity: 0.4,
          },
          {
            fill: 'rgb(255, 255, 0)',
          },
          {
            fill: 'rgb(0, 0, 0)',
          },
          {
            fill: 'rgb(255, 255, 255)',
          },
          {
            fill: 'rgb(189, 189, 189)',
          },
          {
            fill: 'rgb(255, 82, 82)',
          },
          {
            fill: 'rgb(255, 255, 0)',
          },
          {
            fill: 'rgb(105, 240, 174)',
          },
          {
            fill: 'rgb(33, 150, 243)',
          },
          {
            fill: 'rgb(105, 240, 174)',
          },
          {
            fill: 'rgb(0, 0, 0)',
          },
          {
            fill: 'rgb(108, 99, 255)',
          },
        ],
        width: 1187,
        isMulticolor: true,
        isMulticolor2: true,
        grid: 0,
        tags: ['undraw_analytics_5pgy'],
      },
      attrs: [
        {
          fill: 'rgb(0, 0, 0)',
        },
        {
          fill: 'rgb(255, 255, 255)',
        },
        {
          fill: 'rgb(189, 189, 189)',
        },
        {
          fill: 'rgb(255, 82, 82)',
        },
        {
          fill: 'rgb(255, 255, 0)',
        },
        {
          fill: 'rgb(105, 240, 174)',
        },
        {
          fill: 'rgb(224, 224, 224)',
        },
        {
          fill: 'rgb(0, 0, 0)',
        },
        {
          fill: 'rgb(0, 0, 0)',
        },
        {
          fill: 'rgb(0, 0, 0)',
        },
        {
          fill: 'rgb(0, 0, 0)',
        },
        {
          fill: 'rgb(108, 99, 255)',
        },
        {
          fill: 'rgb(105, 240, 174)',
        },
        {
          fill: 'rgb(0, 0, 0)',
        },
        {
          fill: 'rgb(255, 255, 255)',
        },
        {
          fill: 'rgb(189, 189, 189)',
        },
        {
          fill: 'rgb(255, 82, 82)',
        },
        {
          fill: 'rgb(255, 255, 0)',
        },
        {
          fill: 'rgb(105, 240, 174)',
        },
        {
          fill: 'rgb(224, 224, 224)',
        },
        {
          fill: 'rgb(33, 150, 243)',
        },
        {
          fill: 'rgb(33, 150, 243)',
          opacity: 0.4,
        },
        {
          fill: 'rgb(105, 240, 174)',
          opacity: 0.4,
        },
        {
          fill: 'rgb(255, 255, 0)',
          opacity: 0.4,
        },
        {
          fill: 'rgb(105, 240, 174)',
        },
        {
          fill: 'rgb(108, 99, 255)',
        },
        {
          fill: 'rgb(108, 99, 255)',
          opacity: 0.4,
        },
        {
          fill: 'rgb(255, 255, 0)',
        },
        {
          fill: 'rgb(0, 0, 0)',
        },
        {
          fill: 'rgb(255, 255, 255)',
        },
        {
          fill: 'rgb(189, 189, 189)',
        },
        {
          fill: 'rgb(255, 82, 82)',
        },
        {
          fill: 'rgb(255, 255, 0)',
        },
        {
          fill: 'rgb(105, 240, 174)',
        },
        {
          fill: 'rgb(33, 150, 243)',
        },
        {
          fill: 'rgb(105, 240, 174)',
        },
        {
          fill: 'rgb(0, 0, 0)',
        },
        {
          fill: 'rgb(108, 99, 255)',
        },
      ],
      properties: {
        order: 20,
        id: 14,
        name: 'forcasting',
        prevSize: 32,
      },
      setIdx: 0,
      setId: 2,
      iconIdx: 0,
    },
    {
      icon: {
        paths: [
          'M789.842 173.318h-587.791v789.212h587.795v-789.212z',
          'M779.135 184.028h-569.427v761.685h569.427v-761.685z',
          'M450.033 216.14h-195.933v6.117h195.933v-6.114z',
          'M450.033 243.674h-195.933v6.114h195.933v-6.117z',
          'M675.047 216.14h-195.929v6.117h195.929v-6.114zM705.65 390.512h-195.929v6.117h195.929v-6.117zM710.254 407.328h-195.929v6.117h195.929v-6.117zM719.443 424.16h-195.933v6.114h195.933v-6.114zM705.65 661.223h-195.929v6.117h195.929v-6.117zM710.254 678.051h-195.929v6.117h195.929v-6.117zM719.443 694.867h-195.933v6.117h195.933v-6.117z',
          'M463.808 327.794h-208.175v211.065h208.175v-211.065z',
          'M461.843 332.39h-204.899v201.887h204.899v-201.887z',
          'M455.274 344.622h-191.109v131.531h191.109v-131.531z',
          'M453.951 346.154h-188.473v126.949h188.473v-126.949z',
          'M249.499 468.518l47.461-73.421 19.9 32.112 42.86-44.343 36.743 44.343 32.138-65.76 82.656 131.531-267.878-9.178 6.121-15.284zM286.242 378.273c0.001 0 0.002 0 0.004 0 7.604 0 13.769-6.163 13.771-13.767l0-0c-0.002-7.604-6.167-13.767-13.771-13.767-0.001 0-0.003 0-0.004 0l0-0c-0.002-0-0.005-0-0.008-0-7.604 0-13.769 6.163-13.771 13.767l-0 0c0.002 7.604 6.167 13.767 13.771 13.767 0.003 0 0.005-0 0.008-0l-0 0z',
          'M463.808 598.517h-208.175v211.065h208.175v-211.065z',
          'M461.843 603.098h-204.899v201.887h204.899v-201.887z',
          'M455.274 615.344h-191.109v131.531h191.109v-131.531z',
          'M453.951 616.865h-188.473v126.946h188.473v-126.946z',
          'M249.499 739.229l47.461-73.421 19.9 32.127 42.86-44.358 36.743 44.358 32.138-65.771 82.656 131.531-267.878-9.17 6.121-15.296zM286.242 648.992c0.002 0 0.005 0 0.008 0 7.602 0 13.765-6.162 13.767-13.763l0-0c-0.002-7.604-6.167-13.767-13.771-13.767-0.001 0-0.003 0-0.004 0l0-0c-0.002-0-0.005-0-0.008-0-7.604 0-13.769 6.163-13.771 13.767l-0 0c0.002 7.602 6.165 13.763 13.767 13.763 0.004 0 0.008-0 0.012-0l-0.001 0z',
          'M442.178 134.296l-153.831 774.106 576.497 114.57 153.831-774.102-576.497-114.574z',
          'M447.716 146.318l-148.586 747.072 558.505 110.903 148.586-747.072-558.505-110.903z',
          'M877.826 267.564l-396.364-78.708-1.195 6 396.368 78.708 1.191-6zM765.046 834.628l-396.364-78.704-1.195 6 396.364 78.704 1.195-6zM668.088 851.232l-306.282-60.818-1.195 6 306.282 60.818 1.195-6z',
          'M469.045 847.584l-114.1-22.657-1.191 6 114.096 22.657 1.195-6zM672.764 262.72l-198.178-39.352-1.191 6 198.174 39.352 1.195-6z',
          'M825.063 328.818l-357.323-70.948-1.195 6 357.323 70.956 1.195-6z',
          'M547.946 309.665l-87.074-17.287-1.195 6 87.074 17.287 1.195-5.996z',
          'M850.383 405.587l-396.368-78.704-1.191 5.996 396.364 78.708 1.195-6z',
          'M488.903 472.614l-40.543 204.019 355.806 70.713 40.543-204.019-355.806-70.713z',
          'M842.27 544.332l-351.315-69.761-39.682 199.517 351.315 69.761 39.682-199.517z',
          'M843.518 440.1l-396.364-78.704-1.195 6 396.368 78.704 1.191-6z',
          'M565.919 517.522l-43.543-8.647-28.941 145.514 43.543 8.647 28.941-145.514z',
          'M634.44 581.033l-43.547-8.647-19.392 97.511 43.543 8.647 19.395-97.511z',
          'M703.568 641.544l-43.543-8.647-10.441 52.501 43.543 8.643 10.441-52.497z',
          'M792.383 603.037l-43.543-8.647-21.185 106.519 43.543 8.643 21.185-106.515z',
          'M919.423 461.183c-37.253-38.654-89.475-62.66-147.304-62.66-28.102 0-54.88 5.669-79.253 15.926l1.345-0.503c-26.183 10.956-48.521 26.179-67.214 45.023l-0.014 0.014c-77.335 77.9-78.647 204.743-3.004 284.293 37.321 39.176 89.887 63.538 148.142 63.538 42.465 0 81.907-12.945 114.594-35.105l-0.717 0.459 147.706 153.505c1.814 1.881 4.357 3.049 7.172 3.049 2.678 0 5.108-1.057 6.898-2.776l-0.003 0.003 36.803-35.362c1.886-1.809 3.057-4.35 3.057-7.164 0-2.677-1.060-5.106-2.783-6.891l0.003 0.003-147.668-153.498c24.538-33.281 39.272-75.101 39.272-120.362 0-4.853-0.169-9.667-0.503-14.436l0.036 0.642c-3.486-49.886-24.401-94.311-56.628-127.764l0.061 0.064zM873.415 707.994c-20.169 19.394-45.967 33.072-74.704 38.347l-0.897 0.137c-7.723 1.446-16.608 2.273-25.686 2.273-21.189 0-41.325-4.505-59.504-12.61l0.93 0.37c-26.886-11.947-48.847-30.869-64.17-54.496l-0.346-0.569c-14.459-22.261-23.057-49.489-23.057-78.725 0-31.256 9.826-60.216 26.558-83.961l-0.308 0.461c16.507-23.449 39.167-41.554 65.647-52.138l0.985-0.348c15.79-6.357 34.099-10.044 53.269-10.044 11.097 0 21.906 1.236 32.295 3.577l-0.978-0.185c48.19 10.827 86.749 44.318 104.426 88.43l0.348 0.984c6.362 15.771 10.052 34.060 10.052 53.21 0 1.014-0.010 2.025-0.031 3.033l0.002-0.151c-0.828 40.287-17.844 76.445-44.785 102.358l-0.047 0.045z',
          'M663.878 562.093c-16.437 0-16.464 25.528 0 25.528s16.464-25.528 0-25.528z',
          'M778.452 480.332c-44.241-0.997-84.491 21.178-105.897 54.651-6.986 10.923 12.846 20.575 19.794 9.705 17.719-27.712 51.393-45.314 87.817-44.396 38.169 0.956 72.905 22.775 91.295 53.055 6.971 11.484 25.259 1.047 18.349-10.373-22.361-36.671-65.669-61.558-111.358-62.642z',
          'M935.451 453.431c-37.246-38.659-89.465-62.67-147.292-62.67-28.107 0-54.89 5.673-79.265 15.935l1.345-0.503c-26.184 10.955-48.522 26.178-67.214 45.023l-0.014 0.014c-77.335 77.9-78.643 204.739-3.004 284.289 32.27 33.881 75.916 56.668 124.791 62.218l0.937 0.086c6.72 0.783 14.507 1.23 22.397 1.23 42.472 0 81.919-12.948 114.611-35.113l-0.717 0.459 147.695 153.52c1.813 1.883 4.355 3.052 7.17 3.052 2.679 0 5.111-1.059 6.9-2.782l-0.003 0.003 36.803-35.358c1.883-1.811 3.053-4.352 3.053-7.166 0-2.677-1.058-5.106-2.779-6.892l0.003 0.003-147.71-153.505c24.549-33.283 39.29-75.109 39.29-120.378 0-54.958-21.726-104.842-57.059-141.53l0.061 0.064zM889.443 700.135c-26.237 25.222-61.948 40.755-101.288 40.755-21.189 0-41.325-4.506-59.503-12.613l0.929 0.37c-26.887-11.944-48.848-30.865-64.17-54.492l-0.346-0.569c-14.459-22.261-23.057-49.489-23.057-78.725 0-31.256 9.826-60.216 26.558-83.961l-0.308 0.461c16.506-23.45 39.166-41.556 65.647-52.138l0.985-0.348c15.79-6.357 34.099-10.044 53.269-10.044 11.097 0 21.906 1.236 32.295 3.577l-0.978-0.185c29.311 6.569 54.528 21.182 73.988 41.381l0.044 0.046c25.246 26.206 40.798 61.903 40.798 101.234 0 1.001-0.010 1.999-0.030 2.996l0.002-0.149c-0.82 40.289-17.84 76.449-44.788 102.358l-0.048 0.046z',
          'M679.909 554.329c-16.437 0-16.464 25.528 0 25.528s16.464-25.528 0-25.528zM794.484 472.576c-44.241-0.994-84.491 21.178-105.897 54.655-6.986 10.923 12.846 20.575 19.794 9.705 17.719-27.712 51.393-45.318 87.817-44.4 38.169 0.956 72.905 22.775 91.295 53.055 6.971 11.488 25.259 1.051 18.349-10.373-22.399-36.773-65.654-61.66-111.358-62.642z',
          'M163.779 872.293h-4.589v25.998h4.589v-25.998z',
          'M174.497 887.573v-4.581h-26.017v4.581h26.017z',
          'M749.576 13.198c-2.005-0.891-3.377-2.864-3.377-5.159 0-0.586 0.089-1.15 0.255-1.681l-0.011 0.040c0.084-0.25 0.132-0.538 0.132-0.838 0-0.564-0.171-1.088-0.464-1.523l0.006 0.010c-0.511-0.775-1.378-1.279-2.363-1.279-1.144 0-2.129 0.681-2.572 1.659l-0.007 0.018c-0.885 2.007-2.857 3.382-5.15 3.382-0.59 0-1.159-0.091-1.693-0.26l0.040 0.011c-0.251-0.082-0.54-0.129-0.84-0.129-1.21 0-2.241 0.766-2.635 1.839l-0.006 0.019c-0.108 0.287-0.171 0.619-0.171 0.966 0 1.161 0.704 2.158 1.708 2.588l0.018 0.007c2.005 0.886 3.38 2.857 3.38 5.15 0 0.588-0.090 1.154-0.258 1.687l0.011-0.040c-0.087 0.259-0.137 0.558-0.137 0.869 0 1.556 1.262 2.818 2.818 2.818 0.955 0 1.799-0.475 2.308-1.201l0.006-0.009c0.118-0.159 0.224-0.34 0.308-0.532l0.007-0.018c0.89-2.004 2.862-3.376 5.155-3.376 0.588 0 1.155 0.090 1.688 0.258l-0.040-0.011c0.241 0.075 0.518 0.117 0.805 0.117 1.556 0 2.818-1.262 2.818-2.818 0-0.916-0.437-1.729-1.113-2.244l-0.007-0.005c-0.178-0.124-0.382-0.232-0.599-0.312l-0.019-0.006z',
          'M180.148 205.915c-2.005-0.888-3.378-2.861-3.378-5.154 0-0.586 0.090-1.151 0.256-1.682l-0.011 0.040c0.084-0.255 0.132-0.547 0.132-0.852 0-1.554-1.26-2.814-2.814-2.814-1.156 0-2.15 0.697-2.583 1.694l-0.007 0.018c-0.889 2.004-2.861 3.376-5.153 3.376-0.588 0-1.155-0.090-1.687-0.258l0.040 0.011c-0.238-0.072-0.511-0.114-0.795-0.114-1.558 0-2.822 1.263-2.822 2.822 0 0.913 0.434 1.725 1.106 2.241l0.007 0.005c0.159 0.119 0.34 0.224 0.532 0.308l0.017 0.007c2.005 0.888 3.378 2.861 3.378 5.154 0 0.586-0.090 1.151-0.256 1.682l0.011-0.040c-0.084 0.255-0.132 0.547-0.132 0.852 0 1.554 1.26 2.814 2.814 2.814 1.156 0 2.15-0.697 2.583-1.694l0.007-0.018c0.888-2.005 2.861-3.379 5.154-3.379 0.587 0 1.154 0.090 1.686 0.257l-0.040-0.011c0.241 0.075 0.518 0.117 0.805 0.117 1.556 0 2.818-1.262 2.818-2.818 0-0.916-0.437-1.729-1.113-2.244l-0.007-0.005c-0.159-0.119-0.34-0.225-0.533-0.308l-0.017-0.007zM989.901 1001.229c-2.006-0.883-3.381-2.854-3.381-5.145 0-0.589 0.091-1.157 0.259-1.691l-0.011 0.040c0.068-0.23 0.107-0.495 0.107-0.769 0-1.556-1.262-2.818-2.818-2.818-1.127 0-2.099 0.661-2.55 1.616l-0.007 0.017c-0.89 2.005-2.864 3.378-5.159 3.378-0.587 0-1.153-0.090-1.685-0.257l0.040 0.011c-0.238-0.073-0.511-0.114-0.795-0.114-1.554 0-2.814 1.26-2.814 2.814 0 1.134 0.671 2.112 1.638 2.557l0.017 0.007c2.006 0.883 3.381 2.854 3.381 5.145 0 0.589-0.091 1.157-0.259 1.691l0.011-0.040c-0.068 0.23-0.107 0.495-0.107 0.769 0 1.556 1.262 2.818 2.818 2.818 1.127 0 2.099-0.661 2.55-1.616l0.007-0.017c0.887-2.004 2.859-3.378 5.151-3.378 0.59 0 1.158 0.091 1.693 0.259l-0.040-0.011c0.238 0.072 0.511 0.114 0.795 0.114 1.558 0 2.822-1.263 2.822-2.822 0-0.913-0.434-1.725-1.106-2.241l-0.007-0.005c-0.159-0.118-0.34-0.223-0.532-0.308l-0.018-0.007z',
          'M420.947 110.622c5.071 0 9.182-4.111 9.182-9.182s-4.111-9.182-9.182-9.182h-0c-0.079-0.002-0.171-0.004-0.264-0.004-5.073 0-9.186 4.113-9.186 9.186s4.113 9.186 9.186 9.186c0.093 0 0.185-0.001 0.277-0.004l-0.014 0zM1079.148 225.326c0.001 0 0.002 0 0.004 0 5.073 0 9.186-4.113 9.186-9.186 0-5.072-4.11-9.183-9.182-9.186l-0-0c-0.001-0-0.002-0-0.004-0-5.073 0-9.186 4.113-9.186 9.186 0 5.072 4.11 9.183 9.182 9.186l0 0z',
          'M1027.114 499.098c5.070 0 9.18-4.11 9.18-9.18s-4.11-9.18-9.18-9.18l-0 0c-0.096-0.004-0.21-0.006-0.323-0.006-5.073 0-9.186 4.113-9.186 9.186s4.113 9.186 9.186 9.186c0.114 0 0.227-0.002 0.34-0.006l-0.016 0z',
          'M9.189 49.436c0.056 0.001 0.122 0.002 0.189 0.002 5.073 0 9.186-4.113 9.186-9.186s-4.113-9.186-9.186-9.186c-0.065 0-0.13 0.001-0.194 0.002l0.010-0c-4.993 0.104-9.001 4.176-9.001 9.184 0 5.007 4.006 9.078 8.987 9.184l0.010 0z',
        ],
        attrs: [
          {
            fill: 'rgb(0, 0, 0)',
            opacity: 0.5,
          },
          {
            fill: 'rgb(242, 242, 242)',
          },
          {
            fill: 'rgb(224, 224, 224)',
          },
          {
            fill: 'rgb(108, 99, 255)',
            opacity: 0.7,
          },
          {
            fill: 'rgb(224, 224, 224)',
          },
          {
            fill: 'rgb(0, 0, 0)',
            opacity: 0.5,
          },
          {
            fill: 'rgb(245, 245, 245)',
          },
          {
            fill: 'rgb(0, 0, 0)',
            opacity: 0.5,
          },
          {
            fill: 'rgb(255, 255, 255)',
          },
          {
            fill: 'rgb(108, 99, 255)',
            opacity: 0.4,
          },
          {
            fill: 'rgb(0, 0, 0)',
            opacity: 0.5,
          },
          {
            fill: 'rgb(245, 245, 245)',
          },
          {
            fill: 'rgb(0, 0, 0)',
            opacity: 0.5,
          },
          {
            fill: 'rgb(255, 255, 255)',
          },
          {
            fill: 'rgb(189, 189, 189)',
            opacity: 0.4,
          },
          {
            fill: 'rgb(0, 0, 0)',
            opacity: 0.5,
          },
          {
            fill: 'rgb(255, 255, 255)',
          },
          {
            fill: 'rgb(224, 224, 224)',
          },
          {
            fill: 'rgb(108, 99, 255)',
            opacity: 0.7,
          },
          {
            fill: 'rgb(224, 224, 224)',
          },
          {
            fill: 'rgb(58, 210, 159)',
            opacity: 0.7,
          },
          {
            fill: 'rgb(224, 224, 224)',
          },
          {
            fill: 'rgb(0, 0, 0)',
            opacity: 0.5,
          },
          {
            fill: 'rgb(255, 255, 255)',
          },
          {
            fill: 'rgb(224, 224, 224)',
          },
          {
            fill: 'rgb(108, 99, 255)',
          },
          {
            fill: 'rgb(58, 210, 159)',
          },
          {
            fill: 'rgb(245, 95, 68)',
          },
          {
            fill: 'rgb(253, 216, 53)',
          },
          {
            fill: 'rgb(0, 0, 0)',
          },
          {
            fill: 'rgb(0, 0, 0)',
          },
          {
            fill: 'rgb(0, 0, 0)',
          },
          {
            fill: 'rgb(108, 99, 255)',
          },
          {
            fill: 'rgb(108, 99, 255)',
          },
          {
            fill: 'rgb(71, 230, 177)',
          },
          {
            fill: 'rgb(71, 230, 177)',
          },
          {
            fill: 'rgb(77, 138, 240)',
          },
          {
            fill: 'rgb(253, 216, 53)',
          },
          {
            fill: 'rgb(245, 95, 68)',
          },
          {
            fill: 'rgb(77, 138, 240)',
          },
          {
            fill: 'rgb(71, 230, 177)',
            opacity: 0.5,
          },
        ],
        width: 1104,
        isMulticolor: true,
        isMulticolor2: true,
        grid: 0,
        tags: ['undraw_file_searching_duff'],
      },
      attrs: [
        {
          fill: 'rgb(0, 0, 0)',
          opacity: 0.5,
        },
        {
          fill: 'rgb(242, 242, 242)',
        },
        {
          fill: 'rgb(224, 224, 224)',
        },
        {
          fill: 'rgb(108, 99, 255)',
          opacity: 0.7,
        },
        {
          fill: 'rgb(224, 224, 224)',
        },
        {
          fill: 'rgb(0, 0, 0)',
          opacity: 0.5,
        },
        {
          fill: 'rgb(245, 245, 245)',
        },
        {
          fill: 'rgb(0, 0, 0)',
          opacity: 0.5,
        },
        {
          fill: 'rgb(255, 255, 255)',
        },
        {
          fill: 'rgb(108, 99, 255)',
          opacity: 0.4,
        },
        {
          fill: 'rgb(0, 0, 0)',
          opacity: 0.5,
        },
        {
          fill: 'rgb(245, 245, 245)',
        },
        {
          fill: 'rgb(0, 0, 0)',
          opacity: 0.5,
        },
        {
          fill: 'rgb(255, 255, 255)',
        },
        {
          fill: 'rgb(189, 189, 189)',
          opacity: 0.4,
        },
        {
          fill: 'rgb(0, 0, 0)',
          opacity: 0.5,
        },
        {
          fill: 'rgb(255, 255, 255)',
        },
        {
          fill: 'rgb(224, 224, 224)',
        },
        {
          fill: 'rgb(108, 99, 255)',
          opacity: 0.7,
        },
        {
          fill: 'rgb(224, 224, 224)',
        },
        {
          fill: 'rgb(58, 210, 159)',
          opacity: 0.7,
        },
        {
          fill: 'rgb(224, 224, 224)',
        },
        {
          fill: 'rgb(0, 0, 0)',
          opacity: 0.5,
        },
        {
          fill: 'rgb(255, 255, 255)',
        },
        {
          fill: 'rgb(224, 224, 224)',
        },
        {
          fill: 'rgb(108, 99, 255)',
        },
        {
          fill: 'rgb(58, 210, 159)',
        },
        {
          fill: 'rgb(245, 95, 68)',
        },
        {
          fill: 'rgb(253, 216, 53)',
        },
        {
          fill: 'rgb(0, 0, 0)',
        },
        {
          fill: 'rgb(0, 0, 0)',
        },
        {
          fill: 'rgb(0, 0, 0)',
        },
        {
          fill: 'rgb(108, 99, 255)',
        },
        {
          fill: 'rgb(108, 99, 255)',
        },
        {
          fill: 'rgb(71, 230, 177)',
        },
        {
          fill: 'rgb(71, 230, 177)',
        },
        {
          fill: 'rgb(77, 138, 240)',
        },
        {
          fill: 'rgb(253, 216, 53)',
        },
        {
          fill: 'rgb(245, 95, 68)',
        },
        {
          fill: 'rgb(77, 138, 240)',
        },
        {
          fill: 'rgb(71, 230, 177)',
          opacity: 0.5,
        },
      ],
      properties: {
        order: 21,
        id: 13,
        name: 'analysis',
        prevSize: 32,
      },
      setIdx: 0,
      setId: 2,
      iconIdx: 1,
    },
    {
      icon: {
        paths: [
          'M0 28.444c0-15.709 12.735-28.444 28.444-28.444v0h398.222c15.709 0 28.444 12.735 28.444 28.444v0 967.111c0 15.709-12.735 28.444-28.444 28.444v0h-398.222c-15.709 0-28.444-12.735-28.444-28.444v0-967.111zM568.889 28.444c0-15.709 12.735-28.444 28.444-28.444v0h398.222c15.709 0 28.444 12.735 28.444 28.444v0 967.111c0 15.709-12.735 28.444-28.444 28.444v0h-398.222c-15.709 0-28.444-12.735-28.444-28.444v0-967.111z',
        ],
        attrs: [
          {
            fill: 'rgb(104, 97, 221)',
          },
        ],
        isMulticolor: false,
        isMulticolor2: false,
        grid: 0,
        tags: ['column-view'],
        colorPermutations: {
          '110497221125525525515552991': [
            {
              f: 2,
            },
          ],
        },
      },
      attrs: [
        {
          fill: 'rgb(104, 97, 221)',
        },
      ],
      properties: {
        order: 17,
        id: 12,
        name: 'column-view',
        prevSize: 32,
      },
      setIdx: 0,
      setId: 2,
      iconIdx: 0,
    },
    {
      icon: {
        paths: [
          'M546.816 815.859c-14.598 17.647-36.5 28.806-61.009 28.806s-46.41-11.159-60.902-28.673l-0.106-0.132-286.073-353.226c-11.402-13.546-18.33-31.187-18.33-50.445s6.928-36.899 18.428-50.565l-0.098 0.119c14.363-16.431 35.362-26.753 58.771-26.753 0.635 0 1.269 0.008 1.9 0.023l-0.094-0.002c23.981 0.443 45.294 11.496 59.502 28.648l149.179 185.53v-468.561c-0.012-0.521-0.019-1.134-0.019-1.75 0-18.662 6.51-35.803 17.383-49.277l-0.117 0.15c11.473-14.201 27.435-24.37 45.708-28.359l0.534-0.098c4.311-0.832 9.27-1.308 14.339-1.308 18.981 0 36.403 6.675 50.047 17.806l-0.143-0.113c17.195 14.138 28.113 35.369 28.241 59.155l0 0.022v472.28l150.582-185.075c14.608-17.604 36.491-28.731 60.973-28.731 25.404 0 48.009 11.981 62.474 30.601l0.134 0.179c8.643 12.858 13.796 28.69 13.796 45.725 0 19.21-6.552 36.89-17.543 50.927l0.137-0.181-287.744 353.28zM66.021 896h835.961c14.875-0.323 29.48 4.204 41.391 12.935 11.965 8.731 20.642 21.073 24.684 35.193 1.307 4.794 2.058 10.299 2.058 15.978 0 14.709-5.036 28.242-13.478 38.968l0.102-0.135c-11.898 15.214-30.212 24.936-50.802 25.061l-0.021 0h-837.794c-0.452 0.011-0.984 0.017-1.518 0.017-14.985 0-28.836-4.858-40.064-13.085l0.19 0.133c-11.722-8.577-20.416-20.677-24.565-34.726l-0.118-0.467c-1.301-4.784-2.049-10.276-2.049-15.944 0-15.039 5.265-28.848 14.052-39.686l-0.092 0.117c11.981-14.912 30.216-24.376 50.662-24.376 0.492 0 0.984 0.005 1.473 0.016l-0.073-0.001z',
        ],
        attrs: [
          {
            fill: 'rgb(55, 52, 99)',
          },
        ],
        width: 970,
        isMulticolor: false,
        isMulticolor2: false,
        grid: 0,
        tags: ['download'],
        colorPermutations: {
          '110497221125525525515552991': [
            {
              f: 1,
            },
          ],
        },
      },
      attrs: [
        {
          fill: 'rgb(55, 52, 99)',
        },
      ],
      properties: {
        order: 16,
        id: 11,
        name: 'download',
        prevSize: 32,
      },
      setIdx: 0,
      setId: 2,
      iconIdx: 1,
    },
    {
      icon: {
        paths: [
          'M0 28.444c0-15.709 12.735-28.444 28.444-28.444v0h398.222c15.709 0 28.444 12.735 28.444 28.444v0 398.222c0 15.709-12.735 28.444-28.444 28.444v0h-398.222c-15.709 0-28.444-12.735-28.444-28.444v0-398.222zM0 597.333c0-15.709 12.735-28.444 28.444-28.444v0h398.222c15.709 0 28.444 12.735 28.444 28.444v0 398.222c0 15.709-12.735 28.444-28.444 28.444v0h-398.222c-15.709 0-28.444-12.735-28.444-28.444v0-398.222zM568.889 28.444c0-15.709 12.735-28.444 28.444-28.444v0h398.222c15.709 0 28.444 12.735 28.444 28.444v0 398.222c0 15.709-12.735 28.444-28.444 28.444v0h-398.222c-15.709 0-28.444-12.735-28.444-28.444v0-398.222zM568.889 597.333c0-15.709 12.735-28.444 28.444-28.444v0h398.222c15.709 0 28.444 12.735 28.444 28.444v0 398.222c0 15.709-12.735 28.444-28.444 28.444v0h-398.222c-15.709 0-28.444-12.735-28.444-28.444v0-398.222z',
        ],
        attrs: [
          {
            fill: 'rgb(104, 97, 221)',
          },
        ],
        isMulticolor: false,
        isMulticolor2: false,
        grid: 0,
        tags: ['grid-view'],
        colorPermutations: {
          '110497221125525525515552991': [
            {
              f: 2,
            },
          ],
        },
      },
      attrs: [
        {
          fill: 'rgb(104, 97, 221)',
        },
      ],
      properties: {
        order: 15,
        id: 10,
        name: 'grid-view',
        prevSize: 32,
      },
      setIdx: 0,
      setId: 2,
      iconIdx: 2,
    },
    {
      icon: {
        paths: [
          'M685.739 468.105c-17.237 0-33.792 6.963-46.012 19.319-12.22 12.322-19.115 29.082-19.115 46.524v219.409c0 17.476 6.861 34.202 19.081 46.558 11.758 11.869 28.061 19.218 46.080 19.218s34.322-7.349 46.075-19.213l0.005-0.005c12.22-12.322 19.081-29.082 19.081-46.558v-219.409c0-17.442-6.895-34.202-19.115-46.524-11.746-11.903-28.048-19.287-46.074-19.319l-0.006-0zM338.261 336.452c-17.306 0-33.86 6.963-46.080 19.319-11.812 11.95-19.11 28.384-19.115 46.523l-0 0.001v351.027c0 17.476 6.861 34.202 19.115 46.558 11.756 11.859 28.052 19.201 46.063 19.201s34.307-7.342 46.058-19.196l0.005-0.005c12.22-12.322 19.115-29.082 19.115-46.558v-351.027c-0.005-18.139-7.303-34.573-19.121-46.53l0.006 0.006c-11.746-11.903-28.048-19.287-46.074-19.319l-0.006-0zM512 204.8c-17.271 0-33.826 6.963-46.080 19.285-11.816 11.954-19.115 28.396-19.115 46.542 0 0.006 0 0.011 0 0.017l-0-0.001v482.679c0 17.476 6.895 34.202 19.115 46.558 11.758 11.869 28.061 19.218 46.080 19.218s34.322-7.349 46.075-19.213l0.005-0.005c12.22-12.322 19.115-29.082 19.115-46.558v-482.645c0-0.005 0-0.011 0-0.016 0-18.146-7.299-34.587-19.121-46.548l0.006 0.006c-11.746-11.903-28.048-19.287-46.074-19.319l-0.006-0z',
          'M512 0c282.761 0 512 229.239 512 512s-229.239 512-512 512c-282.761 0-512-229.239-512-512s229.239-512 512-512zM512 34.133c-263.919 0-477.867 213.948-477.867 477.867s213.948 477.867 477.867 477.867 477.867-213.948 477.867-477.867-213.948-477.867-477.867-477.867z',
        ],
        attrs: [
          {
            fill: 'rgb(104, 97, 221)',
          },
          {
            fill: 'rgb(104, 97, 221)',
          },
        ],
        isMulticolor: false,
        isMulticolor2: false,
        grid: 0,
        tags: ['graph-icon'],
        colorPermutations: {
          '11049722112552552551': [
            {
              f: 1,
            },
            {
              f: 1,
            },
          ],
        },
      },
      attrs: [
        {
          fill: 'rgb(104, 97, 221)',
        },
        {
          fill: 'rgb(104, 97, 221)',
        },
      ],
      properties: {
        order: 14,
        id: 9,
        name: 'graph-icon',
        prevSize: 32,
      },
      setIdx: 0,
      setId: 2,
      iconIdx: 0,
    },
    {
      icon: {
        paths: [
          'M-303.467 88.082c-56.387-110.16-15.221-249.618 91.952-311.493l1673.852-966.401c107.17-61.875 239.762-22.734 296.149 87.423l518.738 1013.401c56.398 110.157 15.237 249.618-91.943 311.493l-1214.923 701.438c-360.632 208.21-806.798 76.502-996.545-294.177l-277.28-541.687z',
        ],
        attrs: [
          {
            fill: 'rgb(255, 255, 255)',
            opacity: 0.15,
          },
        ],
        width: 2303,
        isMulticolor: false,
        isMulticolor2: false,
        grid: 0,
        tags: ['rect-1'],
        colorPermutations: {
          '11049722112552552551': [
            {
              f: 2,
            },
          ],
        },
      },
      attrs: [
        {
          fill: 'rgb(255, 255, 255)',
          opacity: 0.15,
        },
      ],
      properties: {
        order: 10,
        id: 6,
        name: 'rect-1',
        prevSize: 32,
      },
      setIdx: 0,
      setId: 2,
      iconIdx: 0,
    },
    {
      icon: {
        paths: [
          'M0 873.711c0-29.188 6.012-55.147 18.031-77.882 12.305-23.011 29.077-40.972 50.325-53.884 21.529-12.911 45.572-19.365 72.134-19.365 33.548 0 61.787 7.858 84.711 23.573 22.929 15.719 39.701 37.748 50.325 66.093h-21.805c-8.39-22.45-22.367-40.13-41.939-53.042-19.291-13.188-43.053-19.786-71.292-19.786-22.648 0-43.194 5.475-61.646 16.417-18.457 10.665-32.991 26.244-43.615 46.732-10.624 20.203-15.938 43.921-15.938 71.143 0 26.942 5.314 50.519 15.938 70.722 10.624 19.927 25.162 35.365 43.615 46.311 18.453 10.942 38.999 16.417 61.646 16.417 28.238 0 52.001-6.458 71.292-19.365 19.572-13.192 33.553-31.013 41.939-53.463h21.805c-10.624 28.346-27.396 50.374-50.325 66.093-22.92 15.715-51.159 23.573-84.711 23.573-26.562 0-50.605-6.313-72.134-18.944-21.248-12.911-38.020-30.732-50.325-53.463-12.020-23.015-18.031-48.974-18.031-77.882zM609.152 731.842v289.21h-18.874v-249.637l-110.712 249.637h-15.1l-111.133-249.637v249.637h-18.87v-289.21h20.129l117.421 264.374 117.426-264.374h19.712z',
          'M788.839 724.265c31.034 0 58.153 6.313 81.358 18.944 23.486 12.35 41.517 29.75 54.099 52.199 12.581 22.454 18.874 48.132 18.874 77.039 0 28.627-6.433 54.165-19.291 76.618-12.581 22.454-30.617 40.134-54.103 53.042-23.205 12.631-50.184 18.944-80.937 18.944h-117.004v-296.787h117.004zM782.551 948.224c24.043 0 42.913-6.594 56.613-19.786 13.7-13.188 20.55-31.851 20.55-55.99 0-24.415-6.85-43.219-20.55-56.411-13.7-13.469-32.57-20.207-56.613-20.207h-28.519v152.394h28.519zM1167.261 972.643h-104.844l-15.934 48.409h-86.392l107.78-296.787h94.778l107.359 296.787h-86.813l-15.934-48.409zM1146.711 909.494l-31.872-95.983-31.451 95.983h63.323zM1519.484 724.265v65.672h-78.844v231.114h-82.197v-231.114h-78.002v-65.672h239.042z',
          'M759.742 138.678c-83.039 0-150.355 67.316-150.355 150.355s67.316 150.355 150.355 150.355 150.355-67.316 150.355-150.355-67.316-150.355-150.355-150.355zM470.71 289.032c0-159.628 129.404-289.032 289.032-289.032s289.032 129.404 289.032 289.032-129.404 289.032-289.032 289.032-289.032-129.404-289.032-289.032z',
          'M759.742 138.678c-83.039 0-150.355 67.316-150.355 150.355 0 42.496 17.54 80.776 45.96 108.205 27.557 26.595 28.338 70.491 1.742 98.044-26.591 27.557-70.487 28.338-98.044 1.742-54.379-52.48-88.337-126.332-88.337-207.992 0-159.628 129.404-289.032 289.032-289.032s289.032 129.404 289.032 289.032c0 81.664-33.957 155.512-88.337 207.992-27.557 26.595-71.453 25.815-98.044-1.742-26.595-27.553-25.815-71.449 1.742-98.044 28.42-27.429 45.96-65.709 45.96-108.205 0-83.039-67.316-150.355-150.355-150.355z',
          'M759.742 138.678c-83.039 0-150.355 67.316-150.355 150.355 0 42.496 17.54 80.776 45.96 108.205 27.557 26.595 28.338 70.491 1.742 98.044-26.591 27.557-70.487 28.338-98.044 1.742-54.379-52.48-88.337-126.332-88.337-207.992 0-159.628 129.404-289.032 289.032-289.032 73.208 0 140.21 27.309 191.108 72.192 28.722 25.327 31.471 69.145 6.144 97.866s-69.145 31.476-97.866 6.148c-26.541-23.407-61.229-37.533-99.386-37.533z',
          'M978.279 451.171c0 38.933-31.562 70.495-70.495 70.495s-70.495-31.562-70.495-70.495c0-38.933 31.562-70.495 70.495-70.495s70.495 31.562 70.495 70.495z',
        ],
        attrs: [
          {
            fill: 'rgb(255, 255, 255)',
            opacity: 0.8,
          },
          {
            fill: 'rgb(0, 0, 0)',
          },
          {
            fill: 'rgb(255, 255, 255)',
            opacity: 0.25,
          },
          {
            fill: 'rgb(255, 255, 255)',
            opacity: 0.5,
          },
          {
            fill: 'rgb(255, 255, 255)',
            opacity: 0.75,
          },
          {
            fill: 'rgb(255, 255, 255)',
          },
        ],
        width: 1519,
        isMulticolor: true,
        isMulticolor2: true,
        grid: 0,
        tags: ['cm-dat-full-logo'],
        colorPermutations: {
          '11049722112552552551': [
            {
              f: 2,
            },
            {
              f: 0,
            },
            {
              f: 2,
            },
            {
              f: 2,
            },
            {
              f: 2,
            },
            {
              f: 2,
            },
          ],
        },
      },
      attrs: [
        {
          fill: 'rgb(255, 255, 255)',
          opacity: 0.8,
        },
        {
          fill: 'rgb(0, 0, 0)',
        },
        {
          fill: 'rgb(255, 255, 255)',
          opacity: 0.25,
        },
        {
          fill: 'rgb(255, 255, 255)',
          opacity: 0.5,
        },
        {
          fill: 'rgb(255, 255, 255)',
          opacity: 0.75,
        },
        {
          fill: 'rgb(255, 255, 255)',
        },
      ],
      properties: {
        order: 8,
        id: 5,
        name: 'cm-dat-full-logo',
        prevSize: 32,
      },
      setIdx: 0,
      setId: 2,
      iconIdx: 0,
    },
    {
      icon: {
        paths: [
          'M877.67 556.39h-90.266c-18.995 67.123-79.565 116.275-150.835 116.275s-131.84-50.33-152.064-116.275h-440.525c-24.297-0.028-43.982-19.731-43.982-44.032 0-0.126 0.001-0.252 0.002-0.378l-0 0.019c-0.001-0.107-0.001-0.232-0.001-0.359 0-24.283 19.656-43.974 43.926-44.032l0.005-0h440.627c18.995-67.123 79.565-116.275 150.835-116.275s131.84 49.152 150.835 116.275h90.266c24.275 0.057 43.931 19.749 43.931 44.032 0 0.126-0.001 0.252-0.002 0.378l0-0.019c0.032 0.612 0.050 1.329 0.050 2.050 0 23.385-18.957 42.342-42.342 42.342-0.161 0-0.323-0.001-0.484-0.003l0.025 0zM636.57 440.064c-37.99 0-71.27 31.181-71.27 71.936s30.874 71.936 71.27 71.936c40.397 0 71.27-31.181 71.27-71.936s-33.28-71.936-71.27-71.936zM43.93 818.944h93.85c18.944-67.123 79.565-116.275 150.835-116.275 71.219 0 131.789 49.152 150.784 116.275h438.272c24.275 0.057 43.931 19.749 43.931 44.032 0 0.126-0.001 0.252-0.002 0.378l0-0.019c0.008 0.306 0.012 0.667 0.012 1.029 0 23.922-19.393 43.315-43.315 43.315-0.22 0-0.44-0.002-0.66-0.005l0.033 0h-438.272c-18.944 67.174-79.565 116.326-150.784 116.326-71.27 0-131.84-49.152-150.835-116.326h-93.85c-24.275-0.058-43.931-19.749-43.931-44.032 0-0.108 0-0.216 0.001-0.324l-0 0.017c0-25.19 18.995-44.39 43.93-44.39zM288.614 935.27c37.99 0 71.219-31.181 71.219-71.936s-30.874-71.936-71.219-71.936c-40.448 0-71.27 33.536-71.27 71.936s33.28 71.936 71.27 71.936zM877.67 205.056h-438.272c-18.944 67.123-79.565 116.275-150.784 116.275-71.27 0-131.84-49.152-150.835-116.275h-93.85c-24.275-0.057-43.931-19.749-43.931-44.032 0-0.126 0.001-0.252 0.002-0.378l-0 0.019c0-25.19 18.995-44.339 43.93-44.339h93.85c18.893-67.174 79.565-116.326 150.835-116.326 71.219 0 131.738 49.152 150.784 116.326h438.272c24.275 0.058 43.931 19.749 43.931 44.032 0 0.108-0 0.216-0.001 0.324l0-0.017c0.009 0.322 0.013 0.7 0.013 1.080 0 23.922-19.393 43.315-43.315 43.315-0.221 0-0.441-0.002-0.661-0.005l0.033 0zM288.614 88.73c-38.042 0-71.27 31.181-71.27 71.936s30.874 71.936 71.27 71.936c40.346 0 71.219-31.181 71.219-71.936s-33.28-71.936-71.219-71.936z',
        ],
        attrs: [
          {
            fill: 'rgb(104, 97, 221)',
          },
        ],
        width: 922,
        isMulticolor: false,
        isMulticolor2: false,
        grid: 0,
        tags: ['filters-alt'],
        colorPermutations: {
          '1049722112552552551': [
            {
              f: 0,
            },
          ],
        },
      },
      attrs: [
        {
          fill: 'rgb(104, 97, 221)',
        },
      ],
      properties: {
        order: 7,
        id: 4,
        name: 'filters-alt',
        prevSize: 32,
      },
      setIdx: 0,
      setId: 2,
      iconIdx: 0,
    },
    {
      icon: {
        paths: [
          'M936.96 378.88l-425.301-366.148c-9.228-7.914-21.315-12.732-34.526-12.732s-25.297 4.817-34.597 12.792l0.072-0.060-425.199 366.114c-10.727 9.81-17.429 23.868-17.429 39.49 0 0.529 0.008 1.056 0.023 1.581l-0.002-0.077v550.434c0 13.995 5.393 27.477 15.053 37.547 9.66 10.001 22.767 15.838 36.591 16.213h851.046c14.063 0 27.546-5.666 37.513-15.735 9.933-10.103 15.531-23.757 15.531-38.025v-550.468c-0.004-16.339-7.252-30.985-18.705-40.902l-0.068-0.058zM849.374 916.207h-744.38v-471.381l372.19-320.239 372.19 320.307v471.347z',
        ],
        attrs: [
          {
            fill: 'rgb(255, 255, 255)',
          },
        ],
        width: 956,
        isMulticolor: false,
        isMulticolor2: false,
        grid: 0,
        tags: ['house'],
        colorPermutations: {
          '1049722112552552551': [
            {
              f: 1,
            },
          ],
        },
      },
      attrs: [
        {
          fill: 'rgb(255, 255, 255)',
        },
      ],
      properties: {
        order: 6,
        id: 3,
        name: 'house',
        prevSize: 32,
      },
      setIdx: 0,
      setId: 2,
      iconIdx: 0,
    },
    {
      icon: {
        paths: [
          'M246.816 32.032c-8.211 0.442-15.473 4.174-20.55 9.89l-0.026 0.030c-4.76 5.299-7.67 12.342-7.67 20.065 0 4.71 1.083 9.168 3.013 13.137l-0.078-0.179c3.435 7.129 9.393 12.588 16.688 15.293l0.208 0.067c3.712 1.344 7.616 1.92 11.52 1.696h19.808v277.792l-225.952 438.112c-9.152 17.728-11.776 36.672-11.776 54.080 0 71.424 58.016 129.984 128.768 129.984h574.464c70.784 0 128.768-58.56 128.768-129.984 0-17.408-2.624-36.352-11.776-54.080l-225.92-438.080v-187.84c0.001-0.097 0.002-0.212 0.002-0.327 0-8.215-3.272-15.665-8.584-21.12l0.006 0.007c-5.392-5.518-12.909-8.94-21.225-8.94-4.12 0-8.044 0.84-11.609 2.358l0.194-0.073c-7.383 3.172-13.105 9.029-16.025 16.312l-0.071 0.2c-1.358 3.312-2.147 7.157-2.147 11.185 0 0.152 0.001 0.303 0.003 0.454l-0-0.023v195.296c0.032 4.8 1.216 9.504 3.424 13.76l156.928 304.32c-44.416 32.96-101.888 56.576-130.624 56.576-69.184 0-114.368-28.032-164.352-60.288-49.984-32.288-105.056-69.696-182.304-69.696-14.784 0-29.76 1.504-45.216 4.064l121.024-235.008c2.125-3.992 3.388-8.725 3.424-13.749l0-0.011v-285.248h316.96c0.128 0.002 0.278 0.003 0.429 0.003 8.144 0 15.516-3.303 20.851-8.643l0-0c5.481-5.445 8.874-12.986 8.874-21.32 0-4.202-0.863-8.203-2.421-11.835l0.075 0.196c-3.136-7.381-8.916-13.13-16.122-16.15l-0.198-0.074c-3.289-1.378-7.112-2.179-11.121-2.179-0.14 0-0.28 0.001-0.42 0.003l0.021-0h-396.16c-0.464-0.026-1.006-0.041-1.552-0.041s-1.088 0.015-1.627 0.044l0.075-0.003zM408.384 382.016c-27.36 0-49.536 22.4-49.536 50.016s22.176 49.984 49.536 49.984c27.36 0 49.504-22.4 49.504-49.984 0-27.616-22.144-50.016-49.504-50.016zM497.536 552.032c-21.888 0-39.648 17.92-39.648 40s17.76 40 39.648 40c21.856 0 39.616-17.92 39.616-40s-17.76-40-39.616-40zM249.92 682.016c58.464 0 99.392 27.264 150.080 60 50.72 32.736 110.912 69.984 196.576 69.984 51.040 0 108.544-26.208 158.464-62.496l44.576 86.24c3.104 6.016 4.96 15.2 4.96 26.24 0 39.040-30.72 70.016-69.344 70.016h-574.464c-0.039 0-0.086 0-0.132 0-38.227 0-69.216-30.989-69.216-69.216 0-0.27 0.002-0.54 0.005-0.809l-0 0.041c0-11.072 1.856-20.256 4.96-26.24l71.2-138.176c31.2-11.584 56.448-15.616 82.336-15.616z',
          'M250.208 20.032h395.808c0.147-0.002 0.322-0.003 0.496-0.003 11.456 0 21.826 4.649 29.327 12.162l0.001 0.001c7.672 7.62 12.421 18.174 12.421 29.838 0 5.839-1.19 11.4-3.341 16.453l0.104-0.275c-4.388 10.374-12.507 18.451-22.634 22.681l-0.278 0.103c-5.12 2.080-10.56 3.104-16.096 3.040h-304.864v273.376c-0.050 7.025-1.808 13.628-4.879 19.429l0.111-0.229-110.464 214.592c8-0.768 16-1.184 24-1.184 78.208 0 134.784 36.608 183.040 67.84l5.792 3.776c49.92 32.224 92.48 58.368 157.856 58.368 11.904 0 31.616-5.12 54.72-14.944 19.84-8.48 41.152-19.968 60.48-33.312l-152.16-295.136c-2.957-5.573-4.714-12.175-4.768-19.183l-0-0.017v-195.296c-0.002-0.142-0.003-0.31-0.003-0.477 0-11.468 4.566-21.869 11.98-29.484l-0.009 0.009c7.574-7.726 18.12-12.516 29.784-12.516 5.813 0 11.349 1.19 16.376 3.339l-0.272-0.103c10.35 4.438 18.377 12.631 22.492 22.824l0.1 0.28c2.048 5.12 3.040 10.624 2.976 16.128v184.832l224.64 435.52c10.304 19.968 13.088 40.992 13.088 59.52 0 77.984-63.264 142.016-140.768 142.016h-574.496c-77.504 0-140.768-64.032-140.768-141.984 0-18.56 2.784-39.584 13.12-59.584l224.608-435.52v-262.848h-7.52c-0.567 0.028-1.232 0.044-1.9 0.044-10.784 0-20.608-4.113-27.988-10.856l0.032 0.029c-7.963-7.261-13.113-17.49-13.692-28.924l-0.004-0.1c-0.034-0.633-0.053-1.373-0.053-2.118 0-16.604 9.566-30.974 23.487-37.899l0.246-0.111c4.96-2.368 10.336-3.744 15.84-4.032zM250.208 20.096c-0.602-0.031-1.307-0.049-2.016-0.049s-1.414 0.018-2.114 0.053l0.098-0.004h4.032zM249.248 44.064c-0.274-0.015-0.595-0.024-0.918-0.024-5.217 0-9.902 2.278-13.114 5.894l-0.016 0.018c-2.887 3.196-4.653 7.452-4.653 12.12 0 2.841 0.654 5.53 1.82 7.923l-0.047-0.107c2.070 4.265 5.645 7.529 10.019 9.144l0.125 0.040c2.176 0.8 4.48 1.152 6.816 1.024h32.448v292.704l-227.328 440.64c-7.968 15.456-10.432 32.288-10.432 48.576 0 64.896 52.736 117.984 116.768 117.984h574.464c64.032 0 116.768-53.088 116.768-117.984 0-16.288-2.464-33.12-10.432-48.576l-227.296-440.704v-190.848c0.001-0.064 0.001-0.14 0.001-0.216 0-7.399-4.421-13.766-10.766-16.602l-0.115-0.046c-2.033-0.897-4.404-1.419-6.896-1.419-7.422 0-13.763 4.628-16.295 11.155l-0.041 0.119c-0.812 1.987-1.283 4.292-1.283 6.708 0 0.117 0.001 0.233 0.003 0.35l-0-0.017v195.392c0 2.88 0.704 5.728 2.016 8.288h0.032l161.6 313.44-8.192 6.080c-21.285 15.801-45.487 29.874-71.21 41.117l-2.39 0.931c-23.968 10.176-47.328 16.864-64.16 16.864-73.024 0-120.832-29.92-170.88-62.208l-4.608-3.008c-48.96-31.68-100.192-64.768-171.2-64.768-13.952 0-28.224 1.44-43.2 3.904l-23.552 3.872 131.936-256.256c1.279-2.395 2.045-5.232 2.080-8.245l0-0.011v-297.28h329.12c0.083 0.001 0.182 0.002 0.281 0.002 4.827 0 9.197-1.958 12.359-5.122l0-0c3.31-3.268 5.359-7.805 5.359-12.821 0-2.535-0.524-4.947-1.468-7.136l0.045 0.117c-1.868-4.435-5.325-7.892-9.642-9.716l-0.118-0.044c-1.943-0.811-4.201-1.282-6.569-1.282-0.087 0-0.174 0.001-0.261 0.002l0.013-0h-396.96zM346.88 432c-0-0.076-0.001-0.166-0.001-0.256 0-34.031 27.524-61.633 61.524-61.76l0.012-0c33.999 0.145 61.505 27.74 61.505 61.759 0 0.090-0 0.18-0.001 0.27l0-0.014c0 0.067 0 0.146 0 0.225 0 34.019-27.505 61.614-61.491 61.759l-0.014 0c-34.013-0.127-61.536-27.729-61.536-61.76 0-0.079 0-0.158 0-0.237l-0 0.012zM408.416 393.984c-20.758 0.127-37.537 16.984-37.537 37.759 0 0.090 0 0.18 0.001 0.271l-0-0.014c0 21.088 16.928 37.984 37.536 37.984 20.744-0.145 37.505-16.995 37.505-37.759 0-0.079-0-0.158-0.001-0.237l0 0.012c0.001-0.076 0.001-0.167 0.001-0.257 0-20.765-16.761-37.614-37.491-37.759l-0.014-0zM445.92 591.968c-0-0.038-0-0.083-0-0.128 0-28.563 23.1-51.731 51.638-51.84l0.010-0c28.608 0 51.616 23.36 51.616 51.968 0 28.64-23.040 52-51.616 52-28.548-0.109-51.648-23.277-51.648-51.84 0-0.056 0-0.113 0-0.169l-0 0.009zM497.568 564c-15.289 0.091-27.648 12.506-27.648 27.808 0 0.056 0 0.113 0.001 0.169l-0-0.009c0 15.584 12.48 28 27.648 28 15.279-0.127 27.616-12.542 27.616-27.839 0-0.057-0-0.113-0.001-0.17l0 0.009c0-0.048 0-0.104 0-0.161 0-15.291-12.341-27.699-27.606-27.807l-0.010-0zM176.096 707.296l-69.056 133.984c-1.92 3.68-3.616 10.72-3.616 20.768 0 32.48 25.44 57.984 57.344 57.984h574.464c31.904 0 57.344-25.504 57.344-57.984 0-10.048-1.728-17.056-3.616-20.736zM788.96 841.312l-38.272-74.048c-48.256 32.896-103.456 56.768-154.112 56.768-89.472 0-152.224-39.104-203.072-71.904l-2.016-1.312c-50.208-32.416-87.936-56.768-141.568-56.768-23.2 0-45.92 3.392-73.824 13.312zM163.392 686.432c32.512-12.096 59.2-16.384 86.528-16.384 60.8 0 103.936 27.872 152.384 59.2l4.224 2.72c50.56 32.64 108.16 68.064 190.048 68.064 47.36 0 102.4-24.544 151.424-60.192l11.296-8.224 50.976 98.656c4.32 8.352 6.304 19.648 6.304 31.776 0.002 0.228 0.004 0.498 0.004 0.768 0 44.854-36.362 81.216-81.216 81.216-0.046 0-0.093-0-0.139-0l0.007 0h-574.464c-0.039 0-0.085 0-0.132 0-44.854 0-81.216-36.362-81.216-81.216 0-0.27 0.001-0.54 0.004-0.809l-0 0.041c0-12.128 1.984-23.392 6.304-31.744l73.28-142.272 4.384-1.6z',
        ],
        attrs: [
          {
            fill: 'rgb(104, 97, 221)',
          },
          {
            fill: 'rgb(104, 97, 221)',
          },
        ],
        width: 896,
        isMulticolor: false,
        isMulticolor2: false,
        grid: 0,
        tags: ['jug'],
        colorPermutations: {
          '1049722112552552551': [
            {
              f: 0,
            },
            {
              f: 0,
            },
          ],
        },
      },
      attrs: [
        {
          fill: 'rgb(104, 97, 221)',
        },
        {
          fill: 'rgb(104, 97, 221)',
        },
      ],
      properties: {
        order: 4,
        id: 2,
        name: 'jug',
        prevSize: 32,
      },
      setIdx: 0,
      setId: 2,
      iconIdx: 1,
    },
    {
      icon: {
        paths: [
          'M512 245.648c-147.084 0-266.352 119.249-266.352 266.352 0 147.084 119.249 266.352 266.352 266.352 147.084 0 266.352-119.249 266.352-266.352 0-147.084-119.249-266.352-266.352-266.352zM0 512c0-282.773 229.227-512 512-512s512 229.227 512 512-229.227 512-512 512-512-229.227-512-512z',
          'M512 245.648c-147.084 0-266.352 119.249-266.352 266.352 0 75.273 31.092 143.099 81.417 191.674 23.387 22.4 37.922 53.88 37.922 88.755 0 67.834-54.99 122.824-122.824 122.824-33.338 0-63.574-13.282-85.704-34.844l0.026 0.026c-96.534-93.069-156.486-223.516-156.486-367.965 0-0.165 0-0.33 0-0.496l-0 0.026c0-282.773 229.227-512 512-512s512 229.227 512 512c0 144.663-60.137 275.475-156.486 368.454-22.061 21.309-52.142 34.44-85.29 34.44-67.837 0-122.83-54.993-122.83-122.83 0-34.689 14.38-66.020 37.504-88.356l0.036-0.034c50.222-48.331 81.418-116.123 81.418-191.201 0-0.166-0-0.333-0-0.499l0 0.026c0-147.084-119.249-266.352-266.352-266.352z',
          'M512 245.648c-147.084 0-266.352 119.249-266.352 266.352 0 75.273 31.092 143.099 81.417 191.674 23.387 22.4 37.922 53.88 37.922 88.755 0 67.834-54.99 122.824-122.824 122.824-33.338 0-63.574-13.282-85.704-34.844l0.026 0.026c-96.534-93.069-156.486-223.516-156.486-367.965 0-0.165 0-0.33 0-0.496l-0 0.026c0-282.773 229.227-512 512-512 0.169-0 0.368-0 0.568-0 129.865 0 248.404 48.49 338.499 128.352l-0.533-0.463c25.557 22.617 41.587 55.498 41.587 92.123 0 67.836-54.992 122.828-122.828 122.828-31.211 0-59.702-11.641-81.37-30.818l0.13 0.113c-46.486-41.264-108.037-66.468-175.475-66.468-0.203 0-0.407 0-0.61 0.001l0.032-0z',
          'M899.109 799.223c0 68.965-55.907 124.872-124.872 124.872s-124.872-55.907-124.872-124.872c0-68.965 55.907-124.872 124.872-124.872s124.872 55.907 124.872 124.872z',
        ],
        attrs: [
          {
            fill: 'rgb(255, 255, 255)',
            opacity: 0.25,
          },
          {
            fill: 'rgb(255, 255, 255)',
            opacity: 0.5,
          },
          {
            fill: 'rgb(255, 255, 255)',
            opacity: 0.75,
          },
          {
            fill: 'rgb(255, 255, 255)',
          },
        ],
        isMulticolor: true,
        isMulticolor2: true,
        grid: 0,
        tags: ['cm-dat-logo'],
      },
      attrs: [
        {
          fill: 'rgb(255, 255, 255)',
          opacity: 0.25,
        },
        {
          fill: 'rgb(255, 255, 255)',
          opacity: 0.5,
        },
        {
          fill: 'rgb(255, 255, 255)',
          opacity: 0.75,
        },
        {
          fill: 'rgb(255, 255, 255)',
        },
      ],
      properties: {
        order: 3,
        id: 1,
        name: 'cm-dat-logo',
        prevSize: 32,
      },
      setIdx: 0,
      setId: 2,
      iconIdx: 0,
    },
    {
      icon: {
        paths: [
          'M874.102 149.899c-199.866-199.865-524.339-199.865-724.204 0s-199.865 524.338 0 724.204c199.864 199.862 524.338 199.862 724.204 0 199.862-199.866 199.862-525.571 0-724.204zM744.56 540.992c-7.405 7.402-18.506 12.339-29.61 12.339h-160.387v160.384c0 11.104-4.934 22.208-12.336 29.61s-18.506 12.339-29.61 12.339c-23.443 0-41.949-18.509-41.949-41.949v-160.384h-160.385c-23.441 0-41.947-18.506-41.947-41.949 0-23.44 18.506-41.946 41.947-41.946h160.385v-160.386c0-23.441 18.506-41.947 41.949-41.947 23.44 0 41.946 18.506 41.946 41.947v160.386h160.387c23.44 0 41.946 18.506 41.946 41.946-1.232 11.104-4.934 22.208-12.336 29.61z',
        ],
        attrs: [
          {
            fill: 'rgb(234, 40, 57)',
          },
        ],
        isMulticolor: false,
        isMulticolor2: false,
        grid: 16,
        tags: ['red-plus'],
      },
      attrs: [
        {
          fill: 'rgb(234, 40, 57)',
        },
      ],
      properties: {
        order: 2,
        id: 516,
        name: 'red-plus',
        prevSize: 32,
      },
      setIdx: 0,
      setId: 1,
      iconIdx: 0,
    },
    {
      icon: {
        paths: [
          'M563.825 182.858l-55.653-55.654c-109.971-109.972-288.271-109.972-398.242 0s-109.972 288.271 0 398.241l453.988 453.806 452.547-452.547c109.972-109.974 109.972-288.273 0-398.245-109.967-109.971-288.266-109.971-398.239 0l-54.4 54.398z',
        ],
        attrs: [{}],
        width: 1126,
        isMulticolor: false,
        isMulticolor2: false,
        grid: 16,
        tags: ['heart-solid'],
      },
      attrs: [{}],
      properties: {
        order: 33,
        id: 515,
        name: 'heart-solid',
        prevSize: 32,
      },
      setIdx: 0,
      setId: 1,
      iconIdx: 0,
    },
    {
      icon: {
        paths: [
          'M546.776 162.389l54.398-54.398c109.974-109.971 288.273-109.971 398.244 0s109.971 288.271 0 398.242l-452.55 452.551-453.988-453.807c-109.972-109.971-109.972-288.271 0-398.242s288.271-109.972 398.242 0l55.654 55.654zM545.519 812.619l252.737-252.736 74.281-71.733 0.075 0.074 54.395-54.398c69.98-69.982 69.98-183.445 0-253.427s-183.446-69.982-253.426 0l-126.751 126.751-0.371-0.371-0.055 0.055-127.691-127.691c-69.982-69.982-183.446-69.982-253.427 0s-69.982 183.445 0 253.427l130.019 130.019 0.092-0.092 250.122 250.123z',
        ],
        attrs: [{}],
        width: 1092,
        isMulticolor: false,
        isMulticolor2: false,
        grid: 0,
        tags: ['heart'],
        colorPermutations: {
          '1511511511165153119021401214711012148110123440571255255255140531151781141921271461': [{}],
        },
      },
      attrs: [{}],
      properties: {
        order: 44,
        id: 19,
        name: 'heart',
        prevSize: 32,
      },
      setIdx: 0,
      setId: 2,
      iconIdx: 0,
    },
    {
      icon: {
        paths: [
          'M142.442 51.909c-24.993-24.994-65.516-24.994-90.51 0s-24.994 65.516 0 90.51l369.583 369.583-369.579 369.579c-24.994 24.992-24.994 65.517 0 90.509s65.516 24.992 90.51 0l369.58-369.578 369.581 369.578c24.992 24.992 65.517 24.992 90.509 0s24.992-65.517 0-90.509l-369.58-369.579 369.58-369.583c24.998-24.994 24.998-65.516 0-90.51-24.992-24.994-65.51-24.994-90.509 0l-369.581 369.583-369.583-369.583z',
        ],
        attrs: [
          {
            fill: 'rgb(151, 151, 151)',
          },
        ],
        isMulticolor: false,
        isMulticolor2: false,
        grid: 0,
        tags: ['close'],
        colorPermutations: {
          '1511511511165153119021401214711012148110123440571255255255140531151781141921271461': [
            {
              f: 8,
            },
          ],
        },
      },
      attrs: [
        {
          fill: 'rgb(151, 151, 151)',
        },
      ],
      properties: {
        order: 43,
        id: 18,
        name: 'close',
        prevSize: 32,
      },
      setIdx: 0,
      setId: 2,
      iconIdx: 0,
    },
    {
      icon: {
        paths: [
          'M328.016 434.683c0 29.454-23.878 53.333-53.333 53.333-29.456 0-53.334-23.878-53.334-53.333 0-29.456 23.878-53.334 53.334-53.334 29.454 0 53.333 23.878 53.333 53.334z',
          'M434.683 488.016c29.454 0 53.333-23.878 53.333-53.333 0-29.456-23.878-53.334-53.333-53.334-29.456 0-53.334 23.878-53.334 53.334 0 29.454 23.878 53.333 53.334 53.333z',
          'M594.683 488.016c29.454 0 53.333-23.878 53.333-53.333 0-29.456-23.878-53.334-53.333-53.334-29.456 0-53.334 23.878-53.334 53.334 0 29.454 23.878 53.333 53.334 53.333z',
          'M736.381 132.984c153.875 153.876 165.648 396.042 35.318 563.428 0.816 0.722 1.614 1.472 2.394 2.251l226.274 226.275c20.829 20.827 20.829 54.597 0 75.424-20.827 20.829-54.597 20.829-75.424 0l-226.274-226.274c-0.781-0.781-1.531-1.578-2.251-2.392-167.387 130.334-409.557 118.563-563.434-35.315-166.624-166.622-166.624-436.773 0-603.397s436.773-166.624 603.397 0zM208.408 660.957c124.968 124.968 327.581 124.968 452.549 0s124.968-327.581 0-452.549c-124.968-124.967-327.581-124.967-452.549 0s-124.968 327.581 0 452.549z',
        ],
        attrs: [
          {
            fill: 'rgb(151, 151, 151)',
          },
          {
            fill: 'rgb(151, 151, 151)',
          },
          {
            fill: 'rgb(151, 151, 151)',
          },
          {
            fill: 'rgb(151, 151, 151)',
          },
        ],
        isMulticolor: false,
        isMulticolor2: false,
        grid: 0,
        tags: ['search-loading'],
        colorPermutations: {
          '1511511511165153119021401214711012148110123440571255255255140531151781141921271461': [
            {
              f: 8,
            },
            {
              f: 8,
            },
            {
              f: 8,
            },
            {
              f: 8,
            },
          ],
        },
      },
      attrs: [
        {
          fill: 'rgb(151, 151, 151)',
        },
        {
          fill: 'rgb(151, 151, 151)',
        },
        {
          fill: 'rgb(151, 151, 151)',
        },
        {
          fill: 'rgb(151, 151, 151)',
        },
      ],
      properties: {
        order: 42,
        id: 17,
        name: 'search-loading',
        prevSize: 32,
      },
      setIdx: 0,
      setId: 2,
      iconIdx: 0,
    },
    {
      icon: {
        paths: [
          'M244.513 14.769c107.051 0 197.001 73.218 222.506 172.308h466.723v114.872h-466.723c-25.505 99.089-115.455 172.309-222.506 172.309-126.884 0-229.743-102.861-229.743-229.745s102.86-229.743 229.743-229.743zM244.513 359.385c63.442 0 114.872-51.43 114.872-114.872s-51.43-114.872-114.872-114.872c-63.442 0-114.872 51.43-114.872 114.872s51.43 114.872 114.872 114.872z',
          'M818.873 991.181c-107.051 0-197.002-73.22-222.507-172.308h-466.725v-114.873h466.725c25.505-99.092 115.456-172.308 222.507-172.308 126.881 0 229.742 102.861 229.742 229.742 0 126.885-102.861 229.746-229.742 229.746zM818.873 876.308c63.441 0 114.869-51.428 114.869-114.873 0-63.441-51.428-114.869-114.869-114.869-63.445 0-114.873 51.428-114.873 114.869 0 63.445 51.428 114.873 114.873 114.873z',
        ],
        attrs: [
          {
            fill: 'rgb(92, 127, 146)',
          },
          {
            fill: 'rgb(92, 127, 146)',
          },
        ],
        width: 1063,
        isMulticolor: false,
        isMulticolor2: false,
        grid: 0,
        tags: ['options'],
        colorPermutations: {
          '165153119021401214711012148110123440571255255255140531151781141921271461': [
            {
              f: 6,
            },
            {
              f: 6,
            },
          ],
        },
      },
      attrs: [
        {
          fill: 'rgb(92, 127, 146)',
        },
        {
          fill: 'rgb(92, 127, 146)',
        },
      ],
      properties: {
        order: 41,
        id: 16,
        name: 'options',
        prevSize: 32,
      },
      setIdx: 0,
      setId: 2,
      iconIdx: 0,
    },
    {
      icon: {
        paths: [
          'M867.371 469.333v85.333h-547.371l138.368 138.368-60.331 60.331-241.365-241.365 241.365-241.365 60.331 60.331-138.368 138.368h547.413z',
        ],
        attrs: [{}],
        isMulticolor: false,
        isMulticolor2: false,
        grid: 0,
        tags: ['Back'],
        colorPermutations: {
          '165153119021401214711012148110123440571255255255140531151781141': [{}],
        },
      },
      attrs: [{}],
      properties: {
        order: 40,
        id: 15,
        name: 'Back',
        prevSize: 32,
      },
      setIdx: 0,
      setId: 2,
      iconIdx: 0,
    },
    {
      icon: {
        paths: [
          'M619.729 772.973c-20.564 46.377-35.987 97.908-82.253 144.288-61.689 61.838-143.942 82.45-210.773 82.45-190.211 0-318.732-149.442-318.732-345.261s123.38-350.415 329.012-350.415c164.507 0 262.182 103.063 262.182 190.667 0 46.379-35.985 72.144-71.971 72.144-66.831 0-66.831-51.531-66.831-77.296 0-20.613 0-46.379-5.14-66.992-15.422-56.685-66.831-82.45-118.24-82.45-164.505 0-174.787 206.125-174.787 309.188 0 139.135 35.986 309.19 200.491 309.19 41.127 0 66.831-10.306 82.253-15.458 97.676-41.225 128.522-128.829 149.084-180.361l25.704 10.306z',
          'M1324.022 649.298c0 206.125-138.802 350.413-318.731 350.413-174.789 0-318.731-139.133-318.731-345.261 0-237.046 159.367-355.567 323.871-355.567 179.929-5.154 313.591 139.135 313.591 350.415zM845.926 659.605c0 190.665 25.702 304.036 159.365 304.036 159.367 0 164.507-133.983 164.507-314.342 0-82.452-5.14-133.983-5.14-154.596-5.142-51.531-20.564-164.9-154.226-164.9-143.942 5.152-164.505 139.135-164.505 329.802z',
          'M1452.544 5.153c56.549 0 71.971 0 123.38-5.153v953.334h107.956v30.919h-370.138v-30.919h118.238v-912.109h-118.238v-36.072h138.802z',
          'M1982.046 5.153v30.919h-123.38v917.262h118.24v30.919h-370.14v-30.919h107.958v-953.334c51.407 5.153 66.829 5.153 123.38 5.153h143.942z',
          'M2660.633 953.334v30.919h-102.822c-15.42 0-30.84 0-51.401-5.154-82.261-10.306-97.682-61.838-102.822-92.756-25.7 36.073-77.101 108.217-221.043 108.217-25.72 0-87.401 0-128.522-46.379-20.56-20.613-51.413-66.992-51.413-154.594 0-51.531 10.272-97.91 46.273-133.981 41.121-41.227 77.101-46.379 200.483-72.146 82.261-15.458 118.242-30.919 164.503-46.377v-51.531c0-92.758-5.14-164.902-113.082-164.902-107.962 0-107.962 66.992-113.102 113.371 0 30.919-5.14 72.144-66.841 72.144-30.84 0-66.821 0-66.821-56.685 0-20.613 5.14-36.073 10.28-51.531 30.84-82.45 133.662-103.063 236.484-103.063 56.541 0 113.082 10.306 159.363 30.919 87.381 41.225 87.381 118.523 87.381 185.513v304.036c0 103.065 10.28 133.983 77.121 133.983h35.981zM2413.869 582.307l-123.382 36.071c-71.961 20.613-133.662 46.379-133.662 185.515 0 41.225 0 149.442 92.541 149.442 46.261 0 77.121-25.767 97.682-46.379 61.681-61.838 61.681-133.981 66.821-206.125v-118.523z',
          'M2748.035 5.153c56.541 0 77.101 0 133.662-5.153v407.098c25.7-41.225 71.961-103.063 200.483-103.063 92.541 0 169.643 36.073 215.923 128.829 35.981 77.298 46.261 154.594 46.261 221.586 0 226.738-113.102 355.567-267.324 355.567-25.7 0-56.541-5.152-87.381-15.458-66.841-25.767-87.401-66.992-102.822-97.91l5.14 97.91h-138.802v-958.487h-102.822v-30.919h97.682zM2933.097 386.486c-51.401 56.685-56.541 139.135-56.541 267.965 0 87.604 5.14 154.594 25.7 200.973 20.56 56.685 66.821 97.91 133.662 97.91 154.222 0 154.222-221.586 154.222-324.65 0-61.838-5.14-144.288-35.981-211.279-10.28-20.613-36.001-77.296-113.102-77.296-41.121 5.152-82.261 20.613-107.962 46.377z',
          'M4084.636 649.298c0 206.125-138.802 350.413-318.725 350.413-174.783 0-318.725-139.133-318.725-345.261 0-237.046 159.363-355.567 323.865-355.567 179.923-5.154 313.585 139.135 313.585 350.415zM3601.408 659.605c0 190.665 25.7 304.036 159.363 304.036 159.363 0 164.503-133.983 164.503-314.342 0-82.452-5.14-133.983-5.14-154.596-5.14-51.531-20.56-164.9-154.222-164.9-143.942 5.152-164.503 139.135-164.503 329.802z',
          'M4331.4 953.334h118.242v30.919h-370.146v-30.919h118.242v-608.073h-118.242v-30.919h128.522c51.421 0 71.981 0 128.522-5.152v159.748c36.001-72.146 82.261-170.054 190.223-170.054 92.521 0 123.382 72.144 123.382 128.827 0 51.533-20.58 92.758-71.981 92.758-20.56 0-66.821-15.46-66.821-72.144 0-10.306 5.14-51.533 5.14-61.84 0-41.225-25.72-41.225-36.001-41.225s-25.7 5.154-46.261 25.767c-92.541 92.756-97.682 237.044-102.822 355.567v226.74z',
          'M5333.855 953.334v30.919h-102.802c-20.56 0-30.861 0-51.421-5.154-82.241-10.306-97.661-61.838-102.802-92.756-25.72 36.073-77.121 108.217-221.064 108.217-25.7 0-87.401 0-128.522-46.379-20.56-20.613-51.401-66.992-51.401-154.594 0-51.531 10.28-97.91 46.261-133.981 41.121-41.227 77.121-46.379 200.483-72.146 82.261-15.458 118.242-30.919 164.523-46.377v-51.531c0-92.758-5.14-164.902-113.102-164.902s-107.962 66.992-113.102 113.371c0 30.919-5.14 72.144-66.821 72.144-30.861 0-66.841 0-66.841-56.685 0-20.613 5.14-36.073 10.28-51.531 30.84-82.45 133.662-103.063 236.484-103.063 56.541 0 113.102 10.306 159.363 30.919 87.401 41.225 87.401 118.523 87.401 185.513v304.036c0 103.065 10.28 133.983 77.101 133.983h35.981zM5087.112 582.307l-123.382 36.071c-71.981 20.613-133.662 46.379-133.662 185.515 0 41.225 0 149.442 92.521 149.442 46.281 0 77.121-25.767 97.682-46.379 61.701-61.838 61.701-133.981 66.841-206.125v-118.523z',
          'M5539.499 133.982l-5.14 185.514h149.082v41.225h-149.082l-5.14 463.784c0 46.377 0 128.829 77.101 128.829 46.281 0 77.121-36.073 97.682-82.452l30.84 15.46c-30.84 61.838-61.681 113.369-179.923 113.369-159.363 0-159.363-97.91-159.363-164.9l5.14-474.090h-107.962v-46.379h107.962l5.14-185.513h133.662v5.153z',
          'M6351.752 793.586c-41.121 97.91-97.682 206.125-293.025 206.125-61.701 0-149.082-5.152-226.204-87.602-77.101-82.452-92.541-185.515-92.541-262.811 0-36.073 5.14-66.992 10.28-97.91 15.44-61.838 46.281-128.829 92.541-170.054 51.401-51.531 128.522-82.45 215.923-82.45 92.521 0 159.363 36.071 210.763 82.45 77.121 77.298 82.261 159.748 87.401 226.738h-462.667c0 77.298 0 164.902 30.84 231.892 41.121 108.217 133.662 118.523 174.783 118.523 35.981 0 66.821-10.306 92.541-20.613 82.241-41.225 113.082-118.523 128.522-154.594l30.84 10.306zM6192.389 566.846c0-51.531-5.14-108.215-25.72-154.594-30.84-61.838-82.241-77.298-118.222-77.298-133.662 0-143.942 149.442-149.082 231.892h293.025z',
        ],
        attrs: [
          {
            fill: 'rgb(255, 255, 255)',
          },
          {
            fill: 'rgb(255, 255, 255)',
          },
          {
            fill: 'rgb(255, 255, 255)',
          },
          {
            fill: 'rgb(255, 255, 255)',
          },
          {
            fill: 'rgb(255, 255, 255)',
          },
          {
            fill: 'rgb(255, 255, 255)',
          },
          {
            fill: 'rgb(255, 255, 255)',
          },
          {
            fill: 'rgb(255, 255, 255)',
          },
          {
            fill: 'rgb(255, 255, 255)',
          },
          {
            fill: 'rgb(255, 255, 255)',
          },
          {
            fill: 'rgb(255, 255, 255)',
          },
        ],
        width: 6365,
        isMulticolor: false,
        isMulticolor2: false,
        grid: 16,
        tags: ['logo-text'],
      },
      attrs: [
        {
          fill: 'rgb(255, 255, 255)',
        },
        {
          fill: 'rgb(255, 255, 255)',
        },
        {
          fill: 'rgb(255, 255, 255)',
        },
        {
          fill: 'rgb(255, 255, 255)',
        },
        {
          fill: 'rgb(255, 255, 255)',
        },
        {
          fill: 'rgb(255, 255, 255)',
        },
        {
          fill: 'rgb(255, 255, 255)',
        },
        {
          fill: 'rgb(255, 255, 255)',
        },
        {
          fill: 'rgb(255, 255, 255)',
        },
        {
          fill: 'rgb(255, 255, 255)',
        },
        {
          fill: 'rgb(255, 255, 255)',
        },
      ],
      properties: {
        order: 31,
        id: 514,
        name: 'logo-text',
        prevSize: 32,
      },
      setIdx: 0,
      setId: 1,
      iconIdx: 0,
    },
    {
      icon: {
        paths: [
          'M349.905 330.606c-132.202 0-246.884 74.136-305.817 182.116 58.934 107.981 173.615 182.116 305.817 182.116s246.884-74.135 305.818-182.116c-60.527-109.591-175.209-182.116-305.818-182.116z',
          'M350.437 334.527c130.54 0 243.78 72.246 301.972 177.473 26.737-48.687 42.465-106.798 42.465-166.478 0-190.037-154.132-345.522-346.010-345.522s-346.010 153.914-346.010 345.522c0 61.252 15.728 117.791 42.465 166.478 61.338-106.798 174.578-177.473 305.118-177.473z',
          'M347.291 689.473c-130.54 0-243.78-72.246-301.972-177.473-26.737 48.687-42.465 106.798-42.465 166.479 0 190.037 154.132 345.521 346.010 345.521s346.010-153.913 346.010-345.521c0-61.252-15.728-117.792-42.465-166.479-62.911 105.227-176.151 177.473-305.119 177.473z',
        ],
        attrs: [
          {
            fill: 'rgb(76, 113, 137)',
          },
          {
            fill: 'rgb(73, 51, 18)',
          },
          {
            fill: 'rgb(255, 255, 255)',
          },
        ],
        width: 697,
        isMulticolor: true,
        isMulticolor2: false,
        grid: 16,
        tags: ['logo-v'],
      },
      attrs: [
        {
          fill: 'rgb(76, 113, 137)',
        },
        {
          fill: 'rgb(73, 51, 18)',
        },
        {
          fill: 'rgb(255, 255, 255)',
        },
      ],
      properties: {
        order: 30,
        id: 513,
        name: 'logo-v',
        prevSize: 32,
      },
      setIdx: 0,
      setId: 1,
      iconIdx: 0,
    },
    {
      icon: {
        paths: [
          'M353.319 327.828c-131.091 0-244.809 73.513-303.247 180.586 58.438 107.073 172.157 180.586 303.247 180.586 131.092 0 244.81-73.513 303.249-180.586-60.018-108.671-173.737-180.586-303.249-180.586z',
          'M353.847 331.716c129.443 0 241.731 71.639 299.434 175.981 26.513-48.278 42.108-105.899 42.108-165.079 0-188.44-152.837-342.618-343.102-342.618-190.266 0-343.103 152.62-343.103 342.618 0 60.737 15.596 116.801 42.108 165.079 60.823-105.899 173.111-175.981 302.554-175.981z',
          'M350.727 683.678c-129.443 0-241.731-71.638-299.435-175.981-26.512 48.278-42.108 105.9-42.108 165.080 0 188.44 152.836 342.618 343.103 342.618 190.265 0 343.102-152.62 343.102-342.618 0-60.737-15.595-116.802-42.107-165.080-62.382 104.344-174.671 175.981-302.555 175.981z',
        ],
        attrs: [
          {
            fill: 'rgb(225, 112, 0)',
          },
          {
            fill: 'rgb(255, 255, 255)',
          },
          {
            fill: 'rgb(73, 51, 18)',
          },
        ],
        width: 703,
        isMulticolor: true,
        isMulticolor2: false,
        grid: 16,
        tags: ['Grouplogo'],
      },
      attrs: [
        {
          fill: 'rgb(225, 112, 0)',
        },
        {
          fill: 'rgb(255, 255, 255)',
        },
        {
          fill: 'rgb(73, 51, 18)',
        },
      ],
      properties: {
        order: 26,
        id: 512,
        name: 'logo-alt',
        prevSize: 32,
      },
      setIdx: 0,
      setId: 1,
      iconIdx: 0,
    },
    {
      icon: {
        paths: [
          'M0 194.503v558.719c0 12.394 10.488 22.882 22.883 22.882h978.235c12.394 0 22.882-10.488 22.882-22.882v-558.719c0-12.394-10.488-22.882-22.882-22.882h-978.235c-12.395 0-22.883 10.488-22.883 22.882zM1001.118 473.862c0 28.603-22.883 51.486-51.487 51.486s-51.486-22.882-51.486-51.486c0-28.603 22.882-51.486 51.486-51.486 27.65 0 51.487 22.882 51.487 51.486zM869.542 226.919v492.931h-811.382v-492.931h811.382z',
          'M906.726 473.862c0 23.837 19.069 42.906 42.905 42.906 23.837 0 42.906-19.069 42.906-42.906 0-23.836-19.069-42.905-42.906-42.905-23.836 0-42.905 19.069-42.905 42.905z',
          'M791.359 0h-559.672c-12.394 0-21.929 10.488-21.929 22.883v978.235c0 12.394 10.488 22.882 22.882 22.882h558.719c12.394 0 22.882-10.488 22.882-22.882v-978.235c0-12.395-10.488-22.883-22.882-22.883zM512 1001.118c-28.603 0-51.486-22.883-51.486-51.487s22.882-51.486 51.486-51.486c28.603 0 51.486 22.882 51.486 51.486-0.953 27.65-23.836 51.487-51.486 51.487zM757.989 869.542h-492.932v-811.382h492.932v811.382z',
          'M512 906.727c-23.837 0-42.906 19.069-42.906 42.906 0 23.836 19.069 42.905 42.906 42.905 23.836 0 42.905-19.069 42.905-42.905-0.953-23.837-20.022-42.906-42.905-42.906z',
        ],
        attrs: [
          {
            fill: 'rgb(255, 255, 255)',
          },
          {
            fill: 'rgb(255, 255, 255)',
          },
          {
            fill: 'rgb(0, 165, 153)',
          },
          {
            fill: 'rgb(0, 165, 153)',
          },
        ],
        isMulticolor: true,
        isMulticolor2: false,
        grid: 0,
        tags: ['Phones'],
        colorPermutations: {
          '165153119021401214711012148110123440571255255255140531151781141': [
            {
              f: 7,
            },
            {
              f: 7,
            },
            {
              f: 4,
            },
            {
              f: 4,
            },
          ],
        },
      },
      attrs: [
        {
          fill: 'rgb(255, 255, 255)',
        },
        {
          fill: 'rgb(255, 255, 255)',
        },
        {
          fill: 'rgb(0, 165, 153)',
        },
        {
          fill: 'rgb(0, 165, 153)',
        },
      ],
      properties: {
        order: 37,
        id: 14,
        name: 'Phones',
        prevSize: 32,
      },
      setIdx: 0,
      setId: 2,
      iconIdx: 0,
    },
    {
      icon: {
        paths: [
          'M15.019 645c0-86.82 65.115-158.615 148.596-168.632-5.009-20.036-6.679-40.072-6.679-61.776 1.67-156.945 130.23-287.174 288.843-287.174 41.742 0 81.812 8.348 116.875 25.044 50.089-85.15 141.917-141.917 248.773-141.917 93.499 0 175.309 43.41 228.738 111.865 28.383-21.705 65.114-35.062 103.516-35.062 88.49 0 160.283 66.785 168.632 151.935 8.349 0 15.027-1.67 23.374-1.67 158.615 0 288.843 128.562 288.843 288.845s-128.559 288.845-288.843 288.845h-1155.376c-91.829-3.34-165.292-76.803-165.292-170.302z',
          'M2472.704 855.374c0-86.82-65.114-158.613-150.272-168.63 5.015-20.036 6.686-40.072 6.686-61.777 0-158.613-128.572-288.843-288.858-288.843-41.728 0-81.8 8.349-116.872 25.044-50.086-85.15-141.914-141.917-248.772-141.917-93.5 0-175.306 43.41-228.734 111.864-28.383-21.706-65.114-35.063-103.516-35.063-88.49 0-160.283 66.786-168.632 151.936-8.347 0-15.026-1.67-23.374-1.67-158.613 0-288.843 128.562-288.843 288.845 0 158.613 128.56 288.843 288.843 288.843h1155.372c93.5-1.669 166.972-76.802 166.972-168.632z',
        ],
        attrs: [
          {
            fill: 'rgb(255, 255, 255)',
          },
          {
            fill: 'rgb(234, 40, 57)',
          },
        ],
        width: 2485,
        isMulticolor: true,
        isMulticolor2: false,
        grid: 0,
        tags: ['Clouds'],
        colorPermutations: {
          '165153119021401214711012148110123440571255255255140531151781141': [
            {
              f: 7,
            },
            {
              f: 6,
            },
          ],
        },
      },
      attrs: [
        {
          fill: 'rgb(255, 255, 255)',
        },
        {
          fill: 'rgb(234, 40, 57)',
        },
      ],
      properties: {
        order: 38,
        id: 13,
        name: 'Clouds',
        prevSize: 32,
      },
      setIdx: 0,
      setId: 2,
      iconIdx: 1,
    },
    {
      icon: {
        paths: [
          'M1033.062 553.7v-10.253c0-42.296-33.324-76.902-75.621-78.184v-16.662h12.817c7.69 0 14.099-6.409 14.099-14.099v-151.243c0-7.69-6.409-14.098-14.099-14.098h-183.285c-7.69 0-14.099 6.408-14.099 14.098v148.68c0 7.689 6.409 14.098 14.099 14.098h12.817v16.662c-21.788 1.282-41.015 10.254-55.114 25.634v-82.030c0-24.353-19.225-43.578-43.578-43.578h-58.959v-16.662h12.817c7.69 0 14.099-6.409 14.099-14.099v-149.96c0-7.69-6.409-14.099-14.099-14.099h-184.566c-7.69 0-14.099 6.409-14.099 14.099v148.679c0 7.69 6.409 14.099 14.099 14.099h12.817v19.225h-58.959c-24.353 0-43.578 19.226-43.578 43.579v41.015h248.652v490.896h-247.37v39.733c0 24.353 19.225 43.578 43.578 43.578h275.569c19.226 0 34.606-11.535 41.015-28.197 14.099 17.944 35.889 28.197 61.523 28.197h151.242c43.579 0 79.467-35.888 79.467-79.467v-25.634h-205.074v-364.007h203.793z',
          'M599.843 907.454h-143.552v-105.101c74.339-61.523 123.044-165.342 123.044-283.259 0-152.524-82.030-281.978-196.102-325.555-1.282-1.282-1.282-1.282-2.563-2.564-1.282-1.282-1.282-1.282-2.564-2.563-15.38-10.253-33.324-17.944-53.831-17.944-1.282 0-2.563 0-2.563 0l11.535-67.931-16.662-2.563 6.409-35.888 32.043 5.127 6.408-41.015-178.157-28.198-6.409 41.015 32.043 5.127-6.409 35.888-16.662-2.563-52.551 322.992 23.071 3.846v85.874l74.339 11.536 26.917-82.030 23.070 3.845 11.536-74.339c10.253 3.846 20.507 6.409 32.043 6.409 14.099 0 28.197-3.846 39.733-8.972 52.55 29.479 89.72 94.846 89.72 170.468 0 79.467-39.733 147.397-97.41 174.313h-302.485v73.058h170.468v140.989h-215.328c-5.127 0-8.972 5.126-8.972 10.253v94.846c0 6.409 3.845 10.254 8.972 10.254h590.871c5.126 0 8.972-5.127 8.972-10.254v-93.565c0-6.409-3.846-11.535-8.972-11.535z',
        ],
        attrs: [
          {
            fill: 'rgb(255, 255, 255)',
          },
          {
            fill: 'rgb(190, 214, 0)',
          },
        ],
        width: 1034,
        isMulticolor: true,
        isMulticolor2: false,
        grid: 0,
        tags: ['Microscopes'],
        colorPermutations: {
          '165153119021401214711012148110123440571255255255140531151781141': [
            {
              f: 7,
            },
            {
              f: 5,
            },
          ],
        },
      },
      attrs: [
        {
          fill: 'rgb(255, 255, 255)',
        },
        {
          fill: 'rgb(190, 214, 0)',
        },
      ],
      properties: {
        order: 39,
        id: 12,
        name: 'Microscopes',
        prevSize: 32,
      },
      setIdx: 0,
      setId: 2,
      iconIdx: 2,
    },
    {
      icon: {
        paths: [
          'M816.758 282.35c0 0-18.69 10.785-12.94 25.884 0 0 19.41 5.752 27.322 20.132s69.025 66.149 69.025 66.149l44.578-22.289c0 0-15.504-20.702-64.558-35.157 0 0-28.915-30.992-38.98-36.744s-24.447-17.975-24.447-17.975z',
          'M816.758 282.35c0 0-18.69 10.785-12.94 25.884 0 0 19.41 5.752 27.322 20.132s69.025 66.149 69.025 66.149l44.578-22.289c0 0-15.504-20.702-64.558-35.157 0 0-28.915-30.992-38.98-36.744s-24.447-17.975-24.447-17.975z',
          'M170.438 970.631c-9.598 2.374-19.64-0.402-29.526-0.516s-21.421 4.035-23.844 13.623c-3.255 12.872 11.796 22.581 24.683 25.79 50.017 12.447 102.965-3.709 154.085 2.882 21.542 2.776 42.491 9.573 64.151 11.196 49.577 3.709 98.017-19.873 147.662-17.211 24.871 1.327 49.046 9.224 73.92 10.498 59.516 3.026 118.233-31.911 176.496-19.395 16.452 3.542 31.895 10.748 48.203 14.92 41.21 10.551 84.598 1.145 126.081-8.26 8.245-1.874 18.174-5.507 19.191-13.896 1.115-9.254-9.504-15.057-18.349-18.015-96.666-32.328-200.159-49.455-300.987-34.513-22.945 3.406-45.824 8.457-69.018 8.124-51.334-0.743-98.506-27.519-148.902-37.312-95.494-18.561-190.971 24.735-278.635 66.909z',
          'M302.791 696.292h-29.233v247.153c0 0 188.69 61.129 372.064 0v-247.153h-342.831z',
          'M456.932 725.525c101.275 0 183.375-12.494 183.375-27.904s-82.1-27.905-183.375-27.905c-101.274 0-183.374 12.494-183.374 27.905s82.1 27.904 183.374 27.904z',
          'M456.932 725.525c101.275 0 183.375-12.494 183.375-27.904s-82.1-27.905-183.375-27.905c-101.274 0-183.374 12.494-183.374 27.905s82.1 27.904 183.374 27.904z',
          'M670.093 400.995c-46.259 171.002-204.708 276.908-204.708 276.908s-83.448-171.343-37.188-342.345c46.259-171.003 204.708-276.909 204.708-276.909s83.448 171.344 37.188 342.346z',
          'M249.261 400.995c46.26 171.002 204.708 276.908 204.708 276.908s83.448-171.343 37.188-342.345c-46.259-171.003-204.707-276.909-204.707-276.909s-83.448 171.344-37.189 342.346z',
          'M317.237 364.245c126.936 123.567 142.441 313.518 142.441 313.518s-190.3-10.39-317.237-133.957c-126.936-123.567-142.441-313.519-142.441-313.519s190.3 10.39 317.237 133.958z',
          'M602.118 364.245c-126.937 123.567-142.441 313.518-142.441 313.518s190.3-10.39 317.235-133.957c126.938-123.567 142.442-313.519 142.442-313.519s-190.301 10.39-317.237 133.958z',
          'M459.589 116.935c32.291 0 58.467-26.177 58.467-58.468s-26.176-58.467-58.467-58.467c-32.291 0-58.467 26.177-58.467 58.467s26.176 58.468 58.467 58.468z',
          'M109.472 472.52c4.145 15.043 18.549 24.194 18.549 24.194s7.682-15.238 3.536-30.281c-4.146-15.043-18.549-24.194-18.549-24.194s-7.682 15.238-3.536 30.281z',
          'M187.069 556.297c-4.462 14.953 2.895 30.349 2.895 30.349s14.593-8.846 19.056-23.798c4.462-14.952-2.896-30.349-2.896-30.349s-14.593 8.846-19.055 23.798z',
          'M746.765 652.484c-10.952 11.115-11.673 28.164-11.673 28.164s17.037-0.97 27.993-12.085c10.945-11.115 11.666-28.164 11.666-28.164s-17.034 0.971-27.986 12.085z',
          'M933.243 895.666c0 0 2.154 31.638 5.75 35.233s-32.358 5.75-32.358 5.75l5.037-40.983h21.572z',
          'M933.243 895.666c0 0 2.154 31.638 5.75 35.233s-32.358 5.75-32.358 5.75l5.037-40.983h21.572z',
          'M941.147 920.113c0 0-5.029 0-23.006 9.345 0 0-12.227-2.154-17.256-19.41 0 0-15.102 25.881-25.168 27.322-10.066 1.434-29.476 2.875-16.536 20.131s89.156 9.345 89.156 9.345c0 0 2.162-41.703-7.191-46.732z',
          'M941.147 920.113c0 0-5.029 0-23.006 9.345 0 0-12.227-2.154-17.256-19.41 0 0-15.102 25.881-25.168 27.322-10.066 1.434-29.476 2.875-16.536 20.131s89.156 9.345 89.156 9.345c0 0 2.162-41.703-7.191-46.732z',
          'M930.361 944.56l-5.029 13.661-33.079-9.345 1.889-13.562 0.455-3.277 1.252-9.049c0 0 28.042-7.191 28.042-3.595 0.379 2.966 0.994 5.894 1.843 8.761 1.153 4.422 2.594 9.459 3.565 12.773 0.637 2.192 1.062 3.633 1.062 3.633z',
          'M912.316 757.040c-2.26 3.83-4.832 11.021-0.061 20.009 1.411 2.602 3.148 5.006 5.166 7.168 15.823 17.256 20.131 56.085 20.131 56.085v62.555l-28.042 2.154-25.881-106.413c0 0-15.102-77.653-7.911-91.313s13.661-99.224 13.661-99.224l20.131-20.851h40.99c3.277 2.352 6 5.396 7.972 8.916 6.88 11.389 13.054 35.073-5.818 78.803-29.484 68.306-38.108 79.091-38.108 79.091-0.857 0.919-1.6 1.932-2.23 3.020v0z',
          'M912.316 757.040c-2.26 3.83-4.832 11.021-0.061 20.009 1.411 2.602 3.148 5.006 5.166 7.168 15.823 17.256 20.131 56.085 20.131 56.085v62.555l-28.042 2.154-25.881-106.413c0 0-15.102-77.653-7.911-91.313s13.661-99.224 13.661-99.224l20.131-20.851h40.99c3.277 2.352 6 5.396 7.972 8.916 6.88 11.389 13.054 35.073-5.818 78.803-29.484 68.306-38.108 79.091-38.108 79.091-0.857 0.919-1.6 1.932-2.23 3.020v0z',
          'M925.734 928.154l-31.137 3.891 1.252-9.057c0 0 28.042-7.191 28.042-3.595 0.379 2.966 0.994 5.894 1.843 8.761z',
          'M910.23 664.864c0 0 1.79 56.601 2.086 92.177 0.068 8.046 0.061 15.017-0.061 20.008 0.038 2.64-0.159 5.279-0.584 7.889-2.162 6.47 2.154 20.852 2.154 20.852 17.977 47.453 12.94 89.156 12.94 89.156v31.638l-34.513 4.316c0 0 5.757-4.316-10.066-46.019-9.087-23.954-11.059-47.43-11.082-63.078-0.083-8.564-1.798-17.036-5.052-24.955-0.994-2.67-1.616-5.469-1.836-8.313-1.441-14.382-7.911-32.355-7.911-32.355s-17.256-51.050-21.572-88.439c-1.995-17.796-1.654-35.777 1.001-53.487 0.637-4.502 1.502-8.967 2.594-13.381 0 0 70.292-44.233 96.832-13.661 2.549 2.991 4.574 6.395 5.985 10.066 1.464 3.627 2.594 7.376 3.398 11.202 8.26 40.574-34.315 56.385-34.315 56.385z',
          'M908.076 349.937c20.252 0 36.667-16.417 36.667-36.67s-16.414-36.669-36.667-36.669c-20.252 0-36.667 16.417-36.667 36.669s16.414 36.67 36.667 36.67z',
          'M887.945 336.276c0 0 15.095 42.422 0 64.711-15.102 22.29 48.174 15.1 48.174 15.1l24.447-29.48c0 0-28.763 0-30.204-50.331-1.434-50.331-42.416 0-42.416 0z',
          'M960.565 604.466c-5.219 1.803-10.574 3.146-16.020 4.012-8.951 1.381-19.517 1.431-25.683-4.012-3.664-3.228-12.675-3.624-23.514-2.589-22.824 2.186-53.711 10.699-59.612 12.374 0.637-4.502 1.502-8.968 2.594-13.381 0 0 70.292-44.233 96.832-13.661h15.337c3.277 2.352 6 5.396 7.972 8.916 1.32 5.724 2.094 8.341 2.094 8.341z',
          'M930.361 944.56l-5.029 13.661-33.079-9.345 1.889-13.562c5.681 12.569 15.368 14.275 15.368 14.275 10.46-5.431 16.536-7.707 19.79-8.662 0.637 2.192 1.062 3.633 1.062 3.633z',
          'M932.523 940.965c0 0-5.037 0-23.013 9.345 0 0-12.22-2.154-17.256-19.41 0 0-15.095 25.881-25.16 27.322-10.066 1.434-29.484 2.875-16.536 20.131 12.94 17.256 89.156 9.345 89.156 9.345s2.154-41.703-7.191-46.732z',
          'M761.939 320.291c0 0 1.403-28.004 30.834-25.262 0.827 0.077 1.616 0.358 2.306 0.815s1.252 1.077 1.646 1.806c0.394 0.728 0.599 1.543 0.607 2.37 0 0.828-0.205 1.643-0.592 2.374l-6.030 11.358-28.771 6.538z',
          'M931.802 395.235c0 0-35.233-5.752-44.578-12.943 0 0-7.191 13.662-20.131 6.472s-43.145-6.472-43.145-6.472c0 0-25.16-13.661-30.197-44.578 0 0-5.029-18.694-3.595-23.727 0 0-18.69-19.414-28.042 6.471 3.595 17.975 6.47 16.537 5.757 30.917l11.499 31.636c0 0 0.721 10.785 21.572 25.165s44.578 36.67 44.578 36.67c0 0-12.584 6.83-7.911 38.107 5.712 38.229-2.875 92.752-2.875 92.752v35.232c0 0 71.9-20.852 84.127-10.066 12.22 10.785 41.703 0 41.703 0s-3.595-12.223-8.632-41.703c-5.029-29.479 0.721-58.24 0.721-58.24s18.697-49.612 27.322-69.744c8.632-20.132-6.47-47.454-21.572-57.521-15.095-10.066-20.723-4.022-20.723-4.022s26.48 19.122-5.879 25.593z',
          'M868.42 304.3c-0.015 1.497 0.235 2.983 0.743 4.393 0.834 1.604 1.98 3.026 3.368 4.189 5.385 5.262 10.111 11.515 12.007 18.801 1.282 4.933 1.214 10.103 1.138 15.199-0.319 20.645-1.183 42.928-13.934 59.167-4.688 5.968-10.71 10.714-16.369 15.764-0.789 0.58-1.388 1.383-1.722 2.304-0.159 0.982 0.030 1.987 0.531 2.845 2.632 5.465 8.169 8.817 13.418 11.859 2.397 1.39 4.923 2.819 7.691 2.909 6.538 0.212 10.862-6.695 16.809-9.411 8.662-3.955 18.379 1.55 26.981 5.643 6.227 2.964 12.758 5.241 19.479 6.792 9.201 2.123 19.608 2.645 27.352-2.756 4.483-3.155 7.54-7.944 8.518-13.334 0.622-3.513 0.531-7.592 3.186-9.971 1.373-1.226 3.239-1.735 4.726-2.821 2.298-1.685 3.391-4.52 4.369-7.197l8.859-24.217c1.145-2.558 1.737-5.33 1.729-8.133-0.425-5.831-5.803-10.064-11.203-12.306-5.393-2.242-11.37-3.347-16.119-6.758-8.025-5.769-10.505-16.542-11.226-26.402-0.493-6.772-0.448-13.572 0.144-20.337 0.88-10.031 2.837-20.711-1.623-29.738-4.763-9.64-15.459-14.562-25.357-18.762-3.8-1.613-7.707-3.25-11.833-3.432-4.361-0.193-8.617 1.258-12.743 2.69-6.561 2.275-13.221 5.221-19.995 6.764-3.8 0.867-7.972 0.218-11.643 1.594-13.479 5.057-7.282 23.806-7.282 34.661z',
          'M868.42 302.862c-0.015 1.497 0.235 2.983 0.743 4.393 0.834 1.604 1.98 3.026 3.368 4.19 5.385 5.261 10.111 11.514 12.007 18.801 1.282 4.933 1.214 10.103 1.138 15.199-0.319 20.645-1.183 42.928-13.934 59.167-4.688 5.968-10.71 10.714-16.369 15.764-0.789 0.581-1.388 1.383-1.722 2.304-0.159 0.982 0.030 1.987 0.531 2.845 2.632 5.465 8.169 8.817 13.418 11.859 2.397 1.39 4.923 2.819 7.691 2.909 6.538 0.212 10.862-6.694 16.809-9.411 8.662-3.955 18.379 1.55 26.981 5.643 6.227 2.964 12.758 5.241 19.479 6.793 9.201 2.123 19.608 2.644 27.352-2.756 4.483-3.155 7.54-7.944 8.518-13.334 0.622-3.513 0.531-7.592 3.186-9.971 1.373-1.226 3.239-1.735 4.726-2.821 2.298-1.685 3.391-4.519 4.369-7.197l8.859-24.217c1.145-2.558 1.737-5.33 1.729-8.133-0.425-5.831-5.803-10.064-11.203-12.306-5.393-2.241-11.37-3.347-16.119-6.758-8.025-5.769-10.505-16.542-11.226-26.402-0.493-6.772-0.448-13.572 0.144-20.336 0.88-10.031 2.837-20.712-1.623-29.738-4.763-9.641-15.459-14.563-25.357-18.763-3.8-1.613-7.707-3.249-11.833-3.432-4.361-0.193-8.617 1.258-12.743 2.689-6.561 2.276-13.221 5.221-19.995 6.764-3.8 0.867-7.972 0.218-11.643 1.595-13.479 5.056-7.282 23.805-7.282 34.661z',
          'M839.422 499.083c0 0 5.742-1.39 34.497-5.704 28.763-4.314 79.091 5.753 79.091 5.753z',
          'M49.142 617.313c4.146 15.043 18.549 24.194 18.549 24.194s7.682-15.238 3.536-30.281c-4.146-15.043-18.549-24.194-18.549-24.194s-7.682 15.238-3.536 30.281z',
        ],
        attrs: [
          {
            fill: 'rgb(203, 205, 218)',
          },
          {
            fill: 'rgb(0, 0, 0)',
            opacity: 0.05,
          },
          {
            fill: 'rgb(225, 112, 0)',
            opacity: 0.1,
          },
          {
            fill: 'rgb(63, 61, 86)',
          },
          {
            fill: 'rgb(63, 61, 86)',
          },
          {
            fill: 'rgb(0, 0, 0)',
            opacity: 0.1,
          },
          {
            fill: 'rgb(63, 61, 86)',
          },
          {
            fill: 'rgb(225, 112, 0)',
          },
          {
            fill: 'rgb(63, 61, 86)',
          },
          {
            fill: 'rgb(63, 61, 86)',
          },
          {
            fill: 'rgb(225, 112, 0)',
          },
          {
            fill: 'rgb(225, 112, 0)',
          },
          {
            fill: 'rgb(225, 112, 0)',
          },
          {
            fill: 'rgb(225, 112, 0)',
          },
          {
            fill: 'rgb(255, 185, 185)',
          },
          {
            fill: 'rgb(0, 0, 0)',
            opacity: 0.05,
          },
          {
            fill: 'rgb(203, 205, 218)',
          },
          {
            fill: 'rgb(0, 0, 0)',
            opacity: 0.05,
          },
          {
            fill: 'rgb(255, 185, 185)',
          },
          {
            fill: 'rgb(76, 76, 120)',
          },
          {
            fill: 'rgb(0, 0, 0)',
            opacity: 0.05,
          },
          {
            fill: 'rgb(0, 0, 0)',
            opacity: 0.1,
          },
          {
            fill: 'rgb(76, 76, 120)',
          },
          {
            fill: 'rgb(255, 185, 185)',
          },
          {
            fill: 'rgb(255, 185, 185)',
          },
          {
            fill: 'rgb(0, 0, 0)',
            opacity: 0.1,
          },
          {
            fill: 'rgb(0, 0, 0)',
            opacity: 0.1,
          },
          {
            fill: 'rgb(203, 205, 218)',
          },
          {
            fill: 'rgb(255, 185, 185)',
          },
          {
            fill: 'rgb(203, 205, 218)',
          },
          {
            fill: 'rgb(0, 0, 0)',
            opacity: 0.1,
          },
          {
            fill: 'rgb(185, 107, 107)',
          },
          {
            fill: 'rgb(0, 0, 0)',
            opacity: 0.05,
          },
          {
            fill: 'rgb(225, 112, 0)',
          },
        ],
        width: 1001,
        isMulticolor: true,
        isMulticolor2: true,
        grid: 16,
        tags: ['Grow'],
      },
      attrs: [
        {
          fill: 'rgb(203, 205, 218)',
        },
        {
          fill: 'rgb(0, 0, 0)',
          opacity: 0.05,
        },
        {
          fill: 'rgb(225, 112, 0)',
          opacity: 0.1,
        },
        {
          fill: 'rgb(63, 61, 86)',
        },
        {
          fill: 'rgb(63, 61, 86)',
        },
        {
          fill: 'rgb(0, 0, 0)',
          opacity: 0.1,
        },
        {
          fill: 'rgb(63, 61, 86)',
        },
        {
          fill: 'rgb(225, 112, 0)',
        },
        {
          fill: 'rgb(63, 61, 86)',
        },
        {
          fill: 'rgb(63, 61, 86)',
        },
        {
          fill: 'rgb(225, 112, 0)',
        },
        {
          fill: 'rgb(225, 112, 0)',
        },
        {
          fill: 'rgb(225, 112, 0)',
        },
        {
          fill: 'rgb(225, 112, 0)',
        },
        {
          fill: 'rgb(255, 185, 185)',
        },
        {
          fill: 'rgb(0, 0, 0)',
          opacity: 0.05,
        },
        {
          fill: 'rgb(203, 205, 218)',
        },
        {
          fill: 'rgb(0, 0, 0)',
          opacity: 0.05,
        },
        {
          fill: 'rgb(255, 185, 185)',
        },
        {
          fill: 'rgb(76, 76, 120)',
        },
        {
          fill: 'rgb(0, 0, 0)',
          opacity: 0.05,
        },
        {
          fill: 'rgb(0, 0, 0)',
          opacity: 0.1,
        },
        {
          fill: 'rgb(76, 76, 120)',
        },
        {
          fill: 'rgb(255, 185, 185)',
        },
        {
          fill: 'rgb(255, 185, 185)',
        },
        {
          fill: 'rgb(0, 0, 0)',
          opacity: 0.1,
        },
        {
          fill: 'rgb(0, 0, 0)',
          opacity: 0.1,
        },
        {
          fill: 'rgb(203, 205, 218)',
        },
        {
          fill: 'rgb(255, 185, 185)',
        },
        {
          fill: 'rgb(203, 205, 218)',
        },
        {
          fill: 'rgb(0, 0, 0)',
          opacity: 0.1,
        },
        {
          fill: 'rgb(185, 107, 107)',
        },
        {
          fill: 'rgb(0, 0, 0)',
          opacity: 0.05,
        },
        {
          fill: 'rgb(225, 112, 0)',
        },
      ],
      properties: {
        order: 25,
        id: 511,
        name: 'Grow',
        prevSize: 32,
      },
      setIdx: 0,
      setId: 1,
      iconIdx: 0,
    },
    {
      icon: {
        paths: [
          'M279.327 171.952c27.478 0 49.754-22.275 49.754-49.753s-22.275-49.754-49.754-49.754c-27.478 0-49.754 22.275-49.754 49.754s22.275 49.753 49.754 49.753zM127.791 721.189l30.568-106.010 10.406 3.252s-12.357 79.345-31.868 99.506l-9.105 3.252z',
          'M244.207 152.116s3.903 41.624-5.203 53.331c-9.105 11.706 5.853 34.469 5.853 34.469l27.315 32.518 40.323-18.211 5.853-33.819-3.902-23.414s-13.658-13.657-7.804-38.371c5.853-24.714-62.436-6.504-62.436-6.504z',
          'M244.207 152.116s3.903 41.624-5.203 53.331c-9.105 11.706 5.853 34.469 5.853 34.469l27.315 32.518 40.323-18.211 5.853-33.819-3.902-23.414s-13.658-13.657-7.804-38.371c5.853-24.714-62.436-6.504-62.436-6.504z',
          'M267.621 930.611v26.662l35.77 7.153-3.253-44.222-32.518 10.407zM374.932 920.204l-7.806 37.069 15.61 11.059 27.316-20.161-3.252-31.873-31.868 3.906z',
          'M306.642 961.172s-13.658-23.082-39.022-8.617c0 0-4.553 25.532-9.105 27.481s-29.917 39.018 0 42.272c29.917 3.254 44.875-6.501 44.875-6.501s-5.853 5.037 3.252 2.435c9.105-2.602 5.203-16.915 5.203-16.915l-5.203-40.156zM395.743 945.569s-20.161 14.306-23.413 7.805c-3.252-6.508-8.455-5.856-8.455-5.856s-18.21 68.646-6.504 71.9c7.538 1.858 15.456 1.449 22.763-1.176 0 0 15.609-10.93 15.609-2.48 0 8.457 43.575 7.851 61.785 7.198s8.455-14.306 8.455-14.306l-24.064-23.415-27.316-39.671s-12.357-11.059-18.861 0zM203.884 510.469l27.316 262.097s14.959 159.994 17.56 162.596c2.602 2.602 19.511 11.052 56.582 0l-8.455-209.421 15.609-130.074 35.771 89.751s8.454 241.286 14.308 241.286 41.624 11.704 50.078-2.602c8.455-14.306 7.154-168.444 7.154-168.444s-3.903-243.238-32.518-251.043c-28.617-7.804-183.404 5.853-183.404 5.853z',
          'M279.327 176.18c24.784 0 44.875-20.092 44.875-44.875s-20.092-44.875-44.875-44.875-44.875 20.092-44.875 44.875 20.092 44.875 44.875 44.875z',
          'M281.928 256.174s-4.553-27.966-4.553-33.168c0-5.203-20.161-8.454-20.161-8.454s-15.609-17.56-18.861-14.959c-3.252 2.602-52.68 35.77-60.484 40.323s-16.259 24.064-15.609 25.364c0.651 1.301 40.974 85.849 40.974 85.849s17.56 52.030 5.203 79.345c-12.357 27.316-27.966 81.296-5.203 92.353s133.326 35.119 153.487 14.308c20.161-20.811 34.469-26.665 39.673-26.665s-21.462-90.402-15.609-98.856c5.853-8.454-2.602-61.135-2.602-61.135l29.917-83.897s-2.601-46.826-61.785-57.232l-35.406-17.167-28.98 63.993z',
          'M160.309 522.176s-3.252 31.218-3.252 40.324c0 9.104-15.609 62.435 7.154 68.939s20.812-70.89 20.812-70.89v-39.672l-24.714 1.3zM430.212 492.91s3.903 29.917 1.952 36.42c-1.952 6.504 18.861 63.086-9.105 66.338s-20.812-67.639-20.812-67.639v-35.119h27.966z',
          'M154.456 710.783l18.861-100.157h5.853c3.938 5.037 6.7 11.176 7.771 17.881l0.030 0.225c0.297 1.816 0.466 3.909 0.466 6.041 0 4.873-0.885 9.539-2.503 13.847l0.089-0.272c-7.804 22.112-14.308 62.435-14.308 62.435h-16.26z',
          'M172.016 257.476l-9.756 7.804s-13.007 206.817-9.755 222.426c3.252 15.609-11.707 37.721 1.301 39.672s28.616 10.406 35.77 5.203c7.154-5.203 8.454-24.064 11.056-28.617s7.154-58.533 7.154-58.533 13.657-53.981 5.203-94.304c-8.455-40.323-16.26-81.296-16.26-81.296l-24.713-12.357zM378.183 241.216l29.917 25.365 22.763 132.675s14.309 103.409 3.252 104.71c-11.056 1.301-27.966-1.951-35.119 0s-13.008-3.252-13.008-3.252-7.804-41.624-7.804-42.274c0-0.651-5.203-48.127-5.203-48.127l-6.504-53.331 9.755-58.533 1.951-57.232z',
          'M237.053 855.161s-4.227 12.144-10.055 28.68c-2.706 7.684-5.756 16.331-8.897 25.145-2.022 5.696-4.077 11.461-6.1 17.097-3.226 9.004-6.361 17.658-9.098 25.084-3.617 9.8-6.55 17.484-8.124 21.064-7.154 16.263-137.878-9.755-148.284-16.263-10.406-6.501-13.007-28.611-14.308-59.832-0.007-0.159-0.013-0.326-0.013-0.485-0.169-6.303 1.437-15.686 4.123-26.7 1.34-5.499 2.953-11.408 4.748-17.537 2.406-8.23 5.138-16.854 7.993-25.441 12.266-36.872 26.724-72.916 26.724-72.916s25.365-17.56 34.47-29.267c9.105-11.707 59.183-20.811 59.183-20.811 14.308 0.65 46.826 55.934 59.834 72.841s7.804 79.341 7.804 79.341z',
          'M164.212 756.31c3.232 0 5.853-2.621 5.853-5.853s-2.621-5.853-5.853-5.853c-3.233 0-5.853 2.621-5.853 5.853s2.621 5.853 5.853 5.853zM173.317 760.21c1.795 0 3.252-1.456 3.252-3.251s-1.456-3.252-3.252-3.252c-1.796 0-3.253 1.456-3.253 3.252s1.456 3.251 3.253 3.251z',
          'M226.998 883.841c-2.706 7.684-5.756 16.331-8.897 25.145l-177.056-57.572c2.406-8.23 5.138-16.854 7.993-25.441l177.961 57.867zM212.001 926.083c-3.226 9.004-6.361 17.658-9.099 25.084l-170.728-55.516c-0.169-6.303 1.437-15.686 4.123-26.7l175.704 57.132z',
          'M164.212 751.756s13.007 57.234 5.203 107.964c-7.804 50.73 19.511 98.205 19.511 98.205',
          'M173.316 756.309s-25.364 92.352-26.014 105.36c-0.651 13.009-11.057 106.011-24.064 115.765',
          'M244.875 103.92s-10.157-26.41 4.572-35.044l4.063 11.681s37.076-22.347 46.726-17.268l-9.142 12.189s43.171 0 46.218 16.761l-15.236 0.508s16.253 10.666 16.76 27.934l-32.505 2.031 15.745 9.142s-58.916 8.126-73.137-15.237l-4.063-12.698z',
          'M236.078 104.964s11.706 23.414 27.315 17.56c15.609-5.853 0-27.316 0-27.316l-10.406-5.203-16.909 14.958z',
          'M1245.571 474.333l-212.279-265.266c-9.303 8.527-20.954 14.639-33.873 17.257l-0.458 0.077c-39.966 7.87-78.992-19.42-87.169-60.955-2.822-13.736-1.836-27.982 2.844-41.199 4.688-13.217 12.887-24.904 23.734-33.8l-72.385-90.448-412.357 352.424 379.582 474.331 412.361-352.422z',
          'M981.804 213.798c33.056 0 59.847-26.793 59.847-59.845s-26.791-59.844-59.847-59.844c-33.049 0-59.84 26.793-59.84 59.844s26.791 59.845 59.84 59.845z',
          'M607.35 420.611l-18.311 21.191 61.689 53.304 18.311-21.191-61.689-53.304zM1003.914 799.577l-18.311 21.193 54.682 47.248 18.311-21.193-54.682-47.248z',
          'M1102.711 641.741v1.643c-0.038 4.126-0.152 8.234-0.357 12.323-3.557 69.976-33.746 135.944-84.378 184.375-50.624 48.439-117.866 75.677-187.931 76.133-70.064 0.463-137.651-25.896-188.911-73.667-51.259-47.764-82.307-113.332-86.781-183.256-0.374-5.806-0.561-11.657-0.561-17.551-0.099-56.845 17.544-112.304 50.467-158.644 2.632-3.734 5.37-7.4 8.215-10.997 1.96-2.502 3.977-4.948 6.012-7.375 46.331-54.887 112.329-89.429 183.835-96.214s142.821 14.725 198.656 59.918c3.3 2.67 6.554 5.433 9.724 8.253 2.541 2.259 5.037 4.568 7.487 6.927 48.295 46.193 78.021 108.458 83.574 175.055 0.63 7.618 0.948 15.31 0.948 23.077z',
          'M828.257 950.742c-170.386 0-309.003-138.619-309.003-309.001-0.101-77.954 29.362-153.047 82.448-210.133l6.843 6.35c-51.481 55.361-80.055 128.184-79.956 203.783 0 165.232 134.429 299.664 299.668 299.664 40.148 0.137 79.902-7.858 116.88-23.514 38.353-16.48 71.006-39.293 98.157-67.448l0.087-0.090 6.705 6.501c-28.725 29.817-63.185 53.506-101.308 69.647-35.268 15.327-76.349 24.244-119.513 24.244-0.355 0-0.709-0.001-1.063-0.002l0.055 0z',
          'M873.062 944.204h-78.416v78.416h78.416v-78.416zM612.476 472.099c0.143 0.060 0.266 0.136 0.377 0.226l-0.003-0.002c1.475 1.214-0.374 3.548-0.149 5.47 0.261 2.465 3.547 3.006 6.030 3.249 2.483 0.262 5.62 2.26 4.444 4.462-6.237 2.147-12.547 0.037-18.914-2.408-32.923 46.34-50.565 101.799-50.467 158.645 0 5.9 0.187 11.749 0.561 17.55 0.489 0.361 1.050 0.67 1.65 0.899l0.049 0.016c1.867 0.709 4.033 0.579 5.75 1.587 1.363 0.803 2.278 2.222 3.641 2.969 3.903 2.128 9.317-1.961 12.958 0.579 0.941 0.857 1.833 1.767 2.67 2.725 3.36 2.913 8.887 0.953 12.77 3.137 2.502 1.4 3.79 4.201 5.134 6.74 3.342 6.347 8.756 12.584 15.908 13.087 2.255-0.103 4.515-0.028 6.758 0.225 2.203 0.504 4.369 2.427 4.014 4.649-0.616 3.827 1.27 8.009 0.766 11.837-0.916 7.002-10.829 10.064-11.67 17.065-0.003 1.628-0.097 3.23-0.279 4.807l0.018-0.195c-0.448 1.83-1.83 3.323-2.315 5.153-0.934 3.454 1.55 6.908 4.257 9.223 2.726 2.334 5.974 4.351 7.468 7.599 1.568 3.454 0.803 7.467 1.307 11.222 1.12 8.2 8.196 14.268 15.478 18.182 2.333 0.978 4.405 2.488 6.049 4.407 1.867 2.708 1.681 6.273 2.316 9.504 1.531 7.896 8.178 14.412 8.364 22.46 0.13 5.734-3.043 10.923-4.948 16.323-1.959 5.651-2.542 11.696-1.699 17.62 10.001 8.534 21.053 16.629 32.687 23.878l1.163 0.675c0.647-0.956 1.121-2.018 1.4-3.133 0.226-1.244 0.071-2.518-0.447-3.664-0.533-1.161-1.374-2.104-2.42-2.746l-0.027-0.015c2.007-0.759 3.832-1.927 5.359-3.436 0.749-0.774 1.245-1.752 1.418-2.814 0.044-0.255 0.069-0.55 0.069-0.85 0-0.827-0.191-1.61-0.53-2.307l0.014 0.031c3.286 0.41 7.188 0.614 9.353-1.904 1.737-2.018 1.625-5.037 0.934-7.6-0.948-2.488-1.575-5.082-1.867-7.729 7.613 0.372 15.244 0.114 22.815-0.766-1.096-3.686-3.587-6.811-6.946-8.7 3.435-0.576 6.554-4.688 7.637-7.987 0.936-3.375 0.988-6.925 0.149-10.323-0.145-0.469-0.229-1.009-0.229-1.568 0-0.398 0.042-0.786 0.123-1.161l-0.007 0.036c0.552-1.183 1.523-2.124 2.726-2.632 5.676-3.269 11.351-6.531 17.027-9.785 1.013-0.508 1.934-1.183 2.726-1.995 1.773-2.109 1.512-5.264 0.598-7.858s-2.371-5.044-2.726-7.767c-1.046-8.162 7.692-14.025 10.642-21.716 1.003-3.070 1.544-6.274 1.606-9.503 0.243-3.472 0.262-7.487-2.39-9.708-2.558-2.147-6.535-1.662-9.205-3.66-2.445-1.83-3.286-5.358-5.956-6.833-2.427-1.344-5.451-0.485-8.159-1.12-4.742-1.101-7.73-6.572-12.585-7.076-2.725-0.299-5.825 1.046-8.065-0.541-1.979-1.419-2.054-4.239-2.427-6.629-0.706-3.872-2.53-7.233-5.12-9.83l0 0c-2.591-2.597-5.947-4.428-9.702-5.127l-0.114-0.018c-2.819-0.448-5.881-0.28-8.29-1.83-2.427-1.569-3.529-4.5-5.451-6.684-3.062-3.491-7.917-4.742-12.453-5.806-6.161-1.437-12.317-2.882-18.465-4.332-3.267-0.784-7.487-1.195-9.261 1.681-0.493 1-0.87 2.161-1.072 3.38l-0.010 0.073c-0.667 2.155-1.997 4.044-3.801 5.398-1.72 1.303-3.885 2.102-6.234 2.145l-0.010 0c-1.546-2.607-3.991-4.542-6.899-5.394l-0.084-0.021c-2.217-0.375-4.129-0.842-5.987-1.429l0.311 0.085c-0.999-0.496-1.843-1.157-2.531-1.956l-0.009-0.010c-0.679-0.789-1.211-1.726-1.539-2.755l-0.016-0.056c-0.228-0.707-0.36-1.521-0.36-2.366 0-0.293 0.016-0.582 0.047-0.866l-0.003 0.035c0.114-1.076 0.445-2.118 0.975-3.061 1.059-1.895 1.466-4.085 1.159-6.234-0.327-2.234-1.358-4.183-2.857-5.659l-0.001-0.001c-3.136-2.819-7.673-3.51-11.893-3.23-1.102-2.408 0.746-5.115 2.725-6.871 1.998-1.736 4.406-3.454 4.836-6.068 0.691-4.107-4.555-7.226-8.532-6.012-3.977 1.233-6.516 5.097-8.197 8.906-0.815 2.247-1.927 4.377-3.305 6.33-0.704 0.956-1.642 1.701-2.73 2.157l-0.043 0.016c-0.729 0.307-1.576 0.486-2.464 0.486-0.366 0-0.725-0.030-1.074-0.088l0.038 0.005c-3.286-0.84-4.537-4.742-5.265-8.028-1.115-4.033-1.755-8.664-1.755-13.444 0-0.006 0-0.012 0-0.018l-0 0.001c0.029-4.589 1.852-8.985 5.079-12.248 5.433-5.004 13.797-4.518 21.135-3.715-0.672-0.888-1.076-2.012-1.076-3.229 0-0.149 0.006-0.297 0.018-0.444l-0.001 0.019c0.11-1.358 0.709-2.558 1.618-3.44l0.001-0.001c0.982-0.872 2.162-1.491 3.437-1.803 0.576-0.147 1.238-0.232 1.92-0.232 0.697 0 1.373 0.088 2.018 0.255l-0.056-0.012c2.212 0.458 4.205 1.649 5.657 3.379 2.091 2.54 2.689 5.994 4.257 8.869 1.587 2.895 5.134 5.359 8.029 3.809 2.52-1.345 2.912-4.817 2.296-7.6-0.635-2.763-1.96-5.47-1.736-8.308 0.429-5.396 6.049-8.663 10.997-10.885s10.605-5.228 11.389-10.606c0.040-1.109 0.256-2.156 0.62-3.13l-0.022 0.068c0.554-0.879 1.304-1.587 2.191-2.076l0.031-0.016c14.432-9.541 29.126-19.213 45.631-24.421 0.859-0.28 0.952 0.018 1.83-0.187 1.233-0.71 0.411-2.67-0.765-3.454s-2.744-1.4-3.043-2.782c-0.206-1.008 0.392-2.016 0.542-3.043 0.005-0.071 0.007-0.153 0.007-0.237 0-0.569-0.125-1.109-0.349-1.594l0.010 0.024c-0.266-0.579-0.653-1.062-1.131-1.433l-0.009-0.006c-0.469-0.365-1.038-0.625-1.66-0.734l-0.023-0.003c-0.192-0.035-0.413-0.054-0.639-0.054-0.426 0-0.836 0.070-1.218 0.2l0.027-0.008c-1.326-1.755 1.288-3.79 3.416-4.388 5.732-1.638 12.398-2.771 19.264-3.162l0.247-0.011c0.17-0.030 0.367-0.047 0.567-0.047 0.607 0 1.177 0.155 1.674 0.429l-0.018-0.009c0.469 0.454 0.77 1.078 0.804 1.772l0 0.006c0.002 0.036 0.003 0.079 0.003 0.121 0 0.66-0.242 1.263-0.642 1.726l0.003-0.003c-0.895 0.992-1.866 1.88-2.916 2.669l-0.052 0.038c-1.526 1.484-2.473 3.557-2.473 5.851 0 0.836 0.126 1.644 0.36 2.403l-0.015-0.058c3.454 1.755 7.188 3.567 11.016 2.95 3.809-0.616 7.188-4.91 5.395-8.327-1.661-3.193-6.684-3.921-7.543-7.412-1.008-4.088 4.779-7.729 3.472-11.725-0.56-1.755-2.315-2.8-3.659-4.051-1.536-1.513-2.63-3.47-3.075-5.663l-0.012-0.071c-0.133-0.643-0.209-1.382-0.209-2.139 0-1.568 0.327-3.059 0.916-4.409l-0.028 0.071c-2.186 0.382-4.431 0.235-6.549-0.427-2.204-0.703-4.090-1.866-5.626-3.384l0.001 0.001c-2.913-2.931-5.228-7.58-9.373-7.43-3.79 0.112-7.057 4.537-10.605 3.193-0.878-0.336-1.792-1.008-2.632-0.616-0.279 0.18-0.507 0.414-0.677 0.688l-0.005 0.009c-0.164 0.265-0.274 0.58-0.307 0.917l-0.001 0.009c-0.896 4.313 0.653 9.224-1.699 12.958-2.558 4.051-8.476 4.611-11.576 8.271-1.68 1.979-2.334 4.649-3.884 6.74s-4.817 3.435-6.684 1.606c0.915-1.874 1.165-4.004 0.71-6.039-0.479-2.099-1.623-3.878-3.194-5.15l-0.017-0.014c-1.59-1.059-3.418-1.969-5.357-2.638l-0.169-0.051c-2.364-1.008-4.396-2.158-6.28-3.503l0.1 0.068c-0.962-0.593-1.731-1.415-2.243-2.394l-0.016-0.034c-0.172-0.514-0.272-1.105-0.272-1.72 0-0.767 0.155-1.498 0.435-2.163l-0.014 0.037c0.945-2.697 2.608-5.084 4.808-6.907 2.11-1.757 4.723-2.98 7.594-3.426l0.088-0.011c2.464-0.336 5.34-0.224 6.983-2.109 0.859-0.99 1.307-2.502 2.577-2.894 0.231-0.051 0.497-0.080 0.769-0.080 0.582 0 1.133 0.133 1.625 0.369l-0.022-0.010c3.080 1.082 6.142 2.166 9.223 3.249 0.774 0.363 1.68 0.575 2.636 0.575 0.229 0 0.456-0.012 0.678-0.036l-0.028 0.002c0.576-0.077 1.073-0.365 1.42-0.783l0.003-0.004c0.314-0.379 0.504-0.87 0.504-1.406 0-0.050-0.002-0.099-0.005-0.148l0 0.007c-0.299-1.531-2.651-2.26-2.427-3.809 0.116-0.524 0.387-0.972 0.763-1.305l0.003-0.002c3.33-3.542 7.402-6.304 11.924-8.089 3.589-1.458 7.752-2.304 12.113-2.304 0.746 0 1.486 0.025 2.22 0.073l-0.1-0.005c1.157 1.924-0.672 4.182-2.222 5.807-1.531 1.643-2.763 4.556-0.896 5.806 0.662 0.354 1.448 0.562 2.283 0.562 0.057 0 0.114-0.001 0.171-0.003l-0.008 0c2.27 0.305 4.477 0.973 6.535 1.979 3.193 1.382 6.33 2.913 9.392 4.556-0.184-0.782-0.29-1.679-0.29-2.602 0-1.23 0.188-2.416 0.536-3.531l-0.023 0.084c0.349-0.976 1.027-1.763 1.898-2.243l0.021-0.011c0.566-0.313 1.24-0.497 1.958-0.497 0.347 0 0.684 0.043 1.006 0.124l-0.028-0.006c1.83 0.709 2.763 3.136 4.723 3.36 2.596 0.299 3.622-3.548 2.54-5.937s-3.249-4.369-3.417-7.002c-0.13-1.755 0.542-3.939-0.859-5.004-0.471-0.316-1.036-0.529-1.645-0.596l-0.016-0.001c-11.725-2.147-23.456-4.301-35.194-6.46-2.091-0.392-5.097-0.093-5.191 2.017-0.056 1.195 1.008 2.371 0.542 3.454-0.504 1.157-2.147 1.064-3.342 1.475-0.906 0.418-1.632 1.096-2.098 1.938l-0.012 0.023c-0.348 0.627-0.553 1.374-0.553 2.17 0 0.235 0.018 0.466 0.052 0.692l-0.003-0.025c0.319 1.941 1.072 3.786 2.203 5.395-2.296-0.952-5.75-1.12-8.047-2.090-0.369-2.882-1.077-5.498-2.091-7.955l0.075 0.206c-0.062-0.418-0.211-0.792-0.427-1.118l0.006 0.010c-0.222-0.335-0.506-0.612-0.837-0.819l-0.011-0.007c-0.32-0.201-0.699-0.339-1.106-0.388l-0.013-0.001c-0.096-0.012-0.207-0.019-0.32-0.019-0.307 0-0.602 0.051-0.877 0.144l0.019-0.006c-3.025 0.466-6.050 0.915-9.074 1.381-0.794 0.039-1.511 0.336-2.078 0.808l0.006-0.005c-1.176 1.251-0.019 3.249-0.056 4.966-0.117 1.003-0.537 1.89-1.165 2.587l0.004-0.004c-0.631 0.701-1.466 1.207-2.411 1.426l-0.031 0.006c-1.9 0.385-3.861 0.36-5.75-0.075-4.239-0.653-8.458-1.307-12.696-1.96 3.857-1.253 7.107-3.48 9.572-6.393l0.025-0.031c1.68-1.979 2.577-5.676 0.149-6.609-0.46-0.132-0.989-0.207-1.535-0.207-0.236 0-0.468 0.014-0.696 0.041l0.028-0.003c-5.75 0.037-10.288-4.761-15.665-6.796-1.569-0.603-3.383-0.958-5.278-0.971l-0.006-0-6.012 7.375zM1102.355 655.706c-0.652 0.884-1.525 1.593-2.518 2.065-0.845 0.41-1.838 0.649-2.887 0.649-0.108 0-0.215-0.003-0.322-0.008l0.015 0.001c-5.841-0.504-8.306-8.925-14.093-9.877-0.516-0.13-1.054-0.078-1.532 0.149-0.857 0.467-1.009 1.625-1.062 2.596-0.243 4.817-0.448 9.821 1.434 14.264 2.746 6.497 9.861 11.95 8.366 18.839-8.033-3.716-12.212-12.734-14.101-21.378-1.904-8.645-2.2-17.718-5.598-25.897-2.594 3.305-8.010 0.579-10.361-2.894-2.238-3.286-3.626-7.095-5.787-10.437-2.169-3.323-5.492-6.31-9.451-6.497-4.164-0.187-7.782 2.669-10.961 5.376-2.761 2.040-5.074 4.619-6.811 7.581-2.222 4.481-1.646 9.746-1.752 14.731-0.114 5.377-1.252 11.072-4.93 15.030-3.679 3.939-10.46 5.321-14.51 1.755-1.899-1.98-3.308-4.443-4.025-7.187l-0.025-0.114c-3.731-10.295-7.509-23.406-10.528-36.805l-0.448-2.366c-0.675 3.024-3.345 6.927-5.886 5.153-0.561-0.482-1.024-1.081-1.343-1.754-4.741-8.010-13.494-12.827-22.369-15.721-8.844-2.876-18.167-4.22-26.92-7.393-5.352-1.968-9.966-4.315-14.249-7.126l0.262 0.161c-1.107 1.64-1.76 3.55-1.881 5.528-0.114 1.977 0.303 3.951 1.214 5.712 0.978 1.723 2.511 3.072 4.339 3.839s3.861 0.907 5.78 0.4c1.942-0.635 3.58-1.979 5.507-2.651 1.919-0.654 4.521-0.336 5.355 1.531 0.827 1.773-0.41 3.921 0.205 5.788 0.918 2.819 5.196 3.043 6.69 5.62 0.44 1.020 0.539 2.154 0.288 3.236-0.258 1.082-0.85 2.055-1.691 2.776-1.722 1.4-3.611 2.568-5.636 3.472-6.273 3.491-10.741 9.447-16.225 14.077-5.492 4.649-13.244 8.029-19.775 5.060 1.547-7.898-7.843-13.686-9.58-21.546-0.576-2.596-0.281-5.34-1.085-7.861-1.176-3.66-4.422-6.161-7.069-8.925-3.129-3.288-5.635-7.203-7.307-11.532l-0.081-0.24c-1.427-3.683-2.255-7.945-2.255-12.4 0-0.462 0.009-0.922 0.027-1.38l-0.002 0.066c0.152-3.249 0.743-6.554 0-9.727-0.728-3.155-3.36-6.218-6.607-6.087-7.418 0.336-16.771 0.897-20.654-5.433-1.396-2.26-1.995-5.564 0.023-7.301 0.789-0.499 1.661-0.837 2.587-0.994 0.356-0.064 0.767-0.1 1.186-0.1 0.561 0 1.107 0.066 1.631 0.19l-0.048-0.010c5.583 0.542 11.15 1.101 16.733 1.643 3.899 0.373 8.116 0.691 11.476-1.344s4.817-7.468 1.699-9.877c-2.253-1.755-6.326-1.662-7.001-4.444-0.539-2.333 2.040-4.966 0.637-6.927-0.986-1.381-3.231-1.008-4.597 0.038-1.183 1.235-2.48 2.365-3.861 3.379-2.67 1.381-5.841 0.056-8.723-0.84-2.875-0.896-6.72-0.971-8.101 1.699-1.57 2.969 1.365 6.89-0.167 9.877-2.056 3.94-8.966 1.699-11.84 5.097-3.284 3.884 2.245 9.709 1.145 14.675-1.418 0.704-2.996 1.027-4.581 0.938-1.578-0.088-3.11-0.585-4.437-1.442-1.312-0.889-2.351-2.116-3.011-3.549-0.667-1.434-0.933-3.020-0.766-4.591 0.265-2.241 1.441-4.537 0.66-6.647-0.85-1.629-2.245-2.906-3.944-3.604-5.416-3.006-10.824-5.999-16.24-8.981-1.517 2.801 0.387 6.255 2.784 8.365 2.367 2.091 5.355 3.678 6.925 6.441 0.994 1.915 1.214 4.137 0.622 6.212-0.584 2.075-1.949 3.846-3.8 4.952-0.222 0.154-0.485 0.266-0.769 0.317l-0.012 0.002c-0.101 0.018-0.216 0.029-0.334 0.029-0.181 0-0.355-0.024-0.521-0.070l0.014 0.003c-0.258-0.152-0.485-0.354-0.66-0.595-0.182-0.24-0.311-0.514-0.387-0.806-2.852-7.337-7.168-14.563-14.040-18.39-6.887-3.846-16.763-3.043-21.284 3.398-1.062 1.531-1.79 3.286-2.723 4.911-4.946 8.607-15.588 12.677-25.524 12.415-0.094 0.006-0.205 0.010-0.316 0.010-0.908 0-1.759-0.246-2.489-0.676l0.023 0.013c-1.606-1.102-1.531-3.454-1.289-5.396 0.355-2.744 0.691-5.47 1.046-8.215 0.009-1.746 0.697-3.33 1.813-4.503l-0.003 0.003c1.849-1.456 4.5-0.541 6.852-0.579 1.776-0.079 3.486-0.704 4.889-1.79 1.411-1.086 2.442-2.58 2.973-4.277 0.47-1.713 0.47-3.523-0.015-5.235-0.478-1.71-1.418-3.258-2.715-4.475-1.062-1.008-2.503-2.278-1.942-3.641 0.228-0.375 0.539-0.696 0.903-0.941s0.774-0.408 1.206-0.477c4.202-1.214 8.67-1.531 12.796-2.988 4.142-1.437 8.154-4.387 9.148-8.663 0.296-1.307 0.425-2.894 1.6-3.548 0.599-0.238 1.229-0.365 1.866-0.373 2.245-0.322 4.293-1.472 5.734-3.223s2.169-3.978 2.056-6.243c1.98-1.381 4.763-0.354 6.683 1.12 1.904 1.475 3.603 3.417 5.939 4.052 4.346 1.195 8.549-2.67 13.069-2.689 1.904 0 3.861 0.672 5.636 0.019 1.813-0.654 2.898-2.446 4.278-3.771 1.403-1.345 3.831-2.147 5.112-0.71-0.372-2.707-0.728-5.395-1.1-8.084 2.2 0.554 4.49 0.63 6.728 0.225 2.23-0.406 4.346-1.285 6.212-2.577-4.703-1.588-9.39-3.174-14.093-4.761-0.501-0.122-0.956-0.366-1.327-0.709-1.032-1.102 0-2.819 0.819-4.070 1.995-3.006 2.336-7.954-0.948-9.447-2.245-1.027-4.801 0.205-6.948 1.4-3.436 1.904-6.872 3.827-10.308 5.731-0.319 1.961 2.071 3.081 3.55 4.388 0.895 0.797 1.532 1.848 1.82 3.014 0.296 1.166 0.228 2.392-0.197 3.518-0.435 1.151-1.181 2.101-2.136 2.775l-0.019 0.012c-0.986 0.691-2.154 1.067-3.353 1.080 0.675 0.884 1.145 1.907 1.373 2.995 0.235 1.089 0.212 2.216-0.046 3.297-2.298 0.168-4.612 0.336-6.933 0.504-0.174 0.036-0.374 0.057-0.578 0.057-0.206 0-0.407-0.021-0.601-0.061l0.019 0.003c-0.408-0.083-0.77-0.239-1.087-0.454l0.010 0.007c-0.743-0.653-0.637-1.811-0.819-2.781-0.311-1.161-0.956-2.203-1.866-2.992-0.903-0.788-2.025-1.288-3.216-1.434-2.374-0.268-4.786-0.046-7.077 0.653-0.994 0.351-2.086 0.325-3.057-0.074-0.554-0.367-0.978-0.904-1.198-1.531-0.402-1.28-0.478-2.643-0.197-3.958 0.273-1.315 0.88-2.537 1.767-3.548 1.79-1.991 3.77-3.81 5.901-5.433 4.725-4.151 8.281-9.524 10.182-15.627l0.065-0.243c3.808-1.606 7.752-3.771 11.575-5.377 3.080-1.426 6.303-2.509 9.618-3.23 3.118-0.476 6.281-0.627 9.428-0.448 4.293 0.074 8.609 0.149 12.902 0.243 3.831-0.161 7.661 0.39 11.294 1.624 3.527 1.456 6.645 4.612 6.887 8.421 0.076 0.434 0.038 0.879-0.114 1.295-0.152 0.429-0.403 0.792-0.725 1.074l-0.003 0.003c-0.421 0.238-0.924 0.378-1.459 0.378-0.058 0-0.115-0.002-0.172-0.005l0.008 0c-3.565 0.112-5.074 1.008-8.64 1.139 2.253 2.409 4.794 4.948 8.078 5.377 5.787 0.747 9.952-5.246 12.622-10.455 0.099 1.326 0.705 2.562 1.699 3.444s2.298 1.342 3.626 1.28c1.426-0.246 2.799-0.78 4.013-1.569 11.484-6.276 24.348-9.599 37.433-9.671-0.129-0.991 0.121-1.994 0.69-2.815s1.418-1.402 2.389-1.629c2.67-0.523 5.067 1.774 6.349 4.164 1.274 2.389 2.078 5.153 4.126 6.945 2.040 1.792 5.977 1.699 6.781-0.878 0.781-2.483-1.813-4.612-3.959-6.086-2.162-1.456-4.422-4.164-2.966-6.329 10.976-2.446 22.050-4.873 33.307-5.359 1.911 0.058 3.815-0.272 5.598-0.971 0.887-0.374 1.623-1.028 2.094-1.862s0.652-1.8 0.523-2.75c-2.458 0.573-5.029 0.404-7.388-0.487s-4.407-2.463-5.871-4.516c11.56-0.953 23.658-1.792 34.77 0.803l9.724 8.253c-1.851 1.923-4.316 3.734-2.966 5.657 0.44 0.441 0.978 0.777 1.57 0.981s1.221 0.271 1.843 0.196c2.351 0.037 4.703 0.093 7.039 0.093 48.295 46.194 78.021 108.459 83.574 175.056-3.922-0.149-7.525 4.817-7.024 9.148 0.599 5.022 4.217 9.055 6.819 13.387 0.425 0.704 0.812 1.434 1.153 2.185l-0.357 12.322z',
          'M0 1022.392h1425.34M588.036 128.449c13.081 0 23.685-10.603 23.685-23.684s-10.604-23.685-23.685-23.685c-13.080 0-23.684 10.604-23.684 23.685s10.604 23.684 23.684 23.684zM1287.866 579.485c13.077 0 23.681-10.604 23.681-23.684s-10.604-23.685-23.681-23.685c-13.084 0-23.681 10.604-23.681 23.685s10.597 23.684 23.681 23.684zM1126.18 343.535c13.077 0 23.681-10.604 23.681-23.685s-10.604-23.684-23.681-23.684c-13.084 0-23.689 10.604-23.689 23.684s10.604 23.685 23.689 23.685z',
          'M970.782 546.51c14.685 0 26.578-11.9 26.578-26.579s-11.894-26.579-26.578-26.579c-14.677 0-26.578 11.9-26.578 26.579s11.901 26.579 26.578 26.579z',
          'M1056.161 469.535c19.35 0 35.036-15.686 35.036-35.036s-15.686-35.036-35.036-35.036c-19.35 0-35.036 15.686-35.036 35.036s15.686 35.036 35.036 35.036z',
          'M1091.592 398.178c-9.398-9.174-22.065-14.236-35.203-14.074-13.13 0.163-25.668 5.537-34.839 14.941-19.107 19.583-46.376 118.475-46.376 118.475s98.183-29.714 117.29-49.297c9.17-9.403 14.237-22.066 14.071-35.202-0.159-13.137-5.537-25.67-14.943-34.843zM1040.134 450.931c-3.254-3.171-5.484-7.233-6.425-11.675s-0.546-9.062 1.138-13.277c1.684-4.216 4.581-7.837 8.329-10.406 3.739-2.569 8.162-3.97 12.705-4.026 4.536-0.056 8.988 1.235 12.796 3.711s6.796 6.023 8.579 10.196c1.79 4.173 2.306 8.782 1.472 13.245-0.827 4.464-2.966 8.58-6.136 11.831-4.248 4.358-10.058 6.848-16.141 6.924-6.091 0.075-11.962-2.271-16.316-6.522z',
        ],
        attrs: [
          {
            fill: 'rgb(47, 46, 65)',
          },
          {
            fill: 'rgb(255, 185, 185)',
          },
          {
            fill: 'rgb(0, 0, 0)',
            opacity: 0.1,
          },
          {
            fill: 'rgb(255, 185, 185)',
          },
          {
            fill: 'rgb(47, 46, 65)',
          },
          {
            fill: 'rgb(255, 185, 185)',
          },
          {
            fill: 'rgb(87, 90, 137)',
          },
          {
            fill: 'rgb(255, 185, 185)',
          },
          {
            fill: 'rgb(47, 46, 65)',
          },
          {
            fill: 'rgb(87, 90, 137)',
          },
          {
            fill: 'rgb(63, 61, 86)',
          },
          {
            fill: 'rgb(47, 46, 65)',
          },
          {
            fill: 'rgb(242, 242, 242)',
          },
          {
            fill: 'none',
            stroke: 'rgb(47, 46, 65)',
            strokeLinejoin: 'miter',
            strokeLinecap: 'butt',
            strokeMiterlimit: '10',
            strokeWidth: 22.755555555555556,
          },
          {
            fill: 'none',
            stroke: 'rgb(47, 46, 65)',
            strokeLinejoin: 'miter',
            strokeLinecap: 'butt',
            strokeMiterlimit: '10',
            strokeWidth: 22.755555555555556,
          },
          {
            fill: 'rgb(47, 46, 65)',
          },
          {
            fill: 'rgb(47, 46, 65)',
          },
          {
            fill: 'rgb(242, 242, 242)',
          },
          {
            fill: 'rgb(242, 242, 242)',
          },
          {
            fill: 'rgb(225, 112, 0)',
          },
          {
            fill: 'rgb(63, 61, 86)',
          },
          {
            fill: 'rgb(225, 112, 0)',
          },
          {
            fill: 'rgb(225, 112, 0)',
          },
          {
            fill: 'none',
            stroke: 'rgb(63, 61, 86)',
            strokeLinejoin: 'miter',
            strokeLinecap: 'butt',
            strokeMiterlimit: '10',
            strokeWidth: 15.170370370370371,
          },
          {
            fill: 'rgb(63, 61, 86)',
          },
          {
            fill: 'rgb(255, 255, 255)',
          },
          {
            fill: 'rgb(87, 184, 148)',
          },
        ],
        width: 1426,
        isMulticolor: true,
        isMulticolor2: true,
        grid: 16,
        tags: ['Live'],
      },
      attrs: [
        {
          fill: 'rgb(47, 46, 65)',
        },
        {
          fill: 'rgb(255, 185, 185)',
        },
        {
          fill: 'rgb(0, 0, 0)',
          opacity: 0.1,
        },
        {
          fill: 'rgb(255, 185, 185)',
        },
        {
          fill: 'rgb(47, 46, 65)',
        },
        {
          fill: 'rgb(255, 185, 185)',
        },
        {
          fill: 'rgb(87, 90, 137)',
        },
        {
          fill: 'rgb(255, 185, 185)',
        },
        {
          fill: 'rgb(47, 46, 65)',
        },
        {
          fill: 'rgb(87, 90, 137)',
        },
        {
          fill: 'rgb(63, 61, 86)',
        },
        {
          fill: 'rgb(47, 46, 65)',
        },
        {
          fill: 'rgb(242, 242, 242)',
        },
        {
          fill: 'none',
          stroke: 'rgb(47, 46, 65)',
          strokeLinejoin: 'miter',
          strokeLinecap: 'butt',
          strokeMiterlimit: '10',
          strokeWidth: 22.755555555555556,
        },
        {
          fill: 'none',
          stroke: 'rgb(47, 46, 65)',
          strokeLinejoin: 'miter',
          strokeLinecap: 'butt',
          strokeMiterlimit: '10',
          strokeWidth: 22.755555555555556,
        },
        {
          fill: 'rgb(47, 46, 65)',
        },
        {
          fill: 'rgb(47, 46, 65)',
        },
        {
          fill: 'rgb(242, 242, 242)',
        },
        {
          fill: 'rgb(242, 242, 242)',
        },
        {
          fill: 'rgb(225, 112, 0)',
        },
        {
          fill: 'rgb(63, 61, 86)',
        },
        {
          fill: 'rgb(225, 112, 0)',
        },
        {
          fill: 'rgb(225, 112, 0)',
        },
        {
          fill: 'none',
          stroke: 'rgb(63, 61, 86)',
          strokeLinejoin: 'miter',
          strokeLinecap: 'butt',
          strokeMiterlimit: '10',
          strokeWidth: 15.170370370370371,
        },
        {
          fill: 'rgb(63, 61, 86)',
        },
        {
          fill: 'rgb(255, 255, 255)',
        },
        {
          fill: 'rgb(87, 184, 148)',
        },
      ],
      properties: {
        order: 24,
        id: 498,
        name: 'Live',
        prevSize: 32,
      },
      setIdx: 0,
      setId: 1,
      iconIdx: 13,
    },
    {
      icon: {
        paths: [
          'M1592.889 1012.425h-1592.889v11.575h1592.889v-11.575z',
          'M1261.985 808.057c0 8.905-52.194 34.862-114.187 34.862-62.001 0-110.304-25.957-110.304-34.862 0-8.897 50.244-6.030 112.306-6.030 62.054 0 112.185-2.882 112.185 6.030z',
          'M1261.985 808.057c0 8.905-52.194 34.862-114.187 34.862-62.001 0-110.304-25.957-110.304-34.862z',
          'M637.638 644.695c10.062 1.283 20.504 2.097 30.14-1.011 1.518-0.468 3.187-1.509 3.036-3.018-0.117-0.578-0.356-1.086-0.69-1.518l0.006 0.008c-3.377-4.962-6.432-10.638-8.881-16.627l-0.225-0.621c-0.1-0.324-0.297-0.593-0.557-0.781l-0.004-0.003c-0.144-0.054-0.311-0.085-0.485-0.085s-0.341 0.031-0.495 0.088l0.010-0.003c-4.447 1.162-8.287 4.014-12.703 5.236-2.252 0.614-4.602 0.789-6.921 0.513-2.003-0.226-4.735-1.871-6.556-1.66 1.032 6.595 3.551 12.751 4.325 19.482zM827.938 627.99c6.629-4.527 13.502-9.28 17.423-16.267 0.273-0.418 0.44-0.903 0.47-1.403-0.068-0.493-0.265-0.961-0.561-1.359-3.732-5.895-8.533-11.049-14.162-15.195-2.935 2.062-5.59 4.497-7.896 7.243-1.669 1.751-6.281 4.527-6.326 7.198 0 1.509 1.76 3.259 2.579 4.527 1.107 1.629 2.154 3.29 3.155 4.98 0.576 0.83 5.848 9.944 5.317 10.276z',
          'M677.082 664.901c0.012 0.151 0.019 0.328 0.019 0.506 0 1.451-0.462 2.794-1.247 3.89l0.014-0.020c-0.69 0.69-1.548 1.211-2.507 1.499l-0.042 0.011c-14.068 5.010-30.353-1.238-44.391 3.697-2.884 1.011-5.615 2.474-8.514 3.441-3.456 1.033-7.021 1.661-10.623 1.871-4.963 0.467-9.956 0.769-14.934 0.905-0.759 0.057-1.644 0.089-2.537 0.089-3.098 0-6.105-0.39-8.974-1.124l0.25 0.054c-1.936-0.502-3.626-1.361-5.074-2.51l0.028 0.021c-1.474-1.168-2.679-2.605-3.554-4.244l-0.035-0.072c-0.446-0.858-0.707-1.873-0.707-2.949 0-0.676 0.103-1.328 0.295-1.941l-0.012 0.046c0.235-0.581 0.547-1.080 0.931-1.515l-0.005 0.006c0.951-1.061 2.068-1.963 3.308-2.671l5.175-3.32c2.262-1.609 4.85-3.002 7.607-4.055l0.239-0.080c2.049-0.664 4.219-0.95 6.298-1.509 7.27-2.112 12.824-7.847 17.984-13.355l7.042-7.469c0.655-0.814 1.471-1.47 2.402-1.929l0.042-0.018c0.639-0.219 1.375-0.346 2.141-0.346 0.315 0 0.625 0.021 0.929 0.063l-0.035-0.004c6.84 0.486 13.445 2.687 19.199 6.399 1.47 1.096 3.058 2.028 4.735 2.776 4.128 1.6 9.425 0.392 13.234-1.629 1.806-0.966 1.412-1.509 2.17-3.23s2.611-2.822 4.219-1.252c0.485 0.542 0.83 1.195 1.002 1.902 1.518 4.98 0.941 10.336 0.941 15.558-0.006 0.11-0.010 0.239-0.010 0.369 0 0.73 0.115 1.434 0.328 2.094l-0.013-0.048c0.387 0.787 0.85 1.534 1.381 2.233 0.108 0.185 0.205 0.376 0.289 0.573 0.928 2.312 1.277 4.813 1.016 7.289z',
          'M677.082 664.901c0.012 0.151 0.019 0.328 0.019 0.506 0 1.451-0.462 2.794-1.247 3.89l0.014-0.020c-0.69 0.69-1.548 1.211-2.507 1.499l-0.042 0.011c-14.068 5.009-30.353-1.238-44.391 3.697-2.884 1.011-5.615 2.474-8.514 3.44-3.456 1.033-7.021 1.661-10.623 1.871-4.963 0.468-9.956 0.77-14.934 0.906-0.759 0.057-1.644 0.089-2.537 0.089-3.098 0-6.105-0.39-8.974-1.124l0.25 0.054c-1.936-0.502-3.626-1.361-5.074-2.51l0.028 0.021c-1.474-1.168-2.679-2.605-3.554-4.244l-0.035-0.072c-0.446-0.858-0.707-1.873-0.707-2.949 0-0.676 0.103-1.328 0.295-1.941l-0.012 0.046c0.22-0.552 0.533-1.062 0.926-1.509 0.819 1.705 1.411 3.969 1.927 4.784 0.697 1.208 1.644 2.253 2.781 3.067s2.433 1.379 3.805 1.655c2.054 0.126 4.113-0.135 6.070-0.769 12.748-3.139 26.301-3.184 38.549-7.937 4.204-1.645 8.21-3.834 12.626-4.829s9.106-0.724 13.659-1.101c7.194-0.573 14.16-2.731 21.248-3.863 0.915 2.331 1.243 4.848 0.956 7.334z',
          'M860.152 627.070c-0.667 5.312-4.050 9.884-7.767 13.763s-7.919 7.364-10.885 11.831c-3.641 5.538-5.279 12.404-10.012 17.082-1.82 1.701-3.861 3.148-6.068 4.301-2.48 1.453-5.097 2.651-7.82 3.576-7.069 2.248-14.693 1.735-22.080 1.192-2.397-0.023-4.779-0.478-7.009-1.343-1.024-0.514-1.995-1.11-2.92-1.781-1.851-1.134-3.406-2.684-4.551-4.527-0.561-1.001-0.713-2.177-0.44-3.29 0.425-1.225 1.145-2.326 2.109-3.199 1.669-1.72 3.451-3.319 5.348-4.784 2.594-1.667 4.938-3.7 6.948-6.036 1.236-1.846 2.139-3.887 2.685-6.036 1.077-3.765 1.729-7.637 1.957-11.544-0.008-2.596 0.265-5.187 0.804-7.726 1.123-3.984 4.096-7.545 3.762-11.664-0.044-0.192-0.069-0.412-0.069-0.638 0-0.406 0.081-0.794 0.228-1.147l-0.007 0.020c0.349-0.425 0.83-0.731 1.379-0.857l0.017-0.003c2.321-0.919 4.771-1.484 7.259-1.675 1.244-0.086 2.503 0.105 3.664 0.56 1.168 0.454 2.215 1.16 3.072 2.065 1.032 1.238 1.714 3.018 3.231 3.501 0.759 0.204 1.547 0.235 2.313 0.090 3.732-0.377 7.676-0.845 10.619-3.244 1.358-1.214 2.458-2.694 3.216-4.349 0.751-1.654 1.161-3.446 1.183-5.263 0-1.374-0.622-2.807 1.517-3.018 1.608-0.212 2.89 1.509 3.709 2.565 2.958 3.938 5.992 8.058 7.1 12.856 0.4-0.159 0.864-0.252 1.349-0.256l0.002-0c0.948-0.008 1.881 0.211 2.723 0.639s1.57 1.053 2.116 1.82c1.214 1.946 1.676 4.259 1.32 6.519z',
          'M860.152 627.070c-0.667 5.312-4.050 9.884-7.767 13.763s-7.919 7.364-10.885 11.831c-3.641 5.538-5.279 12.404-10.012 17.082-1.82 1.701-3.861 3.148-6.068 4.301-2.48 1.453-5.097 2.651-7.82 3.576-7.069 2.248-14.693 1.735-22.080 1.192-2.397-0.023-4.779-0.478-7.009-1.343-1.024-0.514-1.995-1.11-2.92-1.781-1.851-1.134-3.406-2.684-4.551-4.527 1.426-0.68 2.973-1.051 4.551-1.086 3.284 0.181 5.681 3.259 8.822 4.21 4.475 1.343 8.935-1.795 13.479-2.867 2.958-0.694 6.068-0.513 8.996-1.509 2.442-0.938 4.695-2.297 6.66-4.014 2.7-1.916 5.097-4.214 7.122-6.821 1.676-2.607 3.080-5.385 4.172-8.285 2.397-5.558 5.219-10.926 8.435-16.056 0.478-0.812 1.054-1.562 1.722-2.233 0.713-0.649 1.517-1.101 2.321-1.675 3.034-2.279 4.293-6.036 5.355-9.718 0.288-1.12 0.69-2.207 1.198-3.244 0.948-0.008 1.881 0.211 2.723 0.639s1.57 1.053 2.116 1.82c1.305 1.993 1.82 4.397 1.441 6.746z',
          'M541.921 156.59c3.777 2.814 6.886 6.421 9.106 10.563 2.125 4.135 14.372 36.216 13.659 40.879 3.991-3.999 19.729-4.647 23.766-8.646 1.685-1.675 10.776-10.035 12.142-11.982s11.504-6.036 12.611-8.088c4.144-7.38-29.381-35.342-25.086-42.63 0.219-0.304 0.35-0.685 0.35-1.095 0-0.018-0-0.036-0.001-0.054l0 0.003c-0.103-0.356-0.299-0.658-0.559-0.888l-0.002-0.002c-2.747-2.792-6.389-4.528-9.698-6.595s-6.495-4.949-7.391-8.753c-3.155 1.444-6.051 3.391-8.574 5.765-6.152 5.241-12.197 10.588-18.136 16.040-2.322 2.143-6.815 4.995-7.892 8.059-1.275 3.29 3.491 5.628 5.706 7.424z',
          'M596.191 144.715c-5.144 3.436-9.95 7.347-14.356 11.68-4.158 4.089-8.104 8.828-9.106 14.547-0.425 2.248-0.364 4.527-0.713 6.805-1.518 9.884-10.108 17.127-13.902 26.377-1.006 2.519-1.844 5.485-2.374 8.557l-0.039 0.271c-1.010 5.154-1.64 11.129-1.744 17.234l-0.001 0.090c-0.091 5.628 5.464 9.507 7.497 14.758s2.58 10.653 3.612 16.041c1.943 10.17 5.509 19.979 9.106 29.727 7.482 20.553 31.734 77.367 39.216 97.935 22.932-5.718 83.971-18.862 104.277-30.919 6.768-4.014-46.971-49.299-39.732-52.423 0.436-0.069 0.824-0.233 1.157-0.47l-0.008 0.006c0.34-0.242 0.616-0.551 0.812-0.911l0.007-0.014c0.2-0.366 0.318-0.802 0.318-1.265 0-0.412-0.093-0.802-0.259-1.15l0.007 0.016c-7.239-31.478-29.883-57.342-40.157-87.99-3.567-10.638-9.971-19.722-14.828-29.833-4.402-9.16-6.754-19.285-12.020-27.992-1.034-1.846-2.314-3.417-3.819-4.736l-0.020-0.017c-1.228-0.945-2.618-1.796-4.096-2.492l-0.138-0.059c-3.005-1.449-5.797-2.309-8.696-3.772z',
          'M543.134 153.014c19.823 0 35.892-15.978 35.892-35.688s-16.069-35.688-35.892-35.688c-19.822 0-35.892 15.977-35.892 35.688s16.069 35.688 35.892 35.688z',
          'M579.649 134.091c1.789-1.641 4.035-2.703 6.444-3.048s4.866 0.045 7.047 1.117c2.428 1.252 4.553 3.788 4.006 6.444l17.802 0.272c2.834-0.077 5.666 0.181 8.439 0.77 2.79 0.604 5.28 2.156 7.041 4.391 0.213 0.287 0.456 0.633 0.82 0.679 0.006 0 0.014 0 0.022 0 0.302 0 0.579-0.102 0.801-0.274l-0.003 0.002c2.018-1.028 4.402-1.63 6.926-1.63 0.683 0 1.356 0.044 2.016 0.13l-0.078-0.008c9.622 0.618 18.515 5.402 26.058 11.378 1.36 0.93 2.416 2.236 3.035 3.757 0.623 2.007-0.121 4.528 1.518 5.961 0 16.599 5.737 32.112 9.561 48.288 0.683 2.882 3.46 5.433 5.388 7.696 2.382 2.509 4.325 5.396 5.752 8.541 3.248 8.39-1.23 18.259 1.927 26.679 1.336 3.561 3.915 6.489 6.070 9.582 2.841 3.572 4.637 7.854 5.191 12.374 0.137 2.022-0.121 4.060 0 6.036 0.204 2.719 0.713 5.407 1.518 8.013 1.295 4.869 2.651 9.733 4.067 14.592 2.307 7.847 5.312 16.313 12.384 20.493-17.073 2.882-35.073 5.704-51.343-0.196-2.443-0.84-4.561-1.918-6.495-3.243l0.091 0.059c-5.873-4.164-8.712-11.287-11.246-18.017-2.822-7.545-5.691-15.226-6.268-23.254 0-0.017 0-0.037 0-0.057 0-2.669-0.394-5.246-1.127-7.676l0.049 0.188c-1.654-4.377-6.070-7.017-10.077-9.447-4.525-2.465-8.624-5.634-12.141-9.386-1.69-1.825-3.028-4.003-3.888-6.409l-0.041-0.131c-0.66-1.832-1.042-3.946-1.042-6.149 0-0.495 0.019-0.985 0.057-1.469l-0.004 0.064c0.303-2.49 1.29-4.889 1.381-7.395s-1.032-5.372-3.445-6.036c-12.43-3.743-18.364-18.38-21.125-30.995-1.026-5.35-1.613-11.503-1.613-17.793 0-0.694 0.007-1.387 0.021-2.077l-0.002 0.103-0.167-12.872c-1.715-1.552-3.095-3.434-4.055-5.533-0.918-1.957-1.476-4.244-1.53-6.656l-0-0.019c0.068-0.527 0.107-1.136 0.107-1.754 0-0.809-0.066-1.602-0.194-2.374l0.011 0.084c-0.634-1.695-1.608-3.135-2.847-4.295l-0.006-0.006c-2.67-2.723-4.942-5.849-6.713-9.277l-0.101-0.215zM541.42 174.895c-0.41 3.984 0.501 8.073-0.395 11.982-0.349 1.509-0.956 3.017-1.396 4.421-1.346 5.625-0.764 11.536 1.654 16.795 2.667 5.7 5.546 10.576 8.826 15.143l-0.191-0.279c1.126 1.597 2.054 3.325 2.762 5.145 0.574 1.911 0.931 3.881 1.063 5.87 0.879 7.991 2.288 15.916 4.219 23.722 1.7 6.761 21.004 64.555 25.497 69.913 0.815 1.186 2.051 2.021 3.46 2.339 0.071 0.003 0.155 0.004 0.238 0.004 0.983 0 1.913-0.224 2.743-0.624l-0.038 0.016 9.106-3.471c0.813-0.252 1.517-0.644 2.118-1.154l-0.009 0.007c0.811-0.938 1.306-2.169 1.306-3.516 0-0.016-0-0.032-0-0.048l0 0.002c0.652-7.364-18.697-65.566-21.156-72.523-7.437-21.005-17.332-41.256-22.173-63.001-1.351-6.036-2.064-15.331-6.511-20.145-1.836-1.992-1.214-1.147-3.414-0.105-1.258 0.547-2.315 1.107-3.323 1.736l0.106-0.062c-1.288 0.891-2.36 2.056-3.137 3.411-0.743 1.272-1.23 2.778-1.353 4.386l-0.002 0.035z',
          'M569.056 214.747c2.443 12.842 4.963 25.653 7.467 38.495l35.634-9.28c0.288-3.712-1.7-7.153-3.036-10.563-3.247-8.103-3.323-17.127-5.949-25.457-1.988-6.338-5.448-12.163-7.315-18.546-1.077-3.712-1.624-7.545-2.686-11.303-1.325-4.266-2.747-7.84-4.401-11.28l0.213 0.491c-2.186-5.47-4.796-10.189-7.908-14.523l0.138 0.202c-4.553 1.69-9.409 3.652-12.005 7.741-1.274 2.167-2.080 4.749-2.214 7.507l-0.001 0.038c-0.622 7.952 2.276 15.95 1.321 23.858-0.375 2.718-0.589 5.858-0.589 9.049 0 4.802 0.485 9.491 1.409 14.020l-0.077-0.449z',
          'M612.749 385.568c2.003 7.545-0.895 15.482-3.262 22.952-3.292 9.969-5.845 21.681-7.183 33.76l-0.072 0.797c-0.155 2.985-0.759 5.93-1.791 8.737-1.123 2.521-3.036 4.648-4.34 7.047-3.582 6.308-3.491 14.004-2.717 21.217 0.516 4.754 1.29 9.492 2.246 14.17 1.169 5.719 2.611 11.695 0.926 17.278 2.822-0.619 4.735 3.018 4.553 5.87s-1.107 6.036 0.273 8.495c3.491 1.267 3.521 6.036 3.415 9.733 0.058 6.41 0.873 12.792 2.428 19.013 5.282 25.251 10.887 50.432 16.816 75.542 12.824 3.953 27.803 8.073 40.035 2.596 2.277-1.011 4.553-2.626 5.069-5.071 0.028-0.266 0.045-0.574 0.045-0.886 0-1.079-0.194-2.113-0.55-3.069l0.020 0.061-5.797-20.975c-1.412-5.070-2.823-10.306-2.079-15.512 0.561-3.878 2.261-8.058 0.349-11.483-0.652-1.177-1.685-2.098-2.443-3.215-3.036-4.421-1.442-10.336-1.199-15.694 0.095-1.202 0.013-2.412-0.243-3.591-0.46-1.503-1.048-2.808-1.775-4.020l0.045 0.081c-4.792-9.249-7.092-19.574-6.678-29.969 0.043-0.3 0.068-0.646 0.068-0.998 0-1.052-0.22-2.052-0.617-2.958l0.019 0.047c-0.338-0.46-0.665-0.984-0.953-1.531l-0.033-0.069c-0.073-0.298-0.114-0.639-0.114-0.99 0-0.688 0.16-1.339 0.444-1.918l-0.011 0.026c-1.761-1.336-3.296-2.825-4.636-4.477l-0.039-0.049c0.847-0.529 1.545-1.219 2.067-2.032l0.016-0.026c0.505-0.786 0.849-1.721 0.964-2.727l0.003-0.030c0.025-0.213 0.039-0.459 0.039-0.709 0-0.785-0.14-1.538-0.396-2.235l0.014 0.045c-0.353-0.965-0.893-1.786-1.582-2.457l-0.001-0.001c0.645-0.132 1.206-0.429 1.655-0.845l-0.002 0.002c0.45-0.417 0.786-0.952 0.958-1.556l0.006-0.024c0.078-0.271 0.124-0.583 0.124-0.905 0-0.336-0.049-0.66-0.14-0.966l0.006 0.024c-0.186-0.625-0.527-1.156-0.979-1.566l-0.003-0.003c-0.744-0.513-1.73-0.74-2.261-1.509-0.82-1.117-0.152-2.672 0.516-3.863l3.536-6.353c2.64-4.723 3.232-10.563 6.070-15.090 4.067-6.595 6.723-13.943 9.349-21.217l10.213-28.023 6.875 5.931c2.29 1.739 4.209 3.914 5.646 6.398 0.978 2.455 1.596 5.037 1.836 7.666 2.519 15.211 12.141 28.4 15.707 43.384 0.789 3.335 1.321 6.836 3.248 9.688 0.689 0.875 1.308 1.804 1.852 2.777 0.502 1.483 0.763 3.037 0.774 4.602 0.319 3.065 1.296 6.026 2.867 8.682s3.699 4.944 6.239 6.71c3.385 2.309 7.588 3.893 9.425 7.545 0.367 1.131 0.877 2.211 1.518 3.215 1.639 1.962 5.175 2.188 5.873 4.647 0.394 1.374-0.334 3.018 0.44 4.226 0.437 0.551 1.005 0.98 1.658 1.243l0.027 0.010 9.88 4.905c11.049 5.492 16.692 18.108 24.846 27.298 2.814 2.993 5.302 6.271 7.433 9.779 3.52 6.262 5.143 14.124 11.097 18.108 1.6 0.825 3.049 1.899 4.308 3.184 1.866 2.445 1.183 5.87 1.35 8.949s2.533 6.745 5.477 5.809c-0.491 1.708-0.774 3.669-0.774 5.696s0.282 3.989 0.81 5.847l-0.037-0.151c12.925-0.66 25.251-5.624 34.998-14.094 2.882-2.505 5.659-5.704 5.689-9.507 0.046-0.656-0.099-1.311-0.425-1.886-0.579-0.734-1.331-1.307-2.194-1.662l-0.036-0.013c-9.239-4.98-12.015-16.524-16.695-25.894-4.081-8.269-10.119-15.392-15.17-23.073-10.991-16.524-18.485-36.518-35.104-47.429-3.656-2.399-7.911-4.527-9.747-8.495-1.016-2.219-1.138-4.754-1.942-7.047s-2.731-4.527-5.189-4.527c1.365-3.32 1.092-7.364 1.183-10.955 0.015-0.241 0.024-0.522 0.024-0.805 0-1.397-0.208-2.745-0.595-4.015l0.026 0.097c-0.693-1.789-1.515-3.33-2.494-4.756l0.050 0.078c-4.336-7.299-6.504-15.671-6.252-24.144 0.121-4.361 0.895-8.858-0.426-13.023-0.667-2.097-1.836-4.014-2.64-6.036-1.157-3.38-1.848-7.275-1.897-11.325l-0-0.023-0.911-14.501c-0.151-5.16-0.828-10.084-1.982-14.821l0.1 0.485c-3.035-11.257-6.070-58.414-16.466-63.725s-28.259 30.98-39.96 31.689c-5.504 0.234-10.689 1.281-15.541 3.026l0.365-0.114c-7.786 2.898-14.312 8.3-20.67 13.581l-21.521 17.972c-4.553 3.727-8.316 7.289-13.34 9.915zM509.458 77.699c4.735-6.429 12.869-9.839 20.883-10.126s15.905 2.218 23.083 5.764c2.119 1.198 4.383 2.121 6.738 2.746 3.794 0.77 8.014-0.256 11.443 1.509 4.553 2.399 5.433 8.511 5.039 13.581s-1.351 10.699 1.366 15.091c0.888 1.142 1.755 2.428 2.536 3.772l0.089 0.167c1.169 2.611 0.485 5.628-0.212 8.39-1.776-1.509-2.777-3.787-4.355-5.538s-4.326-2.928-6.284-1.615-1.927 3.697-2.034 5.84c-0.106 2.143-0.652 4.708-2.686 5.402-0.291 0.069-0.624 0.108-0.967 0.108-0.569 0-1.112-0.108-1.611-0.306l0.030 0.010c-0.827-0.326-1.509-0.871-1.995-1.564l-0.009-0.014c-3.476-4.226-2.080-10.97-5.524-15.226-1.958-2.414-5.221-3.592-7.027-6.127-1.427-1.992-1.791-4.528-3.036-6.67s-4.143-3.712-6.070-2.233c-0.644 0.613-1.186 1.325-1.603 2.113l-0.021 0.045c-1.201 1.712-2.949 2.97-4.959 3.573-0.806 0.251-1.733 0.395-2.694 0.395-1.233 0-2.41-0.238-3.489-0.67l0.063 0.022c-1.38-0.857-2.973-1.563-4.665-2.036l-0.131-0.031c-0.088-0.005-0.192-0.007-0.296-0.007-1.055 0-2.047 0.274-2.907 0.755l0.030-0.016c-0.973 0.542-1.757 1.319-2.291 2.257l-0.015 0.029c-0.962 1.665-1.529 3.662-1.529 5.792 0 0.181 0.004 0.362 0.012 0.541l-0.001-0.025c0 3.017 0.547 6.232-1.183 8.646-0.665 0.911-1.471 1.674-2.394 2.272l-0.035 0.021c-2.534 1.615-6.070 2.701-8.407 0.86-0.773-0.717-1.363-1.62-1.699-2.639l-0.013-0.044c-0.19-0.571-0.299-1.228-0.299-1.911 0-0.447 0.047-0.882 0.136-1.302l-0.007 0.041c0.455-2.1 1.054-4.167 1.791-6.187 1.336-4.678-0.41-9.944 1.047-14.35 1.653-4.242 3.728-7.907 6.244-11.219l-0.082 0.113z',
          'M528.687 184.16c-0.072 0.333-0.114 0.716-0.114 1.109 0 0.783 0.165 1.527 0.461 2.2l-0.014-0.035c0.458 0.705 1.059 1.279 1.766 1.692l0.025 0.013c5.103 3.162 10.908 5.031 16.907 5.448 0.858 0.015 1.66 0.236 2.364 0.617l-0.027-0.014c1.427 0.936 1.518 3.018 0.987 4.679-0.679 1.463-1.075 3.175-1.078 4.979l-0 0.001c0.44 3.154 4.204 4.527 7.376 4.995 4.446 0.558 9.318 0.272 12.839-2.49 2.385-2.163 4.203-4.872 5.297-7.892 8.711-19.904 11.762-41.905 20.579-61.749 0.668-1.296 1.115-2.693 1.321-4.135 0.021-0.156 0.033-0.336 0.033-0.519 0-0.58-0.122-1.132-0.342-1.63l0.010 0.026c-0.3-0.684-0.758-1.251-1.33-1.671l-0.011-0.008c-1.639-1.011-4.189-0.438-5.297-2.022-0.546-0.799-0.485-1.886-0.971-2.731-1.017-1.795-3.688-1.509-5.509-2.55-1.427-0.754-2.413-2.309-4.006-2.61-0.085-0.005-0.184-0.008-0.284-0.008-0.722 0-1.409 0.151-2.031 0.423l0.033-0.013c-0.739 0.322-1.361 0.79-1.854 1.37l-0.006 0.007c-5.175 4.798-7.892 11.605-10.776 18.033-4.97 11.044-10.118 20.371-15.914 29.236l0.495-0.807c0.683-1.056-3.278-9.054-4.826-9.401-2.716-0.543-6.192 4.195-7.664 5.96-4.619 5.569-7.547 12.333-8.438 19.497z',
          'M583.823 123.875c-1.147 0.020-2.223 0.3-3.179 0.785l0.042-0.019c-0.995 0.503-1.827 1.191-2.481 2.025l-0.012 0.016c-1.624 2.097-1.943 4.874-2.352 7.545-1.381 8.462-4.418 16.573-8.939 23.873zM591.563 129.896c-1.579 0.036-3.046 0.487-4.304 1.248l0.039-0.022c-1.294 0.781-2.341 1.85-3.073 3.124l-0.022 0.042c-0.95 2.181-1.608 4.71-1.845 7.36l-0.007 0.094c-1.301 5.688-3.811 11.034-7.361 15.679z',
          'M952.244 424.908v-18.742c0-13.797-5.514-27.027-15.33-36.781s-23.12-15.234-37.001-15.234h-744.386c-13.876 0-27.183 5.48-36.996 15.234s-15.328 22.985-15.332 36.781v34.557l849.044-15.814z',
          'M362.611 332.179s-2.125 131.073 21.248 174.2c23.371 43.128 33.388 230.743 33.388 230.743s245.008 25.197 415.744-30.18c170.735-55.381 534.027-78.031 534.027-78.031l-61.22-410.285s-302.452-19.285-474.506 62.307c-172.056 81.592-468.68 51.246-468.68 51.246z',
          'M362.611 332.179s-2.125 131.073 21.248 174.2c23.371 43.128 33.388 230.743 33.388 230.743s245.008 25.197 415.744-30.18c170.735-55.381 534.027-78.031 534.027-78.031l-61.22-410.285s-302.452-19.285-474.506 62.307c-172.056 81.592-468.68 51.246-468.68 51.246z',
          'M416.836 380.059s-7.664 108.151 11.564 142.707c19.228 34.557 20.124 188.823 20.124 188.823s220.498 10.171 377.35-42.916c156.846-53.086 486.446-87.522 486.446-87.522l-37.456-335.528s-272.718-2.792-431.893 71.934c-159.167 74.726-426.136 62.503-426.136 62.503z',
          'M840.552 607.24c31.372-3.885 50.017-61.272 41.635-128.178s-40.611-117.993-71.983-114.107c-31.372 3.885-50.017 61.272-41.635 128.178s40.611 117.993 71.983 114.107z',
          'M1139.977 18.757s-293.827 73.942-432.391 204.094c-138.561 130.153-430.252 191.781-430.252 191.781s38.427 125.384 73.97 159.306c35.543 33.922 102.958 209.453 102.958 209.453s240.956-50.796 386.344-155.641c145.393-104.846 484.238-237.262 484.238-237.262l-184.866-371.73z',
          'M272.918 395.859s38.411 125.399 73.924 159.322c35.512 33.922 102.957 209.437 102.957 209.437s240.987-50.779 386.392-155.625c145.408-104.846 484.223-237.217 484.223-237.217l-184.866-371.775s-293.82 73.942-432.378 204.094c-138.561 130.152-430.252 191.765-430.252 191.765z',
          'M272.918 395.859s38.411 125.399 73.924 159.322c35.512 33.922 102.957 209.437 102.957 209.437s240.987-50.779 386.392-155.625c145.408-104.846 484.223-237.217 484.223-237.217l-184.866-371.775s-293.82 73.942-432.378 204.094c-138.561 130.152-430.252 191.765-430.252 191.765z',
          'M339.254 424.892s26.088 105.284 55.060 132.295c28.972 27.012 77.4 173.536 77.4 173.536s212.986-57.614 345.885-156.001c132.9-98.387 436.004-231.588 436.004-231.588l-139.181-308.019s-260.415 80.536-388.852 200.231c-128.438 119.695-386.317 189.547-386.317 189.547z',
          'M812.684 511.824c28.664-13.27 28.695-73.576 0.068-134.696s-75.065-99.911-103.725-86.64c-28.661 13.271-28.689 73.576-0.064 134.697s75.065 99.91 103.721 86.64z',
          'M972.337 443.302v520.608c0 5.916-1.168 11.772-3.444 17.234s-5.613 10.422-9.815 14.601c-4.21 4.179-9.201 7.494-14.693 9.755-5.499 2.268-11.385 3.429-17.332 3.429h-778.553c-12.004-0.008-23.515-4.748-32.002-13.191s-13.254-19.888-13.254-31.827v-573.091c22.309 8.239 22.309 8.239 45.255 7.545h778.553c11.992 0 23.499 4.732 31.987 13.157 8.495 8.425 13.274 19.855 13.297 31.782z',
          'M972.337 449.927v520.605c0 11.947-4.771 23.393-13.266 31.835s-20.010 13.183-32.017 13.183h-778.553c-12.004-0.008-23.515-4.748-32.002-13.191s-13.254-19.888-13.254-31.827v-573.104c22.309 8.225 22.309 8.225 45.255 7.545h778.553c12 0 23.506 4.734 31.994 13.163s13.274 19.862 13.289 31.791z',
          'M970.122 642.401v166.491h-162.384c-22.012-0.296-43.016-9.193-58.478-24.773-15.459-15.58-24.126-36.587-24.126-58.473s8.668-42.89 24.126-58.47c15.462-15.579 36.466-24.479 58.478-24.774h162.384z',
          'M972.337 637.965v166.52h-162.384c-22.012-0.296-43.016-9.193-58.477-24.773-15.459-15.58-24.126-36.586-24.126-58.472s8.668-42.891 24.126-58.47c15.462-15.579 36.465-24.48 58.477-24.774l162.384-0.030z',
          'M817.736 758.112c18.030 0 32.647-14.532 32.647-32.459s-14.617-32.459-32.647-32.459c-18.030 0-32.647 14.532-32.647 32.459s14.617 32.459 32.647 32.459z',
          'M819.951 753.706c18.030 0 32.647-14.532 32.647-32.459s-14.617-32.459-32.647-32.459c-18.030 0-32.639 14.532-32.639 32.459s14.609 32.459 32.639 32.459z',
          'M1254.21 636.531c1.289 13.898-9.284 27.389-6.205 40.999 0.667 2.913 1.927 5.659 2.382 8.602 1.274 8.088-3.565 15.739-8.192 22.499l-39.769 58.003c-1.593 2.556-3.497 4.892-5.674 6.978-7.585 6.728-19.001 6.030-28.983 8.040-7.024 1.418-13.653 4.331-19.426 8.541-0.243 0.205-0.402 0.493-0.432 0.812-0.030 0.311 0.053 0.63 0.25 0.88 1.646 2.23 3.831 4.020 6.356 5.196 2.526 1.183 5.302 1.714 8.086 1.547 1.047 1.373 0 3.383-1.517 4.361-2.139 1.509-5.067 1.874-5.492 5.461-0.152 1.252 0.106 2.526 0.728 3.626 1.6 2.435 4.096 4.164 6.948 4.809 13.767 4.179 28.642-3.171 38.942-13.175 10.308-10.005 17.696-22.634 27.807-32.821 5.598-5.628 11.962-10.452 17.727-15.917 11.499-10.895 20.442-24.144 29.074-37.408 2.594-3.999 5.211-8.103 6.303-12.736s0.576-9.311 1.805-13.792c1.608-5.885 5.932-10.563 9.527-15.498 7.062-9.657 11.765-21.473 10.839-33.364s-8.351-23.646-19.638-27.69c-3.504-1.397-7.358-1.63-11.006-0.664-4.627 1.418-8.040 5.221-11.196 8.858l-7.593 8.677c-1.889 1.904-3.383 4.16-4.399 6.64-0.485 1.245-0.599 2.602-0.334 3.911 0.273 1.308 0.91 2.512 1.851 3.468z',
          'M1254.21 636.531c1.289 13.898-9.284 27.389-6.205 40.999 0.667 2.913 1.927 5.659 2.382 8.602 1.274 8.088-3.565 15.739-8.192 22.499l-39.769 58.003c-1.593 2.556-3.497 4.892-5.674 6.978-7.585 6.728-19.001 6.030-28.983 8.040-7.024 1.418-13.653 4.331-19.426 8.541-0.243 0.205-0.402 0.493-0.432 0.812-0.030 0.311 0.053 0.63 0.25 0.88 1.646 2.23 3.831 4.020 6.356 5.196 2.526 1.183 5.302 1.714 8.086 1.547 1.047 1.373 0 3.383-1.517 4.361-2.139 1.509-5.067 1.874-5.492 5.461-0.152 1.252 0.106 2.526 0.728 3.626 1.6 2.435 4.096 4.164 6.948 4.809 13.767 4.179 28.642-3.171 38.942-13.175 10.308-10.005 17.696-22.634 27.807-32.821 5.598-5.628 11.962-10.452 17.727-15.917 11.499-10.895 20.442-24.144 29.074-37.408 2.594-3.999 5.211-8.103 6.303-12.736s0.576-9.311 1.805-13.792c1.608-5.885 5.932-10.563 9.527-15.498 7.062-9.657 11.765-21.473 10.839-33.364s-8.351-23.646-19.638-27.69c-3.504-1.397-7.358-1.63-11.006-0.664-4.627 1.418-8.040 5.221-11.196 8.858l-7.593 8.677c-1.889 1.904-3.383 4.16-4.399 6.64-0.485 1.245-0.599 2.602-0.334 3.911 0.273 1.308 0.91 2.512 1.851 3.468z',
          'M1284.308 994.319c-8.685 5.264-19.502 5.583-29.597 4.361-1.623-0.197-3.55-0.319-4.551 0.933-1.517 1.813 0.273 4.528 2.124 5.932 5.954 4.445 12.948 7.305 20.321 8.313 6.584 0.925 13.229 1.365 19.881 1.312 18.212 0.319 36.424 0.622 54.348-1.972 1.062-0.083 2.094-0.379 3.034-0.88 1.161-0.804 1.957-2.018 2.245-3.391 1.229-4.65-1.138-9.633-4.718-12.857-3.58-3.231-8.177-5.029-12.675-6.766l-15.777-6.106c-3.709-1.434-9.641-5.241-13.661-4.938-7.562 0.546-14.708 12.402-20.973 16.058z',
          'M1284.308 994.319c-8.685 5.264-19.502 5.583-29.597 4.361-1.623-0.197-3.55-0.319-4.551 0.933-1.517 1.813 0.273 4.528 2.124 5.932 5.954 4.445 12.948 7.305 20.321 8.313 6.584 0.925 13.229 1.365 19.881 1.312 18.212 0.319 36.424 0.622 54.348-1.972 1.062-0.083 2.094-0.379 3.034-0.88 1.161-0.804 1.957-2.018 2.245-3.391 1.229-4.65-1.138-9.633-4.718-12.857-3.58-3.231-8.177-5.029-12.675-6.766l-15.777-6.106c-3.709-1.434-9.641-5.241-13.661-4.938-7.562 0.546-14.708 12.402-20.973 16.058z',
          'M1295.368 785.984c-6.569 8.693-13.365 18.728-11.742 29.484 0.88 5.795 4.142 10.915 6.538 16.27 3.246 7.274 4.946 15.087 6.614 22.877 2.465 11.378 4.938 22.786 6.44 34.346 1.714 13.054-6.349 50.821-7.092 63.966-0.182 3.171-0.561 6.592-2.776 8.875-0.865 0.903-2.018 1.623-2.412 2.807-0.228 1.13-0.046 2.313 0.531 3.315 3.702 8.298 11.279 14.488 19.729 18.022 8.457 3.527 28.839 9.626 38.047 9.944 1.214 0.129 2.442-0.030 3.58-0.47 1.229-0.743 2.192-1.843 2.761-3.155 6.607-12.553 0.258-57.192 0.349-71.361 0.091-11.81 2.905-23.552 2.389-35.355-0.425-9.474-3.042-18.743-3.906-28.187-1.517-15.481 1.335-31.039 4.21-46.345 2.185-11.734 4.384-23.476 7.191-35.066 1.714-7.077 3.702-14.215 7.585-20.357 3.042-4.874 7.305-8.949 10.839-13.581 9.815-12.795 14.177-28.914 12.144-44.879-0.212-1.509-22.771 5.689-24.758 6.549-8.109 3.416-15.572 8.187-22.065 14.11-5.219 4.949-9.33 11.558-13.904 17.097-6.463 7.836-12.849 15.729-19.153 23.676-7.191 9.087-14.237 18.227-21.14 27.42z',
          'M1295.368 785.454c-6.569 8.693-13.365 18.743-11.742 29.491 0.88 5.81 4.142 10.923 6.538 16.278 3.246 7.259 4.946 15.095 6.614 22.862 2.465 11.393 4.938 22.801 6.44 34.346 1.714 13.069-6.349 50.821-7.092 63.966-0.182 3.171-0.561 6.614-2.776 8.89-0.865 0.887-2.018 1.616-2.412 2.791-0.235 1.138-0.046 2.313 0.531 3.322 3.702 8.313 11.279 14.488 19.729 18.106 8.457 3.618 28.839 6.774 38.047 7.077 1.214 0.137 2.442-0.030 3.58-0.47 1.229-0.728 2.2-1.828 2.761-3.133 6.607-12.561 0.258-54.325 0.349-68.509 0.091-11.833 2.905-23.56 2.389-35.377-0.425-9.474-3.042-18.735-3.906-28.171-1.517-15.497 1.335-31.054 4.21-46.353 2.185-11.727 4.384-23.469 7.191-35.074 1.714-7.077 3.702-14.215 7.585-20.355 3.042-4.873 7.305-8.948 10.839-13.581 9.815-12.794 14.177-28.914 12.144-44.879-0.212-1.509-22.771 5.689-24.758 6.549-8.109 3.426-15.572 8.203-22.065 14.124-5.219 4.935-9.33 11.544-13.904 17.082-6.463 7.837-12.849 15.734-19.153 23.692-7.191 9.016-14.237 18.126-21.14 27.326z',
          'M1222.246 594.551c20.343 0 36.834-16.398 36.834-36.624s-16.49-36.624-36.834-36.624c-20.336 0-36.826 16.397-36.826 36.624s16.49 36.624 36.826 36.624z',
          'M1255.424 556.387c3.48 5.46 7.856 10.021 12.969 13.601l0.153 0.102c5.249 3.645 11.188 6.201 17.461 7.514l-2.776 10.035c-4.801 17.233-10.187 35.462-23.575 47.413 1.517-5.84-0.425-12.072-3.732-17.143s-7.949-9.054-12.5-12.993l-21.208-18.259c-0.604-0.496-1.11-1.085-1.5-1.75l-0.017-0.031c-0.248-0.594-0.393-1.284-0.393-2.007s0.144-1.413 0.406-2.042l-0.013 0.035c2.708-8.36 10.414-13.581 16.695-19.225 3.113-2.885 5.877-6.069 8.272-9.527l0.125-0.191c4.233-6.005 6.857 0.030 9.633 4.467z',
          'M1173.732 521.107l-0.834-6.881c5.81 1.509 11.332-3.41 15.057-8.495 3.717-5.086 7.16-11.077 12.819-13.204 6.88-2.565 14.162 1.509 20.73 4.949 7.358 4.060 15.436 6.673 23.787 7.697 1.327 0.043 2.647 0.256 3.929 0.633 4.278 1.509 6.311 6.851 6.933 11.695s0.455 9.99 2.564 14.306c1.517 3.275 4.346 5.704 6.076 8.933 4.551 8.662 0.152 20.507 4.9 29.003l-11.81-10.76c-1.077-0.981-2.594-2.007-3.793-1.177-0.941 0.664-1.016 2.098-1.396 3.245-1.138 3.35-5.355 4.346-8.404 3.017-3.057-1.327-5.287-4.21-7.593-6.836-5.219-6.127-11.438-11.514-18.728-14.124-3.193-1.187-6.599-1.685-10.005-1.462-3.398 0.224-6.713 1.164-9.724 2.759-5.507 3.094-9.542 10.307-16.301 10.563-9.254 0.347-13.107-16.795-17.393-23.57 1.57-1.172 2.67-2.854 3.118-4.752 0.44-1.899 0.197-3.892-0.683-5.63 0.622-0.256 6.614-0.966 6.751 0.091z',
          'M718.149 306.993c-2.96 2.626-5.638 5.418-8.078 8.411l-0.102 0.13c-2.501 3.11-3.832 6.99-3.764 10.97 0.015 1.209 0.411 2.323 1.074 3.23l-0.011-0.016c0.344 0.441 0.811 0.771 1.35 0.938l0.019 0.005c0.238 0.075 0.512 0.118 0.796 0.118 0.311 0 0.61-0.052 0.889-0.147l-0.019 0.006c0.619-0.317 1.129-0.767 1.509-1.314l0.009-0.013c1.604-1.917 3.306-3.75 5.1-5.493 0.652-0.649 1.518-1.327 2.398-1.086 0.408 0.146 0.755 0.379 1.031 0.677l0.002 0.002c0.998 0.86 1.743 1.988 2.127 3.271l0.013 0.049c0.531 2.309-0.82 4.617-2.352 6.428s-3.339 3.546-3.961 5.825c-0.112 0.277-0.177 0.599-0.177 0.936s0.065 0.658 0.183 0.953l-0.006-0.017c0.295 0.433 0.695 0.774 1.166 0.989l0.018 0.007c2.173 1.189 4.583 1.89 7.059 2.052s4.957-0.219 7.268-1.117c3.035-1.222 5.737-3.319 8.863-4.406 1.354-0.368 2.666-0.874 3.916-1.509 0.9-0.601 1.652-1.347 2.24-2.214l0.018-0.028c0.596-0.889 1.010-1.886 1.217-2.934 0.394-2.094 0.472-4.236 0.228-6.353-0.379-8.198-2.144-16.273-5.221-23.888-0.188-0.507-0.49-0.933-0.876-1.264l-0.004-0.003c-0.416-0.256-0.921-0.408-1.461-0.408-0.020 0-0.040 0-0.060 0.001l0.003-0c-3.885-0.407-10.259-2.384-14.008-0.951-1.311 0.715-2.442 1.716-3.309 2.928-0.698 0.77-5.084 4.225-5.084 5.236z',
          'M716.92 303.583c0-3.682-4.553-12.57 2.686-13.158 0-3.939-5.6-6.384-4.553-10.563 0.334-1.389 1.518-2.521 1.654-3.939 0.455-4.029-6.86-6.217-5.646-10.080 0.455-1.509 2.064-2.384 2.413-3.878 0.82-3.485-5.448-5.040-5.57-8.617 0-1.207 0.683-2.339 0.623-3.546 0-1.509-1.321-2.656-2.050-3.969-1.897-3.365-0.971-8.571-4.431-10.307 2.291 0.196 3.036-3.184 2.094-5.251s-2.868-3.863-2.883-6.157c0.054-0.376 0.085-0.811 0.085-1.252s-0.031-0.876-0.091-1.301l0.006 0.049c-0.638-2.203-4.264-2.384-4.872-4.527-0.055-0.547-0.087-1.183-0.087-1.826 0-0.228 0.004-0.455 0.012-0.682l-0.001 0.033c-0.243-1.705-2.003-2.791-3.658-3.275-1.835-0.316-3.477-0.922-4.959-1.774l0.073 0.039c-1.063-0.799-2.292-2.128-3.43-1.509-0.425 0.256-0.638 0.74-0.956 1.101-1.365 1.585-3.976 0.891-5.691-0.272-5.068-3.425-7.588-9.567-8.665-15.558s-1.048-12.178-2.398-18.108c-0.478-2.126-1.041-3.942-1.729-5.695l0.091 0.262c-0.577-1.509-2.429-3.878-2.55-5.402-0.273-3.471 6.951-1.101 9.698-0.755 2.667 0.259 5.304 0.765 7.877 1.509 2.746 1.032 5.436 2.205 8.059 3.516 10.958 4.814 24.191 5.402 32.993 13.491 2.899 2.656 5.342 6.141 9.106 7.349 1.726 0.329 3.429 0.768 5.1 1.313 4.173 1.946 4.826 7.455 7.103 11.438 0.715 1.052 1.34 2.163 1.866 3.319 0.439 1.365 0.645 2.793 0.608 4.226l0.319 10.457c0.516 17.52 1.032 35.085-0.85 52.499-0.608 5.75-1.518 11.664 0.197 17.188 0.455 1.509 1.092 2.927 1.518 4.451 0.375 1.787 0.568 3.608 0.576 5.433l0.243 6.776c0.017 0.1 0.026 0.215 0.026 0.332 0 0.439-0.135 0.847-0.365 1.184l0.005-0.007c-0.243 0.197-0.535 0.345-0.853 0.423l-0.015 0.003c-0.153 0.038-0.328 0.060-0.509 0.060-0.163 0-0.321-0.018-0.473-0.051l0.015 0.003c-9.485-0.845-19.077-6.157-28.031-2.942z',
          'M1149.785 824.191c61.986 0 112.246-7.221 112.246-16.134 0-8.905-50.259-16.126-112.246-16.126-61.994 0-112.246 7.221-112.246 16.126 0 8.913 50.252 16.134 112.246 16.134z',
          'M1246.352 808.846c-1.972-8.404-3.201-15.785-3.201-15.785s0.455-9.148-3.679-16.012v-19.194c1.176-3.069 2.617-6.032 4.301-8.858 3.034-5.312 0-24.778 0-24.778s-11.34-27.449-8.594-44.863c2.746-17.413-23.279-77.321-23.279-77.321 0.175-6.156 1.055-12.028 2.564-17.643l-0.121 0.53c0.281-1.176 0.387-2.385 0.334-3.592v-0.302c-0.394-11.484-9.527-33.002-9.527-33.002l1.229-41.015s5.825-24.144-3.679-56.664c-3.322-11.332-5.446-20.402-6.796-27.404-0.152-0.784-0.303-1.509-0.425-2.279 19.562-3.018 34.513-5.433 34.513-5.433s-11.355-47.216-19.016-55.486c-7.669-8.269-13.797-34.239-13.797-34.239s-3.99-33.335 2.458-43.082c6.455-9.748 7.365-26.559 7.365-26.559s14.7-10.563 16.551-15.347c1.858-4.783 4.908-15.346 4.908-20.945s-1.836-10.563-1.229-13.581c0.607-3.018-4.301-14.17-1.836-19.482 0.63-1.632 0.963-3.366 0.971-5.115v-0.151c0.001-0.102 0.001-0.223 0.001-0.345 0-4.778-0.47-9.447-1.365-13.962l0.075 0.454c-4.255-3.572-9.224-6.209-14.571-7.741l-1.153-4.587c-0.47-0.306-0.948-0.589-1.441-0.845v-1.208l-0.137-4.798 2.306-10.775c4.551-18.741-20.624-21.534-20.624-21.534-1.549-2.866-4.038-5.057-7.046-6.187l-0.091-0.030c-5.052-1.766-0.834 28.188 1.517 30.18 1.783 1.509 7.274 10.835 9.929 15.453l0.425 0.755c-0.417 0.371-0.804 0.775-1.153 1.207l0.956 6.504 0.152 0.996c-1.669 2.060-3.026 4.353-4.020 6.805 0 0 4.551 5.010 3.686 10.563s1.411 12.6 1.517 12.977c-0.273-0.317-3.504-3.788-6.736-2.943-3.239 0.845-12.265 3.547-12.265 3.547s-6.736 1.176-6.068 2.656c0.667 1.479-4.559 7.967-4.559 7.967l-18.121-17.082c-0.182-0.514-0.379-1.026-0.531-1.509-0.676-2.166-1.21-4.725-1.5-7.357l-0.017-0.188c1.98-0.466 3.914-1.077 5.803-1.826 1.904-0.65 3.618-1.748 5.006-3.199 1.836-2.158 2.185-5.086 2.928-7.772 1.426-5.251 4.551-9.914 6.72-14.909 2.539-5.675 4.017-12.3 4.017-19.27 0-2.669-0.217-5.288-0.634-7.839l0.038 0.279c-0.281-2.8-1.236-5.492-2.776-7.847-2.966-4.044-8.336-5.689-12.235-8.919s-6.417-8.164-10.976-10.563c-4.111-2.188-9.102-1.931-13.744-1.176-9.072 1.487-17.787 4.639-25.699 9.295-2.64 1.509-5.552 3.366-8.586 2.807-2.609-0.468-4.551-2.536-6.197-4.528 0.023-0.082 0.046-0.163 0.076-0.241-0.068-0.074-0.137-0.154-0.197-0.241-1.919 4.238-2.882 8.843-2.822 13.49 0 0.724 0 1.509 0.091 2.158v1.373c0 0.322-0.046 0.642-0.137 0.951-0.379 0.923-0.963 1.752-1.699 2.43-0.554 0.629-1.062 1.3-1.517 2.007 0-0.242 0.152-0.483 0.243-0.74-1.161 1.68-1.813 3.653-1.881 5.689-0.083 1.481 0.402 2.939 1.365 4.074 0.91 0.878 1.896 1.666 2.958 2.354-0.357 1.992-0.539 4.012-0.546 6.036 0.038 6.001 1.623 11.891 4.619 17.101s7.289 9.565 12.47 12.641c0.212 0.498 0.41 1.011 0.607 1.509 2.321 6.036 4.066 13.128 3.292 19.618 0 0.468-0.137 0.95-0.212 1.418s-0.455 0.498-0.652 0.755c0 0-29.939 0.302-36.985-6.036-7.039-6.338-17.787 15.497-17.787 15.497s-10.725 2.068-12.88 0c-2.154-2.067-14.708-0.287-14.708-0.287-5.143-4.547-11.833-6.975-18.713-6.79-4.172-3.149-8.768-5.69-13.661-7.545l-0.334-0.121c-2.154-0.783-4.468-1.072-6.751-0.845 0 0-14.723-12.073-19.016-18.591s-24.735-30.588-24.826-30.693v-1.162l-0.228-3.501c-0.614 0.095-1.221 0.145-1.843 0.151-0.106-0.347-0.258-0.755-0.41-1.223-1.176-3.415-2.624-6.73-4.339-9.914 0 0 0-4.421 1.289-5.538s-0.531-17.339-0.531-17.339-13.259-30.829-25.145-7.817c0 0-22.46 14.894-3.611 32.248 0 0 7.585 3.622 8.586 6.489 0.698 1.856 3.246 7.062 4.961 10.562l0.774 1.509-0.212 0.181 0.273 2.897 0.121 1.117c-3.55 2.007-5.962 3.999-5.37 5.493 1.047 2.556 1.767 5.233 2.139 7.967 0 0 26.078 32.474 29.446 46.342 0 0 69.92 41.317 92.911 44.26l-4.066 20.598c-0.599 5.59-0.903 11.206-0.918 16.825 0.311 4.421-2.761 24.492-2.761 24.492s-3.99 29.516-7.358 33.651c-3.368 4.135-2.761 21.835-2.761 21.835-0.796 8.473-2.321 16.864-4.551 25.080-3.375 11.212-0.925 25.095-0.925 25.095s-11.643 26.559 16.247 8.556c0 0 13.661-0.845 29.476-1.388v1.509c0 2.022 0 4.21-0.106 6.504-0.212 15.211-0.303 36.216 0.394 52.031 1.229 28.037 9.815 83.524 9.815 83.524v27.932c-0.554 2.62-0.827 5.291-0.819 7.967-0.182 9.828 2.45 19.505 7.593 27.902l2.154 18.591s5.037 12.253 5.128 19.618c-0.015 0.593-0.091 1.184-0.212 1.765-0.197 0.938-0.273 1.896-0.243 2.852-0.288 8.451 4.824 28.671 4.824 28.671s0.303 20.356 3.375 21.549c2.624 1.011-3.512 11.725-5.332 14.803-0.046-0.188-0.083-0.38-0.106-0.573l-0.379 0.604c-0.63 1.648-0.956 3.397-0.956 5.161-0.174 1.39 0.061 2.8 0.66 4.066s1.555 2.336 2.738 3.086c5.833 3.547 8.958 6.49 4.013 7.666-1.82 0.281-3.626 0.66-5.408 1.13 0-0.228-0.182-0.463-0.258-0.675-0.698 0.265-1.274 0.774-1.646 1.418-0.364 0.652-0.501 1.403-0.372 2.139 0.046 2.397 0.667 4.741 1.805 6.849 4.908 10.93 8.306 15.095 8.306 15.095l2.351-0.258c-0.349 0.895-0.804 1.737-1.365 2.518-0.895 1.267-2.086 2.298-3.459 3.019-1.289 0.766-2.723 1.252-4.21 1.434-1.661 0.053-3.292 0.455-4.786 1.176-1.494 0.728-2.822 1.752-3.891 3.019-3.034 3.937-4.976 9.299 1.062 14.002l21.929 7.547s37.729 4.877 35.726-3.542c-2.002-8.427-3.216-15.785-3.216-15.785 0.010-0.306 0.016-0.665 0.016-1.026 0-5.043-1.124-9.823-3.136-14.104l0.086 0.203c-0.394-0.766-0.842-1.502-1.335-2.2l1.335-0.137s2.761-18.606 6.432-22.141c0.85-0.812 1.047-1.509 0.85-1.927 0.379-1.016-0.592-1.6-1.82-1.949l-0.273 0.736c-1.198-0.258-2.427-0.394-3.656-0.402 0 0-1.229-9.736 2.761-13.282 0.307-0.386 0.544-0.843 0.684-1.341l0.007-0.027c0.129-0.498 0.159-1.019 0.083-1.528 0.030-1.336-0.114-2.67-0.425-3.969-0.042 0.093-0.088 0.172-0.14 0.247l0.003-0.005c-2.002-8.843-8.799-22.892-8.799-22.892s-0.311-8.843 2.154-12.389c2.458-3.546-0.319-48.108-0.319-48.108s0.925-21.534-1.836-31.568c-2.769-10.035 3.368-21.851 3.368-21.851v-0.785l-0.349-3.395c-0.004 0.032-0.006 0.069-0.006 0.106s0.002 0.074 0.006 0.11l-0-0.004c-0.622-5.704-1.79-16.041-2.655-20.809-1.236-6.791 0.319-39.234 0.319-39.234l5.507-13.883 9.815 23.918 10.43 31.871s5.158 6.73 5.279 13.581v0.996c-0.083 0.706-0.121 1.416-0.121 2.128-0.012 0.256-0.019 0.556-0.019 0.857 0 3.917 1.192 7.555 3.233 10.572l-0.043-0.067s2.761 15.090 7.062 18.878c4.293 3.787 4.293 11.212 4.293 11.212s5.203 21.851 7.585 25.653c2.063 3.23 2.169 12.073 2.154 14.834v0.785s0.728 7.817 0.698 14.366v2.339c0.004-0.025 0.006-0.054 0.006-0.083s-0.002-0.058-0.006-0.086l0 0.003c0 1.789-0.212 3.572-0.637 5.312l-0.091 0.301c0-0.377 0-0.739 0.106-1.101-0.966 3.883-1.521 8.34-1.521 12.927 0 0.23 0.001 0.46 0.004 0.689l-0-0.035c-0.137 7.847 1.062 17.143 5.848 22.635 8.283 9.447 13.486 8.269 13.486 8.269s-3.975 11.801-8.89 14.166c-0.197 0.095-0.366 0.207-0.519 0.337l0.003-0.003c0-0.243-0.091-0.463-0.121-0.69-0.546 0.584-0.971 1.282-1.229 2.040s-0.357 1.563-0.288 2.367c-0.349 5.188 2.943 13.577 6.068 17.484 1.161 1.13 2.587 1.965 4.142 2.42-0.243 0.174-0.501 0.326-0.774 0.463-0.546 0.303-1.107 0.569-1.684 0.804-0.796 0.334-1.638 0.554-2.503 0.645-1.661 0.046-3.3 0.448-4.794 1.168-1.502 0.721-2.822 1.752-3.884 3.026-3.042 3.929-4.983 9.284 1.062 13.995l21.929 7.54s37.486 4.786 35.514-3.618z',
          'M1102.309 822.788l-21.246-7.547c-5.856-4.703-3.99-10.066-1.032-14.002 1.016-1.252 2.298-2.276 3.747-3.004 1.449-0.721 3.042-1.13 4.657-1.191 1.441-0.182 2.822-0.667 4.058-1.434 1.343-0.728 2.496-1.76 3.368-3.019 1.547-2.442 2.382-5.272 2.412-8.162 0 0 23.309-6.789 29.681 0 1.138 1.229 2.094 2.617 2.829 4.119 2.116 4.688 3.155 9.785 3.034 14.928 0 0 1.183 7.358 3.11 15.785 1.927 8.42-34.619 3.527-34.619 3.527zM1206.181 812.373l-21.254-7.54c-5.856-4.71-3.99-10.066-1.032-13.995 1.016-1.259 2.291-2.283 3.739-3.011 1.449-0.721 3.034-1.123 4.657-1.183 0.842-0.083 1.661-0.303 2.427-0.645 0.561-0.235 1.107-0.501 1.638-0.804 5.932-3.239 5.78-11.211 5.78-11.211s23.302-6.789 29.688 0c0.857 0.925 1.6 1.934 2.23 3.019 3.99 6.865 3.55 16.027 3.55 16.027s1.183 7.38 3.034 15.785c1.858 8.404-34.459 3.557-34.459 3.557z',
          'M1127.97 784.414c1.138 1.229 2.094 2.617 2.829 4.119l-34.907 4.028c1.547-2.442 2.382-5.272 2.412-8.162 0 0 23.294-6.774 29.666 0.015zM1234.087 777.034v6.508c-5.431 8.882-31.706 6.94-39.337 2.488 0.561-0.235 1.107-0.501 1.638-0.804 5.932-3.239 5.78-11.211 5.78-11.211s23.302-6.789 29.688 0c0.857 0.925 1.6 1.934 2.23 3.019z',
          'M1238.228 748.998c-1.623 2.834-3.011 5.797-4.142 8.858v23.312c-5.947 9.732-36.803 6.493-40.975 1.176-4.172-5.31-8.533-19.13-3.838-21.527 4.688-2.402 8.602-14.173 8.602-14.173s-5.052 1.177-13.069-8.269c-8.010-9.447-5.628-30.392-4.142-35.402s0-21.835 0-21.835 0.303-11.815-2.063-15.648c-2.367-3.833-7.418-25.653-7.418-25.653s0-7.379-4.157-11.212c-4.164-3.833-6.834-18.892-6.834-18.892-2.427-3.764-3.474-8.247-2.958-12.691 0.88-7.379-5.052-15.346-5.052-15.346l-10.096-31.886-9.497-23.902-5.348 13.867s-1.517 32.459-0.288 39.234c1.229 6.776 3.042 24.794 3.042 24.794s-5.939 11.8-3.269 21.835c2.678 10.035 1.707 31.599 1.707 31.599s2.67 44.546 0.288 48.092c-2.389 3.546-2.086 12.404-2.086 12.404s12.144 25.955 8.321 29.501c-3.823 3.546-2.67 13.281-2.67 13.281s8.298 0 4.748 3.542c-3.55 3.55-6.235 22.141-6.235 22.141l-35.893 4.179s-3.277-4.119-8.033-15.095c-4.748-10.968 0.88-9.732 5.666-10.923 4.779-1.191 1.76-4.119-3.891-7.665-5.643-3.547-2.367-11.514-2.367-11.514s8.609-14.456 5.636-15.633c-2.981-1.177-3.269-21.549-3.269-21.549s-5.932-24.144-4.445-30.693c1.487-6.549-4.748-22.122-4.748-22.122l-2.078-18.591c-6.349-10.55-8.67-23.021-6.531-35.13v-28.671s-8.313-55.471-9.497-83.509c-0.759-17.957-0.546-42.463-0.303-57.75 0.152-8.571 0.303-14.26 0.303-14.26l128.212-13.279s-0.121 5.885 2.321 18.939c1.32 7.002 3.368 16.071 6.584 27.404 9.201 32.459 3.565 56.648 3.565 56.648l-1.198 41.031s11.279 27.433 8.913 36.88c-1.434 5.609-2.238 11.358-2.397 17.143 0 0 25.221 59.908 22.551 77.322s8.298 44.863 8.298 44.863 3.004 19.467 0.030 24.779z',
          'M1164.925 595.26l39.033-5.175s-22.111 22.438-39.033 5.175z',
          'M1198.315 552.163s1.335 13.731-7.115 18.892c0 0 15.132-2.354 7.115-18.892zM1195.918 508.492s-32.631 26.71-44.495 24.491c-11.871-2.218 44.495-24.491 44.495-24.491zM1116.547 607.785s-24.781 5.598-25.524 15.497c-0.751 9.899 25.524-15.497 25.524-15.497z',
          'M1121.993 730.859s-35.013 6.489-25.069 10.911c9.937 4.421 26.267 7.967 26.267 7.967s11.31 0.589-1.198-18.878z',
          'M1089.847 748.802c-0.885-0.556-1.614-1.278-2.161-2.129l-0.016-0.027c-0.529-0.823-0.893-1.8-1.021-2.851l-0.003-0.033-0.364 0.619s-3.262 7.967 2.382 11.498c0.637 0.407 1.259 0.815 1.828 1.207 1.047-0.196 2.169-0.347 3.246-0.618 4.779-1.177 1.76-4.12-3.891-7.666zM1134.956 746.432c0.971-0.875 0.941-3.139 0.349-6.036-1.517 2.279-1.957 5.84-1.987 8.541 0.364-0.938 0.925-1.79 1.638-2.505zM1129.571 599.621c-1.289 3.49-2.086 7.141-2.374 10.85 0.683-2.562 1.593-5.057 2.723-7.455l-0.349-3.395zM1209.761 584.138c0.235-1.060 0.341-2.144 0.319-3.229-0.44 2.203-0.743 4.24-0.971 6.036 0.197-0.921 0.41-1.796 0.652-2.807zM1128.736 704.542c0.485-0.724 0.759-3.169 0.88-6.564-1.1 2.628-1.684 5.439-1.722 8.285 0.212-0.605 0.493-1.183 0.842-1.72zM1136.018 760.195c-1.843 5.916-3.209 11.977-4.081 18.106l-35.893 4.119s-3.277-4.119-8.033-15.087c-0.379-0.85-0.721-1.714-1.016-2.594-2.154 0.978-3.034 3.201-0.182 9.671 4.756 10.923 8.048 15.087 8.048 15.087l35.893-4.134s2.67-18.591 6.22-22.134c1.82-1.707 0.698-2.594-0.956-3.034zM1088.664 707.198s0.288 20.357 3.269 21.534c1.517-3.365 2.503-6.564 1.168-7.092-3.042-1.177-3.269-21.549-3.269-21.549s-5.932-24.144-4.445-30.693c1.487-6.549-4.748-22.121-4.748-22.121l-2.078-18.591c-6.349-10.549-8.67-23.020-6.523-35.13v-28.671s-8.321-55.471-9.504-83.508c-0.759-17.957-0.546-42.463-0.303-57.75 0-2.762 0.091-5.206 0.137-7.273l-1.016 0.105s-0.167 5.674-0.303 14.26c-0.243 15.286-0.47 39.793 0.303 57.735 1.183 28.038 9.481 83.524 9.481 83.524v28.672c-2.124 12.106 0.197 24.57 6.546 35.114l2.063 18.591s6.235 15.633 4.748 22.137c-1.487 6.504 4.475 30.708 4.475 30.708zM1194.325 774.47c-2.913-4.195-4.862-8.988-5.689-14.017-3.664 3.284 0.546 16.058 4.551 21.125 4.142 5.31 35.013 8.556 40.975-1.191v-5.613c-8.086 7.889-35.923 4.718-39.837-0.303zM1239.427 741.12c-1.623 2.835-3.019 5.797-4.157 8.858v4.18c0.683-1.509 1.638-3.531 3.034-5.915 0.941-2.324 1.388-4.816 1.305-7.319 0 0-0.137 0.136-0.182 0.196zM1196.146 745.784c1.13-2.273 2.109-4.617 2.928-7.017 0 0-5.052 1.177-13.062-8.269-5.833-6.866-6.167-19.844-5.332-28.324-1.517 5.024-3.868 25.97 4.142 35.416 5.241 6.172 9.201 7.802 11.325 8.194zM1180.664 680.338c0.523 5.814 0.721 11.653 0.592 17.489 0.152-0.922 0.357-1.833 0.607-2.731 1.517-5.025 0-21.835 0-21.835s0.303-11.815-2.078-15.648c-2.382-3.833-7.342-25.683-7.342-25.683s0-7.379-4.157-11.212c-4.164-3.833-6.834-18.893-6.834-18.893-2.45-3.755-3.527-8.239-3.034-12.691 0.895-7.379-5.037-15.346-5.037-15.346l-10.096-31.871-9.497-23.902-5.355 13.882s0 1.751-0.19 4.528l4.346-11.272 9.497 23.857 10.096 31.871s5.932 7.967 5.037 15.347c-0.493 4.451 0.584 8.935 3.034 12.69 0 0 2.67 15.091 6.834 18.893 4.157 3.802 4.142 11.212 4.142 11.212s5.052 21.835 7.418 25.654c2.367 3.818 2.018 15.663 2.018 15.663z',
          'M1205.589 137.396l-2.238 10.774 0.137 4.798 0.091 3.532-12.379 1.267-1.381-2.55c-2.564-4.618-7.896-14.004-9.61-15.453-2.291-1.902-6.372-31.871-1.517-30.090 2.989 1.148 5.446 3.358 6.895 6.202 0 0 24.386 2.777 20.002 21.519z',
          'M1203.579 156.5l-12.379 1.267-1.381-2.55c1.661-1.886 3.937-3.139 6.425-3.546s5.044 0.057 7.229 1.312l0.106 3.516z',
          'M1206.712 162.339l-16.331 3.758-0.349-2.414-0.925-6.504s6.463-8.571 15.815-2.143l0.819 3.304 0.971 3.999z',
          'M942.186 138.572l-17.438 9.296-1.517-3.259c-1.654-3.456-4.134-8.662-4.817-10.563-1.032-2.867-8.298-6.488-8.298-6.488-18.212-17.339 3.489-32.248 3.489-32.248 11.507-23.013 24.28 7.817 24.28 7.817s1.798 16.252 0.539 17.338c-1.267 1.087-1.267 5.538-1.267 5.538 1.669 3.19 3.072 6.505 4.21 9.915 0.531 1.644 0.819 2.656 0.819 2.656z',
          'M942.186 138.573l-17.438 9.295-1.517-3.259c2.458-2.052 11.181-9.054 14.048-8.767 1.373 0.17 2.753 0.206 4.134 0.105 0.485 1.615 0.774 2.626 0.774 2.626z',
          'M943.961 143.809l-19.593 9.598-0.394-4.18-0.273-2.898s11.347-9.673 14.7-9.296c1.699 0.244 3.421 0.244 5.12 0l0.228 3.501 0.212 3.275z',
          'M1158.098 208.968s-85.409 9.582-69.45 4.421c11.112-3.607 15.527-10.563 16.452-18.41 0.759-6.534-0.941-13.581-3.171-19.617-2.010-5.355-4.551-10.496-7.585-15.347 0 0 65.255-35.703 52.216-3.244-2.010 4.909-3.254 10.094-3.702 15.377-0.387 5.25 0.182 10.527 1.684 15.573 2.465 8.189 7.153 15.542 13.555 21.247z',
          'M1146.516 156.726c-2.010 4.91-3.254 10.094-3.702 15.377-6.144 5.146-12.88 4.799-21.55 4.799-6.645 0-14.025 1.599-19.335-1.585-2.010-5.355-4.551-10.496-7.585-15.347 0 0 65.24-35.703 52.171-3.244z',
          'M1120.112 179.165c19.502 0 35.317-15.722 35.317-35.115s-15.815-35.115-35.317-35.115c-19.502 0-35.317 15.722-35.317 35.115s15.815 35.115 35.317 35.115z',
          'M1158.098 208.968s-85.409 9.582-69.45 4.421c11.112-3.607 15.527-10.563 16.452-18.41 4.255-4.527 12.796-7.892 18.212-9.642 5.014-1.675 10.422-1.765 15.481-0.257 1.995 0.597 3.884 1.471 5.628 2.596 2.488 8.219 7.221 15.59 13.676 21.292zM1206.712 162.34l-16.331 3.757-0.349-2.414c1.745-2.388 4.195-4.182 7.001-5.138 2.814-0.956 5.848-1.027 8.708-0.203l0.971 3.999zM943.961 143.808l-19.593 9.598-0.394-4.18c6.341-3.392 12.94-6.303 19.729-8.706l0.258 3.289zM1191.883 422.961c-33.102 5.251-80.145 11.952-87.616 9.688-6.205-1.871-25.994-1.675-43.22-1.086 0.152-8.571 0.303-14.26 0.303-14.26l128.212-13.279s-0.121 5.885 2.321 18.938z',
          'M1224.878 415.234s-108.923 18.591-120.612 15.091c-11.681-3.501-71.71 0.287-71.71 0.287-27.011 18.002-15.732-8.556-15.732-8.556s-2.374-13.868 0.895-25.080c2.192-8.231 3.686-16.631 4.475-25.109 0 0-0.592-17.716 2.67-21.851s7.13-33.636 7.13-33.636 2.966-20.070 2.678-24.492c-0.288-4.421 0.88-16.825 0.88-16.825l3.868-20.658c-22.263-2.942-89.938-44.26-89.938-44.26-3.262-13.867-28.482-46.327-28.482-46.327-0.372-2.729-1.070-5.404-2.086-7.967-1.775-4.723 24.94-14.17 24.94-14.17s19.881 24.144 24.037 30.693 18.394 18.591 18.394 18.591c2.215-0.226 4.445 0.063 6.523 0.845l0.349 0.105c4.771 1.862 9.246 4.404 13.282 7.545 6.69-0.158 13.183 2.277 18.106 6.791 0 0 12.144-1.781 14.253 0.287s12.455 0 12.455 0 10.384-21.835 17.211-15.498c6.834 6.338 35.802 6.036 35.802 6.036 3.853-5.1 13.251-8.753 19.122-10.563 5.014-1.668 10.422-1.757 15.481-0.256 2.185 0.648 4.24 1.669 6.068 3.018l17.62 17.112s5.044-6.504 4.453-7.967c-0.592-1.464 5.932-2.656 5.932-2.656s8.602-2.656 11.863-3.546c3.269-0.891 6.258 2.626 6.531 2.943-0.106-0.378-2.336-7.546-1.517-12.977s-3.565-10.563-3.565-10.563c10.377-25.382 33.822-4.135 33.822-4.135s2.67 13.867 0.303 19.179c-2.367 5.312 2.367 16.524 1.775 19.481s1.206 7.968 1.206 13.581c0 5.614-3.042 16.222-4.756 20.945s-16.027 15.347-16.027 15.347-0.895 16.825-7.13 26.559c-6.235 9.733-2.321 43.022-2.321 43.022s5.932 25.97 13.358 34.24c7.418 8.269 18.394 55.395 18.394 55.395z',
          'M1066.098 221.055s-3.262-9.733-6.235-10.563c-2.951-1.080-5.833-2.361-8.609-3.833l1.919-3.637s11.135 3.018 12.925 6.293c1.79 3.275 0 11.74 0 11.74zM1006.44 199.521c-0.592 3.018-27.011 5.599-27.011 5.599l13.35-13.31 0.334 0.121c4.794 1.872 9.284 4.429 13.327 7.59z',
          'M930.012 161.373c1.305 0 2.367-1.054 2.367-2.354s-1.062-2.354-2.367-2.354-2.367 1.054-2.367 2.354 1.062 2.354 2.367 2.354zM933.046 166.097c1.312 0 2.367-1.054 2.367-2.354s-1.054-2.354-2.367-2.354c-1.305 0-2.367 1.054-2.367 2.354s1.062 2.354 2.367 2.354zM936.019 170.458c1.312 0 2.367-1.054 2.367-2.354s-1.054-2.354-2.367-2.354c-1.305 0-2.367 1.054-2.367 2.354s1.062 2.354 2.367 2.354zM939.137 175.166c1.305 0 2.367-1.054 2.367-2.354s-1.062-2.354-2.367-2.354c-1.312 0-2.374 1.054-2.374 2.354s1.062 2.354 2.374 2.354zM1218.894 174.471c1.070 0 1.927-0.858 1.927-1.916s-0.857-1.917-1.927-1.917c-1.062 0-1.927 0.859-1.927 1.917s0.865 1.916 1.927 1.916zM1219.197 178.833c1.070 0 1.927-0.858 1.927-1.917s-0.857-1.916-1.927-1.916c-1.062 0-1.927 0.858-1.927 1.916s0.865 1.917 1.927 1.917zM1219.455 183.178c1.070 0 1.927-0.858 1.927-1.916s-0.857-1.917-1.927-1.917c-1.062 0-1.927 0.858-1.927 1.917s0.865 1.916 1.927 1.916z',
          'M1066.204 301.032c-0.288-0.347 66.628 83.659 118.556 35.115 0.046 0.015-82.011 11.076-118.556-35.115zM1027.808 344.703s40.035 1.087 44.229 12.54v11.922c-1.145 0.629-2.427 0.959-3.732 0.959s-2.587-0.33-3.724-0.959c-4.035-2.173-28.24-14.396-36.773-8.511v-15.951z',
          'M1028.551 344.703s38.29 1.041 42.295 11.966v11.348c-1.085 0.602-2.313 0.919-3.565 0.919-1.244 0-2.473-0.316-3.565-0.919-3.853-2.053-26.996-13.717-35.165-8.103v-15.211z',
          'M1049.661 258.267c4.096 9.414 9.307 18.305 15.527 26.483 6.766 9.039 14.973 16.924 24.28 23.344 0 0-39.14-44.364-39.807-49.827zM1036.569 212.017s6.675 28.67 23.886 38.404l-23.886-38.404zM1026.321 214.913c-0.167-0.528-5.932 22.635 22.187 35.507 0 0-11.939-4.029-22.187-35.507zM1201.137 195.689c-0.44 0 13.873 9.054 17.772 13.279 0 0-9.315-13.883-17.772-13.279z',
          'M1110.57 175.875c0 0.766 0.167 1.522 0.478 2.222 0.319 0.699 0.774 1.327 1.343 1.841 0.576 0.515 1.244 0.906 1.972 1.15 0.736 0.243 1.509 0.334 2.276 0.265 10.756 0.664 21.974 1.132 31.873-3.018 1.851-0.658 3.52-1.756 4.855-3.199 1.76-2.158 2.109-5.085 2.822-7.772 1.396-5.251 4.369-9.914 6.508-14.909 3.626-8.439 4.839-17.706 3.512-26.785-0.304-2.939-1.272-5.601-2.751-7.903l0.043 0.072c-2.852-4.060-8.055-5.704-11.833-8.934s-6.212-8.163-10.627-10.563c-3.975-2.203-8.844-1.931-13.327-1.176-8.806 1.487-17.241 4.637-24.857 9.28-2.564 1.509-5.37 3.365-8.313 2.807-2.579-0.483-4.468-2.641-6.076-4.663-2.063 4.829-2.935 10.082-2.533 15.316 0.114 0.768 0.091 1.55-0.076 2.309-0.372 0.918-0.933 1.746-1.654 2.43-2.655 3.018-4.308 7.922-1.684 11.031 1.138 1.343 2.898 2.082 4.005 3.455 1.987 2.46 1.32 6.036 1.274 9.175-0.106 1.096 0.174 2.196 0.789 3.108 0.576 0.532 1.282 0.908 2.040 1.090 0.766 0.183 1.563 0.166 2.321-0.049 1.502-0.451 3.080-0.599 4.642-0.438 1.646 0.532 3.064 1.594 4.035 3.018 4.9 6.353 6.842 13.264 8.943 20.84z',
          'M1154.624 172.464c-1.335 1.443-3.004 2.541-4.855 3.199-9.959 4.12-21.155 3.652-31.873 3.018-1.153 0.011-2.291-0.242-3.322-0.74-1.638-0.95-2.26-2.942-2.761-4.754-2.094-7.545-4.028-14.471-9.004-20.764-0.956-1.452-2.382-2.541-4.035-3.093-1.563-0.147-3.14 0.002-4.642 0.438-0.759 0.216-1.555 0.235-2.313 0.055-0.798-0.191-1.489-0.568-2.051-1.085l0.003 0.003c-0.614-0.913-0.895-2.013-0.789-3.108 0-3.169 0.713-6.715-1.274-9.175-1.107-1.373-2.867-2.112-4.005-3.471-0.714-0.952-1.189-2.121-1.317-3.393l-0.002-0.029c-0.021-0.199-0.033-0.431-0.033-0.665 0-1.071 0.247-2.084 0.687-2.985l-0.018 0.040c-1.896 3.017-2.7 6.805-0.501 9.401 1.138 1.343 2.898 2.082 4.005 3.455 1.987 2.475 1.32 6.036 1.274 9.175-0.114 1.095 0.159 2.194 0.774 3.108 0.576 0.535 1.282 0.912 2.048 1.095s1.57 0.164 2.329-0.053c1.502-0.451 3.080-0.599 4.642-0.438 1.646 0.532 3.064 1.594 4.035 3.018 4.961 6.293 6.903 13.204 9.004 20.779 0.243 1.864 1.176 3.57 2.624 4.784 1.039 0.498 2.185 0.746 3.337 0.724 10.756 0.664 21.974 1.147 31.873-3.017 1.858-0.655 3.52-1.753 4.855-3.199 0.667-0.85 1.183-1.81 1.517-2.837 0.015 0.196-0.091 0.362-0.212 0.513zM1085.933 121.295c0.478-0.515 0.842-1.121 1.077-1.781 0.065-0.347 0.102-0.746 0.102-1.154s-0.037-0.807-0.109-1.195l0.006 0.040c-0.049-0.668-0.077-1.448-0.077-2.234 0-3.748 0.634-7.349 1.8-10.7l-0.069 0.228-0.197-0.226c-2.071 4.822-2.943 10.072-2.533 15.302 0.046 0.572 0.046 1.148 0 1.72z',
          'M1104.266 197.153s44.123 5.825 48.082-0.77l-48.082 0.77zM1190.032 178.999s24.523 0 29.908 9.175l-29.908-9.175z',
          'M1327.241 994.092c-7.274 6.463-16.725 9.975-26.48 9.838-2.496 0-5.939 0.47-5.954 2.943 0.061 0.728 0.311 1.426 0.728 2.025 3.080 5.105 7.942 8.897 13.661 10.665 5.31 1.6 10.991 1.327 16.528 1.039l16.164-0.827c3.034-0.167 6.068-0.319 9.102-0.698 3.034-0.372 6.349-0.994 9.519-1.502 7.79-1.107 15.671-1.472 23.537-1.092 2.094 0.076 4.551 0 5.795-1.509s0.607-4.392 0.137-6.652c-0.971-4.665 0-9.55-0.895-14.23-1.517-8.207-8.662-14.503-16.498-17.476-7.282-2.746-20.184-5.901-27.072-1.312-7.267 4.817-11.719 12.857-18.273 18.789z',
          'M1343.298 719.059c1.426 6.746 7.995 11.906 8.177 18.787 0.167 5.524-3.793 10.156-6.645 14.879-2.693 4.892-4.961 10.003-6.781 15.267-5.378 13.729-12.045 26.912-19.911 39.39-3.8 6.038-8.048 12.478-7.183 19.494 0.607 3.284 1.767 6.44 3.444 9.33l11.385 22.482c2.496 4.49 4.445 9.254 5.81 14.199 0.986 4.27 1.077 8.693 1.654 13.039 1.79 13.79 8.306 27.671 4.453 41.043-0.334 1.145-1.525 2.533-2.45 1.737 3.77 6.986 6.789 14.017 6.501 21.936-0.152 4.157-1.426 8.48 0.106 12.349 0.652 1.616 1.79 3.125 1.775 4.855 0 1.153-0.531 2.222-0.652 3.337-0.319 3.186 2.624 5.841 5.674 6.849 3.049 1.016 6.372 0.941 9.459 1.858 5.916 1.767 10.149 6.834 15.17 10.354 5.158 3.527 11.234 5.492 17.484 5.659 0.895 0.091 1.798-0.083 2.579-0.516 0.448-0.387 0.804-0.865 1.054-1.403 0.243-0.531 0.372-1.115 0.379-1.707 0.273-2.814-0.152-5.659-1.244-8.275s-2.814-4.923-5.014-6.72c-0.963-0.599-1.76-1.434-2.321-2.42-0.18-0.535-0.284-1.152-0.284-1.793 0-0.32 0.026-0.635 0.076-0.941l-0.005 0.033c0.918-12.364 0.69-24.788-0.667-37.122-0.614-3.906-0.812-7.866-0.592-11.81 0.319-3.292 1.32-6.554 0.956-9.823-0.364-3.277-2.048-6.265-3.034-9.421-1.76-5.613-1.274-11.651-1.517-17.522-0.303-10.194-2.655-20.215-4.991-30.174-0.925-3.914-1.949-8.002-4.726-10.9-2.367-2.458-6.19-4.809-5.294-8.086 0.493-1.206 1.236-2.298 2.169-3.216 1.1-1.373 1.904-2.951 2.374-4.642 0.463-1.691 0.576-3.459 0.326-5.196 1.001 0.25 2.056 0.152 2.989-0.281s1.684-1.176 2.131-2.101c18.485-8.677 33.382-26.032 40.035-45.276 0.387-1.426 0.994-2.791 1.79-4.043 1.714-2.382 4.688-3.406 7.327-4.718 8.291-4.149 14.010-11.924 19.259-19.53 3.034-4.406 6.068-8.963 7.441-14.155 0.713-3.357 1.054-6.783 1.016-10.216l0.47-17.731c0.099-1.167-0.015-2.344-0.334-3.471-0.455-1.052-1.107-2.006-1.927-2.807-5.052-5.307-11.681-8.862-18.917-10.141-4.855-0.86-9.815-0.694-14.73-1.101-9.535-0.784-18.94-3.727-28.475-3.018-14.981 1.101-28.315 11.423-35.377 24.612-2.473 4.647-5.082 8.692-10.392 8.782z',
          'M1260.127 603.77c0.205 2.737-0.167 5.486-1.092 8.074-1.168 2.474-4.096 4.406-6.66 3.395 0.774-1.735-1.274-3.712-3.186-3.501-0.985 0.231-1.843 0.677-2.557 1.287l0.008-0.007c-0.728 0.626-1.297 1.418-1.654 2.31-1.267 2.535-1.699 5.404-1.214 8.194 0.607 3.471 2.624 6.805 2.094 10.292-0.425 2.897-2.564 5.779-1.426 8.465 0.736 1.227 1.661 2.332 2.746 3.275 1.494 1.837 2.23 4.176 2.048 6.534s-1.267 4.557-3.034 6.142l28.71 0.573c-1.047 4.768 1.107 9.642 3.565 13.882 6.887 11.658 16.399 21.572 27.785 28.963s24.341 12.058 37.842 13.637c-0.728 0.424-1.358 1.004-1.836 1.698s-0.789 1.484-0.925 2.315c-0.129 0.831-0.076 1.679 0.159 2.486 0.259 0.844 0.678 1.573 1.226 2.183l-0.005-0.005c2.336 2.308 6.296 2.022 9.224 0.528s5.226-3.969 7.896-5.885c4.71-3.322 10.468-4.863 16.225-4.346 3.595 0.347 7.085 1.509 10.695 1.69 10.627 0.558 19.729-7.047 29.961-10.156 7.449-2.279 15.906-2.279 22.156-6.911 2.7-1.993 4.915-5.267 4.126-8.496-0.693-1.94-1.727-3.605-3.041-5.002l0.007 0.007c-3.595-4.632-5.719-10.201-8.298-15.467-5.112-10.427-12.151-19.805-20.753-27.646-6.485-5.64-13.365-10.823-20.579-15.512-1.745-1.28-3.603-2.396-5.552-3.334-2.518-1.102-5.31-1.63-7.585-3.018-3.375-2.113-5.317-5.84-7.911-8.843-5.689-6.61-14.435-9.643-21.443-14.834-4.703-3.486-8.859-8.074-14.48-9.748-2.731-0.83-5.628-0.891-8.359-1.705-6.205-1.871-10.733-7.349-16.816-9.567-4.809-1.751-10.126-1.298-15.178-1.916-5.997-0.754-11.381-2.892-15.978-6.083l0.118 0.077c-1.517-1.232-3.224-2.219-5.052-2.928-7.691-2.324-8.313 11.922-9.102 16.856-1.016 7.334-2.875 14.622-2.875 22.046z',
          'M1267.629 651.545c1.289 13.914-9.277 27.389-6.19 41.015 0.652 2.897 1.911 5.659 2.367 8.601 1.289 8.074-3.573 15.724-8.2 22.485l-39.762 58.022c-1.593 2.549-3.504 4.885-5.674 6.971-7.593 6.713-19.001 6.038-28.991 8.025-7.016 1.434-13.638 4.346-19.426 8.541-0.258 0.205-0.432 0.501-0.478 0.819-0.046 0.326 0.038 0.652 0.235 0.918 1.654 2.23 3.838 4.020 6.356 5.196 2.518 1.183 5.294 1.714 8.078 1.547 1.047 1.365 0 3.383-1.441 4.361-2.124 1.509-5.067 1.858-5.492 5.469-0.144 1.252 0.106 2.518 0.728 3.618 1.608 2.435 4.096 4.149 6.948 4.801 13.767 4.195 28.642-3.171 38.942-13.175 10.308-10.005 17.696-22.634 27.807-32.806 5.598-5.643 11.954-10.46 17.727-15.921 11.499-10.907 20.457-24.144 29.074-37.408 2.594-3.999 5.219-8.103 6.296-12.736s0.576-9.325 1.805-13.807c1.616-5.87 5.939-10.563 9.535-15.483 7.054-9.657 11.78-21.473 10.839-33.379s-8.351-23.647-19.638-27.69c-3.504-1.384-7.365-1.616-11.006-0.664-4.627 1.418-8.040 5.222-11.203 8.873l-7.585 8.662c-1.851 1.918-3.3 4.179-4.263 6.655-0.493 1.247-0.607 2.608-0.341 3.919 0.273 1.311 0.918 2.518 1.858 3.475z',
          'M1287.782 594.474c-5.219 0.302-10.976 0.815-14.662 4.528-1.547 1.704-2.799 3.652-3.702 5.764-3.58 7.258-7.069 14.849-7.327 22.937-0.212 6.459 1.669 12.782 2.655 19.165 0.819 5.312-1.259 10.729-1.654 16.101 6.478-1.977 15.034-4.663 20.912-7.998 4.005-2.279 7.873-4.874 12.242-6.323 6.243-2.067 16.695 1.509 22.634 4.377 0.319-4.135-2.814-11.348-2.48-15.498 0.057-1.853 0.392-3.609 0.963-5.254l-0.037 0.124c0.895-1.749 1.942-3.412 3.148-4.965 2.253-3.652 3.292-7.92 2.966-12.195-0.334-4.275-2.010-8.336-4.801-11.602-5.272-5.885-13.509-8.088-21.375-9.054-4.946-0.571-9.937-0.743-14.912-0.514z',
        ],
        attrs: [
          {
            fill: 'rgb(133, 132, 139)',
          },
          {
            fill: 'rgb(80, 79, 96)',
          },
          {
            fill: 'rgb(0, 0, 0)',
            opacity: 0.2,
          },
          {
            fill: 'rgb(225, 112, 0)',
          },
          {
            fill: 'rgb(81, 78, 127)',
          },
          {
            fill: 'rgb(70, 67, 83)',
          },
          {
            fill: 'rgb(81, 78, 127)',
          },
          {
            fill: 'rgb(70, 67, 83)',
          },
          {
            fill: 'rgb(161, 97, 106)',
          },
          {
            fill: 'rgb(81, 78, 127)',
          },
          {
            fill: 'rgb(161, 97, 106)',
          },
          {
            fill: 'rgb(70, 67, 83)',
          },
          {
            fill: 'rgb(225, 112, 0)',
          },
          {
            fill: 'rgb(70, 67, 83)',
          },
          {
            fill: 'rgb(225, 112, 0)',
          },
          {
            fill: 'rgb(0, 0, 0)',
            opacity: 0.1,
          },
          {
            fill: 'rgb(51, 50, 61)',
          },
          {
            fill: 'rgb(141, 208, 112)',
          },
          {
            fill: 'rgb(0, 0, 0)',
            opacity: 0.1,
          },
          {
            fill: 'rgb(141, 208, 112)',
          },
          {
            fill: 'rgb(0, 0, 0)',
            opacity: 0.1,
          },
          {
            fill: 'rgb(0, 0, 0)',
            opacity: 0.2,
          },
          {
            fill: 'rgb(141, 208, 112)',
          },
          {
            fill: 'rgb(0, 0, 0)',
            opacity: 0.1,
          },
          {
            fill: 'rgb(141, 208, 112)',
          },
          {
            fill: 'rgb(0, 0, 0)',
            opacity: 0.1,
          },
          {
            fill: 'rgb(0, 0, 0)',
            opacity: 0.1,
          },
          {
            fill: 'rgb(80, 79, 96)',
          },
          {
            fill: 'rgb(0, 0, 0)',
            opacity: 0.1,
          },
          {
            fill: 'rgb(51, 50, 61)',
          },
          {
            fill: 'rgb(0, 0, 0)',
            opacity: 0.1,
          },
          {
            fill: 'rgb(225, 112, 0)',
          },
          {
            fill: 'rgb(251, 190, 190)',
          },
          {
            fill: 'rgb(0, 0, 0)',
            opacity: 0.05,
          },
          {
            fill: 'rgb(63, 61, 86)',
          },
          {
            fill: 'rgb(0, 0, 0)',
            opacity: 0.05,
          },
          {
            fill: 'rgb(70, 67, 83)',
          },
          {
            fill: 'rgb(0, 0, 0)',
            opacity: 0.05,
          },
          {
            fill: 'rgb(251, 190, 190)',
          },
          {
            fill: 'rgb(251, 190, 190)',
          },
          {
            fill: 'rgb(70, 67, 83)',
          },
          {
            fill: 'rgb(161, 97, 106)',
          },
          {
            fill: 'rgb(70, 67, 83)',
          },
          {
            fill: 'rgb(80, 79, 96)',
          },
          {
            fill: 'rgb(0, 0, 0)',
          },
          {
            fill: 'rgb(45, 41, 61)',
          },
          {
            fill: 'rgb(0, 0, 0)',
            opacity: 0.1,
          },
          {
            fill: 'rgb(70, 67, 83)',
          },
          {
            fill: 'rgb(0, 0, 0)',
            opacity: 0.05,
          },
          {
            fill: 'rgb(0, 0, 0)',
            opacity: 0.1,
          },
          {
            fill: 'rgb(0, 0, 0)',
            opacity: 0.05,
          },
          {
            fill: 'rgb(0, 0, 0)',
            opacity: 0.0025000000000000005,
          },
          {
            fill: 'rgb(255, 205, 211)',
          },
          {
            fill: 'rgb(0, 0, 0)',
            opacity: 0.1,
          },
          {
            fill: 'rgb(225, 112, 0)',
          },
          {
            fill: 'rgb(255, 205, 211)',
          },
          {
            fill: 'rgb(0, 0, 0)',
            opacity: 0.1,
          },
          {
            fill: 'rgb(225, 112, 0)',
          },
          {
            fill: 'rgb(255, 205, 211)',
          },
          {
            fill: 'rgb(0, 0, 0)',
            opacity: 0.1,
          },
          {
            fill: 'rgb(255, 205, 211)',
          },
          {
            fill: 'rgb(0, 0, 0)',
            opacity: 0.1,
          },
          {
            fill: 'rgb(63, 61, 86)',
          },
          {
            fill: 'rgb(0, 0, 0)',
            opacity: 0.1,
          },
          {
            fill: 'rgb(87, 89, 136)',
          },
          {
            fill: 'rgb(0, 0, 0)',
            opacity: 0.1,
          },
          {
            fill: 'rgb(63, 61, 86)',
          },
          {
            fill: 'rgb(0, 0, 0)',
            opacity: 0.1,
          },
          {
            fill: 'rgb(45, 41, 61)',
          },
          {
            fill: 'rgb(0, 0, 0)',
            opacity: 0.010000000000000002,
          },
          {
            fill: 'rgb(0, 0, 0)',
            opacity: 0.1,
          },
          {
            fill: 'rgb(63, 61, 86)',
          },
          {
            fill: 'rgb(70, 67, 83)',
          },
          {
            fill: 'rgb(225, 112, 0)',
          },
          {
            fill: 'rgb(251, 190, 190)',
          },
          {
            fill: 'rgb(225, 112, 0)',
          },
        ],
        width: 1593,
        isMulticolor: true,
        isMulticolor2: true,
        grid: 16,
        tags: ['Earn'],
      },
      attrs: [
        {
          fill: 'rgb(133, 132, 139)',
        },
        {
          fill: 'rgb(80, 79, 96)',
        },
        {
          fill: 'rgb(0, 0, 0)',
          opacity: 0.2,
        },
        {
          fill: 'rgb(225, 112, 0)',
        },
        {
          fill: 'rgb(81, 78, 127)',
        },
        {
          fill: 'rgb(70, 67, 83)',
        },
        {
          fill: 'rgb(81, 78, 127)',
        },
        {
          fill: 'rgb(70, 67, 83)',
        },
        {
          fill: 'rgb(161, 97, 106)',
        },
        {
          fill: 'rgb(81, 78, 127)',
        },
        {
          fill: 'rgb(161, 97, 106)',
        },
        {
          fill: 'rgb(70, 67, 83)',
        },
        {
          fill: 'rgb(225, 112, 0)',
        },
        {
          fill: 'rgb(70, 67, 83)',
        },
        {
          fill: 'rgb(225, 112, 0)',
        },
        {
          fill: 'rgb(0, 0, 0)',
          opacity: 0.1,
        },
        {
          fill: 'rgb(51, 50, 61)',
        },
        {
          fill: 'rgb(141, 208, 112)',
        },
        {
          fill: 'rgb(0, 0, 0)',
          opacity: 0.1,
        },
        {
          fill: 'rgb(141, 208, 112)',
        },
        {
          fill: 'rgb(0, 0, 0)',
          opacity: 0.1,
        },
        {
          fill: 'rgb(0, 0, 0)',
          opacity: 0.2,
        },
        {
          fill: 'rgb(141, 208, 112)',
        },
        {
          fill: 'rgb(0, 0, 0)',
          opacity: 0.1,
        },
        {
          fill: 'rgb(141, 208, 112)',
        },
        {
          fill: 'rgb(0, 0, 0)',
          opacity: 0.1,
        },
        {
          fill: 'rgb(0, 0, 0)',
          opacity: 0.1,
        },
        {
          fill: 'rgb(80, 79, 96)',
        },
        {
          fill: 'rgb(0, 0, 0)',
          opacity: 0.1,
        },
        {
          fill: 'rgb(51, 50, 61)',
        },
        {
          fill: 'rgb(0, 0, 0)',
          opacity: 0.1,
        },
        {
          fill: 'rgb(225, 112, 0)',
        },
        {
          fill: 'rgb(251, 190, 190)',
        },
        {
          fill: 'rgb(0, 0, 0)',
          opacity: 0.05,
        },
        {
          fill: 'rgb(63, 61, 86)',
        },
        {
          fill: 'rgb(0, 0, 0)',
          opacity: 0.05,
        },
        {
          fill: 'rgb(70, 67, 83)',
        },
        {
          fill: 'rgb(0, 0, 0)',
          opacity: 0.05,
        },
        {
          fill: 'rgb(251, 190, 190)',
        },
        {
          fill: 'rgb(251, 190, 190)',
        },
        {
          fill: 'rgb(70, 67, 83)',
        },
        {
          fill: 'rgb(161, 97, 106)',
        },
        {
          fill: 'rgb(70, 67, 83)',
        },
        {
          fill: 'rgb(80, 79, 96)',
        },
        {
          fill: 'rgb(0, 0, 0)',
        },
        {
          fill: 'rgb(45, 41, 61)',
        },
        {
          fill: 'rgb(0, 0, 0)',
          opacity: 0.1,
        },
        {
          fill: 'rgb(70, 67, 83)',
        },
        {
          fill: 'rgb(0, 0, 0)',
          opacity: 0.05,
        },
        {
          fill: 'rgb(0, 0, 0)',
          opacity: 0.1,
        },
        {
          fill: 'rgb(0, 0, 0)',
          opacity: 0.05,
        },
        {
          fill: 'rgb(0, 0, 0)',
          opacity: 0.0025000000000000005,
        },
        {
          fill: 'rgb(255, 205, 211)',
        },
        {
          fill: 'rgb(0, 0, 0)',
          opacity: 0.1,
        },
        {
          fill: 'rgb(225, 112, 0)',
        },
        {
          fill: 'rgb(255, 205, 211)',
        },
        {
          fill: 'rgb(0, 0, 0)',
          opacity: 0.1,
        },
        {
          fill: 'rgb(225, 112, 0)',
        },
        {
          fill: 'rgb(255, 205, 211)',
        },
        {
          fill: 'rgb(0, 0, 0)',
          opacity: 0.1,
        },
        {
          fill: 'rgb(255, 205, 211)',
        },
        {
          fill: 'rgb(0, 0, 0)',
          opacity: 0.1,
        },
        {
          fill: 'rgb(63, 61, 86)',
        },
        {
          fill: 'rgb(0, 0, 0)',
          opacity: 0.1,
        },
        {
          fill: 'rgb(87, 89, 136)',
        },
        {
          fill: 'rgb(0, 0, 0)',
          opacity: 0.1,
        },
        {
          fill: 'rgb(63, 61, 86)',
        },
        {
          fill: 'rgb(0, 0, 0)',
          opacity: 0.1,
        },
        {
          fill: 'rgb(45, 41, 61)',
        },
        {
          fill: 'rgb(0, 0, 0)',
          opacity: 0.010000000000000002,
        },
        {
          fill: 'rgb(0, 0, 0)',
          opacity: 0.1,
        },
        {
          fill: 'rgb(63, 61, 86)',
        },
        {
          fill: 'rgb(70, 67, 83)',
        },
        {
          fill: 'rgb(225, 112, 0)',
        },
        {
          fill: 'rgb(251, 190, 190)',
        },
        {
          fill: 'rgb(225, 112, 0)',
        },
      ],
      properties: {
        order: 23,
        id: 492,
        name: 'Earn',
        prevSize: 32,
      },
      setIdx: 0,
      setId: 1,
      iconIdx: 19,
    },
    {
      icon: {
        paths: [
          'M268.744 19.692l-219.513 197.651 65.883 73.171 219.514-197.651-65.884-73.171z',
          'M541.538 315.077h98.462v196.923h147.692v98.462h-246.154v-295.385z',
          'M147.692 512c0 244.704 198.372 443.077 443.077 443.077s443.077-198.372 443.077-443.077c0-244.704-198.372-443.077-443.077-443.077s-443.077 198.372-443.077 443.077zM246.154 512c0-190.326 154.289-344.615 344.615-344.615s344.615 154.289 344.615 344.615c0 190.326-154.289 344.615-344.615 344.615s-344.615-154.289-344.615-344.615z',
          'M912.794 19.692l219.514 197.651-65.883 73.171-219.514-197.651 65.883-73.171z',
        ],
        attrs: [
          {
            fill: 'rgb(151, 151, 151)',
          },
          {
            fill: 'rgb(151, 151, 151)',
          },
          {
            fill: 'rgb(151, 151, 151)',
          },
          {
            fill: 'rgb(151, 151, 151)',
          },
        ],
        width: 1182,
        isMulticolor: false,
        isMulticolor2: false,
        grid: 16,
        tags: ['alarm'],
      },
      attrs: [
        {
          fill: 'rgb(151, 151, 151)',
        },
        {
          fill: 'rgb(151, 151, 151)',
        },
        {
          fill: 'rgb(151, 151, 151)',
        },
        {
          fill: 'rgb(151, 151, 151)',
        },
      ],
      properties: {
        order: 22,
        id: 510,
        name: 'alarm',
        prevSize: 32,
      },
      setIdx: 0,
      setId: 1,
      iconIdx: 0,
    },
    {
      icon: {
        paths: [
          'M315.077 364.308c-27.19 0-49.231 22.041-49.231 49.231s22.041 49.231 49.231 49.231h393.846c27.19 0 49.231-22.041 49.231-49.231s-22.041-49.231-49.231-49.231h-393.846z',
          'M216.615 68.923c-81.568 0-147.692 66.124-147.692 147.692v590.769c0 81.566 66.124 147.692 147.692 147.692h590.769c81.566 0 147.692-66.127 147.692-147.692v-590.769c0-81.568-66.127-147.692-147.692-147.692h-590.769zM167.385 807.385v-541.538h689.231v541.538c0 27.191-22.040 49.231-49.231 49.231h-590.769c-27.19 0-49.231-22.040-49.231-49.231z',
        ],
        attrs: [
          {
            fill: 'rgb(151, 151, 151)',
          },
          {
            fill: 'rgb(151, 151, 151)',
          },
        ],
        isMulticolor: false,
        isMulticolor2: false,
        grid: 16,
        tags: ['calendar'],
      },
      attrs: [
        {
          fill: 'rgb(151, 151, 151)',
        },
        {
          fill: 'rgb(151, 151, 151)',
        },
      ],
      properties: {
        order: 21,
        id: 509,
        name: 'calendar',
        prevSize: 32,
      },
      setIdx: 0,
      setId: 1,
      iconIdx: 1,
    },
    {
      icon: {
        paths: [
          'M626.011 438.277c0-94.256-76.41-170.667-170.667-170.667s-170.667 76.41-170.667 170.667c0 94.256 76.41 170.667 170.667 170.667s170.667-76.41 170.667-170.667zM540.678 438.277c0 47.129-38.205 85.333-85.333 85.333s-85.333-38.205-85.333-85.333c0-47.128 38.205-85.333 85.333-85.333s85.333 38.205 85.333 85.333z',
          'M178.951 704.778l278.112 264.786 264.783-278.112c146.234-153.599 140.268-396.661-13.326-542.896-153.599-146.236-396.661-140.268-542.897 13.328s-140.268 396.659 13.328 542.893zM660.043 632.61l-205.942 216.306-216.309-205.939c-119.464-113.739-124.105-302.787-10.367-422.251s302.787-124.106 422.251-10.367c119.464 113.739 124.106 302.787 10.367 422.251z',
        ],
        attrs: [
          {
            fill: 'rgb(151, 151, 151)',
          },
          {
            fill: 'rgb(151, 151, 151)',
          },
        ],
        width: 887,
        isMulticolor: false,
        isMulticolor2: false,
        grid: 16,
        tags: ['pin'],
      },
      attrs: [
        {
          fill: 'rgb(151, 151, 151)',
        },
        {
          fill: 'rgb(151, 151, 151)',
        },
      ],
      properties: {
        order: 20,
        id: 508,
        name: 'pin',
        prevSize: 32,
      },
      setIdx: 0,
      setId: 1,
      iconIdx: 2,
    },
    {
      icon: {
        paths: [
          'M733.136 670.687c125.119-160.69 113.814-393.172-33.908-540.894-159.956-159.958-419.301-159.958-579.259 0s-159.959 419.303 0 579.259c147.722 147.722 380.203 159.027 540.893 33.908 0.694 0.785 1.415 1.55 2.165 2.301l217.224 217.225c19.995 19.988 52.415 19.995 72.41 0 19.988-19.995 19.988-52.415 0-72.41l-217.225-217.223c-0.751-0.75-1.516-1.471-2.301-2.165zM626.823 202.201c119.966 119.968 119.966 314.477 0 434.446-119.969 119.966-314.477 119.966-434.446 0-119.969-119.969-119.969-314.478 0-434.446s314.477-119.969 434.446 0z',
        ],
        attrs: [
          {
            fill: 'rgb(225, 112, 0)',
          },
        ],
        isMulticolor: false,
        isMulticolor2: false,
        grid: 16,
        tags: ['search'],
      },
      attrs: [
        {
          fill: 'rgb(225, 112, 0)',
        },
      ],
      properties: {
        order: 19,
        id: 507,
        name: 'search',
        prevSize: 32,
      },
      setIdx: 0,
      setId: 1,
      iconIdx: 0,
    },
    {
      icon: {
        paths: [
          'M85.333 256c0-23.564 19.103-42.667 42.667-42.667h768c23.563 0 42.667 19.103 42.667 42.667s-19.103 42.667-42.667 42.667h-768c-23.564 0-42.667-19.103-42.667-42.667zM85.333 513.377c0-23.567 19.103-42.667 42.667-42.667h768c23.563 0 42.667 19.099 42.667 42.667 0 23.563-19.103 42.667-42.667 42.667h-768c-23.564 0-42.667-19.103-42.667-42.667zM128 728.083c-23.564 0-42.667 19.103-42.667 42.667s19.103 42.667 42.667 42.667h768c23.563 0 42.667-19.103 42.667-42.667s-19.103-42.667-42.667-42.667h-768z',
        ],
        attrs: [
          {
            fill: 'rgb(92, 127, 146)',
          },
        ],
        isMulticolor: false,
        isMulticolor2: false,
        grid: 16,
        tags: ['menu'],
      },
      attrs: [
        {
          fill: 'rgb(92, 127, 146)',
        },
      ],
      properties: {
        order: 18,
        id: 506,
        name: 'menu',
        prevSize: 32,
      },
      setIdx: 0,
      setId: 1,
      iconIdx: 0,
    },
    {
      icon: {
        paths: [
          'M342.016 334.39c-127.782 0-238.614 71.68-295.566 176.019 56.952 104.361 167.783 175.997 295.566 175.997 127.76 0 238.592-71.636 295.544-175.997-58.499-105.908-169.33-176.019-295.544-176.019z',
          'M342.517 338.203c126.148 0 235.607 69.806 291.84 171.509 25.78-46.475 40.981-101.905 41.047-160.878l0-0.020c0-183.666-148.959-333.933-334.39-333.933-0.363-0.001-0.792-0.002-1.221-0.002-184.017 0-333.192 149.175-333.192 333.192 0 0.261 0 0.523 0.001 0.784l-0-0.041c0 59.196 15.207 113.838 41.047 160.899 59.261-103.228 168.72-171.509 294.868-171.509z',
          'M339.489 681.221c-0.139 0-0.303 0-0.467 0-124.674 0-233.358-68.462-290.509-169.842l-0.864-1.667c-25.782 46.476-40.983 101.905-41.047 160.88l-0 0.019c0 183.666 148.959 333.911 334.412 333.911 0.356 0.001 0.777 0.002 1.199 0.002 184.017 0 333.192-149.175 333.192-333.192 0-0.254-0-0.507-0.001-0.76l0 0.039c0-59.196-15.207-113.838-41.047-160.899-60.786 101.703-170.224 171.509-294.868 171.509z',
        ],
        attrs: [
          {
            fill: 'rgb(73, 51, 18)',
          },
          {
            fill: 'rgb(92, 127, 146)',
          },
          {
            fill: 'rgb(225, 112, 0)',
          },
        ],
        width: 675,
        isMulticolor: true,
        isMulticolor2: false,
        grid: 16,
        tags: ['collaborate-small-logo'],
      },
      attrs: [
        {
          fill: 'rgb(73, 51, 18)',
        },
        {
          fill: 'rgb(92, 127, 146)',
        },
        {
          fill: 'rgb(225, 112, 0)',
        },
      ],
      properties: {
        order: 17,
        id: 505,
        name: 'collaborate-small-logo',
        prevSize: 32,
      },
      setIdx: 0,
      setId: 1,
      iconIdx: 0,
    },
    {
      icon: {
        paths: [
          'M544.733 38.852c11.13-17.901 37.184-17.9 48.311 0l160.336 257.878c3.92 6.298 10.138 10.817 17.34 12.596l294.798 72.8c20.469 5.053 28.518 29.831 14.933 45.947l-195.709 232.175c-4.784 5.672-7.157 12.988-6.622 20.383l21.862 302.871c1.513 21.020-19.564 36.335-39.088 28.393l-281.293-114.381c-6.866-2.793-14.557-2.793-21.427 0l-281.291 114.381c-19.526 7.942-40.603-7.373-39.085-28.393l21.862-302.871c0.534-7.396-1.842-14.711-6.622-20.383l-195.71-232.175c-13.585-16.116-5.534-40.894 14.929-45.947l294.802-72.8c7.2-1.778 13.421-6.298 17.337-12.596l160.336-257.878z',
        ],
        attrs: [
          {
            fill: 'rgb(253, 200, 47)',
          },
        ],
        width: 1138,
        isMulticolor: false,
        isMulticolor2: false,
        grid: 16,
        tags: ['Star 3'],
      },
      attrs: [
        {
          fill: 'rgb(253, 200, 47)',
        },
      ],
      properties: {
        order: 2,
        id: 492,
        name: 'Star',
        prevSize: 32,
      },
      setIdx: 0,
      setId: 1,
      iconIdx: 0,
    },
    {
      icon: {
        paths: [
          'M437.018 696.051l-181.018-181.022 60.34-60.339 120.678 120.683 241.361-241.361 60.339 60.34-301.7 301.699z',
          'M42.667 512c0 259.204 210.128 469.333 469.333 469.333 259.204 0 469.333-210.129 469.333-469.333 0-259.206-210.129-469.333-469.333-469.333-259.206 0-469.333 210.128-469.333 469.333zM512 896c-212.077 0-384-171.921-384-384 0-212.077 171.923-384 384-384 212.079 0 384 171.923 384 384 0 212.079-171.921 384-384 384z',
        ],
        attrs: [
          {
            fill: 'rgb(190, 214, 0)',
          },
          {
            fill: 'rgb(190, 214, 0)',
          },
        ],
        isMulticolor: false,
        isMulticolor2: false,
        grid: 16,
        tags: ['check-o'],
      },
      attrs: [
        {
          fill: 'rgb(190, 214, 0)',
        },
        {
          fill: 'rgb(190, 214, 0)',
        },
      ],
      properties: {
        order: 16,
        id: 504,
        name: 'check-o',
        prevSize: 32,
      },
      setIdx: 0,
      setId: 1,
      iconIdx: 0,
    },
    {
      icon: {
        paths: [
          'M884.806 231.826h-8.772c-1.727 0-3.13 1.402-3.13 3.131v117.615c0 1.729 1.402 3.131 3.13 3.131h8.772c1.727 0 3.13-1.402 3.13-3.131v-117.615c0-1.729-1.402-3.131-3.13-3.131z',
          'M827.713 0h-396.222c-29.443 0-53.31 23.867-53.31 53.308v915.33c0 29.441 23.867 53.31 53.31 53.31h396.222c29.441 0 53.306-23.869 53.306-53.31v-915.33c0-29.441-23.865-53.308-53.306-53.308z',
          'M811.033 26.619h-57.681v6.939c-0 4.541-0.921 8.867-2.586 12.802l0.081-0.216c-1.653 3.99-4.080 7.615-7.131 10.669-2.977 2.976-6.523 5.383-10.46 7.045l-0.216 0.081c-3.989 1.651-8.266 2.5-12.584 2.497h-183.444c-4.318 0.002-8.595-0.846-12.584-2.497-3.993-1.651-7.62-4.073-10.672-7.126-3.056-3.053-5.482-6.678-7.135-10.669-1.584-3.719-2.504-8.045-2.504-12.586l-0-0v-6.939h-54.005c-10.59 0-20.747 4.207-28.24 11.697-7.489 7.489-11.695 17.647-11.695 28.239v888.908c0 10.594 4.206 20.751 11.695 28.24 7.493 7.489 17.651 11.696 28.24 11.696h360.921c10.59 0 20.747-4.207 28.236-11.696s11.7-17.647 11.7-28.24v-888.839c0.008-5.25-1.020-10.451-3.023-15.304-2.115-5.049-5.039-9.359-8.653-12.98l0 0c-3.614-3.621-7.919-6.551-12.701-8.576l-0.262-0.099c-4.853-2.011-10.051-3.046-15.298-3.046z',
          'M646.021 30.519h-59.635c-2.92 0-5.289 2.369-5.289 5.291v3.668c0 2.922 2.369 5.291 5.289 5.291h59.635c2.924 0 5.293-2.369 5.293-5.291v-3.668c0-2.922-2.369-5.291-5.293-5.291zM670.029 45.738c4.47 0 8.093-3.623 8.093-8.093s-3.623-8.093-8.093-8.093-8.093 3.623-8.093 8.093c0 4.469 3.623 8.093 8.093 8.093z',
          'M632.668 618.644c52.537 0 95.125-42.589 95.125-95.125 0-52.532-42.589-95.121-95.125-95.121-52.532 0-95.121 42.589-95.121 95.121 0 52.537 42.589 95.125 95.121 95.125z',
          'M757.781 510.236c0 25.148-7.46 49.728-21.43 70.635-13.97 20.904-33.825 37.201-57.056 46.82-23.231 9.623-48.794 12.14-73.457 7.234s-47.314-17.017-65.092-34.795c-17.256-17.255-29.575-39.448-34.655-64.277l-0.14-0.819c-4.902-24.662-2.385-50.225 7.238-73.457s25.921-43.086 46.828-57.055c20.908-13.969 45.488-21.425 70.631-21.424 16.697 0.001 33.229 3.29 48.654 9.679 15.422 6.39 29.437 15.755 41.244 27.56 11.807 11.807 21.171 25.822 27.558 41.248 6.391 15.426 9.677 31.958 9.677 48.65zM615.955 577.532l94.307-94.307c0.765-0.761 1.369-1.666 1.781-2.661 0.415-0.995 0.625-2.064 0.625-3.142s-0.21-2.143-0.625-3.142c-0.411-0.995-1.016-1.9-1.781-2.661l-11.605-11.519c-0.757-0.761-1.661-1.365-2.657-1.781-0.995-0.411-2.060-0.625-3.138-0.625-1.073 0-2.143 0.214-3.134 0.625-0.995 0.415-1.9 1.020-2.657 1.781l-76.919 76.919-35.914-35.996c-1.542-1.534-3.627-2.393-5.803-2.393s-4.26 0.86-5.803 2.393l-11.601 11.671c-1.534 1.542-2.393 3.627-2.393 5.803 0 2.171 0.86 4.26 2.393 5.799l53.322 53.306c0.761 0.761 1.666 1.369 2.661 1.781 0.995 0.415 2.060 0.625 3.138 0.625 1.082 0 2.147-0.21 3.142-0.625 0.995-0.411 1.9-1.020 2.661-1.781v-0.070z',
          'M393.934 201.472h-1.317c-1.729 0-3.131 1.402-3.131 3.131v30.398c0 1.729 1.402 3.131 3.131 3.131h1.317c1.729 0 3.131-1.402 3.131-3.131v-30.398c0-1.729-1.402-3.131-3.131-3.131zM394.618 268.599h-2.278c-1.729 0-3.131 1.402-3.131 3.131v57.541c0 1.729 1.402 3.131 3.131 3.131h2.278c1.729 0 3.131-1.402 3.131-3.131v-57.541c0-1.729-1.402-3.131-3.131-3.131zM394.339 354.728h-1.866c-1.729 0-3.131 1.402-3.131 3.131v58.090c0 1.727 1.402 3.13 3.131 3.13h1.866c1.729 0 3.131-1.402 3.131-3.13v-58.090c0-1.729-1.402-3.131-3.131-3.131z',
          'M288.622 524.897c0.217 0.21 0.496 0.345 0.796 0.382s0.603-0.021 0.866-0.169c-0.561 0.008-1.121-0.066-1.663-0.214z',
          'M351.463 549.477l-1.64 8.936-1.266 6.839-2.302 12.502-22.326 15.631s-2.013-1.723-5.332-4.437c-9.15-7.534-28.38-22.873-42.501-31.111-3.633-2.315-7.562-4.125-11.682-5.383l87.049-2.977z',
          'M335.086 556.127s26.031 4.466 27.555-6.65c1.524-11.116-13.399-17.124-26.046-17.873s-88.553 4.47-88.553 4.47-13.389 17.856 34.967 20.846l52.077-0.794z',
          'M392.012 189.287h-136.177v161.476h136.177v-161.476z',
          'M392.012 190.020h-136.177v161.476h136.177v-161.476z',
          'M96.238 465.714c-2.243 0.563-5.108 2.731-8.295 5.868-13.724 13.588-33.381 45.475-33.381 45.475-25.131-29.935 2.678-53.589 14.533-61.716 2.882-1.97 4.818-3.051 4.818-3.051l22.326 13.423zM349.97 240.251s6.7 46.877 29.766 58.039c23.067 11.162-29.766 32.023-29.766 32.023l-72.175-26.809s40.93-13.399 32.74-52.84l39.435-10.414zM272.579 522.273l-1.632 8.908-1.326 6.86-2.303 12.506-22.326 15.615s-2.012-1.707-5.332-4.421c-9.149-7.534-28.378-22.873-42.521-31.111-3.63-2.315-7.561-4.129-11.681-5.383l87.121-2.973z',
          'M253.271 533.257s23.362 0.164 24.768-10.984c1.406-11.149-12.732-17.124-24.768-17.873s-85.163 4.816-85.163 4.816-10.375 21.056 35.623 24.037l49.54 0.004z',
          'M417.068 708.39c-1.020-0.502-2.044-1.020-3.051-1.522l-2.743-3.463-36.005-45.656v0.794c-0.243 7.624-2.836 68.040-23.057 73.625-21.578 5.947-47.609 7.439-59.475-32.743-11.866-40.179-33.548-127.988-55.813-133.202l33.121-27.159s21.929 25.649 30.864 50.201c-0.335-1.522-15.478-72.28-3.050-84.799h108.661s16.775 47.774 28.273 71.441c8.949 18.374 22.384 61.822 31.037 91.222 8.562 29.030-21.525 54.667-48.761 41.26z',
          'M413.976 517.803c-16.775 9.927-90.414 5.889-114.371 4.273l-6.527-0.473c-0.701 0 0.107-0.399 0.107-0.399l0.672-6.757 17.857-45.381 95.614-55.448c-1.937 5.844-2.577 14.78-2.424 25.012 0.442 32.879 9.073 79.173 9.073 79.173z',
          'M413.976 515.565c-16.773 9.927-90.413 5.885-114.37 4.269l-6.527-0.461-1.083-0.090 1.19-0.304 5.886-1.526 12.642-50.595 95.614-55.432c-1.936 5.84-2.577 14.776-2.424 25.008 0.443 32.846 9.073 79.132 9.073 79.132z',
          'M404.841 436.405c-19.444 4.483-62.232 17.634-78.672 49.407-10.964 21.15-20.19 30.222-26.625 34.018l-6.527-0.456c0.043-0.132 0.078-0.263 0.107-0.395l5.886-1.526 12.641-50.595 95.614-55.432c-1.914 5.807-2.576 14.743-2.423 24.979zM73.915 452.324l22.325 13.39c-2.242 0.563-5.108 2.735-8.295 5.868-1.861-5.428-13.536-13.008-18.849-16.24 2.881-1.937 4.818-3.019 4.818-3.019zM289.039 520.245c-0.245 0.127-0.523 0.173-0.797 0.136s-0.528-0.16-0.728-0.35c0.495 0.144 1.008 0.218 1.524 0.214z',
          'M339.559 295.316s-20.098 2.226-34.234-12.656c0 0-59.475 17.125-79.617 55.812s-157.070 114.601-157.070 114.601 23.82 13.386 21.578 20.081l90.047-52.092s32.023-23.056 40.914-28.271c8.891-5.215 58.054-37.208 68.47 49.853 10.416 87.056 0 76.64 0 76.64s14.884 5.219 36.462-36.461c21.578-41.676 88.536-51.344 88.536-51.344l3.722-43.888s13.283-29.096 3.051-41.173c-3.101-3.576-5.161-7.932-5.963-12.596-1.694-11.147 0-29.721 23.696-45.153 36.461-23.82 50.6-43.156 50.6-43.156s0.744-14.151-21.578-20.846c-22.326-6.695-113.106-43.156-113.106-43.156l-3.050 12.656 71.627 50.552s-35.713 28.973-64.046 28.272c-0.002 0 5.26 21.578-20.038 22.325z',
          'M353.335 260.654c-1.538-4.939-2.97-11.069-4.002-17.335l-0.115-0.843-39.436 10.418c1.739 7.528 1.428 15.385-0.899 22.752 8.062 2.152 16.581 1.877 24.488-0.79 8.119-2.791 14.902-7.716 19.893-14.108l0.071-0.094z',
          'M320.59 274.853c23.422 0 42.409-18.987 42.409-42.409s-18.987-42.409-42.409-42.409c-23.422 0-42.409 18.987-42.409 42.409s18.987 42.409 42.409 42.409z',
          'M366.715 573.983s24.551 48.371 17.109 63.237l-17.109-63.237z',
          'M343.133 134.497c11.772 1.343 22.95 6.389 34.54 9.149 2.897 0.901 5.98 1.016 8.936 0.335 4.498-1.388 8.158-6.099 12.825-5.963 2.871 0.092 5.413 2.044 7.777 3.918 3.79 2.901 7.36 6.082 10.675 9.516 7.99 8.676 12.946 20.358 20.233 29.798 7.291 9.439 17.684 20.508 28.039 16.18-7.045 27.449-29.013 44.62-53.976 46.328-9.957 0.684-20.16-1.388-29.797 1.524-2.201 0.93-4.751 1.579-7.419 1.822l-0.101 0.007c-5.551 0-10.019-5.093-13.481-10.049-8.113-11.65-14.532-24.872-23.667-35.5-3.050-3.522-6.572-6.862-10.842-7.502s-8.188 1.403-11.985 3.37c-6.267 3.248-12.672 6.602-17.536 12.2s-7.93 13.861-5.917 21.35c1.083 4.057 3.555 7.717 3.599 11.955 0.092 6.771-5.886 11.712-7.061 18.299-0.265 2.767-0.362 5.548-0.29 8.326-0.518 9.024-6.426 16.407-12.579 22.096-2.409 2.196-5.059 4.575-5.764 7.975-0.473 2.333 0 4.785-0.305 7.152-0.9 5.856-6.74 8.829-11.91 9.592-1.512 0.236-3.257 0.371-5.032 0.371-4.627 0-9.040-0.915-13.069-2.573l0.229 0.083c7.228-3.418 11.681-13.145 10.004-21.852-2.303-12.078-14.441-20.755-13.399-33.045 0.57-3.771 1.701-7.436 3.355-10.872 2.435-5.906 4.428-12.828 5.652-20.013l0.083-0.588c0.915-5.444 1.358-11.224-0.352-16.423-1.524-4.728-4.711-8.493-7.411-12.49-3.452-5.059-6.362-10.879-8.44-17.082l-0.146-0.501c-0.558-1.358-0.883-2.935-0.883-4.588 0-0.436 0.023-0.867 0.067-1.291l-0.004 0.053c0.612-2.338 1.914-4.437 3.737-6.024 6.634-6.973 13.724-14.213 22.615-16.21 2.507-0.438 5.393-0.688 8.338-0.688 1.585 0 3.153 0.072 4.701 0.214l-0.199-0.015c1.416 0.047 3.080 0.074 4.75 0.074 6.188 0 12.289-0.371 18.282-1.092l-0.723 0.071c6.099-0.716 16.407-0.625 21.578-4.575 4.818-3.691 7.534-8.326 13.465-10.674 4.095-1.565 8.832-2.472 13.781-2.472 1.776 0 3.524 0.117 5.238 0.343l-0.201-0.022-0.008-0.001z',
          'M1131.142 1019.411c33.977 0 61.518-4.659 61.518-10.404s-27.541-10.404-61.518-10.404-61.518 4.659-61.518 10.404c0 5.745 27.541 10.404 61.518 10.404z',
          'M1156.577 991.993c2.805-2.291 4.849-5.379 5.86-8.858 0.765-3.504-0.732-7.657-4.1-9.010-3.763-1.439-7.793 1.176-10.832 3.808s-6.547 5.646-10.544 5.079c2.056-1.859 3.598-4.215 4.47-6.847s1.049-5.441 0.51-8.159c-0.181-1.127-0.662-2.188-1.394-3.060-2.081-2.237-5.877-1.287-8.369 0.489-7.953 5.581-10.17 16.405-10.219 26.114-0.81-3.504-0.123-7.16-0.152-10.713-0.029-3.549-0.995-7.653-4.038-9.529-1.879-1.008-3.989-1.505-6.119-1.439-3.582-0.136-7.559 0.23-10.006 2.846-3.060 3.245-2.233 8.69 0.399 12.239s6.654 5.827 10.355 8.295c2.961 1.764 5.486 4.174 7.386 7.053 0.226 0.403 0.411 0.827 0.547 1.271h22.351c5.042-2.554 9.714-5.774 13.892-9.574l0.004-0.004z',
          'M294.735 1024c22.422 0 40.599-3.076 40.599-6.868s-18.177-6.864-40.599-6.864c-22.422 0-40.599 3.072-40.599 6.864s18.177 6.868 40.599 6.868z',
          'M311.523 1005.905c1.85-1.513 3.198-3.549 3.867-5.844 0.294-1.151 0.186-2.369-0.306-3.45s-1.339-1.966-2.4-2.5c-2.484-0.946-5.139 0.781-7.148 2.517s-4.322 3.726-6.956 3.352c1.356-1.226 2.371-2.784 2.946-4.52s0.69-3.59 0.335-5.383c-0.118-0.744-0.436-1.443-0.919-2.019-1.367-1.476-3.877-0.851-5.522 0.321-5.25 3.693-6.714 10.824-6.744 17.235-0.535-2.311-0.081-4.725-0.101-7.065-0.021-2.344-0.656-5.050-2.666-6.292-1.24-0.666-2.633-0.991-4.039-0.95-2.363-0.086-4.988 0.152-6.604 1.879-2.019 2.143-1.474 5.737 0.262 8.077 1.736 2.344 4.392 3.849 6.836 5.47 1.954 1.164 3.621 2.755 4.877 4.651 0.151 0.263 0.273 0.547 0.364 0.839h14.751c3.326-1.686 6.41-3.812 9.167-6.321v0.004zM65.129 1024c22.422 0 40.599-3.076 40.599-6.868s-18.177-6.864-40.599-6.864c-22.422 0-40.599 3.072-40.599 6.864s18.177 6.868 40.599 6.868z',
          'M81.916 1005.905c1.85-1.513 3.198-3.549 3.867-5.844 0.294-1.151 0.187-2.369-0.305-3.45s-1.339-1.966-2.4-2.5c-2.484-0.946-5.139 0.781-7.148 2.517s-4.322 3.726-6.957 3.352c1.356-1.226 2.371-2.784 2.946-4.52s0.691-3.59 0.335-5.383c-0.118-0.744-0.436-1.443-0.919-2.019-1.367-1.476-3.878-0.851-5.522 0.321-5.25 3.693-6.714 10.824-6.744 17.235-0.535-2.311-0.081-4.725-0.102-7.065-0.020-2.344-0.656-5.050-2.666-6.292-1.24-0.666-2.633-0.991-4.039-0.95-2.362-0.086-4.988 0.152-6.603 1.879-2.020 2.143-1.474 5.737 0.262 8.077 1.736 2.344 4.392 3.849 6.836 5.47 1.954 1.164 3.621 2.755 4.877 4.651 0.151 0.263 0.273 0.547 0.364 0.839h14.751c3.326-1.686 6.41-3.812 9.167-6.321v0.004z',
          'M1237.243 1020.077h-1234.022v2.492h1234.022v-2.492z',
          'M1177.004 69.078s-128.822-7.773-113.643 82.495c0 0-3.060 15.957 11.445 23.194 0 0 0.226-6.686 13.217-4.406 4.622 0.767 9.323 0.992 13.999 0.673 6.308-0.415 12.313-2.869 17.104-6.992 0 0 36.214-14.963 50.291-74.141 0 0 10.417-12.912 10.006-16.233l-21.743 9.286s7.435 15.682 1.53 28.712c0 0-0.703-28.151-4.877-27.539-0.843 0.123-11.293 5.431-11.293 5.431s12.777 27.309 3.138 47.169c0 0 3.656-33.658-7.131-45.195l-15.298 8.935s14.932 28.213 4.803 51.239c0 0 2.599-35.312-8.032-49.066l-13.863 10.816s14.032 27.799 5.478 46.896c0 0-1.119-41.095-8.476-44.2 0 0-12.132 10.71-13.986 15.084 0 0 9.611 20.196 3.644 30.844 0 0-3.656-27.386-6.658-27.539 0 0-12.086 18.145-13.341 30.599 0 0 0.522-18.497 10.421-32.312 0 0-11.692 2.004-18.514 9.571 0 0 1.879-12.821 21.496-13.953 0 0 9.989-13.769 12.654-14.595 0 0-19.493-1.641-31.32 3.611 0 0 10.404-12.101 34.898-6.594l13.694-11.184s-25.674-3.504-36.564 0.368c0 0 12.531-10.71 40.253-2.907l14.899-8.905s-21.891-4.713-34.927-3.060c0 0 13.768-7.42 39.303 0.628l10.709-4.785s-16.030-3.151-20.731-3.656c-4.696-0.505-4.939-1.79-4.939-1.79 10.158-1.694 20.587-0.533 30.124 3.351 0 0 22.614-8.425 22.232-9.848z',
          'M1000.506 21.289s-58.138-3.504-51.348 37.285c0 0-1.365 7.207 5.173 10.48 0 0 0.107-3.060 5.98-2.004 2.085 0.351 4.207 0.454 6.317 0.306 2.98-0.203 5.653-1.373 7.743-3.196l-0.016 0.013s16.372-6.762 22.734-33.505c0 0 4.696-5.829 4.511-7.328l-9.821 4.192s3.352 7.084 0.72 12.974c0 0-0.321-12.715-2.204-12.423-0.382 0-5.108 2.461-5.108 2.461s5.782 12.346 1.423 21.313c0 0 1.649-15.208-3.228-20.425l-6.917 4.102s6.749 12.744 2.171 23.149c0 0 1.18-15.957-3.623-22.168l-6.259 4.896s6.333 12.561 2.48 21.192c0 0-0.522-18.574-3.841-19.981 0 0-5.478 4.835-6.321 6.824 0 0 4.347 9.18 1.653 13.938 0 0-1.653-12.377-3.060-12.442 0 0-5.461 8.204-6.029 13.77 0.276-5.192 1.9-10.224 4.713-14.595-3.15 0.597-6.058 2.102-8.369 4.33 0 0 0.86-5.798 9.718-6.303 0 0 4.589-6.227 5.72-6.609 0 0-8.813-0.734-14.151 1.64 0 0 4.696-5.462 15.759-2.983l6.119-5.049s-11.609-1.545-16.532 0.159c0 0 5.663-4.835 18.193-1.315l6.732-4.024s-9.899-2.126-15.788-1.367c0 0 6.226-3.351 17.762 0.273l4.82-2.157s-7.246-1.423-9.38-1.653c-2.13-0.23-2.233-0.811-2.233-0.811 1.237-0.216 2.662-0.34 4.115-0.34 3.426 0 6.692 0.687 9.667 1.931l-0.166-0.061s10.347-3.847 10.17-4.485zM103.945 643.981s-58.138-3.504-51.345 37.283c0 0-1.367 7.205 5.171 10.479 0 0 0.107-3.060 5.982-2.003 2.086 0.35 4.207 0.452 6.318 0.304 2.854-0.189 5.567-1.304 7.726-3.183 0 0 16.37-6.761 22.734-33.504 0 0 4.696-5.827 4.512-7.328l-9.822 4.191s3.351 7.086 0.719 12.975c0 0-0.321-12.716-2.203-12.424-0.383 0-5.111 2.463-5.111 2.463s5.783 12.346 1.423 21.311c0 0 1.652-15.208-3.228-20.422l-6.915 4.1s6.747 12.744 2.173 23.149c0 0 1.179-15.956-3.626-22.17l-6.258 4.898s6.334 12.559 2.479 21.191c0 0-0.519-18.576-3.841-19.982 0 0-5.477 4.836-6.319 6.827 0 0 4.345 9.179 1.653 13.937 0 0-1.653-12.378-3.060-12.444 0 0-5.462 8.204-6.028 13.773 0.296-5.457 2.012-10.458 4.783-14.71l-0.070 0.115c-3.152 0.596-6.061 2.101-8.369 4.33 0 0 0.857-5.799 9.716-6.304 0 0 4.59-6.226 5.722-6.609 0 0-8.812-0.736-14.153 1.641 0 0 4.696-5.461 15.759-2.986l6.12-5.050s-11.608-1.542-16.53 0.16c0 0 5.66-4.836 18.191-1.316l6.732-4.022s-9.899-2.126-15.789-1.369c0 0 6.226-3.352 17.763 0.276l4.819-2.159s-7.247-1.423-9.379-1.653c-2.133-0.23-2.234-0.81-2.234-0.81 4.593-0.765 9.308-0.234 13.617 1.53 0 0 10.347-3.845 10.168-4.483z',
        ],
        attrs: [
          {
            fill: 'rgb(63, 61, 86)',
          },
          {
            fill: 'rgb(63, 61, 86)',
          },
          {
            fill: 'rgb(70, 135, 28)',
          },
          {
            fill: 'rgb(230, 232, 236)',
          },
          {
            fill: 'rgb(255, 255, 255)',
          },
          {
            fill: 'rgb(190, 214, 0)',
          },
          {
            fill: 'rgb(63, 61, 86)',
          },
          {
            fill: 'rgb(0, 0, 0)',
          },
          {
            fill: 'rgb(254, 185, 185)',
          },
          {
            fill: 'rgb(63, 61, 86)',
          },
          {
            fill: 'rgb(47, 46, 65)',
          },
          {
            fill: 'rgb(0, 0, 0)',
            opacity: 0.1,
          },
          {
            fill: 'rgb(254, 185, 185)',
          },
          {
            fill: 'rgb(47, 46, 65)',
          },
          {
            fill: 'rgb(63, 61, 86)',
          },
          {
            fill: 'rgb(0, 0, 0)',
            opacity: 0.1,
          },
          {
            fill: 'rgb(239, 239, 239)',
          },
          {
            fill: 'rgb(0, 0, 0)',
            opacity: 0.1,
          },
          {
            fill: 'rgb(225, 112, 0)',
          },
          {
            fill: 'rgb(0, 0, 0)',
            opacity: 0.1,
          },
          {
            fill: 'rgb(254, 185, 185)',
          },
          {
            fill: 'rgb(0, 0, 0)',
            opacity: 0.1,
          },
          {
            fill: 'rgb(47, 46, 65)',
          },
          {
            fill: 'rgb(225, 112, 0)',
          },
          {
            fill: 'rgb(225, 112, 0)',
          },
          {
            fill: 'rgb(239, 239, 239)',
          },
          {
            fill: 'rgb(239, 239, 239)',
          },
          {
            fill: 'rgb(239, 239, 239)',
          },
          {
            fill: 'rgb(47, 46, 65)',
          },
          {
            fill: 'rgb(225, 112, 0)',
          },
          {
            fill: 'rgb(63, 61, 86)',
          },
        ],
        width: 1238,
        isMulticolor: true,
        isMulticolor2: true,
        grid: 16,
        tags: ['confirmed'],
      },
      attrs: [
        {
          fill: 'rgb(63, 61, 86)',
        },
        {
          fill: 'rgb(63, 61, 86)',
        },
        {
          fill: 'rgb(70, 135, 28)',
        },
        {
          fill: 'rgb(230, 232, 236)',
        },
        {
          fill: 'rgb(255, 255, 255)',
        },
        {
          fill: 'rgb(190, 214, 0)',
        },
        {
          fill: 'rgb(63, 61, 86)',
        },
        {
          fill: 'rgb(0, 0, 0)',
        },
        {
          fill: 'rgb(254, 185, 185)',
        },
        {
          fill: 'rgb(63, 61, 86)',
        },
        {
          fill: 'rgb(47, 46, 65)',
        },
        {
          fill: 'rgb(0, 0, 0)',
          opacity: 0.1,
        },
        {
          fill: 'rgb(254, 185, 185)',
        },
        {
          fill: 'rgb(47, 46, 65)',
        },
        {
          fill: 'rgb(63, 61, 86)',
        },
        {
          fill: 'rgb(0, 0, 0)',
          opacity: 0.1,
        },
        {
          fill: 'rgb(239, 239, 239)',
        },
        {
          fill: 'rgb(0, 0, 0)',
          opacity: 0.1,
        },
        {
          fill: 'rgb(225, 112, 0)',
        },
        {
          fill: 'rgb(0, 0, 0)',
          opacity: 0.1,
        },
        {
          fill: 'rgb(254, 185, 185)',
        },
        {
          fill: 'rgb(0, 0, 0)',
          opacity: 0.1,
        },
        {
          fill: 'rgb(47, 46, 65)',
        },
        {
          fill: 'rgb(225, 112, 0)',
        },
        {
          fill: 'rgb(225, 112, 0)',
        },
        {
          fill: 'rgb(239, 239, 239)',
        },
        {
          fill: 'rgb(239, 239, 239)',
        },
        {
          fill: 'rgb(239, 239, 239)',
        },
        {
          fill: 'rgb(47, 46, 65)',
        },
        {
          fill: 'rgb(225, 112, 0)',
        },
        {
          fill: 'rgb(63, 61, 86)',
        },
      ],
      properties: {
        order: 15,
        id: 503,
        name: 'confirmed',
        prevSize: 32,
      },
      setIdx: 0,
      setId: 1,
      iconIdx: 0,
    },
    {
      icon: {
        paths: [
          'M1092.85 137.668c-230.855-177.823-552.024-185.089-786.334-11.83-123.862 91.592-219.888 231.718-202.416 445.077 6.175 75.468 23.361 137.38 48.433 188.061 101.554 205.461 518.66 197.554 541.825 197.518 15.007-0.014 30.015 0.32 45.020 1.010 52.572 2.411 104.86 9.017 156.373 19.755 73.451 15.296 166.948 22.983 250.489-5.988 14.194-4.9 27.989-10.894 41.252-17.927 45.909-24.384 97.301-47.68 127.353-105.508 22.578-43.399 39.026-97.82 46.94-165.604 28.814-246.851-115.164-426.116-268.935-544.565z',
          'M740.395 1022.379c364.58 0 660.132-27.726 660.132-61.924s-295.552-61.924-660.132-61.924c-364.58 0-660.131 27.726-660.131 61.924s295.551 61.924 660.131 61.924z',
          'M708.152 989.525c339.087 0 613.974-13.013 613.974-29.070 0-16.050-274.887-29.063-613.974-29.063s-613.972 13.013-613.972 29.063c0 16.057 274.885 29.070 613.972 29.070z',
          'M1047.808 131.122v69.473h-90.51v757.649h188.885v-827.122h-98.375zM549.361 597.771v-119.283h-115.43v119.283h-43.285v361.781h200.689v-361.781h-41.974z',
          'M569.023 791.772h-156.092v169.095h156.092v-169.095z',
          'M437.853 791.772h-24.922v169.095h24.922v-169.095z',
          'M890.404 93.107v40.635h-230.862v-40.635h-68.209v867.76h365.965v-867.76h-66.894z',
          'M941.561 923.172h-51.157v62.308h51.157v-62.308zM642.49 93.108h-51.157v867.76h51.157v-867.76z',
          'M330.304 340.851v-32.77h-34.103v32.77h-61.652v620.016h156.094v-620.016h-60.338z',
          'M314.559 308.081h-18.364v32.77h18.364v-32.77zM252.912 340.852h-18.364v620.016h18.364v-620.016zM941.561 427.365h-51.157v533.503h51.157v-533.503zM390.638 340.852h-47.221v114.040h47.221v-114.040z',
          'M877.276 526.987h-73.458v31.46h73.458v-31.46zM721.195 753.756h-73.458v31.46h73.458v-31.46zM349.976 482.419h-73.456v31.46h73.456v-31.46zM528.365 810.119h-73.455v31.46h73.455v-31.46z',
          'M554.597 625.298h-125.924v52.432h125.924v-52.432zM1105.515 260.892h-125.924v52.432h125.924v-52.432zM1105.515 372.311h-125.924v52.432h125.924v-52.432zM1105.515 483.73h-125.924v52.432h125.924v-52.432zM1105.515 595.149h-125.924v52.433h125.924v-52.433zM1105.515 706.568h-125.924v52.43h125.924v-52.43zM1105.515 817.984h-125.924v52.437h125.924v-52.437z',
          'M1189.476 498.148v-142.878h-91.819v142.878h-32.796v462.719h156.096v-462.719h-31.481z',
          'M1126.507 355.27h-28.864v142.879h28.864v-142.879zM1093.717 498.149h-28.857v462.719h28.857v-462.719zM1220.942 730.162h-77.39v45.881h77.39v-45.881z',
          'M1219.634 662h-73.451v31.46h73.451v-31.46z',
          'M1449.55 693.761c0 116.785-69.476 157.56-155.172 157.56s-155.172-40.775-155.172-157.56c0-116.782 155.172-265.347 155.172-265.347s155.172 148.565 155.172 265.347z',
          'M1288.725 833.451l1.593-97.735 66.133-120.911-65.884 105.579 0.711-43.945 45.582-87.479-45.39 75.852 1.287-79.039 48.804-69.646-48.604 57.217 0.804-144.931-5.049 191.861 0.42-7.915-49.628-75.908 48.832 91.103-4.629 88.272-0.135-2.34-57.209-79.886 57.038 88.164-0.583 11.036-0.1 0.164 0.043 0.91-11.726 223.957h15.673l1.877-115.684 56.896-87.943-56.754 79.246z',
          'M312.313 695.024c0 116.78-69.472 157.555-155.17 157.555s-155.171-40.775-155.171-157.555c0-116.782 155.171-265.347 155.171-265.347s155.17 148.565 155.17 265.347z',
          'M151.49 834.716l1.589-97.735 66.138-120.912-65.888 105.581 0.713-43.946 45.582-87.479-45.392 75.851 1.285-79.039 48.81-69.646-48.608 57.217 0.803-144.931-5.047 191.861 0.415-7.915-49.626-75.908 48.829 91.101-4.622 88.276-0.138-2.347-57.21-79.881 57.036 88.158-0.578 11.044-0.104 0.164 0.047 0.903-11.731 223.957h15.674l1.88-115.676 56.896-87.943-56.755 79.246z',
        ],
        attrs: [
          {
            fill: 'rgb(242, 242, 242)',
          },
          {
            fill: 'rgb(63, 61, 86)',
          },
          {
            fill: 'rgb(0, 0, 0)',
            opacity: 0.1,
          },
          {
            fill: 'rgb(87, 90, 137)',
          },
          {
            fill: 'rgb(63, 61, 86)',
          },
          {
            fill: 'rgb(0, 0, 0)',
            opacity: 0.1,
          },
          {
            fill: 'rgb(63, 61, 86)',
          },
          {
            fill: 'rgb(0, 0, 0)',
            opacity: 0.1,
          },
          {
            fill: 'rgb(63, 61, 86)',
          },
          {
            fill: 'rgb(0, 0, 0)',
            opacity: 0.1,
          },
          {
            fill: 'rgb(255, 101, 132)',
          },
          {
            fill: 'rgb(0, 0, 0)',
            opacity: 0.1,
          },
          {
            fill: 'rgb(63, 61, 86)',
          },
          {
            fill: 'rgb(0, 0, 0)',
            opacity: 0.1,
          },
          {
            fill: 'rgb(255, 101, 132)',
          },
          {
            fill: 'rgb(225, 112, 0)',
          },
          {
            fill: 'rgb(63, 61, 86)',
          },
          {
            fill: 'rgb(225, 112, 0)',
          },
          {
            fill: 'rgb(63, 61, 86)',
          },
        ],
        width: 1451,
        isMulticolor: true,
        isMulticolor2: true,
        grid: 16,
        tags: ['city'],
      },
      attrs: [
        {
          fill: 'rgb(242, 242, 242)',
        },
        {
          fill: 'rgb(63, 61, 86)',
        },
        {
          fill: 'rgb(0, 0, 0)',
          opacity: 0.1,
        },
        {
          fill: 'rgb(87, 90, 137)',
        },
        {
          fill: 'rgb(63, 61, 86)',
        },
        {
          fill: 'rgb(0, 0, 0)',
          opacity: 0.1,
        },
        {
          fill: 'rgb(63, 61, 86)',
        },
        {
          fill: 'rgb(0, 0, 0)',
          opacity: 0.1,
        },
        {
          fill: 'rgb(63, 61, 86)',
        },
        {
          fill: 'rgb(0, 0, 0)',
          opacity: 0.1,
        },
        {
          fill: 'rgb(255, 101, 132)',
        },
        {
          fill: 'rgb(0, 0, 0)',
          opacity: 0.1,
        },
        {
          fill: 'rgb(63, 61, 86)',
        },
        {
          fill: 'rgb(0, 0, 0)',
          opacity: 0.1,
        },
        {
          fill: 'rgb(255, 101, 132)',
        },
        {
          fill: 'rgb(225, 112, 0)',
        },
        {
          fill: 'rgb(63, 61, 86)',
        },
        {
          fill: 'rgb(225, 112, 0)',
        },
        {
          fill: 'rgb(63, 61, 86)',
        },
      ],
      properties: {
        order: 14,
        id: 502,
        name: 'city',
        prevSize: 32,
      },
      setIdx: 0,
      setId: 1,
      iconIdx: 0,
    },
    {
      icon: {
        paths: [
          'M1248.639 579.677c-49.020 73.739-36.613 176.233-11.931 257.413 8.311 27.179 17.699 55.897 12.116 85.93-6.824 36.738-34.651 65.027-63.184 80.863-51.986 28.89-112.329 26.512-157.101-6.157-38.694-28.249-64.988-76.437-104.481-103.292-65.992-44.779-154.122-20.824-230.222 17.666-53.844 27.199-112.956 61.889-163.983 40.128-35.902-15.314-59.172-56.558-70.735-101.092-5.58-21.497-9.236-44.924-21.133-61.506-7.123-9.857-16.621-16.622-26.463-22.118-89.885-50.744-208.477-13.239-295.442-70.299-58.685-38.465-93.601-115.802-106.637-197.898s-6.613-169.418 2.101-255.349c6.185-61.059 15.054-126.381 49.116-175.33 36.033-51.775 94.48-73.822 146.029-67.613s96.878 36.958 136.329 74.083c49.305 46.302 94.23 105.022 156.833 121.097 42.633 10.982 88.579 0.677 133.385-4.749 74.915-8.964 149.152-3.977 222.893 1.947 70.603 5.675 141.656 12.336 207.964 36.531 46.919 17.12 83.512 51.217 127.498 73.893 28.672 14.781 60.608 17.369 87.476 36.804 33.098 23.923 62.352 67.305 50.85 120.908-10.94 51.039-55.27 78.962-81.279 118.141z',
          'M1096.301 304.43h-48.544v73.49h48.544v-73.49z',
          'M1091.577 311.577h-39.104v59.196h39.104v-59.196zM1023.775 253.379h-74.554v73.49h74.554v-73.49z',
          'M1016.521 260.526h-60.066v59.195h60.066v-59.195zM306.65 144.035h-227.888v6.067h227.888v-6.067zM306.65 173.704h-227.888v6.067h227.888v-6.067z',
          'M486.481 537.376h-23.281v260.168h23.281v-260.168z',
          'M1166.528 564.694v-239.986c0-6.689 2.662-13.103 7.393-17.832s11.145-7.385 17.831-7.385c6.686 0.013 13.087 2.674 17.804 7.402 4.724 4.727 7.373 11.134 7.379 17.815v290.443c0 6.691-2.656 13.108-7.393 17.839-4.564 4.565-10.87 7.389-17.835 7.389-0.001 0-0.001-0-0.002-0l-156.249 0c-6.692 0-13.107-2.658-17.837-7.389-4.737-4.732-7.393-11.148-7.393-17.839s2.656-13.108 7.393-17.839c4.564-4.565 10.871-7.389 17.837-7.389 0 0 0.001 0 0.001 0l105.842-0c6.692 0 13.107-2.658 17.837-7.389s7.393-11.148 7.393-17.839z',
          'M1166.528 564.694v-239.986c0-6.689 2.662-13.103 7.393-17.832s11.145-7.385 17.831-7.385c6.686 0.013 13.087 2.674 17.804 7.402 4.724 4.727 7.373 11.134 7.379 17.815v290.443c0 6.691-2.656 13.108-7.393 17.839-4.564 4.565-10.87 7.389-17.835 7.389-0.001 0-0.001-0-0.002-0l-156.249 0c-6.692 0-13.107-2.658-17.837-7.389-4.737-4.732-7.393-11.148-7.393-17.839s2.656-13.108 7.393-17.839c4.564-4.565 10.871-7.389 17.837-7.389 0 0 0.001 0 0.001 0l105.842-0c6.692 0 13.107-2.658 17.837-7.389s7.393-11.148 7.393-17.839z',
          'M1010.265 613.797c0.344-6.447 3.151-12.517 7.835-16.958 4.691-4.442 10.901-6.917 17.355-6.917h105.842c6.692 0 13.107-2.658 17.844-7.389 4.73-4.731 7.386-11.148 7.386-17.839v-239.986c-0.007-6.485 2.491-12.722 6.963-17.417 4.466-4.695 10.577-7.488 17.051-7.8v314.307h-180.277z',
          'M230.585 572.791v-239.987c-0-13.913-11.261-25.195-25.166-25.229l-0.003-0c-6.691 0-13.108 2.658-17.839 7.389s-7.389 11.148-7.389 17.839v290.444c-0.008 3.318 0.639 6.604 1.903 9.673s3.122 5.856 5.465 8.205c2.344 2.349 5.127 4.212 8.192 5.484s6.351 1.926 9.669 1.926h156.239c6.691 0 13.108-2.658 17.839-7.389s7.389-11.148 7.389-17.839-2.658-13.108-7.389-17.839c-4.565-4.565-10.873-7.389-17.839-7.389-0 0-0 0-0 0l-105.829-0c-0.003 0-0.007 0-0.011 0-3.486 0-6.807-0.707-9.827-1.985l0.165 0.062c-3.189-1.342-5.911-3.194-8.196-5.483l-0-0c-2.285-2.289-4.132-5.014-5.406-8.041l-0.062-0.166c-1.205-2.842-1.905-6.147-1.905-9.615 0-0.021 0-0.042 0-0.063l-0 0.003z',
          'M230.585 572.791v-239.987c-0-13.913-11.261-25.195-25.166-25.229l-0.003-0c-6.691 0-13.108 2.658-17.839 7.389s-7.389 11.148-7.389 17.839v290.444c-0.008 3.318 0.639 6.604 1.903 9.673s3.122 5.856 5.465 8.205c2.344 2.349 5.127 4.212 8.192 5.484s6.351 1.926 9.669 1.926h156.239c6.691 0 13.108-2.658 17.839-7.389s7.389-11.148 7.389-17.839-2.658-13.108-7.389-17.839c-4.565-4.565-10.873-7.389-17.839-7.389-0 0-0 0-0 0l-105.829-0c-0.003 0-0.007 0-0.011 0-3.486 0-6.807-0.707-9.827-1.985l0.165 0.062c-3.189-1.342-5.911-3.194-8.196-5.483l-0-0c-2.285-2.289-4.132-5.014-5.406-8.041l-0.062-0.166c-1.205-2.842-1.905-6.147-1.905-9.615 0-0.021 0-0.042 0-0.063l-0 0.003z',
          'M386.851 621.895c-0.37-6.702-3.303-12.655-7.827-16.948l-0.011-0.010c-4.512-4.283-10.626-6.917-17.355-6.917-0 0-0 0-0 0l-105.829-0c-0.004 0-0.009 0-0.014 0-3.479 0-6.794-0.705-9.809-1.979l0.166 0.062c-3.185-1.338-5.905-3.185-8.189-5.468l0 0c-2.284-2.283-4.133-5.002-5.41-8.021l-0.062-0.165c-1.215-2.853-1.922-6.173-1.922-9.657l-0-0v-239.987c-0.002-13.493-10.597-24.511-23.921-25.191l-0.061-0.002v314.283h180.245zM947.094 537.376h-23.281v266.239h23.281v-266.239z',
          'M486.481 537.376h-23.281v19.233h23.281v-19.233zM947.094 537.376h-23.281v19.233h23.281v-19.233zM546.353 378.94c-0.372 4.1-0.843 8.255-1.412 12.466h-3.289v-12.466h4.701z',
          'M641.747 508.443c0.071 4.215-2.968 7.669-6.731 7.669h-71.056v-7.408h59.124c2.553 0 4.144-3.087 2.861-5.557l-53.615-109.047c-0.39-0.797-0.97-1.448-1.682-1.914l-0.018-0.011c-0.694-0.455-1.54-0.734-2.449-0.758l-0.006-0h-26.522v-12.466h33.491c1.276 0.034 2.37 0.781 2.9 1.857l0.009 0.020 61.463 118.723c1.416 2.754 2.18 5.797 2.232 8.892z',
          'M511.253 488.664l-0.973 1.638-9.106-6.079 28.173-216.634h7.254s0.297 0.998 0.784 2.897c4.856 18.723 28.707 124.754-26.131 218.177z',
          'M537.373 270.487l-26.119 218.177-0.973 1.638-9.106-6.079 28.173-216.634h7.254s0.285 1.033 0.772 2.897z',
          'M519.655 265.349l-26.726 223.136 17.092 2.047 26.726-223.136-17.093-2.047z',
          'M434.346 508.526c-0.007 1.118-0.912 2.023-2.029 2.030l-0.001 0h-3.040c-0.561-0-1.068-0.227-1.436-0.595l0 0c-0.367-0.367-0.595-0.875-0.595-1.436l-0-0c-0.004-0.036-0.007-0.077-0.007-0.119s0.003-0.083 0.007-0.123l-0 0.005c0.128-1.006 0.977-1.776 2.006-1.781l0-0h3.040c0.471 0.005 0.904 0.169 1.246 0.441l-0.004-0.003c0.347 0.275 0.601 0.655 0.714 1.091l0.003 0.014c0.049 0.14 0.083 0.301 0.095 0.469l0 0.006zM443.455 508.526c-0.007 1.118-0.912 2.023-2.029 2.030l-0.001 0h-3.040c-0.561-0-1.068-0.227-1.436-0.595l0 0c-0.367-0.367-0.595-0.875-0.595-1.436l-0-0c0.001-0.199 0.032-0.391 0.087-0.572l-0.004 0.014c0.095-0.342 0.273-0.634 0.51-0.866l0-0c0.181-0.185 0.398-0.334 0.639-0.436l0.013-0.005c0.226-0.097 0.488-0.153 0.763-0.153 0.003 0 0.006 0 0.009 0l-0-0h3.040c0.003-0 0.007-0 0.010-0 0.407 0 0.786 0.119 1.104 0.325l-0.008-0.005c0.329 0.212 0.589 0.506 0.752 0.855l0.005 0.012c0.111 0.244 0.176 0.53 0.178 0.83l0 0.001zM451.552 508.526c-0.003 0.56-0.231 1.065-0.598 1.432l0-0c-0.367 0.366-0.873 0.594-1.432 0.598l-0.001 0h-3.040c-0.561-0-1.068-0.227-1.436-0.595l0 0c-0.367-0.367-0.595-0.875-0.595-1.436l-0-0c-0-0.009-0-0.020-0-0.031 0-0.295 0.066-0.574 0.184-0.824l-0.005 0.012c0.17-0.356 0.426-0.646 0.742-0.853l0.008-0.005c0.308-0.202 0.684-0.324 1.089-0.33l0.001-0h3.040c0.003-0 0.006-0 0.010-0 0.277 0 0.542 0.056 0.783 0.156l-0.013-0.005c0.247 0.102 0.471 0.251 0.66 0.44 0.184 0.184 0.333 0.403 0.435 0.647l0.005 0.013c0.096 0.227 0.151 0.492 0.151 0.769 0 0.003-0 0.007-0 0.010l0-0.001h0.012zM460.672 508.526c-0.007 1.118-0.912 2.023-2.029 2.030l-0.001 0h-3.040c-0.389-0-0.752-0.11-1.061-0.3l0.009 0.005c-0.317-0.195-0.571-0.466-0.741-0.787l-0.005-0.011c-0.145-0.272-0.23-0.594-0.23-0.937 0-0.047 0.002-0.093 0.005-0.139l-0 0.006c0.026-0.389 0.158-0.742 0.366-1.038l-0.004 0.006 0.238-0.261c0.181-0.185 0.398-0.334 0.639-0.436l0.013-0.005c0.226-0.097 0.488-0.153 0.763-0.153 0.003 0 0.006 0 0.009 0l-0-0h3.040c0.291 0.004 0.567 0.068 0.815 0.18l-0.013-0.005c0.253 0.112 0.481 0.275 0.669 0.478 0.357 0.365 0.557 0.855 0.558 1.366z',
          'M434.286 508.039c0.038 0.141 0.060 0.303 0.060 0.471 0 0.006-0 0.011-0 0.017l0-0.001c-0.007 1.118-0.912 2.023-2.029 2.030l-0.001 0h-3.040c-0.561-0-1.068-0.227-1.436-0.595l0 0c-0.367-0.367-0.595-0.875-0.595-1.436l-0-0c-0.004-0.036-0.007-0.077-0.007-0.119s0.003-0.083 0.007-0.124l-0 0.005 7.040-0.249zM443.288 507.719c0.102 0.234 0.163 0.507 0.166 0.794l0 0.001c-0.007 1.118-0.912 2.023-2.029 2.030l-0.001 0h-3.040c-0.561-0-1.068-0.227-1.436-0.595l0 0c-0.367-0.367-0.595-0.875-0.595-1.436l-0-0c0.001-0.199 0.032-0.391 0.087-0.572l-0.004 0.014 6.85-0.237zM451.256 507.446c0.192 0.303 0.307 0.672 0.309 1.068l0 0.001c-0.003 0.56-0.231 1.066-0.598 1.432l-0 0c-0.367 0.367-0.873 0.595-1.432 0.598l-0.001 0h-3.039c-0.561-0-1.068-0.227-1.436-0.595l0 0c-0.367-0.367-0.595-0.875-0.595-1.436l-0-0c-0-0.010-0-0.022-0-0.035 0-0.293 0.066-0.571 0.183-0.82l-0.005 0.012 6.613-0.225zM460.672 508.526c-0.007 1.118-0.912 2.023-2.029 2.030l-0.001 0h-3.040c-0.389-0-0.753-0.11-1.061-0.3l0.009 0.005c-0.317-0.195-0.571-0.465-0.741-0.786l-0.005-0.011c-0.145-0.272-0.23-0.594-0.23-0.937 0-0.047 0.002-0.093 0.005-0.139l-0 0.006c0.026-0.389 0.158-0.742 0.366-1.038l-0.004 0.006 6.174-0.214c0.345 0.353 0.558 0.837 0.558 1.37 0 0.002-0 0.005-0 0.007l0-0z',
          'M478.889 516.623h-58.708v-2.671c-0-0.001-0-0.002-0-0.004 0-1.234 0.489-2.354 1.285-3.176l-0.001 0.001c0.797-0.824 1.9-1.349 3.125-1.392l0.008-0 47.086-1.627c0.935-0.032 1.868 0.125 2.742 0.46s1.671 0.844 2.345 1.494c0.673 0.651 1.209 1.43 1.575 2.291s0.556 1.788 0.557 2.724l-0.012 1.899z',
          'M768.529 508.443c-0.073 4.215 2.973 7.669 6.732 7.669h71.092v-7.408h-59.194c-2.55 0-4.142-3.087-2.861-5.557l53.611-109.047c0.383-0.786 0.971-1.452 1.704-1.925s1.579-0.736 2.451-0.758h26.538v-12.466h-33.468c-0.601 0.023-1.183 0.209-1.691 0.536-0.502 0.328-0.905 0.787-1.169 1.328l-61.466 118.723c-1.434 2.754-2.213 5.8-2.279 8.904z',
          'M899.039 488.664l0.978 1.638 9.104-6.079-28.177-216.634h-7.254s-0.297 0.998-0.78 2.897c-4.869 18.723-28.771 124.754 26.129 218.177z',
          'M872.917 270.487l26.115 218.177 0.978 1.638 9.104-6.079-28.163-216.634h-7.254s-0.291 1.033-0.78 2.897z',
          'M890.655 265.326l-17.091 2.047 26.723 223.136 17.091-2.047-26.723-223.136z',
          'M975.931 508.526c0 0.538 0.218 1.052 0.595 1.432 0.383 0.38 0.898 0.595 1.434 0.598h3.039c0.535 0 1.057-0.214 1.434-0.595 0.383-0.381 0.595-0.897 0.595-1.436 0.006-0.036 0.010-0.077 0.010-0.119s-0.004-0.083-0.011-0.123l0.001 0.004c-0.064-0.508-0.308-0.95-0.665-1.267l-0.002-0.002c-0.37-0.328-0.846-0.51-1.335-0.512h-3.039c-0.474 0.004-0.908 0.169-1.253 0.441l0.004-0.003c-0.344 0.277-0.596 0.656-0.71 1.091l-0.003 0.014c-0.053 0.154-0.086 0.313-0.092 0.475zM966.821 508.526c0.007 0.538 0.218 1.052 0.601 1.432 0.377 0.38 0.892 0.595 1.434 0.598h3.039c0.264 0 0.529-0.052 0.773-0.155 0.251-0.102 0.469-0.252 0.661-0.44 0.182-0.185 0.331-0.403 0.437-0.645l0.005-0.014c0.096-0.23 0.151-0.497 0.152-0.777l0-0c0-0.189-0.026-0.377-0.086-0.558-0.086-0.329-0.264-0.628-0.509-0.866-0.185-0.19-0.41-0.34-0.654-0.441-0.224-0.097-0.486-0.153-0.76-0.153-0.005 0-0.009 0-0.014 0l0.001-0h-3.098c-0.003-0-0.006-0-0.009-0-0.406 0-0.785 0.119-1.102 0.325l0.008-0.005c-0.33 0.211-0.595 0.511-0.76 0.867-0.077 0.216-0.121 0.465-0.121 0.724 0 0.038 0.001 0.075 0.003 0.112l-0-0.005zM958.728 508.526c0.007 0.538 0.218 1.052 0.601 1.432 0.377 0.38 0.892 0.595 1.427 0.598h3.039c0.542 0 1.057-0.214 1.44-0.595 0.377-0.381 0.595-0.897 0.595-1.436 0.007-0.291-0.059-0.579-0.178-0.843-0.165-0.35-0.423-0.647-0.753-0.858-0.308-0.202-0.684-0.325-1.089-0.33l-0.001-0h-3.039c-0.264-0.001-0.529 0.050-0.78 0.151-0.257 0.109-0.476 0.257-0.661 0.44l0-0c-0.185 0.189-0.337 0.413-0.436 0.66-0.106 0.247-0.152 0.512-0.152 0.779h-0.013zM949.611 508.526c0.007 0.538 0.218 1.052 0.601 1.432 0.377 0.38 0.892 0.595 1.434 0.598h3.039c0.37 0 0.733-0.102 1.050-0.295s0.575-0.469 0.747-0.798c0.172-0.33 0.251-0.7 0.225-1.070-0.028-0.389-0.16-0.742-0.368-1.038l0.004 0.007-0.238-0.261c-0.185-0.19-0.403-0.34-0.647-0.441-0.251-0.102-0.509-0.154-0.773-0.153h-3.039c-0.277 0.003-0.555 0.063-0.806 0.175s-0.482 0.275-0.667 0.478c-0.357 0.365-0.562 0.855-0.562 1.366z',
          'M975.991 508.039c-0.039 0.127-0.061 0.274-0.061 0.425 0 0.022 0 0.043 0.001 0.065l-0-0.003c0 0.537 0.218 1.052 0.595 1.432 0.383 0.38 0.898 0.595 1.434 0.598h3.039c0.542 0 1.057-0.214 1.434-0.595 0.383-0.381 0.595-0.897 0.595-1.436 0.006-0.036 0.010-0.077 0.010-0.119s-0.004-0.083-0.011-0.123l0.001 0.004-7.036-0.249zM966.993 507.719c-0.106 0.252-0.165 0.522-0.165 0.795 0 0.538 0.218 1.052 0.595 1.432 0.383 0.38 0.898 0.595 1.434 0.598h3.039c0.264 0 0.529-0.052 0.78-0.155 0.244-0.102 0.469-0.252 0.654-0.44 0.192-0.188 0.344-0.412 0.443-0.659 0.096-0.23 0.151-0.497 0.152-0.777l0-0c0-0 0-0.001 0-0.001 0-0.198-0.029-0.39-0.083-0.571l0.004 0.014-6.851-0.237zM959.026 507.446c-0.198 0.32-0.311 0.69-0.311 1.068 0.007 0.538 0.218 1.052 0.601 1.432 0.377 0.38 0.892 0.595 1.427 0.598h3.046c0.535 0 1.050-0.214 1.434-0.595 0.377-0.381 0.595-0.897 0.595-1.436 0.007-0.291-0.059-0.579-0.178-0.843l-6.613-0.225zM949.611 508.526c0.007 0.537 0.218 1.052 0.601 1.432 0.377 0.38 0.892 0.595 1.434 0.598h3.039c0.777-0.002 1.452-0.439 1.792-1.082l0.005-0.011c0.172-0.33 0.251-0.7 0.225-1.070-0.028-0.389-0.16-0.742-0.368-1.038l0.004 0.007-6.17-0.214c-0.363 0.368-0.562 0.863-0.562 1.377z',
          'M931.391 516.623h58.712v-2.671c0-1.187-0.462-2.326-1.288-3.179-0.819-0.853-1.942-1.352-3.131-1.392l-47.084-1.627c-0.938-0.032-1.87 0.125-2.742 0.46s-1.671 0.844-2.345 1.494c-0.674 0.651-1.209 1.43-1.572 2.291-0.37 0.861-0.555 1.788-0.562 2.724l0.013 1.899z',
          'M1177.131 548.809c27.39-46.457 17.461-140.164 18.571-141.957 0.984-1.579-2.795-45.708-27.965-56.488-4.545-9.011-9.018-19.161-9.018-19.161-0.443 0.414-0.932 0.776-1.453 1.080-0.198-0.538-0.39-1.084-0.581-1.638-0.317-0.938-0.614-1.899-0.912-2.861 0.707 0.225 1.42 0.408 2.147 0.546 1.922 0.468 3.944 0.289 5.748-0.511 0.614-0.33 1.176-0.76 1.652-1.27 1.982-1.318 3.072-3.692 3.997-5.936l7.327-17.547c3.303-7.918 6.626-15.885 8.384-24.279 2.616-12.632 1.599-25.745-2.92-37.825-1.731-4.607-4.129-9.213-8.205-11.968-8.152-5.532-19.502-1.709-28.824-4.95-3.065-1.069-5.833-2.873-8.892-3.966-6.613-2.374-14.085-1.104-20.447 1.852s-11.515 7.658-17.084 11.872c-2.742 2.101-7.122 4.274-10.352 7.123-3.131 2.446-5.543 5.402-5.080 9.296 0.522 4.452 5.212 7.124 9.579 8.168 0.727 0.166 1.473 0.297 2.213 0.427-5.186 5.253-8.925 11.76-10.848 18.886-0.938 3.341-1.477 7.178-1.477 11.14 0 3.78 0.49 7.446 1.411 10.937l-0.067-0.298c1.837 7.149 5.497 13.7 10.617 19.016s11.535 9.214 18.61 11.316c2.226 4.184 4.155 8.52 5.767 12.976 0.211 0.61 0.423 1.223 0.628 1.841-7.194 2.042-12.823 3.739-13.946 4.677-3.409 2.826 3.726 27.567 3.726 27.567-1.817 2.303-3.667 4.927-5.543 7.741-14.224 21.607-23.235 46.225-26.313 71.911-1.183 9.391-2.728 18.996-4.684 28.126l-85.091-17.061-0.178 2.102-8.417-2.078-0.251 1.436-0.971-0.463c-15.829-7.42-42.493-16.894-60.548-7.123-19.060 10.258 22.066 23.887 48.458 31.141-8.747 0.427-17.117 2.529-23.744 7.444-19.139 14.341 34.988 21.809 60.548 24.457l1.037 0.106v0.546l10.934 1.009 0.198 3.159s12.684 2.078 29.623 4.594c-19.337 4.832-43.239 8.18-59.835 10.139-17.6 2.066-32.576 14.318-37.307 31.402-1.526 4.899-1.671 10.124-0.423 15.102 4.935 17.25-1.097 144.153-2.458 171.484l-31.288 18.009s-48.676 5.939-16.252 17.349c2.92 0.998 5.913 1.79 8.939 2.372-4.274 2.755-3.904 6.349 8.694 10.769 32.444 11.376 107.87-0.495 107.87-0.495s-1.652-13.371-4.334-24.484l0.832 0.073s-7.789-28.983 4.023-43.596c11.812-14.613-1.982-125.847-1.982-125.847s20.678-8.56 82.501-9.118c49.865 12.799 74.164-33.016 73.82-56.702-0.106-0.534-0.132-1.081-0.165-1.567z',
          'M992.851 476.815l-5.279 21.37s-4.75-1.068-11.872-2.897c-24.127-6.244-75.010-21.239-54.616-32.245 17.586-9.498 43.477-0.262 58.85 6.945 5.629 2.647 9.857 5.022 11.746 6.138 0.793 0.451 1.169 0.688 1.169 0.688z',
          'M991.371 482.846l-3.799 15.434s-4.75-1.068-11.878-2.897l4.288-25.3c5.629 2.648 9.857 5.022 11.746 6.138l-0.357 6.625z',
          'M991.377 499.74l-14.746-3.645 4.585-27.021 11.786 2.909-1.625 27.757z',
          'M991.377 499.74l-6.362-1.567 2.398-27.567 5.589 1.377-1.625 27.757z',
          'M1133.654 387.821s-28.315-16.36-40.901 30.571c-12.585 46.931-13.774 68.551-13.774 68.551l-89.418-17.88-2.841 32.661s95.609 30.868 107.639 28.624c12.024-2.244 51.048-67.672 51.048-67.672s35.477-50.706-11.753-74.855z',
          'M992.837 476.815l-5.279 21.37s-4.75-1.068-11.872-2.896c-24.127-6.245-75.010-21.24-54.616-32.245 17.586-9.498 43.477-0.261 58.85 6.945 5.629 2.647 9.857 5.022 11.746 6.138 0.793 0.451 1.169 0.688 1.169 0.688z',
          'M991.358 482.846l-3.799 15.434s-4.75-1.068-11.872-2.897l4.281-25.299c5.629 2.647 9.857 5.022 11.746 6.138l-0.357 6.624z',
          'M991.371 499.74l-14.746-3.645 4.585-27.021 11.786 2.909-1.625 27.757z',
          'M991.371 499.741l-6.362-1.568 2.398-27.567 5.589 1.377-1.625 27.758z',
          'M1133.647 389.008s-28.315-16.36-40.901 30.571c-12.585 46.931-13.768 68.551-13.768 68.551l-89.425-17.88-2.841 32.661s95.609 30.868 107.639 28.624c12.024-2.244 51.048-67.672 51.048-67.672s35.477-50.706-11.753-74.855z',
          'M953.549 751.471l-36.507 21.022s-47.302 5.794-15.789 16.84c31.506 11.039 104.759-0.489 104.759-0.489s-4.070-32.913-9.745-37.505c-5.675-4.591-42.717 0.132-42.717 0.132z',
          'M1095.839 515.567s-18.168 9.497-50.434 17.701c-18.914 4.749-42.585 8.121-58.949 10.044-8.37 0.912-16.285 4.29-22.739 9.708-6.448 5.417-11.145 12.63-13.49 20.72-1.493 4.775-1.638 9.87-0.416 14.722 5.378 18.794-2.649 171.564-2.649 171.564l55.441 5.133s-7.558-28.15 3.924-42.341c11.475-14.184-1.929-122.175-1.929-122.175s20.090-8.311 80.116-8.857c55.613 14.247 78.524-46.622 69.943-63.683-8.588-17.061-58.817-12.537-58.817-12.537z',
          'M953.549 751.471l-36.507 21.022s-47.302 5.794-15.789 16.84c31.506 11.039 104.759-0.489 104.759-0.489s-4.070-32.913-9.745-37.505c-5.675-4.591-42.717 0.132-42.717 0.132z',
          'M1095.839 515.567s-18.168 9.497-50.434 17.701c-18.914 4.749-42.585 8.121-58.949 10.044-8.37 0.912-16.285 4.29-22.739 9.708-6.448 5.417-11.145 12.63-13.49 20.72-1.493 4.775-1.638 9.871-0.416 14.722 5.378 18.794-2.649 171.564-2.649 171.564l55.441 5.133s-7.558-28.15 3.924-42.341c11.475-14.184-1.929-122.175-1.929-122.175s20.090-8.31 80.116-8.857c55.613 14.247 78.524-46.622 69.943-63.683-8.588-17.061-58.817-12.537-58.817-12.537z',
          'M970.666 764.234l-36.507 21.022s-47.276 5.748-15.789 16.833c31.486 11.092 104.765-0.482 104.765-0.482s-4.076-32.913-9.751-37.505c-5.675-4.598-42.717 0.132-42.717 0.132z',
          'M1101.778 604.55c-60.026 0.546-80.116 8.857-80.116 8.857s13.404 108.038 1.929 122.176c-11.482 14.144-3.924 42.341-3.924 42.341l-55.441-5.133s0.099-1.804 0.251-5.034c1.328-26.545 7.181-149.779 2.372-166.53-1.209-4.837-1.070-9.914 0.416-14.674 2.456-8.359 7.161-15.42 13.414-20.706l0.063-0.052c6.186-5.238 13.983-8.755 22.552-9.724l0.194-0.018c16.351-1.911 40.022-5.236 58.936-10.044l0.925-0.238c31.698-8.144 49.509-17.464 49.509-17.464s50.229-4.512 58.811 12.549c1.216 2.705 1.81 5.645 1.757 8.608 0.429 23.020-23.195 67.518-71.647 55.088z',
          'M1018.16 503.445l-2.035 21.964s-4.876-0.344-12.129-1.104c-24.781-2.577-77.335-9.819-58.758-23.744 15.981-11.968 42.955-6.744 59.233-1.9 5.933 1.781 10.491 3.503 12.526 4.322 0.747 0.285 1.163 0.462 1.163 0.462zM1165.636 359.849s-7.432 5.818-16.516 12.205c-9.963 2.255-21.524 4.12-29.861 5.331 2.98-9.498 1.189-20.183-2.174-29.55-3.959-10.464-8.982-19.513-15.105-27.691l0.208 0.29 50.242-15.683c-3.937 9.984-2.16 21.37 1.189 31.272 2.953 8.429 6.996 16.439 12.017 23.827z',
          'M1017.592 509.63l-1.46 15.778s-4.876-0.344-12.129-1.104l0.476-25.656c5.933 1.781 10.491 3.503 12.519 4.322l0.595 6.66z',
          'M1020.122 526.335l-15.129-1.401 0.502-27.401 12.096 1.116 2.53 27.686z',
          'M1165.623 359.849s-7.432 5.818-16.516 12.205c-9.956 2.256-21.524 4.12-29.855 5.331 2.98-9.498 1.183-20.183-2.174-29.55 12.275-3.562 29.835-8.168 36.54-11.872 2.946 8.45 6.983 16.479 12.004 23.887z',
          'M1155.581 336.556s8.403 19.079 13.695 27.698c5.298 8.619-61.519 16.622-61.519 16.622s-6.937-24.018-3.62-26.772c3.31-2.755 45.849-11.968 51.444-17.547z',
          'M1173.524 549.474c-2.814 4.958-6.316 9.491-10.405 13.463-29.511 28.042-77.89-1.187-99.724-17.168 31.698-8.144 49.509-17.464 49.509-17.464s50.229-4.512 58.811 12.549c1.229 2.705 1.85 5.649 1.81 8.619z',
          'M1163.31 560.931c-33.548 31.865-91.413-10.329-107.011-22.759-2.53-2.018-3.944-3.265-3.944-3.265 6.164-5.77 11.575-17.999 15.862-32.958 3.997-14.312 6.877-28.91 8.628-43.666 3.228-26.319 12.319-50.011 25.926-70.438l-0.372 0.593c1.817-2.731 3.561-5.283 5.378-7.515 12.665-16.11 33.951-26.345 33.951-26.345 44.93-13.131 50.969 53.508 49.773 55.431-1.202 1.924 10.815 113.867-28.19 150.921z',
          'M1167.657 469.834s-28.883 70.522-40.438 74.547c-6.613 2.291-41.931-2.054-70.92-6.198-2.53-2.018-3.944-3.265-3.944-3.265 6.164-5.77 11.575-17.999 15.862-32.958l37.34 1.781s-2.081-21.536 3.402-69.833c5.49-48.296 35.893-36.33 35.893-36.33 50.302 16.847 22.805 72.255 22.805 72.255zM1020.122 526.335l-6.534-0.605-1.731-27.603 5.734 0.522 2.53 27.686z',
          'M1144.125 394.469s-30.409-11.956-35.893 36.33c-5.483 48.285-3.409 69.833-3.409 69.833l-91.096-4.358 2.055 32.72s99.15 16.277 110.698 12.264c11.555-4.013 40.438-74.546 40.438-74.546s27.463-55.408-22.792-72.243z',
          'M1146.167 322.974c-1.328-7.218 6.21-7.123 8.919-13.915l-50.249 15.684c3.488 4.682 6.6 9.632 9.308 14.804 2.61 0.774 5.285 1.291 7.994 1.543 11.977 1.14 15.717-10.649 24.028-18.117z',
          'M1164.592 299.25c2.114-22.826-14.68-43.040-37.505-45.149s-43.041 14.684-45.148 37.51c-2.114 22.825 14.68 43.039 37.505 45.148s43.041-14.684 45.148-37.509z',
          'M1082.309 257.938c0.509 4.321 5.067 6.957 9.308 7.931 4.235 0.973 8.833 1.021 12.546 3.288 5.939 3.657 7.538 11.777 6.791 18.758-0.416 3.942-1.011 8.774 2.22 11.065 1.017 0.621 2.147 1.025 3.323 1.187 3.369 0.682 6.831 0.802 10.233 0.356 1.995-0.261 4.050-0.712 5.939-0.154 3.112 0.902 4.948 4.179 5.556 7.348s0.271 6.471 0.76 9.665c0.68 3.998 2.55 7.698 5.378 10.61 2.821 2.912 6.461 4.9 10.438 5.702 1.863 0.454 3.825 0.278 5.576-0.498 2.259-1.187 3.409-3.716 4.387-6.079l7.122-17.049c3.204-7.681 6.435-15.434 8.146-23.578 0.875-4.043 1.376-8.687 1.376-13.448 0-8.365-1.547-16.368-4.37-23.74l0.153 0.455c-1.685-4.464-4.010-8.94-7.967-11.623-7.915-5.378-18.994-1.662-27.992-4.749-2.98-1.033-5.662-2.791-8.635-3.847-6.421-2.291-13.675-1.080-19.859 1.805-6.19 2.884-11.185 7.432-16.622 11.575-4.717 3.669-14.699 7.551-13.807 15.018z',
          'M1083.405 257.023c0.509 4.322 5.067 6.957 9.308 7.931 4.235 0.973 8.833 1.021 12.546 3.289 5.939 3.657 7.538 11.777 6.791 18.758-0.416 3.941-1.011 8.773 2.22 11.064 1.017 0.622 2.147 1.025 3.323 1.187 3.369 0.682 6.824 0.803 10.233 0.357 1.995-0.262 4.050-0.713 5.939-0.155 3.112 0.902 4.948 4.179 5.556 7.349s0.271 6.47 0.76 9.664c0.68 3.999 2.55 7.698 5.378 10.61 2.821 2.912 6.461 4.901 10.438 5.703 1.863 0.453 3.825 0.278 5.576-0.499 2.259-1.187 3.409-3.716 4.38-6.079l7.128-17.049c3.204-7.681 6.435-15.434 8.139-23.578 2.543-12.267 1.559-25.001-2.834-36.733-1.685-4.464-4.017-8.94-7.967-11.623-7.921-5.378-18.994-1.662-27.992-4.749-2.986-1.033-5.668-2.79-8.635-3.847-6.421-2.291-13.675-1.080-19.859 1.805-6.19 2.885-11.185 7.432-16.622 11.575-4.704 3.669-14.686 7.551-13.807 15.018z',
          'M1117.779 420.992s-15.849 61.569-31.632 67.268c-15.776 5.699-8.806 7.313-8.806 7.313z',
          'M1118.532 646.542h-17.23v113.227h17.23v-113.227z',
          'M1118.532 646.542h-17.23v8.393h17.23v-8.393z',
          'M1066.836 645.948v2.374c0 0.731 0.145 1.455 0.429 2.131 0.277 0.676 0.687 1.29 1.202 1.806 0.504 0.506 1.105 0.914 1.774 1.194l0.036 0.013c0.674 0.28 1.401 0.424 2.127 0.424h75.010c0.733 0 1.453-0.144 2.134-0.424 0.702-0.295 1.301-0.703 1.803-1.207l0-0c0.515-0.517 0.925-1.13 1.209-1.806 0.277-0.675 0.423-1.399 0.423-2.131v-2.374c0-0.731-0.145-1.455-0.423-2.131-0.284-0.675-0.694-1.29-1.209-1.806-0.503-0.504-1.102-0.912-1.767-1.193l-0.036-0.014c-0.68-0.28-1.401-0.424-2.134-0.424h-75.010c-0.727 0-1.453 0.144-2.127 0.424-0.705 0.293-1.306 0.701-1.81 1.207l-0 0c-0.503 0.504-0.909 1.104-1.189 1.77l-0.014 0.037c-0.272 0.629-0.429 1.361-0.429 2.13 0 0 0 0.001 0 0.001l-0-0z',
          'M1068.118 642.41h83.591c-0.522-0.636-1.176-1.148-1.922-1.499-0.74-0.351-1.553-0.532-2.378-0.531h-75.010c-0.86 0.001-1.673 0.198-2.398 0.548l0.033-0.014c-0.747 0.351-1.401 0.862-1.916 1.496z',
          'M1174.158 753.605h-128.469c-3.607 0-6.527 2.927-6.527 6.534v0.469c0 3.607 2.92 6.534 6.527 6.534h128.469c3.607 0 6.534-2.927 6.534-6.534v-0.469c0-3.607-2.927-6.534-6.534-6.534z',
          'M1172.691 784.377c4.757 0 8.615-3.858 8.615-8.615 0-4.763-3.858-8.621-8.615-8.621-4.763 0-8.621 3.858-8.621 8.621 0 4.757 3.858 8.615 8.621 8.615zM1047.149 784.377c4.757 0 8.621-3.858 8.621-8.615 0-4.763-3.865-8.621-8.621-8.621-4.763 0-8.621 3.858-8.621 8.621 0 4.757 3.858 8.615 8.621 8.615zM1109.924 784.377c4.757 0 8.621-3.858 8.621-8.615 0-4.763-3.865-8.621-8.621-8.621-4.763 0-8.621 3.858-8.621 8.621 0 4.757 3.858 8.615 8.621 8.615z',
          'M1216.908 507.469h-115.197c-5.576 0-10.095 4.518-10.095 10.092v0.736c0 5.573 4.519 10.091 10.095 10.091h115.197c5.576 0 10.088-4.518 10.088-10.091v-0.736c0-5.574-4.512-10.092-10.088-10.092z',
          'M1118.532 753.605s-6.772 6.686-17.23 0h17.23zM1226.996 518.143v1.65c0 2.283-0.905 4.473-2.517 6.087-1.619 1.614-3.805 2.521-6.085 2.521h-118.17c-2.279 0-4.473-0.907-6.085-2.521s-2.524-3.803-2.524-6.087v-1.65h135.379z',
          'M1001.749 537.376h-23.281v296.642h23.281v-296.642z',
          'M1001.749 537.376h-23.281v19.233h23.281v-19.233z',
          'M295.82 654.639h-17.227v113.223h17.227v-113.223z',
          'M295.82 654.639h-17.227v8.392h17.227v-8.392z',
          'M330.274 654.057v2.375c0 0 0 0 0 0 0 1.537-0.623 2.929-1.631 3.937l-0 0c-1.008 1.007-2.399 1.631-3.937 1.631l-75.009 0c-1.538-0-2.93-0.624-3.937-1.631l0 0c-1.008-1.007-1.631-2.399-1.631-3.937 0-0 0-0 0-0l-0 0v-2.375c0.014-1.529 0.641-2.908 1.647-3.906l0-0c1.006-0.998 2.392-1.614 3.921-1.614l75.009-0c0.731 0 1.455 0.144 2.131 0.424 0.703 0.295 1.303 0.703 1.806 1.207l0 0c0.504 0.504 0.912 1.103 1.193 1.77l0.014 0.036c0.268 0.629 0.424 1.361 0.424 2.13 0 0-0 0-0 0.001l0-0v-0.048z',
          'M329.005 650.507h-83.605c0.521-0.616 1.165-1.111 1.894-1.452l0.034-0.014c0.679-0.318 1.474-0.504 2.312-0.504 0.020 0 0.040 0 0.061 0l-0.003-0h75.009c0.017-0 0.038-0 0.059-0 1.697 0 3.215 0.762 4.232 1.963l0.007 0.008z',
          'M351.451 761.704h-128.47c-3.606 0-6.53 2.92-6.53 6.527v0.476c0 3.607 2.923 6.527 6.53 6.527h128.47c3.606 0 6.53-2.92 6.53-6.527v-0.476c0-3.607-2.923-6.527-6.53-6.527z',
          'M224.445 792.477c4.761 0 8.619-3.858 8.619-8.621 0-4.757-3.859-8.621-8.619-8.621s-8.619 3.865-8.619 8.621c0 4.763 3.859 8.621 8.619 8.621zM349.981 792.477c4.76 0 8.619-3.858 8.619-8.621 0-4.757-3.859-8.621-8.619-8.621s-8.619 3.865-8.619 8.621c0 4.763 3.859 8.621 8.619 8.621zM287.206 792.477c4.761 0 8.619-3.858 8.619-8.621 0-4.757-3.859-8.621-8.619-8.621s-8.619 3.865-8.619 8.621c0 4.763 3.859 8.621 8.619 8.621z',
          'M278.593 761.704s6.768 6.686 17.227 0h-17.227z',
          'M718.075 420.849s-19.33-35.13-12.268-65.665c3.046-12.789 1.856-26.22-3.383-38.276-2.786-6.27-5.811-11.626-9.279-16.653l0.222 0.34',
          'M697.655 281.314c1.011 4.607-4.393 19.792-4.393 19.792s-11.264-11.516-12.288-16.123c-0.344-1.126-0.443-2.31-0.311-3.478 0.139-1.169 0.515-2.296 1.11-3.312s1.394-1.897 2.345-2.59 2.035-1.181 3.184-1.434c1.15-0.254 2.339-0.267 3.495-0.039 1.15 0.227 2.246 0.692 3.211 1.362 0.971 0.671 1.784 1.535 2.405 2.537 0.614 1.002 1.017 2.121 1.183 3.285h0.059zM717.044 303.788c-1.652 4.416-14.435 14.247-14.435 14.247s-3.204-15.79-1.546-20.183c0.357-1.094 0.932-2.105 1.685-2.971 0.76-0.867 1.685-1.572 2.715-2.072 1.037-0.501 2.167-0.787 3.316-0.842s2.292 0.124 3.376 0.524c1.077 0.4 2.061 1.015 2.9 1.806 0.832 0.791 1.5 1.743 1.956 2.798s0.7 2.192 0.707 3.342c0.007 1.15-0.218 2.29-0.661 3.351h-0.013zM726.016 347.502c-3.653 2.98-19.648 4.987-19.648 4.987s5.212-15.244 8.866-18.224c0.872-0.719 1.87-1.26 2.946-1.59 1.083-0.33 2.213-0.444 3.336-0.334s2.207 0.441 3.204 0.974c0.991 0.532 1.87 1.257 2.583 2.131s1.242 1.88 1.566 2.961c0.317 1.081 0.423 2.214 0.304 3.335s-0.462 2.207-1.004 3.196c-0.561 1.010-1.281 1.861-2.137 2.551l-0.016 0.013zM725.369 382.099c-3.098 3.562-18.524 8.239-18.524 8.239s2.557-15.909 5.655-19.459c0.72-0.883 1.619-1.613 2.629-2.144s2.121-0.854 3.257-0.949c1.143-0.095 2.286 0.040 3.376 0.396 1.083 0.357 2.088 0.928 2.946 1.679 0.865 0.752 1.566 1.668 2.061 2.696 0.502 1.027 0.793 2.145 0.852 3.287s-0.112 2.283-0.502 3.357c-0.39 1.075-0.991 2.060-1.764 2.898h0.013zM685.3 322.749c4.017 2.481 20.123 2.374 20.123 2.374s-7.122-14.449-11.132-16.93c-0.898-0.598-1.955-1.039-3.092-1.254l-0.053-0.008c-1.123-0.207-2.273-0.187-3.389 0.059-1.11 0.246-2.167 0.713-3.092 1.372-0.932 0.659-1.724 1.499-2.319 2.468-0.601 0.97-1.004 2.049-1.183 3.176-0.172 1.126-0.126 2.277 0.152 3.384s0.773 2.146 1.453 3.059c0.687 0.912 1.546 1.678 2.53 2.252v0.048zM685.063 363.233c4.565 1.187 19.918-3.704 19.918-3.704s-11.125-11.658-15.697-12.822c-2.154-0.458-4.4-0.066-6.276 1.096-1.87 1.162-3.224 3.003-3.766 5.138-0.548 2.135-0.244 4.399 0.839 6.316s2.867 3.343 4.981 3.976zM690.202 402.602c4.294 1.923 20.262-0.285 20.262-0.285s-8.998-13.368-13.292-15.292c-1.025-0.47-2.223-0.743-3.485-0.743-1.096 0-2.144 0.206-3.106 0.582l0.058-0.020c-2.114 0.809-3.825 2.424-4.743 4.491-0.925 2.067-0.991 4.416-0.185 6.532s2.425 3.822 4.492 4.747v-0.012z',
          'M697.655 281.314c1.011 4.607-4.393 19.792-4.393 19.792s-11.264-11.516-12.288-16.123c-0.344-1.126-0.443-2.31-0.311-3.478 0.139-1.169 0.515-2.296 1.11-3.312s1.394-1.897 2.345-2.59 2.035-1.181 3.184-1.434c1.15-0.254 2.339-0.267 3.495-0.039 1.15 0.227 2.246 0.692 3.211 1.362 0.971 0.671 1.784 1.535 2.405 2.537 0.614 1.002 1.017 2.121 1.183 3.285h0.059zM717.044 303.788c-1.652 4.416-14.435 14.247-14.435 14.247s-3.204-15.79-1.546-20.183c0.357-1.094 0.932-2.105 1.685-2.971 0.76-0.867 1.685-1.572 2.715-2.072 1.037-0.501 2.167-0.787 3.316-0.842s2.292 0.124 3.376 0.524c1.077 0.4 2.061 1.015 2.9 1.806 0.832 0.791 1.5 1.743 1.956 2.798s0.7 2.192 0.707 3.342c0.007 1.15-0.218 2.29-0.661 3.351h-0.013zM726.016 347.502c-3.653 2.98-19.648 4.987-19.648 4.987s5.212-15.244 8.866-18.224c0.872-0.719 1.87-1.26 2.946-1.59 1.083-0.33 2.213-0.444 3.336-0.334s2.207 0.441 3.204 0.974c0.991 0.532 1.87 1.257 2.583 2.131s1.242 1.88 1.566 2.961c0.317 1.081 0.423 2.214 0.304 3.335s-0.462 2.207-1.004 3.196c-0.561 1.010-1.281 1.861-2.137 2.551l-0.016 0.013zM725.369 382.099c-3.098 3.562-18.524 8.239-18.524 8.239s2.557-15.909 5.655-19.459c0.72-0.883 1.619-1.613 2.629-2.144s2.121-0.854 3.257-0.949c1.143-0.095 2.286 0.040 3.376 0.396 1.083 0.357 2.088 0.928 2.946 1.679 0.865 0.752 1.566 1.668 2.061 2.696 0.502 1.027 0.793 2.145 0.852 3.287s-0.112 2.283-0.502 3.357c-0.39 1.075-0.991 2.060-1.764 2.898h0.013zM685.3 322.749c4.017 2.481 20.123 2.374 20.123 2.374s-7.122-14.449-11.132-16.93c-0.898-0.598-1.955-1.039-3.092-1.254l-0.053-0.008c-1.123-0.207-2.273-0.187-3.389 0.059-1.11 0.246-2.167 0.713-3.092 1.372-0.932 0.659-1.724 1.499-2.319 2.468-0.601 0.97-1.004 2.049-1.183 3.176-0.172 1.126-0.126 2.277 0.152 3.384s0.773 2.146 1.453 3.059c0.687 0.912 1.546 1.678 2.53 2.252v0.048zM685.063 363.233c4.565 1.187 19.918-3.704 19.918-3.704s-11.125-11.658-15.697-12.822c-2.154-0.458-4.4-0.066-6.276 1.096-1.87 1.162-3.224 3.003-3.766 5.138-0.548 2.135-0.244 4.399 0.839 6.316s2.867 3.343 4.981 3.976zM690.202 402.602c4.294 1.923 20.262-0.285 20.262-0.285s-8.998-13.368-13.292-15.292c-1.025-0.47-2.223-0.743-3.485-0.743-1.096 0-2.144 0.206-3.106 0.582l0.058-0.020c-2.114 0.809-3.825 2.424-4.743 4.491-0.925 2.067-0.991 4.416-0.185 6.532s2.425 3.822 4.492 4.747v-0.012zM710.22 518.285c-2.781 0.001-5.536-0.569-8.086-1.673-2.642-1.161-4.887-2.763-6.742-4.736l-0.010-0.011c-1.903-2.027-3.376-4.422-4.314-7.039-0.945-2.616-1.341-5.397-1.163-8.173l5.688-90.111h29.253l5.688 90.111c0.172 2.775-0.225 5.557-1.163 8.173-0.945 2.617-2.411 5.012-4.314 7.039s-4.202 3.643-6.758 4.747c-2.379 1.057-5.154 1.673-8.074 1.673-0.002 0-0.004-0-0.006-0l0 0z',
          'M117.918 75.294h-16.621v68.859h16.621v-68.859zM139.286 75.294h-16.621v68.859h16.621v-68.859zM160.66 75.294h-16.621v68.859h16.621v-68.859zM182.028 75.294h-16.621v68.859h16.621v-68.859zM224.769 75.294h-16.621v68.859h16.621v-68.859zM246.137 75.294h-16.621v68.859h16.621v-68.859z',
          'M117.918 88.354h-16.621v3.562h16.621v-3.562zM117.918 131.094h-16.621v3.562h16.621v-3.562zM139.286 88.354h-16.621v3.562h16.621v-3.562zM139.286 131.094h-16.621v3.562h16.621v-3.562zM160.66 88.354h-16.621v3.562h16.621v-3.562zM160.66 131.094h-16.621v3.562h16.621v-3.562zM182.028 88.354h-16.621v3.562h16.621v-3.562zM182.028 131.094h-16.621v3.562h16.621v-3.562zM203.395 88.354h-16.621v3.562h16.621v-3.562zM203.395 131.094h-16.621v3.562h16.621v-3.562zM224.769 88.354h-16.621v3.562h16.621v-3.562zM224.769 131.094h-16.621v3.562h16.621v-3.562zM246.137 88.354h-16.621v3.562h16.621v-3.562zM246.137 131.094h-16.621v3.562h16.621v-3.562z',
          'M203.395 75.294h-16.621v68.859h16.621v-68.859zM261.774 74.979l-15.084 6.982 28.927 62.488 15.083-6.982-28.926-62.488z',
          'M267.264 86.841l-15.083 6.982 1.496 3.233 15.083-6.982-1.496-3.233zM285.206 125.623l-15.083 6.982 1.496 3.233 15.083-6.982-1.496-3.233z',
          'M464.048 785.316l-30.168-19.245c-0.154-27.106-0.581-152.938 5.058-169.773 0.733-2.367 1.155-5.088 1.155-7.907 0-2.511-0.335-4.945-0.962-7.258l0.045 0.194c-3.918-17.108-18.212-29.883-35.533-32.697-16.336-2.659-39.844-7.017-58.768-12.644 16.87-1.745 29.514-3.253 29.514-3.253l0.332-3.122 10.863-0.523v-0.463l1.033-0.059c25.371-1.508 79.248-6.53 60.941-21.56-6.281-5.153-14.473-7.587-23.115-8.406 26.428-6.031 67.731-17.713 49.317-28.695-17.5-10.424-44.296-2.232-60.287 4.428l-0.986 0.416-0.178-1.436-8.417 1.686-0.095-2.090-89.624 13.843c-0.807-11.634-2.106-22.146-3.924-32.48l0.268 1.837c2.006-13.368 11.338-32.862 8.049-43.322-3.822-12.145-19.518-16.123-26.119-27.092-1.734-2.861-3.455-5.545-5.141-7.895-3.788-5.115-7.943-9.594-12.54-13.577l-0.104-0.088c0.311-7.466 1.992-14.461 4.799-20.85l-0.145 0.37c1.789-4.338 3.884-8.543 6.269-12.585 10.446-2.591 19.511-9.071 25.344-18.116s7.996-19.975 6.046-30.56c5.675 2.434 12.573 2.683 16.123-2.066l-1.686-0.653c0.166-0.178 0.332-0.356 0.475-0.558-3.455-1.318-7.124-2.814-9.83-5.212-0.661-0.74-1.234-1.579-1.691-2.487l-0.030-0.066c-1.638-3.324-1.448-7.313-3.016-10.685-0.769-1.58-1.804-2.914-3.059-4l-0.016-0.013c-2.675-2.733-6.079-4.743-9.897-5.714l-0.146-0.032c-4.286-1.247-8.798-1.876-12.905-3.562-5.496-6.356-12.719-11.081-20.94-13.453l-0.308-0.076c-3.54-1.034-7.607-1.63-11.813-1.63-4.778 0-9.377 0.768-13.68 2.187l0.308-0.088-1.484 0.511c0.256-1.182 0.403-2.54 0.403-3.932 0-3.893-1.149-7.518-3.127-10.554l0.046 0.075c-2.73-4.196-6.941-7.233-11.877-8.381l-0.131-0.026c-1.285-0.304-2.76-0.478-4.275-0.478-9.055 0-16.659 6.216-18.776 14.614l-0.029 0.134c0.376-4.327 2.2-8.401 5.176-11.563-0.309 0.261-0.63 0.51-0.926 0.784-1.815 1.709-3.294 3.752-4.342 6.033l-0.050 0.121c-1.046 2.32-1.624 4.823-1.702 7.366-0.006 0.177-0.009 0.385-0.009 0.594 0 5.141 2.002 9.815 5.27 13.284l-0.009-0.010 0.344 0.333c1.371 1.677 3.012 3.114 4.856 4.25-3.488-1.255-6.411-3.366-8.613-6.085l-0.028-0.036c-2.173-2.683-3.654-6.011-4.122-9.655l-0.010-0.097v1.187c0.319 5.348 2.762 10.069 6.489 13.376l0.020 0.017c1.915 1.693 4.146 2.99 6.564 3.817 1.869 0.661 4.024 1.042 6.269 1.042 0.442 0 0.881-0.015 1.316-0.044l-0.059 0.003 0.534-0.059-0.285 0.392c-4.722 6.864-7.542 15.355-7.542 24.505 0 1.111 0.042 2.212 0.123 3.301l-0.009-0.145c0.763 10.213 4.938 19.327 11.374 26.33l-0.028-0.031c0.788 1.805 1.836 3.485 3.11 4.986 0.448 0.513 0.928 0.997 1.437 1.449 3.15 3.319 7.511 5.462 12.372 5.721l0.046 0.002c0.791 0.941 1.634 1.848 2.529 2.719-0.783 3.331-1.807 6.601-3.063 9.783-2.808 6.965-5.963 12.93-9.644 18.519l0.241-0.39c-25.644 7.29-27.9 50.837-26.974 52.488 1.104 1.971-3.823 70.355 15.173 152.962-0.784 23.614 12.988 62.662 61.878 52.369 61.143 3.265 81.195 12.632 81.195 12.632s-5.805 106.341 2.481 121.82c5.188 9.705 1.508 23.948-2.374 34.003-1.439 2.491-2.586 5.133-3.419 7.881-1.187 2.51-2.054 4.030-2.054 4.030h0.831c-3.134 10.887-5.354 24.028-5.354 24.028s74.118 15.043 106.72 5.199c12.656-3.825 13.178-7.36 9.070-10.28 3.026-0.449 6.017-1.103 8.952-1.962 32.625-9.844-15.315-17.903-15.315-17.903z',
          'M302.771 280.495c0 8.453-2.507 16.716-7.203 23.745-4.705 6.973-11.231 12.392-18.901 15.637l-0.28 0.105c-4.833 2.057-10.455 3.253-16.356 3.253-11.802 0-22.488-4.784-30.222-12.518l0 0c-5.801-5.801-9.942-13.262-11.65-21.608l-0.047-0.276c-0.522-2.507-0.821-5.387-0.821-8.338 0-14.753 7.475-27.761 18.844-35.441l0.151-0.096c6.67-4.512 14.893-7.203 23.745-7.203 0 0 0 0 0 0l-0-0c5.613 0 11.17 1.105 16.356 3.253 5.394 2.268 9.998 5.398 13.866 9.265l-0-0c7.734 7.735 12.518 18.42 12.519 30.223l0 0z',
          'M399.039 481.291l4.333 21.632s4.82-0.867 11.956-2.374c24.374-5.165 75.876-17.915 55.93-29.812-17.156-10.222-43.429-2.185-59.101 4.345-5.746 2.374-10.068 4.583-12.003 5.615-0.724 0.369-1.116 0.594-1.116 0.594z',
          'M400.268 487.394l3.11 15.529s4.82-0.867 11.956-2.374l-3.17-25.467c-5.746 2.374-10.068 4.583-12.003 5.616l0.107 6.696z',
          'M399.513 504.264l14.888-2.98-3.371-27.199-11.92 2.386 0.404 27.793z',
          'M399.513 504.264l6.423-1.294-1.175-27.627-5.651 1.128 0.404 27.793z',
          'M262.295 386.158s28.98-15.102 39.511 32.352c10.531 47.453 10.685 69.085 10.685 69.085l90.134-13.926 1.401 32.756s-96.878 26.629-108.786 23.851c-11.908-2.778-48.059-69.869-48.059-69.869s-33.124-52.178 15.114-74.249z',
          'M399.039 481.291l4.333 21.632s4.82-0.867 11.956-2.374c24.374-5.165 75.876-17.915 55.93-29.812-17.156-10.222-43.429-2.185-59.101 4.345-5.746 2.374-10.068 4.583-12.003 5.615-0.724 0.369-1.116 0.594-1.116 0.594z',
          'M400.268 487.394l3.11 15.529s4.82-0.867 11.956-2.374l-3.17-25.467c-5.746 2.374-10.068 4.583-12.003 5.616l0.107 6.696z',
          'M399.513 504.264l14.888-2.98-3.371-27.199-11.92 2.386 0.404 27.793z',
          'M399.513 504.264l6.423-1.294-1.175-27.627-5.651 1.128 0.404 27.793z',
          'M264.669 388.533s28.981-15.101 39.511 32.352c10.531 47.453 10.685 69.085 10.685 69.085l90.134-13.926 1.401 32.755s-96.878 26.63-108.786 23.851c-11.907-2.778-48.059-69.868-48.059-69.868s-33.124-52.179 15.113-74.25z',
          'M426.248 757.416l35.545 22.561s47.002 7.868 15.030 17.52-104.63-5.107-104.63-5.107 5.52-32.695 11.397-37.029c5.876-4.334 42.657 2.055 42.657 2.055z',
          'M294.461 515.448s17.725 10.294 49.603 19.91c18.686 5.639 42.194 9.996 58.435 12.644 8.691 1.375 16.311 5.208 22.327 10.755l-0.029-0.027c6.045 5.573 10.456 12.835 12.486 21.035l0.061 0.292c1.275 4.819 1.197 9.896-0.226 14.674-6.197 18.544-4.939 171.518-4.939 171.518l-55.61 2.669s8.798-27.787-2.042-42.466c-10.839-14.673 7.313-121.962 7.313-121.962s-19.696-9.19-79.651-12.383c-56.192 11.872-76.386-50.042-67.055-66.711s59.326-9.949 59.326-9.949z',
          'M426.242 757.416l35.545 22.561s47.003 7.868 15.030 17.52c-31.972 9.652-104.63-5.107-104.63-5.107s5.521-32.695 11.397-37.029c5.877-4.334 42.657 2.055 42.657 2.055z',
          'M294.461 515.448s17.725 10.294 49.603 19.91c18.686 5.639 42.194 9.996 58.435 12.644 8.691 1.375 16.311 5.208 22.327 10.755l-0.029-0.027c6.045 5.573 10.456 12.835 12.486 21.035l0.061 0.292c1.275 4.819 1.197 9.896-0.226 14.674-6.197 18.544-4.939 171.518-4.939 171.518l-55.61 2.669s8.798-27.787-2.042-42.466c-10.839-14.673 7.313-121.962 7.313-121.962s-19.696-9.19-79.651-12.383c-56.192 11.872-76.386-50.042-67.055-66.711s59.326-9.949 59.326-9.949z',
          'M408.532 769.42l35.546 22.554s47.002 7.875 15.030 17.527-104.631-5.107-104.631-5.107 5.521-32.695 11.397-37.029c5.877-4.334 42.657 2.055 42.657 2.055z',
          'M284.529 604.099c59.955 3.194 79.651 12.382 79.651 12.382s-5.687 104.263 2.374 119.438c8.608 16.093-7.693 44.997-7.693 44.997l55.61-2.676v-5.034c-0.166-26.571-0.569-149.945 4.951-166.484 0.716-2.317 1.128-4.98 1.128-7.739 0-2.466-0.329-4.855-0.946-7.125l0.044 0.19c-2.094-8.491-6.505-15.751-12.52-21.298l-0.029-0.027c-5.986-5.52-13.605-9.353-22.054-10.698l-0.242-0.032c-16.253-2.635-39.749-6.992-58.436-12.632l-0.914-0.285c-31.307-9.497-48.676-19.624-48.676-19.624s-37.030-2.565-46.302 14.104c-1.187 2.16-6.305 6.411-6.518 9.842-1.389 22.961 11.682 62.994 60.573 52.702z',
          'M372.593 506.781l1.057 22.035s4.891-0.131 12.181-0.57c24.872-1.484 77.704-6.399 59.753-21.132-15.434-12.668-42.622-8.631-59.089-4.512-6.043 1.519-10.685 3.039-12.704 3.763-0.784 0.262-1.199 0.416-1.199 0.416zM231.536 356.822s7.123 6.137 15.956 12.929c9.854 2.683 21.371 5.069 29.598 6.648-2.553-9.676-0.285-20.183 3.478-29.431 4.392-10.214 9.791-19.021 16.256-26.922l-0.157 0.198-49.507-17.892c3.503 10.151 1.187 21.489-2.576 31.188-3.606 8.89-7.989 16.562-13.239 23.547l0.191-0.265z',
          'M372.891 512.99l0.76 15.826s4.891-0.131 12.181-0.57l0.665-25.655c-6.043 1.519-10.685 3.039-12.704 3.763l-0.902 6.637z',
          'M369.632 529.564l15.161-0.724 0.712-27.402-12.133 0.582-3.74 27.544z',
          'M225.043 557.808c32.055 33.326 91.832-6.281 107.907-18.011 2.612-1.911 4.072-3.087 4.072-3.087-5.936-6.044-15.434-11.635-19.079-26.772-3.177-13.383-5.676-29.407-6.978-45.769l-0.074-1.151c-0.986-12.525 11.955-36.376 8.215-48.273s-19.138-15.802-25.609-26.57c-1.697-2.802-3.383-5.438-5.045-7.741-11.944-16.621-32.755-27.817-32.755-27.817-44.343-15.137-47.822 48.189-46.718 50.161s-3.966 71.78 16.063 155.028z',
          'M224.713 466.605s25.751 71.733 37.112 76.256c6.506 2.588 41.993-0.201 71.127-3.063 2.612-1.911 4.072-3.087 4.072-3.087-5.936-6.044-10.768-18.497-14.401-33.623l-37.386 0.131s3.027-21.37-0.321-69.916c-3.347-48.546-34.251-37.872-34.251-37.872-50.968 14.615-25.953 71.174-25.953 71.174zM369.632 529.564l6.542-0.309 2.956-27.508-5.758 0.273-3.74 27.544z',
          'M251.541 392.344s30.868-10.602 34.252 37.873c3.384 48.474 0.356 69.915 0.356 69.915l91.203-0.332-3.503 32.602s-99.727 11.872-111.124 7.373c-11.397-4.5-37.125-76.244-37.125-76.244s-25.038-56.572 25.941-71.186z',
          'M252.672 320.861c1.65-7.123-5.936-7.349-8.31-14.247l49.531 17.808c-3.465 4.219-6.752 8.916-9.667 13.859l-0.283 0.518c-2.365 0.617-5.12 1.041-7.95 1.183l-0.099 0.004c-12.038 0.593-15.256-11.314-23.222-19.126z',
          'M278.718 335.828c22.897-1.1 40.566-20.553 39.467-43.449s-20.553-40.566-43.449-39.467c-22.897 1.1-40.566 20.553-39.466 43.449s20.553 40.566 43.449 39.466z',
          'M255.284 423.129s13.131 62.199 28.636 68.551c15.505 6.352 8.477 7.705 8.477 7.705zM309.396 458.259s-10.97 3.431-23.744-12.965l23.744 12.965z',
          'M226.789 255.563c10.491 0 18.996-8.504 18.996-18.996s-8.505-18.996-18.996-18.996c-10.491 0-18.996 8.504-18.996 18.996s8.504 18.996 18.996 18.996z',
          'M213.444 246.6c-3.184-3.388-5.14-7.962-5.14-12.993 0-0 0-0.001 0-0.001l-0 0c0-4.827 1.837-9.473 5.14-12.994-0.309 0.249-0.618 0.499-0.902 0.772-3.55 3.343-5.81 8.020-5.977 13.226l-0.001 0.030c-0.006 0.175-0.009 0.381-0.009 0.588 0 5.039 1.962 9.621 5.164 13.021l-0.009-0.010c3.474 3.689 8.39 5.987 13.843 5.987 5.040 0 9.621-1.962 13.022-5.165l-0.010 0.009c0.297-0.273 0.558-0.57 0.819-0.855-3.261 2.714-7.493 4.361-12.11 4.361-5.447 0-10.359-2.293-13.822-5.966l-0.009-0.009z',
          'M224.296 253.771c-0.341 0.022-0.74 0.034-1.141 0.034-4.632 0-8.878-1.658-12.175-4.413l0.030 0.024c-3.613-3.019-6.075-7.308-6.698-12.173l-0.010-0.094v1.188c0.315 5.028 2.614 9.726 6.393 13.059 1.87 1.65 4.048 2.916 6.408 3.725s4.856 1.145 7.346 0.989c2.637-0.169 5.077-0.852 7.275-1.948l-0.11 0.050c2.241-1.097 4.243-2.624 5.894-4.495 1.594-1.801 2.862-3.933 3.684-6.275l0.041-0.133c0.809-2.36 1.145-4.856 0.989-7.346 0-0.404-0.083-0.784-0.131-1.187 0 0.012 0 0.025 0 0.039 0 5.028-1.953 9.599-5.143 12.996l0.009-0.010c-3.207 3.417-7.647 5.644-12.607 5.968l-0.057 0.003z',
          'M292.030 253.082c4.428 2.185 9.497 2.79 14.246 4.167s9.593 3.894 11.683 8.382c1.531 3.301 1.353 7.206 2.956 10.471 2.304 4.749 7.623 6.933 12.514 8.798-4.203 5.639-13.226 4.108-19.114 0.273s-10.958-9.498-17.808-10.982c-0.973-0.201-2.090-0.316-3.235-0.316-6.066 0-11.377 3.231-14.306 8.066l-0.042 0.074c-1.876 3.289-2.541 7.123-3.467 10.78-2.374 9.64-7.123 19.233-15.434 24.706s-20.693 5.438-27.211-2.054c-3.799-4.369-5.069-10.317-6.197-15.992-0.583-2.302-0.917-4.946-0.917-7.667 0-0.147 0.001-0.294 0.003-0.44l-0 0.022c0.38-6.815 4.915-12.62 9.498-17.678 5.401-5.936 11.148-11.635 16.894-17.298 4.963-4.891 10.685-13.179 18.164-13.76 8.619-0.689 14.71 6.993 21.774 10.447z',
          'M290.843 251.895c4.428 2.184 9.497 2.79 14.247 4.167s9.593 3.894 11.682 8.382c1.531 3.301 1.353 7.206 2.956 10.471 2.303 4.749 7.622 6.933 12.513 8.797-4.203 5.64-13.226 4.108-19.114 0.274s-10.958-9.498-17.808-10.982c-0.973-0.201-2.090-0.316-3.235-0.316-6.066 0-11.377 3.231-14.306 8.066l-0.042 0.074c-1.876 3.288-2.541 7.123-3.466 10.78-2.375 9.64-7.124 19.233-15.434 24.706s-20.693 5.438-27.211-2.054c-3.799-4.369-5.070-10.317-6.198-15.992-0.583-2.303-0.917-4.946-0.917-7.667 0-0.147 0.001-0.293 0.003-0.44l-0 0.022c0.38-6.815 4.915-12.62 9.498-17.678 5.401-5.936 11.148-11.635 16.894-17.298 4.963-4.891 10.685-13.179 18.164-13.76 8.619-0.689 14.71 6.992 21.774 10.447z',
          'M295.417 515.567h-115.197c-5.574 0-10.091 4.517-10.091 10.091v0.736c0 5.573 4.517 10.091 10.091 10.091h115.197c5.573 0 10.091-4.518 10.091-10.091v-0.736c0-5.574-4.518-10.091-10.091-10.091z',
          'M170.129 526.251v1.65c0 2.283 0.906 4.473 2.521 6.087s3.803 2.521 6.086 2.521h118.165c2.283 0 4.473-0.907 6.087-2.521s2.521-3.803 2.521-6.087v-1.65h-135.379z',
          'M431.823 537.376h-23.282v296.603h23.282v-296.603z',
          'M431.823 537.376h-23.282v19.233h23.282v-19.233z',
          'M1012.888 516.113h-615.481v38.467h615.481v-38.467z',
        ],
        attrs: [
          {
            fill: 'rgb(225, 112, 0)',
            opacity: 0.1,
          },
          {
            fill: 'rgb(225, 112, 0)',
            opacity: 0.1,
          },
          {
            fill: 'rgb(225, 112, 0)',
            opacity: 0.1,
          },
          {
            fill: 'rgb(225, 112, 0)',
            opacity: 0.1,
          },
          {
            fill: 'rgb(214, 214, 227)',
          },
          {
            fill: 'rgb(174, 190, 225)',
          },
          {
            fill: 'rgb(83, 84, 97)',
          },
          {
            fill: 'rgb(214, 214, 227)',
          },
          {
            fill: 'rgb(174, 190, 225)',
          },
          {
            fill: 'rgb(83, 84, 97)',
          },
          {
            fill: 'rgb(214, 214, 227)',
          },
          {
            fill: 'rgb(0, 0, 0)',
            opacity: 0.1,
          },
          {
            fill: 'rgb(83, 84, 97)',
          },
          {
            fill: 'rgb(83, 84, 97)',
          },
          {
            fill: 'rgb(0, 0, 0)',
            opacity: 0.1,
          },
          {
            fill: 'rgb(214, 214, 227)',
          },
          {
            fill: 'rgb(227, 237, 249)',
          },
          {
            fill: 'rgb(0, 0, 0)',
            opacity: 0.1,
          },
          {
            fill: 'rgb(214, 214, 227)',
          },
          {
            fill: 'rgb(83, 84, 97)',
          },
          {
            fill: 'rgb(83, 84, 97)',
          },
          {
            fill: 'rgb(0, 0, 0)',
            opacity: 0.1,
          },
          {
            fill: 'rgb(214, 214, 227)',
          },
          {
            fill: 'rgb(227, 237, 249)',
          },
          {
            fill: 'rgb(0, 0, 0)',
            opacity: 0.1,
          },
          {
            fill: 'rgb(214, 214, 227)',
          },
          {
            fill: 'rgb(0, 0, 0)',
          },
          {
            fill: 'rgb(248, 185, 191)',
          },
          {
            fill: 'rgb(0, 0, 0)',
            opacity: 0.1,
          },
          {
            fill: 'rgb(217, 223, 232)',
          },
          {
            fill: 'rgb(0, 0, 0)',
            opacity: 0.1,
          },
          {
            fill: 'rgb(225, 112, 0)',
          },
          {
            fill: 'rgb(0, 0, 0)',
            opacity: 0.010000000000000002,
          },
          {
            fill: 'rgb(0, 0, 0)',
            opacity: 0.010000000000000002,
          },
          {
            fill: 'rgb(0, 0, 0)',
            opacity: 0.010000000000000002,
          },
          {
            fill: 'rgb(0, 0, 0)',
            opacity: 0.010000000000000002,
          },
          {
            fill: 'rgb(0, 0, 0)',
            opacity: 0.010000000000000002,
          },
          {
            fill: 'rgb(104, 115, 157)',
          },
          {
            fill: 'rgb(99, 148, 226)',
          },
          {
            fill: 'rgb(0, 0, 0)',
            opacity: 0.010000000000000002,
          },
          {
            fill: 'rgb(0, 0, 0)',
            opacity: 0.010000000000000002,
          },
          {
            fill: 'rgb(104, 115, 157)',
          },
          {
            fill: 'rgb(99, 148, 226)',
          },
          {
            fill: 'rgb(248, 185, 191)',
          },
          {
            fill: 'rgb(0, 0, 0)',
            opacity: 0.1,
          },
          {
            fill: 'rgb(217, 223, 232)',
          },
          {
            fill: 'rgb(0, 0, 0)',
            opacity: 0.1,
          },
          {
            fill: 'rgb(217, 223, 232)',
          },
          {
            fill: 'rgb(0, 0, 0)',
            opacity: 0.1,
          },
          {
            fill: 'rgb(225, 112, 0)',
          },
          {
            fill: 'rgb(0, 0, 0)',
            opacity: 0.1,
          },
          {
            fill: 'rgb(225, 112, 0)',
          },
          {
            fill: 'rgb(0, 0, 0)',
            opacity: 0.1,
          },
          {
            fill: 'rgb(248, 185, 191)',
          },
          {
            fill: 'rgb(0, 0, 0)',
            opacity: 0.1,
          },
          {
            fill: 'rgb(185, 107, 107)',
          },
          {
            fill: 'rgb(0, 0, 0)',
            opacity: 0.1,
          },
          {
            fill: 'rgb(214, 214, 227)',
          },
          {
            fill: 'rgb(0, 0, 0)',
            opacity: 0.1,
          },
          {
            fill: 'rgb(214, 214, 227)',
          },
          {
            fill: 'rgb(0, 0, 0)',
            opacity: 0.1,
          },
          {
            fill: 'rgb(214, 214, 227)',
          },
          {
            fill: 'rgb(83, 84, 97)',
          },
          {
            fill: 'rgb(214, 214, 227)',
          },
          {
            fill: 'rgb(0, 0, 0)',
            opacity: 0.1,
          },
          {
            fill: 'rgb(214, 214, 227)',
          },
          {
            fill: 'rgb(0, 0, 0)',
            opacity: 0.1,
          },
          {
            fill: 'rgb(214, 214, 227)',
          },
          {
            fill: 'rgb(0, 0, 0)',
            opacity: 0.1,
          },
          {
            fill: 'rgb(214, 214, 227)',
          },
          {
            fill: 'rgb(0, 0, 0)',
            opacity: 0.1,
          },
          {
            fill: 'rgb(214, 214, 227)',
          },
          {
            fill: 'rgb(83, 84, 97)',
          },
          {
            fill: 'rgb(0, 0, 0)',
            opacity: 0.1,
          },
          {
            fill: 'none',
            stroke: 'rgb(83, 84, 97)',
            strokeLinejoin: 'miter',
            strokeLinecap: 'butt',
            strokeMiterlimit: '10',
            strokeWidth: 13.212903225806452,
          },
          {
            fill: 'rgb(225, 112, 0)',
          },
          {
            fill: 'rgb(225, 112, 0)',
          },
          {
            fill: 'rgb(225, 112, 0)',
            opacity: 0.1,
          },
          {
            fill: 'rgb(225, 112, 0)',
            opacity: 0.1,
          },
          {
            fill: 'rgb(225, 112, 0)',
            opacity: 0.1,
          },
          {
            fill: 'rgb(225, 112, 0)',
            opacity: 0.1,
          },
          {
            fill: 'rgb(0, 0, 0)',
          },
          {
            fill: 'rgb(250, 89, 95)',
          },
          {
            fill: 'rgb(248, 185, 191)',
          },
          {
            fill: 'rgb(0, 0, 0)',
            opacity: 0.1,
          },
          {
            fill: 'rgb(217, 223, 232)',
          },
          {
            fill: 'rgb(0, 0, 0)',
            opacity: 0.1,
          },
          {
            fill: 'rgb(225, 112, 0)',
          },
          {
            fill: 'rgb(0, 0, 0)',
            opacity: 0.010000000000000002,
          },
          {
            fill: 'rgb(0, 0, 0)',
            opacity: 0.010000000000000002,
          },
          {
            fill: 'rgb(0, 0, 0)',
            opacity: 0.010000000000000002,
          },
          {
            fill: 'rgb(0, 0, 0)',
            opacity: 0.010000000000000002,
          },
          {
            fill: 'rgb(0, 0, 0)',
            opacity: 0.010000000000000002,
          },
          {
            fill: 'rgb(243, 114, 145)',
          },
          {
            fill: 'rgb(150, 162, 208)',
          },
          {
            fill: 'rgb(0, 0, 0)',
            opacity: 0.010000000000000002,
          },
          {
            fill: 'rgb(0, 0, 0)',
            opacity: 0.010000000000000002,
          },
          {
            fill: 'rgb(243, 114, 145)',
          },
          {
            fill: 'rgb(150, 162, 208)',
          },
          {
            fill: 'rgb(248, 185, 191)',
          },
          {
            fill: 'rgb(0, 0, 0)',
            opacity: 0.1,
          },
          {
            fill: 'rgb(217, 223, 232)',
          },
          {
            fill: 'rgb(225, 112, 0)',
          },
          {
            fill: 'rgb(0, 0, 0)',
            opacity: 0.1,
          },
          {
            fill: 'rgb(225, 112, 0)',
          },
          {
            fill: 'rgb(0, 0, 0)',
            opacity: 0.1,
          },
          {
            fill: 'rgb(248, 185, 191)',
          },
          {
            fill: 'rgb(0, 0, 0)',
            opacity: 0.1,
          },
          {
            fill: 'rgb(250, 89, 95)',
          },
          {
            fill: 'rgb(250, 89, 95)',
          },
          {
            fill: 'rgb(250, 89, 95)',
          },
          {
            fill: 'rgb(0, 0, 0)',
            opacity: 0.1,
          },
          {
            fill: 'rgb(250, 89, 95)',
          },
          {
            fill: 'rgb(214, 214, 227)',
          },
          {
            fill: 'rgb(0, 0, 0)',
            opacity: 0.1,
          },
          {
            fill: 'rgb(214, 214, 227)',
          },
          {
            fill: 'rgb(0, 0, 0)',
            opacity: 0.1,
          },
          {
            fill: 'rgb(214, 214, 227)',
          },
        ],
        width: 1335,
        isMulticolor: true,
        isMulticolor2: true,
        grid: 16,
        tags: ['co_working'],
      },
      attrs: [
        {
          fill: 'rgb(225, 112, 0)',
          opacity: 0.1,
        },
        {
          fill: 'rgb(225, 112, 0)',
          opacity: 0.1,
        },
        {
          fill: 'rgb(225, 112, 0)',
          opacity: 0.1,
        },
        {
          fill: 'rgb(225, 112, 0)',
          opacity: 0.1,
        },
        {
          fill: 'rgb(214, 214, 227)',
        },
        {
          fill: 'rgb(174, 190, 225)',
        },
        {
          fill: 'rgb(83, 84, 97)',
        },
        {
          fill: 'rgb(214, 214, 227)',
        },
        {
          fill: 'rgb(174, 190, 225)',
        },
        {
          fill: 'rgb(83, 84, 97)',
        },
        {
          fill: 'rgb(214, 214, 227)',
        },
        {
          fill: 'rgb(0, 0, 0)',
          opacity: 0.1,
        },
        {
          fill: 'rgb(83, 84, 97)',
        },
        {
          fill: 'rgb(83, 84, 97)',
        },
        {
          fill: 'rgb(0, 0, 0)',
          opacity: 0.1,
        },
        {
          fill: 'rgb(214, 214, 227)',
        },
        {
          fill: 'rgb(227, 237, 249)',
        },
        {
          fill: 'rgb(0, 0, 0)',
          opacity: 0.1,
        },
        {
          fill: 'rgb(214, 214, 227)',
        },
        {
          fill: 'rgb(83, 84, 97)',
        },
        {
          fill: 'rgb(83, 84, 97)',
        },
        {
          fill: 'rgb(0, 0, 0)',
          opacity: 0.1,
        },
        {
          fill: 'rgb(214, 214, 227)',
        },
        {
          fill: 'rgb(227, 237, 249)',
        },
        {
          fill: 'rgb(0, 0, 0)',
          opacity: 0.1,
        },
        {
          fill: 'rgb(214, 214, 227)',
        },
        {
          fill: 'rgb(0, 0, 0)',
        },
        {
          fill: 'rgb(248, 185, 191)',
        },
        {
          fill: 'rgb(0, 0, 0)',
          opacity: 0.1,
        },
        {
          fill: 'rgb(217, 223, 232)',
        },
        {
          fill: 'rgb(0, 0, 0)',
          opacity: 0.1,
        },
        {
          fill: 'rgb(225, 112, 0)',
        },
        {
          fill: 'rgb(0, 0, 0)',
          opacity: 0.010000000000000002,
        },
        {
          fill: 'rgb(0, 0, 0)',
          opacity: 0.010000000000000002,
        },
        {
          fill: 'rgb(0, 0, 0)',
          opacity: 0.010000000000000002,
        },
        {
          fill: 'rgb(0, 0, 0)',
          opacity: 0.010000000000000002,
        },
        {
          fill: 'rgb(0, 0, 0)',
          opacity: 0.010000000000000002,
        },
        {
          fill: 'rgb(104, 115, 157)',
        },
        {
          fill: 'rgb(99, 148, 226)',
        },
        {
          fill: 'rgb(0, 0, 0)',
          opacity: 0.010000000000000002,
        },
        {
          fill: 'rgb(0, 0, 0)',
          opacity: 0.010000000000000002,
        },
        {
          fill: 'rgb(104, 115, 157)',
        },
        {
          fill: 'rgb(99, 148, 226)',
        },
        {
          fill: 'rgb(248, 185, 191)',
        },
        {
          fill: 'rgb(0, 0, 0)',
          opacity: 0.1,
        },
        {
          fill: 'rgb(217, 223, 232)',
        },
        {
          fill: 'rgb(0, 0, 0)',
          opacity: 0.1,
        },
        {
          fill: 'rgb(217, 223, 232)',
        },
        {
          fill: 'rgb(0, 0, 0)',
          opacity: 0.1,
        },
        {
          fill: 'rgb(225, 112, 0)',
        },
        {
          fill: 'rgb(0, 0, 0)',
          opacity: 0.1,
        },
        {
          fill: 'rgb(225, 112, 0)',
        },
        {
          fill: 'rgb(0, 0, 0)',
          opacity: 0.1,
        },
        {
          fill: 'rgb(248, 185, 191)',
        },
        {
          fill: 'rgb(0, 0, 0)',
          opacity: 0.1,
        },
        {
          fill: 'rgb(185, 107, 107)',
        },
        {
          fill: 'rgb(0, 0, 0)',
          opacity: 0.1,
        },
        {
          fill: 'rgb(214, 214, 227)',
        },
        {
          fill: 'rgb(0, 0, 0)',
          opacity: 0.1,
        },
        {
          fill: 'rgb(214, 214, 227)',
        },
        {
          fill: 'rgb(0, 0, 0)',
          opacity: 0.1,
        },
        {
          fill: 'rgb(214, 214, 227)',
        },
        {
          fill: 'rgb(83, 84, 97)',
        },
        {
          fill: 'rgb(214, 214, 227)',
        },
        {
          fill: 'rgb(0, 0, 0)',
          opacity: 0.1,
        },
        {
          fill: 'rgb(214, 214, 227)',
        },
        {
          fill: 'rgb(0, 0, 0)',
          opacity: 0.1,
        },
        {
          fill: 'rgb(214, 214, 227)',
        },
        {
          fill: 'rgb(0, 0, 0)',
          opacity: 0.1,
        },
        {
          fill: 'rgb(214, 214, 227)',
        },
        {
          fill: 'rgb(0, 0, 0)',
          opacity: 0.1,
        },
        {
          fill: 'rgb(214, 214, 227)',
        },
        {
          fill: 'rgb(83, 84, 97)',
        },
        {
          fill: 'rgb(0, 0, 0)',
          opacity: 0.1,
        },
        {
          fill: 'none',
          stroke: 'rgb(83, 84, 97)',
          strokeLinejoin: 'miter',
          strokeLinecap: 'butt',
          strokeMiterlimit: '10',
          strokeWidth: 13.212903225806452,
        },
        {
          fill: 'rgb(225, 112, 0)',
        },
        {
          fill: 'rgb(225, 112, 0)',
        },
        {
          fill: 'rgb(225, 112, 0)',
          opacity: 0.1,
        },
        {
          fill: 'rgb(225, 112, 0)',
          opacity: 0.1,
        },
        {
          fill: 'rgb(225, 112, 0)',
          opacity: 0.1,
        },
        {
          fill: 'rgb(225, 112, 0)',
          opacity: 0.1,
        },
        {
          fill: 'rgb(0, 0, 0)',
        },
        {
          fill: 'rgb(250, 89, 95)',
        },
        {
          fill: 'rgb(248, 185, 191)',
        },
        {
          fill: 'rgb(0, 0, 0)',
          opacity: 0.1,
        },
        {
          fill: 'rgb(217, 223, 232)',
        },
        {
          fill: 'rgb(0, 0, 0)',
          opacity: 0.1,
        },
        {
          fill: 'rgb(225, 112, 0)',
        },
        {
          fill: 'rgb(0, 0, 0)',
          opacity: 0.010000000000000002,
        },
        {
          fill: 'rgb(0, 0, 0)',
          opacity: 0.010000000000000002,
        },
        {
          fill: 'rgb(0, 0, 0)',
          opacity: 0.010000000000000002,
        },
        {
          fill: 'rgb(0, 0, 0)',
          opacity: 0.010000000000000002,
        },
        {
          fill: 'rgb(0, 0, 0)',
          opacity: 0.010000000000000002,
        },
        {
          fill: 'rgb(243, 114, 145)',
        },
        {
          fill: 'rgb(150, 162, 208)',
        },
        {
          fill: 'rgb(0, 0, 0)',
          opacity: 0.010000000000000002,
        },
        {
          fill: 'rgb(0, 0, 0)',
          opacity: 0.010000000000000002,
        },
        {
          fill: 'rgb(243, 114, 145)',
        },
        {
          fill: 'rgb(150, 162, 208)',
        },
        {
          fill: 'rgb(248, 185, 191)',
        },
        {
          fill: 'rgb(0, 0, 0)',
          opacity: 0.1,
        },
        {
          fill: 'rgb(217, 223, 232)',
        },
        {
          fill: 'rgb(225, 112, 0)',
        },
        {
          fill: 'rgb(0, 0, 0)',
          opacity: 0.1,
        },
        {
          fill: 'rgb(225, 112, 0)',
        },
        {
          fill: 'rgb(0, 0, 0)',
          opacity: 0.1,
        },
        {
          fill: 'rgb(248, 185, 191)',
        },
        {
          fill: 'rgb(0, 0, 0)',
          opacity: 0.1,
        },
        {
          fill: 'rgb(250, 89, 95)',
        },
        {
          fill: 'rgb(250, 89, 95)',
        },
        {
          fill: 'rgb(250, 89, 95)',
        },
        {
          fill: 'rgb(0, 0, 0)',
          opacity: 0.1,
        },
        {
          fill: 'rgb(250, 89, 95)',
        },
        {
          fill: 'rgb(214, 214, 227)',
        },
        {
          fill: 'rgb(0, 0, 0)',
          opacity: 0.1,
        },
        {
          fill: 'rgb(214, 214, 227)',
        },
        {
          fill: 'rgb(0, 0, 0)',
          opacity: 0.1,
        },
        {
          fill: 'rgb(214, 214, 227)',
        },
      ],
      properties: {
        order: 13,
        id: 501,
        name: 'co_working',
        prevSize: 32,
      },
      setIdx: 0,
      setId: 1,
      iconIdx: 0,
    },
    {
      icon: {
        paths: [
          'M872.937 727.535c0 0 135.452 7.003 103.9 49.647-31.546 42.638-114.45-25.012-114.45-25.012l10.551-24.635z',
          'M623.318 321.395l27.571 6.893c0 0 16.085 48.249 27.573 91.902 11.482 43.654 34.459 174.616 34.459 174.616l178.123 124.835-21.24 47.527-237.296-93.528-52.844-207.498 43.653-144.747z',
          'M649.259 407.038l-10.276 215.19 21.443 63.978-62.813-46.062 51.646-233.105z',
          'M686.503 788.949c0 0 29.868 80.414 34.459 135.558 4.598 55.144 9.19 98.793 9.19 98.793h-140.149l-27.571-41.356v41.356h-163.127c0 0-45.952-149.339-27.571-167.718 18.381-18.386 192.996-96.5 192.996-96.5l121.773 29.868z',
          'M953.555 1021.205h-810.988v2.795h810.988v-2.795z',
          'M510.74 234.087c48.219 0 87.308-39.088 87.308-87.308s-39.089-87.307-87.308-87.307c-48.219 0-87.308 39.089-87.308 87.307s39.088 87.308 87.308 87.308z',
          'M444.105 183.54l-6.893 101.093 87.308 117.176 43.653-110.283c0 0-39.059-25.273-16.083-78.117l-107.986-29.868z',
          'M699.128 808.478c0 20.685-57.436 52.845-57.436 52.845v11.489l-22.976 11.489-50.543-101.085-13.777 110.268c0 0-101.101 16.093-133.261 0-32.174-16.080-48.254-9.183-94.205-25.263s18.383-232.060 18.383-232.060l-45.951-333.146 105.679-52.846 34.965-6.449 70.727 47.808 9.199 48.254 18.369-20.687 13.875-45.63 98.714 54.829-27.568 220.557c0 0 75.805 238.956 75.805 259.628z',
          'M361.395 879.702c0 0 105.689 85.012 55.142 101.092-50.547 16.087-78.117-87.304-78.117-87.304l22.975-13.788z',
          'M322.335 307.61l-22.975-4.595c0 0-34.464 18.38-36.761 55.142s-32.166 294.088-32.166 294.088l96.498 259.624 78.117-29.868-75.82-243.542 57.439-211.376-64.332-119.474z',
          'M520.846 377.725c4.625 0 8.375-3.75 8.375-8.375s-3.75-8.375-8.375-8.375c-4.625 0-8.375 3.75-8.375 8.375s3.75 8.375 8.375 8.375z',
          'M520.846 432.162c4.625 0 8.375-3.75 8.375-8.375s-3.75-8.375-8.375-8.375c-4.625 0-8.375 3.75-8.375 8.375s3.75 8.375 8.375 8.375z',
          'M568.298 790.891c4.626 0 8.375-3.746 8.375-8.37s-3.749-8.377-8.375-8.377c-4.625 0-8.375 3.752-8.375 8.377s3.75 8.37 8.375 8.37z',
          'M437.024 57.337l-16.139-6.461c0 0 33.746-37.152 80.696-33.921l-13.205-14.538c0 0 32.278-12.922 61.623 20.999 15.425 17.832 33.273 38.792 44.399 62.404h17.284l-7.214 15.884 25.248 15.884-25.914-2.853c1.544 8.698 1.781 17.578 0.703 26.347-1.111 8.771-5.587 16.767-12.483 22.299 0 0-20.016-41.43-20.016-47.891v16.153c0 0-16.139-14.538-16.139-24.23l-8.804 11.307h-58.688l8.803-14.537-33.746 4.846 13.205-17.769-52.248 73.373c0 0-29.916-83.064 12.633-107.294z',
          'M956.205 674.955c77.091 0 139.581-62.496 139.581-139.586s-62.49-139.584-139.581-139.584c-77.091 0-139.588 62.494-139.588 139.584s62.497 139.586 139.588 139.586z',
          'M956.205 655.412c66.296 0 120.039-53.745 120.039-120.043s-53.743-120.043-120.039-120.043c-66.296 0-120.046 53.745-120.046 120.043s53.75 120.043 120.046 120.043z',
          'M950.444 606.205v-17.471c-8.826-0.172-17.963-3.287-23.294-7.612l3.653-11.59c6.336 4.746 14.012 7.351 21.927 7.438 10.815 0 18.121-7.092 18.121-16.952 0-9.515-5.939-15.396-17.21-20.586-15.532-6.919-25.124-14.877-25.124-29.927 0-14.358 8.985-25.256 22.997-27.851v-17.472h9.441v16.78c7.036 0.096 13.907 2.196 19.793 6.054l-3.805 11.418c-5.649-3.867-12.341-5.919-19.185-5.882-11.726 0-16.14 7.957-16.14 14.878 0 8.995 5.629 13.492 18.881 19.721 15.684 7.265 23.598 16.26 23.598 31.656 0 13.666-8.37 26.468-24.054 29.407v17.992h-9.599z',
          'M349.858 704.717l55.827 174.391-44.667-181.459-11.16 7.069z',
          'M65.229 364.041h-35.436c-1.544-0.002-3.025-0.616-4.117-1.708s-1.706-2.573-1.708-4.118v-50.938c0.002-1.545 0.616-3.025 1.708-4.117s2.573-1.706 4.117-1.708h35.436c1.544 0.002 3.025 0.616 4.117 1.708s1.706 2.573 1.708 4.117v50.938c-0.002 1.545-0.616 3.025-1.708 4.118s-2.573 1.706-4.117 1.708zM29.793 304.243c-0.804 0.001-1.575 0.321-2.144 0.889s-0.889 1.34-0.89 2.144v50.938c0.001 0.805 0.321 1.576 0.89 2.144s1.34 0.889 2.144 0.889h35.436c0.804-0.001 1.576-0.32 2.144-0.889s0.889-1.34 0.889-2.144v-50.938c-0.001-0.805-0.321-1.576-0.889-2.144s-1.34-0.889-2.144-0.889h-35.436z',
          'M129.95 364.041h-32.001c-2-0.003-3.917-0.798-5.331-2.212s-2.21-3.332-2.212-5.331v-102.872c0.002-2 0.797-3.917 2.212-5.331s3.331-2.21 5.331-2.212h32.001c2 0.002 3.917 0.797 5.331 2.212s2.21 3.331 2.212 5.331v102.873c-0.002 2-0.797 3.916-2.212 5.331s-3.331 2.209-5.331 2.212zM97.949 248.874c-1.26 0.002-2.468 0.503-3.358 1.393s-1.392 2.098-1.393 3.358v102.872c0.001 1.26 0.503 2.468 1.393 3.358s2.098 1.392 3.358 1.393h32.001c1.26-0.001 2.468-0.502 3.358-1.393s1.391-2.098 1.393-3.358v-102.872c-0.002-1.259-0.503-2.468-1.393-3.358s-2.098-1.391-3.358-1.393h-32.001z',
          'M195.166 364.041h-29.53c-2.327-0.003-4.558-0.929-6.204-2.575s-2.571-3.877-2.574-6.204v-151.34c0.003-2.327 0.928-4.559 2.574-6.205s3.877-2.571 6.204-2.574h29.53c2.327 0.003 4.559 0.928 6.205 2.574s2.571 3.877 2.574 6.205v151.34c-0.003 2.327-0.928 4.558-2.574 6.204s-3.877 2.572-6.205 2.575zM165.636 197.935c-1.587 0.001-3.109 0.633-4.231 1.755s-1.754 2.644-1.756 4.231v151.34c0.002 1.587 0.634 3.109 1.756 4.231s2.644 1.753 4.231 1.755h29.53c1.588-0.002 3.109-0.633 4.231-1.755s1.754-2.645 1.756-4.231v-151.34c-0.002-1.588-0.634-3.109-1.756-4.231s-2.644-1.754-4.231-1.755h-29.53z',
          'M60.803 311.152h-26.577v43.188h26.577v-43.188z',
          'M127.242 256.338h-26.577v98.002h26.577v-98.002z',
          'M193.687 205.399h-26.577v148.941h26.577v-148.941z',
          'M1010.087 203.518h-185.648c-0.178 0.001-0.363-0.036-0.535-0.106-0.165-0.070-0.317-0.173-0.449-0.303s-0.231-0.283-0.304-0.453c-0.073-0.169-0.106-0.351-0.106-0.534v-188.439c0-0.37 0.145-0.725 0.41-0.987s0.614-0.409 0.984-0.409c0.37 0 0.727 0.147 0.991 0.409 0.258 0.262 0.41 0.617 0.41 0.987v187.043h184.247c0.37 0 0.727 0.147 0.991 0.409 0.258 0.262 0.403 0.616 0.403 0.987s-0.145 0.725-0.403 0.987c-0.264 0.262-0.621 0.408-0.991 0.408z',
          'M222.83 383.582h-220.543c-0.183 0-0.365-0.036-0.534-0.106s-0.323-0.173-0.453-0.303c-0.13-0.129-0.232-0.283-0.303-0.453s-0.106-0.351-0.106-0.534v-219.147c0-0.371 0.147-0.725 0.409-0.987s0.617-0.409 0.987-0.409c0.37 0 0.725 0.147 0.987 0.409s0.409 0.616 0.409 0.987v217.751h219.148c0.37 0 0.725 0.147 0.987 0.409s0.408 0.616 0.408 0.987c0 0.37-0.147 0.725-0.408 0.987s-0.617 0.409-0.987 0.409z',
          'M888.508 186.025h-35.437c-1.546-0.002-3.026-0.616-4.116-1.708-1.097-1.092-1.711-2.573-1.711-4.117v-50.939c0-1.544 0.614-3.025 1.711-4.117 1.090-1.092 2.57-1.706 4.116-1.708h35.437c1.546 0.002 3.026 0.616 4.116 1.708s1.704 2.573 1.704 4.116v50.939c0 1.545-0.614 3.025-1.704 4.117s-2.57 1.706-4.116 1.708zM853.071 126.227c-0.806 0.001-1.579 0.32-2.147 0.889s-0.885 1.34-0.885 2.144v50.939c0 0.805 0.317 1.576 0.885 2.144s1.341 0.889 2.147 0.889h35.437c0.806-0.001 1.572-0.321 2.14-0.89s0.892-1.34 0.892-2.144v-50.939c0-0.804-0.324-1.575-0.892-2.144s-1.335-0.889-2.14-0.889h-35.437z',
          'M961.074 186.025h-32.616c-1.922-0.003-3.759-0.766-5.113-2.122-1.361-1.357-2.121-3.196-2.127-5.115v-92.264c0.007-1.919 0.766-3.758 2.127-5.114 1.354-1.356 3.191-2.119 5.113-2.121h32.616c1.916 0.002 3.752 0.765 5.113 2.121 1.354 1.356 2.114 3.196 2.121 5.114v92.264c-0.007 1.919-0.766 3.758-2.121 5.115-1.361 1.356-3.198 2.119-5.113 2.122zM928.457 82.080c-1.183 0.001-2.312 0.47-3.145 1.303s-1.301 1.963-1.301 3.141v92.264c0 1.179 0.469 2.308 1.301 3.141s1.962 1.302 3.145 1.303h32.616c1.176-0.001 2.306-0.47 3.138-1.303s1.301-1.963 1.301-3.141v-92.264c0-1.178-0.469-2.308-1.301-3.141s-1.962-1.302-3.138-1.303h-32.616z',
          'M883.441 133.62h-26.578v43.187h26.578v-43.187z',
          'M958.054 90.876h-26.578v83.56h26.578v-83.56z',
          'M870.499 108.601c6.937 0 12.559-5.625 12.559-12.563s-5.622-12.563-12.559-12.563c-6.937 0-12.565 5.625-12.565 12.563s5.629 12.563 12.565 12.563z',
          'M944.478 61.143c6.937 0 12.565-5.624 12.565-12.563s-5.629-12.563-12.565-12.563c-6.937 0-12.559 5.624-12.559 12.563s5.622 12.563 12.559 12.563z',
        ],
        attrs: [
          {
            fill: 'rgb(255, 184, 184)',
          },
          {
            fill: 'rgb(87, 90, 137)',
          },
          {
            fill: 'rgb(0, 0, 0)',
            opacity: 0.2,
          },
          {
            fill: 'rgb(47, 46, 65)',
          },
          {
            fill: 'rgb(63, 61, 86)',
          },
          {
            fill: 'rgb(255, 184, 184)',
          },
          {
            fill: 'rgb(255, 184, 184)',
          },
          {
            fill: 'rgb(87, 90, 137)',
          },
          {
            fill: 'rgb(255, 184, 184)',
          },
          {
            fill: 'rgb(87, 90, 137)',
          },
          {
            fill: 'rgb(47, 46, 65)',
          },
          {
            fill: 'rgb(47, 46, 65)',
          },
          {
            fill: 'rgb(47, 46, 65)',
          },
          {
            fill: 'rgb(47, 46, 65)',
          },
          {
            fill: 'rgb(63, 61, 86)',
          },
          {
            fill: 'rgb(0, 0, 0)',
            opacity: 0.1,
          },
          {
            fill: 'rgb(225, 112, 0)',
          },
          {
            fill: 'rgb(0, 0, 0)',
            opacity: 0.2,
          },
          {
            fill: 'rgb(63, 61, 86)',
          },
          {
            fill: 'rgb(63, 61, 86)',
          },
          {
            fill: 'rgb(63, 61, 86)',
          },
          {
            fill: 'rgb(225, 112, 0)',
          },
          {
            fill: 'rgb(225, 112, 0)',
          },
          {
            fill: 'rgb(225, 112, 0)',
          },
          {
            fill: 'rgb(63, 61, 86)',
          },
          {
            fill: 'rgb(63, 61, 86)',
          },
          {
            fill: 'rgb(63, 61, 86)',
          },
          {
            fill: 'rgb(63, 61, 86)',
          },
          {
            fill: 'rgb(225, 112, 0)',
          },
          {
            fill: 'rgb(225, 112, 0)',
          },
          {
            fill: 'rgb(225, 112, 0)',
          },
          {
            fill: 'rgb(225, 112, 0)',
          },
        ],
        width: 1097,
        isMulticolor: true,
        isMulticolor2: true,
        grid: 16,
        tags: ['undraw_2'],
      },
      attrs: [
        {
          fill: 'rgb(255, 184, 184)',
        },
        {
          fill: 'rgb(87, 90, 137)',
        },
        {
          fill: 'rgb(0, 0, 0)',
          opacity: 0.2,
        },
        {
          fill: 'rgb(47, 46, 65)',
        },
        {
          fill: 'rgb(63, 61, 86)',
        },
        {
          fill: 'rgb(255, 184, 184)',
        },
        {
          fill: 'rgb(255, 184, 184)',
        },
        {
          fill: 'rgb(87, 90, 137)',
        },
        {
          fill: 'rgb(255, 184, 184)',
        },
        {
          fill: 'rgb(87, 90, 137)',
        },
        {
          fill: 'rgb(47, 46, 65)',
        },
        {
          fill: 'rgb(47, 46, 65)',
        },
        {
          fill: 'rgb(47, 46, 65)',
        },
        {
          fill: 'rgb(47, 46, 65)',
        },
        {
          fill: 'rgb(63, 61, 86)',
        },
        {
          fill: 'rgb(0, 0, 0)',
          opacity: 0.1,
        },
        {
          fill: 'rgb(225, 112, 0)',
        },
        {
          fill: 'rgb(0, 0, 0)',
          opacity: 0.2,
        },
        {
          fill: 'rgb(63, 61, 86)',
        },
        {
          fill: 'rgb(63, 61, 86)',
        },
        {
          fill: 'rgb(63, 61, 86)',
        },
        {
          fill: 'rgb(225, 112, 0)',
        },
        {
          fill: 'rgb(225, 112, 0)',
        },
        {
          fill: 'rgb(225, 112, 0)',
        },
        {
          fill: 'rgb(63, 61, 86)',
        },
        {
          fill: 'rgb(63, 61, 86)',
        },
        {
          fill: 'rgb(63, 61, 86)',
        },
        {
          fill: 'rgb(63, 61, 86)',
        },
        {
          fill: 'rgb(225, 112, 0)',
        },
        {
          fill: 'rgb(225, 112, 0)',
        },
        {
          fill: 'rgb(225, 112, 0)',
        },
        {
          fill: 'rgb(225, 112, 0)',
        },
      ],
      properties: {
        order: 12,
        id: 500,
        name: 'undraw_2',
        prevSize: 32,
      },
      setIdx: 0,
      setId: 1,
      iconIdx: 0,
    },
    {
      icon: {
        paths: [
          'M850.567 940.395c-58.764 0.159-117.463-3.686-175.705-11.508-1.903-0.244-3.825-0.515-5.741-0.806-14.296-2.028-28.598-4.354-42.503-6.904-62.57-11.442-121.575-28.157-175.376-49.674-179.033-71.614-291.6-56.373-354.504-30.978-68.075 27.483-94.244 72.453-94.5 72.902l-2.239-1.275c0.26-0.456 26.766-46.093 95.585-73.939 40.35-16.325 87.16-23.46 139.139-21.213 64.883 2.808 138.053 20.341 217.476 52.112 53.64 21.451 112.48 38.119 174.883 49.535 13.87 2.543 28.139 4.862 42.409 6.891 1.909 0.284 3.819 0.548 5.715 0.793 157.861 21.715 310.153 8.621 410.115-6.19 82.396-12.202 135.419-26.472 135.948-26.617l0.674 2.484c-0.529 0.145-53.684 14.455-136.238 26.683-77.85 11.594-156.434 17.514-235.137 17.705z',
          'M850.739 201.45c-45.386 0-89.57-2.124-132.202-6.369-97.964-9.756-187.894-30.807-267.294-62.566-179.034-71.615-291.6-56.375-354.504-30.977-68.075 27.483-94.244 72.451-94.5 72.902l-2.239-1.271c0.26-0.458 26.766-46.094 95.585-73.941 40.351-16.328 87.16-23.467 139.139-21.215 64.883 2.81 138.053 20.342 217.476 52.111 179.316 71.727 378.852 74.545 514.661 64.288 147.212-11.123 253.357-39.587 254.408-39.873l0.674 2.484c-1.057 0.287-107.394 28.807-254.831 39.953-39.474 2.983-78.346 4.476-116.373 4.476z',
          'M844.073 12.449c0 0-50.619-18.078-83.155 54.233-32.543 72.31-83.162 151.852-83.162 151.852l28.923 7.231c0 0 7.234-50.617 25.309-57.849l-7.227 65.079c0 0 216.929 75.926 314.546-7.231l-3.614-25.309c0 0 14.462 3.615 14.462 25.309l10.848-10.847c0 0-10.848-21.693-43.385-50.617-21.359-18.984-28.698-55.102-31.222-77.684-1.889-18.855-9.434-36.7-21.643-51.193-21.623-25.061-61.024-51.698-120.68-22.975z',
          'M1151.287 421.626c0 0 95.252 81.243 109.257 128.869s-53.228 53.228-53.228 53.228l-145.679 14.008c0 0-2.801 67.239-28.011 75.643-25.217 8.403-5.12-111.187-5.12-111.187l142.389-40.097-64.433-67.236 44.825-53.229z',
          'M705.847 505.671l-11.205 148.479-61.634 252.136c0 0-56.030 114.86-8.404 117.661 47.629 2.801 44.821-109.257 44.821-109.257l89.65-238.13 8.403-162.485-61.632-8.404z',
          'M862.73 245.131c51.061 0 92.451-41.391 92.451-92.449s-41.389-92.449-92.451-92.449c-51.061 0-92.451 41.391-92.451 92.449s41.389 92.449 92.451 92.449z',
          'M820.706 197.506c0 0 33.62 120.464-19.608 151.281s134.474 53.228 184.901-39.221c0 0-89.65-30.816-64.439-112.060h-100.854z',
          'M756.274 362.795l-16.807-5.604c0 0-33.62 14.008-33.62 39.221s-5.602 126.068-5.602 126.068l75.644 8.405-19.615-168.090z',
          'M1085.513 921.415c-103.424 15.32-254.157 27.694-410.472 6.197-0.013-1.546-0.013-3.052-0.013-4.519 0-8.747 0.33-17.388 1.004-25.93 8.007-105.208 62.206-192.922 83.182-223.318 1.050-1.546 2.035-2.94 2.907-4.175 3.389-4.75 5.358-7.26 5.358-7.26s162.486-2.651 246.526 30.964c4.056 1.698 7.763 4.129 10.947 7.155 31.334 28.916 49.747 122.801 60.561 220.887z',
          'M1025.216 323.573c0 0 36.421-19.611 72.843 22.412l72.836 84.045-56.029 61.633-106.456-64.435 16.807-103.655z',
          'M762.827 153.268c32.728-23.685 59.22-50.966 76.747-83.418 0 0 60.059 66.735 96.765 70.072s3.336-80.082 3.336-80.082l-66.732-16.684-63.396 6.673-50.057 33.367 3.336 70.071z',
          'M971.987 303.963c0 0-39.203 61.987-156.877 32.394l-75.644 20.834c0 0 8.403 168.090 30.812 198.906 22.416 30.817 16.813 47.626 11.205 50.427-5.602 2.802-19.608-2.801-11.205 11.207s19.615 5.603 8.403 14.007c-11.205 8.405-16.807 39.22-16.807 39.22l263.34 33.62c0 0-8.403-109.259 14.012-165.289 22.409-56.030 28.011-78.442 28.011-78.442l-16.807-140.075-78.445-16.809z',
          'M424.685 249.119h-360.481v450.604h360.481v-450.604z',
          'M166.556 287.098h-77.246v51.497h77.246v-51.497z',
          'M388.636 387.518h-298.685v18.024h298.685v-18.024z',
          'M388.636 435.152h-298.685v18.024h298.685v-18.024z',
          'M388.636 482.788h-298.685v18.024h298.685v-18.024z',
          'M388.636 530.423h-298.685v18.024h298.685v-18.024z',
          'M388.636 578.058h-298.685v18.024h298.685v-18.024z',
          'M495.494 699.075c-0.017 17.005-6.168 33.435-17.325 46.265s-26.571 21.207-43.408 23.585c-16.837 2.378-33.967-1.401-48.242-10.636-14.275-9.242-24.737-23.321-29.463-39.652-4.726-16.338-3.398-33.832 3.739-49.264s19.604-27.773 35.11-34.752c15.506-6.979 33.010-8.127 49.295-3.235s30.258 15.498 39.351 29.868c7.151 11.317 10.946 24.437 10.944 37.822z',
          'M484.553 661.253l-69.702 69.685c-4.381-6.778-28.787-38.298-28.787-38.298 3.128-3.164 6.466-6.111 9.99-8.82l20.239 26.987 60.097-60.1c3.048 3.249 5.781 6.78 8.163 10.545z',
        ],
        attrs: [
          {
            fill: 'rgb(63, 61, 86)',
          },
          {
            fill: 'rgb(63, 61, 86)',
          },
          {
            fill: 'rgb(47, 46, 65)',
          },
          {
            fill: 'rgb(251, 190, 190)',
          },
          {
            fill: 'rgb(251, 190, 190)',
          },
          {
            fill: 'rgb(251, 190, 190)',
          },
          {
            fill: 'rgb(251, 190, 190)',
          },
          {
            fill: 'rgb(225, 112, 0)',
          },
          {
            fill: 'rgb(47, 46, 65)',
          },
          {
            fill: 'rgb(225, 112, 0)',
          },
          {
            fill: 'rgb(47, 46, 65)',
          },
          {
            fill: 'rgb(225, 112, 0)',
          },
          {
            fill: 'rgb(230, 230, 230)',
          },
          {
            fill: 'rgb(255, 255, 255)',
          },
          {
            fill: 'rgb(255, 255, 255)',
          },
          {
            fill: 'rgb(255, 255, 255)',
          },
          {
            fill: 'rgb(255, 255, 255)',
          },
          {
            fill: 'rgb(255, 255, 255)',
          },
          {
            fill: 'rgb(255, 255, 255)',
          },
          {
            fill: 'rgb(225, 112, 0)',
          },
          {
            fill: 'rgb(255, 255, 255)',
          },
        ],
        width: 1268,
        isMulticolor: true,
        isMulticolor2: false,
        grid: 16,
        tags: ['undraw'],
      },
      attrs: [
        {
          fill: 'rgb(63, 61, 86)',
        },
        {
          fill: 'rgb(63, 61, 86)',
        },
        {
          fill: 'rgb(47, 46, 65)',
        },
        {
          fill: 'rgb(251, 190, 190)',
        },
        {
          fill: 'rgb(251, 190, 190)',
        },
        {
          fill: 'rgb(251, 190, 190)',
        },
        {
          fill: 'rgb(251, 190, 190)',
        },
        {
          fill: 'rgb(225, 112, 0)',
        },
        {
          fill: 'rgb(47, 46, 65)',
        },
        {
          fill: 'rgb(225, 112, 0)',
        },
        {
          fill: 'rgb(47, 46, 65)',
        },
        {
          fill: 'rgb(225, 112, 0)',
        },
        {
          fill: 'rgb(230, 230, 230)',
        },
        {
          fill: 'rgb(255, 255, 255)',
        },
        {
          fill: 'rgb(255, 255, 255)',
        },
        {
          fill: 'rgb(255, 255, 255)',
        },
        {
          fill: 'rgb(255, 255, 255)',
        },
        {
          fill: 'rgb(255, 255, 255)',
        },
        {
          fill: 'rgb(255, 255, 255)',
        },
        {
          fill: 'rgb(225, 112, 0)',
        },
        {
          fill: 'rgb(255, 255, 255)',
        },
      ],
      properties: {
        order: 11,
        id: 499,
        name: 'undraw',
        prevSize: 32,
      },
      setIdx: 0,
      setId: 1,
      iconIdx: 0,
    },
    {
      icon: {
        paths: [
          'M279.327 171.952c27.478 0 49.754-22.275 49.754-49.753s-22.275-49.754-49.754-49.754c-27.478 0-49.754 22.275-49.754 49.754s22.275 49.753 49.754 49.753zM127.791 721.189l30.568-106.010 10.406 3.252s-12.357 79.345-31.868 99.506l-9.105 3.252z',
          'M244.207 152.116s3.903 41.624-5.203 53.331c-9.105 11.706 5.853 34.469 5.853 34.469l27.315 32.518 40.323-18.211 5.853-33.819-3.902-23.414s-13.658-13.657-7.804-38.371c5.853-24.714-62.436-6.504-62.436-6.504z',
          'M244.207 152.116s3.903 41.624-5.203 53.331c-9.105 11.706 5.853 34.469 5.853 34.469l27.315 32.518 40.323-18.211 5.853-33.819-3.902-23.414s-13.658-13.657-7.804-38.371c5.853-24.714-62.436-6.504-62.436-6.504z',
          'M267.621 930.611v26.662l35.77 7.153-3.253-44.222-32.518 10.407zM374.932 920.204l-7.806 37.069 15.61 11.059 27.316-20.161-3.252-31.873-31.868 3.906z',
          'M306.642 961.172s-13.658-23.082-39.022-8.617c0 0-4.553 25.532-9.105 27.481s-29.917 39.018 0 42.272c29.917 3.254 44.875-6.501 44.875-6.501s-5.853 5.037 3.252 2.435c9.105-2.602 5.203-16.915 5.203-16.915l-5.203-40.156zM395.743 945.569s-20.161 14.306-23.413 7.805c-3.252-6.508-8.455-5.856-8.455-5.856s-18.21 68.646-6.504 71.9c7.538 1.858 15.456 1.449 22.763-1.176 0 0 15.609-10.93 15.609-2.48 0 8.457 43.575 7.851 61.785 7.198s8.455-14.306 8.455-14.306l-24.064-23.415-27.316-39.671s-12.357-11.059-18.861 0zM203.884 510.469l27.316 262.097s14.959 159.994 17.56 162.596c2.602 2.602 19.511 11.052 56.582 0l-8.455-209.421 15.609-130.074 35.771 89.751s8.454 241.286 14.308 241.286 41.624 11.704 50.078-2.602c8.455-14.306 7.154-168.444 7.154-168.444s-3.903-243.238-32.518-251.043c-28.617-7.804-183.404 5.853-183.404 5.853z',
          'M279.327 176.18c24.784 0 44.875-20.092 44.875-44.875s-20.092-44.875-44.875-44.875-44.875 20.092-44.875 44.875 20.092 44.875 44.875 44.875z',
          'M281.928 256.174s-4.553-27.966-4.553-33.168c0-5.203-20.161-8.454-20.161-8.454s-15.609-17.56-18.861-14.959c-3.252 2.602-52.68 35.77-60.484 40.323s-16.259 24.064-15.609 25.364c0.651 1.301 40.974 85.849 40.974 85.849s17.56 52.030 5.203 79.345c-12.357 27.316-27.966 81.296-5.203 92.353s133.326 35.119 153.487 14.308c20.161-20.811 34.469-26.665 39.673-26.665s-21.462-90.402-15.609-98.856c5.853-8.454-2.602-61.135-2.602-61.135l29.917-83.897s-2.601-46.826-61.785-57.232l-35.406-17.167-28.98 63.993z',
          'M160.309 522.176s-3.252 31.218-3.252 40.324c0 9.104-15.609 62.435 7.154 68.939s20.812-70.89 20.812-70.89v-39.672l-24.714 1.3zM430.212 492.91s3.903 29.917 1.952 36.42c-1.952 6.504 18.861 63.086-9.105 66.338s-20.812-67.639-20.812-67.639v-35.119h27.966z',
          'M154.456 710.783l18.861-100.157h5.853c3.938 5.037 6.7 11.176 7.771 17.881l0.030 0.225c0.297 1.816 0.466 3.909 0.466 6.041 0 4.873-0.885 9.539-2.503 13.847l0.089-0.272c-7.804 22.112-14.308 62.435-14.308 62.435h-16.26z',
          'M172.016 257.476l-9.756 7.804s-13.007 206.817-9.755 222.426c3.252 15.609-11.707 37.721 1.301 39.672s28.616 10.406 35.77 5.203c7.154-5.203 8.454-24.064 11.056-28.617s7.154-58.533 7.154-58.533 13.657-53.981 5.203-94.304c-8.455-40.323-16.26-81.296-16.26-81.296l-24.713-12.357zM378.183 241.216l29.917 25.365 22.763 132.675s14.309 103.409 3.252 104.71c-11.056 1.301-27.966-1.951-35.119 0s-13.008-3.252-13.008-3.252-7.804-41.624-7.804-42.274c0-0.651-5.203-48.127-5.203-48.127l-6.504-53.331 9.755-58.533 1.951-57.232z',
          'M237.053 855.161s-4.227 12.144-10.055 28.68c-2.706 7.684-5.756 16.331-8.897 25.145-2.022 5.696-4.077 11.461-6.1 17.097-3.226 9.004-6.361 17.658-9.098 25.084-3.617 9.8-6.55 17.484-8.124 21.064-7.154 16.263-137.878-9.755-148.284-16.263-10.406-6.501-13.007-28.611-14.308-59.832-0.007-0.159-0.013-0.326-0.013-0.485-0.169-6.303 1.437-15.686 4.123-26.7 1.34-5.499 2.953-11.408 4.748-17.537 2.406-8.23 5.138-16.854 7.993-25.441 12.266-36.872 26.724-72.916 26.724-72.916s25.365-17.56 34.47-29.267c9.105-11.707 59.183-20.811 59.183-20.811 14.308 0.65 46.826 55.934 59.834 72.841s7.804 79.341 7.804 79.341z',
          'M164.212 756.31c3.232 0 5.853-2.621 5.853-5.853s-2.621-5.853-5.853-5.853c-3.233 0-5.853 2.621-5.853 5.853s2.621 5.853 5.853 5.853zM173.317 760.21c1.795 0 3.252-1.456 3.252-3.251s-1.456-3.252-3.252-3.252c-1.796 0-3.253 1.456-3.253 3.252s1.456 3.251 3.253 3.251z',
          'M226.998 883.841c-2.706 7.684-5.756 16.331-8.897 25.145l-177.056-57.572c2.406-8.23 5.138-16.854 7.993-25.441l177.961 57.867zM212.001 926.083c-3.226 9.004-6.361 17.658-9.099 25.084l-170.728-55.516c-0.169-6.303 1.437-15.686 4.123-26.7l175.704 57.132z',
          'M164.212 751.756s13.007 57.234 5.203 107.964c-7.804 50.73 19.511 98.205 19.511 98.205',
          'M173.316 756.309s-25.364 92.352-26.014 105.36c-0.651 13.009-11.057 106.011-24.064 115.765',
          'M244.875 103.92s-10.157-26.41 4.572-35.044l4.063 11.681s37.076-22.347 46.726-17.268l-9.142 12.189s43.171 0 46.218 16.761l-15.236 0.508s16.253 10.666 16.76 27.934l-32.505 2.031 15.745 9.142s-58.916 8.126-73.137-15.237l-4.063-12.698z',
          'M236.078 104.964s11.706 23.414 27.315 17.56c15.609-5.853 0-27.316 0-27.316l-10.406-5.203-16.909 14.958z',
          'M1245.571 474.333l-212.279-265.266c-9.303 8.527-20.954 14.639-33.873 17.257l-0.458 0.077c-39.966 7.87-78.992-19.42-87.169-60.955-2.822-13.736-1.836-27.982 2.844-41.199 4.688-13.217 12.887-24.904 23.734-33.8l-72.385-90.448-412.357 352.424 379.582 474.331 412.361-352.422z',
          'M981.804 213.798c33.056 0 59.847-26.793 59.847-59.845s-26.791-59.844-59.847-59.844c-33.049 0-59.84 26.793-59.84 59.844s26.791 59.845 59.84 59.845z',
          'M607.35 420.611l-18.311 21.191 61.689 53.304 18.311-21.191-61.689-53.304zM1003.914 799.577l-18.311 21.193 54.682 47.248 18.311-21.193-54.682-47.248z',
          'M1102.711 641.741v1.643c-0.038 4.126-0.152 8.234-0.357 12.323-3.557 69.976-33.746 135.944-84.378 184.375-50.624 48.439-117.866 75.677-187.931 76.133-70.064 0.463-137.651-25.896-188.911-73.667-51.259-47.764-82.307-113.332-86.781-183.256-0.374-5.806-0.561-11.657-0.561-17.551-0.099-56.845 17.544-112.304 50.467-158.644 2.632-3.734 5.37-7.4 8.215-10.997 1.96-2.502 3.977-4.948 6.012-7.375 46.331-54.887 112.329-89.429 183.835-96.214s142.821 14.725 198.656 59.918c3.3 2.67 6.554 5.433 9.724 8.253 2.541 2.259 5.037 4.568 7.487 6.927 48.295 46.193 78.021 108.458 83.574 175.055 0.63 7.618 0.948 15.31 0.948 23.077z',
          'M828.257 950.742c-170.386 0-309.003-138.619-309.003-309.001-0.101-77.954 29.362-153.047 82.448-210.133l6.843 6.35c-51.481 55.361-80.055 128.184-79.956 203.783 0 165.232 134.429 299.664 299.668 299.664 40.148 0.137 79.902-7.858 116.88-23.514 38.353-16.48 71.006-39.293 98.157-67.448l0.087-0.090 6.705 6.501c-28.725 29.817-63.185 53.506-101.308 69.647-35.268 15.327-76.349 24.244-119.513 24.244-0.355 0-0.709-0.001-1.063-0.002l0.055 0z',
          'M873.062 944.204h-78.416v78.416h78.416v-78.416zM612.476 472.099c0.143 0.060 0.266 0.136 0.377 0.226l-0.003-0.002c1.475 1.214-0.374 3.548-0.149 5.47 0.261 2.465 3.547 3.006 6.030 3.249 2.483 0.262 5.62 2.26 4.444 4.462-6.237 2.147-12.547 0.037-18.914-2.408-32.923 46.34-50.565 101.799-50.467 158.645 0 5.9 0.187 11.749 0.561 17.55 0.489 0.361 1.050 0.67 1.65 0.899l0.049 0.016c1.867 0.709 4.033 0.579 5.75 1.587 1.363 0.803 2.278 2.222 3.641 2.969 3.903 2.128 9.317-1.961 12.958 0.579 0.941 0.857 1.833 1.767 2.67 2.725 3.36 2.913 8.887 0.953 12.77 3.137 2.502 1.4 3.79 4.201 5.134 6.74 3.342 6.347 8.756 12.584 15.908 13.087 2.255-0.103 4.515-0.028 6.758 0.225 2.203 0.504 4.369 2.427 4.014 4.649-0.616 3.827 1.27 8.009 0.766 11.837-0.916 7.002-10.829 10.064-11.67 17.065-0.003 1.628-0.097 3.23-0.279 4.807l0.018-0.195c-0.448 1.83-1.83 3.323-2.315 5.153-0.934 3.454 1.55 6.908 4.257 9.223 2.726 2.334 5.974 4.351 7.468 7.599 1.568 3.454 0.803 7.467 1.307 11.222 1.12 8.2 8.196 14.268 15.478 18.182 2.333 0.978 4.405 2.488 6.049 4.407 1.867 2.708 1.681 6.273 2.316 9.504 1.531 7.896 8.178 14.412 8.364 22.46 0.13 5.734-3.043 10.923-4.948 16.323-1.959 5.651-2.542 11.696-1.699 17.62 10.001 8.534 21.053 16.629 32.687 23.878l1.163 0.675c0.647-0.956 1.121-2.018 1.4-3.133 0.226-1.244 0.071-2.518-0.447-3.664-0.533-1.161-1.374-2.104-2.42-2.746l-0.027-0.015c2.007-0.759 3.832-1.927 5.359-3.436 0.749-0.774 1.245-1.752 1.418-2.814 0.044-0.255 0.069-0.55 0.069-0.85 0-0.827-0.191-1.61-0.53-2.307l0.014 0.031c3.286 0.41 7.188 0.614 9.353-1.904 1.737-2.018 1.625-5.037 0.934-7.6-0.948-2.488-1.575-5.082-1.867-7.729 7.613 0.372 15.244 0.114 22.815-0.766-1.096-3.686-3.587-6.811-6.946-8.7 3.435-0.576 6.554-4.688 7.637-7.987 0.936-3.375 0.988-6.925 0.149-10.323-0.145-0.469-0.229-1.009-0.229-1.568 0-0.398 0.042-0.786 0.123-1.161l-0.007 0.036c0.552-1.183 1.523-2.124 2.726-2.632 5.676-3.269 11.351-6.531 17.027-9.785 1.013-0.508 1.934-1.183 2.726-1.995 1.773-2.109 1.512-5.264 0.598-7.858s-2.371-5.044-2.726-7.767c-1.046-8.162 7.692-14.025 10.642-21.716 1.003-3.070 1.544-6.274 1.606-9.503 0.243-3.472 0.262-7.487-2.39-9.708-2.558-2.147-6.535-1.662-9.205-3.66-2.445-1.83-3.286-5.358-5.956-6.833-2.427-1.344-5.451-0.485-8.159-1.12-4.742-1.101-7.73-6.572-12.585-7.076-2.725-0.299-5.825 1.046-8.065-0.541-1.979-1.419-2.054-4.239-2.427-6.629-0.706-3.872-2.53-7.233-5.12-9.83l0 0c-2.591-2.597-5.947-4.428-9.702-5.127l-0.114-0.018c-2.819-0.448-5.881-0.28-8.29-1.83-2.427-1.569-3.529-4.5-5.451-6.684-3.062-3.491-7.917-4.742-12.453-5.806-6.161-1.437-12.317-2.882-18.465-4.332-3.267-0.784-7.487-1.195-9.261 1.681-0.493 1-0.87 2.161-1.072 3.38l-0.010 0.073c-0.667 2.155-1.997 4.044-3.801 5.398-1.72 1.303-3.885 2.102-6.234 2.145l-0.010 0c-1.546-2.607-3.991-4.542-6.899-5.394l-0.084-0.021c-2.217-0.375-4.129-0.842-5.987-1.429l0.311 0.085c-0.999-0.496-1.843-1.157-2.531-1.956l-0.009-0.010c-0.679-0.789-1.211-1.726-1.539-2.755l-0.016-0.056c-0.228-0.707-0.36-1.521-0.36-2.366 0-0.293 0.016-0.582 0.047-0.866l-0.003 0.035c0.114-1.076 0.445-2.118 0.975-3.061 1.059-1.895 1.466-4.085 1.159-6.234-0.327-2.234-1.358-4.183-2.857-5.659l-0.001-0.001c-3.136-2.819-7.673-3.51-11.893-3.23-1.102-2.408 0.746-5.115 2.725-6.871 1.998-1.736 4.406-3.454 4.836-6.068 0.691-4.107-4.555-7.226-8.532-6.012-3.977 1.233-6.516 5.097-8.197 8.906-0.815 2.247-1.927 4.377-3.305 6.33-0.704 0.956-1.642 1.701-2.73 2.157l-0.043 0.016c-0.729 0.307-1.576 0.486-2.464 0.486-0.366 0-0.725-0.030-1.074-0.088l0.038 0.005c-3.286-0.84-4.537-4.742-5.265-8.028-1.115-4.033-1.755-8.664-1.755-13.444 0-0.006 0-0.012 0-0.018l-0 0.001c0.029-4.589 1.852-8.985 5.079-12.248 5.433-5.004 13.797-4.518 21.135-3.715-0.672-0.888-1.076-2.012-1.076-3.229 0-0.149 0.006-0.297 0.018-0.444l-0.001 0.019c0.11-1.358 0.709-2.558 1.618-3.44l0.001-0.001c0.982-0.872 2.162-1.491 3.437-1.803 0.576-0.147 1.238-0.232 1.92-0.232 0.697 0 1.373 0.088 2.018 0.255l-0.056-0.012c2.212 0.458 4.205 1.649 5.657 3.379 2.091 2.54 2.689 5.994 4.257 8.869 1.587 2.895 5.134 5.359 8.029 3.809 2.52-1.345 2.912-4.817 2.296-7.6-0.635-2.763-1.96-5.47-1.736-8.308 0.429-5.396 6.049-8.663 10.997-10.885s10.605-5.228 11.389-10.606c0.040-1.109 0.256-2.156 0.62-3.13l-0.022 0.068c0.554-0.879 1.304-1.587 2.191-2.076l0.031-0.016c14.432-9.541 29.126-19.213 45.631-24.421 0.859-0.28 0.952 0.018 1.83-0.187 1.233-0.71 0.411-2.67-0.765-3.454s-2.744-1.4-3.043-2.782c-0.206-1.008 0.392-2.016 0.542-3.043 0.005-0.071 0.007-0.153 0.007-0.237 0-0.569-0.125-1.109-0.349-1.594l0.010 0.024c-0.266-0.579-0.653-1.062-1.131-1.433l-0.009-0.006c-0.469-0.365-1.038-0.625-1.66-0.734l-0.023-0.003c-0.192-0.035-0.413-0.054-0.639-0.054-0.426 0-0.836 0.070-1.218 0.2l0.027-0.008c-1.326-1.755 1.288-3.79 3.416-4.388 5.732-1.638 12.398-2.771 19.264-3.162l0.247-0.011c0.17-0.030 0.367-0.047 0.567-0.047 0.607 0 1.177 0.155 1.674 0.429l-0.018-0.009c0.469 0.454 0.77 1.078 0.804 1.772l0 0.006c0.002 0.036 0.003 0.079 0.003 0.121 0 0.66-0.242 1.263-0.642 1.726l0.003-0.003c-0.895 0.992-1.866 1.88-2.916 2.669l-0.052 0.038c-1.526 1.484-2.473 3.557-2.473 5.851 0 0.836 0.126 1.644 0.36 2.403l-0.015-0.058c3.454 1.755 7.188 3.567 11.016 2.95 3.809-0.616 7.188-4.91 5.395-8.327-1.661-3.193-6.684-3.921-7.543-7.412-1.008-4.088 4.779-7.729 3.472-11.725-0.56-1.755-2.315-2.8-3.659-4.051-1.536-1.513-2.63-3.47-3.075-5.663l-0.012-0.071c-0.133-0.643-0.209-1.382-0.209-2.139 0-1.568 0.327-3.059 0.916-4.409l-0.028 0.071c-2.186 0.382-4.431 0.235-6.549-0.427-2.204-0.703-4.090-1.866-5.626-3.384l0.001 0.001c-2.913-2.931-5.228-7.58-9.373-7.43-3.79 0.112-7.057 4.537-10.605 3.193-0.878-0.336-1.792-1.008-2.632-0.616-0.279 0.18-0.507 0.414-0.677 0.688l-0.005 0.009c-0.164 0.265-0.274 0.58-0.307 0.917l-0.001 0.009c-0.896 4.313 0.653 9.224-1.699 12.958-2.558 4.051-8.476 4.611-11.576 8.271-1.68 1.979-2.334 4.649-3.884 6.74s-4.817 3.435-6.684 1.606c0.915-1.874 1.165-4.004 0.71-6.039-0.479-2.099-1.623-3.878-3.194-5.15l-0.017-0.014c-1.59-1.059-3.418-1.969-5.357-2.638l-0.169-0.051c-2.364-1.008-4.396-2.158-6.28-3.503l0.1 0.068c-0.962-0.593-1.731-1.415-2.243-2.394l-0.016-0.034c-0.172-0.514-0.272-1.105-0.272-1.72 0-0.767 0.155-1.498 0.435-2.163l-0.014 0.037c0.945-2.697 2.608-5.084 4.808-6.907 2.11-1.757 4.723-2.98 7.594-3.426l0.088-0.011c2.464-0.336 5.34-0.224 6.983-2.109 0.859-0.99 1.307-2.502 2.577-2.894 0.231-0.051 0.497-0.080 0.769-0.080 0.582 0 1.133 0.133 1.625 0.369l-0.022-0.010c3.080 1.082 6.142 2.166 9.223 3.249 0.774 0.363 1.68 0.575 2.636 0.575 0.229 0 0.456-0.012 0.678-0.036l-0.028 0.002c0.576-0.077 1.073-0.365 1.42-0.783l0.003-0.004c0.314-0.379 0.504-0.87 0.504-1.406 0-0.050-0.002-0.099-0.005-0.148l0 0.007c-0.299-1.531-2.651-2.26-2.427-3.809 0.116-0.524 0.387-0.972 0.763-1.305l0.003-0.002c3.33-3.542 7.402-6.304 11.924-8.089 3.589-1.458 7.752-2.304 12.113-2.304 0.746 0 1.486 0.025 2.22 0.073l-0.1-0.005c1.157 1.924-0.672 4.182-2.222 5.807-1.531 1.643-2.763 4.556-0.896 5.806 0.662 0.354 1.448 0.562 2.283 0.562 0.057 0 0.114-0.001 0.171-0.003l-0.008 0c2.27 0.305 4.477 0.973 6.535 1.979 3.193 1.382 6.33 2.913 9.392 4.556-0.184-0.782-0.29-1.679-0.29-2.602 0-1.23 0.188-2.416 0.536-3.531l-0.023 0.084c0.349-0.976 1.027-1.763 1.898-2.243l0.021-0.011c0.566-0.313 1.24-0.497 1.958-0.497 0.347 0 0.684 0.043 1.006 0.124l-0.028-0.006c1.83 0.709 2.763 3.136 4.723 3.36 2.596 0.299 3.622-3.548 2.54-5.937s-3.249-4.369-3.417-7.002c-0.13-1.755 0.542-3.939-0.859-5.004-0.471-0.316-1.036-0.529-1.645-0.596l-0.016-0.001c-11.725-2.147-23.456-4.301-35.194-6.46-2.091-0.392-5.097-0.093-5.191 2.017-0.056 1.195 1.008 2.371 0.542 3.454-0.504 1.157-2.147 1.064-3.342 1.475-0.906 0.418-1.632 1.096-2.098 1.938l-0.012 0.023c-0.348 0.627-0.553 1.374-0.553 2.17 0 0.235 0.018 0.466 0.052 0.692l-0.003-0.025c0.319 1.941 1.072 3.786 2.203 5.395-2.296-0.952-5.75-1.12-8.047-2.090-0.369-2.882-1.077-5.498-2.091-7.955l0.075 0.206c-0.062-0.418-0.211-0.792-0.427-1.118l0.006 0.010c-0.222-0.335-0.506-0.612-0.837-0.819l-0.011-0.007c-0.32-0.201-0.699-0.339-1.106-0.388l-0.013-0.001c-0.096-0.012-0.207-0.019-0.32-0.019-0.307 0-0.602 0.051-0.877 0.144l0.019-0.006c-3.025 0.466-6.050 0.915-9.074 1.381-0.794 0.039-1.511 0.336-2.078 0.808l0.006-0.005c-1.176 1.251-0.019 3.249-0.056 4.966-0.117 1.003-0.537 1.89-1.165 2.587l0.004-0.004c-0.631 0.701-1.466 1.207-2.411 1.426l-0.031 0.006c-1.9 0.385-3.861 0.36-5.75-0.075-4.239-0.653-8.458-1.307-12.696-1.96 3.857-1.253 7.107-3.48 9.572-6.393l0.025-0.031c1.68-1.979 2.577-5.676 0.149-6.609-0.46-0.132-0.989-0.207-1.535-0.207-0.236 0-0.468 0.014-0.696 0.041l0.028-0.003c-5.75 0.037-10.288-4.761-15.665-6.796-1.569-0.603-3.383-0.958-5.278-0.971l-0.006-0-6.012 7.375zM1102.355 655.706c-0.652 0.884-1.525 1.593-2.518 2.065-0.845 0.41-1.838 0.649-2.887 0.649-0.108 0-0.215-0.003-0.322-0.008l0.015 0.001c-5.841-0.504-8.306-8.925-14.093-9.877-0.516-0.13-1.054-0.078-1.532 0.149-0.857 0.467-1.009 1.625-1.062 2.596-0.243 4.817-0.448 9.821 1.434 14.264 2.746 6.497 9.861 11.95 8.366 18.839-8.033-3.716-12.212-12.734-14.101-21.378-1.904-8.645-2.2-17.718-5.598-25.897-2.594 3.305-8.010 0.579-10.361-2.894-2.238-3.286-3.626-7.095-5.787-10.437-2.169-3.323-5.492-6.31-9.451-6.497-4.164-0.187-7.782 2.669-10.961 5.376-2.761 2.040-5.074 4.619-6.811 7.581-2.222 4.481-1.646 9.746-1.752 14.731-0.114 5.377-1.252 11.072-4.93 15.030-3.679 3.939-10.46 5.321-14.51 1.755-1.899-1.98-3.308-4.443-4.025-7.187l-0.025-0.114c-3.731-10.295-7.509-23.406-10.528-36.805l-0.448-2.366c-0.675 3.024-3.345 6.927-5.886 5.153-0.561-0.482-1.024-1.081-1.343-1.754-4.741-8.010-13.494-12.827-22.369-15.721-8.844-2.876-18.167-4.22-26.92-7.393-5.352-1.968-9.966-4.315-14.249-7.126l0.262 0.161c-1.107 1.64-1.76 3.55-1.881 5.528-0.114 1.977 0.303 3.951 1.214 5.712 0.978 1.723 2.511 3.072 4.339 3.839s3.861 0.907 5.78 0.4c1.942-0.635 3.58-1.979 5.507-2.651 1.919-0.654 4.521-0.336 5.355 1.531 0.827 1.773-0.41 3.921 0.205 5.788 0.918 2.819 5.196 3.043 6.69 5.62 0.44 1.020 0.539 2.154 0.288 3.236-0.258 1.082-0.85 2.055-1.691 2.776-1.722 1.4-3.611 2.568-5.636 3.472-6.273 3.491-10.741 9.447-16.225 14.077-5.492 4.649-13.244 8.029-19.775 5.060 1.547-7.898-7.843-13.686-9.58-21.546-0.576-2.596-0.281-5.34-1.085-7.861-1.176-3.66-4.422-6.161-7.069-8.925-3.129-3.288-5.635-7.203-7.307-11.532l-0.081-0.24c-1.427-3.683-2.255-7.945-2.255-12.4 0-0.462 0.009-0.922 0.027-1.38l-0.002 0.066c0.152-3.249 0.743-6.554 0-9.727-0.728-3.155-3.36-6.218-6.607-6.087-7.418 0.336-16.771 0.897-20.654-5.433-1.396-2.26-1.995-5.564 0.023-7.301 0.789-0.499 1.661-0.837 2.587-0.994 0.356-0.064 0.767-0.1 1.186-0.1 0.561 0 1.107 0.066 1.631 0.19l-0.048-0.010c5.583 0.542 11.15 1.101 16.733 1.643 3.899 0.373 8.116 0.691 11.476-1.344s4.817-7.468 1.699-9.877c-2.253-1.755-6.326-1.662-7.001-4.444-0.539-2.333 2.040-4.966 0.637-6.927-0.986-1.381-3.231-1.008-4.597 0.038-1.183 1.235-2.48 2.365-3.861 3.379-2.67 1.381-5.841 0.056-8.723-0.84-2.875-0.896-6.72-0.971-8.101 1.699-1.57 2.969 1.365 6.89-0.167 9.877-2.056 3.94-8.966 1.699-11.84 5.097-3.284 3.884 2.245 9.709 1.145 14.675-1.418 0.704-2.996 1.027-4.581 0.938-1.578-0.088-3.11-0.585-4.437-1.442-1.312-0.889-2.351-2.116-3.011-3.549-0.667-1.434-0.933-3.020-0.766-4.591 0.265-2.241 1.441-4.537 0.66-6.647-0.85-1.629-2.245-2.906-3.944-3.604-5.416-3.006-10.824-5.999-16.24-8.981-1.517 2.801 0.387 6.255 2.784 8.365 2.367 2.091 5.355 3.678 6.925 6.441 0.994 1.915 1.214 4.137 0.622 6.212-0.584 2.075-1.949 3.846-3.8 4.952-0.222 0.154-0.485 0.266-0.769 0.317l-0.012 0.002c-0.101 0.018-0.216 0.029-0.334 0.029-0.181 0-0.355-0.024-0.521-0.070l0.014 0.003c-0.258-0.152-0.485-0.354-0.66-0.595-0.182-0.24-0.311-0.514-0.387-0.806-2.852-7.337-7.168-14.563-14.040-18.39-6.887-3.846-16.763-3.043-21.284 3.398-1.062 1.531-1.79 3.286-2.723 4.911-4.946 8.607-15.588 12.677-25.524 12.415-0.094 0.006-0.205 0.010-0.316 0.010-0.908 0-1.759-0.246-2.489-0.676l0.023 0.013c-1.606-1.102-1.531-3.454-1.289-5.396 0.355-2.744 0.691-5.47 1.046-8.215 0.009-1.746 0.697-3.33 1.813-4.503l-0.003 0.003c1.849-1.456 4.5-0.541 6.852-0.579 1.776-0.079 3.486-0.704 4.889-1.79 1.411-1.086 2.442-2.58 2.973-4.277 0.47-1.713 0.47-3.523-0.015-5.235-0.478-1.71-1.418-3.258-2.715-4.475-1.062-1.008-2.503-2.278-1.942-3.641 0.228-0.375 0.539-0.696 0.903-0.941s0.774-0.408 1.206-0.477c4.202-1.214 8.67-1.531 12.796-2.988 4.142-1.437 8.154-4.387 9.148-8.663 0.296-1.307 0.425-2.894 1.6-3.548 0.599-0.238 1.229-0.365 1.866-0.373 2.245-0.322 4.293-1.472 5.734-3.223s2.169-3.978 2.056-6.243c1.98-1.381 4.763-0.354 6.683 1.12 1.904 1.475 3.603 3.417 5.939 4.052 4.346 1.195 8.549-2.67 13.069-2.689 1.904 0 3.861 0.672 5.636 0.019 1.813-0.654 2.898-2.446 4.278-3.771 1.403-1.345 3.831-2.147 5.112-0.71-0.372-2.707-0.728-5.395-1.1-8.084 2.2 0.554 4.49 0.63 6.728 0.225 2.23-0.406 4.346-1.285 6.212-2.577-4.703-1.588-9.39-3.174-14.093-4.761-0.501-0.122-0.956-0.366-1.327-0.709-1.032-1.102 0-2.819 0.819-4.070 1.995-3.006 2.336-7.954-0.948-9.447-2.245-1.027-4.801 0.205-6.948 1.4-3.436 1.904-6.872 3.827-10.308 5.731-0.319 1.961 2.071 3.081 3.55 4.388 0.895 0.797 1.532 1.848 1.82 3.014 0.296 1.166 0.228 2.392-0.197 3.518-0.435 1.151-1.181 2.101-2.136 2.775l-0.019 0.012c-0.986 0.691-2.154 1.067-3.353 1.080 0.675 0.884 1.145 1.907 1.373 2.995 0.235 1.089 0.212 2.216-0.046 3.297-2.298 0.168-4.612 0.336-6.933 0.504-0.174 0.036-0.374 0.057-0.578 0.057-0.206 0-0.407-0.021-0.601-0.061l0.019 0.003c-0.408-0.083-0.77-0.239-1.087-0.454l0.010 0.007c-0.743-0.653-0.637-1.811-0.819-2.781-0.311-1.161-0.956-2.203-1.866-2.992-0.903-0.788-2.025-1.288-3.216-1.434-2.374-0.268-4.786-0.046-7.077 0.653-0.994 0.351-2.086 0.325-3.057-0.074-0.554-0.367-0.978-0.904-1.198-1.531-0.402-1.28-0.478-2.643-0.197-3.958 0.273-1.315 0.88-2.537 1.767-3.548 1.79-1.991 3.77-3.81 5.901-5.433 4.725-4.151 8.281-9.524 10.182-15.627l0.065-0.243c3.808-1.606 7.752-3.771 11.575-5.377 3.080-1.426 6.303-2.509 9.618-3.23 3.118-0.476 6.281-0.627 9.428-0.448 4.293 0.074 8.609 0.149 12.902 0.243 3.831-0.161 7.661 0.39 11.294 1.624 3.527 1.456 6.645 4.612 6.887 8.421 0.076 0.434 0.038 0.879-0.114 1.295-0.152 0.429-0.403 0.792-0.725 1.074l-0.003 0.003c-0.421 0.238-0.924 0.378-1.459 0.378-0.058 0-0.115-0.002-0.172-0.005l0.008 0c-3.565 0.112-5.074 1.008-8.64 1.139 2.253 2.409 4.794 4.948 8.078 5.377 5.787 0.747 9.952-5.246 12.622-10.455 0.099 1.326 0.705 2.562 1.699 3.444s2.298 1.342 3.626 1.28c1.426-0.246 2.799-0.78 4.013-1.569 11.484-6.276 24.348-9.599 37.433-9.671-0.129-0.991 0.121-1.994 0.69-2.815s1.418-1.402 2.389-1.629c2.67-0.523 5.067 1.774 6.349 4.164 1.274 2.389 2.078 5.153 4.126 6.945 2.040 1.792 5.977 1.699 6.781-0.878 0.781-2.483-1.813-4.612-3.959-6.086-2.162-1.456-4.422-4.164-2.966-6.329 10.976-2.446 22.050-4.873 33.307-5.359 1.911 0.058 3.815-0.272 5.598-0.971 0.887-0.374 1.623-1.028 2.094-1.862s0.652-1.8 0.523-2.75c-2.458 0.573-5.029 0.404-7.388-0.487s-4.407-2.463-5.871-4.516c11.56-0.953 23.658-1.792 34.77 0.803l9.724 8.253c-1.851 1.923-4.316 3.734-2.966 5.657 0.44 0.441 0.978 0.777 1.57 0.981s1.221 0.271 1.843 0.196c2.351 0.037 4.703 0.093 7.039 0.093 48.295 46.194 78.021 108.459 83.574 175.056-3.922-0.149-7.525 4.817-7.024 9.148 0.599 5.022 4.217 9.055 6.819 13.387 0.425 0.704 0.812 1.434 1.153 2.185l-0.357 12.322z',
          'M0 1022.392h1425.34M588.036 128.449c13.081 0 23.685-10.603 23.685-23.684s-10.604-23.685-23.685-23.685c-13.080 0-23.684 10.604-23.684 23.685s10.604 23.684 23.684 23.684zM1287.866 579.485c13.077 0 23.681-10.604 23.681-23.684s-10.604-23.685-23.681-23.685c-13.084 0-23.681 10.604-23.681 23.685s10.597 23.684 23.681 23.684zM1126.18 343.535c13.077 0 23.681-10.604 23.681-23.685s-10.604-23.684-23.681-23.684c-13.084 0-23.689 10.604-23.689 23.684s10.604 23.685 23.689 23.685z',
          'M970.782 546.51c14.685 0 26.578-11.9 26.578-26.579s-11.894-26.579-26.578-26.579c-14.677 0-26.578 11.9-26.578 26.579s11.901 26.579 26.578 26.579z',
          'M1056.161 469.535c19.35 0 35.036-15.686 35.036-35.036s-15.686-35.036-35.036-35.036c-19.35 0-35.036 15.686-35.036 35.036s15.686 35.036 35.036 35.036z',
          'M1091.592 398.178c-9.398-9.174-22.065-14.236-35.203-14.074-13.13 0.163-25.668 5.537-34.839 14.941-19.107 19.583-46.376 118.475-46.376 118.475s98.183-29.714 117.29-49.297c9.17-9.403 14.237-22.066 14.071-35.202-0.159-13.137-5.537-25.67-14.943-34.843zM1040.134 450.931c-3.254-3.171-5.484-7.233-6.425-11.675s-0.546-9.062 1.138-13.277c1.684-4.216 4.581-7.837 8.329-10.406 3.739-2.569 8.162-3.97 12.705-4.026 4.536-0.056 8.988 1.235 12.796 3.711s6.796 6.023 8.579 10.196c1.79 4.173 2.306 8.782 1.472 13.245-0.827 4.464-2.966 8.58-6.136 11.831-4.248 4.358-10.058 6.848-16.141 6.924-6.091 0.075-11.962-2.271-16.316-6.522z',
        ],
        attrs: [
          {
            fill: 'rgb(47, 46, 65)',
          },
          {
            fill: 'rgb(255, 185, 185)',
          },
          {
            fill: 'rgb(0, 0, 0)',
            opacity: 0.1,
          },
          {
            fill: 'rgb(255, 185, 185)',
          },
          {
            fill: 'rgb(47, 46, 65)',
          },
          {
            fill: 'rgb(255, 185, 185)',
          },
          {
            fill: 'rgb(87, 90, 137)',
          },
          {
            fill: 'rgb(255, 185, 185)',
          },
          {
            fill: 'rgb(47, 46, 65)',
          },
          {
            fill: 'rgb(87, 90, 137)',
          },
          {
            fill: 'rgb(63, 61, 86)',
          },
          {
            fill: 'rgb(47, 46, 65)',
          },
          {
            fill: 'rgb(242, 242, 242)',
          },
          {
            fill: 'none',
            stroke: 'rgb(47, 46, 65)',
            strokeLinejoin: 'miter',
            strokeLinecap: 'butt',
            strokeMiterlimit: '10',
            strokeWidth: 22.755555555555556,
          },
          {
            fill: 'none',
            stroke: 'rgb(47, 46, 65)',
            strokeLinejoin: 'miter',
            strokeLinecap: 'butt',
            strokeMiterlimit: '10',
            strokeWidth: 22.755555555555556,
          },
          {
            fill: 'rgb(47, 46, 65)',
          },
          {
            fill: 'rgb(47, 46, 65)',
          },
          {
            fill: 'rgb(242, 242, 242)',
          },
          {
            fill: 'rgb(242, 242, 242)',
          },
          {
            fill: 'rgb(225, 112, 0)',
          },
          {
            fill: 'rgb(63, 61, 86)',
          },
          {
            fill: 'rgb(225, 112, 0)',
          },
          {
            fill: 'rgb(225, 112, 0)',
          },
          {
            fill: 'none',
            stroke: 'rgb(63, 61, 86)',
            strokeLinejoin: 'miter',
            strokeLinecap: 'butt',
            strokeMiterlimit: '10',
            strokeWidth: 15.170370370370371,
          },
          {
            fill: 'rgb(63, 61, 86)',
          },
          {
            fill: 'rgb(255, 255, 255)',
          },
          {
            fill: 'rgb(87, 184, 148)',
          },
        ],
        width: 1426,
        isMulticolor: true,
        isMulticolor2: true,
        grid: 16,
        tags: ['Live'],
      },
      attrs: [
        {
          fill: 'rgb(47, 46, 65)',
        },
        {
          fill: 'rgb(255, 185, 185)',
        },
        {
          fill: 'rgb(0, 0, 0)',
          opacity: 0.1,
        },
        {
          fill: 'rgb(255, 185, 185)',
        },
        {
          fill: 'rgb(47, 46, 65)',
        },
        {
          fill: 'rgb(255, 185, 185)',
        },
        {
          fill: 'rgb(87, 90, 137)',
        },
        {
          fill: 'rgb(255, 185, 185)',
        },
        {
          fill: 'rgb(47, 46, 65)',
        },
        {
          fill: 'rgb(87, 90, 137)',
        },
        {
          fill: 'rgb(63, 61, 86)',
        },
        {
          fill: 'rgb(47, 46, 65)',
        },
        {
          fill: 'rgb(242, 242, 242)',
        },
        {
          fill: 'none',
          stroke: 'rgb(47, 46, 65)',
          strokeLinejoin: 'miter',
          strokeLinecap: 'butt',
          strokeMiterlimit: '10',
          strokeWidth: 22.755555555555556,
        },
        {
          fill: 'none',
          stroke: 'rgb(47, 46, 65)',
          strokeLinejoin: 'miter',
          strokeLinecap: 'butt',
          strokeMiterlimit: '10',
          strokeWidth: 22.755555555555556,
        },
        {
          fill: 'rgb(47, 46, 65)',
        },
        {
          fill: 'rgb(47, 46, 65)',
        },
        {
          fill: 'rgb(242, 242, 242)',
        },
        {
          fill: 'rgb(242, 242, 242)',
        },
        {
          fill: 'rgb(225, 112, 0)',
        },
        {
          fill: 'rgb(63, 61, 86)',
        },
        {
          fill: 'rgb(225, 112, 0)',
        },
        {
          fill: 'rgb(225, 112, 0)',
        },
        {
          fill: 'none',
          stroke: 'rgb(63, 61, 86)',
          strokeLinejoin: 'miter',
          strokeLinecap: 'butt',
          strokeMiterlimit: '10',
          strokeWidth: 15.170370370370371,
        },
        {
          fill: 'rgb(63, 61, 86)',
        },
        {
          fill: 'rgb(255, 255, 255)',
        },
        {
          fill: 'rgb(87, 184, 148)',
        },
      ],
      properties: {
        order: 10,
        id: 498,
        name: 'Live',
        prevSize: 32,
      },
      setIdx: 0,
      setId: 1,
      iconIdx: 0,
    },
    {
      icon: {
        paths: [
          'M122.136 960.855l100.408-144.272-100.459 159.963-0.059 16.415c-7.161-0.062-14.249-0.293-21.264-0.699-0.032-3.728 8.502-208.79 8.14-212.499 0.496-0.144 0.774-19.394 0.97-20.236l-104.896-157.652 105.009 142.729 0.313 4.221 6.23-159.321-90.17-163.149 90.883 135.156c0.034-2.168 4.301-329.287 4.343-331.305 0.026 1.072 1.985 260.322 1.999 261.415l86.236-104.352-86.319 126.775-0.441 142.59 80.027-137.887c-99.872 201.087-77.77 130.719-80.321 238.139l116.244-191.999-116.344 219.654-0.529 176.315z',
          'M1658.212 980.436l41.847-60.116-41.865 66.66-0.025 6.837c-2.985-0.025-5.938-0.119-8.86-0.287-0.012-1.555 3.54-87.009 3.39-88.557 0.206-0.056 0.325-8.080 0.406-8.429l-43.714-65.698 43.757 59.479 0.131 1.755 2.597-66.391-37.576-67.99 37.876 56.326c0.012-0.905 1.792-137.222 1.804-138.065 0.012 0.45 0.83 108.482 0.837 108.937l35.934-43.483-35.971 52.83-0.181 59.417 33.349-57.456c-41.622 83.793-32.406 54.472-33.474 99.234l48.446-80.009-48.484 91.536-0.225 73.472z',
          'M852.898 1024c468.586 0 848.453-14.885 848.453-33.243s-379.867-33.243-848.453-33.243c-468.587 0-848.453 14.885-848.453 33.243s379.866 33.243 848.453 33.243z',
          'M1264.459 392.617h-968.755v577.567h968.755v-577.567z',
          'M535.456 392.617c-0.99 60.777-25.827 118.73-69.155 161.362s-101.676 66.528-162.46 66.534c-2.723 0-5.43-0.047-8.136-0.143v-227.753h239.751z',
          'M827.473 970.184h-92.135c3.465-9.428 9.74-17.57 17.976-23.315 8.242-5.751 18.045-8.835 28.091-8.835s19.849 3.084 28.085 8.835c8.242 5.744 14.517 13.886 17.982 23.315z',
          'M1264.465 671.432v194.548c-24.976-1.224-48.528-12.001-65.773-30.114-17.246-18.107-26.861-42.153-26.861-67.159s9.616-49.052 26.861-67.159c17.246-18.107 40.798-28.891 65.773-30.114z',
          'M1086.495 602.489h-611.142c-15.763 0-28.542 12.779-28.542 28.545v0c0 15.76 12.779 28.541 28.542 28.541h611.142c15.76 0 28.541-12.781 28.541-28.541 0-15.766-12.781-28.545-28.541-28.545z',
          'M1086.495 714.977h-611.142c-15.763 0-28.542 12.781-28.542 28.547v0c0 15.76 12.779 28.541 28.542 28.541h611.142c15.76 0 28.541-12.781 28.541-28.541 0-15.766-12.781-28.547-28.541-28.547z',
          'M1086.495 827.467h-177.196c-15.766 0-28.541 12.781-28.541 28.547 0 15.76 12.775 28.541 28.541 28.541h177.196c15.766 0 28.541-12.781 28.541-28.541 0-15.766-12.775-28.547-28.541-28.547z',
          'M1418.090 177.478c0 0 26.636 10.36 28.116 44.399s-7.399 128.754-7.399 128.754c0 0 32.562 47.358 7.399 60.677-25.157 13.319-28.116-53.277-28.116-53.277l-29.602-140.594c0 0 17.764-41.438 29.602-39.958z',
          'M1145.781 286.993c0 0-63.638 41.438-66.597 8.879s19.244-159.833 19.244-159.833c0 0 2.96-54.758 34.036-41.438 31.082 13.319-8.879 59.197-8.879 59.197l4.439 103.596 29.602-1.48-11.845 31.079z',
          'M1247.894 325.472c0 0-195.347-72.517-184.988 11.84s60.678 190.912 60.678 190.912l17.758 28.119h36.995l-23.677-152.434c0 0 84.355 47.358 109.518 39.958 0 0 32.556 217.55 44.394 233.828 11.838 16.284 32.562 213.111 32.562 213.111l19.237 23.683h36.995v-332.988c0 0 63.638-207.191 14.804-217.55-48.84-10.36-164.277-38.479-164.277-38.479z',
          'M1136.902 537.102c0 0-8.879-16.279-23.677 0-14.804 16.279-50.32 35.518-50.32 35.518s-76.956 17.759-14.798 32.559c62.158 14.799 69.557 0 69.557 0s10.359 2.96 19.237 5.919c8.879 2.96 66.597-7.4 66.597-16.279s-19.593-61.946-27.554-53.912c-7.967 8.035-39.043-3.805-39.043-3.805z',
          'M1363.206 899.84c0 0-21.822-17.976-26.955-12.837-5.132 5.132-32.087 39.792-32.087 39.792s-71.88 55.19-6.419 64.175c65.461 8.985 61.609-15.404 61.609-15.404h20.542c2.566 0 37.22-15.404 35.94-21.816-1.286-6.419-16.69-58.755-21.822-55.052-5.132 3.709-30.807 1.143-30.807 1.143z',
          'M1165.019 121.241c27.792 0 50.32-22.528 50.32-50.318s-22.528-50.318-50.32-50.318c-27.792 0-50.32 22.528-50.32 50.318s22.528 50.318 50.32 50.318z',
          'M1200.54 65.003c0 0 38.475 32.558 65.118 32.558 26.636 0-38.481 60.678-38.481 60.678l-57.719-51.798 31.082-41.438z',
          'M1215.338 158.239l-1.155-11.66c0 0 29.271-51.977 38.156-56.417 8.879-4.44 14.798-4.44 14.798-4.44s29.596-31.078 62.158-14.799c32.556 16.28 109.512 119.875 109.512 119.875s-54.759 4.44-47.354 47.358c0 0 54.753 140.594 39.955 142.074s-59.198-8.879-105.072 11.84c-45.88 20.719-66.597 7.4-66.597 7.4l-23.683-76.957c0 0-44.394-25.159-42.914-47.358l-64.381 28.859 5.919-54.758 39.218-45.138c0 0-7.399-5.92 41.441-45.878z',
          'M1118.739 76.363c-2.004 2.222-4.508 3.929-7.312 4.976-2.866 0.808-6.475-0.183-7.618-2.933l2.129-2.769-6.381-3.964 2.785-3.261-5.139-5.579 4.052-3.217-7.717-5.521c10.003-16.327 20.823-32.859 36.62-43.683s37.876-14.669 54.053-4.432c8.404 5.315 14.348 13.751 19.106 22.48 9.572 17.555 18.007 34.667 19.25 54.624-6.007-5.855-14.786-9.154-20.798-15.009-2.66-2.825-5.682-5.294-8.972-7.346-6.288-3.546-13.818-3.86-20.855-5.459-5.919-1.345-9.759-4.013-14.236-7.828-5.332-4.538-5.545-2.783-10.927 2.326-9.341 8.871-18.688 17.736-28.041 26.595z',
        ],
        attrs: [
          {
            fill: 'rgb(208, 205, 225)',
          },
          {
            fill: 'rgb(208, 205, 225)',
          },
          {
            fill: 'rgb(208, 205, 225)',
          },
          {
            fill: 'rgb(63, 61, 86)',
          },
          {
            fill: 'rgb(225, 112, 0)',
          },
          {
            fill: 'rgb(225, 112, 0)',
          },
          {
            fill: 'rgb(225, 112, 0)',
          },
          {
            fill: 'rgb(255, 255, 255)',
          },
          {
            fill: 'rgb(255, 255, 255)',
          },
          {
            fill: 'rgb(255, 255, 255)',
          },
          {
            fill: 'rgb(160, 97, 106)',
          },
          {
            fill: 'rgb(160, 97, 106)',
          },
          {
            fill: 'rgb(47, 46, 65)',
          },
          {
            fill: 'rgb(47, 46, 65)',
          },
          {
            fill: 'rgb(47, 46, 65)',
          },
          {
            fill: 'rgb(160, 97, 106)',
          },
          {
            fill: 'rgb(160, 97, 106)',
          },
          {
            fill: 'rgb(87, 90, 137)',
          },
          {
            fill: 'rgb(47, 46, 65)',
          },
        ],
        width: 1711,
        isMulticolor: true,
        isMulticolor2: false,
        grid: 16,
        tags: ['about_you'],
      },
      attrs: [
        {
          fill: 'rgb(208, 205, 225)',
        },
        {
          fill: 'rgb(208, 205, 225)',
        },
        {
          fill: 'rgb(208, 205, 225)',
        },
        {
          fill: 'rgb(63, 61, 86)',
        },
        {
          fill: 'rgb(225, 112, 0)',
        },
        {
          fill: 'rgb(225, 112, 0)',
        },
        {
          fill: 'rgb(225, 112, 0)',
        },
        {
          fill: 'rgb(255, 255, 255)',
        },
        {
          fill: 'rgb(255, 255, 255)',
        },
        {
          fill: 'rgb(255, 255, 255)',
        },
        {
          fill: 'rgb(160, 97, 106)',
        },
        {
          fill: 'rgb(160, 97, 106)',
        },
        {
          fill: 'rgb(47, 46, 65)',
        },
        {
          fill: 'rgb(47, 46, 65)',
        },
        {
          fill: 'rgb(47, 46, 65)',
        },
        {
          fill: 'rgb(160, 97, 106)',
        },
        {
          fill: 'rgb(160, 97, 106)',
        },
        {
          fill: 'rgb(87, 90, 137)',
        },
        {
          fill: 'rgb(47, 46, 65)',
        },
      ],
      properties: {
        order: 9,
        id: 497,
        name: 'about_you',
        prevSize: 32,
      },
      setIdx: 0,
      setId: 1,
      iconIdx: 0,
    },
    {
      icon: {
        paths: [
          'M575.958 1012.634c81.467 0 147.509-15.071 147.509-33.663 0-18.591-66.041-33.663-147.509-33.663s-147.51 15.072-147.51 33.663c0 18.592 66.043 33.663 147.51 33.663zM343.847 67.451c36.244-32.261 93.135-38.887 144.928-36.306 162.66 8.103 309.461 86.609 436.496 175.428 45.911 32.161 91.25 66.817 121.092 111.091 60.801 90.145 42.734 215.022-41.753 289.284-28.738 25.264-63.58 44.67-99.353 61.806-63.605 30.523-132.234 55.043-204.425 62.040-51.47 4.964-103.584 0.931-154.768-6.018-142.979-19.381-283.329-62.264-400.971-135.634-51.643-32.2-100.221-72.178-121.489-124.293s-7.656-117.978 45.029-148.787c21.789-12.744 47.834-18.5 73.344-23.897 37.548-7.954 75.691-15.796 109.565-31.976 34.991-16.702 76.434-49 69.486-85.965-7.421-39.668-13.376-74.511 22.818-106.772z',
          'M296.151 253.537l-60.155 23.266c-1.352-2.483-3.339-5.931-5.795-9.928-8.462-14.021-22.472-35.835-34.929-55.005-14.034-21.652-26.132-39.856-26.132-39.856l8.76-2.481 71.458-20.722 46.792 104.725z',
          'M296.147 253.537l-24.432 9.455c-13.649 2.841-27.578 4.122-41.518 3.822-8.462-14.021-22.472-35.835-34.929-55.006l-17.371-42.361 71.458-20.722 46.792 104.812z',
          'M314.314 247.704s-37.968 22.46-94.662 17.373l-45.19-110.173 96.536-16.577 43.317 109.378z',
          'M313.482 245.521c-9.9 0.542-19.828 0.26-29.68-0.844-11.267-1.327-22.596-4.045-32.261-9.057-8.043-4.044-14.974-8.768-21.198-14.273l0.104 0.090c-15.746-14.159-25.487-34.421-34.234-70.294l74.871-12.854 42.399 107.231z',
          'M341.343 239.367s-28.005 5.485-56.47 2.11c-11.267-1.327-22.595-4.057-32.261-9.057-8.041-4.053-14.972-8.776-21.201-14.276l0.106 0.092c-19.481-17.533-29.78-44.396-40.376-98.657 0 0 46.518 11.167 92.503-13.376-0.062 0.050 15.448 96.833 57.698 133.164z',
          'M284.868 241.501c-11.267-1.327-22.595-4.058-32.261-9.058-8.041-4.052-14.971-8.775-21.199-14.274l0.106 0.092c16.589-1.352 18.972-10.422 18.972-10.422 12.247 19.493 34.383 33.663 34.383 33.663z',
          'M215.141 139.492s37.833-2.133 48.392-10.286l1.613 5.137s-25.003 11.030-50.005 11.167v-6.018zM215.141 164.893s36.629-1.998 64.299-15.374l0.943 2.146s-21.974 12.818-65.242 16.131v-2.903zM218.077 174.819s36.642-2.010 64.312-15.373l0.931 2.133s-21.963 12.818-65.243 16.131v-2.891zM221.032 184.734s36.629-1.998 64.299-15.374l0.944 2.148s-21.975 12.817-65.243 16.131v-2.904zM223.974 194.66s36.642-2.010 64.312-15.373l0.931 2.133s-21.962 12.818-65.243 16.131v-2.891zM226.924 204.574s36.629-1.998 64.299-15.374l0.943 2.148s-21.975 12.817-65.242 16.131v-2.904z',
          'M1200.742 354.167l0.733 0.533 0.112-1.154-0.484-1.029-0.781 0.125 0.421 1.525z',
          'M1200.742 354.167l0.733 0.533 0.112-1.154-0.484-1.029-0.781 0.125 0.421 1.525z',
          'M1200.746 354.167l0.719 0.546-0.496 0.831-0.708-0.148-0.21-0.286 0.694-0.943z',
          'M1200.746 354.167l0.719 0.546-0.496 0.831-0.708-0.148-0.21-0.286 0.694-0.943z',
          'M1064.722 257.743l-58.195 80.951c-0.795 1.098-1.271 2.472-1.271 3.957 0 0.383 0.032 0.758 0.093 1.124l-0.005-0.040c0.286 1.771 1.26 3.358 2.71 4.414l124.231 90.046c1.103 0.806 2.485 1.289 3.98 1.289 0.372 0 0.737-0.030 1.093-0.088l-0.039 0.005c1.825-0.295 3.377-1.282 4.407-2.677l0.013-0.019 59.225-81.163-136.242-97.801z',
          'M1064.722 257.743l-58.195 80.951c-0.795 1.098-1.271 2.472-1.271 3.957 0 0.383 0.032 0.758 0.093 1.124l-0.005-0.040c0.286 1.771 1.26 3.358 2.71 4.414l124.231 90.046c1.103 0.806 2.485 1.289 3.98 1.289 0.372 0 0.737-0.030 1.093-0.088l-0.039 0.005c1.825-0.295 3.377-1.282 4.407-2.677l0.013-0.019 59.225-81.163-136.242-97.801z',
          'M1064.49 256.391l-58.195 80.951c-0.794 1.097-1.27 2.469-1.27 3.952 0 0.383 0.032 0.758 0.093 1.123l-0.005-0.040c0.286 1.768 1.26 3.353 2.71 4.406l124.193 90.035c1.455 1.050 3.266 1.481 5.037 1.2 1.825-0.297 3.376-1.285 4.404-2.683l0.013-0.019 59.225-81.149-136.205-97.776z',
          'M1063.771 206.261l1.539 49.484 136.242 97.803-1.291-50.353c-0.029-1.184-0.339-2.29-0.866-3.261l0.019 0.038c-0.546-1.009-1.289-1.845-2.183-2.482l-0.022-0.015-131.142-92.441c-0.209-0.157-0.467-0.258-0.747-0.279l-0.005-0c-0.033-0.003-0.071-0.004-0.109-0.004-0.247 0-0.48 0.063-0.683 0.173l0.008-0.004c-0.242 0.132-0.437 0.323-0.57 0.555l-0.004 0.007c-0.117 0.205-0.187 0.45-0.187 0.711 0 0.024 0.001 0.048 0.002 0.072l-0-0.003z',
          'M1063.771 206.261l1.539 49.484 136.242 97.803-1.291-50.353c-0.029-1.184-0.339-2.29-0.866-3.261l0.019 0.038c-0.546-1.009-1.289-1.845-2.183-2.482l-0.022-0.015-131.142-92.441c-0.209-0.157-0.467-0.258-0.747-0.279l-0.005-0c-0.033-0.003-0.071-0.004-0.109-0.004-0.247 0-0.48 0.063-0.683 0.173l0.008-0.004c-0.242 0.132-0.437 0.323-0.57 0.555l-0.004 0.007c-0.117 0.205-0.187 0.45-0.187 0.711 0 0.024 0.001 0.048 0.002 0.072l-0-0.003z',
          'M1062.949 206.869l1.539 49.522 136.242 97.801-1.327-50.353c-0.063-2.361-1.25-4.432-3.043-5.705l-0.022-0.015-131.13-92.441c-0.205-0.149-0.456-0.245-0.729-0.264l-0.004-0c-0.029-0.002-0.063-0.003-0.098-0.003-0.243 0-0.472 0.061-0.673 0.169l0.008-0.004c-0.237 0.126-0.428 0.309-0.561 0.532l-0.004 0.007c-0.124 0.208-0.197 0.459-0.197 0.727 0 0.010 0 0.019 0 0.029l-0-0.001z',
          'M1068.446 278.577l-3.524 4.964c-0.156 0.219-0.249 0.492-0.249 0.786 0 0.078 0.007 0.154 0.019 0.229l-0.001-0.008c0.061 0.363 0.259 0.672 0.537 0.877l0.004 0.003 4.962 3.722c0.222 0.166 0.502 0.266 0.805 0.266 0.068 0 0.135-0.005 0.201-0.015l-0.007 0.001c0.364-0.054 0.676-0.247 0.885-0.522l0.002-0.003 3.56-4.666c0.178-0.226 0.286-0.515 0.286-0.829 0-0.059-0.004-0.118-0.011-0.175l0.001 0.007c-0.024-0.187-0.083-0.356-0.169-0.507l0.004 0.007c-0.091-0.158-0.206-0.291-0.342-0.398l-0.003-0.002-5.062-3.995c-0.135-0.103-0.293-0.183-0.466-0.23l-0.010-0.002c-0.103-0.028-0.221-0.044-0.344-0.044-0.065 0-0.13 0.005-0.193 0.014l0.007-0.001c-0.187 0.026-0.355 0.087-0.505 0.177l0.006-0.003c-0.156 0.092-0.288 0.209-0.393 0.347l-0.002 0.003zM1077.625 285.179l-3.524 4.962c-0.156 0.219-0.249 0.492-0.249 0.786 0 0.078 0.007 0.154 0.019 0.229l-0.001-0.008c0.062 0.363 0.259 0.671 0.537 0.877l0.004 0.003 4.962 3.722c0.222 0.166 0.503 0.266 0.806 0.266 0.069 0 0.136-0.005 0.202-0.015l-0.007 0.001c0.364-0.054 0.675-0.247 0.884-0.522l0.002-0.003 3.56-4.664c0.106-0.134 0.187-0.291 0.235-0.463l0.002-0.009c0.031-0.107 0.049-0.231 0.049-0.358 0-0.059-0.004-0.118-0.011-0.175l0.001 0.007c-0.023-0.187-0.081-0.356-0.169-0.507l0.003 0.006c-0.090-0.158-0.206-0.29-0.342-0.397l-0.003-0.002-5.012-3.983c-0.136-0.112-0.298-0.2-0.475-0.251l-0.009-0.002c-0.111-0.034-0.24-0.053-0.372-0.053-0.060 0-0.12 0.004-0.178 0.012l0.007-0.001c-0.193 0.025-0.368 0.088-0.522 0.181l0.006-0.003c-0.161 0.095-0.296 0.218-0.402 0.363l-0.003 0.004zM1087.273 292.103l-3.525 4.962c-0.155 0.219-0.248 0.491-0.248 0.785 0 0.451 0.219 0.851 0.555 1.099l0.004 0.003 4.962 3.722c0.222 0.166 0.503 0.266 0.806 0.266 0.069 0 0.136-0.005 0.202-0.015l-0.007 0.001c0.364-0.054 0.675-0.247 0.884-0.522l0.002-0.003 3.562-4.664c0.175-0.228 0.28-0.518 0.28-0.832 0-0.058-0.004-0.116-0.011-0.172l0.001 0.007c-0.047-0.367-0.233-0.683-0.504-0.898l-0.003-0.002-5.062-3.983c-0.134-0.104-0.292-0.185-0.464-0.233l-0.009-0.002c-0.106-0.029-0.228-0.046-0.354-0.046-0.061 0-0.121 0.004-0.18 0.012l0.007-0.001c-0.187 0.026-0.356 0.086-0.507 0.173l0.007-0.004c-0.157 0.092-0.288 0.208-0.394 0.346l-0.002 0.003zM1097.020 299.113l-3.524 4.962c-0.158 0.219-0.253 0.494-0.253 0.79 0 0.076 0.006 0.15 0.018 0.222l-0.001-0.008c0.055 0.352 0.247 0.67 0.533 0.882l4.964 3.722c0.222 0.166 0.502 0.266 0.805 0.266 0.068 0 0.136-0.005 0.201-0.015l-0.007 0.001c0.365-0.054 0.676-0.247 0.885-0.522l0.002-0.003 3.56-4.664c0.175-0.227 0.281-0.515 0.281-0.829 0-0.060-0.004-0.118-0.011-0.176l0.001 0.007c-0.046-0.367-0.232-0.683-0.503-0.898l-0.003-0.002-5.064-3.983c-0.224-0.172-0.508-0.276-0.817-0.276-0.062 0-0.124 0.004-0.184 0.012l0.007-0.001c-0.365 0.049-0.678 0.237-0.889 0.509l-0.002 0.003zM1106.769 306.123l-3.524 4.964c-0.158 0.219-0.252 0.493-0.252 0.789 0 0.076 0.006 0.15 0.018 0.222l-0.001-0.008c0.055 0.353 0.247 0.67 0.533 0.882l4.964 3.723c0.224 0.166 0.505 0.266 0.81 0.266 0.069 0 0.136-0.005 0.202-0.015l-0.007 0.001c0.367-0.053 0.681-0.246 0.892-0.522l0.002-0.003 3.56-4.666c0.175-0.227 0.281-0.515 0.281-0.828 0-0.060-0.004-0.119-0.011-0.176l0.001 0.007c-0.046-0.367-0.233-0.683-0.503-0.898l-0.003-0.002-5.062-3.983c-0.134-0.104-0.292-0.185-0.464-0.233l-0.010-0.002c-0.106-0.029-0.228-0.046-0.354-0.046-0.061 0-0.121 0.004-0.18 0.012l0.007-0.001c-0.187 0.026-0.356 0.086-0.507 0.174l0.006-0.003c-0.157 0.091-0.289 0.207-0.395 0.345l-0.002 0.003zM1116.958 312.513l-4.368 6.204c-0.073 0.103-0.116 0.232-0.116 0.371 0 0.034 0.003 0.068 0.008 0.1l-0-0.004c0.028 0.169 0.117 0.314 0.244 0.412l0.001 0.001 6.204 4.541c0.104 0.079 0.235 0.126 0.377 0.126 0.031 0 0.062-0.002 0.092-0.007l-0.003 0c0.17-0.025 0.316-0.114 0.414-0.241l0.001-0.001 4.429-5.807c0.081-0.105 0.13-0.239 0.13-0.384 0-0.201-0.094-0.38-0.24-0.496l-0.001-0.001-6.204-4.964c-0.068-0.058-0.149-0.103-0.238-0.129l-0.005-0.001c-0.054-0.016-0.116-0.025-0.18-0.025-0.034 0-0.067 0.003-0.099 0.007l0.004-0c-0.097 0.016-0.184 0.051-0.26 0.101l0.002-0.002c-0.078 0.052-0.142 0.117-0.19 0.194l-0.002 0.003zM1126.714 319.523l-4.366 6.204c-0.073 0.103-0.117 0.232-0.117 0.37 0 0.035 0.003 0.069 0.008 0.102l-0-0.004c0.027 0.169 0.116 0.314 0.244 0.411l6.205 4.543c0.134 0.098 0.302 0.142 0.466 0.118 0.17-0.024 0.316-0.113 0.414-0.241l0.001-0.002 4.429-5.807c0.081-0.105 0.13-0.239 0.13-0.384 0-0.028-0.002-0.056-0.005-0.083l0 0.003c-0.022-0.17-0.109-0.317-0.235-0.416l-0.001-0.001-6.203-4.964c-0.068-0.058-0.149-0.103-0.238-0.129l-0.005-0.001c-0.054-0.016-0.116-0.025-0.18-0.025-0.034 0-0.067 0.003-0.099 0.007l0.004-0c-0.097 0.016-0.184 0.051-0.26 0.101l0.002-0.001c-0.078 0.052-0.142 0.118-0.191 0.194l-0.002 0.003zM1135.349 325.728l-4.381 6.204c-0.073 0.102-0.116 0.23-0.116 0.367 0 0.037 0.003 0.073 0.009 0.108l-0.001-0.004c0.030 0.17 0.124 0.314 0.255 0.408l0.002 0.001 6.203 4.541c0.106 0.079 0.24 0.127 0.385 0.127 0.031 0 0.061-0.002 0.091-0.006l-0.003 0c0.172-0.025 0.32-0.115 0.42-0.243l0.001-0.001 4.429-5.795c0.082-0.107 0.131-0.243 0.131-0.39 0-0.028-0.002-0.056-0.005-0.083l0 0.003c-0.022-0.172-0.11-0.321-0.236-0.423l-0.001-0.001-6.204-4.962c-0.067-0.063-0.149-0.112-0.24-0.141l-0.005-0.001c-0.056-0.018-0.12-0.028-0.187-0.028-0.033 0-0.066 0.003-0.098 0.007l0.004-0c-0.1 0.016-0.189 0.052-0.266 0.105l0.002-0.001c-0.078 0.055-0.142 0.124-0.189 0.204l-0.002 0.003zM1145.020 332.677l-4.369 6.204c-0.048 0.063-0.084 0.137-0.105 0.217l-0.001 0.004c-0.012 0.046-0.018 0.099-0.018 0.154 0 0.033 0.002 0.065 0.007 0.096l-0-0.004c0.013 0.083 0.042 0.161 0.087 0.232s0.101 0.131 0.166 0.179l0.002 0.001 6.204 4.541c0.107 0.079 0.241 0.126 0.387 0.126 0.030 0 0.060-0.002 0.089-0.006l-0.003 0c0.172-0.025 0.32-0.115 0.42-0.243l0.001-0.001 4.429-5.795c0.082-0.107 0.131-0.243 0.131-0.391 0-0.028-0.002-0.056-0.005-0.083l0 0.003c-0.022-0.172-0.11-0.321-0.236-0.423l-0.001-0.001-6.204-4.901c-0.064-0.066-0.142-0.119-0.229-0.152l-0.004-0.001c-0.066-0.025-0.141-0.039-0.221-0.039-0.020 0-0.040 0.001-0.059 0.003l0.002-0c-0.099 0.008-0.19 0.039-0.269 0.087l0.003-0.002c-0.081 0.049-0.149 0.114-0.201 0.189l-0.001 0.002zM1154.35 339.414l-4.368 6.204c-0.073 0.102-0.117 0.229-0.117 0.366 0 0.037 0.003 0.074 0.009 0.109l-0.001-0.004c0.029 0.17 0.123 0.314 0.254 0.408l0.002 0.001 6.204 4.554c0.102 0.075 0.231 0.121 0.37 0.121 0.035 0 0.069-0.003 0.102-0.008l-0.004 0c0.17-0.027 0.314-0.119 0.411-0.248l0.001-0.002 4.429-5.795c0.082-0.107 0.131-0.243 0.131-0.39 0-0.028-0.002-0.056-0.005-0.083l0 0.003c-0.022-0.172-0.11-0.32-0.236-0.422l-0.001-0.001-6.204-4.902c-0.065-0.064-0.143-0.114-0.23-0.147l-0.005-0.001c-0.065-0.024-0.14-0.038-0.219-0.038-0.020 0-0.039 0.001-0.058 0.003l0.002-0c-0.099 0.009-0.189 0.039-0.268 0.086l0.003-0.002c-0.082 0.047-0.151 0.11-0.203 0.184l-0.001 0.002zM1163.741 346.14l-4.368 6.204c-0.073 0.103-0.117 0.231-0.117 0.369 0 0.035 0.003 0.069 0.008 0.102l-0-0.004c0.027 0.17 0.116 0.314 0.244 0.412l0.002 0.001 6.203 4.541c0.134 0.1 0.302 0.142 0.466 0.119 0.17-0.025 0.316-0.114 0.414-0.241l0.001-0.001 4.431-5.808c0.1-0.131 0.144-0.298 0.123-0.463-0.022-0.17-0.109-0.317-0.235-0.416l-0.001-0.001-6.203-4.901c-0.064-0.064-0.141-0.114-0.228-0.146l-0.004-0.001c-0.063-0.024-0.135-0.038-0.211-0.038-0.021 0-0.042 0.001-0.063 0.003l0.003-0c-0.098 0.009-0.187 0.038-0.266 0.084l0.003-0.002c-0.081 0.048-0.148 0.11-0.2 0.184l-0.001 0.002zM1173.105 352.877l-4.38 6.204c-0.073 0.102-0.117 0.229-0.117 0.366 0 0.211 0.104 0.399 0.263 0.514l0.002 0.001 6.204 4.554c0.105 0.076 0.237 0.121 0.379 0.121 0.034 0 0.067-0.003 0.1-0.008l-0.004 0c0.172-0.027 0.319-0.119 0.418-0.249l0.001-0.002 4.429-5.795c0.082-0.107 0.131-0.242 0.131-0.389 0-0.203-0.094-0.385-0.241-0.503l-0.001-0.001-6.204-4.964c-0.067-0.063-0.149-0.112-0.24-0.141l-0.005-0.001c-0.056-0.018-0.121-0.028-0.188-0.028-0.033 0-0.066 0.003-0.098 0.007l0.004-0c-0.099 0.016-0.188 0.052-0.265 0.105l0.002-0.001c-0.079 0.054-0.143 0.124-0.19 0.204l-0.002 0.003zM1062.034 287.487l-3.512 4.962c-0.158 0.22-0.253 0.495-0.253 0.792 0 0.075 0.006 0.149 0.018 0.22l-0.001-0.008c0.060 0.363 0.255 0.672 0.531 0.88l0.004 0.003 4.962 3.722c0.29 0.21 0.651 0.299 1.006 0.248 0.366-0.053 0.679-0.245 0.89-0.518l0.002-0.003 3.562-4.664c0.175-0.227 0.281-0.515 0.281-0.829 0-0.060-0.004-0.118-0.011-0.176l0.001 0.007c-0.047-0.367-0.234-0.684-0.504-0.9l-0.003-0.002-5.062-3.995c-0.227-0.17-0.512-0.273-0.822-0.273-0.066 0-0.13 0.005-0.193 0.013l0.007-0.001c-0.369 0.052-0.685 0.243-0.9 0.518l-0.002 0.003zM1048.034 306.968l-3.512 4.962c-0.158 0.22-0.253 0.495-0.253 0.792 0 0.075 0.006 0.149 0.018 0.22l-0.001-0.008c0.059 0.363 0.254 0.673 0.531 0.88l0.004 0.003 4.962 3.722c0.289 0.211 0.649 0.303 1.003 0.255 0.365-0.052 0.679-0.241 0.893-0.512l0.002-0.003 3.562-4.666c0.175-0.227 0.281-0.516 0.281-0.829 0-0.432-0.201-0.817-0.514-1.067l-0.003-0.002-5.062-3.995c-0.228-0.177-0.518-0.283-0.832-0.283-0.062 0-0.122 0.004-0.182 0.012l0.007-0.001c-0.369 0.050-0.687 0.241-0.901 0.517l-0.002 0.003zM1071.213 294.088l-3.525 4.962c-0.158 0.22-0.252 0.494-0.252 0.79 0 0.076 0.006 0.15 0.018 0.222l-0.001-0.008c0.055 0.352 0.247 0.67 0.533 0.882l4.964 3.722c0.224 0.165 0.505 0.263 0.81 0.263 0.069 0 0.136-0.005 0.202-0.015l-0.007 0.001c0.366-0.055 0.679-0.246 0.892-0.519l0.002-0.003 3.56-4.664c0.175-0.227 0.281-0.515 0.281-0.829 0-0.060-0.004-0.118-0.011-0.176l0.001 0.007c-0.046-0.367-0.233-0.683-0.503-0.898l-0.003-0.002-5.062-3.996c-0.225-0.169-0.51-0.271-0.818-0.271-0.065 0-0.129 0.005-0.192 0.013l0.007-0.001c-0.367 0.051-0.681 0.242-0.893 0.517l-0.002 0.003zM1080.854 301.061l-3.512 4.962c-0.158 0.22-0.253 0.495-0.253 0.792 0 0.075 0.006 0.149 0.018 0.22l-0.001-0.008c0.059 0.363 0.254 0.673 0.531 0.88l0.004 0.003 4.962 3.722c0.289 0.213 0.649 0.303 1.002 0.255 0.366-0.052 0.68-0.24 0.894-0.512l0.002-0.003 3.562-4.666c0.175-0.227 0.281-0.516 0.281-0.829 0-0.432-0.201-0.817-0.514-1.067l-0.003-0.002-5.062-3.995c-0.228-0.177-0.518-0.283-0.832-0.283-0.062 0-0.122 0.004-0.182 0.012l0.007-0.001c-0.37 0.050-0.687 0.241-0.901 0.517l-0.002 0.003zM1090.603 308.034l-3.51 4.964c-0.158 0.22-0.253 0.494-0.253 0.791 0 0.075 0.006 0.148 0.018 0.22l-0.001-0.008c0.055 0.353 0.247 0.67 0.533 0.884l4.964 3.722c0.225 0.167 0.509 0.267 0.816 0.267 0.066 0 0.13-0.005 0.193-0.013l-0.007 0.001c0.366-0.052 0.68-0.241 0.894-0.512l0.002-0.003 3.562-4.679c0.174-0.226 0.279-0.513 0.279-0.824 0-0.059-0.004-0.117-0.011-0.174l0.001 0.007c-0.047-0.365-0.233-0.679-0.503-0.892l-0.003-0.002-5.062-3.996c-0.227-0.176-0.517-0.282-0.83-0.282-0.062 0-0.124 0.004-0.184 0.012l0.007-0.001c-0.37 0.049-0.688 0.24-0.902 0.516l-0.002 0.003zM1057.438 313.259l-3.512 4.962c-0.158 0.22-0.253 0.495-0.253 0.792 0 0.075 0.006 0.149 0.018 0.22l-0.001-0.008c0.060 0.363 0.255 0.672 0.531 0.88l0.004 0.003 4.962 3.722c0.289 0.211 0.649 0.303 1.002 0.255 0.366-0.052 0.68-0.24 0.894-0.512l0.002-0.003 3.562-4.678c0.174-0.226 0.28-0.512 0.28-0.824 0-0.43-0.201-0.813-0.513-1.061l-0.003-0.002-5.062-3.995c-0.228-0.177-0.518-0.283-0.832-0.283-0.062 0-0.122 0.004-0.182 0.012l0.007-0.001c-0.369 0.050-0.687 0.241-0.901 0.517l-0.002 0.003zM1067.078 320.181l-3.51 4.964c-0.158 0.22-0.253 0.495-0.253 0.792 0 0.075 0.006 0.149 0.018 0.22l-0.001-0.008c0.059 0.363 0.254 0.672 0.529 0.88l0.004 0.003 4.964 3.722c0.29 0.21 0.65 0.299 1.004 0.248 0.366-0.054 0.679-0.245 0.892-0.518l0.002-0.003 3.562-4.666c0.175-0.228 0.281-0.517 0.281-0.83 0-0.059-0.004-0.116-0.011-0.173l0.001 0.007c-0.047-0.367-0.234-0.684-0.504-0.9l-0.003-0.002-5.062-3.995c-0.227-0.17-0.512-0.273-0.822-0.273-0.066 0-0.13 0.005-0.193 0.013l0.007-0.001c-0.369 0.051-0.686 0.242-0.901 0.517l-0.002 0.003zM1076.834 327.193l-3.512 4.962c-0.158 0.22-0.252 0.494-0.252 0.79 0 0.076 0.006 0.15 0.018 0.222l-0.001-0.008c0.055 0.352 0.247 0.67 0.533 0.882l4.964 3.722c0.289 0.21 0.65 0.299 1.004 0.248 0.366-0.053 0.679-0.245 0.892-0.518l0.002-0.003 3.56-4.664c0.173-0.226 0.277-0.513 0.277-0.824 0-0.062-0.004-0.123-0.012-0.183l0.001 0.007c-0.050-0.367-0.238-0.683-0.51-0.897l-0.003-0.002-5.049-3.995c-0.227-0.173-0.515-0.277-0.827-0.277-0.065 0-0.128 0.004-0.19 0.013l0.007-0.001c-0.37 0.051-0.687 0.245-0.899 0.523l-0.002 0.003zM1100.36 315.044l-3.512 4.964c-0.158 0.22-0.252 0.494-0.252 0.791 0 0.447 0.215 0.844 0.546 1.093l0.004 0.003 4.964 3.722c0.225 0.167 0.509 0.267 0.815 0.267 0.066 0 0.13-0.005 0.194-0.014l-0.007 0.001c0.366-0.052 0.68-0.24 0.894-0.512l0.002-0.003 3.562-4.679c0.174-0.226 0.28-0.512 0.28-0.824 0-0.059-0.004-0.117-0.011-0.174l0.001 0.007c-0.047-0.365-0.233-0.678-0.503-0.892l-0.003-0.002-5.014-4.083c-0.141-0.108-0.308-0.189-0.49-0.234l-0.009-0.002c-0.097-0.025-0.209-0.039-0.324-0.039-0.081 0-0.16 0.007-0.237 0.021l0.008-0.001c-0.195 0.034-0.369 0.105-0.521 0.205l0.005-0.003c-0.157 0.103-0.288 0.232-0.389 0.384l-0.003 0.005zM1110.111 322.043l-3.512 4.964c-0.158 0.22-0.253 0.494-0.253 0.791 0 0.075 0.006 0.148 0.018 0.22l-0.001-0.008c0.056 0.353 0.248 0.67 0.534 0.882l4.964 3.723c0.288 0.211 0.647 0.302 1.002 0.253 0.366-0.051 0.68-0.24 0.894-0.512l0.002-0.003 3.56-4.678c0.174-0.225 0.28-0.512 0.28-0.823 0-0.059-0.004-0.118-0.011-0.175l0.001 0.007c-0.046-0.365-0.232-0.679-0.501-0.892l-0.003-0.002-5.064-3.996c-0.227-0.176-0.516-0.282-0.83-0.282-0.062 0-0.123 0.004-0.183 0.012l0.007-0.001c-0.37 0.049-0.688 0.24-0.902 0.515l-0.002 0.003zM1120.311 328.434l-4.381 6.203c-0.073 0.102-0.116 0.229-0.116 0.366 0 0.037 0.003 0.073 0.009 0.109l-0.001-0.004c0.030 0.17 0.124 0.314 0.255 0.41l0.002 0.001 6.203 4.541c0.106 0.079 0.239 0.126 0.383 0.126 0.032 0 0.063-0.002 0.093-0.007l-0.003 0c0.172-0.024 0.32-0.114 0.42-0.243l0.001-0.001 4.429-5.795c0.082-0.107 0.131-0.242 0.131-0.389 0-0.028-0.002-0.055-0.005-0.082l0 0.003c-0.022-0.172-0.11-0.321-0.236-0.423l-0.001-0.001-6.204-4.964c-0.067-0.063-0.149-0.111-0.24-0.139l-0.004-0.001c-0.055-0.018-0.119-0.028-0.185-0.028-0.034 0-0.067 0.003-0.099 0.008l0.004-0c-0.1 0.016-0.189 0.052-0.266 0.105l0.002-0.001c-0.078 0.055-0.142 0.124-0.189 0.204l-0.002 0.003zM1128.932 334.637l-4.368 6.204c-0.073 0.102-0.116 0.23-0.116 0.367 0 0.037 0.003 0.073 0.009 0.108l-0.001-0.004c0.030 0.17 0.124 0.314 0.255 0.408l0.002 0.001 6.204 4.542c0.066 0.050 0.14 0.088 0.221 0.109s0.164 0.026 0.245 0.014c0.087-0.013 0.166-0.041 0.235-0.083l-0.003 0.002c0.072-0.044 0.133-0.1 0.181-0.165l0.001-0.002 4.429-5.795c0.082-0.107 0.131-0.242 0.131-0.389 0-0.028-0.002-0.055-0.005-0.082l0 0.003c-0.022-0.172-0.11-0.321-0.236-0.423l-0.001-0.001-6.204-4.964c-0.068-0.061-0.15-0.107-0.241-0.135l-0.005-0.001c-0.054-0.016-0.117-0.026-0.181-0.026-0.134 0-0.258 0.041-0.362 0.11l0.002-0.001c-0.079 0.053-0.144 0.121-0.193 0.199l-0.002 0.003zM1138.618 341.585l-4.38 6.204c-0.073 0.101-0.117 0.228-0.117 0.364 0 0.038 0.003 0.075 0.010 0.111l-0.001-0.004c0.029 0.17 0.123 0.314 0.254 0.408l0.002 0.001 6.204 4.542c0.066 0.050 0.14 0.088 0.221 0.109s0.164 0.026 0.245 0.014c0.087-0.013 0.166-0.041 0.235-0.083l-0.003 0.002c0.072-0.045 0.133-0.1 0.181-0.165l0.001-0.002 4.429-5.795c0.082-0.108 0.131-0.244 0.131-0.391 0-0.027-0.002-0.054-0.005-0.081l0 0.003c-0.022-0.173-0.11-0.321-0.236-0.423l-0.001-0.001-6.204-4.902c-0.114-0.114-0.272-0.185-0.447-0.185-0.020 0-0.040 0.001-0.060 0.003l0.003-0c-0.097 0.009-0.186 0.039-0.264 0.084l0.003-0.002c-0.081 0.048-0.149 0.11-0.201 0.184l-0.001 0.002zM1147.971 348.324l-4.368 6.203c-0.073 0.104-0.116 0.233-0.116 0.372 0 0.034 0.003 0.068 0.008 0.101l-0-0.004c0.026 0.164 0.114 0.311 0.245 0.412l6.204 4.542c0.104 0.078 0.235 0.124 0.377 0.124 0.031 0 0.062-0.002 0.092-0.007l-0.003 0c0.17-0.024 0.316-0.114 0.414-0.241l0.001-0.002 4.429-5.807c0.081-0.105 0.13-0.239 0.13-0.384 0-0.201-0.094-0.38-0.24-0.496l-0.001-0.001-6.204-4.964c-0.068-0.058-0.149-0.103-0.238-0.129l-0.005-0.001c-0.054-0.016-0.116-0.025-0.18-0.025-0.034 0-0.067 0.003-0.099 0.007l0.004-0c-0.097 0.016-0.184 0.051-0.26 0.101l0.002-0.002c-0.078 0.052-0.142 0.118-0.19 0.196l-0.002 0.003zM1074.2 310.28l-3.524 4.964c-0.158 0.22-0.253 0.494-0.253 0.791 0 0.075 0.006 0.148 0.018 0.22l-0.001-0.008c0.055 0.353 0.247 0.67 0.534 0.882l4.962 3.723c0.289 0.213 0.65 0.303 1.006 0.253 0.366-0.054 0.68-0.247 0.89-0.523l0.002-0.003 3.562-4.666c0.175-0.228 0.281-0.517 0.281-0.831 0-0.059-0.004-0.117-0.011-0.173l0.001 0.007c-0.047-0.367-0.234-0.683-0.504-0.898l-0.003-0.002-4.987-4.008c-0.138-0.115-0.303-0.204-0.483-0.256l-0.010-0.002c-0.11-0.032-0.237-0.051-0.368-0.051-0.263 0-0.508 0.075-0.716 0.204l0.006-0.003c-0.161 0.101-0.295 0.228-0.4 0.378l-0.003 0.004zM1083.957 317.29l-3.525 4.964c-0.158 0.219-0.252 0.493-0.252 0.789 0 0.076 0.006 0.15 0.018 0.222l-0.001-0.008c0.055 0.353 0.247 0.67 0.533 0.882l4.964 3.723c0.289 0.213 0.65 0.305 1.004 0.253 0.367-0.054 0.681-0.247 0.892-0.523l0.002-0.003 3.56-4.666c0.175-0.227 0.281-0.515 0.281-0.828 0-0.060-0.004-0.119-0.011-0.177l0.001 0.007c-0.047-0.367-0.233-0.683-0.503-0.898l-0.003-0.002-5.062-3.983c-0.134-0.103-0.293-0.184-0.464-0.231l-0.010-0.002c-0.105-0.030-0.226-0.047-0.351-0.047-0.062 0-0.124 0.004-0.184 0.013l0.007-0.001c-0.187 0.025-0.356 0.084-0.506 0.173l0.006-0.003c-0.156 0.092-0.288 0.208-0.394 0.345l-0.002 0.003zM1093.7 324.301l-3.512 4.964c-0.158 0.22-0.253 0.494-0.253 0.791 0 0.075 0.006 0.148 0.018 0.22l-0.001-0.008c0.056 0.353 0.248 0.67 0.534 0.884l4.962 3.722c0.224 0.167 0.506 0.267 0.812 0.267 0.068 0 0.135-0.005 0.201-0.015l-0.007 0.001c0.366-0.054 0.68-0.247 0.89-0.523l0.002-0.003 3.562-4.666c0.172-0.227 0.276-0.514 0.276-0.826 0-0.060-0.004-0.12-0.011-0.178l0.001 0.007c-0.046-0.366-0.231-0.683-0.499-0.9l-0.003-0.002-5.062-3.983c-0.228-0.176-0.518-0.282-0.832-0.282-0.062 0-0.122 0.004-0.182 0.012l0.007-0.001c-0.369 0.050-0.686 0.241-0.901 0.516l-0.002 0.003zM1103.476 331.311l-3.512 4.964c-0.158 0.22-0.252 0.494-0.252 0.79 0 0.076 0.006 0.15 0.018 0.222l-0.001-0.008c0.055 0.352 0.247 0.67 0.533 0.882l4.964 3.722c0.224 0.167 0.506 0.267 0.811 0.267 0.442 0 0.836-0.21 1.085-0.537l0.002-0.003 3.56-4.664c0.175-0.227 0.281-0.515 0.281-0.829 0-0.060-0.004-0.118-0.011-0.176l0.001 0.007c-0.046-0.367-0.233-0.684-0.503-0.9l-0.003-0.002-5.062-3.983c-0.228-0.176-0.518-0.282-0.833-0.282-0.061 0-0.122 0.004-0.181 0.012l0.007-0.001c-0.37 0.050-0.687 0.241-0.902 0.516l-0.002 0.003zM1113.647 337.702l-4.368 6.204c-0.048 0.063-0.085 0.138-0.105 0.219l-0.001 0.004c-0.012 0.045-0.019 0.097-0.019 0.151 0 0.033 0.003 0.066 0.008 0.098l-0-0.003c0.013 0.083 0.042 0.161 0.085 0.232s0.101 0.131 0.169 0.18l6.204 4.541c0.106 0.079 0.24 0.127 0.385 0.127 0.030 0 0.060-0.002 0.090-0.006l-0.003 0c0.172-0.025 0.32-0.114 0.42-0.243l0.001-0.001 4.431-5.808c0.1-0.131 0.144-0.298 0.123-0.463-0.022-0.17-0.109-0.317-0.235-0.416l-0.001-0.001-6.203-4.901c-0.064-0.066-0.142-0.119-0.229-0.152l-0.004-0.001c-0.065-0.025-0.14-0.039-0.219-0.039-0.021 0-0.041 0.001-0.061 0.003l0.003-0c-0.099 0.008-0.19 0.039-0.269 0.087l0.003-0.002c-0.082 0.049-0.15 0.113-0.202 0.189l-0.001 0.002zM1122.286 343.906l-4.381 6.204c-0.073 0.102-0.117 0.229-0.117 0.366 0 0.037 0.003 0.074 0.009 0.109l-0.001-0.004c0.030 0.17 0.124 0.314 0.255 0.408l0.002 0.001 6.203 4.541c0.106 0.079 0.239 0.126 0.383 0.126 0.032 0 0.063-0.002 0.093-0.007l-0.003 0c0.172-0.024 0.32-0.113 0.42-0.241l0.001-0.001 4.418-5.795c0.051-0.062 0.091-0.137 0.114-0.217l0.001-0.004c0.016-0.052 0.025-0.111 0.025-0.172 0-0.027-0.002-0.054-0.005-0.080l0 0.003c-0.011-0.088-0.039-0.168-0.082-0.239l0.002 0.003c-0.043-0.074-0.099-0.136-0.165-0.185l-0.002-0.001-6.204-4.901c-0.063-0.067-0.14-0.119-0.227-0.152l-0.004-0.001c-0.064-0.025-0.139-0.040-0.216-0.040-0.020 0-0.041 0.001-0.061 0.003l0.003-0c-0.098 0.008-0.187 0.039-0.265 0.087l0.003-0.001c-0.081 0.049-0.148 0.113-0.198 0.189l-0.001 0.002zM1132.010 350.855l-4.381 6.204c-0.073 0.102-0.116 0.23-0.116 0.367 0 0.037 0.003 0.073 0.009 0.108l-0.001-0.004c0.030 0.17 0.124 0.313 0.255 0.408l0.002 0.001 6.203 4.541c0.106 0.079 0.239 0.126 0.383 0.126 0.032 0 0.063-0.002 0.093-0.007l-0.003 0c0.172-0.024 0.32-0.113 0.42-0.241l0.001-0.001 4.429-5.795c0.082-0.107 0.131-0.243 0.131-0.391 0-0.028-0.002-0.055-0.005-0.082l0 0.003c-0.022-0.172-0.11-0.321-0.236-0.423l-0.001-0.001-6.204-4.964c-0.067-0.065-0.148-0.116-0.238-0.146l-0.004-0.001c-0.057-0.019-0.122-0.029-0.19-0.029-0.033 0-0.066 0.003-0.097 0.007l0.004-0c-0.1 0.015-0.19 0.052-0.266 0.108l0.002-0.001c-0.079 0.055-0.143 0.126-0.187 0.209l-0.002 0.003zM1141.312 357.593l-4.368 6.204c-0.074 0.105-0.118 0.235-0.118 0.376 0 0.035 0.003 0.069 0.008 0.102l-0-0.004c0.027 0.171 0.117 0.318 0.245 0.418l0.001 0.001 6.203 4.541c0.135 0.097 0.302 0.138 0.466 0.114 0.169-0.024 0.315-0.111 0.414-0.236l4.432-5.808c0.081-0.106 0.129-0.241 0.129-0.387 0-0.027-0.002-0.053-0.005-0.079l0 0.003c-0.022-0.17-0.109-0.317-0.235-0.416l-0.001-0.001-6.204-4.964c-0.067-0.059-0.148-0.105-0.237-0.131l-0.004-0.001c-0.055-0.018-0.118-0.028-0.184-0.028-0.032 0-0.063 0.002-0.094 0.007l0.003-0c-0.097 0.014-0.184 0.048-0.26 0.097l0.002-0.002c-0.079 0.050-0.144 0.115-0.193 0.192l-0.001 0.003zM1157.337 355.048l-4.381 6.204c-0.073 0.102-0.116 0.23-0.116 0.367 0 0.037 0.003 0.073 0.009 0.108l-0.001-0.004c0.030 0.17 0.124 0.314 0.255 0.408l0.002 0.001 6.203 4.541c0.063 0.049 0.139 0.087 0.22 0.109l0.004 0.001c0.081 0.021 0.165 0.026 0.249 0.016 0.088-0.013 0.167-0.042 0.238-0.084l-0.003 0.002c0.073-0.044 0.135-0.1 0.184-0.165l0.001-0.002 4.429-5.795c0.082-0.107 0.131-0.243 0.131-0.39 0-0.028-0.002-0.056-0.005-0.083l0 0.003c-0.022-0.172-0.11-0.321-0.236-0.423l-0.001-0.001-6.204-4.901c-0.065-0.064-0.143-0.115-0.231-0.147l-0.004-0.001c-0.065-0.024-0.14-0.038-0.219-0.038-0.020 0-0.039 0.001-0.058 0.003l0.002-0c-0.099 0.009-0.189 0.039-0.268 0.086l0.003-0.002c-0.082 0.047-0.151 0.11-0.203 0.184l-0.001 0.002zM1166.753 361.786l-4.368 6.204c-0.073 0.105-0.116 0.236-0.116 0.376 0 0.034 0.003 0.068 0.008 0.101l-0-0.004c0.026 0.172 0.116 0.319 0.244 0.419l0.001 0.001 6.204 4.541c0.135 0.097 0.302 0.138 0.466 0.114 0.169-0.024 0.314-0.111 0.414-0.236l0.001-0.001 4.429-5.808c0.081-0.105 0.13-0.238 0.13-0.383 0-0.028-0.002-0.056-0.006-0.084l0 0.003c-0.022-0.17-0.109-0.317-0.235-0.416l-0.001-0.001-6.203-4.962c-0.067-0.059-0.148-0.105-0.237-0.133l-0.005-0.001c-0.055-0.017-0.117-0.026-0.182-0.026-0.032 0-0.064 0.002-0.096 0.007l0.004-0c-0.097 0.013-0.184 0.046-0.26 0.096l0.002-0.001c-0.078 0.051-0.144 0.116-0.194 0.192l-0.002 0.002zM1124.7 360.943l-4.12 5.795c-0.062 0.085-0.108 0.186-0.134 0.295l-0.001 0.006c-0.014 0.057-0.022 0.123-0.022 0.191 0 0.049 0.004 0.097 0.012 0.143l-0.001-0.005c0.020 0.116 0.062 0.22 0.12 0.312l-0.002-0.003c0.060 0.095 0.135 0.175 0.223 0.239l0.003 0.002 5.808 4.293c0.086 0.073 0.189 0.131 0.301 0.165l0.006 0.002c0.071 0.022 0.153 0.035 0.238 0.035 0.039 0 0.078-0.003 0.115-0.008l-0.004 0c0.243-0.032 0.451-0.164 0.582-0.353l0.002-0.003 4.17-5.46c0.074-0.086 0.132-0.187 0.168-0.298l0.002-0.006c0.023-0.073 0.036-0.158 0.036-0.245 0-0.036-0.002-0.072-0.007-0.107l0 0.004c-0.015-0.124-0.055-0.236-0.114-0.335l0.002 0.004c-0.062-0.103-0.142-0.188-0.235-0.256l-0.003-0.002-5.868-4.641c-0.092-0.074-0.202-0.13-0.322-0.161l-0.006-0.001c-0.064-0.017-0.137-0.027-0.212-0.027-0.054 0-0.107 0.005-0.158 0.015l0.005-0.001c-0.251 0.048-0.46 0.2-0.583 0.408l-0.002 0.004zM1134.069 367.669l-4.12 5.807c-0.062 0.085-0.11 0.185-0.137 0.294l-0.001 0.006c-0.015 0.059-0.023 0.127-0.023 0.197 0 0.046 0.004 0.092 0.011 0.136l-0.001-0.005c0.019 0.117 0.059 0.221 0.116 0.313l-0.002-0.004c0.059 0.096 0.134 0.176 0.221 0.24l0.002 0.002 5.82 4.293c0.145 0.116 0.331 0.186 0.534 0.186 0.043 0 0.086-0.003 0.128-0.009l-0.005 0.001c0.123-0.017 0.234-0.058 0.332-0.118l-0.004 0.002c0.102-0.062 0.187-0.14 0.254-0.233l0.002-0.002 4.168-5.46c0.073-0.086 0.13-0.188 0.164-0.3l0.002-0.006c0.023-0.074 0.036-0.159 0.036-0.247 0-0.035-0.002-0.070-0.006-0.104l0 0.004c-0.016-0.123-0.055-0.235-0.114-0.333l0.002 0.004c-0.061-0.103-0.138-0.189-0.23-0.257l-0.002-0.002-5.881-4.629c-0.091-0.075-0.199-0.132-0.317-0.164l-0.006-0.001c-0.064-0.017-0.138-0.027-0.214-0.027-0.181 0-0.348 0.056-0.486 0.153l0.003-0.002c-0.1 0.070-0.183 0.159-0.243 0.263l-0.002 0.004zM1143.423 374.393l-4.118 5.808c-0.114 0.143-0.183 0.327-0.183 0.526 0 0.048 0.004 0.096 0.012 0.142l-0.001-0.005c0.020 0.124 0.064 0.235 0.127 0.331l-0.002-0.003c0.065 0.1 0.147 0.183 0.242 0.247l0.003 0.002 5.82 4.293c0.086 0.074 0.189 0.131 0.301 0.165l0.006 0.002c0.071 0.022 0.153 0.035 0.237 0.035 0.039 0 0.077-0.003 0.115-0.008l-0.004 0c0.124-0.016 0.236-0.057 0.334-0.118l-0.004 0.002c0.102-0.063 0.187-0.143 0.253-0.238l0.002-0.003 4.168-5.472c0.067-0.082 0.118-0.18 0.148-0.287l0.001-0.006c0.020-0.068 0.031-0.146 0.031-0.226 0-0.036-0.002-0.071-0.007-0.106l0 0.004c-0.016-0.116-0.053-0.221-0.107-0.315l0.002 0.004c-0.057-0.098-0.13-0.18-0.216-0.245l-0.002-0.001-5.87-4.641c-0.086-0.081-0.189-0.145-0.304-0.186l-0.006-0.002c-0.084-0.030-0.182-0.048-0.283-0.048-0.027 0-0.054 0.001-0.080 0.004l0.003-0c-0.129 0.011-0.247 0.049-0.351 0.109l0.004-0.002c-0.109 0.061-0.201 0.14-0.273 0.235l-0.002 0.002zM1152.92 380.945l-4.366 6.204c-0.074 0.103-0.118 0.231-0.118 0.37 0 0.038 0.003 0.074 0.009 0.11l-0.001-0.004c0.029 0.172 0.123 0.318 0.255 0.415l0.002 0.001 6.204 4.541c0.104 0.079 0.235 0.126 0.377 0.126 0.031 0 0.062-0.002 0.092-0.007l-0.003 0c0.17-0.025 0.316-0.114 0.414-0.241l0.001-0.001 4.429-5.808c0.081-0.105 0.13-0.238 0.13-0.382 0-0.028-0.002-0.056-0.005-0.083l0 0.003c-0.023-0.171-0.109-0.317-0.235-0.418l-0.001-0.001-6.204-4.962c-0.114-0.104-0.266-0.168-0.432-0.168-0.031 0-0.062 0.002-0.092 0.007l0.003-0c-0.099 0.014-0.188 0.049-0.265 0.1l0.002-0.001c-0.080 0.053-0.145 0.119-0.195 0.197l-0.002 0.003zM1055.081 296.693l-3.722 5.322c-0.157 0.219-0.25 0.492-0.25 0.788 0 0.456 0.224 0.86 0.568 1.108l0.004 0.003 14.567 10.374c0.218 0.156 0.489 0.249 0.783 0.249 0.073 0 0.144-0.006 0.214-0.017l-0.008 0.001c0.358-0.056 0.664-0.245 0.871-0.515l0.002-0.003 3.971-5.175c0.107-0.138 0.19-0.301 0.237-0.479l0.002-0.009c0.027-0.101 0.042-0.217 0.042-0.337 0-0.073-0.006-0.144-0.017-0.214l0.001 0.008c-0.030-0.192-0.096-0.364-0.192-0.515l0.003 0.006c-0.099-0.157-0.224-0.288-0.37-0.391l-0.004-0.003-14.803-10.522c-0.138-0.1-0.3-0.177-0.475-0.219l-0.009-0.002c-0.092-0.022-0.197-0.035-0.305-0.035-0.080 0-0.159 0.007-0.235 0.020l0.008-0.001c-0.188 0.033-0.355 0.1-0.503 0.195l0.005-0.003c-0.153 0.098-0.281 0.22-0.382 0.363l-0.003 0.004zM1150.49 364.417l-4.579 6.514c-0.073 0.102-0.116 0.229-0.116 0.366 0 0.037 0.003 0.074 0.009 0.109l-0.001-0.004c0.029 0.17 0.123 0.314 0.255 0.408l0.002 0.001 15.746 11.168c0.102 0.072 0.23 0.116 0.367 0.116 0.035 0 0.070-0.003 0.104-0.008l-0.004 0c0.169-0.027 0.314-0.116 0.412-0.243l0.001-0.001 4.839-6.328c0.050-0.065 0.089-0.141 0.111-0.224l0.001-0.004c0.013-0.048 0.021-0.102 0.021-0.158 0-0.034-0.003-0.067-0.008-0.1l0 0.004c-0.013-0.090-0.044-0.17-0.088-0.242l0.002 0.003c-0.047-0.073-0.105-0.134-0.173-0.182l-0.002-0.001-16.007-11.378c-0.066-0.047-0.144-0.081-0.228-0.098l-0.004-0.001c-0.038-0.008-0.082-0.013-0.127-0.013s-0.089 0.005-0.131 0.014l0.004-0.001c-0.088 0.019-0.166 0.055-0.234 0.102l0.002-0.001c-0.070 0.049-0.128 0.11-0.173 0.18l-0.002 0.003zM1086.759 333.644l-4.38 6.056c-0.073 0.104-0.117 0.233-0.117 0.372 0 0.036 0.003 0.071 0.008 0.105l-0.001-0.004c0.026 0.171 0.116 0.318 0.244 0.418l0.001 0.001 34.123 25.164c0.104 0.075 0.234 0.121 0.375 0.121 0.032 0 0.063-0.002 0.094-0.007l-0.003 0c0.169-0.025 0.315-0.112 0.415-0.236l0.001-0.001 4.814-6.316c0.050-0.065 0.089-0.141 0.112-0.224l0.001-0.005c0.013-0.048 0.020-0.103 0.020-0.16 0-0.034-0.003-0.066-0.008-0.099l0 0.004c-0.014-0.089-0.045-0.17-0.090-0.24l0.002 0.003c-0.046-0.074-0.104-0.136-0.173-0.184l-0.002-0.001-34.519-24.904c-0.065-0.052-0.142-0.092-0.227-0.116l-0.005-0.001c-0.049-0.014-0.106-0.022-0.164-0.022-0.033 0-0.066 0.003-0.098 0.008l0.004-0c-0.091 0.014-0.173 0.045-0.244 0.091l0.002-0.001c-0.075 0.047-0.137 0.107-0.186 0.176l-0.001 0.002z',
          'M1068.302 277.659l-3.525 4.962c-0.158 0.22-0.252 0.494-0.252 0.79 0 0.076 0.006 0.15 0.018 0.222l-0.001-0.008c0.055 0.353 0.247 0.67 0.533 0.882l4.964 3.723c0.225 0.169 0.51 0.271 0.818 0.271 0.065 0 0.129-0.005 0.192-0.013l-0.007 0.001c0.366-0.052 0.68-0.243 0.893-0.517l0.002-0.003 3.562-4.666c0.105-0.133 0.186-0.291 0.234-0.462l0.002-0.010c0.031-0.107 0.049-0.231 0.049-0.358 0-0.059-0.004-0.118-0.011-0.175l0.001 0.007c-0.023-0.187-0.082-0.357-0.169-0.508l0.003 0.006c-0.091-0.157-0.206-0.29-0.342-0.397l-0.003-0.002-5.062-3.995c-0.134-0.104-0.292-0.185-0.464-0.233l-0.009-0.002c-0.106-0.029-0.228-0.046-0.354-0.046-0.061 0-0.121 0.004-0.18 0.012l0.007-0.001c-0.188 0.026-0.357 0.085-0.508 0.173l0.007-0.004c-0.157 0.092-0.288 0.208-0.394 0.346l-0.002 0.003zM1077.488 284.26l-3.524 4.964c-0.158 0.22-0.253 0.494-0.253 0.791 0 0.075 0.006 0.148 0.018 0.22l-0.001-0.008c0.055 0.353 0.247 0.67 0.533 0.882l4.964 3.723c0.223 0.169 0.505 0.27 0.811 0.27 0.065 0 0.13-0.005 0.193-0.014l-0.007 0.001c0.365-0.052 0.677-0.242 0.888-0.515l0.002-0.003 3.56-4.666c0.178-0.226 0.286-0.515 0.286-0.829 0-0.059-0.004-0.118-0.011-0.175l0.001 0.007c-0.024-0.187-0.083-0.357-0.17-0.508l0.004 0.007c-0.090-0.157-0.205-0.29-0.341-0.397l-0.003-0.002-5.064-3.995c-0.225-0.172-0.509-0.275-0.818-0.275-0.062 0-0.123 0.004-0.182 0.012l0.007-0.001c-0.364 0.050-0.677 0.238-0.889 0.509l-0.002 0.003zM1087.123 291.134l-3.499 4.964c-0.158 0.22-0.253 0.494-0.253 0.791 0 0.075 0.006 0.148 0.018 0.22l-0.001-0.008c0.056 0.353 0.248 0.67 0.534 0.882l4.964 3.723c0.289 0.21 0.65 0.299 1.004 0.248 0.366-0.054 0.679-0.245 0.892-0.518l0.002-0.003 3.56-4.666c0.178-0.226 0.286-0.515 0.286-0.83 0-0.059-0.004-0.118-0.011-0.175l0.001 0.007c-0.023-0.187-0.082-0.357-0.169-0.508l0.003 0.006c-0.091-0.157-0.206-0.29-0.342-0.397l-0.003-0.002-5.064-3.995c-0.136-0.106-0.296-0.188-0.471-0.235l-0.009-0.002c-0.106-0.029-0.227-0.046-0.353-0.046-0.064 0-0.128 0.004-0.19 0.013l0.007-0.001c-0.19 0.027-0.361 0.089-0.513 0.178l0.007-0.004c-0.158 0.094-0.291 0.214-0.398 0.354l-0.002 0.003zM1096.879 298.194l-3.524 4.964c-0.158 0.22-0.253 0.495-0.253 0.792 0 0.074 0.006 0.147 0.017 0.218l-0.001-0.008c0.056 0.353 0.248 0.67 0.534 0.882l4.962 3.723c0.29 0.21 0.651 0.299 1.006 0.248 0.366-0.054 0.679-0.245 0.892-0.518l0.002-0.003 3.56-4.666c0.105-0.133 0.186-0.291 0.235-0.462l0.002-0.010c0.031-0.107 0.049-0.231 0.049-0.358 0-0.059-0.004-0.118-0.011-0.175l0.001 0.007c-0.024-0.187-0.083-0.357-0.17-0.508l0.003 0.007c-0.090-0.158-0.205-0.29-0.342-0.397l-0.003-0.002-5.062-3.996c-0.135-0.103-0.293-0.183-0.466-0.229l-0.009-0.002c-0.104-0.029-0.223-0.045-0.346-0.045-0.064 0-0.127 0.004-0.189 0.013l0.007-0.001c-0.187 0.027-0.356 0.088-0.507 0.177l0.006-0.004c-0.156 0.093-0.287 0.21-0.393 0.349l-0.002 0.003zM1106.617 305.205l-3.512 4.964c-0.158 0.22-0.253 0.494-0.253 0.791 0 0.075 0.006 0.148 0.018 0.22l-0.001-0.008c0.056 0.353 0.248 0.67 0.534 0.882l4.962 3.723c0.224 0.164 0.505 0.262 0.808 0.262 0.442 0 0.836-0.208 1.088-0.532l0.002-0.003 3.562-4.666c0.175-0.227 0.281-0.515 0.281-0.828 0-0.060-0.004-0.119-0.011-0.177l0.001 0.007c-0.047-0.367-0.234-0.683-0.504-0.898l-0.003-0.002-5.062-3.995c-0.227-0.17-0.512-0.273-0.822-0.273-0.066 0-0.13 0.005-0.193 0.013l0.007-0.001c-0.369 0.051-0.685 0.242-0.9 0.517l-0.002 0.003zM1116.815 311.595l-4.368 6.203c-0.075 0.102-0.121 0.231-0.121 0.37 0 0.035 0.003 0.069 0.008 0.102l-0-0.004c0.027 0.17 0.118 0.316 0.248 0.412l0.002 0.001 6.204 4.541c0.105 0.079 0.238 0.126 0.382 0.126 0.032 0 0.063-0.002 0.093-0.007l-0.003 0c0.173-0.024 0.32-0.114 0.42-0.243l0.001-0.001 4.431-5.807c0.081-0.106 0.13-0.24 0.13-0.385 0-0.028-0.002-0.055-0.005-0.082l0 0.003c-0.022-0.17-0.109-0.317-0.235-0.416l-0.001-0.001-6.204-4.964c-0.068-0.060-0.15-0.107-0.241-0.134l-0.005-0.001c-0.055-0.017-0.118-0.027-0.183-0.027-0.034 0-0.068 0.003-0.1 0.008l0.004-0c-0.099 0.015-0.187 0.051-0.264 0.103l0.002-0.001c-0.079 0.053-0.144 0.121-0.193 0.201l-0.002 0.003zM1126.565 318.606l-4.368 6.204c-0.049 0.064-0.087 0.139-0.107 0.222l-0.001 0.004c-0.012 0.046-0.019 0.099-0.019 0.153 0 0.034 0.003 0.067 0.008 0.1l-0-0.004c0.014 0.088 0.044 0.168 0.087 0.238l-0.002-0.003c0.046 0.072 0.102 0.133 0.169 0.181l0.002 0.001 6.203 4.541c0.106 0.076 0.238 0.122 0.381 0.122 0.032 0 0.063-0.002 0.094-0.007l-0.004 0c0.172-0.024 0.32-0.112 0.422-0.238l0.001-0.001 4.429-5.807c0.081-0.105 0.13-0.239 0.13-0.384 0-0.028-0.002-0.056-0.005-0.083l0 0.003c-0.022-0.171-0.109-0.318-0.235-0.418l-0.001-0.001-6.204-4.962c-0.068-0.061-0.149-0.109-0.238-0.138l-0.005-0.001c-0.057-0.018-0.123-0.028-0.191-0.028-0.031 0-0.061 0.002-0.091 0.006l0.003-0c-0.194 0.028-0.358 0.139-0.457 0.295l-0.002 0.003zM1135.208 324.81l-4.38 6.204c-0.073 0.102-0.117 0.229-0.117 0.366 0 0.037 0.003 0.074 0.009 0.109l-0.001-0.004c0.029 0.17 0.123 0.314 0.254 0.408l0.002 0.001 6.204 4.541c0.106 0.079 0.239 0.126 0.383 0.126 0.032 0 0.063-0.002 0.093-0.007l-0.003 0c0.172-0.024 0.32-0.114 0.42-0.243l0.001-0.001 4.429-5.807c0.081-0.105 0.13-0.238 0.13-0.383 0-0.028-0.002-0.056-0.005-0.083l0 0.003c-0.023-0.17-0.109-0.317-0.235-0.416l-0.001-0.001-6.204-4.964c-0.067-0.063-0.149-0.111-0.24-0.139l-0.004-0.001c-0.056-0.018-0.12-0.028-0.187-0.028-0.234 0-0.438 0.127-0.548 0.315l-0.002 0.003zM1144.869 331.759l-4.381 6.203c-0.073 0.102-0.116 0.229-0.116 0.366 0 0.037 0.003 0.073 0.009 0.109l-0.001-0.004c0.030 0.17 0.124 0.314 0.255 0.408l0.002 0.001 6.203 4.542c0.106 0.079 0.239 0.126 0.383 0.126 0.032 0 0.063-0.002 0.093-0.007l-0.003 0c0.172-0.024 0.32-0.114 0.42-0.243l0.001-0.001 4.429-5.807c0.081-0.105 0.13-0.239 0.13-0.384 0-0.201-0.094-0.38-0.24-0.496l-0.001-0.001-6.204-4.964c-0.068-0.061-0.15-0.108-0.241-0.134l-0.004-0.001c-0.055-0.017-0.118-0.027-0.183-0.027-0.034 0-0.068 0.003-0.1 0.008l0.004-0c-0.099 0.015-0.187 0.051-0.264 0.103l0.002-0.001c-0.079 0.053-0.144 0.121-0.191 0.201l-0.002 0.003zM1154.228 338.483l-4.368 6.204c-0.073 0.103-0.117 0.232-0.117 0.37 0 0.035 0.003 0.069 0.008 0.102l-0-0.004c0.027 0.169 0.116 0.314 0.244 0.411l6.205 4.543c0.063 0.048 0.137 0.086 0.217 0.108l0.004 0.001c0.080 0.021 0.163 0.026 0.245 0.014 0.087-0.013 0.166-0.041 0.235-0.083l-0.003 0.002c0.072-0.044 0.132-0.1 0.18-0.165l0.001-0.002 4.431-5.795c0.082-0.108 0.131-0.244 0.131-0.391 0-0.027-0.002-0.054-0.005-0.081l0 0.003c-0.022-0.173-0.11-0.321-0.236-0.423l-0.001-0.001-6.204-4.902c-0.065-0.061-0.142-0.11-0.228-0.142l-0.005-0.002c-0.064-0.022-0.137-0.035-0.213-0.035-0.021 0-0.041 0.001-0.061 0.003l0.003-0c-0.097 0.008-0.185 0.038-0.263 0.083l0.003-0.002c-0.081 0.046-0.149 0.107-0.202 0.179l-0.001 0.002zM1163.596 345.221l-4.368 6.204c-0.048 0.063-0.085 0.138-0.105 0.219l-0.001 0.004c-0.012 0.045-0.019 0.098-0.019 0.152 0 0.034 0.003 0.067 0.008 0.099l-0-0.003c0.014 0.087 0.044 0.165 0.087 0.234l-0.002-0.003c0.044 0.072 0.101 0.132 0.167 0.179l0.002 0.001 6.204 4.542c0.105 0.079 0.238 0.126 0.382 0.126 0.032 0 0.063-0.002 0.093-0.007l-0.003 0c0.172-0.024 0.32-0.114 0.42-0.243l0.001-0.001 4.429-5.807c0.081-0.105 0.13-0.239 0.13-0.384 0-0.028-0.002-0.056-0.005-0.083l0 0.003c-0.022-0.17-0.109-0.317-0.235-0.416l-0.001-0.001-6.203-4.964c-0.068-0.061-0.15-0.107-0.241-0.135l-0.005-0.001c-0.054-0.016-0.117-0.026-0.181-0.026-0.035 0-0.069 0.003-0.102 0.008l0.004-0c-0.099 0.015-0.188 0.051-0.265 0.103l0.002-0.001c-0.078 0.053-0.143 0.121-0.191 0.199l-0.002 0.003zM1172.964 351.934l-4.38 6.203c-0.073 0.101-0.117 0.228-0.117 0.365 0 0.038 0.003 0.074 0.010 0.11l-0.001-0.004c0.029 0.17 0.123 0.314 0.254 0.41l0.002 0.001 6.204 4.541c0.104 0.078 0.235 0.124 0.377 0.124 0.031 0 0.062-0.002 0.092-0.007l-0.003 0c0.17-0.024 0.316-0.114 0.414-0.241l0.001-0.002 4.429-5.795c0.050-0.063 0.089-0.137 0.112-0.217l0.001-0.004c0.015-0.051 0.023-0.111 0.023-0.172 0-0.027-0.002-0.053-0.005-0.080l0 0.003c-0.012-0.088-0.040-0.167-0.080-0.238l0.002 0.003c-0.043-0.074-0.098-0.137-0.163-0.187l-0.001-0.001-6.204-4.901c-0.064-0.064-0.141-0.115-0.227-0.147l-0.004-0.001c-0.065-0.024-0.14-0.038-0.218-0.038-0.019 0-0.039 0.001-0.058 0.003l0.002-0c-0.097 0.009-0.186 0.039-0.264 0.086l0.003-0.002c-0.081 0.047-0.149 0.11-0.201 0.184l-0.001 0.002zM1061.885 286.568l-3.51 4.964c-0.158 0.22-0.253 0.494-0.253 0.791 0 0.075 0.006 0.148 0.018 0.22l-0.001-0.008c0.055 0.353 0.247 0.67 0.533 0.882l4.964 3.723c0.224 0.164 0.506 0.262 0.81 0.262 0.069 0 0.136-0.005 0.202-0.015l-0.007 0.001c0.366-0.055 0.679-0.245 0.892-0.518l0.002-0.003 3.562-4.666c0.175-0.228 0.281-0.517 0.281-0.832 0-0.059-0.004-0.116-0.011-0.173l0.001 0.007c-0.047-0.367-0.234-0.683-0.504-0.898l-0.003-0.002-5.062-3.995c-0.225-0.17-0.51-0.273-0.819-0.273-0.067 0-0.132 0.005-0.196 0.014l0.007-0.001c-0.369 0.051-0.686 0.242-0.901 0.517l-0.002 0.003zM1047.889 306.024l-3.524 4.964c-0.153 0.218-0.244 0.49-0.244 0.782 0 0.45 0.216 0.85 0.55 1.1l0.004 0.003 4.964 3.723c0.223 0.169 0.505 0.27 0.811 0.27 0.437 0 0.825-0.207 1.072-0.528l0.002-0.003 3.573-4.678c0.172-0.225 0.275-0.509 0.275-0.818 0-0.062-0.004-0.123-0.012-0.182l0.001 0.007c-0.049-0.365-0.237-0.678-0.509-0.89l-0.003-0.002-5.050-3.995c-0.227-0.176-0.515-0.282-0.828-0.282-0.063 0-0.124 0.004-0.184 0.012l0.007-0.001c-0.37 0.049-0.688 0.24-0.902 0.515l-0.002 0.003zM1071.065 293.169l-3.51 4.964c-0.158 0.22-0.253 0.494-0.253 0.791 0 0.447 0.215 0.843 0.547 1.092l0.004 0.003 4.962 3.723c0.29 0.21 0.65 0.299 1.004 0.248 0.366-0.054 0.679-0.245 0.892-0.518l0.002-0.003 3.56-4.666c0.175-0.227 0.281-0.515 0.281-0.828 0-0.060-0.004-0.119-0.011-0.177l0.001 0.007c-0.046-0.367-0.233-0.683-0.503-0.898l-0.003-0.002-5.062-3.995c-0.227-0.17-0.512-0.273-0.822-0.273-0.066 0-0.13 0.005-0.193 0.013l0.007-0.001c-0.369 0.051-0.686 0.242-0.901 0.517l-0.002 0.003zM1080.713 300.092l-3.512 4.964c-0.158 0.219-0.252 0.493-0.252 0.789 0 0.076 0.006 0.15 0.018 0.222l-0.001-0.008c0.055 0.353 0.247 0.67 0.533 0.882l4.964 3.723c0.224 0.167 0.506 0.267 0.812 0.267 0.068 0 0.135-0.005 0.201-0.015l-0.007 0.001c0.366-0.054 0.68-0.247 0.89-0.523l0.002-0.003 3.562-4.666c0.172-0.227 0.276-0.515 0.276-0.827 0-0.432-0.199-0.817-0.509-1.070l-0.003-0.002-5.012-4.008c-0.138-0.111-0.303-0.196-0.481-0.246l-0.010-0.002c-0.107-0.031-0.231-0.049-0.359-0.049-0.067 0-0.133 0.005-0.197 0.015l0.007-0.001c-0.194 0.027-0.369 0.092-0.523 0.187l0.006-0.003c-0.161 0.098-0.295 0.223-0.402 0.369l-0.003 0.004zM1090.463 307.103l-3.512 4.964c-0.158 0.219-0.252 0.493-0.252 0.789 0 0.076 0.006 0.15 0.018 0.222l-0.001-0.008c0.055 0.353 0.247 0.67 0.533 0.884l4.964 3.722c0.289 0.214 0.65 0.305 1.004 0.253 0.367-0.054 0.68-0.247 0.892-0.523l0.002-0.003 3.56-4.666c0.173-0.227 0.277-0.515 0.277-0.827 0-0.060-0.004-0.118-0.011-0.176l0.001 0.007c-0.047-0.366-0.232-0.682-0.499-0.9l-0.003-0.002-5.064-3.983c-0.227-0.176-0.517-0.282-0.83-0.282-0.438 0-0.828 0.206-1.077 0.527l-0.002 0.003zM1057.289 312.327l-3.51 4.964c-0.158 0.22-0.253 0.495-0.253 0.792 0 0.075 0.006 0.149 0.018 0.22l-0.001-0.008c0.059 0.363 0.254 0.672 0.529 0.88l0.004 0.003 4.964 3.722c0.289 0.214 0.65 0.305 1.006 0.253 0.366-0.054 0.68-0.247 0.89-0.523l0.002-0.003 3.562-4.666c0.172-0.225 0.276-0.511 0.276-0.821 0-0.063-0.004-0.124-0.012-0.185l0.001 0.007c-0.048-0.367-0.237-0.683-0.509-0.897l-0.003-0.002-5.050-3.983c-0.228-0.176-0.518-0.282-0.832-0.282-0.062 0-0.122 0.004-0.182 0.012l0.007-0.001c-0.37 0.050-0.687 0.241-0.902 0.516l-0.002 0.003zM1066.936 319.264l-3.512 4.964c-0.157 0.218-0.251 0.489-0.251 0.783 0 0.076 0.006 0.15 0.018 0.222l-0.001-0.008c0.059 0.361 0.253 0.668 0.528 0.873l0.004 0.003 4.964 3.722c0.288 0.21 0.646 0.298 0.998 0.247 0.364-0.053 0.675-0.244 0.885-0.517l0.002-0.003 3.573-4.666c0.173-0.226 0.277-0.513 0.277-0.823 0-0.435-0.204-0.823-0.522-1.073l-0.003-0.002-5.049-3.995c-0.225-0.171-0.51-0.274-0.819-0.274-0.068 0-0.135 0.005-0.2 0.015l0.007-0.001c-0.37 0.054-0.686 0.25-0.897 0.53l-0.002 0.003zM1076.69 326.274l-3.525 4.964c-0.151 0.216-0.242 0.485-0.242 0.775 0 0.079 0.007 0.157 0.020 0.232l-0.001-0.008c0.058 0.349 0.249 0.663 0.534 0.874l4.962 3.722c0.289 0.21 0.647 0.298 0.999 0.248 0.364-0.055 0.675-0.246 0.885-0.518l0.002-0.003 3.573-4.664c0.173-0.226 0.277-0.513 0.277-0.824 0-0.062-0.004-0.123-0.012-0.183l0.001 0.007c-0.050-0.367-0.238-0.683-0.51-0.897l-0.003-0.002-4.989-4.007c-0.139-0.113-0.304-0.199-0.484-0.25l-0.010-0.002c-0.108-0.030-0.232-0.048-0.36-0.048-0.068 0-0.135 0.005-0.201 0.014l0.007-0.001c-0.196 0.030-0.372 0.097-0.527 0.194l0.006-0.003c-0.161 0.099-0.296 0.227-0.4 0.376l-0.003 0.004zM1100.213 314.113l-3.512 4.964c-0.158 0.22-0.253 0.495-0.253 0.792 0 0.075 0.006 0.149 0.018 0.22l-0.001-0.008c0.060 0.363 0.255 0.672 0.531 0.88l0.004 0.003 4.962 3.722c0.289 0.214 0.65 0.305 1.006 0.253 0.366-0.054 0.68-0.247 0.89-0.523l0.002-0.003 3.562-4.666c0.172-0.225 0.276-0.511 0.276-0.821 0-0.063-0.004-0.124-0.012-0.185l0.001 0.007c-0.048-0.367-0.237-0.683-0.509-0.897l-0.003-0.002-4.939-4.007c-0.14-0.121-0.308-0.215-0.492-0.272l-0.010-0.003c-0.117-0.036-0.251-0.057-0.39-0.057-0.064 0-0.126 0.004-0.188 0.013l0.007-0.001c-0.202 0.028-0.384 0.097-0.544 0.198l0.006-0.003c-0.165 0.104-0.302 0.236-0.408 0.392l-0.003 0.005zM1109.969 321.125l-3.51 4.962c-0.158 0.22-0.253 0.495-0.253 0.792 0 0.075 0.006 0.149 0.018 0.22l-0.001-0.008c0.055 0.352 0.247 0.67 0.533 0.882l4.964 3.722c0.222 0.166 0.502 0.266 0.805 0.266 0.068 0 0.136-0.005 0.201-0.015l-0.007 0.001c0.365-0.054 0.676-0.247 0.885-0.522l0.002-0.003 3.573-4.664c0.172-0.227 0.275-0.513 0.275-0.824 0-0.062-0.004-0.123-0.012-0.183l0.001 0.007c-0.049-0.367-0.237-0.682-0.509-0.896l-0.003-0.002-5.050-3.983c-0.228-0.177-0.518-0.283-0.832-0.283-0.062 0-0.122 0.004-0.182 0.012l0.007-0.001c-0.37 0.050-0.688 0.241-0.902 0.517l-0.002 0.003zM1120.163 327.515l-4.38 6.204c-0.073 0.102-0.117 0.229-0.117 0.366 0 0.037 0.003 0.074 0.009 0.109l-0.001-0.004c0.029 0.17 0.123 0.314 0.254 0.408l0.002 0.001 6.204 4.541c0.106 0.079 0.239 0.127 0.384 0.127 0.031 0 0.062-0.002 0.092-0.006l-0.003 0c0.172-0.025 0.32-0.115 0.42-0.243l0.001-0.001 4.429-5.808c0.049-0.062 0.087-0.136 0.108-0.216l0.001-0.004c0.013-0.048 0.021-0.102 0.021-0.158 0-0.031-0.002-0.061-0.007-0.091l0 0.003c-0.012-0.087-0.041-0.166-0.083-0.235l0.002 0.003c-0.045-0.072-0.1-0.133-0.165-0.181l-0.002-0.001-6.204-4.901c-0.063-0.066-0.139-0.118-0.226-0.151l-0.004-0.001c-0.065-0.026-0.14-0.041-0.219-0.041-0.019 0-0.039 0.001-0.058 0.003l0.002-0c-0.098 0.009-0.188 0.040-0.267 0.087l0.003-0.002c-0.081 0.049-0.147 0.114-0.198 0.189l-0.001 0.002zM1128.791 333.719l-4.366 6.204c-0.073 0.103-0.117 0.231-0.117 0.369 0 0.035 0.003 0.069 0.008 0.102l-0-0.004c0.027 0.17 0.116 0.314 0.244 0.412l0.002 0.001 6.203 4.541c0.134 0.1 0.302 0.142 0.466 0.119 0.17-0.025 0.315-0.114 0.414-0.241l0.001-0.001 4.429-5.795c0.082-0.107 0.131-0.242 0.131-0.389 0-0.028-0.002-0.056-0.005-0.084l0 0.003c-0.022-0.172-0.11-0.321-0.236-0.423l-0.001-0.001-6.203-4.901c-0.064-0.064-0.142-0.115-0.228-0.147l-0.004-0.001c-0.064-0.024-0.139-0.038-0.216-0.038-0.019 0-0.039 0.001-0.058 0.003l0.002-0c-0.193 0.018-0.359 0.12-0.463 0.268l-0.001 0.002zM1138.458 340.668l-4.368 6.204c-0.073 0.103-0.116 0.232-0.116 0.37 0 0.034 0.003 0.068 0.008 0.101l-0-0.004c0.028 0.169 0.117 0.314 0.244 0.412l0.001 0.001 6.204 4.541c0.104 0.078 0.236 0.125 0.379 0.125 0.031 0 0.061-0.002 0.090-0.006l-0.003 0c0.17-0.025 0.316-0.115 0.414-0.243l0.001-0.002 4.429-5.793c0.082-0.107 0.131-0.243 0.131-0.391 0-0.028-0.002-0.055-0.005-0.082l0 0.003c-0.022-0.172-0.11-0.321-0.236-0.423l-0.001-0.001-6.204-4.901c-0.064-0.064-0.141-0.115-0.227-0.147l-0.004-0.001c-0.065-0.024-0.14-0.038-0.218-0.038-0.019 0-0.039 0.001-0.058 0.003l0.002-0c-0.097 0.009-0.186 0.039-0.264 0.086l0.003-0.002c-0.081 0.047-0.149 0.11-0.201 0.184l-0.001 0.002zM1147.828 347.405l-4.368 6.204c-0.075 0.103-0.12 0.232-0.12 0.372 0 0.034 0.003 0.068 0.008 0.101l-0-0.004c0.027 0.17 0.119 0.314 0.248 0.411l0.002 0.001 6.204 4.554c0.104 0.075 0.233 0.119 0.373 0.119 0.032 0 0.064-0.002 0.095-0.007l-0.004 0c0.17-0.024 0.315-0.111 0.415-0.236l0.001-0.001 4.429-5.807c0.082-0.107 0.131-0.243 0.131-0.391 0-0.028-0.002-0.056-0.005-0.083l0 0.003c-0.022-0.172-0.11-0.321-0.236-0.423l-0.001-0.001-6.204-4.901c-0.064-0.062-0.142-0.111-0.228-0.142l-0.004-0.001c-0.062-0.023-0.134-0.036-0.209-0.036-0.022 0-0.043 0.001-0.064 0.003l0.003-0c-0.097 0.008-0.186 0.038-0.264 0.083l0.003-0.002c-0.082 0.046-0.15 0.107-0.202 0.179l-0.001 0.002zM1074.039 309.361l-3.512 4.964c-0.158 0.22-0.252 0.494-0.252 0.791 0 0.447 0.215 0.844 0.546 1.093l0.004 0.003 4.964 3.722c0.289 0.214 0.65 0.305 1.006 0.253 0.366-0.054 0.68-0.247 0.89-0.523l0.002-0.003 3.562-4.666c0.175-0.228 0.281-0.517 0.281-0.83 0-0.059-0.004-0.116-0.011-0.173l0.001 0.007c-0.048-0.367-0.234-0.683-0.504-0.9l-0.003-0.002-5.062-3.983c-0.228-0.176-0.518-0.282-0.833-0.282-0.061 0-0.122 0.004-0.181 0.012l0.007-0.001c-0.37 0.050-0.687 0.241-0.902 0.516l-0.002 0.003zM1083.796 316.373l-3.512 4.962c-0.158 0.22-0.253 0.495-0.253 0.792 0 0.075 0.006 0.149 0.018 0.22l-0.001-0.008c0.060 0.363 0.255 0.672 0.531 0.88l0.004 0.003 4.962 3.722c0.289 0.214 0.651 0.305 1.006 0.253 0.367-0.054 0.68-0.247 0.892-0.523l0.002-0.003 3.56-4.664c0.175-0.227 0.281-0.515 0.281-0.829 0-0.060-0.004-0.118-0.011-0.176l0.001 0.007c-0.046-0.367-0.233-0.684-0.503-0.9l-0.003-0.002-5.064-3.982c-0.228-0.177-0.518-0.283-0.832-0.283-0.062 0-0.122 0.004-0.182 0.012l0.007-0.001c-0.369 0.050-0.687 0.241-0.901 0.517l-0.002 0.003zM1093.552 323.395l-3.51 4.964c-0.158 0.22-0.253 0.494-0.253 0.791 0 0.075 0.006 0.148 0.018 0.22l-0.001-0.008c0.055 0.353 0.247 0.67 0.533 0.882l4.964 3.723c0.29 0.21 0.65 0.299 1.004 0.248 0.366-0.054 0.679-0.245 0.892-0.518l0.002-0.003 3.56-4.666c0.175-0.227 0.281-0.515 0.281-0.828 0-0.060-0.004-0.119-0.011-0.177l0.001 0.007c-0.046-0.367-0.233-0.683-0.503-0.898l-0.003-0.002-5.062-3.995c-0.227-0.17-0.513-0.273-0.823-0.273-0.066 0-0.13 0.005-0.193 0.013l0.007-0.001c-0.369 0.052-0.685 0.243-0.9 0.517l-0.002 0.003zM1103.302 330.394l-3.512 4.964c-0.158 0.219-0.252 0.493-0.252 0.789 0 0.076 0.006 0.15 0.018 0.222l-0.001-0.008c0.055 0.353 0.247 0.67 0.533 0.882l4.964 3.723c0.29 0.21 0.65 0.299 1.004 0.248 0.366-0.054 0.679-0.245 0.892-0.518l0.002-0.003 3.562-4.666c0.175-0.228 0.281-0.517 0.281-0.832 0-0.059-0.004-0.116-0.011-0.173l0.001 0.007c-0.048-0.367-0.234-0.683-0.504-0.898l-0.003-0.002-5.062-3.996c-0.227-0.17-0.513-0.273-0.823-0.273-0.066 0-0.13 0.005-0.193 0.013l0.007-0.001c-0.369 0.052-0.685 0.243-0.9 0.518l-0.002 0.003zM1113.503 336.783l-4.38 6.204c-0.073 0.101-0.117 0.228-0.117 0.364 0 0.038 0.003 0.075 0.010 0.111l-0.001-0.004c0.029 0.17 0.123 0.314 0.254 0.408l0.002 0.001 6.204 4.541c0.135 0.101 0.305 0.144 0.471 0.121 0.172-0.025 0.32-0.114 0.42-0.243l0.001-0.001 4.429-5.807c0.081-0.105 0.13-0.239 0.13-0.384 0-0.028-0.002-0.056-0.005-0.083l0 0.003c-0.022-0.17-0.109-0.317-0.235-0.416l-0.001-0.001-6.203-4.964c-0.068-0.061-0.15-0.107-0.241-0.135l-0.005-0.001c-0.054-0.016-0.117-0.026-0.181-0.026-0.035 0-0.069 0.003-0.102 0.008l0.004-0c-0.194 0.030-0.357 0.143-0.454 0.3l-0.002 0.003zM1122.086 342.987l-4.368 6.204c-0.072 0.101-0.115 0.228-0.115 0.364 0 0.038 0.003 0.075 0.010 0.111l-0.001-0.004c0.029 0.17 0.123 0.314 0.254 0.408l0.002 0.001 6.204 4.541c0.104 0.078 0.235 0.126 0.378 0.126 0.031 0 0.062-0.002 0.092-0.007l-0.003 0c0.17-0.025 0.316-0.114 0.414-0.241l0.001-0.001 4.429-5.808c0.081-0.105 0.13-0.238 0.13-0.383 0-0.028-0.002-0.056-0.006-0.084l0 0.003c-0.023-0.17-0.11-0.316-0.235-0.416l-0.001-0.001-6.204-4.962c-0.068-0.061-0.15-0.107-0.241-0.135l-0.005-0.001c-0.054-0.016-0.117-0.026-0.181-0.026-0.035 0-0.069 0.003-0.102 0.008l0.004-0c-0.099 0.015-0.187 0.051-0.263 0.102l0.002-0.001c-0.079 0.053-0.144 0.121-0.193 0.199l-0.002 0.003zM1131.804 349.936l-4.38 6.204c-0.073 0.102-0.117 0.229-0.117 0.366 0 0.211 0.104 0.399 0.263 0.514l0.002 0.001 6.204 4.541c0.104 0.078 0.236 0.125 0.378 0.125 0.204 0 0.386-0.097 0.502-0.247l0.001-0.001 4.429-5.808c0.050-0.061 0.089-0.134 0.112-0.214l0.001-0.004c0.014-0.049 0.022-0.106 0.022-0.165 0-0.028-0.002-0.056-0.006-0.084l0 0.003c-0.011-0.087-0.039-0.166-0.080-0.235l0.002 0.003c-0.042-0.074-0.096-0.135-0.161-0.184l-0.002-0.001-6.203-4.962c-0.067-0.061-0.149-0.108-0.238-0.135l-0.005-0.001c-0.054-0.016-0.116-0.026-0.18-0.026-0.133 0-0.256 0.041-0.358 0.11l0.002-0.001c-0.077 0.053-0.141 0.121-0.189 0.199l-0.002 0.003zM1141.163 356.674l-4.368 6.204c-0.072 0.103-0.115 0.231-0.115 0.369 0 0.035 0.003 0.069 0.008 0.102l-0-0.004c0.027 0.169 0.116 0.314 0.243 0.412l0.001 0.001 6.204 4.554c0.102 0.075 0.231 0.121 0.37 0.121 0.035 0 0.069-0.003 0.102-0.008l-0.004 0c0.17-0.027 0.315-0.118 0.411-0.248l0.001-0.002 4.431-5.795c0.081-0.107 0.13-0.242 0.13-0.388 0-0.029-0.002-0.057-0.006-0.085l0 0.003c-0.022-0.172-0.109-0.32-0.235-0.422l-0.001-0.001-6.204-4.964c-0.068-0.058-0.149-0.103-0.238-0.13l-0.005-0.001c-0.053-0.016-0.114-0.025-0.177-0.025-0.035 0-0.069 0.003-0.102 0.008l0.004-0c-0.097 0.016-0.184 0.051-0.26 0.101l0.002-0.001c-0.078 0.052-0.142 0.118-0.191 0.194l-0.002 0.003zM1157.195 354.131l-4.38 6.204c-0.073 0.101-0.116 0.228-0.116 0.365 0 0.037 0.003 0.073 0.009 0.109l-0.001-0.004c0.029 0.17 0.123 0.315 0.254 0.41l0.002 0.001 6.204 4.541c0.106 0.079 0.239 0.126 0.382 0.126 0.032 0 0.063-0.002 0.094-0.007l-0.003 0c0.172-0.024 0.32-0.114 0.42-0.243l0.001-0.001 4.429-5.795c0.082-0.108 0.131-0.244 0.131-0.391 0-0.027-0.002-0.054-0.005-0.081l0 0.003c-0.022-0.172-0.11-0.321-0.236-0.423l-0.001-0.001-6.204-4.901c-0.063-0.069-0.141-0.123-0.228-0.157l-0.004-0.001c-0.066-0.027-0.143-0.042-0.224-0.042-0.020 0-0.039 0.001-0.058 0.003l0.002-0c-0.1 0.008-0.19 0.040-0.269 0.089l0.002-0.001c-0.082 0.050-0.15 0.116-0.201 0.194l-0.001 0.002zM1166.554 360.868l-4.368 6.204c-0.072 0.102-0.115 0.23-0.115 0.367 0 0.035 0.003 0.070 0.008 0.104l-0-0.004c0.027 0.169 0.116 0.314 0.243 0.412l0.001 0.001 6.204 4.554c0.103 0.075 0.233 0.12 0.373 0.12 0.034 0 0.067-0.003 0.099-0.008l-0.004 0c0.17-0.027 0.315-0.118 0.411-0.248l0.001-0.002 4.429-5.795c0.082-0.107 0.131-0.242 0.131-0.389 0-0.029-0.002-0.057-0.005-0.084l0 0.003c-0.022-0.172-0.11-0.321-0.236-0.423l-0.001-0.001-6.204-4.962c-0.067-0.060-0.149-0.105-0.239-0.13l-0.004-0.001c-0.053-0.016-0.114-0.025-0.177-0.025-0.132 0-0.255 0.040-0.357 0.107l0.002-0.001c-0.078 0.052-0.142 0.119-0.191 0.196l-0.002 0.003zM1124.575 360.012l-4.118 5.807c-0.063 0.085-0.111 0.185-0.138 0.294l-0.001 0.006c-0.015 0.060-0.023 0.128-0.023 0.199 0 0.046 0.004 0.091 0.011 0.136l-0.001-0.005c0.020 0.116 0.060 0.22 0.116 0.312l-0.002-0.004c0.059 0.096 0.134 0.176 0.221 0.24l0.002 0.002 5.82 4.293c0.088 0.070 0.192 0.123 0.305 0.155l0.006 0.001c0.069 0.019 0.147 0.030 0.229 0.030 0.042 0 0.082-0.003 0.122-0.008l-0.005 0.001c0.123-0.018 0.233-0.059 0.331-0.119l-0.004 0.002c0.102-0.062 0.187-0.14 0.254-0.233l0.002-0.002 4.17-5.46c0.073-0.086 0.129-0.188 0.164-0.3l0.002-0.006c0.022-0.073 0.035-0.156 0.035-0.243 0-0.037-0.002-0.072-0.007-0.108l0 0.004c-0.015-0.123-0.054-0.235-0.112-0.334l0.002 0.004c-0.061-0.102-0.139-0.188-0.23-0.257l-0.002-0.002-5.87-4.628c-0.147-0.118-0.336-0.189-0.541-0.189-0.052 0-0.103 0.005-0.153 0.013l0.005-0.001c-0.128 0.024-0.241 0.072-0.341 0.139l0.003-0.002c-0.102 0.070-0.186 0.157-0.25 0.259l-0.002 0.004zM1133.917 366.75l-4.108 5.795c-0.069 0.088-0.121 0.193-0.152 0.306l-0.001 0.006c-0.018 0.066-0.028 0.142-0.028 0.22 0 0.045 0.003 0.090 0.010 0.133l-0.001-0.005c0.020 0.123 0.062 0.233 0.122 0.331l-0.002-0.004c0.063 0.101 0.143 0.185 0.236 0.252l0.003 0.002 5.82 4.293c0.087 0.074 0.19 0.13 0.304 0.164l0.006 0.002c0.069 0.020 0.148 0.032 0.231 0.032 0.042 0 0.083-0.003 0.123-0.009l-0.005 0.001c0.124-0.017 0.235-0.059 0.333-0.121l-0.003 0.002c0.101-0.064 0.185-0.145 0.25-0.24l0.002-0.003 4.181-5.46c0.072-0.086 0.127-0.189 0.161-0.301l0.002-0.006c0.021-0.071 0.033-0.153 0.033-0.238 0-0.039-0.003-0.077-0.008-0.115l0 0.004c-0.017-0.124-0.057-0.235-0.116-0.333l0.002 0.004c-0.062-0.102-0.141-0.187-0.234-0.254l-0.003-0.002-5.868-4.628c-0.089-0.080-0.196-0.142-0.314-0.179l-0.006-0.002c-0.075-0.024-0.162-0.038-0.252-0.038-0.040 0-0.079 0.003-0.118 0.008l0.004-0.001c-0.13 0.018-0.247 0.062-0.349 0.128l0.003-0.002c-0.105 0.068-0.192 0.154-0.258 0.255l-0.002 0.003zM1143.284 373.475l-4.118 5.807c-0.096 0.137-0.153 0.306-0.153 0.49 0 0.050 0.004 0.098 0.012 0.146l-0.001-0.005c0.040 0.227 0.164 0.419 0.338 0.547l0.002 0.002 5.807 4.293c0.091 0.075 0.197 0.129 0.31 0.16 0.069 0.020 0.149 0.032 0.231 0.032 0.041 0 0.082-0.003 0.121-0.008l-0.005 0.001c0.123-0.018 0.234-0.060 0.332-0.12l-0.004 0.002c0.102-0.063 0.187-0.142 0.253-0.236l0.002-0.003 4.17-5.46c0.074-0.086 0.132-0.188 0.168-0.3l0.002-0.006c0.023-0.073 0.036-0.158 0.036-0.245 0-0.036-0.002-0.072-0.007-0.107l0 0.004c-0.015-0.123-0.055-0.235-0.114-0.333l0.002 0.004c-0.062-0.103-0.142-0.188-0.235-0.256l-0.003-0.002-5.868-4.628c-0.147-0.118-0.336-0.189-0.541-0.189-0.052 0-0.103 0.005-0.153 0.013l0.005-0.001c-0.25 0.045-0.46 0.192-0.587 0.395l-0.002 0.004zM1152.772 380.026l-4.368 6.204c-0.072 0.102-0.115 0.23-0.115 0.367 0 0.035 0.003 0.070 0.008 0.104l-0-0.004c0.027 0.169 0.116 0.314 0.243 0.412l0.001 0.001 6.204 4.554c0.103 0.075 0.233 0.12 0.373 0.12 0.034 0 0.067-0.003 0.099-0.008l-0.004 0c0.17-0.027 0.315-0.118 0.411-0.248l0.001-0.002 4.429-5.795c0.082-0.107 0.131-0.242 0.131-0.389 0-0.029-0.002-0.057-0.005-0.084l0 0.003c-0.022-0.172-0.11-0.321-0.236-0.423l-0.001-0.001-6.204-4.962c-0.068-0.058-0.149-0.104-0.238-0.13l-0.005-0.001c-0.053-0.016-0.114-0.025-0.176-0.025-0.035 0-0.069 0.003-0.102 0.008l0.004-0c-0.097 0.016-0.184 0.051-0.26 0.101l0.002-0.001c-0.078 0.052-0.142 0.118-0.191 0.194l-0.002 0.003zM1054.876 295.775l-3.722 5.323c-0.157 0.219-0.25 0.491-0.25 0.786 0 0.081 0.007 0.16 0.021 0.237l-0.001-0.008c0.064 0.366 0.265 0.676 0.549 0.881l0.004 0.003 14.58 10.373c0.289 0.205 0.645 0.289 0.994 0.236 0.361-0.056 0.669-0.247 0.877-0.518l0.002-0.003 3.971-5.174c0.107-0.138 0.19-0.302 0.237-0.48l0.002-0.010c0.027-0.101 0.042-0.217 0.042-0.336 0-0.073-0.006-0.144-0.017-0.214l0.001 0.008c-0.030-0.192-0.096-0.364-0.192-0.516l0.003 0.006c-0.099-0.157-0.224-0.288-0.37-0.391l-0.004-0.003-14.803-10.522c-0.139-0.102-0.303-0.18-0.48-0.223l-0.009-0.002c-0.095-0.024-0.203-0.037-0.315-0.037-0.27 0-0.522 0.079-0.734 0.215l0.005-0.003c-0.155 0.099-0.285 0.223-0.387 0.369l-0.003 0.004zM1150.342 363.499l-4.578 6.514c-0.073 0.102-0.117 0.229-0.117 0.366 0 0.037 0.003 0.074 0.009 0.109l-0.001-0.004c0.029 0.17 0.123 0.314 0.254 0.408l0.002 0.001 15.746 11.167c0.102 0.072 0.228 0.115 0.365 0.115 0.034 0 0.068-0.003 0.101-0.008l-0.004 0c0.167-0.027 0.31-0.116 0.406-0.243l0.001-0.002 4.852-6.328c0.050-0.065 0.088-0.141 0.111-0.224l0.001-0.005c0.013-0.048 0.020-0.102 0.020-0.159 0-0.033-0.003-0.066-0.008-0.098l0 0.004c-0.013-0.090-0.044-0.171-0.089-0.241l0.001 0.002c-0.045-0.074-0.103-0.136-0.171-0.184l-0.002-0.001-16.007-11.378c-0.067-0.046-0.145-0.080-0.23-0.098l-0.004-0.001c-0.037-0.008-0.079-0.012-0.123-0.012-0.046 0-0.090 0.005-0.133 0.014l0.004-0.001c-0.088 0.018-0.166 0.053-0.234 0.101l0.002-0.001c-0.071 0.049-0.129 0.111-0.174 0.181l-0.002 0.003zM1086.618 332.726l-4.405 6.055c-0.073 0.104-0.117 0.233-0.117 0.372 0 0.036 0.003 0.071 0.008 0.105l-0.001-0.004c0.026 0.172 0.116 0.319 0.244 0.419l0.001 0.001 34.123 25.163c0.103 0.076 0.233 0.121 0.373 0.121 0.034 0 0.067-0.003 0.099-0.008l-0.004 0c0.17-0.028 0.315-0.119 0.411-0.249l0.001-0.002 4.814-6.316c0.050-0.064 0.089-0.14 0.112-0.223l0.001-0.004c0.013-0.048 0.020-0.103 0.020-0.16 0-0.034-0.003-0.066-0.008-0.099l0 0.004c-0.015-0.090-0.045-0.17-0.090-0.242l0.002 0.003c-0.046-0.073-0.104-0.134-0.173-0.182l-0.002-0.001-34.519-24.891c-0.064-0.049-0.139-0.086-0.222-0.107l-0.004-0.001c-0.046-0.012-0.099-0.019-0.153-0.019-0.034 0-0.067 0.003-0.1 0.008l0.004-0c-0.088 0.013-0.168 0.043-0.238 0.087l0.003-0.002c-0.073 0.046-0.134 0.102-0.183 0.169l-0.001 0.002z',
          'M1066.613 339.724l-19.306 26.716c-0.412 0.562-0.659 1.268-0.659 2.031 0 0.187 0.015 0.37 0.043 0.549l-0.003-0.020c0.147 0.929 0.646 1.72 1.354 2.248l0.009 0.007 49.831 36.84c0.368 0.27 0.786 0.466 1.23 0.576 0.249 0.064 0.535 0.101 0.829 0.101 0.186 0 0.368-0.015 0.546-0.043l-0.020 0.003c0.48-0.076 0.911-0.238 1.293-0.472l-0.015 0.009c0.396-0.244 0.728-0.55 0.994-0.908l0.007-0.009 19.927-27.299c0.26-0.35 0.459-0.762 0.571-1.209l0.005-0.024c0.062-0.246 0.097-0.528 0.097-0.819 0-0.191-0.015-0.379-0.045-0.561l0.003 0.020c-0.078-0.48-0.244-0.91-0.481-1.291l0.009 0.015c-0.246-0.395-0.556-0.726-0.918-0.988l-0.010-0.007-50.452-36.294c-0.557-0.398-1.253-0.636-2.003-0.636-1.166 0-2.198 0.575-2.829 1.456l-0.007 0.011z',
          'M1066.463 338.806l-19.319 26.703c-0.406 0.563-0.65 1.267-0.65 2.027 0 1.142 0.549 2.156 1.398 2.792l0.009 0.007 49.831 36.84c0.568 0.423 1.284 0.677 2.059 0.677 0.186 0 0.369-0.015 0.547-0.043l-0.020 0.003c0.48-0.074 0.911-0.237 1.292-0.472l-0.015 0.009c0.396-0.244 0.728-0.55 0.994-0.908l0.007-0.009 19.927-27.297c0.258-0.351 0.454-0.764 0.565-1.211l0.005-0.024c0.060-0.243 0.095-0.522 0.095-0.809 0-0.195-0.016-0.386-0.047-0.572l0.003 0.020c-0.080-0.48-0.246-0.909-0.484-1.29l0.009 0.015c-0.246-0.394-0.555-0.725-0.917-0.988l-0.010-0.007-50.44-36.293c-0.557-0.398-1.252-0.636-2.002-0.636-0.208 0-0.412 0.018-0.61 0.054l0.021-0.003c-0.933 0.164-1.723 0.681-2.24 1.406l-0.007 0.011z',
          'M1068.961 214.935l0.831 41.779 125.857 90.17-1.117-41.381c-0.025-1.168-0.324-2.261-0.833-3.224l0.019 0.039c-0.528-1.004-1.249-1.839-2.119-2.484l-0.020-0.014-120.361-86.088c-0.206-0.144-0.459-0.236-0.731-0.253l-0.004-0c-0.024-0.001-0.052-0.002-0.080-0.002-0.249 0-0.483 0.063-0.688 0.173l0.008-0.004c-0.235 0.127-0.426 0.31-0.56 0.532l-0.004 0.007c-0.125 0.209-0.2 0.462-0.2 0.732 0 0.007 0 0.014 0 0.021l-0-0.001z',
          'M69.878 397.811l-55.656 39.965c-1.62 1.163-1.99 3.419-0.827 5.039l61.473 85.612c1.163 1.619 3.419 1.989 5.039 0.826l55.657-39.964c1.619-1.163 1.989-3.419 0.826-5.039l-61.472-85.612c-1.163-1.619-3.419-1.99-5.039-0.827z',
          'M73.39 407.199l-50.657 36.373c-0.057 0.041-0.093 0.107-0.093 0.182 0 0.049 0.016 0.094 0.042 0.131l-0-0.001 12.651 17.618c0.041 0.057 0.107 0.093 0.181 0.093 0.049 0 0.094-0.016 0.131-0.042l-0.001 0 50.657-36.374c0.057-0.041 0.093-0.107 0.093-0.181 0-0.049-0.016-0.094-0.042-0.131l0 0.001-12.651-17.618c-0.041-0.057-0.107-0.094-0.181-0.094-0.049 0-0.094 0.016-0.131 0.043l0.001-0z',
          'M70.012 410.147l-43.501 31.236c-1.865 1.339-2.291 3.936-0.952 5.801l7.642 10.643c1.339 1.864 3.936 2.291 5.801 0.952l43.501-31.236c1.865-1.339 2.291-3.936 0.952-5.8l-7.642-10.644c-1.339-1.864-3.936-2.291-5.801-0.952z',
          'M51.377 461.618l-7.348 5.276c-0.774 0.555-0.951 1.633-0.395 2.406l6.086 8.477c0.556 0.773 1.633 0.95 2.407 0.394l7.348-5.275c0.774-0.555 0.951-1.633 0.395-2.408l-6.086-8.476c-0.556-0.775-1.633-0.95-2.407-0.395zM61.679 452.247l-7.327 5.246c-0.772 0.553-0.949 1.625-0.397 2.397l6.052 8.453c0.552 0.771 1.626 0.949 2.397 0.396l7.327-5.247c0.772-0.551 0.949-1.625 0.397-2.397l-6.052-8.452c-0.553-0.772-1.626-0.949-2.397-0.396zM76.185 443.806l-7.348 5.275c-0.774 0.555-0.951 1.633-0.395 2.408l6.086 8.476c0.556 0.775 1.633 0.95 2.407 0.395l7.348-5.276c0.774-0.555 0.951-1.633 0.395-2.406l-6.086-8.477c-0.556-0.773-1.633-0.95-2.407-0.394zM88.56 435.291l-6.944 4.986c-0.885 0.635-1.087 1.868-0.452 2.754l5.797 8.073c0.636 0.885 1.868 1.088 2.753 0.452l6.944-4.986c0.885-0.635 1.087-1.868 0.452-2.753l-5.797-8.074c-0.636-0.885-1.868-1.087-2.753-0.452zM60.274 474.027l-7.348 5.276c-0.774 0.555-0.951 1.633-0.395 2.406l6.086 8.477c0.556 0.773 1.633 0.95 2.407 0.395l7.348-5.276c0.774-0.555 0.95-1.633 0.395-2.406l-6.086-8.477c-0.555-0.773-1.633-0.95-2.407-0.395zM72.684 465.111l-7.348 5.276c-0.774 0.555-0.951 1.633-0.395 2.408l6.086 8.476c0.556 0.775 1.633 0.95 2.407 0.395l7.348-5.276c0.774-0.555 0.951-1.633 0.395-2.406l-6.086-8.477c-0.556-0.773-1.633-0.95-2.407-0.395zM85.075 456.204l-7.348 5.276c-0.774 0.555-0.951 1.633-0.395 2.406l6.086 8.477c0.556 0.775 1.633 0.95 2.407 0.395l7.348-5.276c0.774-0.555 0.951-1.633 0.395-2.406l-6.086-8.477c-0.556-0.773-1.633-0.95-2.407-0.395zM70.114 487.706l-7.348 5.276c-0.774 0.555-0.951 1.633-0.395 2.406l6.086 8.477c0.556 0.773 1.633 0.95 2.407 0.395l7.348-5.276c0.774-0.555 0.95-1.633 0.395-2.406l-6.086-8.477c-0.555-0.773-1.633-0.95-2.407-0.395zM82.511 478.799l-7.348 5.276c-0.774 0.555-0.951 1.633-0.395 2.406l6.086 8.477c0.556 0.773 1.633 0.95 2.407 0.395l7.348-5.276c0.774-0.555 0.951-1.633 0.395-2.408l-6.086-8.476c-0.556-0.775-1.633-0.95-2.407-0.395zM94.915 469.906l-7.348 5.276c-0.774 0.555-0.951 1.633-0.395 2.406l6.086 8.477c0.556 0.773 1.633 0.95 2.407 0.395l7.348-5.276c0.774-0.555 0.951-1.633 0.395-2.406l-6.086-8.477c-0.556-0.775-1.633-0.95-2.407-0.395zM104.742 483.592l-7.348 5.276c-0.774 0.555-0.951 1.633-0.395 2.406l6.086 8.477c0.556 0.773 1.633 0.95 2.407 0.395l7.348-5.276c0.774-0.555 0.951-1.633 0.395-2.406l-6.086-8.477c-0.556-0.773-1.633-0.95-2.407-0.395zM98.143 447.191l-8.315 5.971c-0.286 0.207-0.471 0.541-0.471 0.917 0 0.247 0.079 0.476 0.214 0.662l-0.002-0.003 6.781 9.444c0.364 0.505 1.069 0.622 1.576 0.257l8.315-5.969c0.506-0.365 0.622-1.070 0.259-1.577l-6.781-9.443c-0.207-0.286-0.541-0.471-0.917-0.471-0.247 0-0.476 0.079-0.662 0.214l0.003-0.002zM91.535 493.063l-18.152 13.035c-1.213 0.87-1.491 2.561-0.62 3.774l4.943 6.884c0.871 1.213 2.561 1.49 3.775 0.62l18.152-13.035c1.213-0.87 1.491-2.561 0.62-3.774l-4.943-6.884c-0.871-1.213-2.561-1.49-3.775-0.62zM106.621 461.484l-6.944 4.987c-1.152 0.827-1.416 2.431-0.588 3.584l14.93 20.792c0.827 1.153 2.432 1.417 3.585 0.588l6.944-4.986c1.152-0.827 1.416-2.431 0.588-3.584l-14.93-20.792c-0.827-1.153-2.432-1.417-3.584-0.589z',
          'M81.451 423.714l-4.445 3.193 0.347 0.483 4.445-3.191-0.347-0.484zM74.938 428.381l-4.445 3.191 0.347 0.483 4.445-3.191-0.347-0.483zM68.432 433.047l-4.445 3.191 0.348 0.484 4.445-3.191-0.347-0.484zM61.938 437.723l-4.445 3.191 0.348 0.484 4.445-3.193-0.347-0.483z',
          'M796.996 84.227h-77.489c-1.116 0.003-2.125 0.457-2.857 1.188l-0 0c-0.732 0.731-1.186 1.741-1.189 2.856l-0 0.001v49.001c0.004 1.073 0.431 2.101 1.188 2.861 0.731 0.734 1.741 1.189 2.857 1.196l0.001 0h60.799s1.577 8.351-3.598 9.257c0 0 11.59 0.831 9.568-9.257h10.72c1.119-0.003 2.131-0.458 2.865-1.192l0-0c0.734-0.733 1.189-1.745 1.192-2.864l0-0.001v-49.001c-0.007-1.117-0.463-2.126-1.196-2.857l-0-0c-0.733-0.731-1.744-1.184-2.86-1.188l-0.001-0z',
          'M787.908 97.219h-59.311c-0.953 0-1.725 0.772-1.725 1.725v0.372c0 0.953 0.772 1.725 1.725 1.725h59.311c0.953 0 1.725-0.772 1.725-1.725v-0.372c0-0.953-0.772-1.725-1.725-1.725zM787.908 114.317h-59.311c-0.953 0-1.725 0.772-1.725 1.725v0.372c0 0.953 0.772 1.725 1.725 1.725h59.311c0.953 0 1.725-0.772 1.725-1.725v-0.372c0-0.953-0.772-1.725-1.725-1.725zM777.783 122.866h-49.186c-0.953 0-1.725 0.772-1.725 1.725v0.372c0 0.953 0.772 1.725 1.725 1.725h49.186c0.952 0 1.724-0.772 1.724-1.725v-0.372c0-0.953-0.772-1.725-1.724-1.725zM752.358 105.768h-23.761c-0.953 0-1.725 0.772-1.725 1.725v0.372c0 0.953 0.772 1.725 1.725 1.725h23.761c0.953 0 1.725-0.772 1.725-1.725v-0.372c0-0.952-0.772-1.725-1.725-1.725z',
          'M797.663 83.917h-77.477c-0-0-0-0-0-0-1.118 0-2.131 0.452-2.865 1.184l0-0c-0.734 0.732-1.189 1.743-1.193 2.86l-0 0.001v48.951c-0 0.006-0 0.013-0 0.021 0 0.555 0.111 1.084 0.312 1.566l-0.010-0.027c0.418 1.004 1.197 1.787 2.171 2.201l0.027 0.010c0.459 0.197 0.994 0.311 1.555 0.311 0.001 0 0.002-0 0.004-0l60.8 0s1.575 8.363-3.598 9.257c0 0 11.576 0.831 9.553-9.257h10.745c1.116-0.003 2.125-0.457 2.857-1.188l0-0c0.732-0.731 1.186-1.741 1.189-2.856l0-0.001v-49.013c-0.011-1.116-0.47-2.122-1.206-2.849l-0-0c-0.732-0.724-1.74-1.171-2.851-1.171-0.004 0-0.008 0-0.013 0l0.001-0z',
          'M788.581 96.883h-59.312c-0.952 0-1.724 0.772-1.724 1.725v0.372c0 0.953 0.772 1.725 1.724 1.725h59.312c0.952 0 1.725-0.772 1.725-1.725v-0.372c0-0.952-0.773-1.725-1.725-1.725zM788.581 113.982h-59.312c-0.952 0-1.724 0.772-1.724 1.725v0.372c0 0.953 0.772 1.725 1.724 1.725h59.312c0.952 0 1.725-0.772 1.725-1.725v-0.372c0-0.953-0.773-1.725-1.725-1.725zM778.455 122.519h-49.186c-0.952 0-1.724 0.772-1.724 1.725v0.372c0 0.953 0.772 1.725 1.724 1.725h49.186c0.953 0 1.725-0.772 1.725-1.725v-0.372c0-0.952-0.772-1.725-1.725-1.725zM753.031 105.432h-23.762c-0.952 0-1.724 0.772-1.724 1.725v0.372c0 0.952 0.772 1.725 1.724 1.725h23.762c0.953 0 1.725-0.772 1.725-1.725v-0.372c0-0.953-0.772-1.725-1.725-1.725z',
          'M871.794 0.782h-93.185c-0.68 0.002-1.327 0.142-1.914 0.395l0.032-0.012c-0.619 0.265-1.147 0.629-1.588 1.080l-0.001 0.001c-0.441 0.449-0.796 0.984-1.037 1.577l-0.012 0.033c-0.218 0.533-0.345 1.152-0.345 1.801 0 0.031 0 0.063 0.001 0.094l-0-0.005v58.815c0 1.291 0.512 2.53 1.423 3.444 0.88 0.882 2.096 1.429 3.44 1.433l0.001 0h73.108s1.887 10.051-4.33 11.168c0 0 13.934 0.993 11.49-11.168h12.917c2.69-0.007 4.87-2.186 4.877-4.876l0-0.001v-58.815c0-0.025 0.001-0.055 0.001-0.085 0-2.013-1.219-3.741-2.96-4.487l-0.032-0.012c-0.557-0.24-1.205-0.379-1.886-0.379-0 0-0 0-0 0l0-0z',
          'M860.887 16.44h-71.348c-1.143 0-2.072 0.928-2.072 2.072v0.459c0 1.144 0.928 2.072 2.072 2.072h71.348c1.145 0 2.072-0.928 2.072-2.072v-0.459c0-1.145-0.927-2.072-2.072-2.072zM847.686 37.001h-58.146c-1.143 0-2.072 0.928-2.072 2.072v0.459c0 1.145 0.928 2.072 2.072 2.072h58.146c1.143 0 2.072-0.928 2.072-2.072v-0.459c0-1.144-0.928-2.072-2.072-2.072zM830.24 26.727h-40.7c-1.143 0-2.072 0.928-2.072 2.072v0.459c0 1.145 0.928 2.072 2.072 2.072h40.7c1.143 0 2.072-0.928 2.072-2.072v-0.459c0-1.144-0.928-2.072-2.072-2.072z',
          'M873.011 0h-93.185c-1.345 0.004-2.561 0.55-3.441 1.433l-0 0c-0.879 0.882-1.423 2.1-1.423 3.444l-0 0v58.877c0.003 1.342 0.548 2.557 1.428 3.436l0 0c0.88 0.88 2.094 1.425 3.435 1.428l0.001 0h73.108s1.887 10.051-4.33 11.167c0 0 13.934 1.005 11.502-11.167h12.905c1.343-0.003 2.559-0.548 3.44-1.428l-0 0c0.882-0.879 1.43-2.093 1.438-3.435l0-0.001v-58.877c-0.004-1.346-0.551-2.563-1.432-3.445l0 0c-0.882-0.882-2.099-1.428-3.444-1.432l-0.001-0z',
          'M862.099 15.635h-71.348c-1.143 0-2.072 0.928-2.072 2.072v0.459c0 1.144 0.928 2.072 2.072 2.072h71.348c1.145 0 2.072-0.928 2.072-2.072v-0.459c0-1.145-0.927-2.072-2.072-2.072zM848.896 36.195h-58.145c-1.143 0-2.072 0.928-2.072 2.072v0.459c0 1.145 0.928 2.072 2.072 2.072h58.145c1.145 0 2.073-0.928 2.073-2.072v-0.459c0-1.144-0.928-2.072-2.073-2.072zM831.451 25.909h-40.7c-1.143 0-2.072 0.928-2.072 2.072v0.459c0 1.144 0.928 2.072 2.072 2.072h40.7c1.143 0 2.072-0.928 2.072-2.072v-0.459c0-1.144-0.928-2.072-2.072-2.072z',
          'M263.171 640.499l84.164-31.442c0.833-0.322 1.797-0.509 2.804-0.509 0.099 0 0.197 0.002 0.295 0.005l-0.014-0c1.11 0.040 2.15 0.3 3.091 0.737l-0.049-0.021c0.99 0.458 1.831 1.074 2.529 1.824l0.004 0.005c0.715 0.771 1.273 1.675 1.638 2.661 0.321 0.833 0.507 1.796 0.507 2.804 0 1.202-0.265 2.343-0.741 3.366l0.021-0.049c-0.894 1.929-2.475 3.414-4.422 4.16l-0.055 0.018-84.165 31.442-18.042-1.812 12.434-13.19z',
          'M355.090 611.265c0.321 0.834 0.507 1.798 0.507 2.806 0 1.204-0.265 2.346-0.74 3.37l0.021-0.050c-0.893 1.932-2.475 3.419-4.423 4.167l-0.055 0.019-84.165 31.442-13.536-1.365-1.961 2.073 18.042 1.812 84.165-31.443c2.002-0.764 3.583-2.248 4.456-4.128l0.021-0.049c0.455-0.974 0.72-2.114 0.72-3.317 0-1.007-0.186-1.971-0.526-2.858l0.018 0.055c-0.638-1.691-1.781-3.070-3.242-3.989l-0.033-0.019c0.273 0.423 0.52 0.91 0.715 1.422l0.018 0.054z',
          'M263.182 640.499l5.61 15.002-18.042-1.812 12.432-13.19z',
          'M255.166 648.999c0.345 0.256 0.631 0.569 0.849 0.928l0.008 0.014c0.135 0.207 0.215 0.46 0.215 0.732s-0.080 0.525-0.218 0.737l0.003-0.005c-0.233 0.226-0.499 0.42-0.789 0.575l-0.019 0.009c-0.349 0.224-0.635 0.515-0.847 0.856l-0.007 0.011c-0.206 0.33-0.345 0.722-0.386 1.143l-0.001 0.011-3.239-0.323 4.429-4.689z',
          'M802.152 572.289l-26.793 6.905 22.583 87.622 26.793-6.905-22.583-87.622z',
          'M801.846 572.999l-25.467 6.564 22.279 86.443 25.469-6.564-22.28-86.443z',
          'M798.48 575.319l-18.005 4.641 4.641 18.005 18.005-4.641-4.641-18.005z',
          'M803.335 593.467l-17.963 4.682 4.683 17.963 17.962-4.683-4.682-17.962z',
          'M808.989 615.152l-17.963 4.683 4.683 17.962 17.962-4.682-4.682-17.963z',
          'M774.281 581.271l-23.178 15.023 48.95 75.521 23.178-15.024-48.95-75.52z',
          'M774.206 582.023l-22.033 14.281 48.289 74.5 22.032-14.281-48.288-74.5z',
          'M771.776 585.313l-15.577 10.096 10.096 15.578 15.578-10.097-10.097-15.577z',
          'M783.974 604.106l-15.577 10.097 10.096 15.577 15.578-10.097-10.097-15.577z',
          'M796.173 622.918l-15.577 10.097 10.096 15.577 15.578-10.096-10.097-15.578z',
          'M760.118 591.382l-19.65 19.411 63.248 64.025 19.65-19.411-63.248-64.025z',
          'M760.224 592.129l-18.679 18.452 62.392 63.16 18.679-18.453-62.392-63.158z',
          'M758.507 595.859l-13.206 13.045 13.045 13.206 13.206-13.045-13.045-13.206z',
          'M774.25 611.795l-13.206 13.045 13.045 13.206 13.206-13.045-13.045-13.206z',
          'M789.982 627.736l-13.206 13.045 13.045 13.206 13.206-13.045-13.045-13.206z',
          'M752.607 600.531l-17.063 21.721 70.774 55.594 17.061-21.722-70.773-55.593z',
          'M752.783 601.259l-16.219 20.648 69.817 54.842 16.219-20.648-69.817-54.842z',
          'M751.537 605.17l-11.466 14.597 14.597 11.466 11.466-14.597-14.597-11.466z',
          'M769.159 619.013l-11.467 14.597 14.599 11.467 11.466-14.599-14.597-11.466z',
          'M786.794 632.848l-11.467 14.597 14.599 11.466 11.466-14.597-14.597-11.466z',
          'M1035.594 696.411c-2.358-1.116-5.122-1.767-8.038-1.767-1.050 0-2.081 0.084-3.085 0.247l0.11-0.015c-3.904 0.629-7.324 2.357-10.024 4.852l0.013-0.012c-2.713 2.508-4.693 5.771-5.608 9.454l-0.028 0.132c-0.889 3.682-0.667 7.546 0.638 11.103 1.306 3.555 3.637 6.645 6.698 8.877 3.122 2.298 7.043 3.678 11.286 3.678 3.69 0 7.136-1.043 10.060-2.851l-0.082 0.047c3.235-1.972 5.811-4.86 7.404-8.296 2.136-4.615 2.351-9.888 0.599-14.66-1.801-4.812-5.336-8.622-9.825-10.74l-0.117-0.050zM1022.552 724.577c-2.159-1.014-3.912-2.588-5.118-4.536l-0.029-0.051c-1.093-1.762-1.741-3.9-1.741-6.19 0-0.17 0.004-0.34 0.011-0.509l-0.001 0.024c0.206-4.893 3.343-9.004 7.693-10.637l0.082-0.027c1.216-0.46 2.621-0.726 4.089-0.726 3.452 0 6.559 1.472 8.73 3.823l0.007 0.008c1.539 1.668 2.609 3.79 2.988 6.143l0.009 0.068c0.091 0.551 0.142 1.186 0.142 1.833 0 1.813-0.406 3.531-1.133 5.067l0.031-0.072c-1.341 2.853-3.701 5.043-6.599 6.13l-0.082 0.027c-1.216 0.46-2.621 0.727-4.089 0.727-0.171 0-0.342-0.004-0.512-0.011l0.024 0.001c-1.647-0.070-3.184-0.466-4.574-1.123l0.072 0.031z',
          'M1011.892 647.249l-35.648 25.077c-2.306 1.607-4.168 3.693-5.471 6.124l-0.046 0.093c-1.257 2.337-2.001 5.112-2.015 8.059l-0 0.004c0 9.009 4.107 22.533 23.761 34.744 2.9 1.8 6.256 2.728 9.669 2.674 3.412-0.055 6.737-1.091 9.577-2.985l34.742-23.24-34.569-50.551z',
          'M1051.29 695.964c-5.72 4.752-19.281-2.208-30.313-15.535-11.030-13.326-15.348-27.957-9.628-32.696 5.72-4.741 19.306 2.22 30.338 15.535 0.694 0.856 1.39 1.712 2.023 2.568l0.719 0.981c4.093 5.33 7.096 11.414 8.834 17.906 0.125 0.595 0.248 1.179 0.323 1.749 0.658 4.208-0.037 7.645-2.296 9.493z',
          'M1047.478 691.317c4.624-3.829 1.141-15.666-7.781-26.438-8.921-10.773-19.901-16.401-24.525-12.573-4.624 3.829-1.14 15.666 7.782 26.439 8.921 10.772 19.901 16.401 24.523 12.572z',
          'M1048.623 689.946c-0.087 0.161-0.186 0.31-0.273 0.459-0.257 0.357-0.547 0.667-0.873 0.936l-0.008 0.007c-2.816 2.346-8.003 1.167-13.649-2.481l-0.583-0.398c-1.961-1.365-3.677-2.759-5.286-4.266l0.025 0.023c-1.782-1.672-3.429-3.426-4.962-5.278l-0.077-0.095c-1.079-1.241-2.060-2.593-2.964-3.895-1.197-1.68-2.371-3.605-3.41-5.612l-0.127-0.27c-0.041-0.063-0.083-0.136-0.12-0.212l-0.005-0.012c-3.722-7.308-4.355-13.798-1.154-16.44 4.629-3.835 15.609 1.799 24.531 12.569 1.067 1.242 2.060 2.594 2.953 3.91 0.2 0.26 0.385 0.533 0.559 0.806 5.509 8.153 7.693 16.205 5.422 20.25z',
          'M1053.264 684.723c-0.864 1.724-2.283 3.063-4.019 3.802l-0.052 0.020-0.57 0.198c-0.359 0.115-0.78 0.202-1.214 0.246l-0.027 0.002c-0.302 0.031-0.652 0.049-1.006 0.049-1.2 0-2.351-0.205-3.423-0.581l0.072 0.022c-5.856-1.848-8.562-1.812-9.79-1.241-1.961-1.366-3.678-2.759-5.287-4.267l0.025 0.024c-1.782-1.672-3.429-3.426-4.961-5.278l-0.077-0.095c-1.079-1.241-2.060-2.593-2.966-3.895-1.196-1.68-2.37-3.604-3.409-5.61l-0.128-0.271c5.92 2.357 17.459 6.526 21.343 4.752 1.853-1.050 3.362-2.511 4.437-4.266l0.030-0.053 0.385-0.595 0.16-0.261c0.311-0.508 0.621-1.004 0.894-1.525 5.012 6.539 8.326 13.263 9.58 18.823z',
          'M1053.586 686.473c-0.455 1.136-1.12 2.101-1.955 2.888l-0.004 0.004c-0.831 0.785-1.834 1.395-2.947 1.769l-0.057 0.016c-0.359 0.115-0.78 0.203-1.215 0.246l-0.026 0.002c-0.302 0.031-0.652 0.049-1.006 0.049-1.2 0-2.351-0.205-3.423-0.581l0.072 0.022c-4.231-1.327-6.824-1.687-8.388-1.575-0.509 0.017-0.989 0.125-1.429 0.308l0.027-0.010c-1.961-1.366-3.678-2.76-5.287-4.268l0.025 0.023c-1.782-1.671-3.429-3.425-4.961-5.277l-0.077-0.095c-1.079-1.241-2.060-2.594-2.966-3.896-1.201-1.682-2.375-3.607-3.411-5.614l-0.125-0.267c0.261 0.112 0.521 0.223 0.819 0.323 6.118 2.406 16.813 6.116 20.523 4.441 1.86-1.059 3.373-2.532 4.449-4.301l0.030-0.054 0.385-0.596 0.161-0.26c0.075-0.107 0.153-0.233 0.224-0.363l0.011-0.022c0.503-0.832 0.962-1.69 1.378-2.569 4.093 5.33 7.094 11.415 8.834 17.906 0.137 0.596 0.261 1.179 0.335 1.75z',
          'M1067.756 647.659c-1.389 1.103-2.937 1.99-4.591 2.631-3.253 1.375-5.851 3.771-7.448 6.779l-0.039 0.081c-1.615 3.093-2.091 6.656-1.347 10.065l0.074 0.31c2.023 8.524 1.142 20.435-5.782 22.422-0.358 0.114-0.779 0.201-1.213 0.246l-0.027 0.002c-0.301 0.031-0.65 0.049-1.003 0.049-1.201 0-2.353-0.204-3.426-0.58l0.073 0.022c-5.856-1.848-8.561-1.812-9.79-1.241-1.961-1.366-3.678-2.759-5.287-4.267l0.025 0.024c-1.782-1.672-3.429-3.426-4.961-5.278l-0.077-0.095c-1.079-1.241-2.060-2.593-2.966-3.896-1.196-1.68-2.37-3.604-3.409-5.61l-0.128-0.271c5.92 2.358 17.459 6.527 21.343 4.766 1.86-1.059 3.373-2.533 4.449-4.302l0.030-0.054 0.385-0.595 0.161-0.261c2.598-4.201 4.121-8.978 4.429-13.909 0.459-6.701 3.425-18.339 18.811-14.692 0.829 0.198 1.543 0.611 2.103 1.176l0 0c0.559 0.565 0.966 1.283 1.151 2.086l0.006 0.029c0.066 0.285 0.104 0.613 0.104 0.949 0 0.522-0.092 1.023-0.26 1.486l0.010-0.030c-0.286 0.794-0.77 1.457-1.393 1.953l-0.009 0.007z',
          'M888.445 971.477s-52.462-3.165-46.27 33.6c0 0-1.241 6.489 4.654 9.443 0 0 0.098-2.729 5.385-1.8 1.88 0.318 3.793 0.41 5.695 0.273 2.691-0.182 5.104-1.241 6.987-2.889l-0.014 0.012s14.74-6.093 20.485-30.19c0 0 4.231-5.26 4.070-6.614l-8.859 3.785s3.027 6.391 0.645 11.688c0 0-0.285-11.452-1.985-11.167-0.348 0-4.604 2.221-4.604 2.221s5.212 11.167 1.242 19.208c0 0 1.501-13.649-2.904-18.402l-6.204 3.637s6.080 11.49 1.961 20.858c0 0 1.054-14.369-3.264-19.977l-5.646 4.405s5.708 11.328 2.221 19.096c0 0-0.446-16.738-3.449-18.004 0 0-4.964 4.355-5.696 6.203 0 0 3.921 8.214 1.49 12.557 0 0-1.49-11.167-2.718-11.167 0 0-4.964 7.445-5.423 12.409 0 0 0.211-7.545 4.231-13.166-2.955 0.57-5.522 1.951-7.536 3.9l0.004-0.004s0.769-5.224 8.749-5.67c0 0 4.070-5.608 5.161-5.956 0 0-7.941-0.658-12.755 1.477 0 0 4.231-4.964 14.207-2.693l5.572-4.554s-10.447-1.427-14.89 0.161c0 0 5.112-4.368 16.392-1.241l6.080-3.623s-8.922-1.923-14.232-1.241c0 0 5.608-3.027 16.006 0.248l4.344-1.948s-6.539-1.241-8.451-1.489c-1.911-0.248-2.010-0.733-2.010-0.733 4.138-0.689 8.386-0.217 12.271 1.365 0 0 9.22-3.437 9.058-4.020z',
          'M852.312 1024c20.504 0 37.125-2.811 37.125-6.279 0-3.467-16.622-6.278-37.125-6.278-20.505 0-37.127 2.811-37.127 6.278 0 3.468 16.622 6.279 37.127 6.279z',
          'M989.078 874.618s-29.569-1.787-26.057 18.935c-0.046 0.256-0.072 0.551-0.072 0.851 0 0.815 0.193 1.584 0.536 2.265l-0.013-0.029c0.473 0.957 1.235 1.739 2.179 2.234 0 0 0-1.525 3.029-1.004 1.061 0.175 2.14 0.224 3.214 0.148 1.517-0.108 2.877-0.705 3.941-1.632l-0.008 0.007s8.313-3.425 11.54-17.023c0 0 2.395-2.954 2.295-3.723l-4.962 2.135s1.7 3.598 0.36 6.588c0 0-0.161-6.464-1.117-6.303-0.198 0-2.593 1.241-2.593 1.241s2.941 6.279 0.719 10.832c0 0 0.844-7.73-1.638-10.373l-3.51 1.998s3.424 6.476 1.104 11.763c0 0 0.595-8.103-1.837-11.267l-3.189 2.481s3.226 6.378 1.241 10.757c0 0-0.248-9.43-1.948-10.149-1.204 1.023-2.257 2.164-3.162 3.419l-0.039 0.056s2.196 4.628 0.831 7.072c0 0-0.831-6.291-1.527-6.316 0 0-2.779 4.17-3.064 7.024 0.134-2.648 0.96-5.216 2.395-7.445-1.669 0.323-3.119 1.101-4.259 2.199l0.003-0.003s0.435-2.941 4.964-3.202c0 0 2.295-3.164 2.903-3.35 0 0-4.479-0.372-7.184 0.832 0 0 2.383-2.781 8.003-1.515l3.152-2.568s-5.895-0.806-8.401 0.087c0 0 2.879-2.481 9.245-0.67l3.424-2.048c-2.010-0.46-4.319-0.723-6.689-0.723-0.471 0-0.94 0.010-1.406 0.031l0.066-0.002s3.164-1.7 9.034 0.148l2.481-1.104s-3.722-0.719-4.764-0.831c-1.042-0.112-1.129-0.421-1.129-0.421 0.631-0.111 1.358-0.174 2.099-0.174 1.735 0 3.389 0.347 4.896 0.974l-0.084-0.031s5.1-1.85 5.001-2.171z',
          'M968.708 904.224c11.561 0 20.933-1.583 20.933-3.537 0-1.952-9.372-3.535-20.933-3.535s-20.933 1.583-20.933 3.535c0 1.953 9.372 3.537 20.933 3.537z',
          'M814.503 892.597s-35.698-2.16-31.492 22.868c-0.055 0.308-0.086 0.662-0.086 1.023 0 0.986 0.234 1.917 0.648 2.742l-0.016-0.035c0.582 1.162 1.488 2.089 2.598 2.682l0.033 0.016s0.062-1.848 3.722-1.241c1.28 0.21 2.578 0.273 3.872 0.186 1.831-0.137 3.473-0.856 4.763-1.97l-0.010 0.009s10.039-4.143 13.934-20.56c0 0 2.892-3.573 2.781-4.491l-6.031 2.568s2.060 4.356 0.435 7.966c0 0-0.186-7.805-1.352-7.618-0.236 0-3.127 1.501-3.127 1.501s3.549 7.582 0.868 13.078c0 0 1.017-9.33-1.972-12.532l-4.244 2.483s4.145 7.817 1.329 14.207c0 0 0.719-9.791-2.221-13.649l-3.847 2.991s3.896 7.705 1.525 13.003c0 0-0.31-11.391-2.358-12.259 0 0-3.362 2.966-3.87 4.193 0 0 2.668 5.585 1.004 8.55 0 0-1.004-7.595-1.837-7.631 0 0-3.35 4.964-3.722 8.474 0.16-3.186 1.153-6.275 2.879-8.959-2.010 0.392-3.757 1.333-5.128 2.659l0.003-0.003s0.521-3.562 5.956-3.872c0 0 2.767-3.81 3.512-4.045 0 0-5.41-0.446-8.686 1.004 0 0 2.878-3.362 9.678-1.835l3.797-3.090s-7.122-0.981-10.138 0.1c0 0 3.474-2.966 11.167-0.807l4.133-2.481s-6.068-1.241-9.691-0.831c0 0 3.822-2.060 10.895 0.173l2.966-1.327s-4.456-0.881-5.758-1.017c-1.302-0.137-1.365-0.496-1.365-0.496 2.816-0.469 5.707-0.147 8.351 0.931 0 0 6.216-2.259 6.105-2.656z',
          'M789.916 928.345c13.959 0 25.276-1.911 25.276-4.269 0-2.357-11.317-4.268-25.276-4.268s-25.276 1.911-25.276 4.268c0 2.358 11.317 4.269 25.276 4.269z',
          'M739.921 364.702s1.936-5.793-0.769-8.797l-5.608-6.203-28.539-41.395s-6.947-8.239-5.793-13.103c1.154-4.864-6.564-10.113-6.564-10.113s4.193-5.199 1.737-8.301c-2.456-3.102-6.378-7.866-6.378-9.555 0-1.687-14.828-23.576-34.148-28.911l0.596-0.435c-0.924-0.219-2.077-0.416-3.25-0.546l-0.137-0.012c-13.984-1.539-20.598-2.333-32.622-7.445l-0.645 0.683-1.663-0.683c-3.387-1.439-7.197-3.201-11.713-5.422s-9.368-4.691-15.286-7.768c-3.221-3.886-5.764-8.469-7.365-13.473l-0.080-0.288c-0.168-0.457-0.364-1.099-0.533-1.752l-0.038-0.171c6.57-3.749 11.901-8.987 15.652-15.277l0.107-0.195c3.795-6.456 5.816-13.803 5.856-21.294 0-0.012 0-0.027 0-0.042 0-7.727-2.111-14.961-5.789-21.156l0.105 0.192c-0.236-0.41-0.509-0.794-0.757-1.241 0.087-0.1 0.175-0.186 0.248-0.286 0.233-0.307 0.463-0.655 0.67-1.018l0.025-0.048c0.355-0.646 0.702-1.416 0.991-2.213l0.038-0.119c0.15-0.398 0.285-0.794 0.421-1.242 0.559-1.625 1.117-3.251 1.688-4.876l1.675-4.876c1.062-2.688 1.79-5.8 2.040-9.047l0.007-0.11c0.009-0.169 0.013-0.367 0.013-0.566 0-1.196-0.177-2.351-0.507-3.439l0.022 0.084c-0.221-0.698-0.482-1.297-0.796-1.863l0.026 0.052c-0.189-0.34-0.369-0.623-0.565-0.896l0.019 0.027c-2.829-3.995-8.896-5.67-10.199-10.348-0.166-0.634-0.261-1.361-0.261-2.111 0-0.056 0.001-0.112 0.002-0.169l-0 0.008v-3.462c-0.009-0.362-0.045-0.709-0.106-1.046l0.006 0.041c-0.070-0.428-0.16-0.8-0.276-1.161l0.016 0.056c0-0.087 0-0.174-0.088-0.248-0.141-0.398-0.284-0.726-0.444-1.043l0.023 0.050c-0.2-0.383-0.402-0.708-0.624-1.017l0.017 0.024c-0.031-0.052-0.064-0.096-0.101-0.137l0.001 0.001c-2.16-2.626-5.086-4.55-8.436-5.434l-0.113-0.025c-2.85-0.871-6.125-1.373-9.518-1.373-4.917 0-9.588 1.054-13.799 2.948l0.213-0.086c-0.936 0.541-2.045 0.891-3.229 0.967l-0.022 0.001c-1.837 0-3.251-1.514-4.839-2.407-5.112-2.891-11.515 0.174-16.429 3.375-2.537 1.495-4.697 3.319-6.51 5.449l-0.030 0.036c-1.613 2.134-2.481 4.69-4.008 6.899-4.714 7.011-14.121 9.269-20.933 14.406-7.37 5.559-11.477 14.505-12.494 23.501s0.806 18.104 3.549 26.764c0.361 1.177 0.71 2.119 1.104 3.037l-0.075-0.196c-1.054 11.949 3.896 27.162 4.604 29.78 1.166 4.306-13.898 17.979-13.898 17.979l-46.369 40.141s-0.186-1.154-6.131-0.731c-5.943 0.421-17.085 13.909-17.085 13.909l0.893 0.075c-0.571 0.656-0.893 1.054-0.893 1.054l2.42 0.198c-7.197 6.204-15.684 13.649-20.089 18.004-1.241 1.167-2.234 2.171-2.954 2.954-6.204 6.737-2.122 25.288-2.122 25.288s-0.968 11.416 17 12.917c0 0 20.858 4.12 31.094 0 10.237-4.12 29.68-5.149 29.68-5.149s-7.953 26.69-7.445 34.556c0.509 7.868-5.31 35.823-5.31 35.823l-17.768 93.397s-16.628 32.459 33.502 37.225v1.514s1.241 0.186 3.189 0.396c-0.087 1.067-0.173 2.185-0.261 3.339-0.645 8.189-1.339 18.041-1.004 19.108 0.711 1.469 1.769 2.674 3.070 3.541l0.032 0.020 1.935 16.479s1.923 14.194 3.723 18.339c1.799 4.145 6.203 15.188 5.409 18.748-0.793 3.562 2.892 15.349 2.892 15.349s1.737 11.428 2.32 14.232c0.583 2.804 0 30.709 0 30.709 3.633 1.796 7.458 3.169 11.403 4.095 0.112 0.448 0.223 0.919 0.348 1.39 1.824 7.445 4.38 17.769 5.782 23.141 2.308 8.984 7.333 24.718 7.333 24.718s0.571 20.424 4.045 24.357c3.475 3.933 2.706 42.51 17.371 66.099 10.535 16.937 23.452 49 29.905 65.763-0.236 7.568-0.596 15.833-1.117 22.893-1.882 1.975-3.281 4.428-3.994 7.157l-0.025 0.114c-1.737 8.424-12.545 22.645-12.545 22.645s-11.005 9.182-15.646 10.497c-0.892 0.307-1.665 0.728-2.352 1.255l0.019-0.014c-4.764 3.387-10.361 12.321 0.981 15.833 4.343 1.34 10.534 1.241 17.26 0.236-0.093 1.168-0.093 2.342 0 3.512 0 0-5.795 14.231-8.314 19.666-0.918 1.985-2.977 4.839-4.802 7.855-3.201 5.285-5.67 11.055 0 13.5 1.738 0.746 31.678-0.558 41.717 2.619 10.038 3.176 17.185-7.308 17.185-7.308s0.769-10.672 3.089-15.163c1.315-2.569 0.385-8.203-0.656-12.594-0.807-3.325-1.663-5.931-1.663-5.931-1.429-8.039-2.325-17.386-2.479-26.914l-0.002-0.149 14.778-10.77c2.132-1.538 3.767-3.643 4.698-6.095l0.030-0.091c0.528-1.377 0.833-2.969 0.833-4.632 0-1.115-0.137-2.198-0.396-3.232l0.019 0.092-0.496-1.973c-2.295-9.009-5.893-21.354-9.703-27.297 0.542-2.215 1.377-4.347 2.481-6.341 4.629-6.737 13.141-48.503 15.263-54.881 0.635-2.212 1.149-4.457 1.539-6.726 2.668-13.153 6.712-45.166 0.148-59.981l-3.362-36.183s-1.923-27.707 0.198-38.378c1.142-6.904 1.879-13.869 2.208-20.859v-0.496l20.015 0.981v-93.496l1.75-32.831 0.173-3.325c0.884 0.307 1.788 0.557 2.704 0.744 3.797-2.42 4.752-8.314 4.579-14.357 0.002-0.202 0.004-0.441 0.004-0.68 0-3.175-0.245-6.294-0.717-9.337l0.043 0.339c3.186-3.101 5.429-7.042 6.464-11.366l41.903-37.87 0.173-0.335c0.943-1.898 5.695-11.478 7.52-16.528 1.675-4.664 0.57-29.779 0.137-38.118 2.741 0.236 6.067 0.496 9.232 0.658 4.814 0.261 9.219 0.286 10.609-0.31 3.487-1.502 7.916-11.999 11.39-18.352 3.475-6.353-2.283-20.598-2.283-20.598zM520.743 217.926s0.979-9.318 1.091-20.821l6.204-2.060c0.944 0.881 1.911 1.725 2.929 2.481 0.165 0.828 0.314 1.696 0.446 2.606 1.079 6.999 1.527 15.275-0.248 22.733-0.298 0.21-8.499 5.757-10.497 11.688-1.054 3.164-4.281 4.516-7.135 5.1-1.259 0.252-2.706 0.396-4.187 0.396-0.247 0-0.492-0.004-0.737-0.012l0.036 0.001s-3.027 0.496-7.605 1.241l19.704-23.352zM562.038 665.13c-0.261-0.708-0.484-1.34-0.696-1.898l0.534-0.323v-4.306c0.049 1.675 0.087 3.921 0.161 6.477v0.050z',
          'M631.31 251.143s-20.933 26.728-37.696 47.797c-10.808 13.561-19.854 24.816-20.536 25.001-0.151 0.008-0.327 0.012-0.505 0.012-0.54 0-1.070-0.040-1.589-0.118l0.058 0.007c-8.437-0.744-40.487-5.212-55.068-7.272l-7.295-1.029s0.458-12.607 2.395-27.893c2.295-18.34 6.726-40.525 14.964-49.386 2.379-2.602 4.184-5.675 5.299-9.020 2.929-8.314 2.483-18.24 1.315-26.417-0.933-6.15-2.261-11.59-4.012-16.836l0.204 0.704s53.193-31.355 50.389-2.791c-0.221 1.839-0.347 3.969-0.347 6.128 0 5.572 0.839 10.947 2.397 16.008l-0.102-0.385c4.021 12.93 12.061 18.613 12.061 18.613l0.223 0.161 37.846 26.715z',
          'M581.179 205.703c-6.313 3.908-13.968 6.224-22.165 6.224-0.888 0-1.771-0.027-2.646-0.081l0.12 0.006c-9.067-0.554-17.266-3.865-23.877-9.095l0.089 0.068c-0.933-6.15-2.261-11.589-4.013-16.835l0.204 0.703s53.194-31.355 50.39-2.791c-0.232 1.886-0.364 4.069-0.364 6.283 0 5.533 0.827 10.873 2.364 15.903l-0.101-0.385z',
          'M601.513 167.151c0 0.009 0 0.020 0 0.031 0 10.768-4.002 20.602-10.601 28.094l0.040-0.047c-6.646 7.547-15.853 12.7-26.251 14.095l-0.218 0.024c-1.65 0.227-3.557 0.356-5.493 0.356-8.843 0-17.056-2.699-23.859-7.319l0.149 0.095c-8.442-5.726-14.64-14.212-17.333-24.139l-0.069-0.298c-0.896-3.259-1.411-7-1.411-10.862 0-6.918 1.652-13.45 4.582-19.223l-0.111 0.242c4.679-9.238 12.351-16.391 21.718-20.292l0.281-0.104c4.748-1.99 10.265-3.146 16.052-3.146 15.772 0 29.539 8.587 36.88 21.34l0.109 0.206c3.474 6.022 5.527 13.243 5.534 20.943l0 0.002z',
          'M595.982 146.206c-0.162 0.292-0.322 0.539-0.496 0.775l0.013-0.019c-2.804 3.81-8.239 4.431-12.955 4.033-5.57-0.484-11.738-2.481-14.119-7.52-2.196-4.664-1.589-9.665-7.631-10.361-5.237-0.608-12.259-4.268-17.371-2.171-4.033 1.675-5.646 6.564-6.018 10.931-0.373 4.368 0 8.997-2.035 12.88-1.923 3.66-5.671 6.093-7.62 9.74-2.183 4.12-1.724 9.083-1.154 13.724 0.571 4.641 1.154 9.553-0.868 13.761-0.198 0.417-0.397 0.766-0.617 1.1l0.021-0.034c-3.383-4.41-5.958-9.634-7.391-15.312l-0.063-0.294c-0.781-3.050-1.23-6.551-1.23-10.157 0-2.517 0.219-4.984 0.638-7.381l-0.037 0.255c0.975-5.744 3.121-11.225 6.3-16.106s7.328-9.058 12.188-12.271c6.605-4.422 14.73-7.057 23.472-7.057 3.505 0 6.912 0.424 10.171 1.223l-0.292-0.060c5.666 1.352 10.995 3.853 15.655 7.349 4.661 3.495 8.554 7.91 11.439 12.971z',
          'M568.459 141.242c2.383 5.050 8.549 7.035 14.121 7.507 4.716 0.41 10.151-0.21 12.955-4.032 0.923-1.41 1.623-2.955 2.072-4.579l3.251-9.728c1.713-5.149 3.325-11.167 0.261-15.696-2.742-3.983-8.612-5.646-9.865-10.324-0.583-2.172 0-4.492-0.31-6.713-0.721-4.579-5.274-7.557-9.704-8.922-2.754-0.871-5.921-1.373-9.205-1.373-4.761 0-9.275 1.055-13.322 2.944l0.194-0.081c-0.902 0.531-1.974 0.876-3.118 0.954l-0.022 0.001c-1.774 0-3.139-1.501-4.678-2.395-4.964-2.879-11.167 0.174-15.869 3.363-2.461 1.493-4.553 3.312-6.295 5.43l-0.034 0.042c-1.55 2.122-2.481 4.666-3.872 6.874-4.566 6.986-13.648 9.232-20.225 14.356-7.134 5.534-11.105 14.444-12.073 23.414-0.968 8.972 0.769 18.042 3.412 26.678 0.454 1.704 1.143 3.337 2.048 4.852 2.679 4.070 8.015 5.807 10.621 9.926 2.097 3.312 2.296 7.953 5.485 10.249 3.784 2.718 9.492 0 11.502-4.256s1.44-9.145 0.869-13.773c-0.571-4.629-1.031-9.605 1.154-13.724 1.935-3.648 5.708-6.080 7.618-9.74 2.023-3.885 1.675-8.512 2.035-12.88s1.986-9.244 6.031-10.919c5.074-2.109 12.098 1.563 17.371 2.159 6.006 0.719 5.397 5.708 7.593 10.385z',
          'M506.565 178.144c-2.618-4.12-7.953-5.856-10.634-9.926-0.001-0.015-0.002-0.032-0.002-0.050s0.001-0.035 0.002-0.052l-0 0.002c0.075 0.286 0.161 0.571 0.248 0.856 0.454 1.705 1.143 3.337 2.048 4.852 2.679 4.070 8.015 5.807 10.621 9.926 0.148 0.236 0.298 0.484 0.435 0.744-0.842-2.483-1.761-4.581-2.832-6.586l0.114 0.234zM589.017 98.807c0.383 1.313 1.066 2.438 1.973 3.337l0 0c0.053-0.667 0.084-1.443 0.084-2.227s-0.030-1.561-0.090-2.329l0.006 0.102c-0.294-1.706-1.053-3.199-2.14-4.387l0.006 0.006c-0.059 0.621-0.093 1.343-0.093 2.072 0 1.209 0.092 2.396 0.271 3.554l-0.016-0.129zM558.589 125.273c-5.236-0.596-12.271-4.268-17.371-2.159-4.045 1.675-5.658 6.552-6.018 10.92s0 8.995-2.047 12.879c-1.911 3.661-5.671 6.093-7.606 9.741-2.196 4.12-1.725 9.082-1.154 13.723s1.141 9.555-0.869 13.774c-2.010 4.218-7.73 6.972-11.515 4.255-0.927-0.708-1.676-1.599-2.201-2.624l-0.020-0.043c1.242 2.991 1.875 6.403 4.468 8.264 3.785 2.718 9.492 0 11.503-4.256 2.010-4.256 1.439-9.145 0.868-13.773s-1.029-9.605 1.154-13.723c1.936-3.648 5.708-6.081 7.618-9.741 2.023-3.883 1.675-8.512 2.036-12.88 0.36-4.368 1.985-9.244 6.030-10.919 5.075-2.109 12.098 1.563 17.371 2.159 0.911 0.042 1.757 0.282 2.508 0.679l-0.032-0.016c0.784 0.412 1.439 0.965 1.957 1.631l0.010 0.013c-1.254-3.835-1.712-7.321-6.689-7.905zM601.114 114.714c-0.186-0.261-0.373-0.509-0.571-0.745 0.322 3.524-0.782 7.383-1.936 10.845l-3.239 9.728c-0.488 1.741-1.2 3.264-2.12 4.637l0.036-0.058c-2.792 3.808-8.239 4.429-12.955 4.032-5.087-0.433-10.684-2.133-13.413-6.303 0.408 1.499 0.922 2.967 1.539 4.393 2.383 5.050 8.549 7.035 14.121 7.507 4.714 0.41 10.149-0.211 12.954-4.033 0.924-1.409 1.623-2.954 2.073-4.578 1.079-3.239 2.171-6.477 3.251-9.728 1.712-5.149 3.325-11.217 0.261-15.696z',
          'M515.18 139.965l-15.578 5.295c-3.030 1.029-4.651 4.32-3.622 7.35l15.336 45.126c1.029 3.030 4.32 4.651 7.35 3.622l15.578-5.295c3.030-1.029 4.653-4.32 3.622-7.35l-15.335-45.126c-1.031-3.030-4.322-4.651-7.352-3.622z',
          'M514.181 139.966l-15.579 5.293c-3.030 1.031-4.651 4.322-3.622 7.352l15.336 45.126c1.029 3.030 4.32 4.651 7.35 3.621l15.579-5.293c3.030-1.031 4.651-4.322 3.621-7.352l-15.335-45.124c-1.029-3.030-4.32-4.653-7.35-3.622z',
          'M511.501 163.577c2.433 0 4.405-1.972 4.405-4.405s-1.972-4.406-4.405-4.406c-2.433 0-4.405 1.973-4.405 4.406s1.972 4.405 4.405 4.405z',
          'M508.493 667.375s5.41 22.77 7.656 31.728c2.245 8.959 7.097 24.643 7.097 24.643s0.558 20.337 3.908 24.258c3.35 3.92 2.619 42.374 16.801 65.888 14.182 23.513 32.856 76.347 32.856 76.347l2.483 17.917 23.897-27.807-19.852-101.748s-11.565-41.245-8.028-54.124c3.537-12.88-14.742-62.897-14.742-62.897l-52.077 5.793z',
          'M603.129 880.338l-23.899 27.819-2.481-17.917s-18.613-52.821-32.857-76.347c-14.245-23.527-13.438-61.955-16.801-65.876-3.362-3.92-3.908-24.27-3.908-24.27s-4.851-15.684-7.097-24.643c-1.34-5.348-3.81-15.659-5.583-23.054-1.241-4.962-2.073-8.686-2.073-8.686l52.115-5.782s0.583 1.575 1.502 4.243c4.305 12.346 16.131 48.057 13.238 58.654-3.549 12.879 8.041 54.124 8.041 54.124l19.804 101.736z',
          'M611.122 926.818l-20.87 15.672c-10.088 10.832-39.706 19.791-52.636 15.683-10.969-3.499-5.558-12.407-0.943-15.783 0.641-0.515 1.385-0.936 2.193-1.224l0.053-0.017c4.479-1.315 15.125-10.461 15.125-10.461s10.447-14.182 12.123-22.583c1.675-8.399 13.649-15.311 13.649-15.311s16.044-15.671 23.328-12.507c4.752 2.085 9.666 19.071 12.52 30.598l0.471 1.973c0.622 2.563 0.48 5.251-0.411 7.733s-2.492 4.647-4.603 6.227z',
          'M611.122 926.818l-20.87 15.672c-10.088 10.832-39.706 19.791-52.636 15.683-10.969-3.499-5.558-12.407-0.943-15.783 4.454 6.961 20.722 5.708 20.722 5.708l28.936-12.88 29.321-24.283 0.471 1.973c0.614 2.553 0.469 5.232-0.42 7.702-0.927 2.533-2.511 4.641-4.547 6.183l-0.034 0.024z',
          'M578.438 888.899s-18.613-52.834-32.845-76.347c-14.232-23.514-13.438-61.966-16.8-65.888s-3.921-24.258-3.921-24.258-4.851-15.684-7.085-24.643c-1.352-5.36-3.822-15.659-5.595-23.054-1.241-4.962-2.073-8.686-2.073-8.686l48.851-5.435-0.137-0.36-52.114 5.795s0.868 3.723 2.072 8.686c1.762 7.445 4.243 17.694 5.583 23.054 2.233 8.959 7.085 24.643 7.085 24.643s0.558 20.337 3.921 24.258c3.362 3.921 2.606 42.374 16.8 65.888 14.196 23.513 32.844 76.347 32.844 76.347l2.483 17.917 2.903-3.375-1.972-14.542z',
          'M701.86 332.813h-58.231v67.265h58.231v-67.265z',
          'M706.069 443.346c-1.762 5.024-6.353 14.567-7.27 16.452-0.1 0.236-0.161 0.348-0.161 0.348l-42.858 39.893-0.261-0.856c-2.208-7.445-17.954-60.243-19.852-63.122-1.514-2.27-0.782-11.588-0.311-16.279 0.175-1.663 0.311-2.729 0.311-2.729l-1.217-36.58 6.204-11.911 57.463 18.19 8.053 15.821s1.862 35.164-0.1 40.774z',
          'M698.795 459.798c-0.1 0.236-0.161 0.348-0.161 0.348l-41.853 38.962-15.536 0.931-10.373-84.14s1.7 1.55 4.529 3.883c8.239 6.787 26.057 20.25 39.706 22.025 13.425 1.749 20.733 12.396 23.687 17.991zM703.127 438.592s-8.687-0.843-12.409-4.268c-3.722-3.424-13.301-8.897-13.301-8.897l13.575 14.977s10.311 3.35 12.136-1.812z',
          'M669.256 448.11s0.831 15.25 10.076 15.398c9.244 0.15-10.076-15.398-10.076-15.398zM678.775 448.11s6.999 12.73 10.361 11.055c3.362-1.675-10.361-11.055-10.361-11.055z',
          'M483.858 323.966l-9.765 3.61s-18.8 1.031-28.688 5.137c-9.889 4.108-30.053 0-30.053 0s35.090-45.736 35.648-45.909c0.559-0.175 37.15-13.649 37.15-13.649l-4.293 50.811z',
          'M483.858 323.966l-9.765 3.61s-18.8 1.031-28.688 5.137c-9.889 4.108-30.053 0-30.053 0s35.090-45.736 35.648-45.909c0.559-0.175 37.15-13.649 37.15-13.649l-4.293 50.811z',
          'M623.466 822.665c-2.048 6.353-10.262 47.982-14.742 54.695-4.479 6.714-9.703 45.353-9.703 45.353l-1.004 0.708-2.171 1.525s-32.126-1.489-28.403-7.272c0.765-1.712 1.239-3.541 1.402-5.409 2.481-15.709 2.704-57.488 2.704-57.488l0.373-66.271s8.437-21.379 2.606-37.138c-3.308-8.576-5.224-18.5-5.224-28.87 0-0.084 0-0.168 0-0.252l-0 0.013s0.929-15.311-3.177-21.466c-3.325-4.964-3.958-31.369-4.070-41.072v-3.598l5.212-7.78 57.077 3.92s-0.125 4.604-0.471 10.572c-0.344 7.658-1.108 14.814-2.279 21.832l0.144-1.047c-2.048 10.634-0.186 38.254-0.186 38.254l3.177 35.983c7.507 17.409 0.794 58.468-1.266 64.809z',
          'M562.072 665.861v0.423c-20.548 13.103-39.508 12.409-51.507 9.79-1.241-4.962-2.072-8.686-2.072-8.686l52.115-5.782s0.546 1.562 1.464 4.255z',
          'M646.065 521.232l-0.756 14.492-1.675 32.721-81.559 13.265v82.315c-34.546 22.012-64.523 5.212-64.523 5.212s0.558-27.807 0-30.611c-0.559-2.804-2.246-14.182-2.246-14.182s-3.549-11.763-2.792-15.3c0.757-3.537-3.56-14.555-5.236-18.612-1.675-4.058-3.537-18.277-3.537-18.277l-1.911-16.49c-1.293-0.896-2.313-2.1-2.967-3.508l-0.022-0.054c-0.323-1.054 0.347-10.87 0.968-19.035 0.471-6.055 0.906-11.167 0.906-11.167l76.149-14.369 89.202 13.6z',
          'M559.586 591.649v64.523c-1.527-0.894-3.648-3.115-3.86-8.537-0.335-8.586-1.017-28.923-2.233-38.068s4.641-19.046 4.641-19.046l1.452 1.129z',
          'M512.968 565.467s3.723 8.399 15.871 10.634c12.148 2.233-15.871-10.634-15.871-10.634zM501.224 582.267s25.747 4.293 31.913 4.108l-31.913-4.108zM509.051 601.116s14.505 0.186 22.843-3.549l-22.843 3.549zM506.070 644.978s37.325-14.244 41.804-21.689l-41.804 21.689zM514.846 663.268c1.241-0.186 34.148-19.977 36.952-25.201l-36.952 25.201zM624.398 652.213s-0.125 4.603-0.473 10.572l-61.83-3.115v-3.598l5.212-7.78 57.091 3.921zM573.859 578.334s31.467-7.768 38.094-2.767c6.626 5.002-38.094 2.767-38.094 2.767zM542.461 523.278s6.341 59.362 11.576 63.282c5.237 3.921 27.435-63.282 27.435-63.282h-39.012z',
          'M543.584 521.045s6.353 59.362 11.576 63.282c5.224 3.921 27.434-63.282 27.434-63.282h-39.010z',
          'M646.059 521.232l-0.757 14.492c-6.164-2.28-11.482-5.418-16.122-9.334l0.080 0.065c-0.233-0.206-0.488-0.402-0.757-0.58l-0.026-0.016c-6.366-4.553-14.692-2.878-20.126-0.954-1.927 0.68-3.798 1.51-5.597 2.481 0 0-82.502 2.804-82.502 0.558 0-1.65-11.676 0.869-19.531 3.040-2.103 0.55-4.175 1.217-6.204 1.998-2.977 1.241-10.261 0.694-14.455 0.21h-0.26c0.471-6.055 0.906-11.167 0.906-11.167l76.149-14.369 89.202 13.575z',
          'M648.095 530.935c-1.040-0.231-1.916-0.491-2.766-0.804l0.148 0.048c-6.239-2.268-11.624-5.431-16.308-9.395l0.077 0.064c-0.26-0.211-0.508-0.41-0.781-0.596-6.366-4.541-14.692-2.878-20.126-0.943-1.93 0.675-3.802 1.504-5.597 2.481 0 0-82.502 2.804-82.502 0.559 0-1.65-11.676 0.868-19.531 3.039-2.549 0.672-4.615 1.351-6.632 2.132l0.427-0.145c-2.977 1.241-10.261 0.694-14.455 0.223-1.837-0.223-3.089-0.41-3.089-0.41v-0.633l4.082-103.522 11.751-92.193 4.305-38.639 27.993-13.636c1.612 2.229 3.375 4.18 5.325 5.924l0.035 0.031c7.135 6.466 21.020 14.53 39.558 3.623 2.032-1.2 3.988-2.526 5.856-3.97 6.328-4.877 12.271 0.633 17.731 12.519 21.343 46.308 35.277 189.251 35.277 189.251l21.094 13.648s0.719 2.693 1.414 6.527c1.415 7.953 2.656 20.908-3.289 24.816z',
          'M648.091 533.168c-1.027-0.217-1.903-0.473-2.751-0.788l0.134 0.043c-6.237-2.279-11.619-5.441-16.31-9.396l0.080 0.066c-0.232-0.2-0.486-0.396-0.752-0.577l-0.030-0.019c-6.366-4.541-14.692-2.879-20.127-0.956-2.185 0.773-4.031 1.611-5.793 2.583l0.198-0.1s-82.453 2.866-82.453 0.57c0-1.662-11.676 0.857-19.531 3.029-2.543 0.673-4.609 1.355-6.624 2.141l0.419-0.144c-2.977 1.241-10.261 0.696-14.455 0.211-1.837-0.211-3.089-0.398-3.089-0.398v-0.645l4.082-103.509 11.751-92.206 4.306-38.639 27.992-13.624c1.562 2.174 3.36 4.167 5.36 5.944 7.135 6.476 21.020 14.542 39.558 3.635 2.034-1.205 3.99-2.535 5.856-3.983 6.329-4.876 12.272 0.646 17.732 12.52 21.329 46.295 35.264 189.25 35.264 189.25l21.094 13.649s0.719 2.693 1.414 6.514c1.377 7.978 2.618 20.92-3.325 24.828z',
          'M651.397 508.278c-5.485 6.936-14.592 11.39-22.918 14.171-5.391 1.911-11.754 3.463-18.32 4.381l-0.528 0.060-1.241-5.347c-3.040-12.197-10.709-42.189-15.113-53.356-5.61-14.171-7.11-30.599-7.11-30.599-0.751-15.989-3.728-31.031-8.629-45.175l0.339 1.126c-3.61-10.497-5.645-40.289-6.799-69.721-0.459-11.601-0.782-23.154-1.017-33.44-0.459-21.181-0.496-37.014-0.496-37.014l6.712-10.647c-0.079-0.698-0.124-1.508-0.124-2.327 0-4.185 1.177-8.094 3.219-11.415l-0.054 0.095c1.897-3.3 4.173-6.126 6.822-8.551l0.027-0.024c2.631 1.403 5.050 2.706 7.333 3.896l37.845 26.716s-20.933 26.726-37.696 47.796c21.329 46.295 35.264 189.25 35.264 189.25l21.094 13.649s0.694 2.754 1.39 6.477z',
          'M645.871 437.24c-1.129 21.641 12.681 57.847 12.681 57.847-2.233 25.76-46.655 30.624-46.655 30.624s-10.832-44.422-16.427-58.616c-5.597-14.196-7.098-30.611-7.098-30.611-0.76-15.987-3.739-31.025-8.641-45.164l0.34 1.127c-7.941-23.153-8.313-140.213-8.313-140.213l6.724-10.634c-0.080-0.703-0.126-1.518-0.126-2.343 0-4.178 1.174-8.082 3.209-11.4l-0.054 0.095c1.826-3.198 4.141-6.091 6.861-8.574 5.72 3.064 10.572 5.608 14.778 7.743 4.206 2.133 8.053 3.97 11.328 5.409 11.615 5.064 18.005 5.845 31.517 7.383 1.103 0.117 2.198 0.303 3.277 0.558 19.468 4.454 34.668 27.659 34.668 29.247s3.785 6.453 6.204 9.517c2.42 3.065-1.687 8.264-1.687 8.264s7.445 5.236 6.353 10.088c-1.092 4.852 5.595 13.065 5.595 13.065l-41.815 31.728s-11.603 73.196-12.719 94.86z',
          'M578.27 275.426c1.275 0 2.308-1.035 2.308-2.308 0-1.275-1.033-2.308-2.308-2.308s-2.308 1.033-2.308 2.308c0 1.273 1.033 2.308 2.308 2.308zM578.27 306.222c1.275 0 2.308-1.033 2.308-2.308s-1.033-2.308-2.308-2.308-2.308 1.033-2.308 2.308 1.033 2.308 2.308 2.308zM586.384 379.53c1.275 0 2.308-1.033 2.308-2.308s-1.033-2.308-2.308-2.308-2.308 1.033-2.308 2.308 1.033 2.308 2.308 2.308zM592.27 417.053c1.275 0 2.308-1.033 2.308-2.308s-1.033-2.308-2.308-2.308-2.308 1.033-2.308 2.308 1.033 2.308 2.308 2.308zM598 456.659c1.275 0 2.308-1.033 2.308-2.308s-1.033-2.308-2.308-2.308-2.308 1.033-2.308 2.308 1.033 2.308 2.308 2.308zM582.878 342.268c1.275 0 2.308-1.033 2.308-2.308s-1.033-2.308-2.308-2.308c-1.273 0-2.308 1.033-2.308 2.308s1.035 2.308 2.308 2.308z',
          'M603.152 229.39c-3.127 4.095-11.167 9.926-11.738 9.926-2.11 0-7.209-5.868-9.926-9.157 1.829-3.193 4.143-6.081 6.861-8.562 5.745 3.127 10.597 5.671 14.803 7.793z',
          'M603.152 227.157c-3.127 4.082-11.167 9.988-11.738 9.988-2.11 0-7.209-5.868-9.926-9.157 1.826-3.198 4.141-6.091 6.861-8.574 5.745 3.065 10.597 5.608 14.803 7.743z',
          'M541.524 263.463s-5.62 13.476-11.055 23.303c-1.714 3.35-3.683 6.238-5.962 8.848l0.043-0.051c-3.127 3.127-6.204 12.533-8.574 21.008-2.259 8.214-3.723 15.573-3.723 15.573-3.177 4.864-3.177 65.142-3.177 65.142 5.423 23.154-4.479 88.844-4.479 88.844l-2.916 31.888-0.893 9.605-0.161 1.824c-2.097 0.087-4.12 0.15-6.055 0.173-4.804 0.080-9.609-0.091-14.394-0.508-1.080-0.087-2.123-0.198-3.127-0.323l4.082-103.509 11.751-92.205 4.306-38.64 13.959-6.799c2.295-18.339 6.726-40.525 14.964-49.384 2.379-2.603 4.184-5.677 5.299-9.022 0.996-0.879 2.084-1.746 3.214-2.558l0.124-0.085s1.439 2.767 3.139 6.080c1.824 3.562 3.958 7.756 4.964 9.928 2.035 4.070-1.329 20.87-1.329 20.87z',
          'M539.286 262.346s-10.82 25.947-16.975 32.101c-6.155 6.155-12.321 36.579-12.321 36.579-3.177 4.864-3.177 65.143-3.177 65.143 5.41 23.153-4.479 88.843-4.479 88.843l-4.020 43.305c-74.016 3.425-53.715-37.51-53.715-37.51l17.173-93.062s5.695-27.869 5.137-35.711c-0.558-7.841 7.135-34.433 7.135-34.433s-13.575-70.552-12.172-73.766c1.402-3.214 48.714-11.168 48.714-11.168 1.586 0.053 3.172-0.076 4.729-0.385 2.754-0.571 5.868-1.923 6.886-5.074 1.973-6.031 10.187-11.676 10.187-11.676s1.427 2.766 3.127 6.091c1.824 3.562 3.97 7.756 5.037 9.928 2.072 3.995-1.266 20.795-1.266 20.795z',
          'M535.566 233.795c-7.333 6.614-15.212 30.413-15.212 30.413l-4.964-19.754c2.754-0.571 5.87-1.923 6.887-5.075 1.972-6.018 10.186-11.663 10.186-11.663l3.102 6.080z',
          'M535.566 231.574c-7.333 6.614-15.212 30.413-15.212 30.413l-4.964-19.754c2.754-0.57 5.87-1.923 6.887-5.074 1.972-6.031 10.186-11.676 10.186-11.676s1.402 2.754 3.102 6.091z',
          'M448.622 494.157s0.979 11.34 24.22 4.343c23.241-6.999-24.22-4.343-24.22-4.343z',
          'M736.389 387.396c-3.363 6.341-7.656 16.801-11.007 18.29-1.352 0.596-5.608 0.571-10.261 0.323-6.962-0.373-14.753-1.241-14.753-1.241s17.533-38.156-6.366-47.872h-21.627l-13.823-14.417 36.393-34.905 5.423 3.177 27.62 41.183s2.804 3.164 5.422 6.204c2.618 3.039 0.733 8.772 0.733 8.772s5.608 14.146 2.246 20.485z',
          'M605.264 346.338s10.484-82.267 41.765-104.713c-0.89-0.218-1.999-0.414-3.128-0.545l-0.134-0.013c-13.513-1.539-19.854-2.32-31.53-7.445-7.398 7.845-13.286 17.205-17.142 27.556l-0.185 0.566c-3.13 8.332-4.942 17.962-4.942 28.015 0 1.641 0.048 3.27 0.143 4.887l-0.010-0.223c2.295 42.001 0 51.804 0 51.804h3.722c6.676 13.525 35.016 69.709 50.75 81.51l1.675-14.295s-40.847-47.151-44.384-67.215l3.4 0.112z',
          'M609.745 345.222s10.484-82.28 41.766-104.713c-0.906-0.228-2.016-0.425-3.148-0.549l-0.116-0.010c-13.513-1.539-19.854-2.32-31.53-7.382-7.398 7.844-13.286 17.204-17.142 27.554l-0.185 0.566c-3.13 8.333-4.942 17.964-4.942 28.019 0 1.639 0.048 3.267 0.143 4.883l-0.010-0.223c2.295 42.002 0 51.805 0 51.805h3.722c6.676 13.525 35.017 69.696 50.75 81.497l1.675-14.282s-40.847-47.151-44.372-67.215l3.388 0.050z',
          'M594.571 342.281s34.271 70.999 52.189 84.375l1.675-14.282s-48.057-55.464-44.422-71.694l-9.442 1.602z',
          'M649.334 240.509c-31.294 22.433-41.778 104.713-41.778 104.713h-15.226s2.296-9.803 0-51.805c-0.631-11.106 1.007-22.226 4.815-32.68 3.807-10.454 9.706-20.022 17.333-28.119 11.615 5.062 18.005 5.843 31.517 7.382 1.122 0.098 2.237 0.268 3.339 0.509z',
          'M631.878 425.427l-0.981 57.116 9.653 4.901-8.672-62.016zM653.148 304.895c6.439-1.539 22.955-6.999 23.576-12.409 0.62-5.41-23.576 12.409-23.576 12.409zM654.126 315.677s20.437-8.413 23.662-11.763c3.227-3.35-26.74 5.050-23.662 11.763zM510.738 255.993s-8.922 17.596-3.55 19.431c5.373 1.837 3.55-19.431 3.55-19.431zM579.047 448.11s-71.669 42.324-56.556 44.744c15.113 2.42 56.556-44.744 56.556-44.744zM622.038 537.649s18.848 3.549 18.104 9.343l-18.104-9.343z',
          'M710.4 372.569l-0.844 21.789s-5.31 9.232-9.182 10.398c-0.317 0.072-0.682 0.114-1.056 0.114-0.131 0-0.26-0.005-0.388-0.015l0.017 0.001c-7.606-0.41-36.318-8.81-38.887-13.575-2.804-5.175-45.215-23.787-45.215-23.787s-35.686-54.187-8.959-67.34c26.726-13.152 25.474 51.098 25.474 51.098s24.22 3.635 27.297 5.597c2.581 1.687 26.393 0.508 33.502 0.112l1.85-0.063 7.557 1.39 8.834 14.282z',
          'M710.399 372.569l-0.844 21.789s-5.31 9.232-9.182 10.398c-0.317 0.072-0.682 0.114-1.056 0.114-0.131 0-0.26-0.005-0.388-0.015l0.017 0.001-0.757-0.087s17.373-37.871-6.091-47.809l1.91-0.063 7.557 1.39 8.835 14.282z',
          'M716.242 406.009c-6.949-0.373-14.742-1.242-14.742-1.242s17.521-38.143-6.34-47.907l18.699-1.848c23.402 15.535 7.21 43.651 2.383 50.998z',
          'M715.1 406.009c-6.961-0.373-14.753-1.241-14.753-1.241s17.558-38.156-6.34-47.872l18.748-1.824c23.439 15.473 7.197 43.59 2.345 50.936z',
          'M434.045 267.558l54.112-48.144s14.555-13.649 13.438-17.917c-1.116-4.269-13.252-42.187 7.085-44.422 20.337-2.233 13.649 63.456 13.649 63.456l-58.045 71.297-30.24-24.27z',
          'M400.060 318.704s-3.921-18.475 2.047-25.188c5.968-6.712 33.044-30.24 33.044-30.24s13.586 21.094 37.696 18.017l-27.001 36.108s-11.949 15.684-29.309 14.182c-17.359-1.501-16.477-12.88-16.477-12.88z',
          'M398.928 319.833s-3.92-18.475 2.060-25.201c5.981-6.724 33.031-30.238 33.031-30.238s23.154 23.328 36.406 26.132l-25.759 27.993s-11.949 15.683-29.309 14.194c-17.358-1.489-16.429-12.88-16.429-12.88z',
          'M445.057 275.686l-24.147-2.146s10.77-13.439 16.515-13.861c5.745-0.421 5.92 0.733 5.92 0.733l-7.62 6.774 9.332 8.501z',
          'M445.057 274.569l-24.147-2.146s10.77-13.438 16.515-13.859c5.745-0.421 5.92 0.733 5.92 0.733l-7.62 6.774 9.332 8.499z',
          'M449.561 280.313s-6.203 21.987 15.3 23.464l6.862-21.329s-13.922 2.729-22.162-2.135z',
          'M450.693 279.198s-6.266 21.925 15.288 23.464l6.862-21.367s-13.911 2.767-22.15-2.097z',
          'M625.106 756.181l-3.177-35.983s-1.862-27.62 0.186-38.254c1.113-6.882 1.83-13.821 2.146-20.785 0.335-5.968 0.471-10.572 0.471-10.572l-57.077-3.92-0.15 0.223 53.902 3.722s-0.137 4.604-0.471 10.572c-0.358 7.679-1.121 14.834-2.281 21.855l0.146-1.072c-2.060 10.634-0.198 38.256-0.198 38.256l3.189 35.983c7.445 17.371 0.733 58.418-1.315 64.759-2.047 6.341-10.274 47.982-14.753 54.695-4.479 6.714-9.74 45.328-9.74 45.328l-2.916 2.060 3.089 0.186 3.189-2.246s5.212-38.627 9.691-45.351c4.479-6.726 12.705-48.393 14.753-54.696 2.047-6.303 8.784-47.399 1.315-64.759z',
          'M632.067 561.359l11.563 7.085v93.149l-84.040-4.231-5.795-68.431 13.773-16.752 64.499-10.82z',
          'M570.641 614.182s35.475 28.923 46.295 30.796l-46.295-30.796zM599.020 920.478c-0.383 0.831-0.727 1.815-0.981 2.835l-0.025 0.118-2.171 1.525s-32.125-1.501-28.402-7.284c0.765-1.712 1.239-3.541 1.402-5.409 7.507-1.737 20.237 6.899 20.237 6.899l9.939 1.314z',
          'M601.448 983.003c-2.234 4.479-2.979 15.113-2.979 15.113s-6.911 10.447-16.614 7.284c-9.704-3.164-38.64-1.873-40.327-2.606-5.447-2.481-3.065-8.189 0-13.45 1.775-3.016 3.722-5.856 4.653-7.83 2.483-5.423 8.028-19.606 8.028-19.606-0.744-11.576 7.843-21.466 7.843-21.466l3.722-24.27c6.291-6.329 23.328 5.236 23.328 5.236l9.926 1.315c-5.037 11.007 0.186 41.804 0.186 41.804s0.819 2.58 1.602 5.893c1.004 4.405 1.91 10.026 0.633 12.582z',
          'M601.448 983.003c-2.234 4.479-2.979 15.113-2.979 15.113s-6.911 10.447-16.614 7.284c-9.704-3.164-38.64-1.873-40.327-2.606-5.447-2.481-3.065-8.189 0-13.45 13.14 0.719 42.535 2.097 49.075-0.373 8.388-3.164 10.274-14.096 10.187-18.525 1.029 4.38 1.935 10.001 0.658 12.557z',
          'M585.045 948.769c1.062 0 1.923-0.861 1.923-1.923s-0.861-1.923-1.923-1.923c-1.062 0-1.923 0.861-1.923 1.923s0.861 1.923 1.923 1.923zM562.064 948.769c1.062 0 1.923-0.861 1.923-1.923s-0.861-1.923-1.923-1.923c-1.062 0-1.923 0.861-1.923 1.923s0.861 1.923 1.923 1.923zM585.045 959.193c1.062 0 1.923-0.861 1.923-1.925 0-1.062-0.861-1.923-1.923-1.923s-1.923 0.861-1.923 1.923c0 1.063 0.861 1.925 1.923 1.925zM561.59 959.193c1.062 0 1.923-0.861 1.923-1.925 0-1.062-0.861-1.923-1.923-1.923-1.063 0-1.923 0.861-1.923 1.923 0 1.063 0.86 1.925 1.923 1.925zM579.282 982.817c1.062 0 1.923-0.861 1.923-1.923s-0.861-1.923-1.923-1.923c-1.062 0-1.923 0.861-1.923 1.923s0.861 1.923 1.923 1.923zM559.661 982.817c1.062 0 1.923-0.861 1.923-1.923s-0.861-1.923-1.923-1.923c-1.062 0-1.923 0.861-1.923 1.923s0.861 1.923 1.923 1.923zM580.212 977.518c1.062 0 1.923-0.86 1.923-1.923 0-1.062-0.861-1.923-1.923-1.923s-1.923 0.861-1.923 1.923c0 1.063 0.861 1.923 1.923 1.923zM560.148 977.518c1.062 0 1.923-0.86 1.923-1.923 0-1.062-0.861-1.923-1.923-1.923s-1.923 0.861-1.923 1.923c0 1.063 0.861 1.923 1.923 1.923zM581.199 971.402c1.062 0 1.923-0.861 1.923-1.923s-0.861-1.923-1.923-1.923c-1.062 0-1.923 0.861-1.923 1.923s0.861 1.923 1.923 1.923zM562.064 971.402c1.062 0 1.923-0.861 1.923-1.923s-0.861-1.923-1.923-1.923c-1.062 0-1.923 0.861-1.923 1.923s0.861 1.923 1.923 1.923zM583.129 965.297c1.062 0 1.923-0.861 1.923-1.923s-0.861-1.923-1.923-1.923c-1.062 0-1.923 0.861-1.923 1.923s0.861 1.923 1.923 1.923zM562.064 965.297c1.062 0 1.923-0.861 1.923-1.923s-0.861-1.923-1.923-1.923c-1.062 0-1.923 0.861-1.923 1.923s0.861 1.923 1.923 1.923z',
          'M566.205 932.638s9.53 11.826 21.652 2.483',
          'M562.072 946.846s24.904 6.204 22.981 10.422c0 0-21.9-3.151-23.464 0-1.564 3.152 21.541 6.106 21.541 6.106s-18.998 2.966-21.094 0c-2.097-2.966 19.133 6.105 19.133 6.105s-19.133-1.923-19.133 0 18.141 6.116 18.141 6.116-16.95-1.787-18.141 0 16.875 2.483 17.21 5.299c0.335 2.817-19.617-1.923-19.617 0s25.387-34.048 25.387-34.048',
          'M89.677 988.5c20.504 0 37.125-2.811 37.125-6.278 0-3.468-16.622-6.279-37.125-6.279s-37.125 2.811-37.125 6.279c0 3.467 16.622 6.278 37.125 6.278z',
          'M64.737 953.062s21.181-0.658 27.559-5.199c6.378-4.541 32.571-9.926 34.16-2.679 1.588 7.245 31.827 36.244 7.917 36.443s-55.552-3.723-61.93-7.606c-6.378-3.883-7.706-20.958-7.706-20.958z',
          'M134.794 979.082c-23.911 0.198-55.552-3.722-61.917-7.606-4.852-2.953-6.787-13.55-7.445-18.45h-0.707s1.34 17.073 7.705 20.958c6.365 3.883 38.019 7.792 61.929 7.605 6.899-0.062 9.282-2.481 9.157-6.203-0.943 2.283-3.585 3.66-8.722 3.697z',
        ],
        attrs: [
          {
            fill: 'rgb(225, 112, 0)',
            opacity: 0.1,
          },
          {
            fill: 'rgb(230, 236, 248)',
          },
          {
            fill: 'rgb(0, 0, 0)',
            opacity: 0.1,
          },
          {
            fill: 'rgb(225, 112, 0)',
          },
          {
            fill: 'rgb(0, 0, 0)',
            opacity: 0.1,
          },
          {
            fill: 'rgb(249, 250, 251)',
          },
          {
            fill: 'rgb(0, 0, 0)',
            opacity: 0.1,
          },
          {
            fill: 'rgb(225, 112, 0)',
            opacity: 0.3,
          },
          {
            fill: 'rgb(70, 74, 95)',
          },
          {
            fill: 'rgb(0, 0, 0)',
            opacity: 0.1,
          },
          {
            fill: 'rgb(156, 156, 161)',
          },
          {
            fill: 'rgb(0, 0, 0)',
            opacity: 0.1,
          },
          {
            fill: 'rgb(156, 156, 161)',
          },
          {
            fill: 'rgb(0, 0, 0)',
            opacity: 0.1,
          },
          {
            fill: 'rgb(156, 156, 161)',
          },
          {
            fill: 'rgb(70, 74, 95)',
          },
          {
            fill: 'rgb(0, 0, 0)',
            opacity: 0.1,
          },
          {
            fill: 'rgb(70, 74, 95)',
          },
          {
            fill: 'rgb(0, 0, 0)',
            opacity: 0.010000000000000002,
          },
          {
            fill: 'rgb(70, 74, 95)',
          },
          {
            fill: 'rgb(0, 0, 0)',
            opacity: 0.1,
          },
          {
            fill: 'rgb(147, 148, 152)',
          },
          {
            fill: 'rgb(225, 112, 0)',
          },
          {
            fill: 'rgb(58, 55, 104)',
          },
          {
            fill: 'rgb(0, 0, 0)',
            opacity: 0.1,
          },
          {
            fill: 'rgb(230, 232, 236)',
          },
          {
            fill: 'rgb(0, 0, 0)',
            opacity: 0.1,
          },
          {
            fill: 'rgb(225, 112, 0)',
          },
          {
            fill: 'rgb(0, 0, 0)',
            opacity: 0.010000000000000002,
          },
          {
            fill: 'rgb(0, 0, 0)',
            opacity: 0.004000000000000001,
          },
          {
            fill: 'rgb(249, 250, 251)',
          },
          {
            fill: 'rgb(225, 112, 0)',
            opacity: 0.04000000000000001,
          },
          {
            fill: 'rgb(0, 0, 0)',
            opacity: 0.010000000000000002,
          },
          {
            fill: 'rgb(0, 0, 0)',
            opacity: 0.004000000000000001,
          },
          {
            fill: 'rgb(249, 250, 251)',
          },
          {
            fill: 'rgb(225, 112, 0)',
            opacity: 0.04000000000000001,
          },
          {
            fill: 'rgb(190, 139, 135)',
          },
          {
            fill: 'rgb(255, 255, 255)',
            opacity: 0.1,
          },
          {
            fill: 'rgb(239, 200, 196)',
          },
          {
            fill: 'rgb(114, 122, 156)',
          },
          {
            fill: 'rgb(0, 0, 0)',
            opacity: 0.5,
          },
          {
            fill: 'rgb(249, 250, 251)',
          },
          {
            fill: 'rgb(247, 182, 67)',
          },
          {
            fill: 'rgb(247, 182, 67)',
            opacity: 0.5,
          },
          {
            fill: 'rgb(247, 182, 67)',
            opacity: 0.3,
          },
          {
            fill: 'rgb(0, 0, 0)',
            opacity: 0.5,
          },
          {
            fill: 'rgb(249, 250, 251)',
          },
          {
            fill: 'rgb(249, 120, 120)',
          },
          {
            fill: 'rgb(249, 120, 120)',
            opacity: 0.5,
          },
          {
            fill: 'rgb(249, 120, 120)',
            opacity: 0.3,
          },
          {
            fill: 'rgb(0, 0, 0)',
            opacity: 0.5,
          },
          {
            fill: 'rgb(249, 250, 251)',
          },
          {
            fill: 'rgb(115, 181, 59)',
          },
          {
            fill: 'rgb(115, 181, 59)',
            opacity: 0.5,
          },
          {
            fill: 'rgb(115, 181, 59)',
            opacity: 0.3,
          },
          {
            fill: 'rgb(0, 0, 0)',
            opacity: 0.5,
          },
          {
            fill: 'rgb(255, 255, 255)',
          },
          {
            fill: 'rgb(225, 112, 0)',
          },
          {
            fill: 'rgb(225, 112, 0)',
            opacity: 0.5,
          },
          {
            fill: 'rgb(225, 112, 0)',
            opacity: 0.3,
          },
          {
            fill: 'rgb(240, 203, 198)',
          },
          {
            fill: 'rgb(240, 203, 198)',
          },
          {
            fill: 'rgb(240, 203, 198)',
          },
          {
            fill: 'rgb(249, 250, 251)',
          },
          {
            fill: 'rgb(0, 0, 0)',
            opacity: 0.1,
          },
          {
            fill: 'rgb(0, 0, 0)',
            opacity: 0.1,
          },
          {
            fill: 'rgb(0, 0, 0)',
            opacity: 0.1,
          },
          {
            fill: 'rgb(89, 57, 60)',
          },
          {
            fill: 'rgb(225, 112, 0)',
          },
          {
            fill: 'rgb(225, 112, 0)',
            opacity: 0.1,
          },
          {
            fill: 'rgb(225, 112, 0)',
          },
          {
            fill: 'rgb(225, 112, 0)',
            opacity: 0.1,
          },
          {
            fill: 'rgb(225, 112, 0)',
          },
          {
            fill: 'rgb(225, 112, 0)',
            opacity: 0.1,
          },
          {
            fill: 'rgb(0, 0, 0)',
          },
          {
            fill: 'rgb(255, 185, 185)',
          },
          {
            fill: 'rgb(0, 0, 0)',
            opacity: 0.1,
          },
          {
            fill: 'rgb(255, 185, 185)',
          },
          {
            fill: 'rgb(0, 0, 0)',
            opacity: 0.1,
          },
          {
            fill: 'rgb(185, 107, 107)',
          },
          {
            fill: 'rgb(0, 0, 0)',
            opacity: 0.010000000000000002,
          },
          {
            fill: 'rgb(70, 74, 95)',
          },
          {
            fill: 'rgb(156, 156, 161)',
          },
          {
            fill: 'rgb(147, 148, 152)',
          },
          {
            fill: 'rgb(255, 185, 185)',
          },
          {
            fill: 'rgb(0, 0, 0)',
            opacity: 0.05,
          },
          {
            fill: 'rgb(199, 192, 217)',
          },
          {
            fill: 'rgb(0, 0, 0)',
            opacity: 0.1,
          },
          {
            fill: 'rgb(0, 0, 0)',
            opacity: 0.05,
          },
          {
            fill: 'rgb(202, 168, 177)',
          },
          {
            fill: 'rgb(202, 168, 177)',
          },
          {
            fill: 'rgb(0, 0, 0)',
            opacity: 0.1,
          },
          {
            fill: 'rgb(0, 0, 0)',
            opacity: 0.1,
          },
          {
            fill: 'rgb(203, 205, 218)',
          },
          {
            fill: 'rgb(0, 0, 0)',
            opacity: 0.03,
          },
          {
            fill: 'rgb(255, 185, 185)',
          },
          {
            fill: 'rgb(0, 0, 0)',
            opacity: 0.05,
          },
          {
            fill: 'rgb(76, 76, 120)',
          },
          {
            fill: 'rgb(0, 0, 0)',
            opacity: 0.05,
          },
          {
            fill: 'rgb(0, 0, 0)',
            opacity: 0.1,
          },
          {
            fill: 'rgb(76, 76, 120)',
          },
          {
            fill: 'rgb(0, 0, 0)',
            opacity: 0.1,
          },
          {
            fill: 'rgb(0, 0, 0)',
            opacity: 0.1,
          },
          {
            fill: 'rgb(255, 255, 255)',
          },
          {
            fill: 'rgb(0, 0, 0)',
            opacity: 0.1,
          },
          {
            fill: 'rgb(203, 205, 218)',
          },
          {
            fill: 'rgb(118, 125, 159)',
          },
          {
            fill: 'rgb(0, 0, 0)',
            opacity: 0.1,
          },
          {
            fill: 'rgb(203, 205, 218)',
          },
          {
            fill: 'rgb(0, 0, 0)',
            opacity: 0.1,
          },
          {
            fill: 'rgb(203, 205, 218)',
          },
          {
            fill: 'rgb(0, 0, 0)',
            opacity: 0.1,
          },
          {
            fill: 'rgb(203, 205, 218)',
          },
          {
            fill: 'rgb(0, 0, 0)',
            opacity: 0.1,
          },
          {
            fill: 'rgb(203, 205, 218)',
          },
          {
            fill: 'rgb(0, 0, 0)',
            opacity: 0.1,
          },
          {
            fill: 'rgb(0, 0, 0)',
            opacity: 0.1,
          },
          {
            fill: 'rgb(110, 109, 132)',
          },
          {
            fill: 'rgb(110, 109, 132)',
          },
          {
            fill: 'rgb(0, 0, 0)',
            opacity: 0.1,
          },
          {
            fill: 'rgb(255, 185, 185)',
          },
          {
            fill: 'rgb(0, 0, 0)',
            opacity: 0.1,
          },
          {
            fill: 'rgb(0, 0, 0)',
            opacity: 0.1,
          },
          {
            fill: 'rgb(203, 205, 218)',
          },
          {
            fill: 'rgb(255, 185, 185)',
          },
          {
            fill: 'rgb(0, 0, 0)',
            opacity: 0.1,
          },
          {
            fill: 'rgb(203, 205, 218)',
          },
          {
            fill: 'rgb(0, 0, 0)',
            opacity: 0.1,
          },
          {
            fill: 'rgb(203, 205, 218)',
          },
          {
            fill: 'rgb(0, 0, 0)',
            opacity: 0.1,
          },
          {
            fill: 'rgb(203, 205, 218)',
          },
          {
            fill: 'rgb(0, 0, 0)',
            opacity: 0.1,
          },
          {
            fill: 'rgb(76, 76, 120)',
          },
          {
            fill: 'rgb(0, 0, 0)',
            opacity: 0.1,
          },
          {
            fill: 'rgb(199, 192, 217)',
          },
          {
            fill: 'rgb(0, 0, 0)',
            opacity: 0.1,
          },
          {
            fill: 'rgb(96, 91, 137)',
          },
          {
            fill: 'none',
            opacity: 0.1,
            stroke: 'rgb(0, 0, 0)',
            strokeLinejoin: 'miter',
            strokeLinecap: 'butt',
            strokeMiterlimit: '10',
            strokeWidth: 13.128205128205128,
          },
          {
            fill: 'none',
            opacity: 0.2,
            stroke: 'rgb(96, 91, 137)',
            strokeLinejoin: 'miter',
            strokeLinecap: 'butt',
            strokeMiterlimit: '10',
            strokeWidth: 13.128205128205128,
          },
          {
            fill: 'rgb(225, 112, 0)',
            opacity: 0.1,
          },
          {
            fill: 'rgb(168, 168, 168)',
          },
          {
            fill: 'rgb(0, 0, 0)',
            opacity: 0.2,
          },
        ],
        width: 1208,
        isMulticolor: true,
        isMulticolor2: true,
        grid: 16,
        tags: ['Provider'],
      },
      attrs: [
        {
          fill: 'rgb(225, 112, 0)',
          opacity: 0.1,
        },
        {
          fill: 'rgb(230, 236, 248)',
        },
        {
          fill: 'rgb(0, 0, 0)',
          opacity: 0.1,
        },
        {
          fill: 'rgb(225, 112, 0)',
        },
        {
          fill: 'rgb(0, 0, 0)',
          opacity: 0.1,
        },
        {
          fill: 'rgb(249, 250, 251)',
        },
        {
          fill: 'rgb(0, 0, 0)',
          opacity: 0.1,
        },
        {
          fill: 'rgb(225, 112, 0)',
          opacity: 0.3,
        },
        {
          fill: 'rgb(70, 74, 95)',
        },
        {
          fill: 'rgb(0, 0, 0)',
          opacity: 0.1,
        },
        {
          fill: 'rgb(156, 156, 161)',
        },
        {
          fill: 'rgb(0, 0, 0)',
          opacity: 0.1,
        },
        {
          fill: 'rgb(156, 156, 161)',
        },
        {
          fill: 'rgb(0, 0, 0)',
          opacity: 0.1,
        },
        {
          fill: 'rgb(156, 156, 161)',
        },
        {
          fill: 'rgb(70, 74, 95)',
        },
        {
          fill: 'rgb(0, 0, 0)',
          opacity: 0.1,
        },
        {
          fill: 'rgb(70, 74, 95)',
        },
        {
          fill: 'rgb(0, 0, 0)',
          opacity: 0.010000000000000002,
        },
        {
          fill: 'rgb(70, 74, 95)',
        },
        {
          fill: 'rgb(0, 0, 0)',
          opacity: 0.1,
        },
        {
          fill: 'rgb(147, 148, 152)',
        },
        {
          fill: 'rgb(225, 112, 0)',
        },
        {
          fill: 'rgb(58, 55, 104)',
        },
        {
          fill: 'rgb(0, 0, 0)',
          opacity: 0.1,
        },
        {
          fill: 'rgb(230, 232, 236)',
        },
        {
          fill: 'rgb(0, 0, 0)',
          opacity: 0.1,
        },
        {
          fill: 'rgb(225, 112, 0)',
        },
        {
          fill: 'rgb(0, 0, 0)',
          opacity: 0.010000000000000002,
        },
        {
          fill: 'rgb(0, 0, 0)',
          opacity: 0.004000000000000001,
        },
        {
          fill: 'rgb(249, 250, 251)',
        },
        {
          fill: 'rgb(225, 112, 0)',
          opacity: 0.04000000000000001,
        },
        {
          fill: 'rgb(0, 0, 0)',
          opacity: 0.010000000000000002,
        },
        {
          fill: 'rgb(0, 0, 0)',
          opacity: 0.004000000000000001,
        },
        {
          fill: 'rgb(249, 250, 251)',
        },
        {
          fill: 'rgb(225, 112, 0)',
          opacity: 0.04000000000000001,
        },
        {
          fill: 'rgb(190, 139, 135)',
        },
        {
          fill: 'rgb(255, 255, 255)',
          opacity: 0.1,
        },
        {
          fill: 'rgb(239, 200, 196)',
        },
        {
          fill: 'rgb(114, 122, 156)',
        },
        {
          fill: 'rgb(0, 0, 0)',
          opacity: 0.5,
        },
        {
          fill: 'rgb(249, 250, 251)',
        },
        {
          fill: 'rgb(247, 182, 67)',
        },
        {
          fill: 'rgb(247, 182, 67)',
          opacity: 0.5,
        },
        {
          fill: 'rgb(247, 182, 67)',
          opacity: 0.3,
        },
        {
          fill: 'rgb(0, 0, 0)',
          opacity: 0.5,
        },
        {
          fill: 'rgb(249, 250, 251)',
        },
        {
          fill: 'rgb(249, 120, 120)',
        },
        {
          fill: 'rgb(249, 120, 120)',
          opacity: 0.5,
        },
        {
          fill: 'rgb(249, 120, 120)',
          opacity: 0.3,
        },
        {
          fill: 'rgb(0, 0, 0)',
          opacity: 0.5,
        },
        {
          fill: 'rgb(249, 250, 251)',
        },
        {
          fill: 'rgb(115, 181, 59)',
        },
        {
          fill: 'rgb(115, 181, 59)',
          opacity: 0.5,
        },
        {
          fill: 'rgb(115, 181, 59)',
          opacity: 0.3,
        },
        {
          fill: 'rgb(0, 0, 0)',
          opacity: 0.5,
        },
        {
          fill: 'rgb(255, 255, 255)',
        },
        {
          fill: 'rgb(225, 112, 0)',
        },
        {
          fill: 'rgb(225, 112, 0)',
          opacity: 0.5,
        },
        {
          fill: 'rgb(225, 112, 0)',
          opacity: 0.3,
        },
        {
          fill: 'rgb(240, 203, 198)',
        },
        {
          fill: 'rgb(240, 203, 198)',
        },
        {
          fill: 'rgb(240, 203, 198)',
        },
        {
          fill: 'rgb(249, 250, 251)',
        },
        {
          fill: 'rgb(0, 0, 0)',
          opacity: 0.1,
        },
        {
          fill: 'rgb(0, 0, 0)',
          opacity: 0.1,
        },
        {
          fill: 'rgb(0, 0, 0)',
          opacity: 0.1,
        },
        {
          fill: 'rgb(89, 57, 60)',
        },
        {
          fill: 'rgb(225, 112, 0)',
        },
        {
          fill: 'rgb(225, 112, 0)',
          opacity: 0.1,
        },
        {
          fill: 'rgb(225, 112, 0)',
        },
        {
          fill: 'rgb(225, 112, 0)',
          opacity: 0.1,
        },
        {
          fill: 'rgb(225, 112, 0)',
        },
        {
          fill: 'rgb(225, 112, 0)',
          opacity: 0.1,
        },
        {
          fill: 'rgb(0, 0, 0)',
        },
        {
          fill: 'rgb(255, 185, 185)',
        },
        {
          fill: 'rgb(0, 0, 0)',
          opacity: 0.1,
        },
        {
          fill: 'rgb(255, 185, 185)',
        },
        {
          fill: 'rgb(0, 0, 0)',
          opacity: 0.1,
        },
        {
          fill: 'rgb(185, 107, 107)',
        },
        {
          fill: 'rgb(0, 0, 0)',
          opacity: 0.010000000000000002,
        },
        {
          fill: 'rgb(70, 74, 95)',
        },
        {
          fill: 'rgb(156, 156, 161)',
        },
        {
          fill: 'rgb(147, 148, 152)',
        },
        {
          fill: 'rgb(255, 185, 185)',
        },
        {
          fill: 'rgb(0, 0, 0)',
          opacity: 0.05,
        },
        {
          fill: 'rgb(199, 192, 217)',
        },
        {
          fill: 'rgb(0, 0, 0)',
          opacity: 0.1,
        },
        {
          fill: 'rgb(0, 0, 0)',
          opacity: 0.05,
        },
        {
          fill: 'rgb(202, 168, 177)',
        },
        {
          fill: 'rgb(202, 168, 177)',
        },
        {
          fill: 'rgb(0, 0, 0)',
          opacity: 0.1,
        },
        {
          fill: 'rgb(0, 0, 0)',
          opacity: 0.1,
        },
        {
          fill: 'rgb(203, 205, 218)',
        },
        {
          fill: 'rgb(0, 0, 0)',
          opacity: 0.03,
        },
        {
          fill: 'rgb(255, 185, 185)',
        },
        {
          fill: 'rgb(0, 0, 0)',
          opacity: 0.05,
        },
        {
          fill: 'rgb(76, 76, 120)',
        },
        {
          fill: 'rgb(0, 0, 0)',
          opacity: 0.05,
        },
        {
          fill: 'rgb(0, 0, 0)',
          opacity: 0.1,
        },
        {
          fill: 'rgb(76, 76, 120)',
        },
        {
          fill: 'rgb(0, 0, 0)',
          opacity: 0.1,
        },
        {
          fill: 'rgb(0, 0, 0)',
          opacity: 0.1,
        },
        {
          fill: 'rgb(255, 255, 255)',
        },
        {
          fill: 'rgb(0, 0, 0)',
          opacity: 0.1,
        },
        {
          fill: 'rgb(203, 205, 218)',
        },
        {
          fill: 'rgb(118, 125, 159)',
        },
        {
          fill: 'rgb(0, 0, 0)',
          opacity: 0.1,
        },
        {
          fill: 'rgb(203, 205, 218)',
        },
        {
          fill: 'rgb(0, 0, 0)',
          opacity: 0.1,
        },
        {
          fill: 'rgb(203, 205, 218)',
        },
        {
          fill: 'rgb(0, 0, 0)',
          opacity: 0.1,
        },
        {
          fill: 'rgb(203, 205, 218)',
        },
        {
          fill: 'rgb(0, 0, 0)',
          opacity: 0.1,
        },
        {
          fill: 'rgb(203, 205, 218)',
        },
        {
          fill: 'rgb(0, 0, 0)',
          opacity: 0.1,
        },
        {
          fill: 'rgb(0, 0, 0)',
          opacity: 0.1,
        },
        {
          fill: 'rgb(110, 109, 132)',
        },
        {
          fill: 'rgb(110, 109, 132)',
        },
        {
          fill: 'rgb(0, 0, 0)',
          opacity: 0.1,
        },
        {
          fill: 'rgb(255, 185, 185)',
        },
        {
          fill: 'rgb(0, 0, 0)',
          opacity: 0.1,
        },
        {
          fill: 'rgb(0, 0, 0)',
          opacity: 0.1,
        },
        {
          fill: 'rgb(203, 205, 218)',
        },
        {
          fill: 'rgb(255, 185, 185)',
        },
        {
          fill: 'rgb(0, 0, 0)',
          opacity: 0.1,
        },
        {
          fill: 'rgb(203, 205, 218)',
        },
        {
          fill: 'rgb(0, 0, 0)',
          opacity: 0.1,
        },
        {
          fill: 'rgb(203, 205, 218)',
        },
        {
          fill: 'rgb(0, 0, 0)',
          opacity: 0.1,
        },
        {
          fill: 'rgb(203, 205, 218)',
        },
        {
          fill: 'rgb(0, 0, 0)',
          opacity: 0.1,
        },
        {
          fill: 'rgb(76, 76, 120)',
        },
        {
          fill: 'rgb(0, 0, 0)',
          opacity: 0.1,
        },
        {
          fill: 'rgb(199, 192, 217)',
        },
        {
          fill: 'rgb(0, 0, 0)',
          opacity: 0.1,
        },
        {
          fill: 'rgb(96, 91, 137)',
        },
        {
          fill: 'none',
          opacity: 0.1,
          stroke: 'rgb(0, 0, 0)',
          strokeLinejoin: 'miter',
          strokeLinecap: 'butt',
          strokeMiterlimit: '10',
          strokeWidth: 13.128205128205128,
        },
        {
          fill: 'none',
          opacity: 0.2,
          stroke: 'rgb(96, 91, 137)',
          strokeLinejoin: 'miter',
          strokeLinecap: 'butt',
          strokeMiterlimit: '10',
          strokeWidth: 13.128205128205128,
        },
        {
          fill: 'rgb(225, 112, 0)',
          opacity: 0.1,
        },
        {
          fill: 'rgb(168, 168, 168)',
        },
        {
          fill: 'rgb(0, 0, 0)',
          opacity: 0.2,
        },
      ],
      properties: {
        order: 8,
        id: 496,
        name: 'Provider',
        prevSize: 32,
      },
      setIdx: 0,
      setId: 1,
      iconIdx: 0,
    },
    {
      icon: {
        paths: [
          'M1068.687 1024c337.843 0 611.723-24.751 611.723-55.283s-273.881-55.284-611.723-55.284c-337.846 0-611.726 24.752-611.726 55.284s273.879 55.283 611.726 55.283z',
          'M769.683 451.711h663.983v-451.711h-663.983v451.711z',
          'M1391.275 41.387h-196.601v215.214h196.601v-215.214zM883.875 54.395h189.542v-13.007h-189.542v13.007zM1194.677 302.718h67.105v-13.007h-67.105v13.007zM1197.034 326.367h191.891v-13.007h-191.891v13.007zM845.026 101.694h273.128v-13.007h-273.128v13.007zM845.026 138.352h273.128v-13.008h-273.128v13.008zM845.026 175.008h273.128v-13.006h-273.128v13.006zM845.026 211.666h273.128v-13.007h-273.128v13.007zM845.026 248.323h273.128v-13.007h-273.128v13.007zM845.026 284.981h273.128v-13.007h-273.128v13.007zM845.026 321.637h273.128v-13.007h-273.128v13.007z',
          'M1224.204 164.278c2.909-2.080 6.12-3.698 9.519-4.796 19.696-7.606 42.503-12.828 66.269-14.617l0.809-0.049c19.95-1.422 41.559 0.267 57.142 12.856 2.416 1.787 4.398 4.107 5.79 6.783 1.969 4.247 1.365 9.186 0.735 13.824-0.144 1.799-0.591 3.56-1.339 5.204-2.087 4.009-7.247 5.414-11.737 4.932-4.477-0.48-8.691-2.385-13.115-3.269-2.731-0.479-5.501-0.761-8.271-0.847l-27.736-1.508c-17.245-0.937-34.718-1.859-51.633 1.636-5.604 1.032-10.607 2.826-15.19 5.298l0.272-0.134c-3.864 2.179-6.466 5.306-10.051 1.281-6.299-7.070-9.784-20.065-1.464-26.595z',
          'M1267.179 176.597s37.301-16.795 51.444 2.584c14.152 19.379-7.712 11.628-7.712 11.628l-24.439 7.751-27.011-5.167 7.718-16.795z',
          'M1269.109 164.323s5.145 24.547 1.287 31.006c-3.858 6.46 21.866 15.503 21.866 15.503l24.445-10.335s-6.438-40.050 0-47.802l-47.598 11.628z',
          'M1269.109 164.323s5.145 24.547 1.287 31.006c-3.858 6.46 21.866 15.503 21.866 15.503l24.445-10.335s-6.438-40.050 0-47.802l-47.598 11.628z',
          'M1328.272 139.776c0 10.277-4.070 20.131-11.303 27.397-7.24 7.266-17.051 11.353-27.282 11.361-0.019 0-0.042 0-0.065 0-2.401 0-4.749-0.226-7.024-0.657l0.234 0.037c-7.222-1.31-13.922-4.662-19.314-9.661-5.393-4.999-9.254-11.439-11.131-18.565-0.815-2.974-1.284-6.389-1.284-9.913 0-4.197 0.664-8.24 1.894-12.027l-0.077 0.275c2.224-7.024 6.397-13.265 12.028-17.991 5.632-4.726 12.488-7.741 19.765-8.692 1.495-0.206 3.222-0.323 4.976-0.323 5.936 0 11.558 1.346 16.577 3.748l-0.231-0.1c6.647 3.122 12.275 8.084 16.213 14.302s6.026 13.437 6.026 20.807z',
          'M1351.575 257.783h-123.062l2.791-12.167 12.078-52.87 23.794-16.153s1.93 0.887 4.155 2.094c0.647 0.366 1.308 0.744 1.967 1.146 0.012-0.011 0.012 0 0.012 0 1.067 0.624 2.082 1.331 3.037 2.118 0.177 0.165 0.33 0.307 0.483 0.461 2.448 2.46 9.595 15.515 21.415 8.833 0.597-0.328 1.175-0.692 1.73-1.087 3.081-2.141 6.019-4.485 8.795-7.012 2.484-2.283 4.092-4.045 5.418-5.263 0.575-0.577 1.232-1.073 1.951-1.468l0.044-0.022c0.565-0.293 1.182-0.442 1.799-0.437 3.873 0 9.006 7.746 9.006 7.746l0.158 0.449 0.013 0.035 24.418 73.598z',
          'M1228.514 257.783h37.296c0.011-0.524 0.017-1.141 0.017-1.759 0-3.948-0.25-7.838-0.735-11.654l0.047 0.453c-1.142-8.644-3.944-16.968-5.709-25.505-1.432-6.588-2.252-14.156-2.252-21.916 0-0.294 0.001-0.587 0.004-0.881l-0 0.045c0.012-1.053 0.035-2.118 0.13-3.181 0.092-2.438 0.793-4.811 2.036-6.907 0.884-1.359 2.095-2.518 3.038-3.819 0.307-0.396 0.592-0.841 0.836-1.311l0.023-0.049v-0.012c0.098-0.188 0.205-0.425 0.3-0.669l0.018-0.052c0.198-0.52 0.325-1.122 0.353-1.749l0-0.012c0.213-3.903-3.307-7.663-7.11-9.271-2.775-1.079-5.987-1.704-9.344-1.704-2.605 0-5.123 0.376-7.501 1.078l0.187-0.047c-5.997 1.762-11.189 3.95-16.066 6.639l0.408-0.206c-1.683 0.827-3.356 1.679-4.968 2.624-2.005 1.155-3.734 2.488-5.263 4.021l-0.001 0.001c-4.003 4.15-5.757 9.933-7.169 15.525-1.347 4.276-1.808 8.783-1.354 13.244 0.012 0.142 0.047 0.297 0.071 0.438 1.401 7.366 7.381 12.901 10.572 19.688 3.696 7.876 3.449 17.051 1.977 25.635-0.071 0.438-0.152 0.876-0.235 1.313h10.395zM1380.339 210.471c-4.248 13.38-7.805 29.382-9.998 45.815l-0.163 1.496h-53.169c-1.392-3.807-2.77-7.618-4.162-11.435-0.91-2.262-1.878-5.192-2.692-8.185l-0.142-0.612c-0.758-2.995-1.193-6.433-1.193-9.972 0-0.219 0.002-0.438 0.005-0.657l-0 0.033c0-0.851 0.035-1.715 0.105-2.565 0.006-0.006 0.009-0.014 0.009-0.023 0-0-0-0-0-0.001l0 0c0-0 0-0.001 0-0.001 0-0.009-0.004-0.017-0.009-0.022l0 0c0.323-4.5 1.36-8.919 3.073-13.091 0.786-1.896 1.696-3.74 2.707-5.522 2.468-4.494 5.461-8.726 8.126-13.126 1.654-2.689 3.098-5.503 4.319-8.419v-0.020c0-0.005 0-0.012 0.013-0.016 1.589-3.719 2.416-7.719 2.429-11.765-0.079-5.215-8.862-14.308 0.683-13.434 13.036 1.183 24.235 8.716 34.435 17.3 2.731 2.293 5.383 4.671 7.982 7.012 4.030 3.643 8.284 7.616 9.492 12.925 0.197 0.847 0.315 1.711 0.341 2.578-0.066 3.999-0.814 7.957-2.192 11.706z',
          'M1300.645 196.21c-1.42-3.792-3.47-7.044-6.051-9.79l0.014 0.015c-2.558-2.184-5.658-3.813-9.067-4.66l-0.154-0.032c-4.045-1.206-8.696-1.915-13.508-1.948l-0.018-0c-5.448-0.034-11.764 1.434-14.077 6.388-1.837 3.933-0.412 8.591 1.436 12.519 0.79 2.035 2.107 3.822 3.814 5.174 2.349 1.595 5.388 1.544 8.172 2.078 4.318 1.101 8.407 2.963 12.078 5.498l25.93 15.742c-0.432-0.263-0.278-11.55-0.782-13.4-1.621-5.96-5.271-11.94-7.786-17.584z',
          'M1327.301 119.577c-0.683-2.318-2.192-4.3-4.24-5.569 0.105-2.483-0.197-4.966-0.906-7.35-2.337-6.939-7.864-6.541-13.093-9.609-2.266-1.331-2.127-2.507-3.306-4.694-1.547-2.866-3.861-5.239-6.684-6.849-3.35-2.144-6.888-4.353-10.852-4.624-8.331-0.57-14.719 7.3-22.682 9.826-3.509 1.113-7.281 1.159-10.808 2.212-3.529 1.052-7.049 3.566-7.575 7.225-0.243 1.689 0.186 3.422-0.060 5.111-0.49 3.356-3.421 5.707-5.384 8.468-4.34 6.105-3.844 14.729-0.373 21.371 0.731 1.375 1.569 2.69 2.502 3.935 0.29 3.139 1.188 6.191 2.643 8.985 3.471 6.643 9.443 11.607 15.682 15.73-0.478-1.967-0.809-4.266-0.922-6.622l-0.003-0.085c-0.020-0.162-0.032-0.35-0.032-0.54 0-0.605 0.116-1.183 0.326-1.714l-0.011 0.031c0.696-1.459 2.531-1.847 3.931-2.647 2.9-1.654 4.037-5.317 4.121-8.665 0.083-3.349-0.624-6.702-0.274-10.034 0.016-0.806 0.202-1.566 0.524-2.248l-0.014 0.034c0.336-0.715 0.794-1.32 1.354-1.812l0.006-0.005c0.918-0.536 2.021-0.852 3.198-0.852 0.114 0 0.227 0.003 0.34 0.009l-0.016-0.001c5.941-0.243 12.146-0.353 17.387-3.175 1.558-1.055 3.343-1.981 5.234-2.691l0.177-0.058c4.452-1.166 9.003 1.969 11.57 5.805s3.852 8.403 6.215 12.366c2.363 3.963 6.459 7.498 11.041 7.028 0.249 0.001 0.512-0.053 0.748-0.159 0.223-0.105 0.446-0.259 0.617-0.452 0.197-0.356 0.276-0.763 0.249-1.17l0.249-17.577c0.223-3.007-0.079-6.028-0.88-8.934zM1225.536 236.96c0.835 6.917 1.342 13.858 1.518 20.823h-32.374v-27.328c0.164-0.662 0.341-1.312 0.553-1.963 2.026-6.267 6.275-11.517 9.96-16.968 0.176-0.272 0.365-0.545 0.541-0.817 1.568-2.299 2.916-4.742 4.026-7.295 0.53-1.254 1.377-7.32 2.272-7.84 3.837-2.234 6.958 7.32 7.487 9.448 1.884 7.58 3.521 15.23 4.756 22.952 0.483 2.992 0.903 5.988 1.26 8.988zM1389.135 257.783h-74.319c-0.63-1.502-1.26-3.004-1.917-4.494-4.634-10.529-10.627-20.4-17.823-29.361-1.152-1.149-1.945-2.658-2.196-4.344l-0.005-0.043c-0.002-0.041-0.003-0.090-0.003-0.139 0-0.675 0.18-1.308 0.494-1.854l-0.010 0.018c1.13-2.118 4.121-3.36 6.546-4.364 2.626-1.078 4.881-2.53 6.82-4.319l-0.015 0.014c1.763-1.592 3.113-3.595 3.933-5.829 0.196-0.563 0.367-1.24 0.483-1.936l0.010-0.075c0.341 0.45 0.694 0.911 1.036 1.36 0.835 1.112 1.688 2.212 2.542 3.311 8.245 10.631 17.29 21.108 28.685 27.41 2.967 1.665 6.105 3.009 9.36 4.009 0.315 0.137 0.656 0.207 0.998 0.207s0.67-0.071 0.985-0.207c0.486-0.396 0.788-0.965 0.866-1.585 1.011-4.257 1.365-8.645 2.101-12.96 1.365-7.853 3.978-15.432 7.759-22.444 2.114-3.937 8.953-18.328 13.299-9.259 1.247 2.614 2.507 5.234 3.768 7.864 0.788 1.667 1.589 3.323 2.389 4.99 2.954 5.289 4.306 11.334 3.873 17.383 0.118 12.226 0.236 24.442 0.341 36.645z',
          'M1228.511 257.783h6.439l-8.911-29.704c0.008 0.349 0.012 0.759 0.012 1.171 0 2.719-0.189 5.393-0.553 8.011l0.035-0.302c-0.871 6.53-2.674 12.448-5.286 17.906l0.154-0.357c-0.507 1.077-1.049 2.165-1.483 3.275h9.594zM1359.688 220.388c-0.906 2.45-0.079 5.158 0.617 7.675 2.022 7.302 2.967 14.862 2.809 22.44 0.026 0.133 0.013 0.27-0.013 0.402-0.039 0.13-0.105 0.249-0.21 0.347-0.092 0.096-0.207 0.168-0.336 0.209l-0.006 0.002c-0.118 0.039-0.263 0.047-0.394 0.021-2.967 0.182-6.367 0.202-8.376-1.997l5.908-29.097z',
          'M663.983 4.649h-663.983v451.712h663.983v-451.712z',
          'M238.99 46.036h-196.605v215.214h196.605v-215.214zM549.791 46.036h-189.541v13.007h189.541v-13.007zM111.842 294.359h-67.105v13.007h67.105v-13.007zM236.633 318.010h-191.896v13.007h191.896v-13.007zM588.635 93.336h-273.128v13.007h273.128v-13.007zM588.635 129.993h-273.128v13.007h273.128v-13.007zM588.635 166.651h-273.128v13.007h273.128v-13.007zM588.635 203.307h-273.128v13.007h273.128v-13.007zM588.635 239.965h-273.128v13.007h273.128v-13.007zM588.635 276.622h-273.128v13.007h273.128v-13.007zM588.635 313.28h-273.128v13.007h273.128v-13.007z',
          'M233.641 262.433h-25.559c-1.965-5.31-3.713-10.686-5.238-16.129-1.008-6.4-3.912-12.347-8.335-17.064-1.297-1.446-2.483-3.047-3.512-4.754l-0.080-0.142c-1.588-3.049-2.52-6.658-2.52-10.485 0-1.22 0.095-2.417 0.277-3.586l-0.017 0.13c0.171-1.533 0.403-2.877 0.706-4.194l-0.047 0.244c1.119-5.049 2.991-9.897 4.555-14.816 0.347-1.028 0.949-1.893 1.733-2.548l0.009-0.007c0.773-0.647 1.738-1.091 2.797-1.237l0.029-0.003c0.45-0.080 0.968-0.125 1.497-0.125 1.262 0 2.463 0.259 3.553 0.726l-0.059-0.022c0.385 0.159 0.714 0.334 1.024 0.536l-0.024-0.014c2.791 1.691 4.239 5.144 5.404 8.301 5.334 14.378 10.663 28.757 15.988 43.137 1.036 2.791 2.072 5.589 3.109 8.395 1.529 4.116 3.048 8.23 4.344 12.428 0.129 0.414 0.247 0.815 0.365 1.23z',
          'M127.246 73.176c-6.355 2.156-12.112 7.197-13.413 13.806-0.603 3.064-0.233 6.248-0.741 9.329-1.177 7.145-6.762 12.603-11.912 17.671s-10.469 10.959-10.845 18.192c-0.412 7.92 5.307 15.34 4.317 23.208-1.15 9.141-10.762 15.065-13.139 23.966-1.587 5.942 0.358 12.343 3.557 17.59 6.096 9.998 16.516 16.787 27.612 20.426s22.914 4.405 34.587 4.527c14.213 0.15 29.643-1.075 40.322-10.497 6.099-5.43 9.93-12.975 10.723-21.122 1.015-10.913-3.52-22.191-0.393-32.692 1.969-6.609 6.905-12.644 6.169-19.502-0.721-6.706-6.551-11.459-10.551-16.876-3.735-5.058-6.001-11.031-8.222-16.92l-7.6-20.149c-1.494-3.961-3.135-8.127-6.464-10.727-6.233-4.867-16.255-3.911-23.544-2.907-6.761 0.931-13.961 0.471-20.463 2.677z',
          'M133.123 139.579s0.744 22.415-1.487 24.657c-2.232 2.241 8.926 17.185 8.926 17.185l20.085-0.747 10.415-8.22-8.927-11.955s-3.719-19.426-0.743-23.909c2.975-4.483-28.268 2.988-28.268 2.988z',
          'M133.123 139.579s0.744 22.415-1.487 24.657c-2.232 2.241 8.926 17.185 8.926 17.185l20.085-0.747 10.415-8.22-8.927-11.955s-3.719-19.426-0.743-23.909c2.975-4.483-28.268 2.988-28.268 2.988z',
          'M145.395 148.171c14.79 0 26.779-12.043 26.779-26.898s-11.989-26.898-26.779-26.898c-14.79 0-26.779 12.043-26.779 26.898s11.989 26.898 26.779 26.898z',
          'M159.123 262.433h21.709c0.813-1.478 1.578-3.016 2.46-4.411v-0.012c0.985-1.703 2.318-3.101 3.909-4.134l0.047-0.028c1.038-0.477 2.022-1.067 2.932-1.762 0.844-0.917 1.468-2.050 1.778-3.306l0.011-0.052c1.495-4.691 2.32-9.572 2.448-14.497 0.035-1.655 0-3.335 0.095-4.99 0.047-1.293 0.213-2.58 0.495-3.843 0.744-2.568 1.826-5.025 3.214-7.307 2.943-5.381 5.895-10.761 8.854-16.141 0.407-1.12 0.642-2.412 0.642-3.759 0-0.342-0.015-0.68-0.045-1.014l0.003 0.043c-0.069-2.265-0.771-4.354-1.935-6.11l0.027 0.043c-0.506-0.916-0.947-1.639-1.412-2.343l0.082 0.132c-1.917-3.046-3.999-5.693-6.325-8.103l0.014 0.015c-5.048-5.318-11.175-9.484-17.965-12.216-0.921-0.315-1.719-0.715-2.452-1.205l0.038 0.024c-0.876-0.748-1.613-1.627-2.186-2.613l-0.026-0.048c-2.355-3.559-5.228-7.568-9.477-7.344-0.645-0.332-1.4-0.55-2.2-0.607l-0.019-0.001c-0.118-0.008-0.255-0.013-0.394-0.013-0.675 0-1.323 0.115-1.926 0.326l0.041-0.012c-0.269 0.071-0.489 0.144-0.703 0.228l0.044-0.015c-1.866 0.835-3.415 1.66-4.902 2.576l0.181-0.104c-2.929 1.559-6.405 2.475-10.095 2.475-0.923 0-1.833-0.057-2.726-0.169l0.107 0.011c-0.545-0.039-1.050-0.174-1.51-0.389l0.026 0.011c-0.515-0.331-0.963-0.698-1.364-1.11l-0.002-0.002c-1.028-0.851-2.296-1.448-3.688-1.679l-0.046-0.006c-0.372-0.063-0.801-0.099-1.238-0.099-1.020 0-1.994 0.195-2.888 0.55l0.053-0.019c-1.252 0.456-2.302 1.213-3.097 2.186l-0.010 0.013c-0.777 0.982-1.319 2.164-2.178 3.086-2.225 2.388-5.898 2.483-9.147 2.471-0.702-0.021-1.528-0.033-2.357-0.033-6.284 0-12.408 0.689-18.299 1.995l0.559-0.104c-6.091 1.387-11.416 4.063-15.889 7.738l0.066-0.053-0.012 0.012c-0.636 0.545-1.224 1.1-1.813 1.691-1.31 1.242-2.368 2.736-3.098 4.407l-0.034 0.087c-0.895 2.317-0.777 4.931-1.589 7.284-0.895 2.637-2.884 4.789-3.685 7.438-0.612 2.010-0.53 4.234-1.542 6.055 0.047 0.035 0.082 0.071 0.129 0.106 4.285 3.784 7.947 8.75 12.244 12.498 2.494 1.909 4.604 4.277 6.216 6.978 0.28 0.532 0.54 1.159 0.743 1.81l0.022 0.082c0.483 2.261 0.697 4.571 0.636 6.882 0.542 11.057 6.51 21.084 13.185 29.881 0.13 0.179 0.259 0.356 0.4 0.521h54.861z',
          'M89.273 223.257c-7.168 57.496-8.244 64.718-9.329 71.938l6.268-50.771c-0.543 4.337-1.277 8.139-2.236 11.851l0.141-0.642c-0.612 2.283-1.401 4.517-1.954 6.8h-30.656c0.017-1.363 0.124-2.686 0.314-3.981l-0.019 0.161c0.883-5.007 2.211-9.456 3.982-13.673l-0.156 0.418c3.567-9.673 7.13-19.354 10.69-29.042 1.519-4.126 2.825-8.443 4.497-12.533 0.294-0.757 0.612-1.514 0.954-2.248 1.778-3.925 6.71-2.317 10.36-1.726 1.076 0.137 2.054 0.428 2.956 0.854l-0.060-0.025c1.121 0.628 2.038 1.499 2.702 2.546l0.018 0.031c3.461 5.144 2.708 11.944 1.813 18.092l-0.283 1.952z',
          'M183.291 258.022c0.047 0.165 0.554 1.927 1.39 4.411h-25.559c12.667-2.188 24.169-4.423 24.169-4.423v0.012zM147.627 121.274c16.022 0 29.011-7.025 29.011-15.69s-12.989-15.691-29.011-15.691c-16.023 0-29.011 7.025-29.011 15.691s12.988 15.69 29.011 15.69z',
          'M1089.342 170.94h-663.983v451.711h663.983v-451.711z',
          'M992.803 591.906c42.912 0 77.699-3.705 77.699-8.277 0-4.571-34.787-8.277-77.699-8.277-42.913 0-77.701 3.706-77.701 8.277 0 4.573 34.787 8.277 77.701 8.277z',
          'M664.349 212.328h-196.605v215.213h196.605v-215.213z',
          'M531.048 311.138c0.251 0.080 0.54 0.125 0.839 0.125 0.398 0 0.777-0.081 1.121-0.227l-0.019 0.007c0.623-0.264 1.122-0.721 1.434-1.294l0.008-0.015c2.719-4.303-2.288-9.853-1.204-14.832 0.869-3.988 5.381-6.357 6.304-10.333 0.897-3.865-1.866-8.22 0.001-11.717 1.462-2.739 5.117-3.459 8.175-2.98 3.058 0.48 5.96 1.83 9.049 2.019 4.116 0.252 8.040-1.568 12.065-2.469s8.934-0.549 11.302 2.842c3.040 4.355-0.043 10.419 1.015 15.629 0.84 4.138 4.289 7.564 4.364 11.788 0.026 1.501-3.902 0.291-3.693 1.778s-1.648 0.179-0.164 0.001c0.626-0.158 1.157-0.499 1.547-0.963l0.004-0.004c0.387-0.46 0.638-1.047 0.682-1.691l0.001-0.009c0.177-1.238 2.493-1.652 2.467-2.901-0.063-2.93 5.212-0.954 6.080-3.753 0.792-2.496 1.249-5.366 1.249-8.343 0-4.143-0.885-8.080-2.475-11.631l0.072 0.181c-1.413-2.551-2.542-5.251-3.365-8.050-0.775-3.886 0.445-8.057-0.834-11.806-1.722-5.052-7.421-7.627-12.712-8.15s-10.668 0.414-15.928-0.358c-4.713-0.691-9.275-2.742-14.029-2.444-5.703 0.356-10.667 4.047-14.621 8.192-3.953 4.145-7.307 8.911-11.797 12.463-1.418 0.987-2.657 2.063-3.771 3.257l-0.013 0.014c-2.287 2.8-2.519 6.787-1.883 10.352 0.637 3.566 2.020 6.965 2.605 10.538 0.55 3.358 0.381 6.79 0.617 10.185 0.055 3.424 1.087 6.76 2.974 9.612 0.816 1.105 1.849 2 3.042 2.636l0.049 0.024c1.142 0.612 2.492 0.988 3.926 1.028l0.012 0c0.952 0.022 1.755-0.836 2.716-0.612 1.2 0.28 1.722 1.424 2.788 1.915z',
          'M487.814 428.723c0.86-11.836 1.507-20.681 1.507-20.681l5.557-14.71 17.836 35.391h-24.9z',
          'M487.814 428.723c0.86-11.836 1.507-20.681 1.507-20.681l5.557-14.71 17.836 35.391h-24.9z',
          'M529.148 312.342s16.631 42.521 7.055 50.62c-9.576 8.1 53.42-13.666 53.42-13.666l-1.511-5.569s-20.662-8.099-10.584-31.384c10.080-23.285-48.38 0-48.38 0z',
          'M529.148 312.342s16.631 42.521 7.055 50.62c-9.576 8.1 53.42-13.666 53.42-13.666l-1.511-5.569s-20.662-8.099-10.584-31.384c10.080-23.285-48.38 0-48.38 0z',
          'M552.835 329.553c19.484 0 35.278-15.864 35.278-35.434 0-19.569-15.795-35.434-35.278-35.434s-35.278 15.865-35.278 35.434c0 19.57 15.795 35.434 35.278 35.434z',
          'M638.506 370.557s-0.14 2.813-0.389 7.733c-0.505 10.017-1.413 28.782-2.318 50.433h-136.753c-3.388-4.513-6.313-9.67-8.537-15.186l-0.163-0.458c-0.564-1.486-0.932-3.205-1.022-4.997l-0.002-0.040c-0.754-13.422 11.219-32.152 19.673-33.938 9.57-2.034 27.712-21.261 27.712-21.261 0.063 0.77 0.317 1.469 0.714 2.065l-0.010-0.016c0.407 0.61 0.947 1.101 1.581 1.439l0.023 0.011v0.012c1.25 0.662 2.733 1.051 4.307 1.051 0.154 0 0.307-0.004 0.459-0.011l-0.021 0.001c5.909 0 31.904-12.050 40.251-15.988 1.636-0.769 2.59-1.23 2.59-1.23 9.626 4.173 19.57 7.562 29.737 10.134 5.074 1.271 9.754 3.786 13.623 7.319 3.868 3.533 6.804 7.974 8.545 12.926z',
          'M525.002 307.595c0.251 0.079 0.54 0.125 0.839 0.125 0.398 0 0.777-0.081 1.121-0.227l-0.019 0.007c0.624-0.263 1.123-0.72 1.434-1.294l0.008-0.015c2.719-4.303-2.287-9.853-1.203-14.832 0.868-3.99 5.381-6.357 6.304-10.333 0.897-3.865-1.867-8.221 0.001-11.717 1.462-2.739 5.116-3.459 8.175-2.98 3.058 0.48 5.959 1.83 9.048 2.019 4.117 0.252 8.041-1.568 12.065-2.469 4.025-0.902 8.935-0.549 11.303 2.842 3.039 4.355-0.045 10.419 1.015 15.629 0.84 4.138 10.417 7.043 11.286 4.244 0.792-2.496 1.249-5.366 1.249-8.343 0-4.144-0.884-8.081-2.475-11.633l0.072 0.181c-1.304-2.302-2.449-4.97-3.292-7.769l-0.073-0.281c-0.775-3.885 0.444-8.055-0.834-11.805-1.722-5.052-7.421-7.627-12.712-8.15-5.292-0.524-10.668 0.414-15.928-0.358-4.713-0.691-9.275-2.742-14.029-2.446-5.704 0.357-10.667 4.049-14.621 8.193s-7.307 8.911-11.798 12.461c-1.417 0.988-2.656 2.064-3.77 3.258l-0.013 0.014c-2.287 2.8-2.519 6.787-1.884 10.352 0.637 3.564 2.022 6.965 2.606 10.538 0.549 3.358 0.379 6.79 0.616 10.184 0.056 3.425 1.088 6.761 2.975 9.614 0.814 1.111 1.871 2.020 3.089 2.66 1.142 0.612 2.492 0.988 3.926 1.028l0.012 0c0.952 0.022 1.757-0.836 2.716-0.613 1.201 0.281 1.724 1.426 2.788 1.917z',
          'M655.986 428.723h-39.91c-3.037-22.372-5.544-45.762-5.544-45.762l8.065-3.547 16.387-8.856s1.201 2.861 3.132 7.733c4.12 10.419 11.596 30.024 17.87 50.433z',
          'M659.51 428.723h-45.042c-6.676-24.478-13.257-51.083-13.257-51.083l17.141-12.653 20.154 5.57s11.797 28.202 21.003 58.166z',
          'M975.15 212.328h-189.541v13.007h189.541v-13.007zM537.201 460.65h-67.105v13.007h67.105v-13.007zM661.992 484.299h-191.896v13.007h191.896v-13.007z',
          'M1013.999 259.626h-273.127v13.007h273.127v-13.007zM1013.999 296.284h-273.127v13.007h273.127v-13.007zM1013.999 332.94h-273.127v13.007h273.127v-13.007zM1013.999 369.598h-273.127v13.007h273.127v-13.007zM1013.999 406.256h-273.127v13.007h273.127v-13.007zM1013.999 442.913h-273.127v13.007h273.127v-13.007zM1013.999 479.571h-273.127v13.006h273.127v-13.006z',
          'M1066.643 481.327l-74.663 74.994-31.382-31.521c-0.97-0.974-2.125-1.763-3.409-2.309l-0.070-0.027c-1.213-0.518-2.624-0.82-4.105-0.821l-0-0c-1.482 0-2.893 0.302-4.175 0.847l0.070-0.026c-1.354 0.572-2.51 1.361-3.48 2.335l-0 0-1.128-1.694c-4.189 4.208-3.061 12.724 1.128 16.931l40.716 40.897c1.535 1.541 3.616 2.408 5.786 2.408 0.001 0 0.001 0 0.002 0 2.261 0 4.307-0.919 5.785-2.405l0-0 84.089-84.372c4.192-4.206 5.712-11.919 1.522-16.127-4.188-4.208-12.497-3.317-16.685 0.889z',
          'M1066.643 481.327l-74.663 74.994-31.382-31.521c-0.97-0.974-2.125-1.763-3.409-2.309l-0.070-0.027c-1.213-0.518-2.624-0.82-4.105-0.821l-0-0c-1.482 0-2.893 0.302-4.175 0.847l0.070-0.026c-1.354 0.572-2.51 1.361-3.48 2.335l-0 0-1.128-1.694c-4.189 4.208-3.061 12.724 1.128 16.931l40.716 40.897c1.535 1.541 3.616 2.408 5.786 2.408 0.001 0 0.001 0 0.002 0 2.261 0 4.307-0.919 5.785-2.405l0-0 84.089-84.372c4.192-4.206 5.712-11.919 1.522-16.127-4.188-4.208-12.497-3.317-16.685 0.889z',
          'M1066.644 478.003l-74.663 74.992-31.38-31.52c-0.97-0.975-2.126-1.763-3.41-2.309l-0.070-0.027c-1.212-0.519-2.623-0.821-4.104-0.821-0.001 0-0.001 0-0.002 0l0-0c-0-0-0.001-0-0.002-0-1.481 0-2.891 0.302-4.173 0.847l0.070-0.026c-1.354 0.572-2.51 1.361-3.48 2.335l-0 0c-0.971 0.975-1.757 2.136-2.299 3.424l-0.026 0.071c-0.516 1.218-0.817 2.635-0.817 4.121 0 0.001 0 0.002 0 0.002l-0-0c0 1.415 0.277 2.816 0.817 4.124 0.538 1.308 1.329 2.496 2.325 3.496l40.716 40.896c1.478 1.486 3.524 2.407 5.785 2.409l0 0c2.17 0 4.252-0.865 5.787-2.405l84.089-84.372c0.971-0.975 1.757-2.136 2.3-3.424l0.027-0.071c0.517-1.219 0.818-2.636 0.818-4.123l0-0c0-0.002 0-0.004 0-0.007 0-1.485-0.3-2.9-0.842-4.188l0.027 0.071c-0.569-1.359-1.355-2.52-2.325-3.497l0 0c-2.011-2.020-4.739-3.156-7.584-3.156-2.844 0-5.572 1.136-7.583 3.156z',
          'M1615.938 912.364c0 84.557-117.353 58.403-261.028 58.403-143.669 0-259.269 26.154-259.269-58.403s117.328-102.947 261.002-102.947c143.675 0 259.295 18.39 259.295 102.947z',
          'M1615.938 896.57c0 84.557-117.353 58.402-261.028 58.402-143.669 0-259.269 26.155-259.269-58.402s117.328-102.949 261.002-102.949c143.675 0 259.295 18.391 259.295 102.949z',
          'M1125.409 631.668l-5.317 6.202s-64.651 6.097-62.027 16.639c2.623 10.541 77.838-14.055 77.838-14.055l-10.495-8.785z',
          'M1242.604 626.397s-69.092 24.598-106.701 14.056l17.492 35.139s89.209-2.636 104.951-18.448c15.743-15.813-15.742-30.748-15.742-30.748z',
          'M1242.604 626.397s-69.092 24.598-106.701 14.056l17.492 35.139s89.209-2.636 104.951-18.448c15.743-15.813-15.742-30.748-15.742-30.748z',
          'M1195.815 437.966c25.6 0 46.353-20.845 46.353-46.559 0-25.713-20.753-46.558-46.353-46.558-25.601 0-46.354 20.845-46.354 46.558 0 25.714 20.753 46.559 46.354 46.559z',
          'M1235.337 435.117c1.596 3.060 3.618 5.875 6.005 8.361 6.35 6.938 13.926 12.632 22.344 16.794-26.309 5.371-52.883 9.339-79.609 11.89 2.821-9.981-0.893-20.657-5.885-29.741-4.991-9.083-11.355-17.551-14.479-27.441l31.33 0.845c5.685 0.154 11.387 0.326 17.072 0.046 4.247-0.209 11.324-2.766 15.289-1.824 8.384 1.99 4.275 13.601 7.933 21.068z',
          'M1340.56 653.63l26.23 31.625s43.73 102.781-51.594 113.323c-95.334 10.541-166.177-7.907-166.177-7.907s-38.481-18.448-39.356-4.391c-0.876 14.055-4.373 53.585-25.364 92.239l-18.366 42.166s-9.62 9.662-6.997 22.839c2.624 13.177-58.596 17.569-57.722 0 0 0 8.746-14.933 8.746-23.719 0-8.784 13.993-29.867 13.993-29.867l25.362-126.499s-1.749-65.007 57.723-52.708c59.472 12.299 144.308-2.635 144.308-2.635l19.241-67.642 69.972 13.177z',
          'M1340.56 653.63l26.23 31.625s43.73 102.781-51.594 113.323c-95.334 10.541-166.177-7.907-166.177-7.907s-38.481-18.448-39.356-4.391c-0.876 14.055-4.373 53.585-25.364 92.239l-18.366 42.166s-9.62 9.662-6.997 22.839c2.624 13.177-58.596 17.569-57.722 0 0 0 8.746-14.933 8.746-23.719 0-8.784 13.993-29.867 13.993-29.867l25.362-126.499s-1.749-65.007 57.723-52.708c59.472 12.299 144.308-2.635 144.308-2.635l19.241-67.642 69.972 13.177z',
          'M1242.167 651.315s80.027-30.19 124.623 33.939c0 0 11.382 99.266-34.107 103.659-45.475 4.393-104.947 3.514-118.94-11.42-13.993-14.933-102.328-57.1-102.328-57.1s-43.97-22.528-52.596 6.744c-8.625 29.273-9.5 36.301-9.5 36.301s-45.479 33.381-63.846 39.53c0 0-12.243 17.569-19.241 17.569-6.996 0-49.852 9.664-45.479-22.84l70.842-65.006 70.841-69.4s20.116-29.868 71.717-14.055c26.718 8.513 61.703 17.328 97.328 24.364l6.748 1.111 3.936-23.397z',
          'M1056.316 941.766s16.618 42.166 2.624 47.437c-13.995 5.271-43.73 1.757-43.73 1.757s-34.984-4.391-43.73-3.513c-8.746 0.878-44.604-6.149-39.356-20.206 5.247-14.055 32.36-10.541 32.36-10.541l24.488-11.42s2.624-8.785 8.746-5.271c6.122 3.513 23.614 16.691 58.598 1.757zM965.36 817.025s18.366 41.288-11.369 37.774c-29.737-3.514-52.476-9.664-61.222-10.542-8.413-0.845-32.201-9.005-28.551-25.263 0.196-1.052 0.276-2.122 0.236-3.191 0-2.182 2.953-6.464 26.566-5.805 0 0 17.492-0.001 24.488-12.3 0 0 26.238 33.382 49.852 19.327z',
          'M1163.892 465.638s62.969-39.532 115.445 0c52.48 39.53 87.454 219.616 87.454 219.616l-121.563-27.232s-5.247-21.084-12.243-24.597c-6.997-3.514-7.872-18.449-7.872-18.449s-37.607-11.419-34.984-55.343c2.624-43.923-26.237-93.995-26.237-93.995z',
          'M1196.254 467.394h-32.36s-19.242 21.962-21.865 77.305l-10.495 43.923s-21.865 52.708-8.746 61.493c13.119 8.785 38.481 7.906 43.729-9.662 5.247-17.569 41.106-119.472 41.106-119.472l-11.369-53.587z',
          'M1186.979 330.815c5.254-2.226 11.364-3.519 17.776-3.519 2.678 0 5.303 0.226 7.857 0.659l-0.275-0.039c8.557 1.409 16.557 5.175 23.11 10.881 16.796 15.055 20.186 39.617 24.432 61.823s12.788 46.936 33.625 55.497c-3.485 0.493-7.511 0.775-11.602 0.775-5.882 0-11.628-0.582-17.184-1.692l0.556 0.093 31.488 28.342-53.043-17.366c-16.647-5.45-34.131-10.969-51.371-7.891-28.558 5.1-48.44 32.067-75.872 41.54l3.048-14.94-18.403-0.142c4.408-3.277 8.015-7.521 10.545-12.409-0.862-1.046-1.907-1.906-3.092-2.54l-0.055-0.027c-1.129-0.605-2.452-1.010-3.856-1.13l-0.038-0.003c-7.671-48.062 20.744-95.573 57.773-126.973 7.284-6.177 15.343-12.108 24.751-13.653s20.389 2.679 23.66 11.672z',
          'M384.467 771.294c0 101.116 63.155 182.936 141.202 182.936l-141.202-182.936z',
          'M525.673 954.23c0-102.25 70.476-184.991 157.573-184.991l-157.573 184.991z',
          'M435.635 780.46c0 96.050 40.272 173.77 90.041 173.77l-90.041-173.77z',
          'M525.673 954.23c0-130.655 81.461-236.377 182.129-236.377l-182.129 236.377z',
          'M495.968 955.521s20.024-0.62 26.059-4.936 30.803-9.471 32.301-2.548c1.497 6.923 30.092 34.43 7.486 34.614-22.608 0.182-52.531-3.538-58.554-7.223s-7.291-19.906-7.291-19.906z',
          'M562.217 980.24c-22.608 0.184-52.53-3.537-58.553-7.222-4.588-2.807-6.416-12.877-7.028-17.524-0.423 0.018-0.668 0.026-0.668 0.026s1.268 16.221 7.291 19.906c6.023 3.685 35.946 7.406 58.554 7.223 6.526-0.054 8.78-2.385 8.655-5.839-0.906 2.086-3.395 3.39-8.252 3.429z',
        ],
        attrs: [
          {
            fill: 'rgb(63, 61, 86)',
          },
          {
            fill: 'rgb(63, 61, 86)',
            opacity: 0.3,
          },
          {
            fill: 'rgb(242, 242, 242)',
          },
          {
            fill: 'rgb(47, 46, 65)',
          },
          {
            fill: 'rgb(242, 242, 242)',
          },
          {
            fill: 'rgb(255, 185, 185)',
          },
          {
            fill: 'rgb(0, 0, 0)',
            opacity: 0.1,
          },
          {
            fill: 'rgb(255, 185, 185)',
          },
          {
            fill: 'rgb(242, 242, 242)',
          },
          {
            fill: 'rgb(47, 46, 65)',
          },
          {
            fill: 'rgb(255, 185, 185)',
          },
          {
            fill: 'rgb(47, 46, 65)',
          },
          {
            fill: 'rgb(0, 0, 0)',
            opacity: 0.1,
          },
          {
            fill: 'rgb(63, 61, 86)',
            opacity: 0.3,
          },
          {
            fill: 'rgb(242, 242, 242)',
          },
          {
            fill: 'rgb(208, 205, 225)',
          },
          {
            fill: 'rgb(47, 46, 65)',
          },
          {
            fill: 'rgb(160, 97, 106)',
          },
          {
            fill: 'rgb(0, 0, 0)',
            opacity: 0.1,
          },
          {
            fill: 'rgb(160, 97, 106)',
          },
          {
            fill: 'rgb(208, 205, 225)',
          },
          {
            fill: 'rgb(208, 205, 225)',
          },
          {
            fill: 'rgb(47, 46, 65)',
          },
          {
            fill: 'rgb(63, 61, 86)',
          },
          {
            fill: 'rgb(0, 0, 0)',
            opacity: 0.1,
          },
          {
            fill: 'rgb(242, 242, 242)',
          },
          {
            fill: 'rgb(47, 46, 65)',
          },
          {
            fill: 'rgb(87, 90, 137)',
          },
          {
            fill: 'rgb(0, 0, 0)',
            opacity: 0.1,
          },
          {
            fill: 'rgb(160, 97, 106)',
          },
          {
            fill: 'rgb(0, 0, 0)',
            opacity: 0.1,
          },
          {
            fill: 'rgb(160, 97, 106)',
          },
          {
            fill: 'rgb(87, 90, 137)',
          },
          {
            fill: 'rgb(47, 46, 65)',
          },
          {
            fill: 'rgb(0, 0, 0)',
            opacity: 0.1,
          },
          {
            fill: 'rgb(87, 90, 137)',
          },
          {
            fill: 'rgb(225, 112, 0)',
          },
          {
            fill: 'rgb(242, 242, 242)',
          },
          {
            fill: 'rgb(87, 184, 148)',
          },
          {
            fill: 'rgb(0, 0, 0)',
            opacity: 0.1,
          },
          {
            fill: 'rgb(87, 184, 148)',
          },
          {
            fill: 'rgb(0, 0, 0)',
            opacity: 0.1,
          },
          {
            fill: 'rgb(63, 61, 86)',
          },
          {
            fill: 'rgb(255, 193, 199)',
          },
          {
            fill: 'rgb(225, 112, 0)',
          },
          {
            fill: 'rgb(0, 0, 0)',
            opacity: 0.1,
          },
          {
            fill: 'rgb(255, 193, 199)',
          },
          {
            fill: 'rgb(255, 193, 199)',
          },
          {
            fill: 'rgb(47, 46, 65)',
          },
          {
            fill: 'rgb(0, 0, 0)',
            opacity: 0.1,
          },
          {
            fill: 'rgb(47, 46, 65)',
          },
          {
            fill: 'rgb(203, 206, 218)',
          },
          {
            fill: 'rgb(225, 112, 0)',
          },
          {
            fill: 'rgb(225, 112, 0)',
          },
          {
            fill: 'rgb(47, 46, 65)',
          },
          {
            fill: 'rgb(63, 61, 86)',
          },
          {
            fill: 'rgb(225, 112, 0)',
          },
          {
            fill: 'rgb(225, 112, 0)',
          },
          {
            fill: 'rgb(63, 61, 86)',
          },
          {
            fill: 'rgb(168, 168, 168)',
          },
          {
            fill: 'rgb(0, 0, 0)',
            opacity: 0.2,
          },
        ],
        width: 1680,
        isMulticolor: true,
        isMulticolor2: true,
        grid: 16,
        tags: ['Provisioner'],
      },
      attrs: [
        {
          fill: 'rgb(63, 61, 86)',
        },
        {
          fill: 'rgb(63, 61, 86)',
          opacity: 0.3,
        },
        {
          fill: 'rgb(242, 242, 242)',
        },
        {
          fill: 'rgb(47, 46, 65)',
        },
        {
          fill: 'rgb(242, 242, 242)',
        },
        {
          fill: 'rgb(255, 185, 185)',
        },
        {
          fill: 'rgb(0, 0, 0)',
          opacity: 0.1,
        },
        {
          fill: 'rgb(255, 185, 185)',
        },
        {
          fill: 'rgb(242, 242, 242)',
        },
        {
          fill: 'rgb(47, 46, 65)',
        },
        {
          fill: 'rgb(255, 185, 185)',
        },
        {
          fill: 'rgb(47, 46, 65)',
        },
        {
          fill: 'rgb(0, 0, 0)',
          opacity: 0.1,
        },
        {
          fill: 'rgb(63, 61, 86)',
          opacity: 0.3,
        },
        {
          fill: 'rgb(242, 242, 242)',
        },
        {
          fill: 'rgb(208, 205, 225)',
        },
        {
          fill: 'rgb(47, 46, 65)',
        },
        {
          fill: 'rgb(160, 97, 106)',
        },
        {
          fill: 'rgb(0, 0, 0)',
          opacity: 0.1,
        },
        {
          fill: 'rgb(160, 97, 106)',
        },
        {
          fill: 'rgb(208, 205, 225)',
        },
        {
          fill: 'rgb(208, 205, 225)',
        },
        {
          fill: 'rgb(47, 46, 65)',
        },
        {
          fill: 'rgb(63, 61, 86)',
        },
        {
          fill: 'rgb(0, 0, 0)',
          opacity: 0.1,
        },
        {
          fill: 'rgb(242, 242, 242)',
        },
        {
          fill: 'rgb(47, 46, 65)',
        },
        {
          fill: 'rgb(87, 90, 137)',
        },
        {
          fill: 'rgb(0, 0, 0)',
          opacity: 0.1,
        },
        {
          fill: 'rgb(160, 97, 106)',
        },
        {
          fill: 'rgb(0, 0, 0)',
          opacity: 0.1,
        },
        {
          fill: 'rgb(160, 97, 106)',
        },
        {
          fill: 'rgb(87, 90, 137)',
        },
        {
          fill: 'rgb(47, 46, 65)',
        },
        {
          fill: 'rgb(0, 0, 0)',
          opacity: 0.1,
        },
        {
          fill: 'rgb(87, 90, 137)',
        },
        {
          fill: 'rgb(225, 112, 0)',
        },
        {
          fill: 'rgb(242, 242, 242)',
        },
        {
          fill: 'rgb(87, 184, 148)',
        },
        {
          fill: 'rgb(0, 0, 0)',
          opacity: 0.1,
        },
        {
          fill: 'rgb(87, 184, 148)',
        },
        {
          fill: 'rgb(0, 0, 0)',
          opacity: 0.1,
        },
        {
          fill: 'rgb(63, 61, 86)',
        },
        {
          fill: 'rgb(255, 193, 199)',
        },
        {
          fill: 'rgb(225, 112, 0)',
        },
        {
          fill: 'rgb(0, 0, 0)',
          opacity: 0.1,
        },
        {
          fill: 'rgb(255, 193, 199)',
        },
        {
          fill: 'rgb(255, 193, 199)',
        },
        {
          fill: 'rgb(47, 46, 65)',
        },
        {
          fill: 'rgb(0, 0, 0)',
          opacity: 0.1,
        },
        {
          fill: 'rgb(47, 46, 65)',
        },
        {
          fill: 'rgb(203, 206, 218)',
        },
        {
          fill: 'rgb(225, 112, 0)',
        },
        {
          fill: 'rgb(225, 112, 0)',
        },
        {
          fill: 'rgb(47, 46, 65)',
        },
        {
          fill: 'rgb(63, 61, 86)',
        },
        {
          fill: 'rgb(225, 112, 0)',
        },
        {
          fill: 'rgb(225, 112, 0)',
        },
        {
          fill: 'rgb(63, 61, 86)',
        },
        {
          fill: 'rgb(168, 168, 168)',
        },
        {
          fill: 'rgb(0, 0, 0)',
          opacity: 0.2,
        },
      ],
      properties: {
        order: 6,
        id: 493,
        name: 'Provisioner',
        prevSize: 32,
      },
      setIdx: 0,
      setId: 1,
      iconIdx: 2,
    },
    {
      icon: {
        paths: [
          'M746.942 389.598c18.469-17.214 19.493-46.141 2.275-64.61-17.211-18.469-46.14-19.487-64.609-2.273l-133.766 124.673-124.673-133.766c-17.214-18.469-46.141-19.487-64.61-2.273s-19.487 46.141-2.273 64.61l124.673 133.766-133.766 124.673c-18.469 17.213-19.487 46.141-2.273 64.609s46.141 19.487 64.61 2.273l133.766-124.673 124.673 133.766c17.213 18.469 46.141 19.487 64.606 2.273 18.476-17.213 19.493-46.141 2.275-64.609l-124.671-133.766 133.763-124.673z',
          'M45.714 512c0 277.723 225.137 502.857 502.857 502.857 277.723 0 502.857-225.134 502.857-502.857 0-277.721-225.134-502.857-502.857-502.857-277.721 0-502.857 225.137-502.857 502.857zM548.571 923.429c-227.226 0-411.429-184.203-411.429-411.429s184.203-411.429 411.429-411.429 411.429 184.203 411.429 411.429-184.203 411.429-411.429 411.429z',
        ],
        attrs: [
          {
            fill: 'rgb(255, 255, 255)',
          },
          {
            fill: 'rgb(255, 255, 255)',
          },
        ],
        width: 1097,
        isMulticolor: false,
        isMulticolor2: false,
        grid: 16,
        tags: ['close-o'],
      },
      attrs: [
        {
          fill: 'rgb(255, 255, 255)',
        },
        {
          fill: 'rgb(255, 255, 255)',
        },
      ],
      properties: {
        order: 5,
        id: 494,
        name: 'close-o',
        prevSize: 32,
      },
      setIdx: 0,
      setId: 1,
      iconIdx: 0,
    },
    {
      icon: {
        paths: [
          'M889.68 166.32c-93.608-102.216-228.154-166.32-377.68-166.32-282.77 0-512 229.23-512 512h96c0-229.75 186.25-416 416-416 123.020 0 233.542 53.418 309.696 138.306l-149.696 149.694h352v-352l-134.32 134.32z',
          'M928 512c0 229.75-186.25 416-416 416-123.020 0-233.542-53.418-309.694-138.306l149.694-149.694h-352v352l134.32-134.32c93.608 102.216 228.154 166.32 377.68 166.32 282.77 0 512-229.23 512-512h-96z',
        ],
        tags: ['loop', 'repeat', 'player', 'reload', 'refresh', 'update', 'synchronize', 'arrows'],
        defaultCode: 59950,
        grid: 16,
        attrs: [],
      },
      attrs: [],
      properties: {
        ligatures: 'loop2, repeat2',
        name: 'loop2',
        order: 5,
        id: 303,
        prevSize: 32,
        code: 59950,
      },
      setIdx: 0,
      setId: 1,
      iconIdx: 302,
    },
    {
      icon: {
        paths: ['M192 1024h640l64-704h-768zM640 128v-128h-256v128h-320v192l64-64h768l64 64v-192h-320zM576 128h-128v-64h128v64z'],
        tags: ['bin', 'trashcan', 'remove', 'delete', 'recycle', 'dispose'],
        defaultCode: 59821,
        grid: 16,
        attrs: [],
      },
      attrs: [],
      properties: {
        ligatures: 'bin2, trashcan2',
        name: 'bin2',
        order: 3,
        id: 174,
        prevSize: 32,
        code: 59821,
      },
      setIdx: 0,
      setId: 1,
      iconIdx: 173,
    },
    {
      icon: {
        paths: ['M608 192h160v-192h-160c-123.514 0-224 100.486-224 224v96h-128v192h128v512h192v-512h160l32-192h-192v-96c0-17.346 14.654-32 32-32z'],
        tags: ['facebook', 'brand', 'social'],
        defaultCode: 60048,
        grid: 16,
        attrs: [],
      },
      attrs: [],
      properties: {
        ligatures: 'facebook, brand10',
        name: 'facebook',
        order: 2,
        id: 401,
        prevSize: 32,
        code: 60048,
      },
      setIdx: 0,
      setId: 1,
      iconIdx: 400,
    },
  ],
  height: 1024,
  metadata: {
    name: 'icomoon',
  },
  preferences: {
    showGlyphs: true,
    showQuickUse: true,
    showQuickUse2: true,
    showSVGs: true,
    fontPref: {
      prefix: 'icon-',
      metadata: {
        fontFamily: 'icomoon',
      },
      metrics: {
        emSize: 1024,
        baseline: 6.25,
        whitespace: 50,
      },
      embed: false,
    },
    imagePref: {
      prefix: 'icon-',
      png: true,
      useClassSelector: true,
      color: 0,
      bgColor: 16777215,
      classSelector: '.icon',
    },
    historySize: 100,
    showCodes: true,
    gridSize: 16,
  },
};
